import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from './codegen-hooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {"errorPolicy":"all"} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: string; output: string; }
};

export type AcceptSocialFollowersRequest = {
  followers: Array<SocialFollowerInput>;
};

export type AcceptSocialFollowersResult = AcceptSocialFollowersSuccess | InvalidSocialAcceptFollowRequestError | SocialUserDoesNotExistError | UnexpectedError;

export type AcceptSocialFollowersSuccess = {
  __typename?: 'AcceptSocialFollowersSuccess';
  followers: Array<SocialUser>;
};

/** The input of the `updateGuestBirthday` mutation. */
export type AddGuestBirthdayInput = {
  /** The `Guest` birthday to add to account. A birthday should not already be on file. */
  birthday: Scalars['Date']['input'];
  /** The `Guest` birthday consent status. Should be null if a guest is not consenting to birthday use cases. */
  birthdayConsentedUseCases?: InputMaybe<Array<BirthdayConsentedUseCase>>;
};

/** The possible results of the `updateGuestBirthday` mutation. */
export type AddGuestBirthdayResult = AddGuestBirthdaySuccess | BirthdayAlreadyExistsError | InvalidBirthdayError | UnexpectedError;

/** The successful result of the `updateGuestBirthday` mutation. */
export type AddGuestBirthdaySuccess = {
  __typename?: 'AddGuestBirthdaySuccess';
  /** The current verified, authorized guest. */
  guest: Guest;
};

/** Specifies the identity field to update for the guest. */
export type AddGuestIdentityInput = {
  identityString: Scalars['String']['input'];
  identityType: IdentityType;
};

/** The possible results of the `addGuestIdentity` mutation. */
export type AddGuestIdentityResult = AddGuestIdentitySuccess | GuestIdentityAlreadyExistsForCurrentGuestError | InvalidEmailError | ProfileLockedForDeletionError | UnexpectedError;

/** The successful result of the `addGuestIdentity` mutation. */
export type AddGuestIdentitySuccess = {
  __typename?: 'AddGuestIdentitySuccess';
  /** Always true. Errors will be indicated with the appropriate error type. */
  success: Scalars['Boolean']['output'];
};

/** Input to add a reaction to a post. */
export type AddGuestReactionToPostInput = {
  /** The ID of the post to add the reaction to. */
  postId: Scalars['ID']['input'];
  /** The type of reaction to add to the post. */
  reaction: GuestPostReactionType;
};

/** The possible responses of the `addGuestReactionToPost` mutation. */
export type AddGuestReactionToPostResponse = AddGuestReactionToPostSuccess | UnexpectedError;

export type AddGuestReactionToPostSuccess = {
  __typename?: 'AddGuestReactionToPostSuccess';
  reactionAggregates: Array<GuestPostReactionAggregate>;
};

export type AddItemToCartInput = {
  cartGuid: Scalars['ID']['input'];
  selection: SelectionInput;
};

export type AddItemToCartInputV2 = {
  /** The GUID of the cart to add the **selection** to. Not including it indicates that a new cart will be created. */
  cartGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Data required for creating a new cart. If **cartGuid** is null, then this is required. If **cartGuid** is not null, then this is ignored. */
  createCartInput?: InputMaybe<CreateCartInputV2>;
  /** The item to be added to the cart indicated by **cartGuid**, or the new cart that will be created. */
  selection: SelectionInput;
};

export type AddItemToCartResponse = {
  __typename?: 'AddItemToCartResponse';
  cart?: Maybe<Cart>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AddItemsToGuestSavedListInput = {
  items: Array<GuestSavedListItemInput>;
  listId: Scalars['ID']['input'];
};

export type AddLoyaltyRedemptionInput = {
  cartGuid: Scalars['ID']['input'];
  /** Guid of the redemption to be applied, obtained from the **loyaltyInquiry** mutation */
  redemptionGuid: Scalars['ID']['input'];
};

export type AddLoyaltyRedemptionV2Input = {
  cartGuid: Scalars['ID']['input'];
  /** Redemption to be applied, obtained from the **loyaltyInquiry** mutation */
  redemption: LoyaltyRedemptionInput;
};

export type AddPushNotificationTargetToCustomerInput = {
  targetIdentifier: Scalars['String']['input'];
  targetType: PushNotificationTargetType;
};

export type AddPushNotificationTargetToCustomerResponse = {
  __typename?: 'AddPushNotificationTargetToCustomerResponse';
  success: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type AddressValidationInput = {
  address: AddressInput;
  siteGuid: Scalars['ID']['input'];
};

export type AddressValidationResponse = {
  __typename?: 'AddressValidationResponse';
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recommendedAddress?: Maybe<Address>;
  valid: Scalars['Boolean']['output'];
};

export type AdminAddAwardTypeToSeasonInput = {
  awardSeasonId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AdminAddAwardTypeToSeasonResult = AdminAddAwardTypeToSeasonSuccess | UnexpectedError;

export type AdminAddAwardTypeToSeasonSuccess = {
  __typename?: 'AdminAddAwardTypeToSeasonSuccess';
  awardType: AwardType;
};

export type AdminAddItemsToGuestSavedListsInput = {
  addItemsToGuestSavedListsInput: Array<AddItemsToGuestSavedListInput>;
  guestId: Scalars['ID']['input'];
};

export type AdminCreateAwardSeasonInput = {
  endDateTime: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  startDateTime: Scalars['DateTime']['input'];
};

export type AdminCreateAwardSeasonResult = AdminCreateAwardSeasonSuccess | UnexpectedError;

export type AdminCreateAwardSeasonSuccess = {
  __typename?: 'AdminCreateAwardSeasonSuccess';
  awardSeason: AwardSeason;
};

export type AdminCreatePlaceVideoPostInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  placeId: Scalars['ID']['input'];
  rawVideoUrl: Scalars['String']['input'];
  socialUserId: Scalars['ID']['input'];
  toastMenuItems: Array<AdminCreatePlaceVideoPostToastMenuItemInput>;
  visibility: GuestPostVisibility;
};

export type AdminCreatePlaceVideoPostResult = AdminCreatePlaceVideoPostSuccess | UnexpectedError;

export type AdminCreatePlaceVideoPostSuccess = {
  __typename?: 'AdminCreatePlaceVideoPostSuccess';
  postId: Scalars['ID']['output'];
};

export type AdminCreatePlaceVideoPostToastMenuItemInput = {
  itemGroupId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
};

export type AdminDeletePlaceVideoPostInput = {
  postId: Scalars['ID']['input'];
};

export type AdminDeletePlaceVideoPostResult = AdminDeletePlaceVideoPostSuccess | UnexpectedError;

export type AdminDeletePlaceVideoPostSuccess = {
  __typename?: 'AdminDeletePlaceVideoPostSuccess';
  postId: Scalars['ID']['output'];
};

export type AdsManagerConversionTagsConfig = {
  __typename?: 'AdsManagerConversionTagsConfig';
  managementSetGuid: Scalars['ID']['output'];
  restaurantConversionsDataList?: Maybe<Array<Maybe<AdsManagerRestaurantConversionsData>>>;
};

export type AdsManagerQuery = {
  __typename?: 'AdsManagerQuery';
  adsManagerConversionConfig?: Maybe<Restaurant>;
  adsManagerConversionTagsConfig: AdsManagerConversionTagsConfig;
  adsManagerRestaurantConversionsData: AdsManagerRestaurantConversionsData;
};


export type AdsManagerQueryAdsManagerConversionConfigArgs = {
  guid: Scalars['ID']['input'];
};


export type AdsManagerQueryAdsManagerConversionTagsConfigArgs = {
  guid: Scalars['ID']['input'];
};


export type AdsManagerQueryAdsManagerRestaurantConversionsDataArgs = {
  guid: Scalars['ID']['input'];
};

export type AdsManagerRestaurantConversionsData = {
  __typename?: 'AdsManagerRestaurantConversionsData';
  googleConversionsData?: Maybe<GoogleConversionsData>;
  metaConversionsData?: Maybe<MetaConversionsData>;
  restaurantGuid: Scalars['ID']['output'];
};

export type AlternativePaymentError = Error & {
  __typename?: 'AlternativePaymentError';
  code: AlternativePaymentErrorCode;
  message: Scalars['String']['output'];
};

export enum AlternativePaymentErrorCode {
  /** Generic error response received from g2 service */
  PaymentGenericError = 'PAYMENT_GENERIC_ERROR',
  /** The requested payment is no longer available */
  PaymentOptionNotFound = 'PAYMENT_OPTION_NOT_FOUND'
}

export type AndroidVersionInput = {
  versionCode: Scalars['Int']['input'];
  versionName: Scalars['String']['input'];
};

export type ApplicableCustomerRewardInput = {
  /** The order amount that the customer is seeing while placing the order, accounting for the reward. */
  customerExpectedAmount: Scalars['Float']['input'];
  /** The customer reward to be applied to the order being placed. */
  reward: ApplyCustomerRewardInput;
};

export type AppliedCustomerReward = {
  __typename?: 'AppliedCustomerReward';
  amount?: Maybe<Scalars['Float']['output']>;
  beforeTax?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rewardType?: Maybe<RewardType>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** An object representing an applied funded offer */
export type AppliedFundedOffer = {
  __typename?: 'AppliedFundedOffer';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  offerGuid: Scalars['ID']['output'];
};

export type AppliedPreauthInfoInput = {
  cardHolderExpirationMonth?: InputMaybe<Scalars['String']['input']>;
  cardHolderExpirationYear?: InputMaybe<Scalars['String']['input']>;
  cardHolderFirstName?: InputMaybe<Scalars['String']['input']>;
  cardHolderLastName?: InputMaybe<Scalars['String']['input']>;
  cardHolderhash4?: InputMaybe<Scalars['String']['input']>;
  cardHolderhash6?: InputMaybe<Scalars['String']['input']>;
  cardType: Scalars['String']['input'];
  guid: Scalars['ID']['input'];
  last4CardDigits: Scalars['String']['input'];
  magStripeName?: InputMaybe<Scalars['String']['input']>;
  oneTimeUse?: InputMaybe<Scalars['Boolean']['input']>;
  preAuthAmount: Scalars['Float']['input'];
  readerType?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  useCount?: InputMaybe<Scalars['Int']['input']>;
};

/** Indicates that the `applyCodeToGuestCurrencyAccount` mutation failed to apply the input code to the `GuestCurrencyAccount`. See `applyCodeToGuestCurrencyAccount` documentation for security notes. */
export type ApplyCodeToGuestCurrencyAccountError = Error & {
  __typename?: 'ApplyCodeToGuestCurrencyAccountError';
  message: Scalars['String']['output'];
};

/** The input of the `applyCodeToGuestCurrencyAccount` mutation. */
export type ApplyCodeToGuestCurrencyAccountInput = {
  /** The code to apply to the guest's `GuestCurrencyAccount`. */
  code: Scalars['String']['input'];
  /** The unique identifier of the `GuestCurrencyAccount` to which the `code` is to be applied. */
  currencyAccountId: Scalars['ID']['input'];
};

/** The possible results of the `applyCodeToGuestCurrencyAccount` mutation. */
export type ApplyCodeToGuestCurrencyAccountResult = ApplyCodeToGuestCurrencyAccountError | ApplyCodeToGuestCurrencyAccountSuccess;

/** The successful result of the `applyCodeToGuestCurrencyAccount` mutation. */
export type ApplyCodeToGuestCurrencyAccountSuccess = {
  __typename?: 'ApplyCodeToGuestCurrencyAccountSuccess';
  /** The guest's updated Toast-specific currency account. See `Guest.currencyAccount` for detail. */
  currencyAccount: GuestCurrencyAccount;
  /** The `GuestCurrencyUnit` created as a result of the `applyCodeToGuestCurrencyAccount` operation. The created unit's balance is added to `GuestCurrencyAccount.availableBalance`. */
  currencyUnit: GuestCurrencyUnit;
};

export type ApplyCustomerRewardInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  beforeTax?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RewardType>;
};

/** Promo code error type and message. The message should be the same regardless of the code, as we do not want to expose any additional information that could help a malicious user abuse promo codes. */
export type ApplyPromoCodeError = Error & {
  __typename?: 'ApplyPromoCodeError';
  code: ApplyPromoCodeErrorCode;
  message: Scalars['String']['output'];
};

export enum ApplyPromoCodeErrorCode {
  /** Indicates that the code is a correct code but the specific user cannot use it. */
  CodeCannotBeRedeemed = 'CODE_CANNOT_BE_REDEEMED',
  /** Indicates that the code the user has entered does not exist. */
  CodeDoesNotExist = 'CODE_DOES_NOT_EXIST'
}

/** Input for when a customer attempts to apply a promo code for their cart. */
export type ApplyPromoCodeInput = {
  /** The guid of the cart that the user wishes to apply the promo code reward to. */
  cartGuid: Scalars['ID']['input'];
  /** A generic string that is used to look up rewards. */
  promoCode: Scalars['String']['input'];
};

/** Input for when a customer attempts to apply a promo code to their order. */
export type ApplyPromoCodeInputV2 = {
  /** The guid of the cart in the order the user wishes to apply the promo code reward to. */
  cartGuid: Scalars['ID']['input'];
  /** A string representing the type of the promo code being applied. */
  discountType: DiscountType;
  /** A generic string that is used to look up rewards. */
  promoCode: Scalars['String']['input'];
};

/** Input for when a customer attempts to apply a promo code to their order. */
export type ApplyPromoCodeInputV3 = {
  /** The guid of the cart in the order the user wishes to apply the promo code reward to. */
  cartGuid: Scalars['ID']['input'];
  /** A generic string that is used to look up rewards. */
  promoCode: Scalars['String']['input'];
};

/** When a user applies a promo code, on success, they should receive the cart with the reward applied. */
export type ApplyPromoCodeResponse = {
  __typename?: 'ApplyPromoCodeResponse';
  cart: Cart;
};

export type ApplyPromoCodeResponseOrError = ApplyPromoCodeError | ApplyPromoCodeResponse;

export type ApplyPromoCodeResponseOrErrorV2 = ApplyPromoCodeError | CartModificationError | CartOutOfStockError | CartResponse;

export type ApplyPromoInProgressOrderInput = {
  /** The guid of the check to apply the promo code */
  checkGuid: Scalars['ID']['input'];
  /** The guid of the order to apply the promo code */
  orderGuid: Scalars['ID']['input'];
  /** The promo code */
  promoCode: Scalars['String']['input'];
  /** The restaurant for the order to apply the promo code */
  restaurantGuid: Scalars['ID']['input'];
};

/** Toast funded offer (TFO) error type and message. */
export type ApplyToastFundedOfferError = Error & {
  __typename?: 'ApplyToastFundedOfferError';
  /** The error code for the TFO application. */
  code: ApplyToastFundedOfferErrorCode;
  /** The human readable message for the error. */
  message: Scalars['String']['output'];
};

/** Error codes encountered when applying a TFO. */
export enum ApplyToastFundedOfferErrorCode {
  /** Indicates that the TFO could not be applied. */
  ApplicationFailed = 'APPLICATION_FAILED',
  /** Indicates that the guest is not logged in. */
  GuestLoginRequired = 'GUEST_LOGIN_REQUIRED'
}

/** Input for when a customer attempts to apply a Toast funded offer (TFO) to their order. */
export type ApplyToastFundedOfferInput = {
  /** The guid of the cart in the order the user wishes to apply the TFO to. */
  cartGuid: Scalars['ID']['input'];
  /** The guid of the TFO the user wishes to apply to the cart. */
  offerGuid: Scalars['ID']['input'];
};

/** Return type for the applyToastFundedOffer mutation. Follows the pattern of other cart mutations. */
export type ApplyToastFundedOfferResponseOrError = ApplyToastFundedOfferError | CartModificationError | CartOutOfStockError | CartResponse;

export type ApprovalRule = {
  __typename?: 'ApprovalRule';
  requiredAdjustment: Scalars['Float']['output'];
  ruleType: OrderTriggerMatchType;
  thresholdAmount: Scalars['Float']['output'];
};

export type ArchiveGuestCommentInput = {
  commentId: Scalars['ID']['input'];
};

export type ArchiveGuestCommentResult = ArchiveGuestCommentSuccess | UnexpectedError;

export type ArchiveGuestCommentSuccess = {
  __typename?: 'ArchiveGuestCommentSuccess';
  commentContent: Scalars['String']['output'];
  commentId: Scalars['ID']['output'];
  socialUserId: Scalars['ID']['output'];
  targetId: Scalars['ID']['output'];
  targetType: GuestCommentTargetType;
};

export type ArchiveGuestPostInput = {
  postId: Scalars['ID']['input'];
};

export type ArchiveGuestPostResult = ArchiveGuestPostSuccess | UnexpectedError;

export type ArchiveGuestPostSuccess = {
  __typename?: 'ArchiveGuestPostSuccess';
  postContent: Scalars['String']['output'];
  postId: Scalars['ID']['output'];
  socialUserId: Scalars['ID']['output'];
};

export type ArchiveGuestReviewInput = {
  reviewId: Scalars['ID']['input'];
};

export type ArchiveGuestReviewResult = ArchiveGuestReviewSuccess | UnexpectedError;

export type ArchiveGuestReviewSuccess = {
  __typename?: 'ArchiveGuestReviewSuccess';
  guestId?: Maybe<Scalars['ID']['output']>;
  reviewContent: Scalars['String']['output'];
  reviewId: Scalars['ID']['output'];
};

export type ArchiveSocialUserProfilePhotoInput = {
  socialUserId: Scalars['ID']['input'];
};

export type ArchiveSocialUserProfilePhotoResult = ArchiveSocialUserProfilePhotoSuccess | UnexpectedError;

export type ArchiveSocialUserProfilePhotoSuccess = {
  __typename?: 'ArchiveSocialUserProfilePhotoSuccess';
  guestGuid: Scalars['ID']['output'];
  profilePhotoContent: Scalars['String']['output'];
  profilePhotoId: Scalars['ID']['output'];
  socialUserId: Scalars['ID']['output'];
};

export type AsapSchedule = {
  __typename?: 'AsapSchedule';
  /** The ISO 8601 date/time string that represents the earliest time, in the future, that an **ASAP** order can be placed. A null value indicates that no such time can be found. */
  availableAt?: Maybe<Scalars['String']['output']>;
  /** Whether **ASAP** option is available at the moment the request is made. */
  availableNow: Scalars['Boolean']['output'];
};

export type AuthorizePaymentError = Error & {
  __typename?: 'AuthorizePaymentError';
  message: Scalars['String']['output'];
};

export type AuthorizePaymentInput = {
  /** Check amount to authorize the card for */
  amount: Scalars['Float']['input'];
  /** cart guid to associate with the payment request */
  cartGuid?: InputMaybe<Scalars['String']['input']>;
  /** The guest's email address */
  email: Scalars['String']['input'];
  /** some orders on COO might come from a special menu, this is that name */
  fastLinkName?: InputMaybe<Scalars['String']['input']>;
  /** A new credit card with encrypted data. Either newCardInput, savedCardInput or pkPaymentToken must be supplied. */
  newCardInput?: InputMaybe<NewCardInput>;
  /** reCaptcha token for fraud prevention */
  reCaptchaToken?: InputMaybe<Scalars['String']['input']>;
  /** The guid of the restaurant which has the order being paid for */
  restaurantGuid: Scalars['ID']['input'];
  /** The amount that the consumer selected to tip */
  tipAmount: Scalars['Float']['input'];
};

export type AuthorizePaymentResponse = {
  __typename?: 'AuthorizePaymentResponse';
  /** The amount of this payment not including tip. */
  amount: Scalars['Float']['output'];
  /** The reason a payment was denied. This must be displayed to the user. */
  denialReason?: Maybe<Scalars['String']['output']>;
  paymentGuid?: Maybe<Scalars['ID']['output']>;
  /** The state of the payment. Toast may introduce enum values at any time, please future-proof your implementation */
  paymentState?: Maybe<PaymentState>;
  /** The tip amount of this payment. */
  tipAmount: Scalars['Float']['output'];
};

export type AuthorizePaymentResponseOrError = AuthorizePaymentError | AuthorizePaymentResponse;

export type AwardLeaderboard = {
  __typename?: 'AwardLeaderboard';
  awardType: AwardType;
  /** Places are ordered by number of votes received, descending. */
  placesAwarded: Array<PlaceAwardTally>;
};

export type AwardSeason = {
  __typename?: 'AwardSeason';
  endDateTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDateTime: Scalars['DateTime']['output'];
};

export type AwardSeasonHasEndedError = Error & {
  __typename?: 'AwardSeasonHasEndedError';
  message: Scalars['String']['output'];
};

export type AwardType = {
  __typename?: 'AwardType';
  awardSeasonId: Scalars['ID']['output'];
  /** The description of the award. Text used to power the subtitle on the leaderboard. */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum BackfillEligibilityStatus {
  /** The card fingerprint is not eligible for backfilling because a backfill was already performed from the card link. */
  BackfillAlreadyPerformedFromLink = 'BACKFILL_ALREADY_PERFORMED_FROM_LINK',
  /** The card fingerprint is eligible for backfilling. */
  Eligible = 'ELIGIBLE',
  /** The card fingerprint is not eligible for backfilling because it is not eligible to be linked. */
  Ineligible = 'INELIGIBLE',
  /** The card fingerprint is not eligible for backfilling because it was recently backfilled by you. */
  RecentlyBackfilled = 'RECENTLY_BACKFILLED'
}

/** The result of the `backfillGuestOrderHistoryByCardFingerprints` mutation that represents the backfill guest order history attempts and their results. */
export type BackfillGuestOrderHistoryByCardFingerprintsAttempts = {
  __typename?: 'BackfillGuestOrderHistoryByCardFingerprintsAttempts';
  failedCardFingerprintIds: Array<BackfillGuestOrderHistoryByCardFingerprintsFailure>;
  /** This represents the order that the guest has ordered most recently among all the orders that were successfully backfilled. For example, if the guest has ordered at restaurant A on 2019-01-01, restaurant B on 2019-01-02, and restaurant A again on 2019-01-03, this will be the order at restaurant A on 2019-01-03. Null if no orders were successfully backfilled and to accommodate the inability to resolve due to crossing network boundary. */
  highlightedOrder?: Maybe<CompletedOrder>;
  /** The deduplicated list of restaurants at which the orders successfully backfilled were placed. This list is sorted by the most recently ordered restaurant first. In the case that a restaurant is not found and a required field is requested (e.g. name), then the value for that restaurant will be null. */
  maybeRestaurants: Array<Maybe<Restaurant>>;
  /** The deduplicated list of restaurants at which the orders successfully backfilled were placed. This list is sorted by the most recently ordered restaurant first. For example, if the guest has ordered at restaurant A on 2019-01-01, restaurant B on 2019-01-02, and restaurant A again on 2019-01-03, the list will be [restaurant A, restaurant B]. This is an all-or-nothing request, so if there is a failure to resolve a required field (e.g. name) from a single restaurant then the entire request will fail. See `maybeRestaurants` for an alternative. */
  restaurants: Array<Restaurant>;
  successfulCardFingerprintIds: Array<Scalars['String']['output']>;
  /** The list of restaurants where orders were successfully backfilled, ordered by frequency (most frequent at the front of the list) and then by recency. */
  visitedRestaurants: Array<GuestVisitedRestaurant>;
};

/** Represents a backfill guest order history by card fingerprint failure attempt. */
export type BackfillGuestOrderHistoryByCardFingerprintsFailure = {
  __typename?: 'BackfillGuestOrderHistoryByCardFingerprintsFailure';
  cardFingerprintId: Scalars['String']['output'];
  reason: BackfillGuestOrderHistoryByCardFingerprintsFailureReason;
};

/** Possible reasons for why a card fingerprint failed to be used to backfill a guest's order history. */
export enum BackfillGuestOrderHistoryByCardFingerprintsFailureReason {
  /** The card fingerprint is ineligible to be linked and hence cannot be used to backfill guest order history. */
  IneligibleForLinking = 'INELIGIBLE_FOR_LINKING',
  /** The card fingerprint has been used to backfill guest order history in the last 1 day. */
  RecentlyBackfilled = 'RECENTLY_BACKFILLED',
  /** There are issues with upstream systems that backfilling guest order history depends on. */
  UpstreamSystemsIssue = 'UPSTREAM_SYSTEMS_ISSUE'
}

/** The input of the `backfillGuestOrderHistoryByCardFingerprints` mutation. */
export type BackfillGuestOrderHistoryByCardFingerprintsInput = {
  cardFingerprintIds: Array<Scalars['String']['input']>;
};

/** The possible results of the `backfillGuestOrderHistoryByCardFingerprints` mutation. */
export type BackfillGuestOrderHistoryByCardFingerprintsResult = BackfillGuestOrderHistoryByCardFingerprintsAttempts | BackfillGuestOrderHistoryTooManyCardFingerprintsError | UnexpectedError;

export type BackfillGuestOrderHistoryTooManyCardFingerprintsError = Error & ValidationError & {
  __typename?: 'BackfillGuestOrderHistoryTooManyCardFingerprintsError';
  message: Scalars['String']['output'];
};

export type BalanceMessagesData = {
  __typename?: 'BalanceMessagesData';
  /** For 1st party this will return balance as either points or visits depending on the accrual type. Supports singular/plural forms. For 3rd party we show the message as points. e.g. 'You have 1 visit' or 'You have 50 points' */
  balance?: Maybe<Scalars['String']['output']>;
  /** For 1st party this will return balance as either points or visits depending on the accrual type. Supports singular/plural forms. For 3rd party we show the message as points. e.g. 'Total points: 100' or 'Total visits: 10' */
  balanceShort?: Maybe<Scalars['String']['output']>;
};

/** Loyalty account balance information and messages. This can be used both for first and third party loyalty providers, (notes: that some third party providers may not provide the balance information though). */
export type BalanceStateData = {
  __typename?: 'BalanceStateData';
  /** Loyalty account balance. For 1st party can be visits or points. Loyalty always stores balance in points but performs conversion to visits based on visitConfig.pointsPerVisit configuration. For 3rd party can be points only. */
  balance?: Maybe<Scalars['Int']['output']>;
  /** Loyalty account balance in points. */
  balancePoints?: Maybe<Scalars['Int']['output']>;
  /** Different messages related to balance that should be used on different applications supporting loyalty. */
  messages?: Maybe<BalanceMessagesData>;
};

export type BanSocialUserRequest = {
  socialUser: SocialUserInput;
};

export type BanSocialUserResult = BanSocialUserSuccess | SocialUserBannedError | SocialUserDoesNotExistError | UnexpectedError;

export type BanSocialUserSuccess = {
  __typename?: 'BanSocialUserSuccess';
  socialUser: SocialUser;
};

export type BaseOfferTargeting = {
  type: Scalars['String']['output'];
};

export type BaseRankedToastFundedOffer = {
  /** Whether the offer is active or disabled */
  active: Scalars['Boolean']['output'];
  /** The dollar amount needed to reach the offer threshold */
  amountNeeded: Scalars['Float']['output'];
  /** The end date of the offer */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Estimates how much money will be saved if they reach the offer threshold and apply the offer. This is not exact since some types may depend on the final prices of items in the cart during checkout. */
  estimatedSavings: Scalars['Float']['output'];
  guid: Scalars['ID']['output'];
  /** The maximum number of redemptions per guest */
  maxGuestRedemptions: Scalars['Int']['output'];
  /** The minimum purchase amount required to apply the offer */
  minPurchaseAmount: Money;
  /** This is true once the offer has been added to the cart, if applicable. */
  offerClaimed: Scalars['Boolean']['output'];
  /** An expanded description of the funded offer */
  offerDescription?: Maybe<Scalars['String']['output']>;
  /** The funded offer name */
  offerName: Scalars['String']['output'];
  /** 0-100% to being able to apply the offer. Use whole percentages to be consistent with offer percents. */
  percentComplete: Scalars['Float']['output'];
  /** 0-100% see percentComplete, but in Int format to avoid precision errors when using Double */
  percentCompleteInt: Scalars['Int']['output'];
  /** The start date of the offer */
  startDate: Scalars['DateTime']['output'];
  /** The targeting for the offer. This is a union type that can be one of the following: - NoTargeting - RestaurantTargeting - LocationTargeting */
  targeting: OfferTargeting;
};

export type BaseToastFundedOffer = {
  active: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  guid: Scalars['ID']['output'];
  maxGuestRedemptions: Scalars['Int']['output'];
  minPurchaseAmount: Money;
  offerDescription?: Maybe<Scalars['String']['output']>;
  offerName: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  targeting: OfferTargeting;
};

/** Fields that can be changed as part of updating the basic info on an account. All are required, but can be left the same as the current values stored in the database. */
export type BasicInfoInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

/** A birthday already exists for the guest. */
export type BirthdayAlreadyExistsError = Error & {
  __typename?: 'BirthdayAlreadyExistsError';
  message: Scalars['String']['output'];
};

/** When providing a birthday, the birthday consent must be provided. */
export enum BirthdayConsentedUseCase {
  Rewards = 'REWARDS'
}

export type Booking = {
  __typename?: 'Booking';
  bookingNotes?: Maybe<Scalars['String']['output']>;
  bookingStatus: BookingStatus;
  bookingType: BookingType;
  createdByAuthenticatedUser: Scalars['Boolean']['output'];
  depositAmount?: Maybe<Scalars['Float']['output']>;
  depositBookableConfigSnapshot?: Maybe<BookingDepositBookableConfigSnapshot>;
  depositCheckId?: Maybe<Scalars['ID']['output']>;
  depositOrderId?: Maybe<Scalars['ID']['output']>;
  depositPaymentExpirationDatetime?: Maybe<Scalars['DateTime']['output']>;
  depositRefundableCancellationDatetime?: Maybe<Scalars['DateTime']['output']>;
  depositStatus?: Maybe<Scalars['String']['output']>;
  expectedStartTime: Scalars['DateTime']['output'];
  externalServiceArea?: Maybe<Scalars['String']['output']>;
  externalServiceAreas?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  mainGuest?: Maybe<BookingGuest>;
  partySize?: Maybe<Scalars['Int']['output']>;
  requestedServiceAreaGroups: Array<BookingServiceAreaGroup>;
  restaurant?: Maybe<Restaurant>;
  restaurantGuid?: Maybe<Scalars['ID']['output']>;
  serviceAreaGroup?: Maybe<BookingServiceAreaGroup>;
  specialOccasion: BookingSpecialOccasion;
};

/** Bulk availabilities */
export type BookingBulkAvailabilitiesRestaurantLimitExceeded = BookingError & Error & {
  __typename?: 'BookingBulkAvailabilitiesRestaurantLimitExceeded';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingCancelReservationResponse = BookingCancelReservationResponseSuccess | BookingInternalError | BookingNotFound | BookingRestaurantNotFound | BookingUnableToRefundDeposit | BookingUnauthorizedGuestProfile | BookingUnsupportedTransition;

export type BookingCancelReservationResponseSuccess = {
  __typename?: 'BookingCancelReservationResponseSuccess';
  bookingGuid: Scalars['ID']['output'];
};

export type BookingCreateReservationRequest = {
  bookingNotes?: InputMaybe<Scalars['String']['input']>;
  dateTime: Scalars['DateTime']['input'];
  deposit?: InputMaybe<BookingDepositRequest>;
  externalServiceArea: Scalars['String']['input'];
  guest: BookingGuestInput;
  partySize: Scalars['Int']['input'];
  paymentGuid?: InputMaybe<Scalars['ID']['input']>;
  requestedServiceAreaGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  restaurantGuid: Scalars['ID']['input'];
  rwgConversionTracking?: InputMaybe<BookingRwgConversionTrackingInput>;
  specialOccasion?: Scalars['String']['input'];
};

export type BookingCreateReservationResponse = BookingCreateReservationResponseSuccess | BookingDepositAmountChanged | BookingDepositRuleNotMatching | BookingInvalidEmail | BookingInvalidPartySize | BookingInvalidPhoneNumber | BookingNoTableAvailable | BookingOverlappingBooking | BookingRequiresDepositData | BookingRestaurantIsClosed | BookingRestaurantNotFound | BookingServiceAreaNotFound | BookingUnableToCreateDepositOrder | BookingUnableToCreateGuest;

export type BookingCreateReservationResponseSuccess = {
  __typename?: 'BookingCreateReservationResponseSuccess';
  booking: Booking;
};

export type BookingCreateWaitlistRequest = {
  bookingNotes?: InputMaybe<Scalars['String']['input']>;
  externalServiceAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  guest: BookingGuestInput;
  partySize: Scalars['Int']['input'];
  requestedServiceAreaGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  restaurantGuid: Scalars['ID']['input'];
  specialOccasion?: Scalars['String']['input'];
};

export type BookingCreateWaitlistResponse = BookingCreateReservationResponseSuccess | BookingInvalidEmail | BookingInvalidPartySize | BookingInvalidPhoneNumber | BookingOverlappingBooking | BookingRestaurantIsClosed | BookingRestaurantNotFound | BookingServiceAreaNotFound | BookingUnableToCreateGuest;

export type BookingDepositAmountChanged = BookingError & Error & {
  __typename?: 'BookingDepositAmountChanged';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingDepositAvailabilityInfo = {
  __typename?: 'BookingDepositAvailabilityInfo';
  autoCancelUnpaidDeposit: Scalars['Boolean']['output'];
  autoCancelUnpaidDepositTimeframe: Scalars['Int']['output'];
  cancellationRefundableTimeframe: Scalars['Int']['output'];
  depositPolicy?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  strategy: BookingDepositStrategy;
};

export type BookingDepositBookableConfigSnapshot = {
  __typename?: 'BookingDepositBookableConfigSnapshot';
  cancellationRefundableTimeframe?: Maybe<Scalars['Int']['output']>;
  depositPolicy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  strategy?: Maybe<BookingDepositBookableConfigSnapshotStrategy>;
};

export type BookingDepositBookableConfigSnapshotStrategy = {
  __typename?: 'BookingDepositBookableConfigSnapshotStrategy';
  amount: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type BookingDepositRequest = {
  depositAmount: Scalars['Float']['input'];
  depositBookableConfigGuid: Scalars['ID']['input'];
};

export type BookingDepositRuleNotMatching = BookingError & Error & {
  __typename?: 'BookingDepositRuleNotMatching';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingDepositStrategy = {
  actualAmount: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type BookingDepositStrategyByBooking = BookingDepositStrategy & {
  __typename?: 'BookingDepositStrategyByBooking';
  actualAmount: Scalars['Float']['output'];
  amountsByParty: Array<Scalars['Float']['output']>;
  defaultAmount: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type BookingDepositStrategyByPartySize = BookingDepositStrategy & {
  __typename?: 'BookingDepositStrategyByPartySize';
  actualAmount: Scalars['Float']['output'];
  amountPerGuest: Scalars['Float']['output'];
  maxPartySize?: Maybe<Scalars['Int']['output']>;
  minPartySize: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type BookingError = {
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export enum BookingErrorCode {
  Accepted = 'ACCEPTED',
  BadRequest = 'BAD_REQUEST',
  Conflict = 'CONFLICT',
  ExpectationFailed = 'EXPECTATION_FAILED',
  Forbidden = 'FORBIDDEN',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  NotFound = 'NOT_FOUND',
  UnableToRefund = 'UNABLE_TO_REFUND',
  UnauthorizedGuest = 'UNAUTHORIZED_GUEST',
  UnsupportedTransition = 'UNSUPPORTED_TRANSITION'
}

export type BookingGuest = {
  __typename?: 'BookingGuest';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  guestProfilesGuid?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type BookingGuestBookingInput = {
  /** The booking guid to fetch */
  bookingGuid: Scalars['ID']['input'];
};

export type BookingGuestBookingsResponse = BookingGuestBookingsResponseSuccess | BookingInternalError;

export type BookingGuestBookingsResponseSuccess = {
  __typename?: 'BookingGuestBookingsResponseSuccess';
  bookings: Array<Booking>;
};

export type BookingGuestInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type BookingGuestNotFound = BookingError & Error & {
  __typename?: 'BookingGuestNotFound';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingHours = {
  __typename?: 'BookingHours';
  friday: Array<BookingTimeSlot>;
  monday: Array<BookingTimeSlot>;
  saturday: Array<BookingTimeSlot>;
  sunday: Array<BookingTimeSlot>;
  thursday: Array<BookingTimeSlot>;
  tuesday: Array<BookingTimeSlot>;
  wednesday: Array<BookingTimeSlot>;
};

export type BookingInternalError = BookingError & Error & {
  __typename?: 'BookingInternalError';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingInvalidBooking = BookingError & Error & {
  __typename?: 'BookingInvalidBooking';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingInvalidEmail = BookingError & Error & {
  __typename?: 'BookingInvalidEmail';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingInvalidPartySize = BookingError & Error & {
  __typename?: 'BookingInvalidPartySize';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingInvalidPhoneNumber = BookingError & Error & {
  __typename?: 'BookingInvalidPhoneNumber';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingMutation = {
  __typename?: 'BookingMutation';
  cancelGuestReservation: BookingCancelReservationResponse;
  cancelPublicReservation: BookingCancelReservationResponse;
  createGuestReservation: BookingCreateReservationResponse;
  createGuestWaitlist: BookingCreateWaitlistResponse;
  createPublicReservation: BookingCreateReservationResponse;
  updateGuestReservation: BookingUpdateReservationResponse;
  updateGuestWaitlist: BookingUpdateWaitlistResponse;
  updatePublicReservation: BookingUpdateReservationResponse;
};


export type BookingMutationCancelGuestReservationArgs = {
  bookingGuid: Scalars['ID']['input'];
};


export type BookingMutationCancelPublicReservationArgs = {
  bookingGuid: Scalars['ID']['input'];
};


export type BookingMutationCreateGuestReservationArgs = {
  request: BookingCreateReservationRequest;
};


export type BookingMutationCreateGuestWaitlistArgs = {
  request: BookingCreateWaitlistRequest;
};


export type BookingMutationCreatePublicReservationArgs = {
  request: BookingCreateReservationRequest;
};


export type BookingMutationUpdateGuestReservationArgs = {
  request: BookingUpdateReservationRequest;
};


export type BookingMutationUpdateGuestWaitlistArgs = {
  request: BookingUpdateWaitlistRequest;
};


export type BookingMutationUpdatePublicReservationArgs = {
  request: BookingUpdateReservationRequest;
};

export type BookingNoTableAvailable = BookingError & Error & {
  __typename?: 'BookingNoTableAvailable';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingNotFound = BookingError & Error & {
  __typename?: 'BookingNotFound';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingOverlappingBooking = BookingError & Error & {
  __typename?: 'BookingOverlappingBooking';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingPublicAvailabilities = {
  __typename?: 'BookingPublicAvailabilities';
  datetime: Scalars['DateTime']['output'];
  serviceAreas: Array<BookingPublicServiceArea>;
};

export type BookingPublicAvailabilitiesInput = {
  /** The booking guid for which to search availability */
  bookingGuid?: InputMaybe<Scalars['ID']['input']>;
  /** The end time of the availability search */
  endTime: Scalars['String']['input'];
  /** The party size for which to search availability */
  partySize: Scalars['Int']['input'];
  /** The guid for the restaurant for which to search availabilities */
  restaurantGuid: Scalars['ID']['input'];
  /** The the ID of the service area group to confine the availability search to */
  serviceAreaGroupGuid?: InputMaybe<Scalars['ID']['input']>;
  /** The start time of the availability search */
  startTime: Scalars['String']['input'];
};

export type BookingPublicAvailabilitiesResponse = BookingNotFound | BookingPublicAvailabilitiesResponseSuccess | BookingRestaurantNotFound;

export type BookingPublicAvailabilitiesResponseSuccess = {
  __typename?: 'BookingPublicAvailabilitiesResponseSuccess';
  availabilities: Array<BookingPublicAvailabilities>;
  restaurantGuid: Scalars['ID']['output'];
};

export type BookingPublicBookingInput = {
  /** The booking guid to fetch */
  bookingGuid: Scalars['ID']['input'];
};

export type BookingPublicBookingResponse = BookingInternalError | BookingNotFound | BookingPublicBookingResponseSuccess | BookingRestaurantNotFound | BookingUnableToFetchGuests;

export type BookingPublicBookingResponseSuccess = {
  __typename?: 'BookingPublicBookingResponseSuccess';
  booking: Booking;
};

export type BookingPublicBulkAvailabilitiesError = {
  __typename?: 'BookingPublicBulkAvailabilitiesError';
  errors?: Maybe<Array<BookingPublicBulkAvailabilitiesErrorResponse>>;
};

export type BookingPublicBulkAvailabilitiesErrorResponse = BookingNotFound | BookingRestaurantNotFound;

export type BookingPublicBulkAvailabilitiesInput = {
  /** The end time of the availability search */
  endTime: Scalars['DateTime']['input'];
  /** The party size for which to search availability */
  partySize: Scalars['Int']['input'];
  /** The guid for the restaurant for which to search availabilities */
  restaurantGuids: Array<Scalars['ID']['input']>;
  /** The start time of the availability search */
  startTime: Scalars['DateTime']['input'];
};

/** Bulk availabilities */
export type BookingPublicBulkAvailabilitiesResponse = BookingBulkAvailabilitiesRestaurantLimitExceeded | BookingPublicBulkAvailabilitiesError | BookingPublicBulkAvailabilitiesResponseSuccess;

export type BookingPublicBulkAvailabilitiesResponseSuccess = {
  __typename?: 'BookingPublicBulkAvailabilitiesResponseSuccess';
  availabilities: Array<BookingPublicAvailabilitiesResponseSuccess>;
};

export type BookingPublicBulkWaitlistEstimatesByBookingInput = {
  bookingGuid: Scalars['ID']['input'];
  restaurantGuid: Scalars['ID']['input'];
};

export type BookingPublicBulkWaitlistEstimatesByRestaurantInput = {
  partySize?: InputMaybe<Scalars['Int']['input']>;
  restaurantGuids: Array<Scalars['ID']['input']>;
};

export type BookingPublicBulkWaitlistEstimatesResponse = BookingPublicBulkWaitlistEstimatesSuccess | BookingRestaurantLimitExceeded;

export type BookingPublicBulkWaitlistEstimatesSuccess = {
  __typename?: 'BookingPublicBulkWaitlistEstimatesSuccess';
  estimates: Array<BookingPublicWaitlistEstimateById>;
};

export type BookingPublicBulkWaitlistInfoInput = {
  /** list of restaurant IDs to get waitlist info for */
  restaurantGuids: Array<Scalars['ID']['input']>;
};

export type BookingPublicBulkWaitlistInfoResponse = BookingPublicBulkWaitlistInfoSuccess | BookingRestaurantLimitExceeded;

export type BookingPublicBulkWaitlistInfoSuccess = {
  __typename?: 'BookingPublicBulkWaitlistInfoSuccess';
  waitlistInfoByRestaurant: Array<BookingPublicWaitlistInfo>;
};

export type BookingPublicDayInfo = {
  __typename?: 'BookingPublicDayInfo';
  blockedReason: Scalars['String']['output'];
  onlineReservationsBlocked: Scalars['Boolean']['output'];
  onlineWaitlistBlocked: Scalars['Boolean']['output'];
  specialDateDescription: Scalars['String']['output'];
  specialDateName: Scalars['String']['output'];
};

export type BookingPublicDayInfoInput = {
  /** The date for which to fetch day info */
  businessDate: Scalars['DateTime']['input'];
  /** The restaurant guid for which to fetch day info */
  restaurantGuid: Scalars['ID']['input'];
};

export type BookingPublicDayInfoResponse = {
  __typename?: 'BookingPublicDayInfoResponse';
  dayInfo: BookingPublicDayInfo;
};

export type BookingPublicRestaurantInput = {
  /** The restaurant guid for which to fetch booking information */
  restaurantGuid: Scalars['ID']['input'];
};

export type BookingPublicRestaurantResponse = BookingInternalError | BookingPublicRestaurantResponseSuccess | BookingRestaurantNotFound;

export type BookingPublicRestaurantResponseSuccess = {
  __typename?: 'BookingPublicRestaurantResponseSuccess';
  restaurant: Restaurant;
};

export type BookingPublicServiceArea = {
  __typename?: 'BookingPublicServiceArea';
  deposit?: Maybe<BookingDepositAvailabilityInfo>;
  externalServiceArea?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  serviceAreaGroup?: Maybe<BookingServiceAreaGroup>;
};

export type BookingPublicWaitlistEstimateById = {
  __typename?: 'BookingPublicWaitlistEstimateByID';
  estimateOrError: BookingPublicWaitlistEstimateResponse;
  id: Scalars['ID']['output'];
};

export type BookingPublicWaitlistEstimateInput = {
  bookingGuid?: InputMaybe<Scalars['ID']['input']>;
  partySize?: InputMaybe<Scalars['Int']['input']>;
  restaurantGuid: Scalars['ID']['input'];
};

export type BookingPublicWaitlistEstimateResponse = BookingInternalError | BookingInvalidBooking | BookingNotFound | BookingPublicWaitlistEstimateResponseSuccess | BookingRestaurantIsClosed | BookingRestaurantNotFound;

export type BookingPublicWaitlistEstimateResponseSuccess = {
  __typename?: 'BookingPublicWaitlistEstimateResponseSuccess';
  partiesAheadByArea?: Maybe<Array<BookingWaitlistServiceAreaGroup>>;
  totalPartiesAhead: Scalars['Int']['output'];
  totalPartiesWaiting: Scalars['Int']['output'];
};

export type BookingPublicWaitlistInfo = {
  __typename?: 'BookingPublicWaitlistInfo';
  isOpenNow: Scalars['Boolean']['output'];
  maxPartySize: Scalars['Int']['output'];
  minPartySize: Scalars['Int']['output'];
  restaurantGuid: Scalars['ID']['output'];
};

export type BookingPublicWaitlistInfoInput = {
  /** restaurant ID to get waitlist info for */
  restaurantGuid: Scalars['ID']['input'];
};

export type BookingPublicWaitlistInfoResponse = BookingPublicWaitlistInfoSuccess | BookingRestaurantIsClosed | BookingRestaurantNotFound;

export type BookingPublicWaitlistInfoSuccess = {
  __typename?: 'BookingPublicWaitlistInfoSuccess';
  waitlistInfo: BookingPublicWaitlistInfo;
};

export type BookingQuery = {
  __typename?: 'BookingQuery';
  guestBookings: BookingGuestBookingsResponse;
  /** bookingType: The type of booking to return. If null, returns all booking types. */
  guestBookingsByBookingType: BookingGuestBookingsResponse;
  publicAvailabilities: BookingPublicAvailabilitiesResponse;
  publicBooking: BookingPublicBookingResponse;
  publicBulkAvailabilities: BookingPublicBulkAvailabilitiesResponse;
  publicBulkWaitlistEstimatesByBooking: BookingPublicBulkWaitlistEstimatesResponse;
  publicBulkWaitlistEstimatesByRestaurant: BookingPublicBulkWaitlistEstimatesResponse;
  publicBulkWaitlistInfo: BookingPublicBulkWaitlistInfoResponse;
  publicDayInfo: BookingPublicDayInfoResponse;
  publicRestaurant: BookingPublicRestaurantResponse;
  publicWaitlistEstimate: BookingPublicWaitlistEstimateResponse;
  publicWaitlistInfo: BookingPublicWaitlistInfoResponse;
};


export type BookingQueryGuestBookingsByBookingTypeArgs = {
  bookingType?: InputMaybe<BookingType>;
};


export type BookingQueryPublicAvailabilitiesArgs = {
  input: BookingPublicAvailabilitiesInput;
};


export type BookingQueryPublicBookingArgs = {
  input: BookingPublicBookingInput;
};


export type BookingQueryPublicBulkAvailabilitiesArgs = {
  input: BookingPublicBulkAvailabilitiesInput;
};


export type BookingQueryPublicBulkWaitlistEstimatesByBookingArgs = {
  input: Array<BookingPublicBulkWaitlistEstimatesByBookingInput>;
};


export type BookingQueryPublicBulkWaitlistEstimatesByRestaurantArgs = {
  input: BookingPublicBulkWaitlistEstimatesByRestaurantInput;
};


export type BookingQueryPublicBulkWaitlistInfoArgs = {
  input: BookingPublicBulkWaitlistInfoInput;
};


export type BookingQueryPublicDayInfoArgs = {
  input: BookingPublicDayInfoInput;
};


export type BookingQueryPublicRestaurantArgs = {
  input: BookingPublicRestaurantInput;
};


export type BookingQueryPublicWaitlistEstimateArgs = {
  input: BookingPublicWaitlistEstimateInput;
};


export type BookingQueryPublicWaitlistInfoArgs = {
  input: BookingPublicWaitlistInfoInput;
};

export type BookingRequiresDepositData = BookingError & Error & {
  __typename?: 'BookingRequiresDepositData';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingRestaurantAvailabilityInfo = {
  __typename?: 'BookingRestaurantAvailabilityInfo';
  invalidPartySize: Scalars['Boolean']['output'];
  onlineReservationsDisabled: Scalars['Boolean']['output'];
  reservationsDisabled: Scalars['Boolean']['output'];
  slots: Array<BookingSlotAvailabilityInfo>;
};

export type BookingRestaurantConfig = {
  __typename?: 'BookingRestaurantConfig';
  allowJoinOnlineNoWait: Scalars['Boolean']['output'];
  bookingHours: BookingHours;
  bookingMaxHoursInAdvance: Scalars['Int']['output'];
  bookingMinHoursInAdvance: Scalars['Int']['output'];
  bookingProfilePicUrl: Scalars['String']['output'];
  closeOutHour: Scalars['Int']['output'];
  coursingEnabled: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  maxPartySize: Scalars['Int']['output'];
  minPartySize: Scalars['Int']['output'];
  onlineReservationsEnabled: Scalars['Boolean']['output'];
  onlineWaitlistEnabled: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
  reservationPolicy: Scalars['String']['output'];
  serviceAreaGroups: Array<BookingServiceAreaGroup>;
  showWaitlistEstimate: Scalars['Boolean']['output'];
  waitlistEnabled: Scalars['Boolean']['output'];
  waitlistMaxPartySize: Scalars['Int']['output'];
  waitlistMinPartySize: Scalars['Int']['output'];
  waitlistPolicy: Scalars['String']['output'];
  websiteUrl: Scalars['String']['output'];
};

export type BookingRestaurantIsClosed = BookingError & Error & {
  __typename?: 'BookingRestaurantIsClosed';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingRestaurantLimitExceeded = BookingError & Error & {
  __typename?: 'BookingRestaurantLimitExceeded';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingRestaurantNotFound = BookingError & Error & {
  __typename?: 'BookingRestaurantNotFound';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingRwgConversionTrackingInput = {
  merchantId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type BookingServiceAreaAvailabilityInfo = {
  __typename?: 'BookingServiceAreaAvailabilityInfo';
  deposit?: Maybe<BookingDepositAvailabilityInfo>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  serviceAreaGroup: BookingServiceAreaGroup;
};

export type BookingServiceAreaGroup = {
  __typename?: 'BookingServiceAreaGroup';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  serviceAreas?: Maybe<Array<Scalars['ID']['output']>>;
};

export type BookingServiceAreaNotFound = BookingError & Error & {
  __typename?: 'BookingServiceAreaNotFound';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingSlotAvailabilityInfo = {
  __typename?: 'BookingSlotAvailabilityInfo';
  blockedReason: Scalars['String']['output'];
  bookingMaxHoursInAdvance: Scalars['Int']['output'];
  bookingMinHoursInAdvance: Scalars['Int']['output'];
  currentCovers: Scalars['Int']['output'];
  datetime: Scalars['DateTime']['output'];
  hostReservationsBlocked: Scalars['Boolean']['output'];
  maxCoversPerTimeslot: Scalars['Int']['output'];
  notInSlotSize: Scalars['Boolean']['output'];
  onlineReservationsBlocked: Scalars['Boolean']['output'];
  onlineReservationsDisabled: Scalars['Boolean']['output'];
  serviceAreas: Array<BookingServiceAreaAvailabilityInfo>;
  servicePeriodName?: Maybe<Scalars['String']['output']>;
  servicePeriodOverrideName?: Maybe<Scalars['String']['output']>;
  slotSize: Scalars['Int']['output'];
  tooFar: Scalars['Boolean']['output'];
  tooNear: Scalars['Boolean']['output'];
  violatesCoverFlow: Scalars['Boolean']['output'];
};

export enum BookingSpecialOccasion {
  Anniversary = 'ANNIVERSARY',
  Birthday = 'BIRTHDAY',
  Business = 'BUSINESS',
  Celebration = 'CELEBRATION',
  Date = 'DATE',
  None = 'NONE',
  Reunion = 'REUNION'
}

export enum BookingStatus {
  RArrived = 'R_ARRIVED',
  RCancelled = 'R_CANCELLED',
  RCheckedIn = 'R_CHECKED_IN',
  RConfirmed = 'R_CONFIRMED',
  RCreated = 'R_CREATED',
  RDone = 'R_DONE',
  RLateArrival = 'R_LATE_ARRIVAL',
  RNoShow = 'R_NO_SHOW',
  RPartiallyArrived = 'R_PARTIALLY_ARRIVED',
  RSeated = 'R_SEATED',
  WArrived = 'W_ARRIVED',
  WCancelled = 'W_CANCELLED',
  WCheckedIn = 'W_CHECKED_IN',
  WConfirmed = 'W_CONFIRMED',
  WDone = 'W_DONE',
  WLateArrival = 'W_LATE_ARRIVAL',
  WNotified = 'W_NOTIFIED',
  WNoShow = 'W_NO_SHOW',
  WPartiallyArrived = 'W_PARTIALLY_ARRIVED',
  WSeated = 'W_SEATED',
  WWaiting = 'W_WAITING'
}

export type BookingTimeSlot = {
  __typename?: 'BookingTimeSlot';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export enum BookingType {
  Reservation = 'RESERVATION',
  Waitlist = 'WAITLIST'
}

export type BookingUnableToCreateDepositOrder = BookingError & Error & {
  __typename?: 'BookingUnableToCreateDepositOrder';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingUnableToCreateGuest = BookingError & Error & {
  __typename?: 'BookingUnableToCreateGuest';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingUnableToFetchGuests = BookingError & Error & {
  __typename?: 'BookingUnableToFetchGuests';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingUnableToRefundDeposit = BookingError & Error & {
  __typename?: 'BookingUnableToRefundDeposit';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingUnableToSendSms = BookingError & Error & {
  __typename?: 'BookingUnableToSendSMS';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingUnableToUpdateReservation = BookingError & Error & {
  __typename?: 'BookingUnableToUpdateReservation';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingUnauthorizedGuestProfile = BookingError & Error & {
  __typename?: 'BookingUnauthorizedGuestProfile';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingUnsupportedTransition = BookingError & Error & {
  __typename?: 'BookingUnsupportedTransition';
  message: Scalars['String']['output'];
  status: BookingErrorCode;
};

export type BookingUpdateReservationRequest = {
  bookingGuid: Scalars['ID']['input'];
  bookingNotes?: InputMaybe<Scalars['String']['input']>;
  expectedStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  externalServiceArea?: InputMaybe<Scalars['String']['input']>;
  guest?: InputMaybe<BookingGuestInput>;
  partySize?: InputMaybe<Scalars['Int']['input']>;
  requestedServiceAreaGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  specialOccasion?: InputMaybe<Scalars['String']['input']>;
};

export type BookingUpdateReservationResponse = BookingInvalidEmail | BookingInvalidPhoneNumber | BookingNotFound | BookingOverlappingBooking | BookingRestaurantIsClosed | BookingUnableToCreateGuest | BookingUnableToSendSms | BookingUnableToUpdateReservation | BookingUnauthorizedGuestProfile | BookingUpdateReservationResponseSuccess;

export type BookingUpdateReservationResponseSuccess = {
  __typename?: 'BookingUpdateReservationResponseSuccess';
  bookingGuid: Scalars['ID']['output'];
};

export type BookingUpdateWaitlistRequest = {
  bookingGuid: Scalars['ID']['input'];
  bookingNotes?: InputMaybe<Scalars['String']['input']>;
  partySize?: InputMaybe<Scalars['Int']['input']>;
  requestedServiceAreaGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BookingUpdateWaitlistResponse = BookingNotFound | BookingRestaurantIsClosed | BookingRestaurantNotFound | BookingUnableToSendSms | BookingUpdateWaitlistResponseSuccess;

export type BookingUpdateWaitlistResponseSuccess = {
  __typename?: 'BookingUpdateWaitlistResponseSuccess';
  bookingGuid: Scalars['ID']['output'];
};

export type BookingWaitlistServiceAreaGroup = {
  __typename?: 'BookingWaitlistServiceAreaGroup';
  estimatedLowerBound?: Maybe<Scalars['Int']['output']>;
  estimatedUpperBound?: Maybe<Scalars['Int']['output']>;
  minutes?: Maybe<Scalars['Int']['output']>;
  partiesAhead: Scalars['Int']['output'];
  serviceAreaGroup: Scalars['ID']['output'];
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_EnrollInIndustryPassError = {
  __typename?: 'CON_EnrollInIndustryPassError';
  message: Scalars['String']['output'];
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_EnrollInIndustryPassResult = Con_EnrollInIndustryPassError | Con_EnrollInIndustryPassSuccess;

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_EnrollInIndustryPassSuccess = {
  __typename?: 'CON_EnrollInIndustryPassSuccess';
  industryPass: Con_IndustryPass;
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_IndustryPass = {
  __typename?: 'CON_IndustryPass';
  /** This will be null if `status` is not `CON_IndustryPassEnrolled`. */
  restaurants?: Maybe<Array<Restaurant>>;
  status: Con_IndustryPassStatus;
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_IndustryPassEligible = {
  __typename?: 'CON_IndustryPassEligible';
  employer: Restaurant;
  expirationDateTime: Scalars['DateTime']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_IndustryPassEnrolled = {
  __typename?: 'CON_IndustryPassEnrolled';
  employer: Restaurant;
  expirationDateTime: Scalars['DateTime']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_IndustryPassIneligible = {
  __typename?: 'CON_IndustryPassIneligible';
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_IndustryPassStatus = Con_IndustryPassEligible | Con_IndustryPassEnrolled | Con_IndustryPassIneligible;

/** CONCEPT - Experimental. */
export type Con_Person = {
  __typename?: 'CON_Person';
  guid: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_RestaurantIndustryPassConfig = {
  __typename?: 'CON_RestaurantIndustryPassConfig';
  discountPrimaryMessage: Scalars['String']['output'];
  discountSecondaryMessage: Scalars['String']['output'];
};

export type Con_SocialUserFollowedAfterReferralCampaign = {
  __typename?: 'CON_SocialUserFollowedAfterReferralCampaign';
  expirationDateTime: Scalars['DateTime']['output'];
  promotionalGuestCurrencyRewardAmount: Money;
};

export type Con_SocialUserReferAFriendCampaign = {
  __typename?: 'CON_SocialUserReferAFriendCampaign';
  expirationDateTime: Scalars['DateTime']['output'];
  numberOfCompletedTracks: Scalars['Int']['output'];
  promotionalGuestCurrencyRewardAmount: Money;
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_ToastCashbackAlreadyIssuedReward = Error & {
  __typename?: 'CON_ToastCashbackAlreadyIssuedReward';
  message: Scalars['String']['output'];
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_ToastCashbackInvalidInputError = Error & {
  __typename?: 'CON_ToastCashbackInvalidInputError';
  message: Scalars['String']['output'];
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_ToastCashbackInvalidOrder = Error & {
  __typename?: 'CON_ToastCashbackInvalidOrder';
  message: Scalars['String']['output'];
};

export type Con_ToastCashbackParticipatingRestaurant = {
  __typename?: 'CON_ToastCashbackParticipatingRestaurant';
  cashbackPercentage: Scalars['Float']['output'];
  /** Only set if CON_ToastCashbackRestaurantsInput.location was provided. Distance returned is in miles. */
  distanceFromLocation?: Maybe<Scalars['Float']['output']>;
  restaurant: Restaurant;
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_ToastCashbackProgramNotFoundError = Error & {
  __typename?: 'CON_ToastCashbackProgramNotFoundError';
  message: Scalars['String']['output'];
  programGuid: Scalars['ID']['output'];
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_ToastCashbackRestaurants = {
  __typename?: 'CON_ToastCashbackRestaurants';
  restaurants: Array<Con_ToastCashbackParticipatingRestaurant>;
};

export type Con_ToastCashbackRestaurantsInput = {
  location?: InputMaybe<CoordinatesInput>;
  programGuid: Scalars['ID']['input'];
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_ToastCashbackRestaurantsResult = Con_ToastCashbackInvalidInputError | Con_ToastCashbackProgramNotFoundError | Con_ToastCashbackRestaurants;

export type Con_ToastCashbackReward = {
  __typename?: 'CON_ToastCashbackReward';
  amount: Money;
  balance?: Maybe<Money>;
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_ToastCashbackRewardFailed = Error & {
  __typename?: 'CON_ToastCashbackRewardFailed';
  message: Scalars['String']['output'];
};

/** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
export type Con_ToastCashbackRewardResult = Con_ToastCashbackAlreadyIssuedReward | Con_ToastCashbackInvalidOrder | Con_ToastCashbackReward | Con_ToastCashbackRewardFailed;

export type CampaignProgressUpdateNotificationHubItem = GuestNotificationHubItem & {
  __typename?: 'CampaignProgressUpdateNotificationHubItem';
  id: Scalars['ID']['output'];
  notificationRoutes?: Maybe<NotificationHubRoutes>;
  notificationText: Scalars['String']['output'];
  reward: NotificationHubCampaignReward;
  timestamp: Scalars['String']['output'];
};

export type CampaignRewardIssuedNotificationHubItem = GuestNotificationHubItem & {
  __typename?: 'CampaignRewardIssuedNotificationHubItem';
  id: Scalars['ID']['output'];
  notificationRoutes?: Maybe<NotificationHubRoutes>;
  notificationText: Scalars['String']['output'];
  reward: NotificationHubCampaignReward;
  timestamp: Scalars['String']['output'];
};

/** Use cases that the guest has consented to for card linking. */
export enum CardFingerprintConsentUseCase {
  /** Use case for displaying orders tied to the guest by card fingerprint in order history. */
  OrderHistory = 'ORDER_HISTORY',
  /** Use case for earning rewards for orders tied to the guest by card fingerprint. */
  Rewards = 'REWARDS'
}

/** Specifies if a card is linked or eligible to be linked. */
export enum CardFingerprintLinkableStatus {
  /** The guest has not consented to linking the card and no other guest has consented to linking this card. */
  Eligible = 'ELIGIBLE',
  /** A different guest is already linked to this card, therefore it is ineligible for linking. */
  Ineligible = 'INELIGIBLE',
  /** The guest has consented and successfully linked the card. */
  Linked = 'LINKED'
}

export enum CardStatusType {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum CardType {
  Amex = 'AMEX',
  Cit = 'CIT',
  Diners = 'DINERS',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
  Laser = 'LASER',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Solo = 'SOLO',
  Unknown = 'UNKNOWN',
  Visa = 'VISA'
}

export type Cart = {
  __typename?: 'Cart';
  /** The applied funded offers in the cart */
  appliedFundedOffers?: Maybe<Array<AppliedFundedOffer>>;
  approvalRules: Array<ApprovalRule>;
  /** The system in which the cart resides. */
  cartSource?: Maybe<CartSource>;
  /** Cart Upsell Info */
  cartUpsellInfo?: Maybe<CartUpsellInfo>;
  /** Given that the cart has **diningOptionBehavior** set to **DELIVERY**, this field provides information regarding the delivery provider. Null if the cart does not have **diningOptionBehavior** set to **DELIVERY**. */
  deliveryProviderInfo?: Maybe<DeliveryProviderInfo>;
  /** The duration that represents how long, from the current time, it would take for the order to be fulfilled if the order were made to be an ASAP delivery order, regardless of what **fulfillmentType** and **diningOptionBehavior** currently are. Typically this value will not be null unless the restaurant is misconfigured. A non-null value does not necessarily indicate delivery is currently available. */
  deliveryQuoteTime?: Maybe<Scalars['Int']['output']>;
  /** **DELIVERY** or **TAKE_OUT** or **DINE_IN**. Note this does not yet support **OUTPOST**. */
  diningOptionBehavior: DiningOptionBehavior;
  expiredDate: Scalars['Float']['output'];
  /** An ISO 8601 date+time string that represents when the order is expected to be fullfilled at, set by the diner. Only relevant for a **fulfillmentType** of **FUTURE**. If **fulfillmentType** is not **FUTURE**, this value will be null. */
  fulfillmentDateTime?: Maybe<Scalars['String']['output']>;
  /** ASAP or FUTURE */
  fulfillmentType: FulfillmentType;
  guid: Scalars['ID']['output'];
  /** @deprecated Inaccurate and causes client errors */
  isPurchasable: Scalars['Boolean']['output'];
  order?: Maybe<Order>;
  paymentOptions: CartPaymentOptions;
  preComputedTips: Array<Maybe<PreComputedTip>>;
  /** The duration that represents how long, from the current time, it would take for the order to be fulfilled. This reflects the current state of the cart and typically varies based on the current **diningOptionBehavior**. Only relevant for a **fulfillmentType** of **ASAP**. If **fulfillmentType** is not **ASAP**, this value will be null. */
  quoteTime?: Maybe<Scalars['Int']['output']>;
  restaurant?: Maybe<Restaurant>;
  /** The duration that represents how long, from the current time, it would take for the order to be fulfilled if the order were made to be an ASAP takeout order, regardless of what **fulfillmentType** and **diningOptionBehavior** currently are. Typically this value will not be null unless the restaurant is misconfigured. A non-null value does not necessarily indicate takeout is currently available. */
  takeoutQuoteTime?: Maybe<Scalars['Int']['output']>;
};

/** The available APIs for retrieving cart data */
export enum CartApiType {
  /** The online ordering api for cart */
  Oo = 'OO',
  /** The order and pay at the table api for cart */
  Opt = 'OPT'
}

export type CartError = Error & {
  __typename?: 'CartError';
  code: CartErrorCode;
  message: Scalars['String']['output'];
};

export enum CartErrorCode {
  /** The requested cart is no longer available */
  CartNotFound = 'CART_NOT_FOUND'
}

export type CartFulfillmentInput = {
  /** TBD Open Questions: - should probably be required when behavior = DELIVERY - should validate this is in the delivery area - if behavior != DELIVERY should we clear out what was saved on the server and ignore this field on the input - should we strictly require this field to be null when behavior != DELIVERY */
  deliveryInfo?: InputMaybe<DeliveryInfoInput>;
  /** DELIVERY or TAKE_OUT or DINE_IN, defaults to TAKE_OUT */
  diningOptionBehavior?: InputMaybe<DiningOptionBehavior>;
  /** The expected time at which the order on the cart would be fulfilled. 1. A **fulfillmentType** of **ASAP** requires this value to not be set. 2. A **fulfillmentType** of **FUTURE** requires this value to be set, in ISO 8601 format. */
  fulfillmentDateTime?: InputMaybe<Scalars['String']['input']>;
  /** ASAP or FUTURE */
  fulfillmentType: FulfillmentType;
};

export type CartInfo = Info & {
  __typename?: 'CartInfo';
  code: CartInfoCode;
  message: Scalars['String']['output'];
};

export enum CartInfoCode {
  /** If a cart is scheduled for a particular fulfillment time, Price-based Prep can push the fulfillment time out if the prep time increases due to cart modification. Placing the order on the cart is still possible. */
  FulfillmentDateChanged = 'FULFILLMENT_DATE_CHANGED'
}

export type CartModificationError = Error & {
  __typename?: 'CartModificationError';
  code: CartModificationErrorCode;
  message: Scalars['String']['output'];
};

export enum CartModificationErrorCode {
  /** Either the requested cart or the requested cart item is no longer available. */
  CartContentNotFound = 'CART_CONTENT_NOT_FOUND',
  /** Either the selection in the request (only for **addItemToCartV2** and **editItemInCartV2**) or an existing selection on the cart (for **addItemToCartV2**, **editItemInCartV2**, and **deleteItemFromCartV2**) does not meet the modifier configuration. */
  ModifierConfigurationMismatch = 'MODIFIER_CONFIGURATION_MISMATCH'
}

export type CartModificationResponseOrError = CartModificationError | CartOutOfStockError | CartResponse | CartValidationError;

export type CartOutOfStockError = Error & {
  __typename?: 'CartOutOfStockError';
  cart: Cart;
  items: Array<CartOutOfStockItem>;
  message: Scalars['String']['output'];
};

export type CartOutOfStockItem = {
  __typename?: 'CartOutOfStockItem';
  guid?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CartPaymentOption = {
  __typename?: 'CartPaymentOption';
  paymentType: PaymentType;
};

export type CartPaymentOptions = {
  __typename?: 'CartPaymentOptions';
  atCheckout: Array<Maybe<CartPaymentOption>>;
  uponReceipt: Array<Maybe<CartPaymentOption>>;
};

export type CartResponse = {
  __typename?: 'CartResponse';
  cart: Cart;
  /** Sides effects that wouldn't prevent placing the order represented by **cart**. */
  info: Array<CartInfo>;
  /** Sides effects that would prevent placing the order represented by **cart**. */
  warnings: Array<CartWarning>;
};

export type CartResponseOrError = CartError | CartResponse;

/** Represents the system in which the cart resides. This should only be used for metrics/performance tracking and should not be used for business logic. */
export enum CartSource {
  /** The cart resides in do-carts. */
  Do = 'DO',
  /** The cart resides in the legacy online-ordering database. */
  Oo = 'OO'
}

/** Upsell data returned from DataScience Upsell Service */
export type CartUpsellInfo = {
  __typename?: 'CartUpsellInfo';
  /** List of Longs returned from the upsell service */
  upsellItems?: Maybe<Array<Scalars['String']['output']>>;
};

export type CartValidationError = Error & {
  __typename?: 'CartValidationError';
  cart: Cart;
  key: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type CartWarning = Warning & {
  __typename?: 'CartWarning';
  code: CartWarningCode;
  message: Scalars['String']['output'];
};

export enum CartWarningCode {
  /** Placing the order on the cart is not possible due to either: 1. Cart is ASAP but restaurant does not accept ASAP orders currently. 2. Cart has a set fulfillment time (scheduled order) but restaurant cannot fulfill an order at that time. Reason #2 can occur as a result of Price-based Prep pushing the fulfillment time outside of the restaurant's configured schedule. */
  CartUnfulfillable = 'CART_UNFULFILLABLE',
  /** Placing the order on the cart is not possible due to the current delivery info being outside the restaurant's delivery area. This is only applicable if the cart's dining option behavior is DELIVERY. */
  NotInDeliveryArea = 'NOT_IN_DELIVERY_AREA',
  /** Placing the order on the cart is not possible due to the delivery provider being disabled or otherwise unavailable. This is only applicable if the cart is a DaaS order. */
  ProviderUnavailable = 'PROVIDER_UNAVAILABLE'
}

export enum Client {
  ConsumerAppIos = 'CONSUMER_APP_IOS',
  OnlineOrdering = 'ONLINE_ORDERING'
}

/** Indicates generic OTP authentication error and validation should be attempted again at a later time. This error message should be surfaced to the guest. */
export type CodeAuthenticationError = Error & {
  __typename?: 'CodeAuthenticationError';
  message: Scalars['String']['output'];
};

/** Indicates that OTP entered has expired and a new one should be requested. This error message should be surfaced to the guest. */
export type CodeExpiredError = Error & {
  __typename?: 'CodeExpiredError';
  message: Scalars['String']['output'];
};

/** Indicates that OTP has been attempted too many times and a new one should be requested. This error message should be surfaced to the guest. */
export type CodeMaxAttemptsReachedError = Error & {
  __typename?: 'CodeMaxAttemptsReachedError';
  message: Scalars['String']['output'];
};

export type CommentDoesNotExistError = Error & {
  __typename?: 'CommentDoesNotExistError';
  message: Scalars['String']['output'];
};

/** Contact specific data to update on the profile. */
export type CompleteGuestContactInput = {
  /** The `GuestContact` email to set. It will only update if this guest does not already have an email on file. Must meet [Toast email validation](https://github.com/toasttab/toast-java-common/blob/development/src/main/java/com/toasttab/util/ValidationUtils.java#L18) requirements. This value is not unique; multiple guests can have this same email value. Currently, this value cannot be changed once it has been set. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The `GuestContact` first name to update. If set, `lastName` must also be provided. Cannot be blank. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The `GuestContact` last name to update. If set, `firstName` must also be provided. Cannot be blank. */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Profile data that can be updated to progress profile completion. */
export type CompleteGuestProfileInput = {
  /** Contact information that can be updated on the profile that you may want to capture and update immediately during authentication interactions with the guest. */
  contact?: InputMaybe<CompleteGuestContactInput>;
};

/** Indicates this guest does not have a valid profile and you MUST call `confirmGuest` again with the fields indicated in `profileProgress` to complete the profile and verification process. This may also occur if you provided a `profile`, but did not provide all incomplete fields. */
export type CompleteGuestProfileInputRequiredError = Error & {
  __typename?: 'CompleteGuestProfileInputRequiredError';
  message: Scalars['String']['output'];
  /** Provides the fields you must collect from the guest to resubmit to `confirmGuest`. */
  profileProgress: GuestProfileProgress;
};

export type CompleteIdentityProfileError = Error & {
  __typename?: 'CompleteIdentityProfileError';
  code: CompleteIdentityProfileErrorCode;
  message: Scalars['String']['output'];
};

export enum CompleteIdentityProfileErrorCode {
  InvalidEmail = 'INVALID_EMAIL',
  InvalidName = 'INVALID_NAME',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE'
}

export type CompleteIdentityProfileInput = {
  /** Email for the account. Cannot be changed once the account is created. */
  email: Scalars['String']['input'];
  /** The guest's provided first name */
  firstName: Scalars['String']['input'];
  /** The guest's provided last name */
  lastName: Scalars['String']['input'];
  /** The source for the account creation (Toast App vs web Online Ordering vs Order and Pay) */
  source: RegistrationSource;
};

export type CompleteIdentityProfileResponse = {
  __typename?: 'CompleteIdentityProfileResponse';
  guestGuid: Scalars['ID']['output'];
};

export type CompleteIdentityProfileResponseOrError = CompleteIdentityProfileError | CompleteIdentityProfileResponse;

export type CompleteProfileCreationError = Error & {
  __typename?: 'CompleteProfileCreationError';
  code: CompleteProfileCreationErrorCode;
  message: Scalars['String']['output'];
};

export enum CompleteProfileCreationErrorCode {
  ServiceUnavailable = 'SERVICE_UNAVAILABLE'
}

export type CompleteProfileCreationInput = {
  /** The source for the account creation (Toast App vs web Online Ordering vs Order and Pay) */
  source: RegistrationSource;
};

export type CompleteProfileCreationResponse = {
  __typename?: 'CompleteProfileCreationResponse';
  guestGuid: Scalars['ID']['output'];
};

export type CompleteProfileCreationResponseOrError = CompleteProfileCreationError | CompleteProfileCreationResponse;

export enum CompleteTypeEnum {
  AutoCompleted = 'AUTO_COMPLETED',
  UserCompleted = 'USER_COMPLETED'
}

/** An order that has already been placed. Contains fields useful for displaying past orders or for an order confirmation screen. */
export type CompletedOrder = {
  __typename?: 'CompletedOrder';
  /**
   * The optional applied reward, if any for the order. If present, use the **tax** and **total** for this object for the values after the reward has been applied.
   * @deprecated Use discounts field
   */
  appliedCustomerReward?: Maybe<AppliedCustomerReward>;
  /** The approval status of the order. Is FUTURE for approved, scheduled orders */
  approvalStatus?: Maybe<OrderApprovalStatus>;
  /** Guid of the check on this order, used primarily for creating a loyalty account to connect the order to the new account */
  checkGuid: Scalars['ID']['output'];
  /** The display number assigned to this order's check (only one check per order for digital orders) */
  checkNumber?: Maybe<Scalars['Int']['output']>;
  /** (Deprecated) The curbside pickup options for an order. Can be null if curbside pickup indication is not needed. */
  curbsidePickup?: Maybe<CurbsidePickup>;
  /** The curbside pickup information for an order. Can be null if curbside pickup indication is not needed. */
  curbsidePickupV2?: Maybe<CurbsidePickupV2>;
  /**
   * Provided personal information, either from inputs for guest orders or retrieved from guest-profiles for orders with a saved account
   * @deprecated use customerV2
   */
  customer: CustomerInfo;
  /**
   * Provided personal information, either from inputs for guest orders or retrieved from guest-profiles for orders with a saved account. Will only be present if returned from PlaceOrder or if the user is authenticated.
   * @deprecated use customerV3
   */
  customerV2?: Maybe<CustomerInfo>;
  /** Provided personal information, either from inputs for guest orders or retrieved from guest-profiles for orders with a saved account. Will only be present if returned from PlaceOrder or if the user is authenticated. Possible for some parts of the the customer info to be nullable. */
  customerV3?: Maybe<CustomerInfoV2>;
  /**
   * The total amount of delivery charges on this order based on **deliveryInfo**, included in the **total** below, assuming this was a delivery order.
   * @deprecated service charges are separated out into different categories such as processingServiceCharges and deliveryServiceCharges
   */
  deliveryChargeTotal: Scalars['Float']['output'];
  /** The provided delivery info used to calculate delivery fees, assuming this was a delivery order. Will only be present if returned from PlaceOrder or if the user is authenticated. */
  deliveryInfo?: Maybe<DeliveryInfo>;
  /** The sum of the service charges that are not UBP and only for delivery orders */
  deliveryServiceCharges: Scalars['Float']['output'];
  /** Information relevant to Toast Delivery Service (TDS) orders. Will be null for non-TDS orders */
  deliveryServiceInfo?: Maybe<DeliveryServiceInfo>;
  /** Inferred dining option of the order, based on the presence of delivery info. Will be 'TAKEOUT' for both takeout and outpost orders; use **outpostOrder** field to know if an order is an outpost order. */
  diningOptionBehavior: DiningOptionBehavior;
  /** Optional discounts, if any, for the order. */
  discounts: Discounts;
  /** Total of all the discounts applied to the order. */
  discountsTotal: Scalars['Float']['output'];
  /** Timestamp of the estimated fulfillment (current time + quote time) */
  estimatedFulfillmentDate?: Maybe<Scalars['Float']['output']>;
  /** If there were loyalty points accrued by this order, calculate the amount of points that would have been accrued for this order/guest. Returns null in split-payment scenarios. Returns null if the order is more than 1 minute old (in order to prevent recalculations that do not match the actual accrual due to restaurant loyalty config changes post-order). */
  estimatedLoyaltyPointAccrual?: Maybe<Scalars['Int']['output']>;
  /** The total amount of fundraising-specific service charges on this order, included in the **total** below. */
  fundraisingTotal?: Maybe<Scalars['Float']['output']>;
  /** Gift card applied as payment */
  giftCard?: Maybe<GiftCardPayment>;
  /** The sum of the service charges that are not UBP, not only for delivery orders, and identified as gratuity */
  gratuityServiceCharges: Scalars['Float']['output'];
  /** The message set by the restaurant in the OO-config for takeout orders, null if unset by the restaurant */
  guestCommunication?: Maybe<Scalars['String']['output']>;
  /** The guid of the order object in the database */
  guid: Scalars['ID']['output'];
  /** Whether the order has loyalty info attached, meaning a loyalty account was found with the same email at this restaurant */
  hasLoyaltyAttached: Scalars['Boolean']['output'];
  isEligibleForReview: Scalars['Boolean']['output'];
  /** The sum of the cost of all items, after discounts, in the cart except for outpost fees */
  itemsSubtotal: Scalars['Float']['output'];
  /** The sum of the service charges that are not UBP, not only for delivery orders, and not identified as gratuity */
  nonDeliveryNonGratuityNonUbpServiceCharges: Scalars['Float']['output'];
  /** Number of items present on this order */
  numberOfSelections: Scalars['Int']['output'];
  /** Timestamp of when the order was placed */
  openedDateTime: Scalars['Float']['output'];
  /** identifier for the order payment */
  orderPaymentGuid?: Maybe<Scalars['ID']['output']>;
  /** The current state the order is in. Order's not submitted to a KDS will return null */
  orderStatus?: Maybe<OrderStatusType>;
  /** The fee the user has paid for using outpost. Only not null if the user actually order from outpost. */
  outpostFee?: Maybe<Scalars['Float']['output']>;
  /** Whether or not the order is being delivered to Outpost. False (or null) is a standard takeout order. */
  outpostOrder?: Maybe<Scalars['Boolean']['output']>;
  /** Packaging preferences selected by the guest */
  packagingSelections: Array<PackagingSelection>;
  /** Enum defining which kind of payment was used to place this order */
  paymentType: PaymentType;
  /** Completed payments */
  payments: Array<CompletedPayment>;
  /** The sum of the cost of all items, before discounts, in the cart except for outpost fees */
  preDiscountItemsSubtotal: Scalars['Float']['output'];
  /** The sum of the service charges identified as UBP (user based pricing) */
  processingServiceCharges: Scalars['Float']['output'];
  /** For scheduled orders, the date and time that the order is scheduled to be fulfilled. For dine-in and as soon as possible (ASAP) orders, promisedDate is null. */
  promisedDateTime?: Maybe<Scalars['Float']['output']>;
  /** Whether or not an order is considered reorderable Business logic currently primarily considers whether a restaurant has off-prem services available. The removeDuplicates argument will determine whether we take into consideration if an order is a duplicate in a list of orders within a single query response. Null response means that the reorderability status has not been computed. */
  reorderable?: Maybe<Scalars['Boolean']['output']>;
  /** Restaurant the order was placed at, which contains all relevant information (name, address, etc.) */
  restaurant: Restaurant;
  review?: Maybe<CompletedOrderReview>;
  /** List of items present on this order */
  selections: Array<CompletedOrderSelection>;
  /**
   * The total amount of service charges on this order, included in the **total** below. Does not include delivery charges.
   * @deprecated service charges are separated out into different categories such as processingServiceCharges and deliveryServiceCharges
   */
  serviceChargeTotal: Scalars['Float']['output'];
  shouldPromptForReview: Scalars['Boolean']['output'];
  /** The source of the Order */
  source?: Maybe<OrderSource>;
  /**
   * The subtotal of the order (price without tax/tip/service charges), included in the **total** below
   * @deprecated use itemsSubtotal
   */
  subtotal: Scalars['Float']['output'];
  /** The sum of the service charges that are surcharges, with the sum of their taxes as a separate field */
  surchargeServiceCharges: SurchargeAmounts;
  /**
   * The total amount of taxes on this order, included in the **total** below
   * @deprecated Use taxV2 field
   */
  tax: Scalars['Float']['output'];
  /** The total amount of taxes on this order after applying global promos, included in the **totalV2** below */
  taxV2: Scalars['Float']['output'];
  /** The tip for the order, included in the **total** below */
  tip: Scalars['Float']['output'];
  /**
   * The final price of the order, including **subtotal**, **tax**, **tip**, and **serviceChargeTotal**
   * @deprecated Use totalV2 field
   */
  total: Scalars['Float']['output'];
  /** The final price of the order, including **subtotal**, **tax**, **tip**, **serviceChargeTotal** and **discounts** */
  totalV2: Scalars['Float']['output'];
};


/** An order that has already been placed. Contains fields useful for displaying past orders or for an order confirmation screen. */
export type CompletedOrderReorderableArgs = {
  removeDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompletedOrderInput = {
  orderGuid: Scalars['ID']['input'];
  restaurantGuid: Scalars['ID']['input'];
};

/** A modifier on an item for an order that has already been placed. */
export type CompletedOrderModifierSelection = {
  __typename?: 'CompletedOrderModifierSelection';
  /** List of nested modifier selections */
  modifiers: Array<CompletedOrderModifierSelection>;
  /** Display name of the modifier */
  name: Scalars['String']['output'];
  /** Indicates whether this modifier was voided, only relevant for OPT open tab orders. */
  voided?: Maybe<Scalars['Boolean']['output']>;
};

/** Reviews for a completed order. */
export type CompletedOrderReview = {
  __typename?: 'CompletedOrderReview';
  /** Review of a guest's order experience. See [GuestReview]. */
  experienceReview?: Maybe<GuestReview>;
};

/** An item on an order that has already been placed. */
export type CompletedOrderSelection = {
  __typename?: 'CompletedOrderSelection';
  /** External ID that matches with the user's selection when placing the order */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Includes the unit of measure for the item as well as the quantity to be measured. */
  fractionalQuantity: FractionalQuantity;
  /** The ID to uniquely identify this selection */
  guid: Scalars['String']['output'];
  /** the ID of the item group this selection's item is a part of */
  itemGroupGuid?: Maybe<Scalars['String']['output']>;
  /** the ID of the item this selection represents */
  itemGuid?: Maybe<Scalars['String']['output']>;
  /** List of all modifiers included on this item */
  modifiers: Array<CompletedOrderModifierSelection>;
  /** The item's display name */
  name: Scalars['String']['output'];
  /** The cost of the Selection before any discounts are applied to the order */
  preDiscountPrice?: Maybe<Scalars['Float']['output']>;
  /** The item's price (including the price of any modifiers) */
  price: Scalars['Float']['output'];
  /** Quantity of this item (including modifiers) */
  quantity: Scalars['Int']['output'];
  /** Quantity of this item as represented by the check independent of the unit of measure */
  rawQuantity: Scalars['Float']['output'];
  /** Price of the item that will appear on the receipt, it doesnt take into consideration quantity. Returns single price for single item. Includes or excludes tax respective to tax config */
  receiptLinePrice?: Maybe<Scalars['Float']['output']>;
  usesFractionalQuantity: Scalars['Boolean']['output'];
  /** Indicates whether this selection was voided, only relevant for OPT open tab orders. */
  voided?: Maybe<Scalars['Boolean']['output']>;
};

export type CompletedPayment = {
  __typename?: 'CompletedPayment';
  /** The amount of the payment */
  amount: Scalars['Float']['output'];
  /** The guid of the payment object in the database */
  guid: Scalars['ID']['output'];
  /** Name of OTHER payment method */
  otherPaymentName?: Maybe<Scalars['String']['output']>;
  /** The status of the payment */
  status?: Maybe<PaymentStatus>;
  /** The tip amount for this payment */
  tipAmount: Scalars['Float']['output'];
  /** The total amount of the payment */
  totalAmount: Scalars['Float']['output'];
  /** The type of payment used */
  type: PaymentType;
};

/** A general container for any data related to config. */
export type ConfigData = {
  __typename?: 'ConfigData';
  messages?: Maybe<ConfigMessagesData>;
};

export type ConfigMessagesData = {
  __typename?: 'ConfigMessagesData';
  /** A long message promoting loyalty signup that will be shown to the guests in different places (receipts, emails). 1st party only. e.g. 'Earn 1 point for every $1 spent and unlock $2.50 off every 25 points.' */
  programDescription?: Maybe<Scalars['String']['output']>;
  /** An accrual part of the program description. Useful in carousels. 1st party only. e.g. 'Earn 1 point for every $1 spent.' */
  programDescriptionAccrual?: Maybe<Scalars['String']['output']>;
  /** A reward part of the program description. Useful in carousels. 1st party only. e.g. 'Visit 8 times, get coffee.' or 'Unlock $2.50 off every 25 points.' */
  programDescriptionReward?: Maybe<Scalars['String']['output']>;
};

/** Specifies the identity field to verify for the guest using the code. */
export type ConfirmGuestIdentityInput = {
  code: Scalars['String']['input'];
  identityString: Scalars['String']['input'];
  identityType: IdentityType;
};

/** The possible results of the `confirmGuestIdentity` mutation. */
export type ConfirmGuestIdentityResult = CodeAuthenticationError | CodeExpiredError | CodeMaxAttemptsReachedError | ConfirmGuestIdentitySuccess | GuestIdentityAlreadyExistsForAnotherGuestError | IncorrectCodeError | UnexpectedConfirmCodeError;

/** The successful result of the `confirmGuestIdentity` mutation. */
export type ConfirmGuestIdentitySuccess = {
  __typename?: 'ConfirmGuestIdentitySuccess';
  /** The current verified, authorized guest. */
  guest: Guest;
};

/** The input of the `confirmGuest` mutation. */
export type ConfirmGuestInput = {
  /** Optional; newly collected profile information that should be added to the guest. This information MUST be provided in the first chain of setup/confirm calls for this guest when creating their account. You can check the `ConfirmGuestSuccess` result to determine if the guest has completed their profile and if this data is necessary. */
  profile?: InputMaybe<CompleteGuestProfileInput>;
  /** Identification of your product confirming the guest. */
  source: GuestAuthenticationSource;
};

/** The possible results of the `confirmGuest` mutation. */
export type ConfirmGuestResult = CompleteGuestProfileInputRequiredError | ConfirmGuestSuccess | InvalidEmailError | InvalidNameError | ProfileLockedForDeletionError | UnexpectedAuthError;

/** The successful result of the `confirmGuest` mutation. */
export type ConfirmGuestSuccess = {
  __typename?: 'ConfirmGuestSuccess';
  /** The current verified, authorized guest. */
  guest: Guest;
  /** If true, you should refresh the guest authorization token via `toast-authentication` and use that token for all future requests that require `GuestAuthorization`. Failure to do so will result in `FORBIDDEN` GraphQL errors for subsequent guest operations. */
  mustRefreshToken: Scalars['Boolean']['output'];
  /** Provides details on any additional information you may want or must collect from the guest. */
  profileProgress: GuestProfileProgress;
};

export enum ConsumerAppRestaurantSearchFilter {
  ToastGiftCards = 'TOAST_GIFT_CARDS'
}

export type ContactEmail = {
  __typename?: 'ContactEmail';
  email: Scalars['String']['output'];
  isVerified: Scalars['Boolean']['output'];
};

/** Information on a single point in the world. */
export type Coordinates = {
  __typename?: 'Coordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

/** Information on a single point in the world. */
export type CoordinatesInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CreateApplePayPreauthInput = {
  orderSource: Scalars['String']['input'];
  pkPaymentToken: Scalars['String']['input'];
};

export type CreateCartInput = {
  orderSource?: InputMaybe<OrderSource>;
  restaurantGuid: Scalars['ID']['input'];
};

export type CreateCartInputV2 = {
  /** Indicates how the order on the cart should be fulfilled. */
  cartFulfillmentInput: CartFulfillmentInput;
  /** Optional channel GUID used for cart validation */
  channelGuid?: InputMaybe<Scalars['String']['input']>;
  /** Indicates which digital surface this cart is used on */
  digitalSurface?: InputMaybe<DigitalSurface>;
  /** The product that the cart is created on. */
  orderSource: OrderSource;
  /** The GUID of the restaurant that the cart will be created in. */
  restaurantGuid: Scalars['ID']['input'];
};

export type CreateCartResponse = {
  __typename?: 'CreateCartResponse';
  cart?: Maybe<Cart>;
};

export type CreateCreditCardPreauthAuthorizedResponse = {
  __typename?: 'CreateCreditCardPreauthAuthorizedResponse';
  expirationMonth?: Maybe<Scalars['String']['output']>;
  expirationYear?: Maybe<Scalars['String']['output']>;
  last4CardDigits: Scalars['String']['output'];
  preauthGuid: Scalars['ID']['output'];
  preauthToken: Scalars['String']['output'];
};

export type CreateCreditCardPreauthDeniedResponse = {
  __typename?: 'CreateCreditCardPreauthDeniedResponse';
  denialReason?: Maybe<Scalars['String']['output']>;
  preauthGuid: Scalars['ID']['output'];
};

export type CreateCreditCardPreauthResponse = CreateCreditCardPreauthAuthorizedResponse | CreateCreditCardPreauthDeniedResponse;

export type CreateEncryptedCreditCardPreauthInput = {
  creditCardData: EncryptedCreditCardData;
  creditCardMetadata: EncryptedCreditCardMetadata;
  orderSource: Scalars['String']['input'];
  willSaveCard: Scalars['Boolean']['input'];
};

export type CreateGiftCardOrderInput = {
  orderDetails: GiftCardOrderDetailsInput;
  purchaseSource?: InputMaybe<GiftCardPurchaseSource>;
  recaptchaToken: Scalars['String']['input'];
  restaurantGuid: Scalars['ID']['input'];
};

export type CreateGiftCardOrderResponse = {
  __typename?: 'CreateGiftCardOrderResponse';
  orderGuid: Scalars['ID']['output'];
  paymentGuid: Scalars['ID']['output'];
  toastCardGuid?: Maybe<Scalars['ID']['output']>;
};

export type CreateGiftMetadataInput = {
  /** Metadata about the device; one of mobileMetadata or webMetadata must be provided */
  mobileMetadata?: InputMaybe<CreateGiftMobileMetadataInput>;
  /** The guest's IP address deprecated(reason: "Respects origin IP from Toast-Origin-IP header instead") */
  originIP: Scalars['String']['input'];
  webMetadata?: InputMaybe<CreateGiftWebMetadataInput>;
};

export type CreateGiftMobileMetadataInput = {
  /** Mobile UID generated by Forter's SDK */
  forterMobileUID: Scalars['ID']['input'];
};

export type CreateGiftWebMetadataInput = {
  /** Token cookie generated by Forter's SDK */
  forterTokenCookie: Scalars['ID']['input'];
  /** User agent of the guest's browser deprecated(reason: "Respects user agent from User-Agent header instead") */
  userAgent: Scalars['String']['input'];
};

export type CreateGuestCommentOnPostInput = {
  content: Scalars['String']['input'];
  postId: Scalars['ID']['input'];
};

export type CreateGuestCommentOnPostResult = CreateGuestCommentOnPostSuccess | NotFollowingPostAuthorError | UnexpectedError;

export type CreateGuestCommentOnPostSuccess = {
  __typename?: 'CreateGuestCommentOnPostSuccess';
  comment: VisibleGuestComment;
};

export type CreateGuestPasscodeError = {
  __typename?: 'CreateGuestPasscodeError';
  code: CreateGuestPasscodeErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CreateGuestPasscodeErrorCode {
  GenericError = 'GenericError'
}

export type CreateGuestPasscodeResponse = CreateGuestPasscodeError | GuestPasscode;

export type CreateMarketingSubscriptionInput = {
  channel: Scalars['String']['input'];
  customList?: InputMaybe<Scalars['ID']['input']>;
  value: Scalars['String']['input'];
};

export type CreateMarketingSubscriptionRequestError = Error & {
  __typename?: 'CreateMarketingSubscriptionRequestError';
  message: Scalars['String']['output'];
};

export type CreateMarketingSubscriptionRequestInput = {
  managementSetGuid?: InputMaybe<Scalars['ID']['input']>;
  restaurantGuid: Scalars['ID']['input'];
  subscriptionRequest: MarketingSubscriptionRequestInput;
};

export type CreateMarketingSubscriptionRequestResponse = CreateMarketingSubscriptionRequestError | CreateMarketingSubscriptionRequestSuccessResponse;

export type CreateMarketingSubscriptionRequestSuccessResponse = {
  __typename?: 'CreateMarketingSubscriptionRequestSuccessResponse';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  restaurantGuid: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  subscriptions: Array<CreateMarketingSubscriptionResponse>;
};

export type CreateMarketingSubscriptionResponse = {
  __typename?: 'CreateMarketingSubscriptionResponse';
  channel: Scalars['String']['output'];
  customList?: Maybe<Scalars['ID']['output']>;
  value: Scalars['String']['output'];
};

export type CreateOrUpdateCroppedProfilePhotoResult = GuestCroppedProfilePhotoSuccess | UnexpectedError;

export type CreateOrUpdateGuestAwardInput = {
  awardTypeId: Scalars['ID']['input'];
  placeId: Scalars['ID']['input'];
};

export type CreateOrUpdateGuestAwardResult = AwardSeasonHasEndedError | CreateOrUpdateGuestAwardSuccess | UnexpectedError;

export type CreateOrUpdateGuestAwardSuccess = {
  __typename?: 'CreateOrUpdateGuestAwardSuccess';
  award: GuestAward;
};

export type CreateOrUpdateSocialUserProfilePhotoInput = {
  imageFormat: ImageFormat;
};

export type CreateOrUpdateSocialUserProfilePhotoResult = GuestCreateOrUpdateProfilePhotoSuccess | UnexpectedError;

export type CreateOrUpdateToastOrderPostInput = {
  checkId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
  /** If null then the visibility will be determined by the user's profile visibility setting. Otherwise, the visibility will overwrite the existing post visibility, or be set if the post does not exist. */
  visibility?: InputMaybe<GuestPostVisibility>;
};

export type CreateOrUpdateToastOrderPostResult = CreateOrUpdateToastOrderPostSuccess | UnexpectedError;

export type CreateOrUpdateToastOrderPostSuccess = {
  __typename?: 'CreateOrUpdateToastOrderPostSuccess';
  post: GuestPost;
};

export type CreateSetupIntentResponse = CreateSetupIntentSuccessResponse | SetupIntentError;

export type CreateSetupIntentSuccessResponse = {
  __typename?: 'CreateSetupIntentSuccessResponse';
  /** Facade'd SetupIntent to be returned in a Successful Response */
  setupIntent: SetupIntent;
};

export type CreateSocialUserRequest = {
  /** The social user ID of the user that invited this guest, if this user was invited via referral. */
  referrerSocialUserId?: InputMaybe<Scalars['ID']['input']>;
  userVisibility: SocialUserVisibility;
};

export type CreateSocialUserResult = CreateSocialUserSuccess | UnexpectedError;

export type CreateSocialUserSuccess = {
  __typename?: 'CreateSocialUserSuccess';
  socialUser: SocialUser;
};

/** An object representing curbside pickup options */
export type CurbsidePickup = {
  __typename?: 'CurbsidePickup';
  selected: Scalars['Boolean']['output'];
};

/** Provides details about the restaurant's curbside pickup configuration Note **enabled** and **enabledV2** should be mutally exclusive, though **enabledV2** would take precedence. */
export type CurbsidePickupConfig = {
  __typename?: 'CurbsidePickupConfig';
  /** If true, indicates the client can prompt the user to request curbside pickup for their takeout order (legacy version that cannot accept transport details) **curbsidePickup** should be included on the corresponding Place*OrderInput when calling the place*Order mutation */
  enabled: Scalars['Boolean']['output'];
  /** If true, indicates the client can prompt the user to request curbside pickup and must also prompt for transport details **curbsidePickupV2** should be included on the corresponding Place*OrderInput when calling the place*Order mutation */
  enabledV2: Scalars['Boolean']['output'];
};

export type CurbsidePickupInput = {
  selected: Scalars['Boolean']['input'];
};

export type CurbsidePickupInputV2 = {
  notes?: InputMaybe<Scalars['String']['input']>;
  transportColor?: InputMaybe<Scalars['String']['input']>;
  transportDescription: Scalars['String']['input'];
};

/** An object representing curbside pickup information */
export type CurbsidePickupV2 = {
  __typename?: 'CurbsidePickupV2';
  notes?: Maybe<Scalars['String']['output']>;
  transportColor?: Maybe<Scalars['String']['output']>;
  transportDescription: Scalars['String']['output'];
};

/** An `ISO-4217` compliant Currency. */
export enum Currency {
  /** Canadian Dollars (CAD). */
  Cad = 'CAD',
  /** Euro (EUR). */
  Eur = 'EUR',
  /** United Kingdom Pounds (GBP). */
  Gbp = 'GBP',
  /** United States Dollars (USD). */
  Usd = 'USD'
}

export type CustomDiscount = {
  __typename?: 'CustomDiscount';
  /** Whether the discount is currently active */
  active: Scalars['Boolean']['output'];
  /** How a discount is applied if conditions are met - FIXED - How many dollars are discounted from the check/item - PERCENT - What percentage of the check/item is discounted - BOGO - Follow the bogoAction for how the discount is applied to action items (buy one get one free) */
  amountType: Scalars['String']['output'];
  /** Time and day of the week restrictions for when the offer can be applied */
  availability?: Maybe<PromoOfferDiscountAvailability>;
  /** The action to take when the discount amountType is BOGO and the offer is applied */
  bogoAction?: Maybe<PromoOfferDiscountBogoAction>;
  /** Dollar amount or percentage that is discounted */
  discountValue?: Maybe<Scalars['Float']['output']>;
  /** Channels that the discount is available on - ONLINE_ORDERING - available for display on the online ordering web apps - TOAST_APP - available for display on the Toast app - MARKETING_SMS - available via SMS marketing */
  displayChannels?: Maybe<Array<Scalars['String']['output']>>;
  /** Guid for the discount */
  guid: Scalars['String']['output'];
  /** Minimum amount that needs to be spent to apply the discount */
  minSpendAmount?: Maybe<Scalars['Float']['output']>;
  /** Name of the discount. This is the same as the banner text */
  name: Scalars['String']['output'];
  /** Promo codes that are associated with the discount */
  promoCodes?: Maybe<Array<PromoOfferDiscountPromoCode>>;
  /** Type that needs to be selected for the discount to be able to be applied - CHECK - The discount can be applied if the amount condition is met - ITEM - The discount can be applied if the conditions on target entities (item, group, menu) are met */
  selectionType: Scalars['String']['output'];
  /** List of groups that an item in the cart can belong to for this offer to be applied */
  triggerMenuGroups?: Maybe<Array<Scalars['String']['output']>>;
  /** List of items that need to be in the cart for this offer to be applied */
  triggerMenuItems?: Maybe<Array<Scalars['String']['output']>>;
  /** List of menus that an item in the cart can belong to for this offer to be applied */
  triggerMenus?: Maybe<Array<Scalars['String']['output']>>;
};

/** The stored data for a customer account that is visible to the customer */
export type Customer = {
  __typename?: 'Customer';
  addresses: Array<SavedAddress>;
  /** List of saved credit cards for this customer, sorted with the primary card first */
  creditCards: Array<SavedCreditCard>;
  /** Email (primary identifier for the customer account) */
  email: Scalars['String']['output'];
  favorites: CustomerFavorites;
  /** First name, from basic info - not a required field when creating an account on OO so can be nullable */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Customer guid */
  guid: Scalars['ID']['output'];
  /** Last name, from basic info - not a required field when creating an account on OO so can be nullable */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Phone number, from basic info - not a required field when creating an account on OO so can be nullable */
  phone?: Maybe<Scalars['String']['output']>;
};

export type CustomerFavorites = {
  __typename?: 'CustomerFavorites';
  restaurants: Array<Restaurant>;
};

export type CustomerInfo = {
  __typename?: 'CustomerInfo';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type CustomerInfoV2 = {
  __typename?: 'CustomerInfoV2';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CustomerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerLoyaltyError = Error & {
  __typename?: 'CustomerLoyaltyError';
  code: LoyaltyErrorCode;
  message: Scalars['String']['output'];
};

export type CustomerLoyaltyInfoBulkInput = {
  restaurantGuids: Array<Scalars['ID']['input']>;
};

export type CustomerLoyaltyInfoBulkItemResponse = {
  __typename?: 'CustomerLoyaltyInfoBulkItemResponse';
  inquiryResponseOrError?: Maybe<CustomerLoyaltyInfoResponseOrError>;
  restaurantGuid: Scalars['ID']['output'];
};

export type CustomerLoyaltyInfoInput = {
  restaurantGuid: Scalars['ID']['input'];
};

export type CustomerLoyaltyInfoResponseOrError = CustomerLoyaltyError | LoyaltyInquiryResponse;

export type DailySchedule = {
  __typename?: 'DailySchedule';
  /** ISO 8601 local date string. */
  date: Scalars['String']['output'];
  /** May be set if this schedule was overridden from the weekly schedule. */
  overrideDescription?: Maybe<Scalars['String']['output']>;
  servicePeriods: Array<ServicePeriod>;
};

export type DateRangeInput = {
  /** ISO 8601 local date string (time zone is not part of the definition) */
  end: Scalars['String']['input'];
  /** ISO 8601 local date string (time zone is not part of the definition) */
  start: Scalars['String']['input'];
};

/** Range defined by a start and optional end represented as UTC string, e.g. '2024-02-01T00:00:00Z' */
export type DateTimeRange = {
  __typename?: 'DateTimeRange';
  end?: Maybe<Scalars['String']['output']>;
  start: Scalars['String']['output'];
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeleteAccountError = Error & {
  __typename?: 'DeleteAccountError';
  code: DeleteAccountErrorCode;
  message: Scalars['String']['output'];
};

export enum DeleteAccountErrorCode {
  ServiceUnavailable = 'SERVICE_UNAVAILABLE'
}

export type DeleteAccountResponse = {
  __typename?: 'DeleteAccountResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteAccountResponseOrError = DeleteAccountError | DeleteAccountResponse;

export type DeleteAddressError = Error & {
  __typename?: 'DeleteAddressError';
  code: DeleteAddressErrorCode;
  message: Scalars['String']['output'];
};

export enum DeleteAddressErrorCode {
  AddressNotFound = 'ADDRESS_NOT_FOUND'
}

export type DeleteAddressInput = {
  addressGuid: Scalars['ID']['input'];
};

export type DeleteAddressResponse = {
  __typename?: 'DeleteAddressResponse';
  customer: Customer;
};

export type DeleteAddressResponseOrError = DeleteAddressError | DeleteAddressResponse;

export type DeleteCreditCardError = Error & {
  __typename?: 'DeleteCreditCardError';
  code: DeleteCreditCardErrorCode;
  message: Scalars['String']['output'];
};

export enum DeleteCreditCardErrorCode {
  CardNotFound = 'CARD_NOT_FOUND'
}

/** Guid of the desired card to be deleted from the account */
export type DeleteCreditCardInput = {
  cardGuid: Scalars['ID']['input'];
};

export type DeleteCreditCardResponse = {
  __typename?: 'DeleteCreditCardResponse';
  customer: Customer;
};

export type DeleteCreditCardResponseOrError = DeleteCreditCardError | DeleteCreditCardResponse;

export type DeleteCustomerPushNotificationTargetInput = {
  targetIdentifier: Scalars['String']['input'];
};

export type DeleteCustomerPushNotificationTargetResponse = {
  __typename?: 'DeleteCustomerPushNotificationTargetResponse';
  success: Scalars['Boolean']['output'];
};

/** The input of the `deleteGuestAddress` mutation. */
export type DeleteGuestAddressInput = {
  /** Identifies the guest address to delete. */
  addressId: Scalars['ID']['input'];
};

/** The possible results of the `deleteGuestAddress` mutation. */
export type DeleteGuestAddressResult = DeleteGuestAddressSuccess | UnexpectedError;

/** The successful result of the `deleteGuestAddress` mutation. */
export type DeleteGuestAddressSuccess = {
  __typename?: 'DeleteGuestAddressSuccess';
  /** The current verified, authorized guest. */
  guest: Guest;
};

export type DeleteGuestCommentOnPostInput = {
  commentId: Scalars['ID']['input'];
};

export type DeleteGuestCommentOnPostResult = DeleteGuestCommentOnPostSuccess | UnexpectedError;

export type DeleteGuestCommentOnPostSuccess = {
  __typename?: 'DeleteGuestCommentOnPostSuccess';
  id: Scalars['ID']['output'];
};

/** The input of the `deleteGuestPaymentCard` mutation. */
export type DeleteGuestPaymentCardInput = {
  /** Uniquely identifies the guest's payment card that will be deleted. */
  paymentCardId: Scalars['ID']['input'];
};

/** The possible results of the `deleteGuestPaymentCard` mutation. */
export type DeleteGuestPaymentCardResult = DeleteGuestPaymentCardSuccess | UnexpectedError;

/** The successful result of the `deleteGuestPaymentCard` mutation. */
export type DeleteGuestPaymentCardSuccess = {
  __typename?: 'DeleteGuestPaymentCardSuccess';
  /** The current verified, authorized guest. */
  guest: Guest;
};

export type DeleteItemFromCartInput = {
  /** The GUID of the cart that the cart item referenced by **selectionGuid** would be removed from. */
  cartGuid: Scalars['ID']['input'];
  /** Indicates the cart item to be removed from the cart referenced by **cartGuid**. */
  selectionGuid: Scalars['ID']['input'];
};

export type DeleteItemFromCartResponse = {
  __typename?: 'DeleteItemFromCartResponse';
  cart?: Maybe<Cart>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DeleteSocialUserRequest = {
  id: Scalars['ID']['input'];
};

export type DeleteSocialUserResult = DeleteSocialUserSuccess | SocialUserDoesNotExistError | UnexpectedError;

export type DeleteSocialUserSuccess = {
  __typename?: 'DeleteSocialUserSuccess';
  id: Scalars['ID']['output'];
};

export type DeliveryBanner = PromoBannerBase & {
  __typename?: 'DeliveryBanner';
  /** The GUID of the banner */
  bannerGuid: Scalars['String']['output'];
  /** The banner text */
  bannerText: Scalars['String']['output'];
  /** The delivery banner type */
  type: Scalars['String']['output'];
};

export type DeliveryDriver = {
  __typename?: 'DeliveryDriver';
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

export type DeliveryDriverLocation = {
  __typename?: 'DeliveryDriverLocation';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type DeliveryInfo = {
  __typename?: 'DeliveryInfo';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  administrativeArea?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  /** Notes for the delivery driver */
  notes?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type DeliveryInfoInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  administrativeArea?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  /** Notes for the delivery driver */
  notes?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export enum DeliveryProvider {
  /** The order is to be delivered by a DoorDash driver. */
  Doordash = 'DOORDASH',
  /** The order is being delivered by a first party delivery driver, i.e. a driver that the restaurant supplied themselves. */
  Toast = 'TOAST',
  /** The order is being delivered by a third party delivery driver, but the actual provider has not been assigned yet */
  ToastDeliveryServices = 'TOAST_DELIVERY_SERVICES',
  /** The order is to be delivered by an Uber driver */
  Uber = 'UBER'
}

export type DeliveryProviderConfig = {
  __typename?: 'DeliveryProviderConfig';
  /** The dining option GUID represented by this provider */
  diningOptionGuid: Scalars['ID']['output'];
  /** Whether this provider is enabled or not */
  enabled: Scalars['Boolean']['output'];
  /** Whether this provider is pending or not */
  pending: Scalars['Boolean']['output'];
  /** The configured provider */
  provider: DeliveryProvider;
};

export type DeliveryProviderInfo = {
  __typename?: 'DeliveryProviderInfo';
  /** Indicates whether this provider requires consent from the diner for delivery-related communication from the provider to the diner. */
  needsDeliveryCommunicationConsent: Scalars['Boolean']['output'];
  /** The provider fulfilling the delivery. */
  provider: DeliveryProvider;
};

export type DeliveryServiceAvailability = {
  __typename?: 'DeliveryServiceAvailability';
  /** Whether or not third party delivery is available from at least one third party delivery provider */
  available: Scalars['Boolean']['output'];
  /** The dining option GUID for third party delivery if available */
  diningOptionId?: Maybe<Scalars['ID']['output']>;
  /** Provides reasons for why delivery is unavailable. If valid or no reason, left as an empty list */
  unavailabilityReasons: Array<DeliveryUnavailableReason>;
};

export type DeliveryServiceInfo = {
  __typename?: 'DeliveryServiceInfo';
  driverName?: Maybe<Scalars['String']['output']>;
  driverPhoneNumber?: Maybe<Scalars['String']['output']>;
  originalQuotedDeliveryDate?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
};

export enum DeliveryTimeException {
  EarlyDelivery = 'EARLY_DELIVERY',
  LateDelivery = 'LATE_DELIVERY'
}

export type DeliveryUnavailableReason = Warning & {
  __typename?: 'DeliveryUnavailableReason';
  code: DeliveryUnavailableReasonCode;
  message: Scalars['String']['output'];
};

export enum DeliveryUnavailableReasonCode {
  /** The request is not in the delivery service area */
  NotInDeliveryArea = 'NOT_IN_DELIVERY_AREA',
  /** The provider is unavailable, either due to us turning it off, or some type of outage. */
  ProviderUnavailable = 'PROVIDER_UNAVAILABLE'
}

export enum DigitalSurface {
  CustomBrandedApp = 'CUSTOM_BRANDED_APP',
  Local = 'LOCAL',
  OoBasic = 'OO_BASIC',
  OoEcommerce = 'OO_ECOMMERCE',
  OoPro = 'OO_PRO',
  Websites = 'WEBSITES'
}

export type DiningOption = {
  __typename?: 'DiningOption';
  /** The ability for this **DiningOption** to accept **ASAP** order. A null value indicates that **ASAP** orders cannot be accepted due to restaurant configuration. */
  asapSchedule?: Maybe<AsapSchedule>;
  /** The type of the dining option */
  behavior: DiningOptionBehavior;
  /** The delivery provider that this dining option is used for, whether that's Toast, or a third party. Is null for non delivery dining options. */
  deliveryProvider?: Maybe<DeliveryProviderInfo>;
  /** A description of the **DiningOption** */
  description: Scalars['String']['output'];
  /** The ability for this **DiningOption** to accept **FUTURE** order. A null value indicates that **FUTURE** orders cannot be accepted due to restaurant configuration. */
  futureSchedule?: Maybe<FutureSchedule>;
  /** The unique identifier for the **DiningOption** */
  guid: Scalars['ID']['output'];
};

export enum DiningOptionBehavior {
  /** The order is to be delivered to the diner. */
  Delivery = 'DELIVERY',
  /** The order is to be eaten at the restaurant */
  DineIn = 'DINE_IN',
  /** The order is to be picked up at an outpost. */
  Outpost = 'OUTPOST',
  /** The order is to be picked up at the restaurant. */
  TakeOut = 'TAKE_OUT'
}

export type DiningOptionsInput = {
  /** Only one of **restaurantGuid** and **cartGuid** can be non-null. If **cartGuid** is supplied, then the dining options will be resolved according to the restaurant configuration and the cart content. */
  cartGuid?: InputMaybe<Scalars['ID']['input']>;
  /** The date range used to filter **FutureFulfillmentDate**s. If not provided, will default to start with today and end with a date based on the max days ahead the restaurant accepts scheduled orders. */
  futureFulfillmentDatesBetween?: InputMaybe<DateRangeInput>;
  /** The number of days used to filter **FutureFulfillmentDate**s. Starts with today and ends with a date futureFulfillmentDaysAhead in the future, capped at the restaurant's configured maximum. */
  futureFulfillmentDaysAhead?: InputMaybe<Scalars['Int']['input']>;
  /** The dining option behaviors used to filter the dining options. An empty **includeBehaviors** will return an empty list. */
  includeBehaviors: Array<DiningOptionBehavior>;
  /** Only one of **restaurantGuid** and **cartGuid** can be non-null. If **restaurantGuid** is supplied, then the dining options will be resolved according to the restaurant configuration only. */
  restaurantGuid?: InputMaybe<Scalars['ID']['input']>;
};

export type DiscountDetails = {
  __typename?: 'DiscountDetails';
  entityType: Scalars['String']['output'];
  guid: Scalars['ID']['output'];
};

export type DiscountOffMinOffer = BaseToastFundedOffer & {
  __typename?: 'DiscountOffMinOffer';
  active: Scalars['Boolean']['output'];
  amountToDiscount: Money;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  guid: Scalars['ID']['output'];
  maxGuestRedemptions: Scalars['Int']['output'];
  minPurchaseAmount: Money;
  offerDescription?: Maybe<Scalars['String']['output']>;
  offerName: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  targeting: OfferTargeting;
};

export enum DiscountType {
  /** A global discount that is not tied to a specific restaurant, e.x. sign up and get $5 off */
  Global = 'GLOBAL',
  /** A restaurant specific loyalty discount, tied to a guest/loyalty account */
  Loyalty = 'LOYALTY',
  /** A discount that is tied to a specific restaurant, e.x. Get 20% off as part of a promotion */
  Restaurant = 'RESTAURANT'
}

/** An object represeting the various discounts that can be applied to an order. Each field will contain an object with each discount's associated information, such as type, name, and amount. */
export type Discounts = {
  __typename?: 'Discounts';
  discount?: Maybe<DiscountDetails>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  globalReward?: Maybe<AppliedCustomerReward>;
  loyaltyDetails?: Maybe<LoyaltyDetails>;
  loyaltyDiscount?: Maybe<LoyaltyDiscount>;
  loyaltyDiscounts?: Maybe<Array<Maybe<LoyaltyDiscount>>>;
  name?: Maybe<Scalars['String']['output']>;
  restaurantDiscount?: Maybe<RestaurantDiscount>;
};

export enum DistanceUnit {
  Km = 'KM',
  Mi = 'MI'
}

export type DoMenus_FindMenuItemError = {
  __typename?: 'DoMenus_FindMenuItemError';
  message: Scalars['String']['output'];
};

export type DoMenus_FindMenuItemInput = {
  /** Optional Channel identifier */
  channelGuid?: InputMaybe<Scalars['String']['input']>;
  /** The instant at which to evaluate time-specific menu features, such as availability and pricing. The current time will be used if omitted. Should be in ISO 8601 format and include date and time. Example: 2019-08-07T13:00:00-04:00 */
  dateTime?: InputMaybe<Scalars['String']['input']>;
  menuGroupGuid: Scalars['String']['input'];
  menuItemGuid: Scalars['String']['input'];
  restaurantGuid: Scalars['String']['input'];
  visibility: Menus_VisibilityEnum;
};

export type DoMenus_FindMenuItemResponse = {
  __typename?: 'DoMenus_FindMenuItemResponse';
  /** The parent menu of the found item. */
  menu: Menus_MenuV2;
  /** The immediate parent menu group of the found item. */
  menuGroup: Menus_MenuGroupV2;
  /** The path of ancestor menu groups of the found item within `menu` up to and including `menuGroup`. */
  menuGroups: Array<Menus_MenuGroupV2>;
  /** The found item. */
  menuItem: Menus_MenuItemV2;
  /** The contents of this menu response will be stripped to only contain data relevant to the found menu item. */
  menuResponse: Menus_MenuResponseV2;
};

export type DoMenus_FindMenuItemResult = DoMenus_FindMenuItemError | DoMenus_FindMenuItemResponse;

export type DoMenus_FindMenuItemsError = {
  __typename?: 'DoMenus_FindMenuItemsError';
  message: Scalars['String']['output'];
};

export type DoMenus_FindMenuItemsInput = {
  /** The instant at which to evaluate time-specific menu features, such as availability and pricing. The current time will be used if omitted. Should be in ISO 8601 format and include date and time. Example: 2019-08-07T13:00:00-04:00 */
  dateTime?: InputMaybe<Scalars['String']['input']>;
  items: Array<DoMenus_FindMenuItemsItemInput>;
  restaurantGuid: Scalars['String']['input'];
  visibility: Menus_VisibilityEnum;
};

export type DoMenus_FindMenuItemsItem = {
  __typename?: 'DoMenus_FindMenuItemsItem';
  menuGroup: Menus_MenuGroupV2;
  menuItem: Menus_MenuItemV2;
};

export type DoMenus_FindMenuItemsItemInput = {
  groupGuid: Scalars['String']['input'];
  itemGuid: Scalars['String']['input'];
};

/** Will return an array equal in length to the input array, even if items are not found within the menu. The order of items in the response will also be in the same order as the input. For example, if the input provided is [item1, item2, item3] and item2 was not found, then the result would be [item1Info, null, item2Info]. Will return an empty array when the oo-find-menu-items feature flag is disabled */
export type DoMenus_FindMenuItemsResponse = {
  __typename?: 'DoMenus_FindMenuItemsResponse';
  items: Array<Maybe<DoMenus_FindMenuItemsItem>>;
};

export type DoMenus_FindMenuItemsResult = DoMenus_FindMenuItemsError | DoMenus_FindMenuItemsResponse;

export type DoMenus_GetMenuGroupsError = {
  __typename?: 'DoMenus_GetMenuGroupsError';
  message: Scalars['String']['output'];
};

export type DoMenus_GetMenuGroupsGroup = {
  __typename?: 'DoMenus_GetMenuGroupsGroup';
  description?: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  imageLink?: Maybe<Scalars['String']['output']>;
  itemTags: Array<Menus_MenuItemTag>;
  items: Array<Maybe<DoMenus_GetMenuItemsItem>>;
  masterId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type DoMenus_GetMenuGroupsGroupInput = {
  channelGuid?: InputMaybe<Scalars['String']['input']>;
  menuGroupGuid: Scalars['String']['input'];
  restaurantGuid: Scalars['String']['input'];
};

export type DoMenus_GetMenuGroupsInput = {
  fulfillmentDate?: InputMaybe<Scalars['String']['input']>;
  groups: Array<DoMenus_GetMenuGroupsGroupInput>;
  respectAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  visibility: Menus_VisibilityEnum;
};

export type DoMenus_GetMenuGroupsResponse = {
  __typename?: 'DoMenus_GetMenuGroupsResponse';
  groups: Array<Maybe<DoMenus_GetMenuGroupsGroup>>;
};

export type DoMenus_GetMenuGroupsResult = DoMenus_GetMenuGroupsError | DoMenus_GetMenuGroupsResponse;

export type DoMenus_GetMenuItemsError = {
  __typename?: 'DoMenus_GetMenuItemsError';
  message: Scalars['String']['output'];
};

export type DoMenus_GetMenuItemsInput = {
  items: Array<DoMenus_GetMenuItemsItemInput>;
};

export type DoMenus_GetMenuItemsItem = {
  __typename?: 'DoMenus_GetMenuItemsItem';
  calories?: Maybe<Scalars['Int']['output']>;
  contentAdvisories: Menus_ContentAdvisories;
  description?: Maybe<Scalars['String']['output']>;
  groupGuid?: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  hasModifiers?: Maybe<Scalars['Boolean']['output']>;
  imageLink?: Maybe<Scalars['String']['output']>;
  itemTags: Array<Menus_MenuItemTag>;
  masterId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  prices: Array<DoMenus_Price>;
  unitOfMeasure: Menus_UnitOfMeasure;
};

export type DoMenus_GetMenuItemsItemInput = {
  /** The instant at which to evaluate time-specific menu features, such as availability and pricing. The current time will be used if omitted. Should be in ISO 8601 format and include date and time. Example: 2019-08-07T13:00:00-04:00 */
  dateTime?: InputMaybe<Scalars['String']['input']>;
  menuGroupGuid: Scalars['String']['input'];
  menuItemGuid: Scalars['String']['input'];
  respectAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  restaurantGuid: Scalars['String']['input'];
  visibility: Menus_VisibilityEnum;
};

export type DoMenus_GetMenuItemsResponse = {
  __typename?: 'DoMenus_GetMenuItemsResponse';
  items: Array<Maybe<DoMenus_GetMenuItemsItem>>;
};

export type DoMenus_GetMenuItemsResult = DoMenus_GetMenuItemsError | DoMenus_GetMenuItemsResponse;

export type DoMenus_PopularItem = {
  __typename?: 'DoMenus_PopularItem';
  menuGroup: Menus_MenuGroupV2;
  menuItem: Menus_MenuItemV2;
};

export type DoMenus_PopularItemsError = {
  __typename?: 'DoMenus_PopularItemsError';
  message: Scalars['String']['output'];
};

export type DoMenus_PopularItemsInput = {
  dateTime?: InputMaybe<Scalars['String']['input']>;
  restaurantGuid: Scalars['String']['input'];
  visibility: Menus_VisibilityEnum;
};

export type DoMenus_PopularItemsResponse = {
  __typename?: 'DoMenus_PopularItemsResponse';
  /** Ordered list of popular items that are currently visible based on the input parameters. */
  popularItems: Array<DoMenus_PopularItem>;
};

export type DoMenus_PopularItemsResult = DoMenus_PopularItemsError | DoMenus_PopularItemsResponse;

export type DoMenus_Price = {
  __typename?: 'DoMenus_Price';
  guid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type EGiftCardConfig = {
  __typename?: 'EGiftCardConfig';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  eGiftCardImage?: Maybe<Scalars['String']['output']>;
  eGiftCardPurchasingEnabled?: Maybe<Scalars['Boolean']['output']>;
  maximumPurchaseAmount?: Maybe<GiftCardAmount>;
  minimumPurchaseAmount?: Maybe<GiftCardAmount>;
};

export type EGiftCardShopCartGiftCard = {
  __typename?: 'EGiftCardShopCartGiftCard';
  amount: Scalars['Int']['output'];
  deliveryDate?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  recipientPhone?: Maybe<Scalars['String']['output']>;
  senderEmail?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  senderPhone?: Maybe<Scalars['String']['output']>;
};

export type EGiftCardShopCartMutation = {
  __typename?: 'EGiftCardShopCartMutation';
  addEGiftCardToCart: EGiftCardShopCartResponse;
};


export type EGiftCardShopCartMutationAddEGiftCardToCartArgs = {
  cartGuid?: InputMaybe<Scalars['ID']['input']>;
  giftCardInfo: GiftCardInfoRequest;
  restaurantGuid: Scalars['ID']['input'];
};

export type EGiftCardShopCartQuery = {
  __typename?: 'EGiftCardShopCartQuery';
  eGiftCardShopCart: EGiftCardShopCartResponse;
};


export type EGiftCardShopCartQueryEGiftCardShopCartArgs = {
  cartGuid: Scalars['ID']['input'];
  restaurantGuid: Scalars['ID']['input'];
};

export type EGiftCardShopCartResponse = {
  __typename?: 'EGiftCardShopCartResponse';
  cartGuid: Scalars['ID']['output'];
  giftCards: Array<EGiftCardShopCartGiftCard>;
  totalAmount: Scalars['Int']['output'];
};

export type EGiftCardShopConfigQuery = {
  __typename?: 'EGiftCardShopConfigQuery';
  eGiftCardShopConfig: EGiftCardShopConfigResponse;
};


export type EGiftCardShopConfigQueryEGiftCardShopConfigArgs = {
  restaurantGuid?: InputMaybe<Scalars['ID']['input']>;
  shortUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EGiftCardShopConfigResponse = {
  __typename?: 'EGiftCardShopConfigResponse';
  backgroundImage: Scalars['String']['output'];
  bannerImage: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  eGiftCardImage: Scalars['String']['output'];
  eGiftCardPurchasingEnabled: Scalars['Boolean']['output'];
  maxGiftCardCount: Scalars['Int']['output'];
  maximumPurchaseAmount: Scalars['Int']['output'];
  minimumPurchaseAmount: Scalars['Int']['output'];
  restaurantImage: Scalars['String']['output'];
  restaurantName: Scalars['String']['output'];
};

export type EcommerceMutationErrorResponse = {
  __typename?: 'EcommerceMutationErrorResponse';
  message: Scalars['String']['output'];
};

export type EcommerceMutationSuccessResponse = {
  __typename?: 'EcommerceMutationSuccessResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EcommerceResponse = EcommerceMutationErrorResponse | EcommerceMutationSuccessResponse;

export type EditItemInCartInput = {
  /** The GUID of the cart that the cart item referenced by **selectionGuid** belongs to. */
  cartGuid: Scalars['ID']['input'];
  /** Indicates what the cart item referenced by **selectionGuid** would look like. */
  selection: SelectionInput;
  /** Indicates the cart item to be modified. */
  selectionGuid: Scalars['ID']['input'];
};

export type EditItemInCartResponse = {
  __typename?: 'EditItemInCartResponse';
  cart?: Maybe<Cart>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EncryptedCreditCardData = {
  encryptedCardData: Scalars['String']['input'];
  keyId: Scalars['String']['input'];
};

export type EncryptedCreditCardMetadata = {
  cardFirst6: Scalars['String']['input'];
  cardLast4: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

/** Indicates the failure to achieve the intended result of a query or mutation. */
export type Error = {
  message: Scalars['String']['output'];
};

export enum ErrorCode {
  /** 4xx for auth , permissions, validation */
  AuthError = 'AUTH_ERROR',
  CommunicationError = 'COMMUNICATION_ERROR',
  CourseIdNotFound = 'COURSE_ID_NOT_FOUND',
  DbError = 'DB_ERROR',
  DeserializationError = 'DESERIALIZATION_ERROR',
  DomainNotAllowed = 'DOMAIN_NOT_ALLOWED',
  IncorrectClientId = 'INCORRECT_CLIENT_ID',
  /** 5xx for internal errors */
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  InvalidToken = 'INVALID_TOKEN',
  InvalidUrl = 'INVALID_URL',
  KeyAlreadyExists = 'KEY_ALREADY_EXISTS',
  OperationNotAllowed = 'OPERATION_NOT_ALLOWED',
  SerializationError = 'SERIALIZATION_ERROR',
  UnauthorizedOperation = 'UNAUTHORIZED_OPERATION'
}

/** Data for Error Codes */
export type ErrorCodeData = {
  __typename?: 'ErrorCodeData';
  message: Scalars['String']['output'];
  statusCode: Scalars['Int']['output'];
};

export type FavoriteRestaurantsInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export enum FeedbackRatingEnum {
  Negative = 'NEGATIVE',
  Passive = 'PASSIVE',
  Positive = 'POSITIVE',
  SomewhatNegative = 'SOMEWHAT_NEGATIVE',
  SomewhatPositive = 'SOMEWHAT_POSITIVE'
}

export enum FeedbackRatingV2 {
  Negative = 'NEGATIVE',
  Passive = 'PASSIVE',
  Positive = 'POSITIVE',
  SomewhatNegative = 'SOMEWHAT_NEGATIVE',
  SomewhatPositive = 'SOMEWHAT_POSITIVE'
}

export enum FeedbackRawRatingEnum {
  Faces = 'FACES',
  Stars = 'STARS',
  Thumbs = 'THUMBS'
}

export enum FeedbackRawRatingV2 {
  Faces = 'FACES',
  Stars = 'STARS',
  Thumbs = 'THUMBS'
}

export type FindGiftCardBySecureTokenInput = {
  secureToken: Scalars['String']['input'];
};

export type FingerprintAllCardsPartialSuccessResponse = {
  __typename?: 'FingerprintAllCardsPartialSuccessResponse';
  errorResponses: Array<FingerprintCardError>;
  guest: Guest;
  successResponses: Array<FingerprintCardSuccessResponse>;
};

export type FingerprintAllCardsResponse = FingerprintAllCardsPartialSuccessResponse | FingerprintAllCardsSuccessResponse | UnexpectedError;

export type FingerprintAllCardsSuccessResponse = {
  __typename?: 'FingerprintAllCardsSuccessResponse';
  guest: Guest;
};

export type FingerprintCardError = Error & {
  __typename?: 'FingerprintCardError';
  code: FingerprintErrorCode;
  message: Scalars['String']['output'];
  paymentCardId: Scalars['ID']['output'];
};

export type FingerprintCardSuccessResponse = {
  __typename?: 'FingerprintCardSuccessResponse';
  cardFingerprintId: Scalars['String']['output'];
  paymentCardId: Scalars['ID']['output'];
};

export enum FingerprintErrorCode {
  FingerprintCardFailed = 'FINGERPRINT_CARD_FAILED'
}

export type FollowRequestAcceptedGuestNotificationHubItem = GuestNotificationHubItem & {
  __typename?: 'FollowRequestAcceptedGuestNotificationHubItem';
  followee?: Maybe<SocialUser>;
  id: Scalars['ID']['output'];
  notificationRoutes?: Maybe<NotificationHubRoutes>;
  notificationText: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type FractionalQuantity = {
  __typename?: 'FractionalQuantity';
  quantity: Scalars['Float']['output'];
  unitOfMeasure: UnitOfMeasure;
};

/** Data representing the unit of measure to use when weighing out an item and the amount to weigh. */
export type FractionalQuantityInput = {
  quantity: Scalars['Float']['input'];
  unitOfMeasure: UnitOfMeasure;
};

export type FreeDeliveryOffer = BaseToastFundedOffer & {
  __typename?: 'FreeDeliveryOffer';
  active: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  guid: Scalars['ID']['output'];
  maxDeliveryValue: Money;
  maxGuestRedemptions: Scalars['Int']['output'];
  minPurchaseAmount: Money;
  offerDescription?: Maybe<Scalars['String']['output']>;
  offerName: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  targeting: OfferTargeting;
};

export enum FulfillmentType {
  /** The order on the cart is intended to be fulfilled as soon as possible, within the current service period. */
  Asap = 'ASAP',
  /** The order on the cart is intended to be fulfilled at a later time indicated by the client. */
  Future = 'FUTURE'
}

export type FundedOffersQuery = {
  __typename?: 'FundedOffersQuery';
  toastFundedOffers: Array<ToastFundedOffer>;
};


export type FundedOffersQueryToastFundedOffersArgs = {
  input: GetToastFundedOffersInput;
};

export type FundraisingConfig = {
  __typename?: 'FundraisingConfig';
  /** Whether a fundraiser is enabled for the restaurant */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** campaign Description */
  campaignDescription?: Maybe<Scalars['String']['output']>;
  /** campaign logo URL */
  campaignLogoURL?: Maybe<Scalars['String']['output']>;
  /** campaign name */
  campaignName?: Maybe<Scalars['String']['output']>;
  /** Some campaigns are for specific projects at a cause, e.g. Ukraine Relief at World Central Kitchen. When this is the case, this field contains that parent cause's name */
  causeParentName?: Maybe<Scalars['String']['output']>;
  /** Amounts of money which can be chosen to donate */
  donationAmounts?: Maybe<Array<Scalars['Float']['output']>>;
  /** The type of donation that will be made. */
  donationType?: Maybe<Scalars['String']['output']>;
  /** The legal disclosure that must be shown to the guest if they opt-in to donate. May contain <a> links that need to be clickable and open the linked content in a new tab */
  guestLegalDisclosure?: Maybe<Scalars['String']['output']>;
};

export type FundraisingInput = {
  fundraisingAmount: Scalars['Float']['input'];
};

export type FutureFulfillmentDate = {
  __typename?: 'FutureFulfillmentDate';
  /** ISO 8601 local date string. */
  date: Scalars['String']['output'];
  /** A list of fulfillment times without any service gap. */
  times: Array<FutureFulfillmentTime>;
  /** A **FutureFulfillmentTime** represents a time that can be selected for placing a **FUTURE** order. A **FutureFulfillmentServiceGap** represents a gap between two service periods. */
  timesAndGaps: Array<FutureFulfillmentTimeSlot>;
};

export type FutureFulfillmentServiceGap = {
  __typename?: 'FutureFulfillmentServiceGap';
  /** The label for a service gap. */
  description: Scalars['String']['output'];
};

export type FutureFulfillmentTime = {
  __typename?: 'FutureFulfillmentTime';
  /** ISO 8601 date/time string. This is the full date/time string for clients' ease to select and store a timestamp as opposed to having the need to stitch together a local date and a local time. */
  time: Scalars['String']['output'];
};

export type FutureFulfillmentTimeSlot = FutureFulfillmentServiceGap | FutureFulfillmentTime;

export type FutureSchedule = {
  __typename?: 'FutureSchedule';
  /** The dates that can be selected for placing a **FUTURE** order. */
  dates: Array<FutureFulfillmentDate>;
};

/** General error resulted from temporary unavailability or failure of critical upstream services or tripped circuit breakers. */
export type GeneralError = Error & {
  __typename?: 'GeneralError';
  code: GeneralErrorCode;
  message: Scalars['String']['output'];
};

export enum GeneralErrorCode {
  /** Invalid Input */
  InvalidInput = 'INVALID_INPUT',
  /** Temporary unavailability or failure of upstream services. */
  Retryable = 'RETRYABLE',
  /** Tripped circuit breakers within BFF or critical upstream services. */
  ServiceUnavailable = 'SERVICE_UNAVAILABLE'
}

export type GenerateGuestMediaPostImageUploadUrlsRequest = {
  numberOfUrls: Scalars['Int']['input'];
  placeId: Scalars['ID']['input'];
  postId: Scalars['ID']['input'];
};

export type GenerateGuestMediaPresignedImageUrlsRequest = {
  numberOfUrls: Scalars['Int']['input'];
};

export type GenerateGuestMediaPresignedUrlsResult = GenerateGuestMediaPresignedUrlsSuccess | InvalidRequestError | UnexpectedError;

export type GenerateGuestMediaPresignedUrlsSuccess = {
  __typename?: 'GenerateGuestMediaPresignedUrlsSuccess';
  urls: Array<GuestMediaPresignedUrl>;
};

export type GenerateGuestMediaUploadUrlSuccess = {
  __typename?: 'GenerateGuestMediaUploadUrlSuccess';
  retrievalUrl: Scalars['String']['output'];
  uploadFormFields: Array<GuestMediaUploadFormField>;
  uploadUrl: Scalars['String']['output'];
};

export type GenerateGuestMediaUploadUrlsResult = GenerateGuestMediaUploadUrlsSuccess | InvalidRequestError | UnexpectedError;

export type GenerateGuestMediaUploadUrlsSuccess = {
  __typename?: 'GenerateGuestMediaUploadUrlsSuccess';
  results: Array<GenerateGuestMediaUploadUrlSuccess>;
};

export type GenericResponse = {
  __typename?: 'GenericResponse';
  message: Scalars['String']['output'];
};

export type GeoCoordinates = {
  __typename?: 'GeoCoordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GeoCoordinatesInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GetAllPostsForSocialUserInput = {
  socialUserId: Scalars['ID']['input'];
};

export type GetAllReviewsForGuestInput = {
  guestGuid: Scalars['ID']['input'];
};

export type GetAllReviewsForGuestResponse = {
  __typename?: 'GetAllReviewsForGuestResponse';
  experienceRatings: Array<GuestRating>;
  imageReviews: Array<GuestImageReview>;
  menuItemRatings: Array<GuestRating>;
  textReviews: Array<GuestTextReview>;
};

export type GetAwardLeaderboardInput = {
  latitude: Scalars['Float']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  longitude: Scalars['Float']['input'];
};

export type GetAwardLeaderboardResult = GetAwardLeaderboardSuccess | UnexpectedError;

export type GetAwardLeaderboardSuccess = {
  __typename?: 'GetAwardLeaderboardSuccess';
  leaderboards: Array<AwardLeaderboard>;
};

export type GetMarketingSubscriptionRequest = {
  __typename?: 'GetMarketingSubscriptionRequest';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  managementSetGuid?: Maybe<Scalars['ID']['output']>;
  restaurantGuid: Scalars['ID']['output'];
  source: Scalars['String']['output'];
};

export type GetMyGuestNotificationHubItemsInput = {
  pageInput: PageInput;
};

export type GetMySocialUserResult = GetMySocialUserSuccess | SocialUserDoesNotExistError | UnexpectedError;

export type GetMySocialUserSuccess = {
  __typename?: 'GetMySocialUserSuccess';
  socialUser: SocialUser;
};

export type GetSocialUsersResult = GetSocialUsersSuccess | SocialUserDoesNotExistError | UnexpectedError;

export type GetSocialUsersSuccess = {
  __typename?: 'GetSocialUsersSuccess';
  socialUsers: Array<SocialUser>;
};

export type GetSurchargeSummaryInput = {
  cartGuid: Scalars['ID']['input'];
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  restaurantGuid: Scalars['ID']['input'];
  totalGiftCardBalance?: InputMaybe<Scalars['Float']['input']>;
};

export type GetToastFundedOffersInput = {
  restaurantGuid?: InputMaybe<Scalars['ID']['input']>;
  userLocation?: InputMaybe<GeoCoordinatesInput>;
};

export type GiftCardAmount = {
  __typename?: 'GiftCardAmount';
  currency: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type GiftCardAmountInput = {
  currency: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type GiftCardBalanceInquiryError = Error & {
  __typename?: 'GiftCardBalanceInquiryError';
  code: GiftCardBalanceInquiryErrorCode;
  message: Scalars['String']['output'];
};

export enum GiftCardBalanceInquiryErrorCode {
  /** Indicates no available balance on the gift card This is used instead of just applying a balance of 0 because we don't want to expose errors for invalid cards to the front-end and we don't want to apply a balance (even if zero) to an invalid card */
  NoBalance = 'NO_BALANCE'
}

export type GiftCardBalanceInquiryInput = {
  /** Gift Card Number to lookup */
  cardNumber: Scalars['String']['input'];
  /** References Cart Guid */
  cartGuid: Scalars['ID']['input'];
};

export type GiftCardBalanceInquiryResponse = {
  __typename?: 'GiftCardBalanceInquiryResponse';
  /** The balance available on the gift card */
  availableBalance: Scalars['Float']['output'];
  /** The requested card number */
  cardNumber: Scalars['String']['output'];
};

export type GiftCardBalanceInquiryResponseOrError = GiftCardBalanceInquiryError | GiftCardBalanceInquiryResponse;

/** Gift Card Config */
export type GiftCardConfig = {
  __typename?: 'GiftCardConfig';
  /** Can add value */
  addValueAllowed: Scalars['Boolean']['output'];
  /** If true supports the extended gift card API that third party gift cards use. */
  hasGiftCardsExtension: Scalars['Boolean']['output'];
  /** Can lookup value */
  lookupAllowed: Scalars['Boolean']['output'];
  /** Can Purchase Gift Cards */
  purchaseAllowed: Scalars['Boolean']['output'];
  /** Can Redeem Gift Cards */
  redemptionAllowed: Scalars['Boolean']['output'];
  /** If true then pin number is supported */
  supportVerificationCode: Scalars['Boolean']['output'];
  /** If true then a gift card can cover tips. This is set as a config in Toastweb. */
  tipAllowed: Scalars['Boolean']['output'];
};

export type GiftCardData = {
  __typename?: 'GiftCardData';
  /** The balance available on the gift card */
  balance: Scalars['Float']['output'];
  /** The requested Gift Card number */
  giftCardNumber: Scalars['String']['output'];
  /** The restaurant associated with the lookup request */
  rxGuid?: Maybe<Scalars['String']['output']>;
};

export type GiftCardDataOrError = GiftCardData | GiftCardLookupError | GiftCardNotFoundError;

export type GiftCardExtensionBalanceInquiryInput = {
  /** Captcha token. Should be recaptcha:enterprise:<token> */
  captchaToken: Scalars['String']['input'];
  /** Gift Card Number to lookup */
  cardNumber: Scalars['String']['input'];
  /** References Cart Guid */
  cartGuid: Scalars['ID']['input'];
  /** Optional pin number */
  pin?: InputMaybe<Scalars['String']['input']>;
};

export type GiftCardInfoInput = {
  amount: GiftCardAmountInput;
  deliveryDateTime?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  recipient: GiftCardRecipientInput;
  sendType: GiftCardSendType;
};

export type GiftCardInfoRequest = {
  amount: Scalars['Int']['input'];
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientPhone?: InputMaybe<Scalars['String']['input']>;
  senderEmail?: InputMaybe<Scalars['String']['input']>;
  senderName?: InputMaybe<Scalars['String']['input']>;
  senderPhone?: InputMaybe<Scalars['String']['input']>;
};

/** Gift Card Links are so clients can direct guests to Toastweb URLs to purchase or manage gift cards */
export type GiftCardLinks = {
  __typename?: 'GiftCardLinks';
  /** Allows the client to set guest expectations for the checkValueLink link if true, indicate that value can be added if false, do no indicate value can be added */
  addValueEnabled: Scalars['Boolean']['output'];
  /** The link in Toastweb for guests to check a gift card value or add value if addValueEnabled === true if null, the client should not display the link */
  checkValueLink?: Maybe<Scalars['String']['output']>;
  /** The link in Toastweb for guests to purchase gift cards if null, the client should not display the link */
  purchaseLink?: Maybe<Scalars['String']['output']>;
};

export type GiftCardLookupData = {
  /** Gift Card Number to lookup */
  cardNumber: Scalars['String']['input'];
  /** References Restaurant Guid */
  rxGuid: Scalars['String']['input'];
};

export type GiftCardLookupError = Error & {
  __typename?: 'GiftCardLookupError';
  /** The error code */
  code: GiftCardLookupErrorCode;
  /** The requested Gift Card number */
  giftCardNumber: Scalars['String']['output'];
  /** The error message */
  message: Scalars['String']['output'];
  /** The restaurant associated with the lookup request */
  rxGuid: Scalars['String']['output'];
};

export enum GiftCardLookupErrorCode {
  OperationFailed = 'OPERATION_FAILED'
}

export type GiftCardLookupInput = {
  /** Array of Gift Cards to lookup */
  giftCards: Array<GiftCardLookupData>;
};

export type GiftCardLookupResponse = {
  __typename?: 'GiftCardLookupResponse';
  /** A collection of successful lookup responses */
  data: Array<GiftCardData>;
  /** A collection of failed lookup responses */
  errors: Array<GiftCardLookupError>;
};

export type GiftCardNotFoundError = Error & {
  __typename?: 'GiftCardNotFoundError';
  code: GiftCardNotFoundErrorCode;
  message: Scalars['String']['output'];
};

export enum GiftCardNotFoundErrorCode {
  GiftCardNotFound = 'GIFT_CARD_NOT_FOUND'
}

export type GiftCardOrderDetailsInput = {
  giftCards: Array<GiftCardInfoInput>;
  paymentGuid: Scalars['ID']['input'];
  sender: GiftCardSenderInput;
  totalAmount: GiftCardAmountInput;
};

export type GiftCardPayment = {
  __typename?: 'GiftCardPayment';
  /** The balance of the gift card used as payment on the order */
  appliedBalance: Scalars['Float']['output'];
};

export type GiftCardPaymentInput = {
  /** The full numeric card number, no spaces */
  cardNumber: Scalars['String']['input'];
  /** The amount that is expected to be used during the place order action If check amount > expectedAvailableBalance and expectedAvailableBalance < the actual balance of the gift card at the time of placing the order and the alternative payment is Credit Card then the order will error because the amount charged to the card would be more than expected by the client */
  expectedAvailableBalance: Scalars['Float']['input'];
  /** This value will default to false but should be set to true if the intent is for a gift card to cover or contribute to the tip. */
  shouldCoverTip?: InputMaybe<Scalars['Boolean']['input']>;
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};

export type GiftCardPhoneInput = {
  countryCode: Scalars['String']['input'];
  nationalNumber: Scalars['String']['input'];
};

export enum GiftCardPurchaseSource {
  GiftcardShop = 'GIFTCARD_SHOP',
  Websites = 'WEBSITES'
}

export type GiftCardRecipientInput = {
  email: Scalars['String']['input'];
  phone?: InputMaybe<GiftCardPhoneInput>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export enum GiftCardSendType {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export type GiftCardSenderInput = {
  email: Scalars['String']['input'];
  from?: InputMaybe<Scalars['String']['input']>;
};

export type GoogleConversionLabel = {
  __typename?: 'GoogleConversionLabel';
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GoogleConversionsData = {
  __typename?: 'GoogleConversionsData';
  conversionLabels?: Maybe<Array<Maybe<GoogleConversionLabel>>>;
  tagId?: Maybe<Scalars['String']['output']>;
};

/** Contains a guest's profile data. */
export type Guest = {
  __typename?: 'Guest';
  /** Fetches the addresses saved in the guest's profile, in the order of most recently saved first. */
  addresses: Array<GuestAddress>;
  /** The guest's birthday. */
  birthday?: Maybe<Scalars['Date']['output']>;
  /** The guest's birthday consent status. */
  birthdayConsentedUseCases?: Maybe<Array<BirthdayConsentedUseCase>>;
  /** See **GuestContact**. */
  contact: GuestContact;
  /** Uniquely identifies a guest. */
  id: Scalars['ID']['output'];
  /** The loyalty accounts associated with this guest */
  loyaltyAccounts: Array<GuestLoyaltyAccount>;
  /** See documentation for `GuestWallet`. */
  wallet: GuestWallet;
  /** A signed JWT that can be used to authenticate a user in Zendesk's guest facing customer support service. */
  zendeskJWT?: Maybe<Scalars['String']['output']>;
};

/** A saved address for a guest. */
export type GuestAddress = {
  __typename?: 'GuestAddress';
  /** The postal address saved to the guest account. */
  address: PostalAddress;
  /** The latitude and longitude of the postal address. */
  coordinates: Coordinates;
  /** Uniquely identifies a guest's address. */
  id: Scalars['ID']['output'];
  /** A descriptor for this address such as "Home" or "Work". */
  label?: Maybe<Scalars['String']['output']>;
  /** Additional comments about the address, such as instructions for delivery drivers. */
  notes?: Maybe<Scalars['String']['output']>;
};

/** Indicates that the guest's address intended to be operated on cannot be found. Returns the existing addresses that belong to the guest so the client should update the list of the guest's addresses. */
export type GuestAddressNotFoundError = Error & {
  __typename?: 'GuestAddressNotFoundError';
  /** Addresses that are found in the guest's profile. Follows the same constraints as `Guest.addresses`. */
  existingAddresses: Array<GuestAddress>;
  message: Scalars['String']['output'];
};

/** The Toast product used to setup and confirm the Guest. */
export enum GuestAuthenticationSource {
  Catering = 'CATERING',
  Local = 'LOCAL',
  OnlineOrdering = 'ONLINE_ORDERING',
  OrderAndPay = 'ORDER_AND_PAY',
  Sites = 'SITES',
  ToastApp = 'TOAST_APP',
  ToastPay = 'TOAST_PAY',
  ToastTables = 'TOAST_TABLES'
}

export type GuestAward = {
  __typename?: 'GuestAward';
  awardType: AwardType;
  place?: Maybe<Place>;
};

export type GuestAwardSeason = {
  __typename?: 'GuestAwardSeason';
  awards: Array<GuestAward>;
};

/** A card fingerprint for a guest. */
export type GuestCardFingerprint = {
  __typename?: 'GuestCardFingerprint';
  /** See **BackfillEligibilityStatus**. */
  backfillEligibilityStatus: BackfillEligibilityStatus;
  /** See **PaymentCardType**. */
  cardType?: Maybe<PaymentCardType>;
  /** Two digit expiration month. */
  expirationMonth?: Maybe<Scalars['String']['output']>;
  /** Two digit expiration year. */
  expirationYear?: Maybe<Scalars['String']['output']>;
  /** Uniquely identifies a guest's card fingerprint. */
  id: Scalars['String']['output'];
  /** Descriptor for this card fingerprint. */
  label: Scalars['String']['output'];
  /** See **CardFingerprintLinkableStatus**. */
  linkableStatus: CardFingerprintLinkableStatus;
  /** Last four digits of the card number. */
  panLast4?: Maybe<Scalars['String']['output']>;
  /** Payment card id associated with this card fingerprint. */
  paymentCardId?: Maybe<Scalars['String']['output']>;
  /** See **PaymentMethodType**. */
  paymentMethodType: PaymentMethodType;
};

export type GuestComment = {
  id: Scalars['ID']['output'];
};

export type GuestCommentReportReason = {
  __typename?: 'GuestCommentReportReason';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type GuestCommentReportReasonInput = {
  id: Scalars['ID']['input'];
};

export type GuestCommentReportReasonsResult = GuestCommentReportReasonsSuccess | UnexpectedError;

export type GuestCommentReportReasonsSuccess = {
  __typename?: 'GuestCommentReportReasonsSuccess';
  reasons: Array<GuestCommentReportReason>;
};

export enum GuestCommentTargetType {
  Post = 'POST'
}

export type GuestCommentsPage = {
  __typename?: 'GuestCommentsPage';
  currentPageToken?: Maybe<Scalars['String']['output']>;
  items: Array<GuestComment>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** Contact data for a guest. */
export type GuestContact = {
  __typename?: 'GuestContact';
  /** A list of email addresses on file for a guest. */
  contactEmails?: Maybe<Array<ContactEmail>>;
  /** The email address on file for a guest. Currently will not return null. Defining nullable now to enable a future for not requiring full contact for a complete profile. */
  email?: Maybe<Scalars['String']['output']>;
  /** The first name on file for a guest. Profiles created purely from the passwordless authentication flow will not result in null. Profiles imported from customermgmt might return null. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The last name on file for a guest. Profiles created purely from the passwordless authentication flow will not result in null. Profiles imported from customermgmt might return null. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The phone number on file and the primary authentication identifier for a guest. Currently will not return null. Defining nullable now to enable a future for email authentication and not requiring full contact for a complete profile. */
  phone?: Maybe<Scalars['String']['output']>;
};

/** The possible fields to collect on a `GuestContact`. */
export enum GuestContactField {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Phone = 'PHONE'
}

export type GuestCreateOrUpdateProfilePhotoSuccess = {
  __typename?: 'GuestCreateOrUpdateProfilePhotoSuccess';
  croppedProfilePhoto: CreateOrUpdateCroppedProfilePhotoResult;
};

export type GuestCroppedProfilePhotoSuccess = {
  __typename?: 'GuestCroppedProfilePhotoSuccess';
  profilePhotoSuccess: GuestProfilePhotoSuccess;
};

/** Represents a guest's Toast-specific currency account. */
export type GuestCurrencyAccount = {
  __typename?: 'GuestCurrencyAccount';
  /** The total available amount of Toast-specific currency in the account. Includes Stored Value balance if restaurantGuid is input and flag stp-spend-sv-as-guest-currency is true for the restaurant. Returns 0 if restaurantGuid is input and flag nv1-allow-global-giftcards is false for the restaurant. */
  availableBalance: Money;
  /** The total available amount of Toast-specific currency in the account. Always includes Stored Value balance; intended for use outside of restaurant contexts. */
  availableBalanceWithStoredValue: Money;
  /** The total available amount of Toast-specific currency in the account. Never includes Stored Value balance. */
  availableBalanceWithoutStoredValue: Money;
  /** The individual units contributing to the total available amount of Toast-specific currency in the account that have an available balance greater than zero, are expirable, and not expired at the time of request. The relationship between the balance and these units is asymmetrical: all of these units contribute to the guest's available balance (GuestCurrencyAccount.availableBalance), but the available balance does not necessarily comprise exclusively of these units. If `pageInput` is not set, it defaults to null, which results in requesting for the first page with the default page size (see `PageInput.nextPageSize`). Returned in ascending order of `GuestCurrencyExpirableUnit.expirationDateTime` (soonest to expire first). */
  expirableUnits: GuestCurrencyExpirableUnitPage;
  /** Unique identifier for this `GuestCurrencyAccount`. */
  id: Scalars['ID']['output'];
  /** Intended to make consistent across platforms UX use-cases such as: - "$10 expiring today" - "$10 expiring soon" - "$15 expiring tomorrow" - "$5 expiring in 30 days" Indicates the nearest future expiring "value" for a guest's currency account, lumped to a calendar date. Multiple units of value are combined to be considered as expiring on the same date, using the provided timezone to determine the "start" and "end" points of a 24-hour day to which a date corresponds. (e.g., the backend has discretion to determine that date is considered 2am-2am vs. the traditional midnight-midnight cutoff) Expiration occurs at a specific UTC datetime, and this logic will normalize these datetime expirations to a calendar day. For example: - I am in the America/New_York time zone - I have (a) $6 expiring at 09/19/2024 at 1:00PM EDT - I have (b) $10 expiring at 09/20/2024 11:00AM EDT - I have (c) $5 expiring at 09/20/2024 2:00PM EDT - I have (d) $7 expiring at 09/21/2024 10:00PM EDT - Toast considers 11:59PM EDT as the end of the day for that time zone If it is currently 09/19/2024 at 10:00AM EDT when I am requesting nearestFutureExpirableValueByDay, then, we would tell a guest that $6 of value (a) is expiring on 09/19/2024, as this is the nearest date during which Toast Cash can be used. - (a) is included because it will expire at some point during the 09/19/2024 calendar date for my time zone. - (b), (c), and (d) are all excluded because they will be expiring during a different future calendar date for my time zone. If it is currently 09/19/2024 at 1:01PM EDT when I am requesting nearestFutureExpirableValueByDay, then, we would tell a guest that $15 of value (b + c) is expiring on 09/20/2024, as this is the nearest date during which Toast Cash can be used. - (a) is excluded because it has already expired, and can no longer be used. - (b) is included because it will expire during some time on the calendar date of 09/20/2024. - (c) is included for the same reason as b; it is part of the same 24-hour period that represents the date of 09/20/2024 - (d) is excluded because it is beyond the 9/20/2024 calendar date for my time zone Null indicates there is no pending expiring value in the future. */
  nearestFutureExpirableDayValue?: Maybe<GuestCurrencyExpirableDayValue>;
  /** The history of Toast-specific currency units received into the guest currency account. Units can either come from promotional value (which are not filtered by expiry or balance) or stored value. Returns a single page containing all units in descending order of the date the applicable currency unit was received (most recently received units first). For a broader view of the guest currency account, look at the transactions field, which also includes spent guest currency. */
  receivedUnits: GuestCurrencyUnitPage;
  /** History of transactions on the guest currency account. "Transaction" is a broad term referring to any change in the guest currency balance, either from additions or reductions. In practice, this always returns one page; the pagination type is for future-proofing. */
  transactions: GuestCurrencyTransactionPage;
};


/** Represents a guest's Toast-specific currency account. */
export type GuestCurrencyAccountAvailableBalanceArgs = {
  restaurantGuid?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a guest's Toast-specific currency account. */
export type GuestCurrencyAccountExpirableUnitsArgs = {
  pageInput?: InputMaybe<PageInput>;
};


/** Represents a guest's Toast-specific currency account. */
export type GuestCurrencyAccountNearestFutureExpirableDayValueArgs = {
  timeZone: Scalars['String']['input'];
};

/** Input for using guest currency account as a payment method. */
export type GuestCurrencyAccountPaymentInput = {
  /** The amount the guest expects to be spent from their guest currency account as payment. */
  expectedGuestCurrencyAccountPaymentAmount: Scalars['Float']['input'];
  /** The unique identifier for the guest currency account from which the payment should be authorized. */
  guestCurrencyAccountId: Scalars['ID']['input'];
};

/** Represents expiring value in the future, lumped by calendar day */
export type GuestCurrencyExpirableDayValue = {
  __typename?: 'GuestCurrencyExpirableDayValue';
  /** The amount of value, as equivalent currency, that will expire. */
  amount: Money;
  /** The calendar date at the value will be considered expired. A value can expire at *any* time during this calendar date. */
  expirationDate: Scalars['Date']['output'];
  /** The instant (date and time) at which the nearest unit (part or whole of the value) will be considered expired. This is useful for a client to utilize to either report the exact time of the nearest expiring unit, or as a way to indicate the time at which the client state is 'stale' and should consider re-querying for the next GuestCurrencyExpirableDayValue */
  nearestUnitExpirationDateTime: Scalars['DateTime']['output'];
};

/** A unit of Toast-specific currency that is expirable. */
export type GuestCurrencyExpirableUnit = GuestCurrencyUnit & PageItem & {
  __typename?: 'GuestCurrencyExpirableUnit';
  /** See documentation for `GuestCurrencyUnit.availableBalance`. */
  availableBalance: Money;
  /** @deprecated Use expirableDepositTrigger instead. */
  depositTrigger: GuestCurrencyUnitDepositTrigger;
  /** The specific type of event that triggered the deposit of the expirable unit to the account. */
  expirableDepositTrigger: GuestCurrencyExpirableUnitDepositTrigger;
  /** The timestamp after which the unit will expire. After the timestamp, any `availableBalance` greater than zero will no longer be spendable. */
  expirationDateTime: Scalars['DateTime']['output'];
  /** Unique identifier for this `GuestCurrencyExpirableUnit`. */
  id: Scalars['ID']['output'];
  /** See documentation for `GuestCurrencyUnit.issuanceReason`. */
  issuanceReason: Scalars['String']['output'];
  /** See documentation for `GuestCurrencyUnit.issuedAmount`. */
  issuedAmount: Money;
  /** See documentation for `GuestCurrencyUnit.issuedDateTime`. */
  issuedDateTime: Scalars['DateTime']['output'];
};

/** Possible triggers for a `GuestCurrencyExpirableUnit` to be deposited into a `GuestCurrencyAccount`. Intentionally somewhat duplicates `GuestCurrencyUnitDepositTrigger` to narrow the concern of a deposit trigger to an expirable unit. */
export enum GuestCurrencyExpirableUnitDepositTrigger {
  /** The `GuestCurrencyUnit` was deposited as a result of `applyCodeToGuestCurrencyAccount`. */
  CodeApplication = 'CODE_APPLICATION',
  /** The `GuestCurrencyUnit` was deposited as a result of a promotion. For example, Mastercard runs a promotional campaign that triggers deposits of Toast-specific currency from payments via a Mastercard. */
  Promotion = 'PROMOTION'
}

/** A page of `GuestCurrencyExpirableUnit`s. */
export type GuestCurrencyExpirableUnitPage = Page & {
  __typename?: 'GuestCurrencyExpirableUnitPage';
  /** See documentation for `Page.currentPageToken`. */
  currentPageToken?: Maybe<Scalars['String']['output']>;
  /** `GuestCurrencyExpirableUnit`s in the current `GuestCurrencyExpirableUnitPage`. */
  items: Array<GuestCurrencyExpirableUnit>;
  /** See documentation for `Page.nextPageToken`. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** A transaction depicting that an expirable unit expired. */
export type GuestCurrencyExpiration = {
  __typename?: 'GuestCurrencyExpiration';
  /** A positive value representing a negative delta to the guest currency balance */
  amount: Money;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type GuestCurrencyMoneyInput = {
  amount: Scalars['Decimal']['input'];
  currency: Currency;
};

/** Some amount of guest currency that was spent as a payment at a restaurant. */
export type GuestCurrencySpend = {
  __typename?: 'GuestCurrencySpend';
  /** A positive value representing a negative delta to the guest currency balance */
  amount: Money;
  /** No guarantees on what this id is or what kind of entity it maps to. It's just a unique identifier to support lists of this type. */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** The path to the logo of the restaurant that this spend occurred at. */
  restaurantLogoUrl?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

/** A unit of gifted Toast-specific currency that is backed by real, stored monetary value. */
export type GuestCurrencyStoredValueGiftUnit = GuestCurrencyUnit & PageItem & {
  __typename?: 'GuestCurrencyStoredValueGiftUnit';
  /** See documentation for `GuestCurrencyUnit.availableBalance`. */
  availableBalance: Money;
  /**
   * Should always be STORED_VALUE_GIFT_REDEMPTION, but also this field is only here to fulfill the interface.
   * @deprecated Use __typename instead
   */
  depositTrigger: GuestCurrencyUnitDepositTrigger;
  giftDetails: StoredValueGiftDetails;
  /** Unique identifier for this `GuestCurrencyStoredValueUnit`. */
  id: Scalars['ID']['output'];
  /** See documentation for `GuestCurrencyUnit.issuanceReason`. */
  issuanceReason: Scalars['String']['output'];
  /** The amount on the stored value gift. */
  issuedAmount: Money;
  /** When the stored value gift was redeemed. */
  issuedDateTime: Scalars['DateTime']['output'];
};

/** A unit of self-loaded Toast-specific currency that is backed by real, stored monetary value. */
export type GuestCurrencyStoredValueLoadUnit = GuestCurrencyUnit & PageItem & {
  __typename?: 'GuestCurrencyStoredValueLoadUnit';
  /** See documentation for `GuestCurrencyUnit.availableBalance`. */
  availableBalance: Money;
  /**
   * Should always be STORED_VALUE_LOAD, but also this field is only here to fulfill the interface.
   * @deprecated Use __typename instead
   */
  depositTrigger: GuestCurrencyUnitDepositTrigger;
  /** Unique identifier for this `GuestCurrencyStoredValueUnit`. */
  id: Scalars['ID']['output'];
  /** See documentation for `GuestCurrencyUnit.issuanceReason`. */
  issuanceReason: Scalars['String']['output'];
  /** The amount loaded. */
  issuedAmount: Money;
  /** When the stored value funds were loaded. */
  issuedDateTime: Scalars['DateTime']['output'];
};

export type GuestCurrencyTransaction = GuestCurrencyExpirableUnit | GuestCurrencyExpiration | GuestCurrencySpend | GuestCurrencyStoredValueGiftUnit | GuestCurrencyStoredValueLoadUnit;

/** Purposefully duplicates Page without implementing it because GuestCurrencyTransaction is a union and not an implementation of PageItem. */
export type GuestCurrencyTransactionPage = {
  __typename?: 'GuestCurrencyTransactionPage';
  /** Opaque token used to retrieve the current `Page`. If the current `Page` is the first page, this will be `null`. */
  currentPageToken?: Maybe<Scalars['String']['output']>;
  items: Array<GuestCurrencyTransaction>;
  /** Opaque token that can be used to retrieve the next `Page`. If there are no more `Page`s, this will be `null`. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** An individual unit of Toast-specific currency that contributes to the `GuestCurrencyAccount.availableBalance` of a particular `GuestCurrencyAccount`. */
export type GuestCurrencyUnit = {
  /** The current available amount of Toast-specific currency in the unit. */
  availableBalance: Money;
  /**
   * The specific type of event that triggered the deposit of the unit to the `GuestCurrencyAccount`.
   * @deprecated Use fields on implementing types instead
   */
  depositTrigger: GuestCurrencyUnitDepositTrigger;
  /** The identifier for the unit */
  id: Scalars['ID']['output'];
  /** A description of why the unit was issued to the `GuestCurrencyAccount`. */
  issuanceReason: Scalars['String']['output'];
  /** The original money amount at the time of issuance. Useful for historical auditing purposes. */
  issuedAmount: Money;
  /** When the amount was issued to the account. */
  issuedDateTime: Scalars['DateTime']['output'];
};

/** Possible triggers for a `GuestCurrencyUnit` to be deposited into a `GuestCurrencyAccount`. */
export enum GuestCurrencyUnitDepositTrigger {
  /** The `GuestCurrencyUnit` was deposited as a result of `applyCodeToGuestCurrencyAccount`. */
  CodeApplication = 'CODE_APPLICATION',
  /** The `GuestCurrencyUnit` was deposited as a result of a promotion. For example, Mastercard runs a promotional campaign that triggers deposits of Toast-specific currency from payments via a Mastercard. */
  Promotion = 'PROMOTION',
  /** The `GuestCurrencyUnit` was deposited as the result of a redeemed stored value gift. */
  StoredValueGiftRedemption = 'STORED_VALUE_GIFT_REDEMPTION',
  /** The `GuestCurrencyUnit` was deposited as the result of loading stored value funds. */
  StoredValueLoad = 'STORED_VALUE_LOAD'
}

/** A page of `GuestCurrencyUnit`s. */
export type GuestCurrencyUnitPage = Page & {
  __typename?: 'GuestCurrencyUnitPage';
  /** See documentation for `Page.currentPageToken`. */
  currentPageToken?: Maybe<Scalars['String']['output']>;
  /** `GuestCurrencyUnit`s in the current `GuestCurrencyUnitPage`. */
  items: Array<GuestCurrencyUnit>;
  /** See documentation for `Page.nextPageToken`. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type GuestFacingInstructionsQueryInput = {
  restaurantGuid: Scalars['ID']['input'];
  siteGuid: Scalars['ID']['input'];
};

export type GuestFacingMessagesConfig = {
  __typename?: 'GuestFacingMessagesConfig';
  confirmationInstructions?: Maybe<Instructions>;
};

export type GuestFeedback = {
  __typename?: 'GuestFeedback';
  id?: Maybe<Scalars['ID']['output']>;
};

export type GuestFeedbackContactInformationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  optIn?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GuestFeedbackError = {
  __typename?: 'GuestFeedbackError';
  code: GuestFeedbackErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum GuestFeedbackErrorCode {
  FailedToCreateFeedback = 'FailedToCreateFeedback'
}

export type GuestFeedbackInput = {
  category: Scalars['String']['input'];
  checkID: Scalars['ID']['input'];
  contactInformation?: InputMaybe<GuestFeedbackContactInformationInput>;
  feedbackRating: FeedbackRatingEnum;
  feedbackRawRating: FeedbackRawRatingEnum;
  feedbackSource: Scalars['String']['input'];
  internalFeedback: Scalars['Boolean']['input'];
  orderID: Scalars['ID']['input'];
  orderPaymentID: Scalars['ID']['input'];
  restaurantID: Scalars['ID']['input'];
};

export type GuestFeedbackMutation = {
  __typename?: 'GuestFeedbackMutation';
  createGuestFeedback: GuestFeedbackResponse;
};


export type GuestFeedbackMutationCreateGuestFeedbackArgs = {
  data: GuestFeedbackInput;
};

export type GuestFeedbackResponse = GuestFeedback | GuestFeedbackError;

export type GuestFeedbackV2Error = Error & {
  __typename?: 'GuestFeedbackV2Error';
  code: GuestFeedbackV2ErrorCode;
  message: Scalars['String']['output'];
};

export enum GuestFeedbackV2ErrorCode {
  FeedbackAlreadySubmitted = 'FEEDBACK_ALREADY_SUBMITTED',
  FeedbackNotSubmitted = 'FEEDBACK_NOT_SUBMITTED',
  UnknownError = 'UNKNOWN_ERROR'
}

export type GuestFeedbackV2SuccessResponse = {
  __typename?: 'GuestFeedbackV2SuccessResponse';
  guestFeedbackEventGuid: Scalars['ID']['output'];
};

/** Indicates that the guest has entered the correct OTP but this identity has already been verified on a different guest's account. This error message should be surfaced to the guest. */
export type GuestIdentityAlreadyExistsForAnotherGuestError = Error & {
  __typename?: 'GuestIdentityAlreadyExistsForAnotherGuestError';
  message: Scalars['String']['output'];
};

/** Indicates that a guest tried to add an identity that has already been added and confirmed on their account. */
export type GuestIdentityAlreadyExistsForCurrentGuestError = Error & {
  __typename?: 'GuestIdentityAlreadyExistsForCurrentGuestError';
  message: Scalars['String']['output'];
};

/** The uniquely identifying piece of information the guest will use to authenticate themselves. Once verified, this phone number will always only be associated with this guest and no others. Must include one piece of identification. In the future, "email" will also be supported. */
export type GuestIdentityInput = {
  /** The phone number that will be used to authenticate the guest. Must be in the format of [E.164](https://en.wikipedia.org/wiki/E.164), such as `"+12223334444"`. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GuestImageReview = {
  __typename?: 'GuestImageReview';
  id: Scalars['ID']['output'];
  /** The URLs from which the image can be fetched. These URLs are imgproxy URLs. */
  imageSet: ImageSet;
};

export type GuestImageReviewInput = {
  imageFormat: ImageFormat;
};

export type GuestImageReviewUpload = {
  __typename?: 'GuestImageReviewUpload';
  /** The unique identifier of the corresponding `GuestImageReview`, same as its `GuestImageReview.id`. */
  imageReviewId: Scalars['ID']['output'];
  /** The form parameters to be submitted when uploading the image to `uploadUrl`. */
  uploadFormParameters: Array<GuestImageReviewUploadFormParameter>;
  /** The headers to be submitted when uploading the image to `uploadUrl`. */
  uploadHeaders: Array<GuestImageReviewUploadHeader>;
  /** The URL to which an image can be uploaded. Valid for 5 minutes. Maximum 30 MB for the image. */
  uploadUrl: Scalars['String']['output'];
};

export type GuestImageReviewUploadFormParameter = {
  __typename?: 'GuestImageReviewUploadFormParameter';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GuestImageReviewUploadHeader = {
  __typename?: 'GuestImageReviewUploadHeader';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GuestInput = {
  /** Guest's email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Guest's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Guest's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Guest's phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum GuestListVisibility {
  OnlyMe = 'ONLY_ME',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type GuestLoyaltyAccount = {
  __typename?: 'GuestLoyaltyAccount';
  /** Unique identifier for the loyalty account. */
  id: Scalars['ID']['output'];
  /** Identifies the restaurant with which this loyalty account is associated */
  restaurantGuid: Scalars['ID']['output'];
};

export type GuestMediaPresignedUrl = {
  __typename?: 'GuestMediaPresignedUrl';
  url: Scalars['String']['output'];
};

export type GuestMediaUploadFormField = {
  __typename?: 'GuestMediaUploadFormField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GuestNotificationHubItem = {
  id: Scalars['ID']['output'];
  notificationRoutes?: Maybe<NotificationHubRoutes>;
  notificationText: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type GuestNotificationHubItemPage = {
  __typename?: 'GuestNotificationHubItemPage';
  currentPageToken?: Maybe<Scalars['String']['output']>;
  items: Array<GuestNotificationHubItem>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** Review prompt details and existing review data. */
export type GuestOrderReviewPrompt = {
  __typename?: 'GuestOrderReviewPrompt';
  /** See [GuestReview]. Experience review of the order. */
  experienceReview: GuestReview;
  /** See [GuestTextReview]. The text review of the guest's order experience. Null if the guest has not submitted a text review for order experience. */
  experienceTextReview?: Maybe<GuestTextReview>;
  /** See [GuestImageReview]. Sorted by the order the image reviews are uploaded; for additional detail, see [submitGuestToastOrderImageReviews]. */
  imageReviews: Array<GuestImageReview>;
  /** See [GuestOrderReviewPromptMenuItem]. List of menu items to review sorted by most to least expensive. */
  menuItems: Array<GuestOrderReviewPromptMenuItem>;
  /** The place associated with the review. Nullable to accommodate the inability to resolve due to crossing network boundary. */
  place?: Maybe<Place>;
};

/** Input required to fetch a guest's order review prompt. */
export type GuestOrderReviewPromptInput = {
  /** ID of guest's check on the order being reviewed. */
  checkGuid: Scalars['ID']['input'];
  /** ID of order being reviewed. */
  orderGuid: Scalars['ID']['input'];
  /** ID of place being reviewed. */
  placeId: Scalars['ID']['input'];
};

/** Data about the menu item to review and review details if they exist. */
export type GuestOrderReviewPromptMenuItem = {
  __typename?: 'GuestOrderReviewPromptMenuItem';
  /** The URLs by size of the image of the menu item at the time the order was placed. Null if the menu item does not have an image. */
  image?: Maybe<ImageSet>;
  /** ID of group to which the menu item belongs. */
  menuItemGroupId: Scalars['ID']['output'];
  /** ID of menu item being reviewed. */
  menuItemId: Scalars['ID']['output'];
  /** Name of the menu item to review. */
  name: Scalars['String']['output'];
  /** See [GuestReview]. Review of this menu item. */
  review: GuestReview;
  /** Unique identifier of the selection being reviewed. */
  selectionGuid?: Maybe<Scalars['ID']['output']>;
};

export type GuestOrderReviewPromptResult = GuestOrderReviewPrompt | UnexpectedError;

export type GuestPasscode = {
  __typename?: 'GuestPasscode';
  expiredAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type GuestPasscodeMutation = {
  __typename?: 'GuestPasscodeMutation';
  create: CreateGuestPasscodeResponse;
};

/** A saved payment card for a guest. */
export type GuestPaymentCard = {
  __typename?: 'GuestPaymentCard';
  /** The card fingerprint attached to this payment card. Will be null if card has not been fingerprinted. */
  cardFingerprint?: Maybe<GuestCardFingerprint>;
  /** See **PaymentCardType**. */
  cardType: PaymentCardType;
  /** Two digit expiration month. */
  expirationMonth: Scalars['String']['output'];
  /** Two digit expiration year. */
  expirationYear: Scalars['String']['output'];
  /** Uniquely identifies a guest's payment card. */
  id: Scalars['ID']['output'];
  /** Indicates whether the card is expired at the time this field is queried. */
  isExpired: Scalars['Boolean']['output'];
  /** Indicates whether the card is the primary card and should be selected by default for the guest. */
  isPrimary: Scalars['Boolean']['output'];
  /** Last four digits of the card number. */
  panLast4: Scalars['String']['output'];
  /** The payment method ID of the card in the customer-vault, if we have it. Cards synced from customer-vault from mid-September 2024 should have this value. */
  paymentMethodId?: Maybe<Scalars['ID']['output']>;
};

/** Indicates that the guest's payment card intended to be operated on cannot be found. Returns the existing payment cards that belong to the guest so the client should update the list of the guest's payment cards. */
export type GuestPaymentCardNotFoundError = Error & {
  __typename?: 'GuestPaymentCardNotFoundError';
  /** Payment cards that are found in the guest's profile. Follows the same constraints as `Guest.paymentCards`. */
  existingPaymentCards: Array<GuestPaymentCard>;
  message: Scalars['String']['output'];
};

/** A post created by a guest, such as an order placed by the guest with Toast. */
export type GuestPost = {
  __typename?: 'GuestPost';
  /** The author of the post. Nullable to accommodate the inability to resolve due to crossing network boundary. */
  author?: Maybe<SocialUser>;
  /** Total number of comments on a post. Comments which are anonymized (from users that are banned, deleted, or opted out) are included in the count. Comments that are deleted (from user or moderator action) are not included in the count. */
  commentCount: Scalars['Int']['output'];
  /** Comments for the post returned in reverse chronological order of their created date. */
  comments: GuestCommentsPage;
  content: GuestPostContent;
  id: Scalars['ID']['output'];
  /** The reaction of the authenticated social user on the post. Null means either the authenticated social user did not react to the post or this field was unable to resolve due to crossing network boundary. */
  myReaction?: Maybe<GuestPostReaction>;
  /** The aggregate data of each reaction type on the post. Each reaction type is represented by a single `GuestPostReaction` item in this list. Nullable to accommodate the inability to resolve due to crossing network boundary. */
  reactionAggregates?: Maybe<Array<GuestPostReactionAggregate>>;
  visibility: GuestPostVisibility;
};


/** A post created by a guest, such as an order placed by the guest with Toast. */
export type GuestPostCommentsArgs = {
  input?: InputMaybe<PageInput>;
};

/** The content of a `GuestPost`. */
export type GuestPostContent = {
  /** The place associated with the post. Nullable to accommodate the inability to resolve due to crossing network boundary. */
  place?: Maybe<Place>;
};

export type GuestPostInput = {
  postId: Scalars['ID']['input'];
};

export type GuestPostPage = {
  __typename?: 'GuestPostPage';
  currentPageToken?: Maybe<Scalars['String']['output']>;
  items: Array<GuestPost>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** A single reaction from a `SocialUser` on a `GuestPost`. */
export type GuestPostReaction = {
  __typename?: 'GuestPostReaction';
  reactionType: GuestPostReactionType;
  /** The social user that reacted to the post. Nullable to accommodate the inability to resolve due to crossing network boundary. */
  socialUser?: Maybe<SocialUser>;
};

/** The aggregate data of a particular reaction type on a `GuestPost`. */
export type GuestPostReactionAggregate = {
  __typename?: 'GuestPostReactionAggregate';
  /** The number of reactions of `type`. */
  count: Scalars['Int']['output'];
  type: GuestPostReactionType;
};

export type GuestPostReactionPage = {
  __typename?: 'GuestPostReactionPage';
  currentPageToken?: Maybe<Scalars['String']['output']>;
  items: Array<GuestPostReaction>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export enum GuestPostReactionType {
  Toast = 'TOAST'
}

export type GuestPostReportReason = {
  __typename?: 'GuestPostReportReason';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type GuestPostReportReasonInput = {
  id: Scalars['ID']['input'];
};

export type GuestPostReportReasonsResult = {
  __typename?: 'GuestPostReportReasonsResult';
  reasons: Array<GuestPostReportReason>;
};

export enum GuestPostVisibility {
  AuthorOnly = 'AUTHOR_ONLY',
  Everyone = 'EVERYONE',
  FollowersOnly = 'FOLLOWERS_ONLY'
}

export type GuestProfileMedia = {
  __typename?: 'GuestProfileMedia';
  croppedProfilePhoto?: Maybe<GuestProfilePhoto>;
};

export type GuestProfilePhoto = {
  __typename?: 'GuestProfilePhoto';
  urls: ImageSet;
};

export type GuestProfilePhotoSuccess = {
  __typename?: 'GuestProfilePhotoSuccess';
  profilePhotoId: Scalars['ID']['output'];
  /** The form parameters to be submitted when uploading the image to `uploadUrl`. */
  uploadFormParameters: Array<GuestProfilePhotoUploadFormParameter>;
  /** The headers to be submitted when uploading the image to `uploadUrl`. */
  uploadHeaders: Array<GuestProfilePhotoUploadHeader>;
  /** The URL to which an image can be uploaded. Valid for 5 minutes. Maximum 30 MB for the image. */
  uploadUrl: Scalars['String']['output'];
};

export type GuestProfilePhotoUploadFormParameter = {
  __typename?: 'GuestProfilePhotoUploadFormParameter';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GuestProfilePhotoUploadHeader = {
  __typename?: 'GuestProfilePhotoUploadHeader';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Indicates how much profile information is missing from the `Guest` that you may want to collect, even if they already have a valid account. */
export type GuestProfileProgress = {
  __typename?: 'GuestProfileProgress';
  /** Returns the fields that should be collected and can be submitted on `GuestProfileCompletionInput` (or, in the future, update contact). Will be empty if all contact data has already been provided. In the future, the fields returned here may expand based on our guest profile goals; you should ensure your app is resilient to new fields appearing here, even if you won't be collecting these fields. It is up to your product to determine what fields it should collect, though as a baseline we almost always want to capture PHONE, EMAIL, FIRST_NAME, LAST_NAME. Currently, PHONE will always be already filled out on a guest that used a phone identity to authenticate. However, we plan to support accounts that use email identities instead, so you should prepare for the possibility of capturing a phone number from the guest. */
  incompleteContactFields: Array<GuestContactField>;
};

/** The rating of a reviewable entity. */
export type GuestRating = {
  __typename?: 'GuestRating';
  id: Scalars['ID']['output'];
  /** Rating for the visit. */
  rating: Scalars['Int']['output'];
  /** See [RatingSystem]. */
  ratingSystem: RatingSystem;
};

/** Input type for a rating. */
export type GuestRatingInput = {
  /** Rating for the visit based on RatingSystem. */
  rating: Scalars['Int']['input'];
  /** See [RatingSystem]. */
  ratingSystem: RatingSystem;
};

export type GuestRestaurantsSummaryDataResult = GuestRestaurantsSummaryDataSuccess | UnexpectedError;

export type GuestRestaurantsSummaryDataSuccess = {
  __typename?: 'GuestRestaurantsSummaryDataSuccess';
  /** The total number of orders a guest has placed across all restaurants. */
  totalOrderCount: Scalars['Int']['output'];
  /** The list of restaurants visited by the guest, ordered by frequency (most frequent at the front of the list) and then by recency. */
  visitedRestaurants: Array<GuestVisitedRestaurant>;
};

/** Specifies all facets of a review for a reviewable entity. */
export type GuestReview = {
  __typename?: 'GuestReview';
  /** See [GuestRating]. */
  rating?: Maybe<GuestRating>;
  /** Optional field to specify IDs used to identify the reviewable entity. For example, menu item ID and menu group ID to identify a menu item review. See [ReviewableEntityIdentifier]. */
  reviewableEntityIdentifiers?: Maybe<Array<ReviewableEntityIdentifier>>;
  /** Describes the type of review. See [GuestReviewType]. */
  type: GuestReviewType;
};

export enum GuestReviewType {
  OrderExperience = 'ORDER_EXPERIENCE'
}

export type GuestSavedList = {
  __typename?: 'GuestSavedList';
  id: Scalars['ID']['output'];
  itemCount: Scalars['Int']['output'];
  items: Array<GuestSavedListItem>;
  listType: GuestSavedListType;
  name: Scalars['String']['output'];
  visibility: GuestListVisibility;
};

export type GuestSavedListItem = {
  id: Scalars['ID']['output'];
  itemType: GuestSavedListItemType;
  rank: Scalars['Int']['output'];
};

export type GuestSavedListItemInput = {
  referencedItemId: Scalars['ID']['input'];
  referencedItemType: GuestSavedListItemType;
};

export enum GuestSavedListItemType {
  Place = 'PLACE'
}

export enum GuestSavedListType {
  Favorites = 'FAVORITES',
  Wishlist = 'WISHLIST'
}

export type GuestTextReview = {
  __typename?: 'GuestTextReview';
  id: Scalars['ID']['output'];
  /** For a valid text review, the minimum number of characters is 1. An empty string is the result of a successful delete text review `submitGuestToastOrderTextReview` mutation. Maximum number of characters is 5000. */
  reviewText: Scalars['String']['output'];
};

/** Represents a restaurant visited by the guest and the number of visits. */
export type GuestVisitedRestaurant = {
  __typename?: 'GuestVisitedRestaurant';
  /** The number of visits to the restaurant. */
  orderCount: Scalars['Int']['output'];
  /** The restaurant visited by the guest. */
  restaurant?: Maybe<Restaurant>;
};

/** Contains methods that the guest can use to pay, such as Toast-specific currency account and saved cards. */
export type GuestWallet = {
  __typename?: 'GuestWallet';
  /** Fetches the cardFingerprints saved in the guest's profile */
  cardFingerprints: Array<GuestCardFingerprint>;
  /** The aforementioned id of the customer in customer-vault. Identifies fintech's domain representation of a guest. */
  customerVaultId?: Maybe<Scalars['ID']['output']>;
  /** The guest's Toast-specific currency account, which holds currency that is only spendable on various Toast products, such as Toast App. */
  guestCurrencyAccount: GuestCurrencyAccount;
  /** Unique identifier for the `GuestWallet`. Currently, this is always set to `Guest.id`, which is verified to match the ID from the guest JWT. In the future, this ideally would be the ID generated by the customer vault service as part of the [Simplified Payments Integration](https://toasttab.atlassian.net/wiki/spaces/FIN/pages/3418852975/Simplified+Payments+Integration). But for now, the customer id is represented in the customerVaultId field below for convenience. */
  id: Scalars['ID']['output'];
  /** Fetches the payment cards saved in the guest's profile. The card most recently marked as primary via `updatePrimaryGuestPaymentCard` will be the first in the list. Other cards are returned in the order of the most recently saved first. The first card will always have `isPrimary` set to true, and the other cards will always have `isPrimary` set to false. */
  paymentCards: Array<GuestPaymentCard>;
};

export type GuidShortUrlRestaurantSearchInput = {
  /** A set of guids by which to search. Either this field or the shortURL field must be populated. */
  guids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The number of requested results Cannot exceed the maximum which is 200 */
  limit: Scalars['Int']['input'];
  /** If requesting the upcoming online ordering schedule, the number of days for which the schedule should be retrieved. This field has a maximum value of 30. */
  scheduleDayCount?: InputMaybe<Scalars['Int']['input']>;
  /** If requesting the upcoming online ordering schedule, the date on which the schedule should start */
  scheduleStartDate?: InputMaybe<Scalars['String']['input']>;
  /** A short URL by which to search. Either this field or the guids field must be populated. */
  shortURL?: InputMaybe<Scalars['String']['input']>;
};

/** Placeholder for a comment which does not contain content or author information. Used for comments that have been soft-deleted or archived but still need to be referenced. */
export type HiddenGuestComment = GuestComment & {
  __typename?: 'HiddenGuestComment';
  id: Scalars['ID']['output'];
};

export type I18n = {
  __typename?: 'I18n';
  /** Restaurant's location / country. */
  country?: Maybe<Scalars['String']['output']>;
  /** A restaurants operating currency USD, EUR, GBP & CAD */
  currency: Scalars['String']['output'];
  /** A restaurants operating locale. e.g. 'en-US', 'en-IE', 'fr-CH' */
  locale: Scalars['String']['output'];
};

export type IosVersionInput = {
  cfBundleShortVersionString: Scalars['String']['input'];
  cfBundleVersion: Scalars['Int']['input'];
};

/** The type of identity to add to the guest. */
export enum IdentityType {
  Email = 'EMAIL'
}

export enum ImageFormat {
  Bmp = 'BMP',
  Gif = 'GIF',
  Heif = 'HEIF',
  Jpeg = 'JPEG',
  Png = 'PNG',
  Svg = 'SVG',
  Tiff = 'TIFF',
  Webp = 'WEBP'
}

/** Contains a mapping of size to image paths. The sizes other than **raw** are resized from the original image, which is represented by **raw**. Resizing is done by the toast-image-lambda Lambda function and is cached on CloudFront. For details, refer to the [toast-image-lambda documentation](https://github.com/toasttab/system-docs/blob/master/consumer/image-processing/cached-resizing/Readme.md). */
export type ImageSet = {
  __typename?: 'ImageSet';
  /** 1080p */
  large: Scalars['String']['output'];
  /** 720p */
  medium: Scalars['String']['output'];
  /** the raw image that has not gone through resizing */
  raw: Scalars['String']['output'];
  /** 360p */
  small: Scalars['String']['output'];
  /** 1280p */
  xl: Scalars['String']['output'];
  /** 180p */
  xs: Scalars['String']['output'];
  /** 1920p */
  xxl: Scalars['String']['output'];
};

export type ImportStatus = {
  __typename?: 'ImportStatus';
  canImport: Scalars['Boolean']['output'];
  importCount: Scalars['Int']['output'];
};

export type InAppCheckInMutation = {
  __typename?: 'InAppCheckInMutation';
  /** Associates the check and order with the in-app check-in experience after payment and processes relevant data */
  linkCheck: InAppCheckIn_LinkCheckResponse;
};


export type InAppCheckInMutationLinkCheckArgs = {
  checkId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};

export type InAppCheckInQuery = {
  __typename?: 'InAppCheckInQuery';
  /** Returns most recent open check at a table */
  checkAtTable: InAppCheckIn_GetTableCheckResponse;
  /** Returns open checks at a restaurant for the current date in local time zone */
  openChecks: InAppCheckIn_OpenChecksResponse;
  /** Returns list of tables configured at a restaurant */
  tables: InAppCheckIn_GetTablesResponse;
};


export type InAppCheckInQueryCheckAtTableArgs = {
  restaurantId: Scalars['ID']['input'];
  tableId: Scalars['ID']['input'];
};


export type InAppCheckInQueryOpenChecksArgs = {
  restaurantId: Scalars['ID']['input'];
};


export type InAppCheckInQueryTablesArgs = {
  restaurantId: Scalars['ID']['input'];
};

export type InAppCheckIn_Check = {
  __typename?: 'InAppCheckIn_Check';
  /** check display number */
  displayNumber: Scalars['String']['output'];
  /** check guid */
  id: Scalars['ID']['output'];
  /** order guid check is associated with */
  orderId: Scalars['ID']['output'];
  /** table check is associated with */
  table?: Maybe<InAppCheckIn_Table>;
};

export type InAppCheckIn_GetTableCheckError = {
  __typename?: 'InAppCheckIn_GetTableCheckError';
  code?: Maybe<InAppCheckIn_GetTableCheckErrorCode>;
};

export enum InAppCheckIn_GetTableCheckErrorCode {
  FailedToRetrieveCheckAtTable = 'FailedToRetrieveCheckAtTable'
}

export type InAppCheckIn_GetTableCheckResponse = InAppCheckIn_GetTableCheckError | InAppCheckIn_GetTableCheckSuccess;

export type InAppCheckIn_GetTableCheckSuccess = {
  __typename?: 'InAppCheckIn_GetTableCheckSuccess';
  check: InAppCheckIn_Check;
};

export type InAppCheckIn_GetTablesError = {
  __typename?: 'InAppCheckIn_GetTablesError';
  code?: Maybe<InAppCheckIn_GetTablesErrorCode>;
};

export enum InAppCheckIn_GetTablesErrorCode {
  FailedToRetrieveTables = 'FailedToRetrieveTables'
}

export type InAppCheckIn_GetTablesResponse = InAppCheckIn_GetTablesError | InAppCheckIn_GetTablesSuccess;

export type InAppCheckIn_GetTablesSuccess = {
  __typename?: 'InAppCheckIn_GetTablesSuccess';
  tables: Array<InAppCheckIn_Table>;
};

export type InAppCheckIn_LinkCheckError = {
  __typename?: 'InAppCheckIn_LinkCheckError';
  code: InAppCheckIn_LinkCheckErrorCode;
};

export enum InAppCheckIn_LinkCheckErrorCode {
  FailedToLinkCheck = 'FailedToLinkCheck',
  FailedToRetrieveConfig = 'FailedToRetrieveConfig'
}

export type InAppCheckIn_LinkCheckResponse = InAppCheckIn_LinkCheckError | InAppCheckIn_LinkCheckSuccess;

export type InAppCheckIn_LinkCheckSuccess = {
  __typename?: 'InAppCheckIn_LinkCheckSuccess';
  message?: Maybe<Scalars['String']['output']>;
};

export type InAppCheckIn_OpenChecksError = {
  __typename?: 'InAppCheckIn_OpenChecksError';
  code: InAppCheckIn_OpenChecksErrorCode;
};

export enum InAppCheckIn_OpenChecksErrorCode {
  FailedToRetrieveChecks = 'FailedToRetrieveChecks'
}

export type InAppCheckIn_OpenChecksResponse = InAppCheckIn_OpenChecksError | InAppCheckIn_OpenChecksSuccess;

export type InAppCheckIn_OpenChecksSuccess = {
  __typename?: 'InAppCheckIn_OpenChecksSuccess';
  checks: Array<InAppCheckIn_Check>;
};

export type InAppCheckIn_Table = {
  __typename?: 'InAppCheckIn_Table';
  guid?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** An order with at least one, but potentially more, checks which are open. */
export type InProgressOrder = {
  __typename?: 'InProgressOrder';
  /** The check requested. Only the check matching the client's requested check will be returned. Will return null if no check matches the requested number or guid. */
  check?: Maybe<InProgressOrderCheck>;
  /**
   * The check requested. Only the check matching the client's requested check will be returned. Will return null if no check matches the requested number or guid.
   * @deprecated use check
   */
  checks: Array<InProgressOrderCheck>;
  /** The discounts associated with the order. */
  discounts: Discounts;
  guid: Scalars['ID']['output'];
  /** The restaurant associated with the order. Used so that the client can know if amex is accepted. */
  restaurant: Restaurant;
};

/** An open check associated with an InProgressOrder. */
export type InProgressOrderCheck = {
  __typename?: 'InProgressOrderCheck';
  /** The total amount unpaid on the check */
  amountRemaining: Scalars['Float']['output'];
  guid: Scalars['ID']['output'];
  /** Order guid corresponding to a check */
  orderGuid: Scalars['ID']['output'];
  /** The amount, before tax and discounts, on the check */
  preDiscountSubTotal: Scalars['Float']['output'];
  /** All selections that have not been voided associated with the InProgressOrderCheck */
  selections: Array<InProgressOrderSelection>;
  /** The amount, before tax, on the check */
  subTotal: Scalars['Float']['output'];
  /** Suggested tip for a check based on restaurant tipping preferences. Null indicates failure in obtaining suggested tip values */
  suggestedTips?: Maybe<SuggestedTip>;
  /** The sum of all surcharges applied to the check, most commonly an auto gratuity or less commonly a kitchen appreciation fee. */
  surchargeAmount: Scalars['Float']['output'];
  /** The amount of tax on the check */
  taxAmount: Scalars['Float']['output'];
  /** The total amount associated with the check */
  totalAmount: Scalars['Float']['output'];
};

/** Fetch an order with at least one open check. The order can be identified by its table name. */
export type InProgressOrderForTableInput = {
  /** The guid of the restaurant which has the order being paid for */
  restaurantGuid: Scalars['ID']['input'];
  /** Table name at which to search for an order */
  tableName: Scalars['String']['input'];
};

/** Fetch an order with at least one open check. The order can be identified by the number of a check it contains, or by the table name the order is located at. */
export type InProgressOrderInput = {
  /** The guid of the check to be paid for */
  checkGuid?: InputMaybe<Scalars['String']['input']>;
  /** If orderGuid is present, checkGuid must also be sent. This is more consistent and speeds up the search by using the indexed orders APIs instead of getting a bulk list. This also solves the missed checks after midnight and only being able to query for a check within the past calendar day. */
  orderGuid?: InputMaybe<Scalars['String']['input']>;
  /** The guid of the restaurant which has the order being paid for */
  restaurantGuid: Scalars['ID']['input'];
  /** Removing support. Will return an error if requested. Please only use checkguid */
  tableName?: InputMaybe<Scalars['String']['input']>;
};

/** A selection associated with an InProgressOrderCheck. */
export type InProgressOrderSelection = {
  __typename?: 'InProgressOrderSelection';
  /** The name of the selection */
  name: Scalars['String']['output'];
  /** The price before tax and discounts, for the selection */
  preDiscountPrice: Scalars['Float']['output'];
  /** The net price, after tax and discounts, for the selection */
  price: Scalars['Float']['output'];
  /**
   * The number of selections this object represents
   * @deprecated Quantity Fraction
   */
  quantity: Scalars['Int']['output'];
  /** The number of selections this object represents, as a float. */
  quantityFraction: Scalars['Float']['output'];
};

/** Indicates that the guest entered the incorrect OTP. This error message should be surfaced to the guest. */
export type IncorrectCodeError = Error & {
  __typename?: 'IncorrectCodeError';
  message: Scalars['String']['output'];
};

export type InfluencersByLocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type InfluencersByLocationResult = InfluencersByLocationSuccess | UnexpectedError;

export type InfluencersByLocationSuccess = {
  __typename?: 'InfluencersByLocationSuccess';
  influencers: Array<SocialUser>;
};

/** Indicates that although the intended result of a query or mutation was achieved, there are side effects that occurred that wouldn't affect downstream actions. */
export type Info = {
  message: Scalars['String']['output'];
};

/** Input of the initiateCardLinkingByPaymentMethodId mutation. */
export type InitiateCardLinkingByPaymentMethodIdInput = {
  /** Uniquely identifies the guest's payment method that will be linked. This is the ID of the payment method provided by SPI. */
  paymentMethodId: Scalars['String']['input'];
};

/** The possible responses of the initiateCardLinkingByPaymentMethodId mutation. */
export type InitiateCardLinkingByPaymentMethodIdResponse = InitiateCardLinkingByPaymentMethodIdSuccess | UnexpectedError;

/** Success response of the initiateCardLinkingByPaymentMethodId mutation. */
export type InitiateCardLinkingByPaymentMethodIdSuccess = {
  __typename?: 'InitiateCardLinkingByPaymentMethodIdSuccess';
  /** See **InitiateCardLinkingByPaymentMethodIdInput.paymentMethodId**'s documentation. */
  paymentMethodId: Scalars['String']['output'];
};

export type Instructions = {
  __typename?: 'Instructions';
  enabled: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

/** The provided birthday did not meet the [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format guidelines. */
export type InvalidBirthdayError = Error & ValidationError & {
  __typename?: 'InvalidBirthdayError';
  message: Scalars['String']['output'];
};

/** The provided email did not meet [Toast email validation](https://github.com/toasttab/toast-java-common/blob/development/src/main/java/com/toasttab/util/ValidationUtils.java#L18) requirements. */
export type InvalidEmailError = Error & ValidationError & {
  __typename?: 'InvalidEmailError';
  message: Scalars['String']['output'];
};

/** When providing a first or last name, both names must be provided and cannot be blank. */
export type InvalidNameError = Error & ValidationError & {
  __typename?: 'InvalidNameError';
  message: Scalars['String']['output'];
};

export type InvalidOffsetError = {
  __typename?: 'InvalidOffsetError';
  code?: Maybe<GeneralErrorCode>;
  invalidOffsetValue?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** The provided phone did not meet [E.164](https://en.wikipedia.org/wiki/E.164) format guidelines. */
export type InvalidPhoneFormatError = Error & ValidationError & {
  __typename?: 'InvalidPhoneFormatError';
  message: Scalars['String']['output'];
};

export type InvalidRequestError = Error & {
  __typename?: 'InvalidRequestError';
  message: Scalars['String']['output'];
};

/** When a user tries to accept a follow request from someone who did not request to follow them, this error is returned. */
export type InvalidSocialAcceptFollowRequestError = Error & {
  __typename?: 'InvalidSocialAcceptFollowRequestError';
  message: Scalars['String']['output'];
};

export type ItemDetailOfferBadge = {
  __typename?: 'ItemDetailOfferBadge';
  bannerGuid: Scalars['String']['output'];
  bannerText: Scalars['String']['output'];
  /** The menu item guid that should show this badge */
  itemGuid: Scalars['String']['output'];
  promoCode: Scalars['String']['output'];
};

export type ItemDetailOfferBadgeInput = {
  /** The guid of the item which we are requesting offers for */
  itemGuid: Scalars['ID']['input'];
  /** The guid of the restaurant */
  restaurantGuid: Scalars['ID']['input'];
};

export type ItemDetailOfferBadgeResponse = {
  __typename?: 'ItemDetailOfferBadgeResponse';
  itemOfferBadges: Array<ItemDetailOfferBadge>;
};

export type ItemDetailOfferBadgeResponseOrError = GeneralError | ItemDetailOfferBadgeResponse;

export type ItemFeedbackConfig = {
  __typename?: 'ItemFeedbackConfig';
  itemFeedbackEnabled: Scalars['Boolean']['output'];
};

export type ItemFeedbackConfigError = {
  __typename?: 'ItemFeedbackConfigError';
  code: ItemFeedbackConfigErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ItemFeedbackConfigErrorCode {
  ConfigNotFound = 'ConfigNotFound',
  FailedToRetrieveConfig = 'FailedToRetrieveConfig',
  ManagementSetGuidNotFound = 'ManagementSetGuidNotFound'
}

export type ItemFeedbackConfigResponse = ItemFeedbackConfig | ItemFeedbackConfigError;

export type ItemOrderHistoryInput = {
  /** @deprecated This property will no longer be used to determine whether to show null orders. Instead a check for all default expectedOrderSources is used. */
  allowNullOrderSource?: InputMaybe<Scalars['Boolean']['input']>;
  /** This property will default to show only off-prem orders. Starting Oct 2023 only orders made on MOP and MP have an orderSource connected to the guest-profiles saved order. All earlier orders and orders from other platforms will have a null orderSource. If a client wants to receive null orderSources all four of these default orderSources must be listed as expectedOrderSources ONLINE, CONSUMER_APP, LOCAL, BOO. */
  expectedOrderSources?: InputMaybe<Array<InputMaybe<OrderSource>>>;
  /** Menus information to query to get the item from. */
  menusInput: MenusInput;
  /** Index to start getting orders from */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Count of how many orders to query for items */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Identifier for which page of orders to return items of */
  pageToken?: InputMaybe<Scalars['String']['input']>;
  /** Guid of the restaurant */
  restaurantGuid: Scalars['ID']['input'];
  /** This property will default to show only orders from the expectedOrderSources. If this property is true it will show all orders from all orderSources. */
  showAllOrdersFromAllSources?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemOrderHistoryResponse = {
  __typename?: 'ItemOrderHistoryResponse';
  /** Page token used to retrieve the current page of orders when querying guest profiles. Passing this value through as the pageToken in subsequent requests will result in the same orders being retrieved. */
  currentPageToken?: Maybe<Scalars['String']['output']>;
  /** The guest's last ordered items sorted via openedDate newest -> oldest */
  items: Array<MenuItem>;
  /** Page token used to retrieve the next page of orders when querying guest profiles When this field is null that indicates that [currentPageToken] was the last page in the result set. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
  /** Offset used to get orders from a specific point when querying customer mgmt. */
  offset?: Maybe<Scalars['Int']['output']>;
};

export type ItemOrderHistoryResponseOrError = InvalidOffsetError | ItemOrderHistoryResponse | MissingCustomerOrGuestGuidError;

/** Rule defining how far in advance an item must be ordered. Unit of hours assumed for now. */
export type LeadTimeRule = {
  __typename?: 'LeadTimeRule';
  leadTime: Scalars['Float']['output'];
};

export type LineItemInput = {
  currency: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  totalPrice: Scalars['String']['input'];
  weight: Scalars['String']['input'];
  weightUnit: Scalars['String']['input'];
};

/** Input of the linkCardFingerprintByPaymentMethodId mutation. */
export type LinkCardFingerprintByPaymentMethodIdInput = {
  /** Uniquely identifies the guest's payment method of which the card fingerprint will be linked. This is the ID of the payment method provided by SPI. */
  paymentMethodId: Scalars['String']['input'];
};

/** The possible responses of the linkCardFingerprintByPaymentMethodId mutation. */
export type LinkCardFingerprintByPaymentMethodIdResponse = LinkCardFingerprintByPaymentMethodIdSuccess | UnexpectedError;

/** Success response of the linkCardFingerprintByPaymentMethodId mutation. */
export type LinkCardFingerprintByPaymentMethodIdSuccess = {
  __typename?: 'LinkCardFingerprintByPaymentMethodIdSuccess';
  /** The linked card fingerprint. */
  cardFingerprint: GuestCardFingerprint;
};

/** Input of the linkCardFingerprint mutation. */
export type LinkCardFingerprintInput = {
  /** Uniquely identifies the guest's card fingerprint that will be linked. */
  cardFingerprintId: Scalars['String']['input'];
};

/** The possible responses of the linkCardFingerprint mutation. */
export type LinkCardFingerprintResponse = LinkCardFingerprintSuccess | UnexpectedError;

/** Success response of the linkCardFingerprint mutation. */
export type LinkCardFingerprintSuccess = {
  __typename?: 'LinkCardFingerprintSuccess';
  /** The card fingerprint that has been successfully linked. */
  cardFingerprint: GuestCardFingerprint;
};

export type ListSizeExceededError = Error & {
  __typename?: 'ListSizeExceededError';
  message: Scalars['String']['output'];
};

export type LocalPostFeedInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  pageInput?: InputMaybe<PageInput>;
};

export type Location = {
  __typename?: 'Location';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  distanceFromCustomer?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  phone: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type LocationTargeting = BaseOfferTargeting & {
  __typename?: 'LocationTargeting';
  locations: Array<TargetedLocation>;
  type: Scalars['String']['output'];
};

export type LoyaltyAccountCreationInput = {
  /** Guid of the check from the placed order. Used to accrue points for that order despite the account being created afterwards. */
  checkIdentifier: Scalars['ID']['input'];
  /** Guid of the restaurant that a loyalty account is being created at */
  restaurantGuid: Scalars['ID']['input'];
  /** Guid generated by the front-end client that is constant per session (i.e. retries use the same guid). */
  transactionGuid: Scalars['ID']['input'];
};

export enum LoyaltyAccrualType {
  CheckTotal = 'CHECK_TOTAL',
  Visit = 'VISIT'
}

export type LoyaltyBanner = PromoBannerBase & {
  __typename?: 'LoyaltyBanner';
  /** The time constraints on a loyalty offer Example: a double points offer available Mon-Fri between 4-6PM */
  availability?: Maybe<PromoBannerAvailability>;
  /** The GUID of the banner */
  bannerGuid: Scalars['String']['output'];
  /** The banner text */
  bannerText: Scalars['String']['output'];
  /** The points multiplier, if applicable. */
  multiplier?: Maybe<Scalars['Int']['output']>;
  /** The banner subtitle */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The loyalty banner type */
  type: Scalars['String']['output'];
};

export type LoyaltyConfig = {
  __typename?: 'LoyaltyConfig';
  /** The rate at which points are accrued for loyalty. Example: 2.0 means "1 point is earned for every 2 dollars" */
  accrualRate?: Maybe<Scalars['Float']['output']>;
  /** The number of points that a diner needs to reach before they are allowed to redeem */
  accrualTarget?: Maybe<Scalars['Int']['output']>;
  /** The amount each point is worth. Example: 0.2 means "0.2 dollars for every point" */
  conversionRate?: Maybe<Scalars['Float']['output']>;
  /** The custom description text, in case the loyalty program uses one. Will be null if the restaurant does not have loyalty program. */
  customDescription?: Maybe<Scalars['String']['output']>;
  /** Number of points needed to redeem an item based reward */
  itemPointsToRedeem?: Maybe<Scalars['Int']['output']>;
  /** Name of the item based reward */
  itemRewardName?: Maybe<Scalars['String']['output']>;
  /** Whether loyalty redemptions are enabled at this restaurant or not. Will be false if the restaurant does not have loyalty program. */
  loyaltyRedemptionEnabled: Scalars['Boolean']['output'];
  /** The one time point bonus for creating a new loyalty account */
  loyaltySignupBonus?: Maybe<Scalars['Int']['output']>;
  /** Whether loyalty signups are enabled at this restaurant or not. Will be false if the restaurant does not have a loyalty program. */
  loyaltySignupEnabled: Scalars['Boolean']['output'];
  /** The loyalty program name. Will be null if the restaurant does not have loyalty program. Clients usually display "{Restaurant Name} Rewards Program" as a fallback. */
  programName?: Maybe<Scalars['String']['output']>;
  /** The loyalty program type. Will be either "CASHBACK" or "ITEM". Defaulted to "CASHBACK" */
  rewardType?: Maybe<RewardRedemptionType>;
  /** The signup method. It can be "EMAIL" or "PHONE_NUMBER". Will be null if the restaurant does not have loyalty program. */
  signupMethod?: Maybe<Scalars['String']['output']>;
  /** Whether loyalty program uses a custom description or not. Will be false if the restaurant does not have loyalty program. */
  useCustomDescription: Scalars['Boolean']['output'];
};

export type LoyaltyDetails = {
  __typename?: 'LoyaltyDetails';
  referenceId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

/** An object representing a (restaurant-specific) loyalty redemption, which is tied to a guest/loyalty account */
export type LoyaltyDiscount = {
  __typename?: 'LoyaltyDiscount';
  amount: Scalars['Float']['output'];
  expirations?: Maybe<Array<Maybe<LoyaltyExpiration>>>;
  guid: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  type: LoyaltyRedemptionType;
};

export enum LoyaltyErrorCode {
  /** If the diner does not have a loyalty account. */
  NoLoyaltyAccount = 'NO_LOYALTY_ACCOUNT',
  /** If the restaurant does not have loyalty enabled. */
  RestaurantLoyaltyNotEnabled = 'RESTAURANT_LOYALTY_NOT_ENABLED'
}

export type LoyaltyExpiration = {
  __typename?: 'LoyaltyExpiration';
  /** Eopch milliseconds string date that the reward will expire. */
  date?: Maybe<Scalars['String']['output']>;
  /** Number of rewards that will expire at the date that is associated in each respective object. */
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type LoyaltyFeatures = {
  __typename?: 'LoyaltyFeatures';
  /** The description of the reward */
  description?: Maybe<Scalars['String']['output']>;
  /** The display message of the reward */
  message?: Maybe<Scalars['String']['output']>;
  /** The tag designating where and how this reward/feature is applicable in the program Example: REWARD,ACCRUAL,CASHBACK,BALANCE,ONE_OFF,SIGNUP,etc. */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LoyaltyFeaturesInput = {
  /** The locale the feature messages should be returned in */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** The guid of the restaurant with the loyalty program */
  restaurantGuid: Scalars['ID']['input'];
};

export type LoyaltyFeaturesResponse = {
  __typename?: 'LoyaltyFeaturesResponse';
  /** List of rewards that can be earned in the program */
  features: Array<Maybe<LoyaltyFeatures>>;
  /** The general description of the loyalty program */
  programDescription: Scalars['String']['output'];
};

export type LoyaltyInquiryInput = {
  cartGuid: Scalars['ID']['input'];
};

/** Only will be present if a loyalty account was successfully found with the email in the diner's guest account (also will be null if the diner is unauthenticated). Will trigger a loyalty inquiry from the Online Ordering API, which in rare cases may cause the cart to change (i.e. the customer guid has changed after applying the redemption so the redemption is removed) */
export type LoyaltyInquiryResponse = {
  __typename?: 'LoyaltyInquiryResponse';
  /** Configuration messages and parameters that can be useful for the client app. For example, program description. 1st party only. */
  config?: Maybe<ConfigData>;
  /** Loyalty account balance information and messages. Client applications are supposed to use these messages when implementing UIs rather than building them by themselves to ensure consistency and correctness (e.g. points vs. visits) 1st party only. */
  currentState?: Maybe<BalanceStateData>;
  /** List of objects with the quantity of rewards that will expire at the associated date. Date should be in epoch milliseconds string format. */
  expirations?: Maybe<Array<Maybe<LoyaltyExpiration>>>;
  /** **The Masked** Identifier for the customer's loyalty account (the equivalent of guestGuid for guest-profiles accounts, but for the loyalty account) Will be null if no loyalty account was found for the customer. ex: An identifier of 12345678 might have a masked identifier of 345678 */
  loyaltyAccountIdentifier?: Maybe<Scalars['ID']['output']>;
  /**
   * The number of loyalty points the user has at this restaurant.
   * @deprecated use currentState.balance
   */
  pointsBalance: Scalars['Int']['output'];
  /** Available redemptions for this cart/customer. Will only have redemptions that can be applied to the current cart and with a value dependent on the customer's earned loyalty points. */
  redemptions: Array<LoyaltyRedemption>;
  /** A hashed, secure token that can be used to access the card data for a loyalty account. */
  secureToken?: Maybe<Scalars['String']['output']>;
  /** Identifier for the customer's loyalty account (the equivalent of guestGuid for guest-profiles accounts, but for the loyalty account) Will be null if no loyalty account was found for the customer. */
  unmaskedLoyaltyAccountIdentifier?: Maybe<Scalars['String']['output']>;
};

export type LoyaltyInquiryResponseOrError = CartOutOfStockError | CustomerLoyaltyError | LoyaltyInquiryResponse;

export type LoyaltyRedemption = {
  __typename?: 'LoyaltyRedemption';
  /** Indicate if the reward is currently redeemable */
  available?: Maybe<Scalars['Boolean']['output']>;
  /** The reward state based on the current order. If the order hasn't been started shows the state of all rewards as if they haven't been redeemed. If the order has been started and includes any loyalty discounts - has the updated state showing those rewards non-redeemable and the messages updated. Most of the data is specified for 1st party only. */
  currentState?: Maybe<RewardStateData>;
  /** 3rd party item-based discounts need this to pass on the guid */
  discount?: Maybe<DiscountDetails>;
  /** List of objects with the quantity of rewards that will expire at the associated date. Date should be in epoch milliseconds string format. */
  expirations?: Maybe<Array<Maybe<LoyaltyExpiration>>>;
  /** 3rd Party has a name */
  name?: Maybe<Scalars['String']['output']>;
  /** Maximum redemption amount (may be greater than the total value of the cart, in which case only the cart's value is deducted) */
  redemptionAmount: Scalars['Float']['output'];
  /** Identifier for this redemption discount, for attaching to the cart if the user chooses. */
  redemptionGuid: Scalars['ID']['output'];
  /** For 1st party this is the same string as type. For 3rd party type will === LoyaltyRedemptionType.INTEGRATION and this will be the id to use for applying or removing a discount. */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** 1st party uses quantity to populate redemptionAmount but 3rd party uses quantity to denote how many times a reward may be used. Disambiguate by renaming to rewardQuantity and only populating for 3rd party loyalty rewards. */
  rewardQuantity?: Maybe<Scalars['Int']['output']>;
  /** Type of the redeemed reward. Null for 3rd party */
  rewardType?: Maybe<RewardTypeData>;
  /** Target (points or visits, depending on configuration) that should be reached by the guest to avail for reward redeem. Can be null for rewards that are triggered differently (for example, a birthday reward can be redeemed at specific dates). 1st party only. */
  target?: Maybe<Scalars['Int']['output']>;
  /** Type of this redemption discount, for displaying reward as birthday or cash. */
  type: LoyaltyRedemptionType;
};

/** The guid refers to the guid the reward applies to. For check level rewards this is the same GUID. To disambiguate for first party type is used. For third party we use referenceId and set the type to INTEGRATION. */
export type LoyaltyRedemptionInput = {
  guid: Scalars['ID']['input'];
  /** If set prefer this over type for adding and removing a reward. */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  type: LoyaltyRedemptionType;
};

export enum LoyaltyRedemptionType {
  BirthdayRewards = 'BIRTHDAY_REWARDS',
  /** 3rd party integration reward */
  Integration = 'INTEGRATION',
  ItemRewards = 'ITEM_REWARDS',
  LoyaltyDollarsAmounts = 'LOYALTY_DOLLARS_AMOUNTS',
  LoyaltyPointsAmount = 'LOYALTY_POINTS_AMOUNT'
}

export type LoyaltySignupError = Error & {
  __typename?: 'LoyaltySignupError';
  code: LoyaltySignupErrorCode;
  message: Scalars['String']['output'];
};

export enum LoyaltySignupErrorCode {
  SignupFailed = 'SIGNUP_FAILED'
}

export type LoyaltySignupInput = {
  customerGuid: Scalars['ID']['input'];
  loyaltyAccountCreationInput: LoyaltyAccountCreationInput;
};

export type LoyaltySignupResponse = {
  __typename?: 'LoyaltySignupResponse';
  customer?: Maybe<Customer>;
};

export type LoyaltySignupResponseOrError = LoyaltySignupError | LoyaltySignupResponse;

export enum LoyaltySignupSource {
  /** Order and pay */
  OrderAndPay = 'ORDER_AND_PAY',
  /** Toast Takeout App */
  ToastConsumerApp = 'TOAST_CONSUMER_APP'
}

export type LoyaltySignupTransactionlessInput = {
  /** Guid of the restaurant that a loyalty account is being created at. */
  restaurantGuid: Scalars['ID']['input'];
  /** Sign-up source */
  source: LoyaltySignupSource;
};

export type MakeCreditCardPrimaryError = Error & {
  __typename?: 'MakeCreditCardPrimaryError';
  code: MakeCreditCardPrimaryErrorCode;
  message: Scalars['String']['output'];
};

export enum MakeCreditCardPrimaryErrorCode {
  CardNotFound = 'CARD_NOT_FOUND'
}

/** Guid of the desired card to be made the primary card for the account */
export type MakeCreditCardPrimaryInput = {
  cardGuid: Scalars['ID']['input'];
};

export type MakeCreditCardPrimaryResponse = {
  __typename?: 'MakeCreditCardPrimaryResponse';
  customer: Customer;
};

export type MakeCreditCardPrimaryResponseOrError = MakeCreditCardPrimaryError | MakeCreditCardPrimaryResponse;

export type MarketingAccount = {
  __typename?: 'MarketingAccount';
  currentPageToken?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<MarketingAccountData>>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
  pageSize: Scalars['Int']['output'];
  totalResultCount?: Maybe<Scalars['Int']['output']>;
};

export type MarketingAccountData = {
  __typename?: 'MarketingAccountData';
  channel: Scalars['String']['output'];
  sender?: Maybe<Scalars['String']['output']>;
  senderGuid: Scalars['ID']['output'];
  state: MarketingAccountState;
};

export enum MarketingAccountState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  InProgress = 'IN_PROGRESS'
}

export type MarketingAccountsQueryError = Error & {
  __typename?: 'MarketingAccountsQueryError';
  message: Scalars['String']['output'];
};

export type MarketingAccountsQueryInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  managementSetGuid?: InputMaybe<Scalars['ID']['input']>;
};

export type MarketingAccountsQueryResponse = MarketingAccountsQueryError | MarketingAccountsQuerySuccessResponse;

export type MarketingAccountsQuerySuccessResponse = {
  __typename?: 'MarketingAccountsQuerySuccessResponse';
  accounts: Array<Maybe<MarketingAccountData>>;
};

export type MarketingConfigQueryError = {
  __typename?: 'MarketingConfigQueryError';
  message: Scalars['String']['output'];
};

export type MarketingConfigQueryInput = {
  managementSetGuid?: InputMaybe<Scalars['ID']['input']>;
  restaurantGuid: Scalars['ID']['input'];
};

export type MarketingConfigQueryResponse = MarketingConfigQueryError | MarketingConfigQuerySuccessResponse;

export type MarketingConfigQuerySuccessResponse = {
  __typename?: 'MarketingConfigQuerySuccessResponse';
  smsAccountEnabled: Scalars['Boolean']['output'];
};

export type MarketingMutation = {
  __typename?: 'MarketingMutation';
  marketingSubscription: CreateMarketingSubscriptionRequestResponse;
};


export type MarketingMutationMarketingSubscriptionArgs = {
  input: CreateMarketingSubscriptionRequestInput;
};

export type MarketingQuery = {
  __typename?: 'MarketingQuery';
  marketingAccounts: MarketingAccountsQueryResponse;
  marketingConfig: MarketingConfigQueryResponse;
};


export type MarketingQueryMarketingAccountsArgs = {
  input: MarketingAccountsQueryInput;
};


export type MarketingQueryMarketingConfigArgs = {
  input: MarketingConfigQueryInput;
};

export type MarketingSubscriptionRequestInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  restaurantGuid: Scalars['ID']['input'];
  source: Scalars['String']['input'];
  subscriptions: Array<CreateMarketingSubscriptionInput>;
};

export type Menu = {
  __typename?: 'Menu';
  groups?: Maybe<Array<Maybe<MenuGroup>>>;
  /** This will be a unique identifier for this menu within the scope of the restaurant but should be treated as an opaque string. It may be the numeric database id or the guid, depending which API was used to retrieve the menu but that should not be relied upon by the client. */
  id: Scalars['ID']['output'];
  /** Will only be populated if retrieved from DO Menus */
  masterId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The available APIs for retrieving menu and stock data */
export enum MenuApiType {
  /** The endpoints in toast-do-menus, requires a restaurantGuid to be provided */
  Do = 'DO',
  /** The former menu and stock endpoints in toastweb, no longer supported and will throw an error */
  Toastweb = 'TOASTWEB'
}

export type MenuGroup = {
  __typename?: 'MenuGroup';
  description?: Maybe<Scalars['String']['output']>;
  dietaryItemTags: Array<Menus_MenuItemTag>;
  /** Top-level menu group guid. Do not use this for item related queries. Instead, use MenuItem.itemGroupGuid. */
  guid: Scalars['ID']['output'];
  itemTags: Array<Menus_MenuItemTag>;
  items?: Maybe<Array<Maybe<MenuItem>>>;
  /** Will only be populated if retrieved from DO Menus */
  masterId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MenuGroupOfferBadge = OfferBadge & {
  __typename?: 'MenuGroupOfferBadge';
  badgeText: Scalars['String']['output'];
  /** The menu group guid that should show this badge */
  groupGuid: Scalars['String']['output'];
};

export type MenuGrouping = {
  __typename?: 'MenuGrouping';
  children?: Maybe<Array<MenuGrouping>>;
  guid: Scalars['String']['output'];
  itemCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** An item in the menu */
export type MenuItem = {
  __typename?: 'MenuItem';
  calories?: Maybe<Scalars['Int']['output']>;
  contentAdvisories: Menus_ContentAdvisories;
  /** The summed prices of all default modifiers on this item */
  defaultModifiersPrice?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dietaryItemTags: Array<Menus_MenuItemTag>;
  guid: Scalars['ID']['output'];
  hasModifiers?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use imageUrls */
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageUrls?: Maybe<ImageSet>;
  /** This is the sub-group guid if the item is part of a subgroup. Else, this is the top-level menu group guid. Use this for item related queries. */
  itemGroupGuid: Scalars['ID']['output'];
  itemTags: Array<Menus_MenuItemTag>;
  /** Will only be populated if retrieved from DO Menus */
  masterId?: Maybe<Scalars['String']['output']>;
  /** This optional argument allows the query to specify the level of nesting in the modifiers. Any top level modifier with greater than the specified level of nesting is removed, and empty modifier groups are removed as well. A level of 1 will return mods without nesting. A level of 2 will return mods with at most one level of nesting, and so on. */
  modifierGroups: Array<ModifierGroup>;
  name?: Maybe<Scalars['String']['output']>;
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use prices instead */
  price?: Maybe<Scalars['Float']['output']>;
  /** prices contains either an array of a single price which is the actual price of the menu item, or it contains a list of prices, which are required size option modifiers that determine the menu item's price. Clients can display these in whichever way is most appropriate whether that's a range or list of the potential prices. */
  prices: Array<Scalars['Float']['output']>;
  timeBasedRules?: Maybe<TimeBasedRules>;
  unitOfMeasure: UnitOfMeasure;
  usesFractionalQuantity?: Maybe<Scalars['Boolean']['output']>;
};


/** An item in the menu */
export type MenuItemModifierGroupsArgs = {
  nestingLevel?: InputMaybe<Scalars['Int']['input']>;
};

/** Note that shortUrl will remain required throughout the transition to the DO menu API */
export type MenuItemDetailsInput = {
  /** Optional Channel identifier */
  channelGuid?: InputMaybe<Scalars['String']['input']>;
  /** Date should be in ISO 8601 format and include date and time. Example: 2019-08-07T13:00:00-04:00 This is necessary if fetching menu items that are not currently available. If the dateTime is not provided, the current time is used. */
  dateTime?: InputMaybe<Scalars['String']['input']>;
  itemGroupGuid: Scalars['ID']['input'];
  itemGuid: Scalars['ID']['input'];
  /** Determine which menu API should be used for retrieving menu and stock data */
  menuApi?: InputMaybe<MenuApiType>;
  /** Required if menuApi is DO */
  restaurantGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Deprecated: shortUrl and the TOASTWEB menuApi are no longer supported */
  shortUrl?: InputMaybe<Scalars['String']['input']>;
  /** Determines the visibility to filter menu items by. Defaults to TOAST_ONLINE_ORDERING. */
  visibility?: InputMaybe<Menus_VisibilityEnum>;
};

export type MenuItemFromCart = {
  __typename?: 'MenuItemFromCart';
  modifierGroups: Array<ModifierGroup>;
  name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  specialRequest?: Maybe<Scalars['String']['output']>;
};

/** Note that shortUrl will remain required throughout the transition to the DO menu API */
export type MenuItemFromCartInput = {
  cartGuid: Scalars['ID']['input'];
  itemGroupGuid: Scalars['ID']['input'];
  itemGuid: Scalars['ID']['input'];
  /** Determine which menu API should be used for retrieving menu and stock data */
  menuApi?: InputMaybe<MenuApiType>;
  /** Required if menuApi is DO */
  restaurantGuid?: InputMaybe<Scalars['ID']['input']>;
  selectionGuid: Scalars['ID']['input'];
  /** Deprecated: shortUrl and the TOASTWEB menuApi are no longer supported */
  shortUrl?: InputMaybe<Scalars['String']['input']>;
};

export type MenuItemOfferBadge = OfferBadge & {
  __typename?: 'MenuItemOfferBadge';
  badgeText: Scalars['String']['output'];
  /** The menu item guid that should show this badge */
  itemGuid: Scalars['String']['output'];
};

export type MenuOfferBadge = OfferBadge & {
  __typename?: 'MenuOfferBadge';
  badgeText: Scalars['String']['output'];
  /** The menu guid that should show this badge */
  menuGuid: Scalars['String']['output'];
};

export type MenuOfferBadgesInput = {
  /** The guid of the restaurant which has the order being paid for */
  restaurantGuid: Scalars['ID']['input'];
};

export type MenuOfferBadgesResponse = {
  __typename?: 'MenuOfferBadgesResponse';
  groups: Array<MenuGroupOfferBadge>;
  items: Array<MenuItemOfferBadge>;
  menus: Array<MenuOfferBadge>;
};

export type MenuOfferBadgesResponseOrError = GeneralError | MenuOfferBadgesResponse;

export type MenusInput = {
  /** Optional Channel identifier */
  channelGuid?: InputMaybe<Scalars['String']['input']>;
  /** Date should be in ISO 8601 format and include date and time. Example: 2019-08-07T13:00:00-04:00 */
  dateTime?: InputMaybe<Scalars['String']['input']>;
  /** Determines whether the request should filter out of stock items or include them */
  hideOutOfStockItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determine which menu API should be used for retrieving menu and stock data */
  menuApi?: InputMaybe<MenuApiType>;
  /** Determines whether the request should respect fulfillment time and availability schedules */
  respectAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required if menuApi is DO */
  restaurantGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Deprecated: shortUrl and the TOASTWEB menuApi are no longer supported */
  shortUrl?: InputMaybe<Scalars['ID']['input']>;
  /** Determines the visibility to filter menu items by. Defaults to TOAST_ONLINE_ORDERING. */
  visibility?: InputMaybe<Menus_VisibilityEnum>;
};

export type MenusResponse = {
  __typename?: 'MenusResponse';
  menus: Array<Menu>;
};

export type MenusResponseOrError = GeneralError | MenusResponse;

/** A representation of com.toasttab.service.menus.api.Alcohol */
export type Menus_Alcohol = {
  __typename?: 'Menus_Alcohol';
  containsAlcohol?: Maybe<Menus_ContainsAlcohol>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.Availability */
export type Menus_Availability = {
  __typename?: 'Menus_Availability';
  alwaysAvailable: Scalars['Boolean']['output'];
  schedule?: Maybe<Array<Menus_Schedule>>;
};

/** A representation of com.toasttab.models.ContainsAlcohol Note this is being treated as logically belonging to toast-menus */
export enum Menus_ContainsAlcohol {
  No = 'NO',
  Yes = 'YES'
}

/** A representation of com.toasttab.service.menus.ContentAdvisories */
export type Menus_ContentAdvisories = {
  __typename?: 'Menus_ContentAdvisories';
  alcohol?: Maybe<Menus_Alcohol>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.MappablePricingStrategy */
export enum Menus_MappablePricingStrategy {
  BasePrice = 'BASE_PRICE',
  Default = 'DEFAULT',
  GroupPrice = 'GROUP_PRICE',
  LocationSpecificPrice = 'LOCATION_SPECIFIC_PRICE',
  MenuSpecificPrice = 'MENU_SPECIFIC_PRICE',
  None = 'NONE',
  OpenPrice = 'OPEN_PRICE',
  SequencePrice = 'SEQUENCE_PRICE',
  SizePrice = 'SIZE_PRICE',
  SizeSequencePrice = 'SIZE_SEQUENCE_PRICE',
  TimeSpecificPrice = 'TIME_SPECIFIC_PRICE'
}

/** A 1:1 representation of com.toasttab.service.menus.api.v2.MenuGroupV2 Menu groups are globally unique by `guid`. */
export type Menus_MenuGroupV2 = {
  __typename?: 'Menus_MenuGroupV2';
  description?: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  itemTags: Array<Menus_MenuItemTag>;
  masterId?: Maybe<Scalars['String']['output']>;
  menuGroups: Array<Menus_MenuGroupV2>;
  menuItems: Array<Menus_MenuItemV2>;
  name: Scalars['String']['output'];
  visibility: Array<Menus_VisibilityEnum>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.MenuItemTag */
export type Menus_MenuItemTag = {
  __typename?: 'Menus_MenuItemTag';
  guid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.v2.MenuItemV2 In general, menu items are *not* globally unique by `guid`. They are unique in conjunction with their parent `Menus_MenuGroupV2`. Items with the same `guid` may have different property values (e.g. `name`, `price`) depending on their location within the menu structure. Note however that all menu items with the same `guid` share the same state with regard to the `toast-stock` API. */
export type Menus_MenuItemV2 = {
  __typename?: 'Menus_MenuItemV2';
  calories?: Maybe<Scalars['Int']['output']>;
  contentAdvisories: Menus_ContentAdvisories;
  description: Scalars['String']['output'];
  dietaryItemTags: Array<Menus_MenuItemTag>;
  guid: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isDiscountable: Scalars['Boolean']['output'];
  itemTags: Array<Menus_MenuItemTag>;
  masterId?: Maybe<Scalars['String']['output']>;
  modifierGroupReferences: Array<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  plu: Scalars['String']['output'];
  portions: Array<Menus_PortionV2>;
  price?: Maybe<Scalars['Float']['output']>;
  pricingRules?: Maybe<Menus_PricingRules>;
  pricingStrategy: Menus_MappablePricingStrategy;
  salesCategory?: Maybe<Menus_SalesCategory>;
  sku: Scalars['String']['output'];
  taxInfo: Array<Scalars['String']['output']>;
  unitOfMeasure: Menus_UnitOfMeasure;
  visibility: Array<Menus_VisibilityEnum>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.v2.MenuOptionGroupV2 In general, menu option groups are *not* globally unique by `guid`. They are unique in conjunction with their `referenceId`. Option groups with the same `guid` may have different property values (e.g. `name`, `pricingRules`) depending on their location within the menu structure. */
export type Menus_MenuOptionGroupV2 = {
  __typename?: 'Menus_MenuOptionGroupV2';
  /** Note this is a "YES"/"NO" string, not a boolean */
  defaultOptionsChargePrice?: Maybe<Scalars['String']['output']>;
  /** Note this is a "YES"/"NO" string, not a boolean */
  defaultOptionsSubstitutionPricing?: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  isMultiSelect?: Maybe<Scalars['Boolean']['output']>;
  masterId?: Maybe<Scalars['String']['output']>;
  maxSelections?: Maybe<Scalars['Int']['output']>;
  minSelections: Scalars['Int']['output'];
  modifierOptionReferences: Array<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  preModifierGroupReference?: Maybe<Scalars['Int']['output']>;
  pricingRules?: Maybe<Menus_PricingRules>;
  pricingStrategy: Menus_MappablePricingStrategy;
  referenceId: Scalars['Int']['output'];
  requiredMode: Menus_RequiredMode;
  visibility: Array<Menus_VisibilityEnum>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.v2.MenuResponseV2 */
export type Menus_MenuResponseV2 = {
  __typename?: 'Menus_MenuResponseV2';
  lastUpdated?: Maybe<Scalars['String']['output']>;
  menus: Array<Menus_MenuV2>;
  /** List of entries that should be associated by referenceId to build a lookup map */
  modifierGroupReferences: Array<Menus_MenuOptionGroupV2>;
  /** List of entries that should be associated by referenceId to build a lookup map */
  modifierOptionReferences: Array<Menus_ModifierOptionV2>;
  /** List of entries that should be associated by referenceId to build a lookup map */
  preModifierGroupReferences: Array<Menus_PreModifierGroupV2>;
  restaurantGuid: Scalars['String']['output'];
  restaurantTimeZone?: Maybe<Scalars['String']['output']>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.v2.MenuV2 Menus are globally unique by `guid`. */
export type Menus_MenuV2 = {
  __typename?: 'Menus_MenuV2';
  availability: Menus_Availability;
  description: Scalars['String']['output'];
  guid: Scalars['String']['output'];
  highResImage?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  masterId?: Maybe<Scalars['String']['output']>;
  menuGroups: Array<Menus_MenuGroupV2>;
  name: Scalars['String']['output'];
  visibility: Array<Menus_VisibilityEnum>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.ModifierOptionTaxInfo */
export type Menus_ModifierOptionTaxInfo = {
  __typename?: 'Menus_ModifierOptionTaxInfo';
  overrideItemTaxRates: Scalars['Boolean']['output'];
  taxRateGuids: Array<Scalars['String']['output']>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.v2.ModifierOptionV2 In general, modifier options are *not* globally unique by `guid`. They are unique in conjunction with their `referenceId`. Option groups with the same `guid` may have different property values (e.g. `name`, `pricingRules`) depending on their location within the menu structure. Note however that all modifier options with the same `guid` share the same state with regard to the `toast-stock` API. */
export type Menus_ModifierOptionV2 = {
  __typename?: 'Menus_ModifierOptionV2';
  allowsDuplicates?: Maybe<Scalars['Boolean']['output']>;
  calories?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  guid: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  itemTags: Array<Menus_MenuItemTag>;
  masterId?: Maybe<Scalars['String']['output']>;
  modifierGroupReferences: Array<Scalars['Int']['output']>;
  modifierOptionTaxInfo: Menus_ModifierOptionTaxInfo;
  name: Scalars['String']['output'];
  plu: Scalars['String']['output'];
  portions: Array<Maybe<Menus_PortionV2>>;
  price?: Maybe<Scalars['Float']['output']>;
  pricingRules?: Maybe<Menus_PricingRules>;
  pricingStrategy: Menus_MappablePricingStrategy;
  referenceId: Scalars['Int']['output'];
  salesCategory?: Maybe<Menus_SalesCategory>;
  sku: Scalars['String']['output'];
  taxInfo: Array<Scalars['String']['output']>;
  unitOfMeasure: Menus_UnitOfMeasure;
  visibility: Array<Menus_VisibilityEnum>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.v2.PortionV2 */
export type Menus_PortionV2 = {
  __typename?: 'Menus_PortionV2';
  guid: Scalars['String']['output'];
  modifierGroupReferences: Array<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

/** A 1:1 representation of com.toasttab.service.menus.api.v2.PreModifierGroupV2 */
export type Menus_PreModifierGroupV2 = {
  __typename?: 'Menus_PreModifierGroupV2';
  guid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  preModifiers: Array<Menus_PreModifierV2>;
  referenceId: Scalars['Int']['output'];
};

/** A 1:1 representation of com.toasttab.service.menus.api.v2.PreModifierV2 */
export type Menus_PreModifierV2 = {
  __typename?: 'Menus_PreModifierV2';
  displayMode: Menus_PreModifierV2DisplayMode;
  fixedPrice?: Maybe<Scalars['Float']['output']>;
  guid: Scalars['String']['output'];
  multiplicationFactor?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

/** A 1:1 representation of com.toasttab.service.menus.api.v2.PreModifierV2.DisplayMode */
export enum Menus_PreModifierV2DisplayMode {
  Other = 'OTHER',
  Prefix = 'PREFIX',
  Suffix = 'SUFFIX'
}

/** A 1:1 representation of com.toasttab.service.menus.api.PricingRules */
export type Menus_PricingRules = {
  __typename?: 'Menus_PricingRules';
  sizeSequencePricingRules: Array<Menus_SizeSequencePricingRule>;
  sizeSpecificPricingGuid?: Maybe<Scalars['String']['output']>;
  timeSpecificPricingRules: Array<Menus_TimeSpecificPricingRule>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.RequiredMode */
export enum Menus_RequiredMode {
  Optional = 'OPTIONAL',
  OptionalForceShow = 'OPTIONAL_FORCE_SHOW',
  Required = 'REQUIRED'
}

/** A 1:1 representation of com.toasttab.service.menus.api.SalesCategory */
export type Menus_SalesCategory = {
  __typename?: 'Menus_SalesCategory';
  guid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.Schedule */
export type Menus_Schedule = {
  __typename?: 'Menus_Schedule';
  days: Array<Scalars['String']['output']>;
  timeRanges: Array<Menus_TimeRange>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.SequencePrice */
export type Menus_SequencePrice = {
  __typename?: 'Menus_SequencePrice';
  price: Scalars['Float']['output'];
  sequence: Scalars['Int']['output'];
};

/** A 1:1 representation of com.toasttab.service.menus.api.SizeSequencePricingRule */
export type Menus_SizeSequencePricingRule = {
  __typename?: 'Menus_SizeSequencePricingRule';
  sequencePrices: Array<Menus_SequencePrice>;
  sizeGuid?: Maybe<Scalars['String']['output']>;
  sizeName?: Maybe<Scalars['String']['output']>;
};

/** A 1:1 representation of com.toasttab.service.menus.api.TimeRange */
export type Menus_TimeRange = {
  __typename?: 'Menus_TimeRange';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

/** A 1:1 representation of com.toasttab.service.menus.api.TimeSpecificPricingRule */
export type Menus_TimeSpecificPricingRule = {
  __typename?: 'Menus_TimeSpecificPricingRule';
  basePrice: Scalars['Float']['output'];
  schedule: Array<Menus_Schedule>;
  timeSpecificPrice: Scalars['Float']['output'];
};

/** A 1:1 representation of com.toasttab.service.menus.api.UnitOfMeasure */
export enum Menus_UnitOfMeasure {
  G = 'G',
  Kg = 'KG',
  Lb = 'LB',
  None = 'NONE',
  Oz = 'OZ'
}

/** A 1:1 representation of com.toasttab.service.menus.api.VisibilityEnum */
export enum Menus_VisibilityEnum {
  Grubhub = 'GRUBHUB',
  Kiosk = 'KIOSK',
  OrderingPartners = 'ORDERING_PARTNERS',
  Pos = 'POS',
  ToastOnlineOrdering = 'TOAST_ONLINE_ORDERING',
  Unknown = 'UNKNOWN'
}

export type MetaConversionsData = {
  __typename?: 'MetaConversionsData';
  pixelId?: Maybe<Scalars['String']['output']>;
};

export type MissingCustomerOrGuestGuidError = {
  __typename?: 'MissingCustomerOrGuestGuidError';
  code?: Maybe<GeneralErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Modifier = {
  __typename?: 'Modifier';
  /** Required for modifier quantity implementation. Will only be populated if retrieved from DO Menus. */
  allowsDuplicates?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  itemGroupGuid?: Maybe<Scalars['ID']['output']>;
  itemGuid: Scalars['ID']['output'];
  modifierGroups: Array<ModifierGroup>;
  name?: Maybe<Scalars['String']['output']>;
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
};

export type ModifierGroup = {
  __typename?: 'ModifierGroup';
  guid: Scalars['ID']['output'];
  maxSelections?: Maybe<Scalars['Int']['output']>;
  minSelections?: Maybe<Scalars['Int']['output']>;
  modifiers: Array<Modifier>;
  name?: Maybe<Scalars['String']['output']>;
  pricingMode?: Maybe<Scalars['String']['output']>;
};

export type ModifierGroupInput = {
  guid: Scalars['ID']['input'];
  modifiers: Array<SelectionInput>;
};

/** Note that shortUrl will remain required throughout the transition to the DO menu API */
export type ModifierGroupsInput = {
  itemGroupGuid: Scalars['ID']['input'];
  itemGuid: Scalars['ID']['input'];
  /** Determine which menu API should be used for retrieving menu and stock data */
  menuApi?: InputMaybe<MenuApiType>;
  /** Required if menuApi is DO */
  restaurantGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Deprecated: shortUrl and the TOASTWEB menuApi are no longer supported */
  shortUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ModifyGuestSavedListsResponse = ListSizeExceededError | ModifyGuestSavedListsSuccess | UnexpectedError;

export type ModifyGuestSavedListsSuccess = {
  __typename?: 'ModifyGuestSavedListsSuccess';
  updatedLists: Array<GuestSavedList>;
};

/** A monetary value with currency. */
export type Money = {
  __typename?: 'Money';
  /** The amount of money */
  amount: Scalars['Decimal']['output'];
  /** The currency the money is paid in */
  currency: Currency;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** CONCEPT - Experimental. */
  CON_addPerson: Con_Person;
  /** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
  CON_enrollInIndustryPass: Con_EnrollInIndustryPassResult;
  CON_mutationPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! Guest authentication required. */
  CON_toastCashbackReward: Con_ToastCashbackRewardResult;
  acceptSocialRequestsToFollow: AcceptSocialFollowersResult;
  /** Updates the guests birthday and birthday consent. */
  addGuestBirthday: AddGuestBirthdayResult;
  /** Ensures the guest is able to complete an authentication action when updating an identity type. ### Authorization A valid guest authorization token is required. ### See also See `confirmGuestIdentity` for the follow-up call that should occur after this mutation. For example: 1. `addGuestIdentity` calls `toast-authentication` > `startPasswordless(email/phone)` 1. accept code from guest 1. `confirmGuestIdentity` calls `toast-authentication to confirm otp */
  addGuestIdentity: AddGuestIdentityResult;
  /** Idempotently adds a reaction by the authenticated social user to a post. Each social user can have only one reaction per post. */
  addGuestReactionToPost: AddGuestReactionToPostResponse;
  /** @deprecated use addItemToCartV2 */
  addItemToCart?: Maybe<AddItemToCartResponse>;
  /** Adds the given **selection** to the cart represented by **cartGuid**, if **cartGuid** is given. Otherwise, creates a cart and add the given **selection** to the newly created cart. */
  addItemToCartV2: CartModificationResponseOrError;
  /** @deprecated Use V2 mutation instead */
  addItemsToGuestSavedLists: Array<GuestSavedList>;
  addItemsToGuestSavedListsV2: ModifyGuestSavedListsResponse;
  /** Adds a loyalty redemption discount to the cart. Only one redemption can be present on a cart at a time, but it can be combined with a promo code discount. Loyalty points will be adjusted after the order is placed, not when the redemption is added. To get the required **redemptionGuid** field, call the **loyaltyInquiry** mutation. */
  addLoyaltyRedemption: CartModificationResponseOrError;
  /** Adds a loyalty redemption discount to the cart. Differs from ***addLoyaltyRedemption*** as it takes a ***AddLoyaltyRedemptionV2Input***. ***AddLoyaltyRedemptionV2Input*** includes the guid of the redemption and the type of the redemption in order to add a specific type of loyalty redemption. This allows for redemption of multiple types of loyalty rewards. Loyalty points will be adjusted after the order is placed, not when the redemption is added. To get the required **guid** and **type** field, call the **loyaltyInquiry** mutation. */
  addLoyaltyRedemptionV2: CartModificationResponseOrError;
  /** Adds a new push notification target to the customer referenced by **customerGuid**. */
  addPushNotificationTargetToCustomer?: Maybe<AddPushNotificationTargetToCustomerResponse>;
  adminAddAwardTypeToSeason: AdminAddAwardTypeToSeasonResult;
  /** @deprecated Use V2 mutation instead */
  adminAddItemsToGuestSavedLists: Array<GuestSavedList>;
  adminAddItemsToGuestSavedListsV2: ModifyGuestSavedListsResponse;
  adminCreateAwardSeason: AdminCreateAwardSeasonResult;
  adminCreatePlaceVideoPost: AdminCreatePlaceVideoPostResult;
  adminDeletePlaceVideoPost: AdminDeletePlaceVideoPostResult;
  /** Apply the given `ApplyCodeToGuestCurrencyAccountInput.code` to the guest's `GuestCurrencyAccount`. A new `GuestCurrencyUnit` will be created as a result of this operation, with an automatically generated expiration timestamp, in the case of a `GuestCurrencyExpirableUnit`. See `ApplyCodeToGuestCurrencyAccountSuccess.currencyUnit` for the newly created `GuestCurrencyUnit`. See `ApplyCodeToGuestCurrencyAccountSuccess.currencyAccount` for the updated `GuestCurrencyAccount`. Note that depending on which `GuestCurrencyExpirableUnitPage` is requested as part of this mutation's successful result, the newly created `GuestCurrencyUnit` might not appear in the page. It is up to the client to amend any client-side page data with the newly created `GuestCurrencyUnit`. ## Authorization A valid guest authorization token is required. ## Security To not aid malicious attempts at guessing codes, the various error cases are intentionally grouped into a single `ApplyCodeToGuestCurrencyAccountError` result, including, but not limited to, input code being invalid, request being rate limited, and downstream services being unavailable. */
  applyCodeToGuestCurrencyAccount: ApplyCodeToGuestCurrencyAccountResult;
  /**
   * Attempts to redeem the promo code to the cart referenced in the input. On success, will return the cart with the reward applied. On failure, it will return an error. The response is optional because the user needs to be authenticated to actually apply a reward.
   * @deprecated use applyPromoCodeV3
   */
  applyPromoCode?: Maybe<ApplyPromoCodeResponseOrError>;
  /**
   * Attempts to redeem the promo code of given type (currently only supports Restaurant) in the input to the cart referenced in the input. On success, will return the cart with the reward applied. On failure, it will return an error.
   * @deprecated use applyPromoCodeV3
   */
  applyPromoCodeV2: ApplyPromoCodeResponseOrErrorV2;
  /**
   * Attempts to redeem the promo code for any supported reward types for the cart. Only one reward type is supported on a cart at a time. If a promo code reward already exists, a ApplyPromoCodeError will be returned. On success, will return the cart with the reward applied. On failure, it will return an error.
   * @deprecated For restaurant-specific promo codes use applyPromoCodeV4 to apply it to the cart. For guest currency codes use applyCodeToGuestCurrencyAccount (federated) to apply it to the guest's guest currency account and submit a place order request with guestCurrencyAccountPayment set.
   */
  applyPromoCodeV3: ApplyPromoCodeResponseOrErrorV2;
  /** Attempts to apply a restaurant-specific promo code to the given cart. */
  applyPromoCodeV4: ApplyPromoCodeResponseOrErrorV2;
  /** Allows clients to apply promos to the current in progress order */
  applyPromoInProgressOrder?: Maybe<InProgressOrder>;
  /** Attempts to apply the Toast funded offer (TFO) to the cart referenced in the input. On success, will return the cart with the applied TFO. On failure, it will return an error. Guest login is required. */
  applyToastFundedOffer: ApplyToastFundedOfferResponseOrError;
  /** Soft deletes a guests comment and removes content. Creates an archived record of the original comment. */
  archiveGuestComment: ArchiveGuestCommentResult;
  /** An admin mutation to archive a guest's image review if it contains inappropriate content. The review will no longer be visible to any guests. */
  archiveGuestImageReview: ArchiveGuestReviewResult;
  archiveGuestPost: ArchiveGuestPostResult;
  /** An admin mutation to archive a guest's text review if it contains inappropriate content. The review will no longer be visible to any guests. */
  archiveGuestTextReview: ArchiveGuestReviewResult;
  archiveSocialUserProfilePhoto: ArchiveSocialUserProfilePhotoResult;
  /** Allows clients to authorize a card for an amount */
  authorizePayment: AuthorizePaymentResponseOrError;
  /** Attempts to fetch the orders associated with the provided card fingerprints and backfill them into the guest's order history. Validations: 1. Each attempt is limited to 3 card fingerprints. 1. Each card fingerprint must be eligible for backfill. Each guest can only attempt a backfill using a particular card fingerprint every 1 day. Each card fingerprint must be eligible for linking to be eligible for backfilling. If the client requested more than 3 card fingerprints, `ValidationError` will be returned. If a requested card fingerprint has not been linked and is eligible for linking, it will be linked as part of this request. */
  backfillGuestOrderHistoryByCardFingerprints: BackfillGuestOrderHistoryByCardFingerprintsResult;
  banSocialUser: BanSocialUserResult;
  booking: BookingMutation;
  /** For unified login flows, this API is called to create a verified profile for the guest */
  completeIdentityProfile: CompleteIdentityProfileResponseOrError;
  /** Complete profile creation after user has confirmed their phone number with Auth0 thus verifying the users account */
  completeProfileCreation: CompleteProfileCreationResponseOrError;
  /** Verifies the authenticated guest and returns their details and profile status to indicate the next action you should take. ## Usage You should always call this **after** a guest `token` action in `toast-authentication` is completed. A failure to call may result in future authorization `FORBIDDEN` GraphQL error codes for guest operations, or a loss of data. You may need to additionally call the `token` action again to get a new token, depending on the result of this operation. A `CompleteGuestProfileInputRequiredError` result may occur if this guest has not completed and verified their profile before; when this occurs, the `profileProgress` will indicate which fields need to be collected. You must then repeat this `confirmGuest` call with the filled out `profile` fields to receive a valid `guest`. ### Authorization A valid guest authorization token is required. ### Scenarios Clients should always check for the following in the response to determine the next course of action: 1. `if __typename == CompleteGuestProfileInputRequiredError` > collect incomplete fields indicated in `profileProgress` and call `confirmGuest` again 1. `if __typename == ConfirmGuestSuccess` > up to your product requirements to collect fields indicated in `profileProgress` and call `confirmGuest` again 1. `if ConfirmGuestSuccess.mustRefreshToken == true` > you should refresh the token issued from `toast-authentication` > In the future, a `CompleteGuestProfileInputRequiredError` response may not occur. > In this situation, it will be fully up to your product to perform the second `confirmGuest` based on your requirements > by checking the `profileProgress` field; requiring this additional profile data will not be enforced in the backend. #### Signing up for a new guest account If the guest has not created an account with us before, the first call to `confirmGuest` will indicate as much. You should then make a second call to `confirmGuest` to finish setting up their profile, which would then also indicate the guest authorization needs to be refreshed now that they have a valid account: 1. `setupGuest` 1. `toast-authentication` > `passwordlessStart` 1. accept code from guest 1. `toast-authentication` > `token` 1. `confirmGuest` 1. collect user info 1. `confirmGuest` 1. `toast-authentication` > `token` #### Returning guest logging in, missing first and last name If the guest is just logging in, but never provided a name on their profile and your product captures name, then the following flow can support this: 1. `setupGuest` 1. `toast-authentication` > `passwordlessStart` 1. accept code from guest 1. `toast-authentication` > `token` 1. `confirmGuest` 1. collect first and last name 1. `confirmGuest` #### Returning guest logging in, complete profile If the guest then returns and is just logging in, only a single `confirmGuest` is necessary: 1. `setupGuest` 1. `toast-authentication` > `passwordlessStart` 1. accept code from guest 1. `toast-authentication` > `token` 1. `confirmGuest` ### See also See `setupGuest` for the start of these auth-related call chains that should occur before interactions with `toast-authentication`. */
  confirmGuest: ConfirmGuestResult;
  /** Verifies the authenticated guest owns the guest identity and that no other guest has already verified this identity, and returns their profile details. ### Authorization A valid guest authorization token is required. ### See also See `addGuestIdentity` for the start of this call chain to add a new guest identity. */
  confirmGuestIdentity: ConfirmGuestIdentityResult;
  createApplePayPreauth: CreateCreditCardPreauthResponse;
  /** @deprecated use addItemToCartV2 */
  createCart?: Maybe<CreateCartResponse>;
  createEncryptedCreditCardPreauth: CreateCreditCardPreauthResponse;
  createGiftCardOrder: CreateGiftCardOrderResponse;
  /** Creates a new comment on a post. */
  createGuestCommentOnPost: CreateGuestCommentOnPostResult;
  createOrUpdateGuestAward: CreateOrUpdateGuestAwardResult;
  /** This mutation generates a URL to which an image can be uploaded. To upload an image to the generated upload URL, the client must send a POST form submission HTTP request with the headers in `uploadHeaders` and the form parameters in `uploadFormParameters`. Additionally, the POST HTTP request must also include the image file to be uploaded as the last form parameter. The generated URL is persisted on the corresponding profilePhoto generated as part of this mutation; however, until the image is uploaded to the URL by the client, the URL for the profilePhoto will not return an image. Additionally, during the upload the previous profile photo will be deleted and that URL will no longer be valid. */
  createOrUpdateSocialUserProfilePhoto: CreateOrUpdateSocialUserProfilePhotoResult;
  /** Creates or updates a post by looking up the order with the `orderId` and `checkId` from `CreateOrUpdatePostInput` and generating the post content if it does not exist. If there are no fields to update and the post already exists, then there is no change. */
  createOrUpdateToastOrderPost: CreateOrUpdateToastOrderPostResult;
  createSocialUser: CreateSocialUserResult;
  /** Will attempt to delete a guest with a guest-profiles account. Request must be sent along with a valid access token for guest-profiles in the 'authorization' header. The guestGuid will be extracted from the token and used for account deletion. */
  deleteAccount: DeleteAccountResponseOrError;
  /** Deletes an existing address on the account */
  deleteAddress: DeleteAddressResponseOrError;
  /** Removes the credit card from the account (and the associated secure token for the card from ccpartner) */
  deleteCreditCard: DeleteCreditCardResponseOrError;
  /** Deletes a customer's push notification target referenced by **customerGuid**. */
  deleteCustomerPushNotificationTarget?: Maybe<DeleteCustomerPushNotificationTargetResponse>;
  /** Deletes the guest address identified by `input.addressId`. */
  deleteGuestAddress: DeleteGuestAddressResult;
  /** Soft deletes a guests comment. */
  deleteGuestCommentOnPost: DeleteGuestCommentOnPostResult;
  /** Deletes the payment card represented by `paymentCardId` in `input` for the guest. */
  deleteGuestPaymentCard: DeleteGuestPaymentCardResult;
  /** @deprecated use deleteItemFromCartV2 */
  deleteItemFromCart?: Maybe<DeleteItemFromCartResponse>;
  /** Deletes the cart item represented by **selectionGuid** in the cart represented by **cartGuid**. */
  deleteItemFromCartV2: CartModificationResponseOrError;
  deleteSocialUser: DeleteSocialUserResult;
  eGiftCardShopCart: EGiftCardShopCartMutation;
  /** @deprecated use editItemInCartV2 */
  editItemInCart?: Maybe<EditItemInCartResponse>;
  /** Modifies the cart item represented by **selectionGuid** in the cart represented by **cartGuid** to be the same as the given **selection**. */
  editItemInCartV2: CartModificationResponseOrError;
  /** Fingerprints all of a guest's saved credit cards to their account. */
  fingerprintAllCards: FingerprintAllCardsResponse;
  followSocialUsers: SocialFollowResult;
  generateGuestMediaPostImageUploadUrls: GenerateGuestMediaUploadUrlsResult;
  generateGuestMediaPresignedImageUrls: GenerateGuestMediaPresignedUrlsResult;
  guestFeedback?: Maybe<GuestFeedbackMutation>;
  guestPasscode: GuestPasscodeMutation;
  inAppCheckIn: InAppCheckInMutation;
  /** Creates a request that will be processed asynchronously to link a guest's payment card. Updates the card fingerprint obtained from using **input.paymentMethodId** to be linked and updates any other card fingerprint with the same card fingerprint to be ineligible for linking. */
  initiateCardLinkingByPaymentMethodId: InitiateCardLinkingByPaymentMethodIdResponse;
  /** Updates the guest's card fingerprint represented by `cardFingerprintId` in `input` to be linked and updates any other card fingerprint with the same `cardFingerprintId` to be ineligible for linking. Returns the card fingerprint without any updates if it is already linked. Returns an error if the guest's card fingerprint is ineligible for linking. */
  linkCardFingerprint: LinkCardFingerprintResponse;
  /** Fetches the card fingerprint of the guest's payment method by `paymentMethodId` in `input` and links it to the guest's account. This updates any other card fingerprint with the same `cardFingerprintId` to be ineligible for linking. */
  linkCardFingerprintByPaymentMethodId: LinkCardFingerprintByPaymentMethodIdResponse;
  /** Performs a loyalty inquiry, which attempts to find a loyalty account for the given customer guid and attaches it to the cart. If an account was found, the cart will be repriced, which may trigger an out of stock cart adjustment, but otherwise the cart should be unchanged. */
  loyaltyInquiry: LoyaltyInquiryResponseOrError;
  /**
   * Performs a loyalty inquiry, which attempts to find a loyalty account for the given customer guid and attaches it to the cart. If an account was found, the cart will be repriced, which may trigger an out of stock cart adjustment, but otherwise the cart should be unchanged. Differs from ***loyaltyInquiry*** as it includes birthday rewards in the response. It also returns the type of the redemption - to allow for redemption of multiple types of loyalty rewards.
   * @deprecated use loyaltyInquiryV3
   */
  loyaltyInquiryV2: LoyaltyInquiryResponseOrError;
  /** Performs a loyalty inquiry, which attempts to find a loyalty account for the given customer guid and attaches it to the cart. If an account was found, the cart will be repriced, which may trigger an out of stock cart adjustment, but otherwise the cart should be unchanged. Differs from ***loyaltyInquiryV2*** as it includes all the redemptions(regardless available or not) in the response. It also returns the type of the redemption - to allow for redemption of multiple types of loyalty rewards. */
  loyaltyInquiryV3: LoyaltyInquiryResponseOrError;
  /** Create a new loyalty account using the same email as the customermgmt account. This shared email is the only link between the two accounts. Requires the customer account to already have a saved basic info (first name, last name, phone). */
  loyaltySignup: LoyaltySignupResponseOrError;
  /** Create a new loyalty account at a given restaurant without initiating a transaction. */
  loyaltySignupTransactionless: LoyaltySignupResponseOrError;
  /** Sets the credit card as the primary (used by default) card on the account */
  makeCreditCardPrimary: MakeCreditCardPrimaryResponseOrError;
  marketing: MarketingMutation;
  oo: OnlineOrderingMutation;
  /** Increments auth amount, then fires a round of items for that order */
  opt_addIncAuthAndFire: Opt_OptPartyRefreshResponseV2;
  /** Create payment intent. */
  opt_createPaymentIntent: Opt_CreatePaymentIntentResponse;
  /** Covers the "split even" use case in Scan to Pay, in which clients specify exactly how to divvy up selections. */
  opt_createPaymentIntentForSplitCheckBySelections: Opt_CreatePaymentIntentResponse;
  /** Increments auth amount */
  opt_incrementAuth: Opt_IncrementAuthorizationResponse;
  /** Sends a customer notification to the assigned server. */
  opt_mdsCustomServerNotification: Opt_MdsCustomServerNotificationResponse;
  /** Creates a Party with Refresh Return */
  opt_mnpCreatePartyRefreshV2: Opt_OptPartyRefreshResponseV2;
  opt_optAddDiscountPayG: Opt_OptPartyRefreshResponseV2;
  opt_optAddDiscountPayGV2: Opt_OptPartyRefreshResponseV2;
  opt_optAddDiscountTabs: Opt_OptPartyRefreshResponseV2;
  opt_optAddDiscountTabsV2: Opt_OptPartyRefreshResponseV2;
  /** Adds an item to a party member's cart */
  opt_optAddItemToPartyMemberCartV2: Opt_OptPartyRefreshResponseV2;
  /** Creates a preauthorization tab with an order containing the saved preauth info, then fires a round of items for that order */
  opt_optAddPreauthAndFireV2: Opt_OptPartyRefreshResponseV2;
  /** Updates the number of split even portions that have been paid for */
  opt_optApplyEvenSplitPaidPortion: Opt_OptPartyRefreshResponseV2;
  opt_optApplyLoyaltyPayG: Opt_OptPartyRefreshResponseV2;
  opt_optApplyLoyaltyPayGV2: Opt_OptPartyRefreshResponseV2;
  opt_optApplyLoyaltyTabs: Opt_OptPartyRefreshResponseV2;
  opt_optApplyLoyaltyTabsV2: Opt_OptPartyRefreshResponseV2;
  /** @deprecated Use optApplyLoyaltyPayG */
  opt_optApplyPayGLoyalty: Opt_OptPartyRefreshResponseV2;
  /** Sets the type of split for the check and how many portions it's being split if the SplitMode is 'EVEN' */
  opt_optApplySplitType: Opt_OptPartyRefreshResponseV2;
  /** Creates a Party with Refresh Return */
  opt_optCreatePartyRefreshV2: Opt_OptPartyRefreshResponseV2;
  /** Edits an item in a party member's cart */
  opt_optDeleteItemInPartyMemberCartV2: Opt_OptPartyRefreshResponseV2;
  /** Edits an item in a party member's cart */
  opt_optEditItemInPartyMemberCartV2: Opt_OptPartyRefreshResponseV2;
  /** Fires items in member's carts to an order */
  opt_optFireTabRoundV2: Opt_OptPartyRefreshResponseV2;
  /** Increments auth amount, then fires a round of items for that order */
  opt_optIncrementAuthAndFire: Opt_OptPartyRefreshResponseV2;
  /** Creates a party on a specific order/check or joins a Party if one already exists for that order/check with Refresh Return */
  opt_optJoinOrCreatePartyDynamicQrRefresh: Opt_OptPartyRefreshResponseV2;
  /** Joins a Party */
  opt_optJoinPartySecureV2: Opt_OptPartyRefreshResponseV2;
  /** Joins a Party */
  opt_optJoinPartyV2: Opt_OptPartyRefreshResponseV2;
  /** Applies payment and fires PayG order. */
  opt_optPartyPayGCloseout: Opt_OptCloseoutResponse;
  /** Apply a promo code to an order at table tab */
  opt_optPartyPaygApplyPromo: Opt_OptPartyRefreshResponseV2;
  /** Remove promo code associated with a table tab */
  opt_optPartyPaygRemovePromo: Opt_OptPartyRefreshResponseV2;
  /** Apply a promo code to an order at table tab */
  opt_optPartyTabApplyPromo: Opt_OptPartyRefreshResponseV2;
  /** Applies payment to a party order's main check. */
  opt_optPartyTabCloseout: Opt_OptCloseoutResponse;
  /** Remove promo code associated with a table tab */
  opt_optPartyTabRemovePromo: Opt_OptPartyRefreshResponseV2;
  opt_optRemoveDiscountPayG: Opt_OptPartyRefreshResponseV2;
  opt_optRemoveDiscountPayGV2: Opt_OptPartyRefreshResponseV2;
  /** Removes splitPaymentData from the party */
  opt_optRemoveSplitPaymentData: Opt_OptPartyRefreshResponseV2;
  /** Copies a selection from a party member's tab and adds it to their cart */
  opt_optReorderItemV2: Opt_OptPartyRefreshResponseV2;
  /** Persists a splitting of a party's check and accepts payment for that check. */
  opt_optSplitCheckCloseout: Opt_OptCloseoutResponse;
  /** Validates cart */
  opt_optValidateV2: Opt_OptPartyRefreshResponseV2;
  /**
   * Allows clients to pay for an open check
   * @deprecated No longer supported.
   */
  opt_payForCheck: Opt_PayForCheckResponseOrError;
  /**
   * Places the order using the cart referenced by **cartGuid** using an Apple Pay payment token, and sends an email receipt to the email in the customer object. If the cart was modified by the server, e.g. an item on the cart is out of stock or order time has been adjusted, the cart will be returned in the **PlaceOrderCartUpdatedError** response since it was modified; otherwise either a successful **PlaceOrderResponse** will be returned (with a warning if afterPlaceOrder failed) or a generic **PlaceOrderError** with a code specifying the error if the request was unsuccessful.
   * @deprecated Use placeOPTApplePayPAYGOrder for DDI
   */
  opt_placeApplePayOrder: Opt_PlaceApplePayOrderResponse;
  /** Allows clients to sign-up to restaurant's rewards program */
  opt_signUpToLoyalty: Opt_SignUpToLoyaltyResponseOrError;
  /** Creates a Party with Refresh Return */
  opt_stpCreatePartyRefreshV2: Opt_OptPartyRefreshResponseV2;
  /** Creates a party on a specific order/check or joins a Party if one already exists for that order/check with Refresh Return */
  opt_stpJoinOrCreatePartyByMainCheckGuid: Opt_OptPartyRefreshResponseV2;
  /** Submit feedback from a guest */
  opt_submitGuestFeedback: Opt_GuestFeedbackResponse;
  opt_submitItemLevelFeedback: Opt_ItemLevelFeedbackSubmissionResponse;
  /** Update the firstName, lastName, and/or phone number on the account */
  opt_updateBasicInfo: Opt_UpdateBasicInfoResponseOrError;
  /** Updates a partyMember in a party */
  opt_updatePartyMember: Opt_PartyMemberResponse;
  /** Update payment intent. */
  opt_updatePaymentIntent: Opt_UpdatePaymentIntentResponse;
  /** Covers the "split even" use case in Scan to Pay, in which clients specify exactly how to divvy up selections. */
  opt_updatePaymentIntentForSplitCheckBySelections: Opt_UpdatePaymentIntentResponse;
  /** accepts the validationURL generated by Apple Pay JS on the client and passes it through to the Apple Pay server’s Payment Session endpoint */
  opt_validateApplePayMerchant: Opt_ValidateApplePayMerchantResponse;
  /**
   * Validates that the given code was the one sent to the guest. Will call toast-authentication to verify the code and if successful will return an accessToken and refreshToken. Will also call guest-profiles to verify the account. Used for PW- Auth V1 Workflows
   * @deprecated use passwordlessConfirmCodeUnified
   */
  passwordlessConfirmCode: PasswordlessTokenResponseOrError;
  /** Validates that the given code was the one sent to the guest. Will call toast-authentication to verify the code and if successful will return an accessToken and refreshToken Used for PW- Auth V2 Workflows where login/create account flows are unified */
  passwordlessConfirmCodeUnified: PasswordlessTokenUnifiedResponseOrError;
  /**
   * Begins the process to login. Will call toast-authentication to send a code to the guest for account verification/login. Used for PW- Auth V1 Workflows
   * @deprecated use passwordlessLoginUnified
   */
  passwordlessLogin: PasswordlessLoginResponseOrError;
  /** Begins the process to login. Will call toast-authentication to send a code to the guest for account verification/login and will create user account in toast-users if it doesnt already exist. Used for PW- Auth V2 Workflows where login/create account flows are unified */
  passwordlessLoginUnified: PasswordlessLoginUnifiedResponseOrError;
  /** Revokes the given refresh token. Effectly rendering the token useless. The guest will need to login in order to be issued a new valid refresh token. */
  passwordlessLogout: PasswordlessLogoutResponseOrError;
  /** Retrieves a new accessToken and refreshToken. */
  passwordlessRefreshToken: PasswordlessTokenResponseOrError;
  /** Attempts to create a new account with the given parameters. Will create the account in guest-profiles and then call toast-authentication to send a code to the guest for account verification/login. */
  passwordlessSignup: PasswordlessSignupResponseOrError;
  /** Specific mutations for PAY specific checkout */
  pay: PayMutation;
  /** Allows clients to pay for an open check */
  payForCheck: PayForCheckResponseOrError;
  paymentsMutation: PaymentsMutation;
  /** Places the order using the cart referenced by **cartGuid** using an APM token (ex: Klarna), and sends an email receipt to the email in the customer object. If the cart was modified by the server, e.g. an item on the cart is out of stock or order time has been adjusted, the cart will be returned in the **PlaceOrderCartUpdatedError** response since it was modified; otherwise either a successful **PlaceOrderResponse** will be returned (with a warning if afterPlaceOrder failed) or a generic **PlaceOrderError** with a code specifying the error if the request was unsuccessful. */
  placeApmOrder: PlaceApmOrderResponse;
  /** Places the order using the cart referenced by **cartGuid** using an Apple Pay payment token, and sends an email receipt to the email in the customer object. If the cart was modified by the server, e.g. an item on the cart is out of stock or order time has been adjusted, the cart will be returned in the **PlaceOrderCartUpdatedError** response since it was modified; otherwise either a successful **PlaceOrderResponse** will be returned (with a warning if afterPlaceOrder failed) or a generic **PlaceOrderError** with a code specifying the error if the request was unsuccessful. */
  placeApplePayOrder: PlaceApplePayOrderResponse;
  /** Places the order using the cart referenced by **cartGuid** using a cash payment (in store), and sends an email receipt to the email in the customer object. If the cart was modified by the server, e.g. an item on the cart is out of stock or order time has been adjusted, the cart will be returned in the **PlaceOrderCartUpdatedError** response since it was modified; otherwise either a successful **PlaceOrderResponse** will be returned (with a warning if afterPlaceOrder failed) or a generic **PlaceOrderError** with a code specifying the error if the request was unsuccessful. */
  placeCashOrder: PlaceCashOrderResponse;
  /** Places the order using the cart referenced by **cartGuid** using a credit card payment, and sends an email receipt to the email in the customer object. If the cart was modified by the server, e.g. an item on the cart is out of stock or order time has been adjusted, the cart will be returned in the **PlaceOrderCartUpdatedError** response since it was modified; otherwise either a successful **PlaceOrderResponse** will be returned (with a warning if afterPlaceOrder failed) or a generic **PlaceOrderError** with a code specifying the error if the request was unsuccessful. */
  placeCcOrder: PlaceCcOrderResponse;
  /** Places the order using the cart referenced by **cartGuid** using a gift card payment, and sends an email receipt to the email in the customer object. If the cart was modified by the server, e.g. an item on the cart is out of stock or order time has been adjusted, the cart will be returned in the **PlaceOrderCartUpdatedError** response since it was modified; otherwise either a successful **PlaceOrderResponse** will be returned (with a warning if afterPlaceOrder failed) or a generic **PlaceOrderError** with a code specifying the error if the request was unsuccessful. */
  placeGiftCardOrder: PlaceGiftCardOrderResponse;
  placePaidGiftCardOrder: PlacePaidGiftCardOrderResponse;
  /** Places the order using the cart referenced by **cartGuid** using a given payment, and sends an email receipt to the email in the customer object. If the cart was modified by the server, e.g. an item on the cart is out of stock or order time has been adjusted, the cart will be returned in the **PlaceOrderCartUpdatedError** response since it was modified; otherwise either a successful **PlaceOrderResponse** will be returned (with a warning if afterPlaceOrder failed) or a generic **PlaceOrderError** with a code specifying the error if the request was unsuccessful. */
  placePaidOrder: PlacePaidOrderResponse;
  rejectSocialRequestsToFollow: RejectSocialFollowersResult;
  removeGuestAward: RemoveGuestAwardResult;
  /** Idempotently removes the reaction by the authenticated social user from a post. */
  removeGuestReactionFromPost: RemoveGuestReactionFromPostResponse;
  /** After removing the requested image reviews, the order of the remaining image reviews for a particular order and check combination is maintained. For example, for a given order and check combination that has image reviews A, B, and C, if B is requested to be removed, the order of the remaining image reviews is A, C. */
  removeGuestToastOrderImageReviews: RemoveGuestToastOrderImageReviewsResult;
  /** @deprecated Use V2 mutation instead */
  removeItemsFromGuestSavedLists: Array<GuestSavedList>;
  removeItemsFromGuestSavedListsV2: ModifyGuestSavedListsResponse;
  /** Removes a loyalty redemption discount from the cart. Does not remove the attached loyalty info on the cart, so accruals will still take place for the given customer email when the order is placed. */
  removeLoyaltyRedemption: CartModificationResponseOrError;
  /** Removes a loyalty redemption discount from the cart. Does not remove the attached loyalty info on the cart, so accruals will still take place for the given customer email when the order is placed. Differs from ***removeLoyaltyRedemption*** as it takes a ***RemoveLoyaltyRedemptionV2Input***. ***RemoveLoyaltyRedemptionV2Input*** includes the guid of the redemption and the type of the redemption in order to remove a specific type of loyalty redemption. This allows for redemption of multiple types of loyalty rewards. */
  removeLoyaltyRedemptionV2: CartModificationResponseOrError;
  /**
   * Attempts to remove the promo code of given type (currently only supports Restaurant) in the input with the guid in the input from the cart in the input. On success, will return the cart with the removed discount. On failure, it will return an error.
   * @deprecated use removePromoCodeV2
   */
  removePromoCode: RemovePromoCodeResponseOrError;
  /** Attempts to remove all rewards for the the promo code. On success, will return the cart with the removed discount. On failure, it will return an error. */
  removePromoCodeV2: RemovePromoCodeResponseOrError;
  removeSocialFollowers: RemoveSocialFollowersResult;
  /** This mutation will remove a social user profile photo. */
  removeSocialUserProfilePhoto: RemoveSocialUserProfilePhotoResult;
  /** Attempts to remove the Toast funded offer (TFO) to the cart referenced in the input. On success, will return the cart without the applied TFOs. On failure, it will return an error. */
  removeToastFundedOffer: RemoveToastFundedOfferResponseOrError;
  /**
   * Creates a new cart in the restaurant referenced by **restaurantGuid**, Attempts to add each item in the order referenced by **orderGuid** to the newly created cart and return the cart. If any of the items is unavailable, they'll be added to the warning message in **warnings**.
   * @deprecated use reorderV2
   */
  reorder?: Maybe<ReorderResponse>;
  /** Creates a new cart in the restaurant referenced by **restaurantGuid**, Attempts to add each item in the order referenced by **orderGuid** to the newly created cart and return the cart. If any of the items is unavailable, but at least one item is available, the unavailable items will be added to a warning in **warningsV2**. If an error is encountered, a **ReorderError** is returned. See **ReorderErrorCode** for the possible errors. A null return value indicates that the customer is unauthenticated. */
  reorderV2?: Maybe<ReorderResponseOrError>;
  reportGuestComment: ReportGuestCommentResult;
  reportGuestPost: ReportGuestPostResult;
  reportSocialUser: ReportSocialUserResult;
  /** Allows clients to send a pay at a distance link */
  sendPaadLink: SendPayAtADistanceResponse;
  setFavoriteRestaurants: Array<Scalars['ID']['output']>;
  setMyUserVisibility: UpdateMySocialUserResult;
  /** Inform a 3rd party that a guest intends to use a specific payment method for checkout and retrieves a token to initialize payment with the client */
  setPaymentIntent: PaymentIntentResponseOrError;
  setSelectedShippingRate: EcommerceResponse;
  /** Ensures the guest is able to complete an authentication action. ## Usage You should always call this **before** a guest `passwordlessStart` action in `toast-authentication`. A failure to call may result in the guest not receiving a one-time code. ### Authorization No authorization is required. ### See also See `confirmGuest` for the follow-up call that should occur after `toast-authentication`. For example: 1. `setupGuest` 1. `toast-authentication` > `passwordlessStart` 1. accept code from guest 1. `toast-authentication` > `token` 1. `confirmGuest` */
  setupGuest: SetupGuestResult;
  shortenData?: Maybe<UrlShorteningResponseOrError>;
  /** Allows clients to sign-up to restaurant's rewards program */
  signUpToLoyalty: SignUpToLoyaltyResponseOrError;
  /** Start identity and profile creation (process) to start passwordless auth flow for unified login For clients that are creating accounts using unified login, they must call this API before passwordlessStart in order to ensure an Auth0 account exists for the guest Successful response: null Error response: StartIdentityProfileError */
  startIdentityProfile?: Maybe<StartIdentityProfileError>;
  /** Start profile creation (process) to start passwordless auth flow */
  startProfileCreation: StartProfileCreationResponseOrError;
  storedValue: StoredValueMutation;
  /** Allows guests to submit feedback and tag said feedback with specific tags. Also allows for open text feedback */
  submitGuestFeedbackV2: SubmitGuestFeedbackV2Response;
  /** Creates a new rating for the order if it does not already exist, otherwise updates the existing rating. If input is submitted with a null rating then the rating will be deleted. */
  submitGuestOrderExperienceRating: SubmitGuestRatingResult;
  /** Creates a new rating for the menu item in an order if it does not already exist, otherwise updates the existing rating. If input is submitted with a null rating then the rating will be deleted. */
  submitGuestOrderMenuItemRatings: SubmitGuestRatingResults;
  /** This mutation generates URLs to which images can be uploaded according to `SubmitGuestToastOrderImageReviewsInput.imageReviewInputs`. To upload images to the generated upload URLs, the client must send a POST form submission HTTP request with the headers in `GuestImageReviewUpload.uploadHeaders` and the form parameters in `GuestImageReviewUpload.uploadFormParameters`. Additionally, the POST HTTP request must also include the image file to be uploaded as the last form parameter. Each generated URL is persisted on the corresponding review generated as part of this mutation; however, until the images are uploaded to the URLs by the client, the URLs on the post will not return images. The order of the image reviews for a particular order and check combination is maintained across calls to this mutation. For example, for a given order and check combination, if the first call to this mutation created image reviews C and D, and the second call created image reviews A and B, the order of the image reviews for this order and check combination is C, D, A, B. Ensures that the order and check the guest is submitting the image reviews to are in the guest's order history. */
  submitGuestToastOrderImageReviews: SubmitGuestToastOrderImageReviewsResult;
  /** Creates, updates, or removes a text review associated with a guest's order and check. If no text review exists for the `SubmitGuestToastOrderTextReviewInput.orderId` and `SubmitGuestToastOrderTextReviewInput.checkId` combination, a new text review is created. If a text review already exists for the `SubmitGuestToastOrderTextReviewInput.orderId` and `SubmitGuestToastOrderTextReviewInput.checkId` combination, the text review is updated. If `SubmitGuestToastOrderTextReviewInput.reviewText` is null, the text review associated with the `SubmitGuestToastOrderTextReviewInput.orderId` and `SubmitGuestToastOrderTextReviewInput.checkId` combination is removed. */
  submitGuestToastOrderTextReview: SubmitGuestToastOrderTextReviewResult;
  unbanSocialUser: UnbanSocialUserResult;
  unfollowSocialUsers: SocialUnfollowResult;
  /** Updates the guest's card fingerprint represented by `cardFingerprintId` in `input` to be eligible and updates any other card fingerprint with the same `cardFingerprintId` to also be eligible for linking. Returns the card fingerprint without any update if it is already eligible and not linked. Returns an error if the guest's card fingerprint is ineligible for linking. */
  unlinkCardFingerprint: UnlinkCardFingerprintResponse;
  /** Updates an existing address on the account */
  updateAddress: UpdateAddressResponseOrError;
  /** Update the firstName, lastName, and/or phone number on the account */
  updateBasicInfo: UpdateBasicInfoResponseOrError;
  /** Updates the dining type of the cart. Currently this is controlled by the dining option, which is either takeout or outpost. */
  updateDiningOption: CartModificationResponseOrError;
  /** Modifies the fulfillment information for the cart represented by **cartGuid**. All items in the cart will be removed *if and only if* the fulfillment type or time changed. This is a workaround because we cannot currently determine if existing items in the cart are available at the newly selected time. The following are considered fulfillment information for the purpose of this mutation: - fulfillment type (**ASAP** / **FUTURE**) - fulfillment date+time - dining option behavior (**TAKE_OUT** / **DELIVERY** / **DINE_IN**) - delivery info */
  updateFulfillmentAndClearCart: CartModificationResponseOrError;
  /** Modifies the fulfillment information for the cart represented by **cartGuid**. Items in the cart will be validated using online-ordering validation endpoint. The following are considered fulfillment information for the purpose of this mutation: - fulfillment type (**ASAP** / **FUTURE**) - fulfillment date+time - dining option behavior (**TAKE_OUT** / **DELIVERY** / **DINE_IN**) - delivery info */
  updateFulfillmentAndValidate: CartModificationResponseOrError;
  /** Updates the guest address identified by `input.addressId`. */
  updateGuestAddress: UpdateGuestAddressResult;
  /** Updates the contact information for the guest. */
  updateGuestContact: UpdateGuestContactResult;
  updateGuestPostVisibility: UpdateGuestPostVisibilityResult;
  /** Updates the payment card represented by `paymentCardId` in `input` to be the primary payment card for the guest. Previous primary payment cards will no longer be the primary payment card for the guest. */
  updatePrimaryGuestPaymentCard: UpdatePrimaryGuestPaymentCardResult;
  validateAddress: AddressValidationResponse;
  /** accepts the validationURL generated by Apple Pay JS on the client and passes it through to the Apple Pay server’s Payment Session endpoint */
  validateApplePayMerchant: ValidateApplePayMerchantResponse;
  /** accepts the validationURL generated by Apple Pay JS on the client and passes it through to the Apple Pay server’s Payment Session endpoint */
  validateApplePayMerchantWIP: ValidateApplePayMerchantResponse;
  /** Removes items from the cart if they are out of stock */
  validateCartPreCheckout: CartModificationResponseOrError;
  walkout_createPreauthOrderForBooking: Walkout_CreatePreauthOrderForBookingResponse;
};


export type MutationCon_AddPersonArgs = {
  name: Scalars['String']['input'];
};


export type MutationCon_ToastCashbackRewardArgs = {
  input: CompletedOrderInput;
};


export type MutationAcceptSocialRequestsToFollowArgs = {
  request: AcceptSocialFollowersRequest;
};


export type MutationAddGuestBirthdayArgs = {
  input: AddGuestBirthdayInput;
};


export type MutationAddGuestIdentityArgs = {
  input: AddGuestIdentityInput;
};


export type MutationAddGuestReactionToPostArgs = {
  input: AddGuestReactionToPostInput;
};


export type MutationAddItemToCartArgs = {
  input: AddItemToCartInput;
};


export type MutationAddItemToCartV2Args = {
  input: AddItemToCartInputV2;
};


export type MutationAddItemsToGuestSavedListsArgs = {
  input: Array<AddItemsToGuestSavedListInput>;
};


export type MutationAddItemsToGuestSavedListsV2Args = {
  input: Array<AddItemsToGuestSavedListInput>;
};


export type MutationAddLoyaltyRedemptionArgs = {
  input: AddLoyaltyRedemptionInput;
};


export type MutationAddLoyaltyRedemptionV2Args = {
  input: AddLoyaltyRedemptionV2Input;
};


export type MutationAddPushNotificationTargetToCustomerArgs = {
  input: AddPushNotificationTargetToCustomerInput;
};


export type MutationAdminAddAwardTypeToSeasonArgs = {
  input: AdminAddAwardTypeToSeasonInput;
};


export type MutationAdminAddItemsToGuestSavedListsArgs = {
  input: AdminAddItemsToGuestSavedListsInput;
};


export type MutationAdminAddItemsToGuestSavedListsV2Args = {
  input: AdminAddItemsToGuestSavedListsInput;
};


export type MutationAdminCreateAwardSeasonArgs = {
  input: AdminCreateAwardSeasonInput;
};


export type MutationAdminCreatePlaceVideoPostArgs = {
  input: AdminCreatePlaceVideoPostInput;
};


export type MutationAdminDeletePlaceVideoPostArgs = {
  input: AdminDeletePlaceVideoPostInput;
};


export type MutationApplyCodeToGuestCurrencyAccountArgs = {
  input: ApplyCodeToGuestCurrencyAccountInput;
};


export type MutationApplyPromoCodeArgs = {
  input: ApplyPromoCodeInput;
};


export type MutationApplyPromoCodeV2Args = {
  input: ApplyPromoCodeInputV2;
};


export type MutationApplyPromoCodeV3Args = {
  input: ApplyPromoCodeInputV3;
};


export type MutationApplyPromoCodeV4Args = {
  input: ApplyPromoCodeInputV3;
};


export type MutationApplyPromoInProgressOrderArgs = {
  input: ApplyPromoInProgressOrderInput;
};


export type MutationApplyToastFundedOfferArgs = {
  input: ApplyToastFundedOfferInput;
};


export type MutationArchiveGuestCommentArgs = {
  input: ArchiveGuestCommentInput;
};


export type MutationArchiveGuestImageReviewArgs = {
  input: ArchiveGuestReviewInput;
};


export type MutationArchiveGuestPostArgs = {
  input: ArchiveGuestPostInput;
};


export type MutationArchiveGuestTextReviewArgs = {
  input: ArchiveGuestReviewInput;
};


export type MutationArchiveSocialUserProfilePhotoArgs = {
  input: ArchiveSocialUserProfilePhotoInput;
};


export type MutationAuthorizePaymentArgs = {
  input: AuthorizePaymentInput;
};


export type MutationBackfillGuestOrderHistoryByCardFingerprintsArgs = {
  input: BackfillGuestOrderHistoryByCardFingerprintsInput;
};


export type MutationBanSocialUserArgs = {
  request: BanSocialUserRequest;
};


export type MutationCompleteIdentityProfileArgs = {
  input: CompleteIdentityProfileInput;
};


export type MutationCompleteProfileCreationArgs = {
  input: CompleteProfileCreationInput;
};


export type MutationConfirmGuestArgs = {
  input: ConfirmGuestInput;
};


export type MutationConfirmGuestIdentityArgs = {
  input: ConfirmGuestIdentityInput;
};


export type MutationCreateApplePayPreauthArgs = {
  input: CreateApplePayPreauthInput;
};


export type MutationCreateCartArgs = {
  input: CreateCartInput;
};


export type MutationCreateEncryptedCreditCardPreauthArgs = {
  input: CreateEncryptedCreditCardPreauthInput;
};


export type MutationCreateGiftCardOrderArgs = {
  input: CreateGiftCardOrderInput;
};


export type MutationCreateGuestCommentOnPostArgs = {
  input: CreateGuestCommentOnPostInput;
};


export type MutationCreateOrUpdateGuestAwardArgs = {
  input: CreateOrUpdateGuestAwardInput;
};


export type MutationCreateOrUpdateSocialUserProfilePhotoArgs = {
  input: CreateOrUpdateSocialUserProfilePhotoInput;
};


export type MutationCreateOrUpdateToastOrderPostArgs = {
  input: CreateOrUpdateToastOrderPostInput;
};


export type MutationCreateSocialUserArgs = {
  request: CreateSocialUserRequest;
};


export type MutationDeleteAddressArgs = {
  input: DeleteAddressInput;
};


export type MutationDeleteCreditCardArgs = {
  input: DeleteCreditCardInput;
};


export type MutationDeleteCustomerPushNotificationTargetArgs = {
  input: DeleteCustomerPushNotificationTargetInput;
};


export type MutationDeleteGuestAddressArgs = {
  input: DeleteGuestAddressInput;
};


export type MutationDeleteGuestCommentOnPostArgs = {
  input: DeleteGuestCommentOnPostInput;
};


export type MutationDeleteGuestPaymentCardArgs = {
  input: DeleteGuestPaymentCardInput;
};


export type MutationDeleteItemFromCartArgs = {
  input: DeleteItemFromCartInput;
};


export type MutationDeleteItemFromCartV2Args = {
  input: DeleteItemFromCartInput;
};


export type MutationDeleteSocialUserArgs = {
  request: DeleteSocialUserRequest;
};


export type MutationEditItemInCartArgs = {
  input: EditItemInCartInput;
};


export type MutationEditItemInCartV2Args = {
  input: EditItemInCartInput;
};


export type MutationFollowSocialUsersArgs = {
  request: SocialFollowRequest;
};


export type MutationGenerateGuestMediaPostImageUploadUrlsArgs = {
  request: GenerateGuestMediaPostImageUploadUrlsRequest;
};


export type MutationGenerateGuestMediaPresignedImageUrlsArgs = {
  request: GenerateGuestMediaPresignedImageUrlsRequest;
};


export type MutationInitiateCardLinkingByPaymentMethodIdArgs = {
  input: InitiateCardLinkingByPaymentMethodIdInput;
};


export type MutationLinkCardFingerprintArgs = {
  input: LinkCardFingerprintInput;
};


export type MutationLinkCardFingerprintByPaymentMethodIdArgs = {
  input: LinkCardFingerprintByPaymentMethodIdInput;
};


export type MutationLoyaltyInquiryArgs = {
  input: LoyaltyInquiryInput;
};


export type MutationLoyaltyInquiryV2Args = {
  input: LoyaltyInquiryInput;
};


export type MutationLoyaltyInquiryV3Args = {
  input: LoyaltyInquiryInput;
};


export type MutationLoyaltySignupArgs = {
  input: LoyaltySignupInput;
};


export type MutationLoyaltySignupTransactionlessArgs = {
  input: LoyaltySignupTransactionlessInput;
};


export type MutationMakeCreditCardPrimaryArgs = {
  input: MakeCreditCardPrimaryInput;
};


export type MutationOpt_AddIncAuthAndFireArgs = {
  addIncAuthAndFire: Opt_AddIncAuthAndFireInput;
};


export type MutationOpt_CreatePaymentIntentArgs = {
  createPaymentIntentInput: Opt_CreatePaymentIntentInput;
};


export type MutationOpt_CreatePaymentIntentForSplitCheckBySelectionsArgs = {
  createPaymentIntentInput: Opt_CreatePaymentIntentForSplitCheckBySelectionsInput;
};


export type MutationOpt_IncrementAuthArgs = {
  incrementAuthInput: Opt_IncrementAuthInput;
};


export type MutationOpt_MdsCustomServerNotificationArgs = {
  mdsCustomServerNotificationInput: Opt_MdsCustomServerNotificationInput;
};


export type MutationOpt_MnpCreatePartyRefreshV2Args = {
  mnpCreatePartyInput: Opt_MnpCreatePartyInput;
};


export type MutationOpt_OptAddDiscountPayGArgs = {
  input: Opt_OptDiscountInput;
};


export type MutationOpt_OptAddDiscountPayGv2Args = {
  input: Opt_OptDiscountInput;
};


export type MutationOpt_OptAddDiscountTabsArgs = {
  input: Opt_OptDiscountInput;
};


export type MutationOpt_OptAddDiscountTabsV2Args = {
  input: Opt_OptDiscountInput;
};


export type MutationOpt_OptAddItemToPartyMemberCartV2Args = {
  optAddItemToPartyMemberCartInput: Opt_OptAddItemToPartyMemberCartInput;
};


export type MutationOpt_OptAddPreauthAndFireV2Args = {
  addPreauthAndFireInput: Opt_AddPreauthToPartyInput;
};


export type MutationOpt_OptApplyEvenSplitPaidPortionArgs = {
  optSplitInput: Opt_SplitPaymentPaidPortionInput;
};


export type MutationOpt_OptApplyLoyaltyPayGArgs = {
  optApplyLoyaltyInput: Opt_OptApplyLoyaltyInput;
};


export type MutationOpt_OptApplyLoyaltyPayGv2Args = {
  input: Opt_OptApplyLoyaltyInput;
};


export type MutationOpt_OptApplyLoyaltyTabsArgs = {
  optApplyLoyaltyInput: Opt_OptApplyLoyaltyInput;
};


export type MutationOpt_OptApplyLoyaltyTabsV2Args = {
  input: Opt_OptApplyLoyaltyInput;
};


export type MutationOpt_OptApplyPayGLoyaltyArgs = {
  optApplyPayGLoyaltyInput: Opt_OptApplyPayGLoyaltyInput;
};


export type MutationOpt_OptApplySplitTypeArgs = {
  optSplitInput: Opt_InitializeSplitPaymentDataInput;
};


export type MutationOpt_OptCreatePartyRefreshV2Args = {
  optCreatePartyInput: Opt_OptCreatePartyInput;
};


export type MutationOpt_OptDeleteItemInPartyMemberCartV2Args = {
  optDeleteItemInPartyMemberCartInput: Opt_OptEditOrDeleteItemInPartyMemberCartInput;
};


export type MutationOpt_OptEditItemInPartyMemberCartV2Args = {
  optEditItemInPartyMemberCartInput: Opt_OptEditOrDeleteItemInPartyMemberCartInput;
};


export type MutationOpt_OptFireTabRoundV2Args = {
  optFireTabRoundInput: Opt_OptFireTabRoundInput;
};


export type MutationOpt_OptIncrementAuthAndFireArgs = {
  incrementAuthAndFire: Opt_IncrementAuthAndFireInput;
};


export type MutationOpt_OptJoinOrCreatePartyDynamicQrRefreshArgs = {
  optDynamicQrJoinOrCreatePartyInput: Opt_OptDynamicQrJoinOrCreatePartyInput;
};


export type MutationOpt_OptJoinPartySecureV2Args = {
  optJoinPartySecureInput: Opt_OptJoinPartySecureInput;
};


export type MutationOpt_OptJoinPartyV2Args = {
  optJoinPartyInput: Opt_OptJoinPartyInput;
};


export type MutationOpt_OptPartyPayGCloseoutArgs = {
  optCloseoutInput: Opt_OptCloseoutInput;
};


export type MutationOpt_OptPartyPaygApplyPromoArgs = {
  optPartyPaygPromoInput: Opt_OptPartyPaygPromoInput;
};


export type MutationOpt_OptPartyPaygRemovePromoArgs = {
  memberAuthToken: Scalars['String']['input'];
  partyGuid: Scalars['ID']['input'];
  partyMemberGuid: Scalars['ID']['input'];
};


export type MutationOpt_OptPartyTabApplyPromoArgs = {
  optPartyTabPromoInput: Opt_OptPartyTabPromoInput;
};


export type MutationOpt_OptPartyTabCloseoutArgs = {
  optCloseoutInput?: InputMaybe<Opt_OptCloseoutInput>;
};


export type MutationOpt_OptPartyTabRemovePromoArgs = {
  memberAuthToken: Scalars['String']['input'];
  partyGuid: Scalars['ID']['input'];
  partyMemberGuid: Scalars['ID']['input'];
};


export type MutationOpt_OptRemoveDiscountPayGArgs = {
  input: Opt_OptDiscountInput;
};


export type MutationOpt_OptRemoveDiscountPayGv2Args = {
  input: Opt_OptDiscountInput;
};


export type MutationOpt_OptRemoveSplitPaymentDataArgs = {
  memberAuthToken: Scalars['String']['input'];
  partyGuid: Scalars['ID']['input'];
  partyMemberGuid: Scalars['ID']['input'];
};


export type MutationOpt_OptReorderItemV2Args = {
  optReorderItemInput: Opt_OptReorderItemInput;
};


export type MutationOpt_OptSplitCheckCloseoutArgs = {
  optCloseoutInput: Opt_OptCloseoutInput;
};


export type MutationOpt_OptValidateV2Args = {
  optValidateInput: Opt_OptValidateInput;
};


export type MutationOpt_PayForCheckArgs = {
  input: Opt_PayForCheckInput;
};


export type MutationOpt_PlaceApplePayOrderArgs = {
  input: Opt_PlaceApplePayOrderInput;
};


export type MutationOpt_SignUpToLoyaltyArgs = {
  input: Opt_SignUpToLoyaltyInput;
};


export type MutationOpt_StpCreatePartyRefreshV2Args = {
  stpCreatePartyInput: Opt_StpCreatePartyInput;
};


export type MutationOpt_StpJoinOrCreatePartyByMainCheckGuidArgs = {
  stpJoinOrCreatePartyByMainCheckGuidInput: Opt_StpJoinOrCreatePartyByMainCheckGuidInput;
};


export type MutationOpt_SubmitGuestFeedbackArgs = {
  guestFeedbackInput: Opt_GuestFeedbackInput;
};


export type MutationOpt_SubmitItemLevelFeedbackArgs = {
  input: Opt_ItemLevelFeedbackInput;
};


export type MutationOpt_UpdateBasicInfoArgs = {
  input: Opt_BasicInfoInput;
};


export type MutationOpt_UpdatePartyMemberArgs = {
  updatePartyMemberInput: Opt_UpdatePartyMemberInput;
};


export type MutationOpt_UpdatePaymentIntentArgs = {
  updatePaymentIntentInput: Opt_UpdatePaymentIntentInput;
};


export type MutationOpt_UpdatePaymentIntentForSplitCheckBySelectionsArgs = {
  updatePaymentIntentInput: Opt_UpdatePaymentIntentForSplitCheckBySelectionsInput;
};


export type MutationOpt_ValidateApplePayMerchantArgs = {
  input: Opt_ValidateApplePayMerchantInput;
};


export type MutationPasswordlessConfirmCodeArgs = {
  input: PasswordlessConfirmCodeInput;
};


export type MutationPasswordlessConfirmCodeUnifiedArgs = {
  input: PasswordlessConfirmCodeUnifiedInput;
};


export type MutationPasswordlessLoginArgs = {
  input: PasswordlessLoginInput;
};


export type MutationPasswordlessLoginUnifiedArgs = {
  input: PasswordlessLoginUnifiedInput;
};


export type MutationPasswordlessLogoutArgs = {
  input: PasswordlessLogoutInput;
};


export type MutationPasswordlessRefreshTokenArgs = {
  input: PasswordlessRefreshTokenInput;
};


export type MutationPasswordlessSignupArgs = {
  input: PasswordlessSignupInput;
};


export type MutationPayForCheckArgs = {
  input: PayForCheckInput;
};


export type MutationPlaceApmOrderArgs = {
  input: PlaceApmOrderInput;
};


export type MutationPlaceApplePayOrderArgs = {
  input: PlaceApplePayOrderInput;
};


export type MutationPlaceCashOrderArgs = {
  input: PlaceCashOrderInput;
};


export type MutationPlaceCcOrderArgs = {
  input: PlaceCcOrderInput;
};


export type MutationPlaceGiftCardOrderArgs = {
  input: PlaceGiftCardOrderInput;
};


export type MutationPlacePaidGiftCardOrderArgs = {
  cartGuid: Scalars['ID']['input'];
  paymentGuid: Scalars['ID']['input'];
  restaurantGuid: Scalars['ID']['input'];
};


export type MutationPlacePaidOrderArgs = {
  input: PlacePaidOrderInput;
};


export type MutationRejectSocialRequestsToFollowArgs = {
  request: RejectSocialFollowersRequest;
};


export type MutationRemoveGuestAwardArgs = {
  input: RemoveGuestAwardInput;
};


export type MutationRemoveGuestReactionFromPostArgs = {
  input: RemoveGuestReactionFromPostInput;
};


export type MutationRemoveGuestToastOrderImageReviewsArgs = {
  input: RemoveGuestToastOrderImageReviewsInput;
};


export type MutationRemoveItemsFromGuestSavedListsArgs = {
  input: Array<RemoveItemsFromGuestSavedListInput>;
};


export type MutationRemoveItemsFromGuestSavedListsV2Args = {
  input: Array<RemoveItemsFromGuestSavedListInput>;
};


export type MutationRemoveLoyaltyRedemptionArgs = {
  input: RemoveLoyaltyRedemptionInput;
};


export type MutationRemoveLoyaltyRedemptionV2Args = {
  input: RemoveLoyaltyRedemptionV2Input;
};


export type MutationRemovePromoCodeArgs = {
  input: RemovePromoCodeInput;
};


export type MutationRemovePromoCodeV2Args = {
  input: RemovePromoCodeInputV2;
};


export type MutationRemoveSocialFollowersArgs = {
  request: RemoveSocialFollowersRequest;
};


export type MutationRemoveToastFundedOfferArgs = {
  input: RemoveToastFundedOfferInput;
};


export type MutationReorderArgs = {
  input: ReorderInput;
};


export type MutationReorderV2Args = {
  input: ReorderInput;
};


export type MutationReportGuestCommentArgs = {
  input: ReportGuestCommentInput;
};


export type MutationReportGuestPostArgs = {
  input: ReportGuestPostInput;
};


export type MutationReportSocialUserArgs = {
  request: ReportSocialUserRequest;
};


export type MutationSendPaadLinkArgs = {
  input: PayAtADistanceLinkInput;
};


export type MutationSetFavoriteRestaurantsArgs = {
  overwriteAllExisting: Scalars['Boolean']['input'];
  restaurantGuids: Array<Scalars['ID']['input']>;
};


export type MutationSetMyUserVisibilityArgs = {
  request: SetMyUserVisibilityRequest;
};


export type MutationSetPaymentIntentArgs = {
  paymentIntentInput: PaymentIntentInput;
};


export type MutationSetSelectedShippingRateArgs = {
  input: SetSelectedShippingRateInput;
};


export type MutationSetupGuestArgs = {
  input: SetupGuestInput;
};


export type MutationShortenDataArgs = {
  urlShorteningInput: UrlShorteningInput;
};


export type MutationSignUpToLoyaltyArgs = {
  input: SignUpToLoyaltyInput;
};


export type MutationStartIdentityProfileArgs = {
  input: StartIdentityProfileInput;
};


export type MutationStartProfileCreationArgs = {
  input: StartProfileCreationInput;
};


export type MutationSubmitGuestFeedbackV2Args = {
  input: SubmitGuestFeedbackV2Input;
};


export type MutationSubmitGuestOrderExperienceRatingArgs = {
  input: SubmitGuestOrderExperienceRatingInput;
};


export type MutationSubmitGuestOrderMenuItemRatingsArgs = {
  input: SubmitGuestOrderMenuItemRatingInputs;
};


export type MutationSubmitGuestToastOrderImageReviewsArgs = {
  input: SubmitGuestToastOrderImageReviewsInput;
};


export type MutationSubmitGuestToastOrderTextReviewArgs = {
  input: SubmitGuestToastOrderTextReviewInput;
};


export type MutationUnbanSocialUserArgs = {
  request: UnbanSocialUserRequest;
};


export type MutationUnfollowSocialUsersArgs = {
  request: SocialUnfollowRequest;
};


export type MutationUnlinkCardFingerprintArgs = {
  input: UnlinkCardFingerprintInput;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateBasicInfoArgs = {
  input: BasicInfoInput;
};


export type MutationUpdateDiningOptionArgs = {
  input: UpdateDiningOptionInput;
};


export type MutationUpdateFulfillmentAndClearCartArgs = {
  input: UpdateFulfillmentAndClearCartInput;
};


export type MutationUpdateFulfillmentAndValidateArgs = {
  input: UpdateFulfillmentAndValidateInput;
};


export type MutationUpdateGuestAddressArgs = {
  input: UpdateGuestAddressInput;
};


export type MutationUpdateGuestContactArgs = {
  input: UpdateGuestContactInput;
};


export type MutationUpdateGuestPostVisibilityArgs = {
  input: UpdateGuestPostVisibilityInput;
};


export type MutationUpdatePrimaryGuestPaymentCardArgs = {
  input: UpdatePrimaryGuestPaymentCardInput;
};


export type MutationValidateAddressArgs = {
  input: AddressValidationInput;
};


export type MutationValidateApplePayMerchantArgs = {
  input: ValidateApplePayMerchantInput;
};


export type MutationValidateApplePayMerchantWipArgs = {
  input: ValidateApplePayMerchantInput;
};


export type MutationValidateCartPreCheckoutArgs = {
  input: ValidateCartPreCheckoutInput;
};


export type MutationWalkout_CreatePreauthOrderForBookingArgs = {
  appliedPreauthInfo: AppliedPreauthInfoInput;
  bookingId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};

export type NearbyRestaurantSearchInput = {
  /** If set, disables the default behavior of filtering out restaurants which don't have the online ordering product module. */
  allowRestaurantsWithoutOnlineOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  /** Latitude and longitude */
  coordinates: GeoCoordinatesInput;
  /** If set, filters to restaurants where delivery is available (true) or not available (false) If not set, does not filter on this criteria. Works for both first-party and DaaS deliveries. */
  deliveryAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Choose to display distance to restaurants in miles or kilometers. Defaults to miles. */
  distanceUnit?: InputMaybe<DistanceUnit>;
  /** The number of requested results Cannot exceed the maximum which is 200 */
  limit: Scalars['Int']['input'];
  /** If set, filters by whether the restaurant takes online reservations */
  onlineReservationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, filters by whether the restaurant takes online waitlist submissions */
  onlineWaitlistEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The radius by which to restrict results for geographic queries in miles If not passed in, will not filter by a default value */
  radius?: InputMaybe<Scalars['Int']['input']>;
  /** If requesting the upcoming online ordering schedule, the number of days for which the schedule should be retrieved. This field has a maximum value of 30. */
  scheduleDayCount?: InputMaybe<Scalars['Int']['input']>;
  /** If requesting the upcoming online ordering schedule, the date on which the schedule should start */
  scheduleStartDate?: InputMaybe<Scalars['String']['input']>;
  /** The search string by which to query restaurants */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** If set, filters to restaurants where takeout is enabled (true) or not enabled (false) If not set, does not filter on this criteria. */
  takeoutEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NearbyRestaurantsInput = {
  diningOption: DiningOptionBehavior;
  fulfillmentDateTime: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  longitude: Scalars['Float']['input'];
  radius: Scalars['Float']['input'];
};

export type NewAddressInput = {
  deliveryInfo: DeliveryInfoInput;
  /** If **saveAddress** is **true**, set the name/label for the address, e.g. "Home", "Work" */
  name?: InputMaybe<Scalars['String']['input']>;
  /** This field indicates whether or not the customer would like to save the new address. If it is not found in the input, it will have **false** as a default value. For unauthenticated place order mutations, addresses will never be saved, but we may implement that in the future. For authenticated place order mutations, the client should include this field as part of the input. */
  saveAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewCardInput = {
  /** First 6 digits (BIN) to be passed through to CCPartner for fraud prevention */
  cardFirst6?: InputMaybe<Scalars['String']['input']>;
  /** Last 4 digits to be passed through to CCPartner for fraud prevention */
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  /** The encrypted credit card information. */
  encryptedCardDataString: Scalars['String']['input'];
  /** The algorithm used to encrypt the credit card information. */
  encryptionKeyId: Scalars['String']['input'];
  /** Two-digit expiration month to be passed through to CCPartner for OPT preauth */
  expMonth?: InputMaybe<Scalars['String']['input']>;
  /** Two-digit expiration year to be passed through to CCPartner for OPT preauth */
  expYear?: InputMaybe<Scalars['String']['input']>;
  /** This field indicates whether or not the customer would like to save the new credit card. If it is not found in the input, it will have **false** as a default value. For unauthenticated **placeCcOrder**, the value of this field only matters if customer guid is also supplied on the **PlaceCCOrderInput**, to allow saving a card on an unauthenticated account For authenticated **placeCcOrder**, the client should include this field as part of the input. */
  saveCard?: InputMaybe<Scalars['Boolean']['input']>;
  /** Billing zip code to be passed through to CCPartner for fraud prevention */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type NewFollowRequestGuestNotificationHubItem = GuestNotificationHubItem & {
  __typename?: 'NewFollowRequestGuestNotificationHubItem';
  follower?: Maybe<SocialUser>;
  id: Scalars['ID']['output'];
  notificationRoutes?: Maybe<NotificationHubRoutes>;
  notificationText: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type NewFollowerGuestNotificationHubItem = GuestNotificationHubItem & {
  __typename?: 'NewFollowerGuestNotificationHubItem';
  follower?: Maybe<SocialUser>;
  id: Scalars['ID']['output'];
  notificationRoutes?: Maybe<NotificationHubRoutes>;
  notificationText: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type NoTargeting = BaseOfferTargeting & {
  __typename?: 'NoTargeting';
  type: Scalars['String']['output'];
};

export type NotFollowingPostAuthorError = Error & {
  __typename?: 'NotFollowingPostAuthorError';
  message: Scalars['String']['output'];
};

export type NotificationHubCampaignReward = {
  trackId: Scalars['String']['output'];
};

export type NotificationHubPromotionalGuestCurrencyReward = NotificationHubCampaignReward & {
  __typename?: 'NotificationHubPromotionalGuestCurrencyReward';
  trackId: Scalars['String']['output'];
};

export type NotificationHubRoutes = {
  __typename?: 'NotificationHubRoutes';
  consumerNativeApp?: Maybe<Scalars['String']['output']>;
};

export type NvBrandsInput = {
  defaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  restaurantGuid: Scalars['String']['input'];
};

export enum Opt_AdPlacement {
  OptCheckout = 'OPT_CHECKOUT',
  StpCheckout = 'STP_CHECKOUT'
}

export type Opt_AddIncAuthAndFireInput = {
  /** Customer's information. */
  customer: Opt_OrderAtTableCustomerInput;
  /** Data required to increment auth */
  incrementAuthData: Opt_IncrementAuthDataInput;
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** RestaurantGuid for the new preauth tab. */
  restaurantGuid: Scalars['ID']['input'];
  /** Card details from SPI SDK */
  spiCardInfo: Opt_SpiCardInfoInput;
};

export type Opt_AddPreauthToPartyInput = {
  /** Customer's information. */
  customer?: InputMaybe<Opt_OrderAtTableCustomerInput>;
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** A new credit card with encrypted data. */
  newCardInput?: InputMaybe<Opt_NewCardInput>;
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** Apple Pay payment token */
  pkPaymentToken?: InputMaybe<Scalars['String']['input']>;
  /** RestaurantGuid for the new preauth tab. */
  restaurantGuid: Scalars['ID']['input'];
  /** A customer's saved credit card. This is for future use. For now, preauth tabs can only use new cards */
  savedCardInput?: InputMaybe<Opt_SavedCardInput>;
};

export type Opt_ApplicableCustomerRewardInput = {
  /** The order amount that the customer is seeing while placing the order, accounting for the reward. */
  customerExpectedAmount: Scalars['Float']['input'];
  /** The customer reward to be applied to the order being placed. */
  reward: Opt_ApplyCustomerRewardInput;
};

export type Opt_AppliedCustomerReward = {
  __typename?: 'OPT_AppliedCustomerReward';
  amount?: Maybe<Scalars['Float']['output']>;
  beforeTax?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rewardType?: Maybe<Opt_RewardType>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** An object representing the raw applied discount. */
export type Opt_AppliedDiscount = {
  __typename?: 'OPT_AppliedDiscount';
  appliedPromoCode?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Opt_Discount>;
  discountAmount: Scalars['Float']['output'];
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['ID']['output']>;
  loyaltyDetails?: Maybe<Opt_LoyaltyDetails>;
  name: Scalars['String']['output'];
  processingState?: Maybe<Scalars['String']['output']>;
};

export type Opt_AppliedLoyaltyInfo = {
  __typename?: 'OPT_AppliedLoyaltyInfo';
  loyaltyIdentifier: Scalars['ID']['output'];
  maskedLoyaltyIdentifier: Scalars['String']['output'];
  vendor: Scalars['String']['output'];
};

export type Opt_AppliedPreauthInfo = {
  __typename?: 'OPT_AppliedPreauthInfo';
  cardHolderExpirationMonth: Scalars['String']['output'];
  cardHolderExpirationYear: Scalars['String']['output'];
  cardHolderFirstName: Scalars['String']['output'];
  cardHolderLastName?: Maybe<Scalars['String']['output']>;
  cardType: Opt_CardType;
  guid: Scalars['ID']['output'];
  last4CardDigits: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

/** A percentage/open/fixed service charge added to a check which could represent in general an upcharge like a gratuity or delivery fee. Whether the upcharge is taxable is defined in the restaurant-configured serviceCharge. The fields on the AppliedServiceCharge are computed based on the referenced ServiceCharge configuration. */
export type Opt_AppliedServiceCharge = {
  __typename?: 'OPT_AppliedServiceCharge';
  chargeAmount: Scalars['Float']['output'];
  chargeType: Opt_ServiceChargeType;
  externalId?: Maybe<Scalars['ID']['output']>;
  gratuity: Scalars['Boolean']['output'];
  guid?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  serviceCharge: Opt_ServiceCharge;
  serviceChargeCalculation: Opt_ServiceChargeCalculation;
  serviceChargeCategory?: Maybe<Opt_ServiceChargeCategory>;
  serviceChargeDetails?: Maybe<Opt_ServiceChargeDetails>;
  taxAmount: Scalars['Float']['output'];
  taxable: Scalars['Boolean']['output'];
};

export type Opt_ApplyCustomerRewardInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  beforeTax?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Opt_RewardType>;
};

/** link to loyalty docs: https://github.toasttab.com/toasttab/toast-cards/blob/main/toast-cards-api/src/main/java/com/toasttab/service/cards/api/inquiry/balance/BalanceStateData.kt */
export type Opt_BalanceStateData = {
  __typename?: 'OPT_BalanceStateData';
  balance?: Maybe<Scalars['Int']['output']>;
  balancePoints?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Opt_BalanceStateMessages>;
};

/** link to loyalty docs: https://github.toasttab.com/toasttab/toast-cards/blob/main/toast-cards-api/src/main/java/com/toasttab/service/cards/api/inquiry/balance/BalanceMessagesData.kt */
export type Opt_BalanceStateMessages = {
  __typename?: 'OPT_BalanceStateMessages';
  balance?: Maybe<Scalars['String']['output']>;
  balanceShort?: Maybe<Scalars['String']['output']>;
};

/** Fields that can be changed as part of updating the basic info on an account. All are required, but can be left the same as the current values stored in the database. */
export type Opt_BasicInfoInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Concrete type for Boolean feature flag results. Contains the flag and a Boolean value representing its current state. */
export type Opt_BooleanFeatureFlagResult = Opt_FeatureFlagResult & {
  __typename?: 'OPT_BooleanFeatureFlagResult';
  flag: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type Opt_BrandingInformationInput = {
  /** Type of advertisement being ran */
  adType?: InputMaybe<Scalars['String']['input']>;
  /** Brand the advertisement is for */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** Amount user will receive in Toast cash (if $0 no reward is issued) */
  creditRewardsAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum check amount required be eligible for reward */
  minimumSpendAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Payment method such as click to pay or apple pay, etc if being used in a joint campaign with a card brand */
  paymentMethod?: InputMaybe<Opt_PaymentMethods>;
};

export enum Opt_CardType {
  Amex = 'AMEX',
  Cit = 'CIT',
  Diners = 'DINERS',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
  Laser = 'LASER',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Solo = 'SOLO',
  Unknown = 'UNKNOWN',
  Visa = 'VISA'
}

export type Opt_CartMessage = {
  __typename?: 'OPT_CartMessage';
  messageType?: Maybe<Scalars['String']['output']>;
  userFacingMessage?: Maybe<Scalars['String']['output']>;
};

export type Opt_CartPaymentOption = {
  __typename?: 'OPT_CartPaymentOption';
  paymentType: Opt_PaymentType;
};

export type Opt_CartPaymentOptions = {
  __typename?: 'OPT_CartPaymentOptions';
  atCheckout: Array<Maybe<Opt_CartPaymentOption>>;
  uponReceipt: Array<Maybe<Opt_CartPaymentOption>>;
};

export enum Opt_CheckPaymentStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Paid = 'PAID'
}

/** An item on an order that has already been placed. */
export type Opt_CheckSelection = {
  /** List of discounts applied directly to this item as opposed to the whole check. */
  appliedDiscounts: Array<Opt_AppliedDiscount>;
  /** External ID that matches with the user's selection when placing the order */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Includes the unit of measure for the item as well as the quantity to be measured. */
  fractionalQuantity: Opt_FractionalQuantity;
  /** the ID of the item group this selection's item is a part of */
  itemGroupGuid?: Maybe<Scalars['String']['output']>;
  /** the ID of the item this selection represents */
  itemGuid?: Maybe<Scalars['String']['output']>;
  /** List of all modifiers included on this item */
  modifiers: Array<Opt_CompletedOrderModifierSelection>;
  /** The item's display name */
  name: Scalars['String']['output'];
  /** The cost of the Selection before any discounts are applied to the order. Where taxInclusion is 'INCLUDED' a tax inclusive value is returned. */
  preDiscountPrice?: Maybe<Scalars['Float']['output']>;
  /** The item's price (including the price of any modifiers) */
  price: Scalars['Float']['output'];
  /** Quantity of this item (non-integer quantities indicate split items) */
  quantity: Scalars['Float']['output'];
  usesFractionalQuantity: Scalars['Boolean']['output'];
};

/** An item on an order that has already been placed. */
export type Opt_CheckSelectionGuid = Opt_CheckSelection & {
  __typename?: 'OPT_CheckSelectionGuid';
  appliedDiscounts: Array<Opt_AppliedDiscount>;
  externalId?: Maybe<Scalars['String']['output']>;
  fractionalQuantity: Opt_FractionalQuantity;
  /** ID for the selection. If guid is set and externalID is null the selection came from the POS. */
  guid: Scalars['ID']['output'];
  itemGroupGuid?: Maybe<Scalars['String']['output']>;
  itemGuid?: Maybe<Scalars['String']['output']>;
  modifiers: Array<Opt_CompletedOrderModifierSelection>;
  name: Scalars['String']['output'];
  preDiscountPrice?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  usesFractionalQuantity: Scalars['Boolean']['output'];
  /** Indicates whether this selection was voided */
  voided?: Maybe<Scalars['Boolean']['output']>;
};

/** An item on an order that has already been placed. */
export type Opt_CheckSelectionNoGuid = Opt_CheckSelection & {
  __typename?: 'OPT_CheckSelectionNoGuid';
  appliedDiscounts: Array<Opt_AppliedDiscount>;
  externalId?: Maybe<Scalars['String']['output']>;
  fractionalQuantity: Opt_FractionalQuantity;
  itemGroupGuid?: Maybe<Scalars['String']['output']>;
  itemGuid?: Maybe<Scalars['String']['output']>;
  modifiers: Array<Opt_CompletedOrderModifierSelection>;
  name: Scalars['String']['output'];
  preDiscountPrice?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  usesFractionalQuantity: Scalars['Boolean']['output'];
};

export type Opt_Click2PayInput = {
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  correlationId: Scalars['String']['input'];
  flowId: Scalars['String']['input'];
  merchantTransactionId: Scalars['String']['input'];
  srcDpaId: Scalars['String']['input'];
};

export enum Opt_Client {
  ConsumerAppIos = 'CONSUMER_APP_IOS',
  OnlineOrdering = 'ONLINE_ORDERING'
}

/** An order that has already been placed. Contains fields useful for displaying past orders or for an order confirmation screen. */
export type Opt_CompletedOrder = {
  __typename?: 'OPT_CompletedOrder';
  /**
   * The optional applied reward, if any for the order. If present, use the **tax** and **total** for this object for the values after the reward has been applied.
   * @deprecated Use discounts field
   */
  appliedCustomerReward?: Maybe<Opt_AppliedCustomerReward>;
  /** Guid of the check on this order, used primarily for creating a loyalty account to connect the order to the new account */
  checkGuid: Scalars['ID']['output'];
  /** The display number assigned to this order's check (only one check per order for digital orders) */
  checkNumber?: Maybe<Scalars['Int']['output']>;
  /** (Deprecated) The curbside pickup options for an order. Can be null if curbside pickup indication is not needed. */
  curbsidePickup?: Maybe<Opt_CurbsidePickup>;
  /** The curbside pickup information for an order. Can be null if curbside pickup indication is not needed. */
  curbsidePickupV2?: Maybe<Opt_CurbsidePickupV2>;
  /**
   * Provided personal information, either from inputs for guest orders or retrieved from customermgmt for orders with a saved account
   * @deprecated use customerV2
   */
  customer: Opt_CustomerInfo;
  /** Provided personal information, either from inputs for guest orders or retrieved from customermgmt for orders with a saved account. Will only be present if returned from PlaceOrder or if the user is authenticated. */
  customerV2?: Maybe<Opt_CustomerInfo>;
  /** The total amount of delivery charges on this order based on **deliveryInfo**, included in the **total** below, assuming this was a delivery order. */
  deliveryChargeTotal: Scalars['Float']['output'];
  /** The provided delivery info used to calculate delivery fees, assuming this was a delivery order. Will only be present if returned from PlaceOrder or if the user is authenticated. */
  deliveryInfo?: Maybe<Opt_DeliveryInfo>;
  /** Inferred dining option of the order, based on the presence of delivery info. Will be 'TAKEOUT' for both takeout and outpost orders; use **outpostOrder** field to know if an order is an outpost order. */
  diningOptionBehavior: Opt_DiningOptionBehavior;
  /** Optional discounts, if any, for the order. */
  discounts: Opt_Discounts;
  /** Timestamp of the estimated fulfillment (current time + quote time) */
  estimatedFulfillmentDate?: Maybe<Scalars['Float']['output']>;
  /** Gift card applied as payment */
  giftCard?: Maybe<Opt_GiftCardPayment>;
  /** The message set by the restaurant in the OO-config for takeout orders, null if unset by the restaurant */
  guestCommunication?: Maybe<Scalars['String']['output']>;
  /** The guid of the order object in the database */
  guid: Scalars['ID']['output'];
  /** Whether the order has loyalty info attached, meaning a loyalty account was found with the same email at this restaurant */
  hasLoyaltyAttached: Scalars['Boolean']['output'];
  /** Number of items present on this order */
  numberOfSelections: Scalars['Int']['output'];
  /** Timestamp of when the order was placed */
  openedDateTime: Scalars['Float']['output'];
  /** The current state the order is in. Order's not submitted to a KDS will return null */
  orderStatus?: Maybe<Opt_OrderStatusType>;
  /** The fee the user has paid for using outpost. Only not null if the user actually order from outpost. */
  outpostFee?: Maybe<Scalars['Float']['output']>;
  /** Whether or not the order is being delivered to Outpost. False (or null) is a standard takeout order. */
  outpostOrder?: Maybe<Scalars['Boolean']['output']>;
  /** Enum defining which kind of payment was used to place this order */
  paymentType: Opt_PaymentType;
  /** Restaurant the order was placed at, which contains all relevant information (name, address, etc.) */
  restaurant: Opt_Restaurant;
  /** List of items present on this order */
  selections: Array<Opt_CompletedOrderSelection>;
  /** The total amount of service charges on this order, included in the **total** below. Does not include delivery charges. */
  serviceChargeTotal: Scalars['Float']['output'];
  /** The subtotal of the order (price without tax/tip/service charges), included in the **total** below */
  subtotal: Scalars['Float']['output'];
  /**
   * The total amount of taxes on this order, included in the **total** below
   * @deprecated Use taxV2 field
   */
  tax: Scalars['Float']['output'];
  /** The total amount of taxes on this order after applying global promos, included in the **totalV2** below */
  taxV2: Scalars['Float']['output'];
  /** The tip for the order, included in the **total** below */
  tip: Scalars['Float']['output'];
  /**
   * The final price of the order, including **subtotal**, **tax**, **tip**, and **serviceChargeTotal**
   * @deprecated Use totalV2 field
   */
  total: Scalars['Float']['output'];
  /** The final price of the order, including **subtotal**, **tax**, **tip**, **serviceChargeTotal** and **discounts** */
  totalV2: Scalars['Float']['output'];
};

export type Opt_CompletedOrderInput = {
  orderGuid: Scalars['ID']['input'];
  restaurantGuid: Scalars['ID']['input'];
};

/** A modifier on an item for an order that has already been placed. */
export type Opt_CompletedOrderModifierSelection = {
  __typename?: 'OPT_CompletedOrderModifierSelection';
  /** List of nested modifier selections */
  modifiers: Array<Opt_CompletedOrderModifierSelection>;
  /** Display name of the modifier */
  name: Scalars['String']['output'];
  /** The modifier's price */
  price: Scalars['Float']['output'];
  /** Indicates whether this modifier was voided, only relevant for OPT open tab orders. */
  voided?: Maybe<Scalars['Boolean']['output']>;
};

/** An item on an order that has already been placed. */
export type Opt_CompletedOrderSelection = {
  __typename?: 'OPT_CompletedOrderSelection';
  /** List of discounts applied directly to this item as opposed to the whole check. */
  appliedDiscounts: Array<Maybe<Opt_AppliedDiscount>>;
  /** External ID that matches with the user's selection when placing the order */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Includes the unit of measure for the item as well as the quantity to be measured. */
  fractionalQuantity: Opt_FractionalQuantity;
  /** ID for the selection. If guid is set and externalID is null the selection came from the POS. */
  guid: Scalars['ID']['output'];
  /** the ID of the item group this selection's item is a part of */
  itemGroupGuid?: Maybe<Scalars['String']['output']>;
  /** the ID of the item this selection represents */
  itemGuid?: Maybe<Scalars['String']['output']>;
  /** List of all modifiers included on this item */
  modifiers: Array<Opt_CompletedOrderModifierSelection>;
  /** The item's display name */
  name: Scalars['String']['output'];
  /** The cost of the Selection before any discounts are applied to the order */
  preDiscountPrice?: Maybe<Scalars['Float']['output']>;
  /** The item's price (including the price of any modifiers) */
  price: Scalars['Float']['output'];
  /** Quantity of this item (including modifiers) */
  quantity: Scalars['Int']['output'];
  usesFractionalQuantity: Scalars['Boolean']['output'];
  /** Indicates whether this selection was voided, only relevant for OPT open tab orders. */
  voided?: Maybe<Scalars['Boolean']['output']>;
};

export type Opt_ContactInfo = {
  contact: Scalars['String']['input'];
  contactType: Opt_ContactInfoType;
};

export enum Opt_ContactInfoType {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export type Opt_CreatePaymentIntentForSplitCheckBySelectionsInput = {
  /** Email to be sent for fraud checks. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** List of selections to split, paired with floats indicating how they should be split. */
  selectionsToSplit: Array<Opt_SplitItemInput>;
};

export type Opt_CreatePaymentIntentInput = {
  /** Identifier for the check */
  checkGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Email to be sent for fraud checks. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** Flag indicating if incremental authorization is requested for a payment intent. */
  requestIncrementalAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether split payment data should be used for pricing. */
  useSplitPaymentData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Opt_CreatePaymentIntentResponse = Opt_PaymentIntent | Opt_PaymentIntentError;

/** An object representing curbside pickup options */
export type Opt_CurbsidePickup = {
  __typename?: 'OPT_CurbsidePickup';
  selected: Scalars['Boolean']['output'];
};

export type Opt_CurbsidePickupInput = {
  selected: Scalars['Boolean']['input'];
};

export type Opt_CurbsidePickupInputV2 = {
  notes?: InputMaybe<Scalars['String']['input']>;
  transportColor?: InputMaybe<Scalars['String']['input']>;
  transportDescription: Scalars['String']['input'];
};

/** An object representing curbside pickup information */
export type Opt_CurbsidePickupV2 = {
  __typename?: 'OPT_CurbsidePickupV2';
  notes?: Maybe<Scalars['String']['output']>;
  transportColor?: Maybe<Scalars['String']['output']>;
  transportDescription: Scalars['String']['output'];
};

/** The stored data for a customer account that is visible to the customer */
export type Opt_Customer = {
  __typename?: 'OPT_Customer';
  addresses: Array<Opt_SavedAddress>;
  /** List of saved credit cards for this customer, sorted with the primary card first */
  creditCards: Array<Opt_SavedCreditCard>;
  /** Email (primary identifier for the customer account) */
  email: Scalars['String']['output'];
  /** First name, from basic info - not a required field when creating an account on OO so can be nullable */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Customer guid */
  guid: Scalars['ID']['output'];
  /** Last name, from basic info - not a required field when creating an account on OO so can be nullable */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Phone number, from basic info - not a required field when creating an account on OO so can be nullable */
  phone?: Maybe<Scalars['String']['output']>;
};

export type Opt_CustomerInfo = {
  __typename?: 'OPT_CustomerInfo';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type Opt_CustomerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export enum Opt_DdiMode {
  Mnp = 'MNP',
  Opt = 'OPT',
  Stp = 'STP',
  Tts = 'TTS'
}

export type Opt_DeleteItemFromCartInput = {
  /** The GUID of the cart that the cart item referenced by **selectionGuid** would be removed from. */
  cartGuid: Scalars['ID']['input'];
  /** Indicates the cart item to be removed from the cart referenced by **cartGuid**. */
  selectionGuid: Scalars['ID']['input'];
};

export type Opt_DeliveryInfo = {
  __typename?: 'OPT_DeliveryInfo';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  /** Notes for the delivery driver */
  notes?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type Opt_DeliveryInfoInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  /** Notes for the delivery driver */
  notes?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export enum Opt_DiningOptionBehavior {
  /** The order is to be delivered to the diner. */
  Delivery = 'DELIVERY',
  /** The order is to be picked up at an outpost. */
  Outpost = 'OUTPOST',
  /** The order is to be picked up at the restaurant. */
  TakeOut = 'TAKE_OUT'
}

export type Opt_Discount = {
  __typename?: 'OPT_Discount';
  guid?: Maybe<Scalars['ID']['output']>;
};

/** An object represeting the various discounts that can be applied to an order. Each field will contain an object with each discount's associated information, such as type, name, and amount. */
export type Opt_Discounts = {
  __typename?: 'OPT_Discounts';
  globalReward?: Maybe<Opt_AppliedCustomerReward>;
  loyaltyDiscount?: Maybe<Opt_LoyaltyDiscount>;
  loyaltyDiscounts: Array<Maybe<Opt_LoyaltyDiscount>>;
  restaurantDiscount?: Maybe<Opt_RestaurantDiscount>;
};

export type Opt_DoItemTag = {
  __typename?: 'OPT_DoItemTag';
  guid: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Opt_DoMenuImage = {
  __typename?: 'OPT_DoMenuImage';
  item?: Maybe<Opt_DoMenuImageItem>;
};

export type Opt_DoMenuImageItem = {
  __typename?: 'OPT_DoMenuImageItem';
  fullPath?: Maybe<Scalars['String']['output']>;
};

export type Opt_DoMenuItem = {
  __typename?: 'OPT_DoMenuItem';
  description: Scalars['String']['output'];
  dietaryItemTags: Array<Opt_DoItemTag>;
  guid: Scalars['ID']['output'];
  imageLink?: Maybe<Scalars['String']['output']>;
  imageUrls?: Maybe<Opt_ImageSet>;
  images?: Maybe<Opt_DoMenuImage>;
  itemTags: Array<Opt_DoItemTag>;
  modifierGroups: Array<Maybe<Opt_DoModifierGroup>>;
  name: Scalars['String']['output'];
  outOfStock: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  unitOfMeasure?: Maybe<Opt_UnitOfMeasure>;
  usesFractionalQuantity: Scalars['Boolean']['output'];
};

export type Opt_DoModifierGroup = {
  __typename?: 'OPT_DoModifierGroup';
  guid: Scalars['ID']['output'];
  maxSelections: Scalars['Int']['output'];
  minSelections: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  options: Array<Maybe<Opt_DoModifierOption>>;
  pricingMode: Scalars['String']['output'];
};

export type Opt_DoModifierOption = {
  __typename?: 'OPT_DoModifierOption';
  allowsDuplicates: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  guid: Scalars['ID']['output'];
  images: Opt_DoMenuImage;
  isDefault: Scalars['Boolean']['output'];
  maxSelections: Scalars['Int']['output'];
  modifierGroups: Array<Maybe<Opt_DoModifierGroup>>;
  name: Scalars['String']['output'];
  outOfStock: Scalars['Boolean']['output'];
  price: Scalars['Float']['output'];
};

export type Opt_EditItemInCartInput = {
  /** The GUID of the cart that the cart item referenced by **selectionGuid** belongs to. */
  cartGuid: Scalars['ID']['input'];
  /** Indicates what the cart item referenced by **selectionGuid** would look like. */
  selection: Opt_SelectionInput;
  /** Indicates the cart item to be modified. */
  selectionGuid: Scalars['ID']['input'];
};

/** Indicates the failure to achieve the intended result of a query or mutation. */
export type Opt_Error = {
  message: Scalars['String']['output'];
};

export enum Opt_FailureReason {
  AvsDecline = 'AVS_DECLINE',
  BankDecline = 'BANK_DECLINE',
  CvvDecline = 'CVV_DECLINE',
  DuplicateRequest = 'DUPLICATE_REQUEST',
  Fraudulent = 'FRAUDULENT',
  InternalError = 'INTERNAL_ERROR'
}

/** Interface for all types of feature flag results to implement. LaunchDarkly supports Boolean, String, Number, and JSON feature flags currently. */
export type Opt_FeatureFlagResult = {
  flag: Scalars['String']['output'];
};

export enum Opt_FeedbackRating {
  Dislike = 'DISLIKE',
  Like = 'LIKE'
}

export type Opt_FractionalQuantity = {
  __typename?: 'OPT_FractionalQuantity';
  quantity: Scalars['Float']['output'];
  unitOfMeasure: Opt_UnitOfMeasure;
};

/** Data representing the unit of measure to use when weighing out an item and the amount to weigh. */
export type Opt_FractionalQuantityInput = {
  quantity: Scalars['Float']['input'];
  unitOfMeasure: Opt_UnitOfMeasure;
};

/** General error resulted from temporary unavailability or failure of critical upstream services or tripped circuit breakers. */
export type Opt_GeneralError = Opt_Error & {
  __typename?: 'OPT_GeneralError';
  code: Opt_GeneralErrorCode;
  message: Scalars['String']['output'];
};

export enum Opt_GeneralErrorCode {
  /** Temporary unavailability or failure of upstream services. */
  Retryable = 'RETRYABLE',
  /** Tripped circuit breakers within BFF or critical upstream services. */
  ServiceUnavailable = 'SERVICE_UNAVAILABLE'
}

export type Opt_GetMenusError = Opt_Error & {
  __typename?: 'OPT_GetMenusError';
  code?: Maybe<Opt_GetMenusErrorCode>;
  message: Scalars['String']['output'];
};

export enum Opt_GetMenusErrorCode {
  Failed = 'FAILED'
}

export type Opt_GetMenusResponse = {
  __typename?: 'OPT_GetMenusResponse';
  menus: Array<Opt_MenuV2>;
};

export type Opt_GetMenusResponseOrError = Opt_GetMenusError | Opt_GetMenusResponse;

export type Opt_GetPopularItemsError = Opt_Error & {
  __typename?: 'OPT_GetPopularItemsError';
  code: Opt_GetPopularItemsErrorCode;
  message: Scalars['String']['output'];
};

export enum Opt_GetPopularItemsErrorCode {
  Failed = 'FAILED'
}

export type Opt_GetPopularItemsInput = {
  channelGuid?: InputMaybe<Scalars['String']['input']>;
  popItemsLimit: Scalars['Int']['input'];
  restaurantGuid: Scalars['String']['input'];
};

export type Opt_GetPopularItemsResponse = Opt_GetPopularItemsError | Opt_PopularItemsV3;

/** Gift Card Config */
export type Opt_GiftCardConfig = {
  __typename?: 'OPT_GiftCardConfig';
  /** Can add value */
  addValueAllowed: Scalars['Boolean']['output'];
  /** Can lookup value */
  lookupAllowed: Scalars['Boolean']['output'];
  /** Can Purchase Gift Cards */
  purchaseAllowed: Scalars['Boolean']['output'];
  /** Can Redeem Gift Cards */
  redemptionAllowed: Scalars['Boolean']['output'];
  /** Can allow guest to tip with a gift card */
  tipAllowed: Scalars['Boolean']['output'];
};

/** Gift Card Links are so clients can direct guests to Toastweb URLs to purchase or manage gift cards */
export type Opt_GiftCardLinks = {
  __typename?: 'OPT_GiftCardLinks';
  /** Allows the client to set guest expectations for the checkValueLink link if true, indicate that value can be added if false, do no indicate value can be added */
  addValueEnabled: Scalars['Boolean']['output'];
  /** The link in Toastweb for guests to check a gift card value or add value if addValueEnabled === true if null, the client should not display the link */
  checkValueLink?: Maybe<Scalars['String']['output']>;
  /** The link in Toastweb for guests to purchase gift cards if null, the client should not display the link */
  purchaseLink?: Maybe<Scalars['String']['output']>;
};

export type Opt_GiftCardPayment = {
  __typename?: 'OPT_GiftCardPayment';
  /** The balance of the gift card used as payment on the order */
  appliedBalance: Scalars['Float']['output'];
};

export type Opt_GiftCardPaymentInput = {
  /** The full numeric card number, no spaces */
  cardNumber: Scalars['String']['input'];
  /** The amount that is expected to be used during the place order action If check amount > expectedAvailableBalance and expectedAvailableBalance < the actual balance of the gift card at the time of placing the order and the alternative payment is Credit Card then the order will error because the amount charged to the card would be more than expected by the client */
  expectedAvailableBalance: Scalars['Float']['input'];
};

export type Opt_GlobalGiftCardPaymentInput = {
  /** Identifier associated with the Toast Cash (global gift card). */
  cardIdentifier: Scalars['String']['input'];
  /** Amount the Toast Cash (global gift card) can cover. */
  expectedAvailableBalance: Scalars['Float']['input'];
};

export type Opt_GooglePayBillingAddress = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  administrativeArea?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  locality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  sortingCode?: InputMaybe<Scalars['String']['input']>;
};

export type Opt_GooglePayInput = {
  billingAddress: Opt_GooglePayBillingAddress;
  token: Scalars['String']['input'];
};

export type Opt_GuestCurrencyAccountPaymentInput = {
  expectedAvailableBalance: Scalars['Float']['input'];
};

export type Opt_GuestCurrencyConfig = {
  __typename?: 'OPT_GuestCurrencyConfig';
  /** Whether the restaurant has Guest Currency payments enabled. Currently, restaurants can opt-out of supporting this feature. Use to determine whether Guest Currency should be shown to the user as a valid payment option for this restaurant. To be enabled, a restaurant must accept promotional currencies */
  enabled: Scalars['Boolean']['output'];
  /** For cases where you need to know if specific types of guest currency are enabled for a restaurant. */
  promoEnabled: Scalars['Boolean']['output'];
  storedValueEnabled: Scalars['Boolean']['output'];
};

export type Opt_GuestFeedbackInput = {
  /** optional bool indicating the diner gave permission to be contacted */
  feedbackContactPermission?: InputMaybe<Scalars['Boolean']['input']>;
  /** guid of the feedback record in the g2 feedback service */
  feedbackGuid?: InputMaybe<Scalars['String']['input']>;
  /** additional metadata in the form of String: String */
  feedbackMeta?: InputMaybe<Array<InputMaybe<Opt_StringKeyValInput>>>;
  /** either LIKE or DISLIKE */
  feedbackRating: Opt_FeedbackRating;
  /** array of string tags the diner associated with their experience */
  feedbackTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** optional additional feedback text */
  feedbackText?: InputMaybe<Scalars['String']['input']>;
  /** ID of the order relating to this feedback */
  orderGuid: Scalars['ID']['input'];
  /** Party guest is a part of. */
  partyGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Guest's unique identifier. */
  partyMemberGuid?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the restaurant relating to this feedback */
  restaurantGuid: Scalars['ID']['input'];
};

/** GROUP ORDERING */
export type Opt_GuestFeedbackResponse = {
  __typename?: 'OPT_GuestFeedbackResponse';
  /** optional bool indicating the diner gave permission to be contacted */
  feedbackContactPermission?: Maybe<Scalars['Boolean']['output']>;
  /** guid of the feedback record in the g2 feedback service */
  feedbackGuid?: Maybe<Scalars['String']['output']>;
  /** additional metadata in the form of String: String */
  feedbackMeta?: Maybe<Array<Maybe<Opt_StringKeyVal>>>;
  /** either LIKE or DISLIKE */
  feedbackRating: Opt_FeedbackRating;
  /** array of string tags the diner associated with their experience */
  feedbackTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** optional additional feedback text */
  feedbackText?: Maybe<Scalars['String']['output']>;
  /** ID of the order relating to this feedback */
  orderGuid: Scalars['ID']['output'];
  /** ID of the restaurant relating to this feedback */
  restaurantGuid: Scalars['ID']['output'];
};

export type Opt_I18n = {
  __typename?: 'OPT_I18n';
  /** Restaurant's location / country. */
  country?: Maybe<Scalars['String']['output']>;
  /** A restaurants operating currency USD, EUR, GBP & CAD */
  currency?: Maybe<Scalars['String']['output']>;
  /** A restaurants operating locale. e.g. 'en-US', 'en-IE', 'fr-CH' */
  locale?: Maybe<Scalars['String']['output']>;
};

/** Contains a mapping of size to image paths. The sizes other than **raw** are resized from the original image, which is represented by **raw**. Resizing is done by the toast-image-lambda Lambda function and is cached on CloudFront. For details, refer to the [toast-image-lambda documentation](https://github.com/toasttab/system-docs/blob/master/consumer/image-processing/cached-resizing/Readme.md). */
export type Opt_ImageSet = {
  __typename?: 'OPT_ImageSet';
  /** 1080p */
  large: Scalars['String']['output'];
  /** 720p */
  medium: Scalars['String']['output'];
  /** the raw image that has not gone through resizing */
  raw: Scalars['String']['output'];
  /** 360p */
  small: Scalars['String']['output'];
  /** 1280p */
  xl: Scalars['String']['output'];
  /** 180p */
  xs: Scalars['String']['output'];
  /** 1920p */
  xxl: Scalars['String']['output'];
};

export type Opt_ImportStatus = {
  __typename?: 'OPT_ImportStatus';
  canImport: Scalars['Boolean']['output'];
  importCount: Scalars['Int']['output'];
};

/** An order with at least one, but potentially more, checks which are open. */
export type Opt_InProgressOrder = {
  __typename?: 'OPT_InProgressOrder';
  /** The check requested. Only the check matching the client's requested check will be returned. Will return null if no check matches the requested number or guid. */
  check?: Maybe<Opt_InProgressOrderCheck>;
  /**
   * The check requested. Only the check matching the client's requested check will be returned. Will return null if no check matches the requested number or guid.
   * @deprecated use check
   */
  checks: Array<Opt_InProgressOrderCheck>;
  guid: Scalars['ID']['output'];
  /** The restaurant associated with the order. Used so that the client can know if amex is accepted. */
  restaurant: Opt_Restaurant;
};

/** An open check associated with an InProgressOrder. */
export type Opt_InProgressOrderCheck = {
  __typename?: 'OPT_InProgressOrderCheck';
  /** The total amount unpaid on the check */
  amountRemaining: Scalars['Float']['output'];
  guid: Scalars['ID']['output'];
  /** All selections that have not been voided associated with the InProgressOrderCheck */
  selections: Array<Opt_InProgressOrderSelection>;
  /** The amount, before tax, on the check */
  subTotal: Scalars['Float']['output'];
  /** The sum of all surcharges applied to the check, most commonly an auto gratuity or less commonly a kitchen appreciation fee. */
  surchargeAmount: Scalars['Float']['output'];
  /** The amount of tax on the check */
  taxAmount: Scalars['Float']['output'];
  /** The total amount associated with the check */
  totalAmount: Scalars['Float']['output'];
};

/** Fetch an order with at least one open check. The order can be identified by the number of a check it contains, or by the table name the order is located at. */
export type Opt_InProgressOrderInput = {
  /** The guid of the check to be paid for */
  checkGuid?: InputMaybe<Scalars['String']['input']>;
  /** The guid of the restaurant which has the order being paid for */
  restaurantGuid: Scalars['ID']['input'];
  /** Removing support. Will return an error if requested. Please only use checkguid */
  tableName?: InputMaybe<Scalars['String']['input']>;
};

/** A selection associated with an InProgressOrderCheck. */
export type Opt_InProgressOrderSelection = {
  __typename?: 'OPT_InProgressOrderSelection';
  /** The name of the selection */
  name: Scalars['String']['output'];
  /** The net price, after tax and discounts, for the selection */
  price: Scalars['Float']['output'];
  /**
   * The number of selections this object represents
   * @deprecated Quantity Fraction
   */
  quantity: Scalars['Int']['output'];
  /** The number of selections this object represents, as a float. */
  quantityFraction: Scalars['Float']['output'];
};

export type Opt_IncrementAuthAndFireInput = {
  /** Customer's information. */
  customer?: InputMaybe<Opt_OrderAtTableCustomerInput>;
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
};

export type Opt_IncrementAuthData = {
  __typename?: 'OPT_IncrementAuthData';
  externalReferenceId: Scalars['ID']['output'];
  lastIncrement: Scalars['Boolean']['output'];
  paymentIntentId: Scalars['ID']['output'];
  paymentMethodId: Scalars['ID']['output'];
  spiPaymentType: Opt_SpiPaymentMethods;
};

export type Opt_IncrementAuthDataInput = {
  externalReferenceId: Scalars['ID']['input'];
  lastIncrement: Scalars['Boolean']['input'];
  paymentIntentId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
  spiPaymentType: Opt_SpiPaymentMethods;
};

export type Opt_IncrementAuthInput = {
  /** Indicates whether this is the last increment (closeout). */
  lastIncrement: Scalars['Boolean']['input'];
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** Tip amount */
  tipAmount: Scalars['Float']['input'];
};

export type Opt_IncrementAuthorizationAmountDetails = {
  __typename?: 'OPT_IncrementAuthorizationAmountDetails';
  surcharge?: Maybe<Scalars['Int']['output']>;
  tip: Scalars['Int']['output'];
};

export type Opt_IncrementAuthorizationFailure = {
  __typename?: 'OPT_IncrementAuthorizationFailure';
  failureReason?: Maybe<Scalars['String']['output']>;
  failureReasonDetail?: Maybe<Scalars['String']['output']>;
  isFailureRetryable?: Maybe<Scalars['Boolean']['output']>;
};

export type Opt_IncrementAuthorizationResponse = Opt_IncrementAuthorizationFailure | Opt_IncrementalAuthorization;

export type Opt_IncrementalAuthorization = {
  __typename?: 'OPT_IncrementalAuthorization';
  amount: Scalars['Int']['output'];
  amountDetails: Opt_IncrementAuthorizationAmountDetails;
  lastIncrement: Scalars['Boolean']['output'];
};

/** Indicates that although the intended result of a query or mutation was achieved, there are side effects that occurred that wouldn't affect downstream actions. */
export type Opt_Info = {
  message: Scalars['String']['output'];
};

export type Opt_InitializeSplitPaymentDataInput = {
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Indicates whether a split type is being overridden */
  overrideSplit: Scalars['Boolean']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** The split type and metadata */
  splitPaymentInitializationData: Opt_SplitPaymentInitializationDataInput;
};

export type Opt_ItemFeedbackInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Can be optionally provided to update an existing item review */
  feedbackGuid?: InputMaybe<Scalars['ID']['input']>;
  itemGroupGuid?: InputMaybe<Scalars['ID']['input']>;
  itemGuid: Scalars['ID']['input'];
  /** Time of submission provided by the client to support resolving race-conditions server-side, in ISO 8061 format. */
  submissionTime: Scalars['String']['input'];
  /** *Constraints:* * Maximal length: `250` */
  textFeedback?: InputMaybe<Scalars['String']['input']>;
  thumbRating?: InputMaybe<Opt_ItemFeedbackThumbRatingValue>;
};

export type Opt_ItemFeedbackPrompt = {
  __typename?: 'OPT_ItemFeedbackPrompt';
  displayName: Scalars['String']['output'];
  itemGroupGuid?: Maybe<Scalars['ID']['output']>;
  itemGuid: Scalars['ID']['output'];
};

export type Opt_ItemFeedbackSurvey = {
  __typename?: 'OPT_ItemFeedbackSurvey';
  checkGuid: Scalars['ID']['output'];
  /** The parameters to provide prompts for an item feedback survey Currently supports a maximum of ten prompts */
  itemPrompts: Array<Opt_ItemFeedbackPrompt>;
  orderGuid: Scalars['ID']['output'];
  paymentGuid: Scalars['ID']['output'];
  restaurantGuid: Scalars['ID']['output'];
};


export type Opt_ItemFeedbackSurveyItemPromptsArgs = {
  maxPrompts: Scalars['Int']['input'];
};

export type Opt_ItemFeedbackSurveyError = Opt_Error & {
  __typename?: 'OPT_ItemFeedbackSurveyError';
  message: Scalars['String']['output'];
};

export type Opt_ItemFeedbackSurveyLookupInput = {
  checkGuid: Scalars['ID']['input'];
  orderGuid: Scalars['ID']['input'];
  paymentGuid: Scalars['ID']['input'];
  restaurantGuid: Scalars['ID']['input'];
};

export type Opt_ItemFeedbackSurveyResponse = Opt_ItemFeedbackSurvey | Opt_ItemFeedbackSurveyError;

export enum Opt_ItemFeedbackThumbRatingValue {
  Dislike = 'DISLIKE',
  Like = 'LIKE'
}

export type Opt_ItemLevelFeedbackConfig = {
  __typename?: 'OPT_ItemLevelFeedbackConfig';
  enabled: Scalars['Boolean']['output'];
};

export type Opt_ItemLevelFeedbackInput = {
  checkGuid: Scalars['ID']['input'];
  itemRatings: Array<Opt_ItemFeedbackInput>;
  orderGuid: Scalars['ID']['input'];
  partyGuid?: InputMaybe<Scalars['ID']['input']>;
  partyMemberGuid?: InputMaybe<Scalars['ID']['input']>;
  paymentGuid: Scalars['ID']['input'];
  restaurantGuid: Scalars['ID']['input'];
};

/** General usage is deprecated in favor of ItemLevelFeedbackSubmissionsStatus */
export type Opt_ItemLevelFeedbackSubmission = {
  __typename?: 'OPT_ItemLevelFeedbackSubmission';
  /** An identifier for the created feedback record. Can be re-used in future mutations in order to update an existing record. For failed submissions, an empty string is returned (prefer ItemLevelFeedbackSubmissionsStatus for a better-formatted schema response) */
  feedbackGuid: Scalars['ID']['output'];
  /** The itemGuid for which the feedback was submitted. Acts as a stable identifier for a review submission in the absence of a feedbackGuid existing prior to the initial feedback submission. */
  itemGuid: Scalars['ID']['output'];
  status: Opt_ItemLevelFeedbackSubmissionStatus;
};

export type Opt_ItemLevelFeedbackSubmissionFailure = {
  __typename?: 'OPT_ItemLevelFeedbackSubmissionFailure';
  /** The itemGuid for which the feedback was submitted. Acts as a stable identifier for a review submission in the absence of a feedbackGuid existing prior to the initial feedback submission. */
  itemGuid: Scalars['ID']['output'];
};

export type Opt_ItemLevelFeedbackSubmissionResponse = {
  __typename?: 'OPT_ItemLevelFeedbackSubmissionResponse';
  /** @deprecated Use submissionsStatus */
  submissions: Array<Opt_ItemLevelFeedbackSubmission>;
  submissionsStatus: Array<Opt_ItemLevelFeedbackSubmissionsStatus>;
};

export enum Opt_ItemLevelFeedbackSubmissionStatus {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type Opt_ItemLevelFeedbackSubmissionSuccess = {
  __typename?: 'OPT_ItemLevelFeedbackSubmissionSuccess';
  /** An identifier for the created feedback record. Can be re-used in future mutations in order to update an existing record. */
  feedbackGuid: Scalars['ID']['output'];
  /** The itemGuid for which the feedback was submitted. Acts as a stable identifier for a review submission in the absence of a feedbackGuid existing prior to the initial feedback submission. */
  itemGuid: Scalars['ID']['output'];
};

export type Opt_ItemLevelFeedbackSubmissionsStatus = Opt_ItemLevelFeedbackSubmissionFailure | Opt_ItemLevelFeedbackSubmissionSuccess;

export type Opt_ItemTag = {
  __typename?: 'OPT_ItemTag';
  guid: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Line items pre-calculated for frontend display. All amounts should be positive: The frontend will decide if they should be shown negative. */
export type Opt_LineItems = {
  __typename?: 'OPT_LineItems';
  /** Null means 0 */
  discounts?: Maybe<Scalars['Float']['output']>;
  /** Null means 0 */
  loyaltyAmount?: Maybe<Scalars['Float']['output']>;
  /** Null means 0 */
  serviceChargeTotal?: Maybe<Scalars['Float']['output']>;
  subtotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  /** Null means 0 */
  totalPaid?: Maybe<Scalars['Float']['output']>;
  /** Null means 0 */
  totalRemaining?: Maybe<Scalars['Float']['output']>;
};

export type Opt_Location = {
  __typename?: 'OPT_Location';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  distanceFromCustomer?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  phone: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type Opt_LookupPartiesByCheckInput = {
  checkGuid: Scalars['String']['input'];
  restaurantGuid: Scalars['String']['input'];
};

export type Opt_LookupPartiesByTableInput = {
  activeOnly: Scalars['Boolean']['input'];
  restaurantGuid: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
};

export type Opt_LoyaltyConfig = {
  __typename?: 'OPT_LoyaltyConfig';
  /** The rate at which points are accrued for loyalty. Example: 2.0 means "1 point is earned for every 2 dollars" */
  accrualRate?: Maybe<Scalars['Float']['output']>;
  /** The number of points that a diner needs to reach before they are allowed to redeem */
  accrualTarget?: Maybe<Scalars['Int']['output']>;
  /** The amount each point is worth. Example: 0.2 means "0.2 dollars for every point" */
  conversionRate?: Maybe<Scalars['Float']['output']>;
  /** The custom description text, in case the loyalty program uses one. Will be null if the restaurant does not have loyalty program. */
  customDescription?: Maybe<Scalars['String']['output']>;
  /** Whether loyalty redemptions are enabled at this restaurant or not. Will be false if the restaurant does not have loyalty program. */
  loyaltyRedemptionEnabled: Scalars['Boolean']['output'];
  /** The one time point bonus for creating a new loyalty account */
  loyaltySignupBonus?: Maybe<Scalars['Int']['output']>;
  /** Whether loyalty signups are enabled at this restaurant or not. Will be false if the restaurant does not have a loyalty program. */
  loyaltySignupEnabled: Scalars['Boolean']['output'];
  /** The loyalty program description. */
  programDescription?: Maybe<Scalars['String']['output']>;
  /** The loyalty program name. Will be null if the restaurant does not have loyalty program. Clients usually display "{Restaurant Name} Rewards Program" as a fallback. */
  programName?: Maybe<Scalars['String']['output']>;
  /** The loyalty program type. Will be either "CASHBACK" or "ITEM". Defaulted to "CASHBACK" */
  rewardType: Scalars['String']['output'];
  /** The signup method. It can be "EMAIL" or "PHONE_NUMBER". Will be null if the restaurant does not have loyalty program. */
  signupMethod?: Maybe<Scalars['String']['output']>;
  /** Whether loyalty program uses a custom description or not. Will be false if the restaurant does not have loyalty program. */
  useCustomDescription: Scalars['Boolean']['output'];
};

export type Opt_LoyaltyDetails = {
  __typename?: 'OPT_LoyaltyDetails';
  referenceId?: Maybe<Opt_LoyaltyRedemptionType>;
  vendor?: Maybe<Scalars['String']['output']>;
};

/** An object representing a (restaurant-specific) loyalty redemption, which is tied to a customermgmt/loyalty account */
export type Opt_LoyaltyDiscount = {
  __typename?: 'OPT_LoyaltyDiscount';
  amount: Scalars['Float']['output'];
  guid: Scalars['ID']['output'];
};

export type Opt_LoyaltyRedemption = {
  __typename?: 'OPT_LoyaltyRedemption';
  redemptionAmount: Scalars['Float']['output'];
  redemptionGuid: Scalars['ID']['output'];
  type: Opt_LoyaltyRedemptionType;
};

export enum Opt_LoyaltyRedemptionType {
  BirthdayRewards = 'BIRTHDAY_REWARDS',
  ItemRewards = 'ITEM_REWARDS',
  LoyaltyDollarsAmounts = 'LOYALTY_DOLLARS_AMOUNTS',
  LoyaltyPointsAmount = 'LOYALTY_POINTS_AMOUNT'
}

/** link to loyalty docs: https://github.toasttab.com/toasttab/toast-cards/blob/main/toast-cards-api/src/main/java/com/toasttab/service/cards/api/inquiry/redemption/RewardMessagesData.kt */
export type Opt_LoyaltyRewardMessages = {
  __typename?: 'OPT_LoyaltyRewardMessages';
  nextRewardMessage?: Maybe<Scalars['String']['output']>;
  nextRewardMiniMessage?: Maybe<Scalars['String']['output']>;
  rewardLabelMessage?: Maybe<Scalars['String']['output']>;
  rewardValueMessage?: Maybe<Scalars['String']['output']>;
  unlockedMessage?: Maybe<Scalars['String']['output']>;
};

/** link to loyalty docs: https://github.toasttab.com/toasttab/toast-cards/blob/main/toast-cards-api/src/main/java/com/toasttab/service/cards/api/inquiry/redemption/RewardStateData.kt */
export type Opt_LoyaltyRewardState = {
  __typename?: 'OPT_LoyaltyRewardState';
  leftToTarget?: Maybe<Scalars['Int']['output']>;
  messages?: Maybe<Opt_LoyaltyRewardMessages>;
};

export type Opt_MdsCustomServerNotificationInput = {
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Message input by the guest */
  message: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** Restaurant identifier */
  restaurantGuid: Scalars['ID']['input'];
  /** Table name of this order */
  tableName?: InputMaybe<Scalars['String']['input']>;
};

export type Opt_MdsCustomServerNotificationResponse = Opt_MdsServerNotificationResponse | Opt_OptPartyError;

export type Opt_MdsServerNotificationResponse = {
  __typename?: 'OPT_MDSServerNotificationResponse';
  sent: Scalars['Boolean']['output'];
};

export type Opt_MnpCreatePartyInput = {
  /** User's contact info. Phone/email. */
  contactInfo?: InputMaybe<Opt_ContactInfo>;
  /** User's name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Used for disambiguating table names */
  restaurantGuid: Scalars['ID']['input'];
  /** Table the Party represents */
  tableName: Scalars['String']['input'];
};

export type Opt_MenuGroupV2 = {
  __typename?: 'OPT_MenuGroupV2';
  description?: Maybe<Scalars['String']['output']>;
  dietaryItemTags: Array<Opt_ItemTag>;
  groups: Array<Opt_MenuGroupV2>;
  guid: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  itemTags: Array<Opt_ItemTag>;
  items: Array<Opt_MenuItemV2>;
  masterID?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type Opt_MenuItemV2 = {
  __typename?: 'OPT_MenuItemV2';
  calories?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dietaryItemTags: Array<Opt_ItemTag>;
  guid: Scalars['ID']['output'];
  hasModifiers: Scalars['Boolean']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageUrls?: Maybe<Opt_ImageSet>;
  isDiscountable: Scalars['Boolean']['output'];
  itemGroupGuid: Scalars['ID']['output'];
  itemTags: Array<Opt_ItemTag>;
  modifierGroups: Array<Opt_ModifierGroupV2>;
  name: Scalars['String']['output'];
  outOfStock: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  pricingRules?: Maybe<Opt_PricingRules>;
  pricingStrategy: Opt_PricingStrategy;
  stockQuantity?: Maybe<Scalars['Float']['output']>;
  taxInfo: Array<Scalars['String']['output']>;
  unitOfMeasure: Opt_UnitOfMeasure;
  usesFractionalQuantity: Scalars['Boolean']['output'];
};


export type Opt_MenuItemV2ModifierGroupsArgs = {
  nestingLevel?: InputMaybe<Scalars['Int']['input']>;
};

export type Opt_MenuV2 = {
  __typename?: 'OPT_MenuV2';
  description?: Maybe<Scalars['String']['output']>;
  groups: Array<Opt_MenuGroupV2>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Opt_ModifierGroupInput = {
  guid: Scalars['ID']['input'];
  modifiers: Array<Opt_SelectionInput>;
};

export type Opt_ModifierGroupV2 = {
  __typename?: 'OPT_ModifierGroupV2';
  defaultOptionsChargePrice: Scalars['Boolean']['output'];
  defaultOptionsSubstitutionPricing: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  guid: Scalars['ID']['output'];
  isMultiSelect: Scalars['Boolean']['output'];
  maxSelections?: Maybe<Scalars['Int']['output']>;
  minSelections: Scalars['Int']['output'];
  modifiers: Array<Opt_ModifierOptionV2>;
  name: Scalars['String']['output'];
  pricingRules?: Maybe<Opt_PricingRules>;
  pricingStrategy: Opt_PricingStrategy;
  requiredMode: Opt_RequiredMode;
};

export type Opt_ModifierOptionV2 = {
  __typename?: 'OPT_ModifierOptionV2';
  allowsDuplicates: Scalars['Boolean']['output'];
  calories?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  guid: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  itemGuid: Scalars['ID']['output'];
  modifierGroups: Array<Opt_ModifierGroupV2>;
  name: Scalars['String']['output'];
  outOfStock: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  pricingRules?: Maybe<Opt_PricingRules>;
  pricingStrategy: Opt_PricingStrategy;
  stockQuantity?: Maybe<Scalars['Float']['output']>;
  unitOfMeasure: Opt_UnitOfMeasure;
};

export type Opt_NewAddressInput = {
  deliveryInfo: Opt_DeliveryInfoInput;
  /** If **saveAddress** is **true**, set the name/label for the address, e.g. "Home", "Work" */
  name?: InputMaybe<Scalars['String']['input']>;
  /** This field indicates whether or not the customer would like to save the new address. If it is not found in the input, it will have **false** as a default value. For unauthenticated place order mutations, addresses will never be saved, but we may implement that in the future. For authenticated place order mutations, the client should include this field as part of the input. */
  saveAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Opt_NewCardInput = {
  /** First 6 digits (BIN) to be passed through to CCPartner for fraud prevention */
  cardFirst6?: InputMaybe<Scalars['String']['input']>;
  /** Last 4 digits to be passed through to CCPartner for fraud prevention */
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  /** The encrypted credit card information. */
  encryptedCardDataString: Scalars['String']['input'];
  /** The algorithm used to encrypt the credit card information. */
  encryptionKeyId: Scalars['String']['input'];
  /** Two-digit expiration month to be passed through to CCPartner for OPT preauth */
  expMonth?: InputMaybe<Scalars['String']['input']>;
  /** Two-digit expiration year to be passed through to CCPartner for OPT preauth */
  expYear?: InputMaybe<Scalars['String']['input']>;
  /** This field indicates whether or not the customer would like to save the new credit card. If it is not found in the input, it will have **false** as a default value. For unauthenticated **placeCcOrder**, the value of this field only matters if customer guid is also supplied on the **PlaceCCOrderInput**, to allow saving a card on an unauthenticated account For authenticated **placeCcOrder**, the client should include this field as part of the input. */
  saveCard?: InputMaybe<Scalars['Boolean']['input']>;
  /** Billing zip code to be passed through to CCPartner for fraud prevention */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Concrete type for Numeric feature flag results. Contains the flag and a Float value representing its current state. */
export type Opt_NumericFeatureFlagResult = Opt_FeatureFlagResult & {
  __typename?: 'OPT_NumericFeatureFlagResult';
  flag: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Opt_NvBrandingConfig = {
  __typename?: 'OPT_NvBrandingConfig';
  /**
   * Retrieves keyword to send to Kevel ad server
   * @deprecated No longer needed for ad server.
   */
  campaignKeyword?: Maybe<Scalars['String']['output']>;
  /** Retrieves if new ventures branding applies to the restaurant based on guid. */
  isNvBrandingEnabled: Scalars['Boolean']['output'];
};

export type Opt_NvBrandsInput = {
  /** Where the ad will be placed in the guest experience. Defaults to STP_CHECKOUT. */
  adPlacement?: InputMaybe<Opt_AdPlacement>;
  /** Default value for return if error occurs. */
  defaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** GUID for restaurant to see if branding should be shown on that particular restaurant. */
  restaurantGuid: Scalars['String']['input'];
};

export type Opt_OptAddItemToPartyMemberCartInput = {
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** Selection to add to cart. */
  selection: Opt_SelectionInput;
};

export type Opt_OptApplyLoyaltyInput = {
  memberAuthToken: Scalars['ID']['input'];
  partyGuid: Scalars['ID']['input'];
  partyMemberGuid: Scalars['ID']['input'];
};

export type Opt_OptApplyPayGLoyaltyInput = {
  memberAuthToken: Scalars['ID']['input'];
  partyGuid: Scalars['ID']['input'];
  partyMemberGuid: Scalars['ID']['input'];
};

export type Opt_OptCart = {
  __typename?: 'OPT_OPTCart';
  cartMessages?: Maybe<Array<Maybe<Opt_CartMessage>>>;
  creditCardConfig: Opt_RestaurantCreditCardConfig;
  guid: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['String']['output']>;
  order: Opt_OptOrderNoGuid;
  paymentOptions: Opt_CartPaymentOptions;
  preComputedTips: Array<Opt_PreComputedTip>;
};

export type Opt_OptCartError = Opt_Error & {
  __typename?: 'OPT_OPTCartError';
  code?: Maybe<Opt_OptCartErrorCode>;
  message: Scalars['String']['output'];
};

export enum Opt_OptCartErrorCode {
  CartLookupError = 'CART_LOOKUP_ERROR'
}

export type Opt_OptCartResponse = Opt_OptCart | Opt_OptCartError;

export type Opt_OptCheckV2 = {
  appliedLoyaltyInfo?: Maybe<Opt_AppliedLoyaltyInfo>;
  /** List of any service charges applied to this check. Null means no charges have been applied to this check. */
  appliedServiceCharges?: Maybe<Array<Opt_AppliedServiceCharge>>;
  /** Customer associated with this check. */
  customer?: Maybe<Opt_CustomerInfo>;
  /** An object containing potential discounts applied to order, such as a global reward or a restaurant specific reward. */
  discounts: Opt_Discounts;
  /** Total amount expected to pay to close the check. Especially useful to validate that client and server check states are in sync, and to display to the guest a consistent remaining balance calculation. */
  expectedPaymentAmount: Scalars['Float']['output'];
  /** How many selections can be found in the Selections field of this check. */
  numberOfSelections: Scalars['Int']['output'];
  /** Precomputed tip suggestions for a check, based on restaurant preferences */
  preComputedTips: Array<Opt_PreComputedTip>;
  /** Total cost of all selections on this check, before discounts and before tax. Voided items are considered $0.00. */
  preDiscountedSubtotal: Scalars['Float']['output'];
  /** List of selections (items ordered by guest) on this check. */
  selections: Array<Opt_CheckSelection>;
  /** Does not include delivery charges. */
  serviceChargeTotal: Scalars['Float']['output'];
  /** Total cost of all selections on this check, after discounts but before tax. */
  subtotal: Scalars['Float']['output'];
  /** The order tax calculated after applying global promo codes if they exist. */
  tax: Scalars['Float']['output'];
  /** The order tax calculated after applying global promo codes if they exist, minus any taxes on surcharge service charges. This is for display purposes, as surcharge tax should have its own line item. */
  taxWithoutSurchargeTax: Scalars['Float']['output'];
  /** The order total calculated after applying global promo codes if they exist. Includes tip amounts if tip(s) are already on the check from previous payments. */
  total: Scalars['Float']['output'];
};

export type Opt_OptCheckV2Guid = Opt_OptCheckV2 & {
  __typename?: 'OPT_OPTCheckV2Guid';
  /** Total already paid toward the balance of this check, including tip amounts. */
  amountAlreadyPaid: Scalars['Float']['output'];
  appliedLoyaltyInfo?: Maybe<Opt_AppliedLoyaltyInfo>;
  /** If a card was preauthorized for this check, this field holds the relevant information. */
  appliedPreauthInfo?: Maybe<Opt_AppliedPreauthInfo>;
  appliedServiceCharges?: Maybe<Array<Opt_AppliedServiceCharge>>;
  customer?: Maybe<Opt_CustomerInfo>;
  discounts: Opt_Discounts;
  expectedPaymentAmount: Scalars['Float']['output'];
  /** Unique identifier for this check. */
  guid: Scalars['ID']['output'];
  /** Whether or not the check has been closed out. (Derived from voided state and paymentStatus) */
  isClosed: Scalars['Boolean']['output'];
  /** Check number- non-unique identifier. */
  number?: Maybe<Scalars['Int']['output']>;
  numberOfSelections: Scalars['Int']['output'];
  /** The status of the check's payments. */
  paymentStatus: Opt_CheckPaymentStatus;
  /** List of payments made against this check. */
  payments: Array<Opt_OptPayment>;
  preComputedTips: Array<Opt_PreComputedTip>;
  preDiscountedSubtotal: Scalars['Float']['output'];
  selections: Array<Opt_CheckSelection>;
  serviceChargeTotal: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  /** A breakdown of potential surcharge amounts on the check depending on the payment type. Payment types are unique across all list elements, e.g. you won't see multiple surcharge entries with PaymentType.CREDIT. */
  surcharges?: Maybe<Array<Opt_SurchargeSummaryForPaymentTypes>>;
  tax: Scalars['Float']['output'];
  taxWithoutSurchargeTax: Scalars['Float']['output'];
  /** Total tips paid on this check. */
  tip: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};


export type Opt_OptCheckV2GuidSurchargesArgs = {
  totalGiftCardBalance?: InputMaybe<Scalars['Float']['input']>;
};

export type Opt_OptCheckV2NoGuid = Opt_OptCheckV2 & {
  __typename?: 'OPT_OPTCheckV2NoGuid';
  appliedLoyaltyInfo?: Maybe<Opt_AppliedLoyaltyInfo>;
  appliedServiceCharges?: Maybe<Array<Opt_AppliedServiceCharge>>;
  customer?: Maybe<Opt_CustomerInfo>;
  discounts: Opt_Discounts;
  expectedPaymentAmount: Scalars['Float']['output'];
  numberOfSelections: Scalars['Int']['output'];
  preComputedTips: Array<Opt_PreComputedTip>;
  preDiscountedSubtotal: Scalars['Float']['output'];
  selections: Array<Opt_CheckSelection>;
  serviceChargeTotal: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  /** A breakdown of potential surcharge amounts on the check depending on the payment type. Payment types are unique across all list elements, e.g. you won't see multiple surcharge entries with PaymentType.CREDIT. */
  surcharges?: Maybe<Array<Opt_SurchargeSummaryForPaymentTypes>>;
  tax: Scalars['Float']['output'];
  taxWithoutSurchargeTax: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type Opt_OptCloseoutInput = {
  /** Information for issuing rewards */
  adInfo?: InputMaybe<Opt_BrandingInformationInput>;
  /** Indicates which check to pay for. Affects only optPartyTabCloseout, as other payment mutations automatically infer this information. */
  checkGuid?: InputMaybe<Scalars['ID']['input']>;
  /** When paying with click 2 pay, the information needed to authorize the payment */
  click2PayParams?: InputMaybe<Opt_Click2PayInput>;
  /** Customer's information, required for unauthenticated order. When used with authenticated order, will override email preferences inferred from authorized customer. */
  customer: Opt_OrderAtTableCustomerInput;
  /** DEPRECATED - Unconfirmed account flows no longer supported Customer guid, should only be provided for an unconfirmed account - authenticated orders placed for a confirmed account will use the customer guid from the access token (JWT) */
  customerGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Amount the client expects to be paying for their check. Validates against current state of check before payment. Must NOT include surcharge amount. */
  expectedAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Additional surcharge amount the client expects to be paying for their check. */
  expectedSurchargeAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Gift Card Payment */
  giftCard?: InputMaybe<Opt_GiftCardPaymentInput>;
  /** Promo code to be used for a Toast Cash redemption. Normal restaurant promo codes should *not* be submitted here. */
  globalGiftCard?: InputMaybe<Opt_GlobalGiftCardPaymentInput>;
  /** Google Pay payment parameters */
  googlePayParams?: InputMaybe<Opt_GooglePayInput>;
  /** Pay using Toast Cash from the guest currency account, a global wallet tied to the guest */
  guestCurrencyAccount?: InputMaybe<Opt_GuestCurrencyAccountPaymentInput>;
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** A new credit card with encrypted data. */
  newCardInput?: InputMaybe<Opt_NewCardInput>;
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** Apple Pay payment token */
  pkPaymentToken?: InputMaybe<Scalars['String']['input']>;
  /** When splitting evenly, the number of portions to pay for. */
  portionsToBePaid?: InputMaybe<Scalars['Float']['input']>;
  /** Guest communication preferences after a successful payment has been processed. If null, how to handle guest communication will fall back to a default behavior. */
  postPaymentCommunicationPreferences?: InputMaybe<Opt_PostPaymentCommunicationPreferences>;
  /** A customer's preauthedCard guid, if present, should be compared against the preauth guid stored on the order. If it's a match, use it to submit the payment request. */
  preauthedCardGuid?: InputMaybe<Scalars['String']['input']>;
  /** RestaurantGuid for party. */
  restaurantGuid: Scalars['ID']['input'];
  /** A customer's saved credit card. */
  savedCardInput?: InputMaybe<Opt_SavedCardInput>;
  /** Only necessary if a user wants to split a check off in a non-default manner. Affects only optSplitCheckCloseout. */
  selectionsToSplit?: InputMaybe<Array<Opt_SplitItemInput>>;
  /** An ID corresponding to an already-authorized payment via SPI. */
  spiPayment?: InputMaybe<Opt_SpiPayment>;
  /** A SPI payment that needs to be updated and confirmed in the backend. */
  spiPaymentData?: InputMaybe<Opt_SpiPaymentData>;
  /** The amount of tip the customer intends to give. */
  tipAmount: Scalars['Float']['input'];
  /** When splitting evenly, the total number of portions in the check. */
  totalPortions?: InputMaybe<Scalars['Float']['input']>;
};

export type Opt_OptCloseoutResponse = Opt_OptPartyPaymentErrorV2 | Opt_OptPartyPaymentResponse | Opt_OptSplitCheckPaymentError;

export type Opt_OptConfig = {
  __typename?: 'OPT_OPTConfig';
  /** Whether or not a restaurant wishes to allow for joinable parties */
  allowJoinableParty?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not a restaurant wishes to enforce preauthorization for tabs */
  allowPreauth?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not a restaurant wishes to allow users to open tabs */
  allowTabs?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not a restaurant wishes to text a guest upon ticket fulfillment */
  allowTextFulfillment?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not a restaurant has OPT view-only menus enabled */
  viewOnlyMenu?: Maybe<Scalars['Boolean']['output']>;
};

export type Opt_OptCreatePartyInput = {
  /** User's contact info. Phone/email. */
  contactInfo?: InputMaybe<Opt_ContactInfo>;
  /** User's name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Used for disambiguating table names */
  restaurantGuid: Scalars['ID']['input'];
  /** Table the Party represents */
  tableName: Scalars['String']['input'];
  /** Users can choose to have a private party */
  visibility?: InputMaybe<Opt_PartyVisibility>;
};

/** GROUP ORDERING */
export type Opt_OptEditOrDeleteItemInPartyMemberCartInput = {
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** Selection to add to cart. */
  selection?: InputMaybe<Opt_SelectionInput>;
  /** Guid of the selection to be updated. */
  selectionGuid: Scalars['String']['input'];
};

export type Opt_OptFireTabRoundInput = {
  /** Customer's information. */
  customer?: InputMaybe<Opt_OrderAtTableCustomerInput>;
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
};

export type Opt_OptGetGiftCardBalanceInput = {
  /** String corresponding to either a restaurant gift card or a Toast Cash card. */
  cardIdentifier: Scalars['String']['input'];
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
};

export type Opt_OptGiftCardBalanceResponse = {
  __typename?: 'OPT_OPTGiftCardBalanceResponse';
  /** An unredeemed Toast Cash card (global gift card). */
  globalGiftCard?: Maybe<Opt_OptGlobalGiftCard>;
  /** An unredeemed restaurant gift card. */
  restaurantGiftCard?: Maybe<Opt_OptRestaurantGiftCard>;
};

export type Opt_OptGlobalGiftCard = {
  __typename?: 'OPT_OPTGlobalGiftCard';
  /** Identifier associated with the Toast Cash (global gift card). */
  cardIdentifier: Scalars['String']['output'];
  /** Amount the Toast Cash (global gift card) can cover. */
  expectedAvailableBalance: Scalars['Float']['output'];
};

export type Opt_OptJoinPartyInput = {
  /** User's contact info. Phone/email. */
  contactInfo?: InputMaybe<Opt_ContactInfo>;
  /** User's name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Party to join */
  partyGuid: Scalars['ID']['input'];
};

export type Opt_OptJoinPartySecureInput = {
  /** User's contact info. Phone/email. */
  contactInfo?: InputMaybe<Opt_ContactInfo>;
  /** User's name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Party to join */
  partyGuid: Scalars['ID']['input'];
  /** PIN required to join party. */
  pin: Scalars['String']['input'];
};

/** Essentially OPTTabOrderV2, renamed for clarity */
export type Opt_OptOrder = {
  checks: Array<Opt_OptCheckV2>;
};

export type Opt_OptOrderError = Opt_Error & {
  __typename?: 'OPT_OPTOrderError';
  code: Opt_OptPayForCheckErrorCode;
  invalidatesPreauth: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type Opt_OptOrderGuid = Opt_OptOrder & {
  __typename?: 'OPT_OPTOrderGuid';
  /** Guid for the primary check on this order */
  checkGuid: Scalars['ID']['output'];
  checks: Array<Opt_OptCheckV2Guid>;
  /** Order guid */
  guid: Scalars['ID']['output'];
  /** Whether the entire order is closed. False if any checks on the order are unpaid. */
  isClosed: Scalars['Boolean']['output'];
};

export type Opt_OptOrderNoGuid = Opt_OptOrder & {
  __typename?: 'OPT_OPTOrderNoGuid';
  checks: Array<Opt_OptCheckV2NoGuid>;
};

export type Opt_OptParties = {
  __typename?: 'OPT_OPTParties';
  parties: Array<Opt_OptPartyV3>;
};

export type Opt_OptPartiesLookupError = Opt_Error & {
  __typename?: 'OPT_OPTPartiesLookupError';
  code: Opt_OptPartiesLookupErrorCode;
  message: Scalars['String']['output'];
};

export enum Opt_OptPartiesLookupErrorCode {
  LookupFailed = 'LOOKUP_FAILED'
}

export type Opt_OptPartiesLookupResponse = Opt_OptParties | Opt_OptPartiesLookupError;

export type Opt_OptPartyCartResponse = Opt_OptCart | Opt_OptPartyError;

export type Opt_OptPartyError = Opt_Error & {
  __typename?: 'OPT_OPTPartyError';
  code?: Maybe<Opt_OptPartyErrorCode>;
  message: Scalars['String']['output'];
};

export enum Opt_OptPartyErrorCode {
  AddIncAuthFailed = 'ADD_INC_AUTH_FAILED',
  AddParticipantsToSplitPaymentBucketFailed = 'ADD_PARTICIPANTS_TO_SPLIT_PAYMENT_BUCKET_FAILED',
  AddPreauthFailed = 'ADD_PREAUTH_FAILED',
  AddToCartFailed = 'ADD_TO_CART_FAILED',
  ApplyLoyaltyDiscountFailed = 'APPLY_LOYALTY_DISCOUNT_FAILED',
  ApplyLoyaltyInfoFailed = 'APPLY_LOYALTY_INFO_FAILED',
  ApplyPromoFailed = 'APPLY_PROMO_FAILED',
  CalcSplitPaymentChargesFailed = 'CALC_SPLIT_PAYMENT_CHARGES_FAILED',
  CartValidationFailed = 'CART_VALIDATION_FAILED',
  CreateMnpPartyFailed = 'CREATE_MNP_PARTY_FAILED',
  CreateOptPartyFailed = 'CREATE_OPT_PARTY_FAILED',
  CreatePartyFailed = 'CREATE_PARTY_FAILED',
  CreateSplitPaymentBucketFailed = 'CREATE_SPLIT_PAYMENT_BUCKET_FAILED',
  CreateStpPartyFailed = 'CREATE_STP_PARTY_FAILED',
  FireTabRoundFailed = 'FIRE_TAB_ROUND_FAILED',
  GetCartFailed = 'GET_CART_FAILED',
  /** Can't pay for checks containing gift card selections via Toast Pay */
  HasGiftCardSelection = 'HAS_GIFT_CARD_SELECTION',
  IncrementAuthFailed = 'INCREMENT_AUTH_FAILED',
  JoinOrCreateOptPartyDynamicQrFailed = 'JOIN_OR_CREATE_OPT_PARTY_DYNAMIC_QR_FAILED',
  JoinOrCreatePartyFailed = 'JOIN_OR_CREATE_PARTY_FAILED',
  JoinOrCreateStpPartyMainCheckGuid = 'JOIN_OR_CREATE_STP_PARTY_MAIN_CHECK_GUID',
  JoinPartyFailed = 'JOIN_PARTY_FAILED',
  LookupPartyFailed = 'LOOKUP_PARTY_FAILED',
  LookupPartyTableFailed = 'LOOKUP_PARTY_TABLE_FAILED',
  MemberNotFound = 'MEMBER_NOT_FOUND',
  MissingCardInput = 'MISSING_CARD_INPUT',
  MoveItemInSplitPaymentBucketFailed = 'MOVE_ITEM_IN_SPLIT_PAYMENT_BUCKET_FAILED',
  /** deprecated: use OPTPartyPaymentError */
  PartyAlreadyPaid = 'PARTY_ALREADY_PAID',
  /** deprecated: use OPTPartyPaymentError */
  PartyMemberAlreadyPaid = 'PARTY_MEMBER_ALREADY_PAID',
  /** deprecated: use OPTPartyPaymentError */
  PartyPaymentOutOfSync = 'PARTY_PAYMENT_OUT_OF_SYNC',
  PreauthAlreadyExists = 'PREAUTH_ALREADY_EXISTS',
  PriceSplitCheckFailed = 'PRICE_SPLIT_CHECK_FAILED',
  RemoveLoyaltyDiscountFailed = 'REMOVE_LOYALTY_DISCOUNT_FAILED',
  RemoveParticipantsFromSplitPaymentBucketFailed = 'REMOVE_PARTICIPANTS_FROM_SPLIT_PAYMENT_BUCKET_FAILED',
  RemovePromoFailed = 'REMOVE_PROMO_FAILED',
  /** This error will be sent if there has been a payment posted to the check. At this point, the split type and portions are locked in. */
  SplitPaymentAssignmentLockedInError = 'SPLIT_PAYMENT_ASSIGNMENT_LOCKED_IN_ERROR',
  /** This error will be sent if the number of paid portions is fewer than the number of portions being asked to remove */
  SplitPaymentCannotRemovePaidPortions = 'SPLIT_PAYMENT_CANNOT_REMOVE_PAID_PORTIONS',
  /** This error will be sent if the user tries to assign paid portions to a check, but the check has been completely paid for */
  SplitPaymentNoPortionsLeftError = 'SPLIT_PAYMENT_NO_PORTIONS_LEFT_ERROR',
  /** This error will be sent if the party object doesn't have splitPaymentData */
  SplitPaymentNoSplitDataFound = 'SPLIT_PAYMENT_NO_SPLIT_DATA_FOUND',
  /** This error will be sent if a split type has already been chosen, but no payment has been posted. The user can still change the split type and number of portions, but must request it with an explicit override request */
  SplitPaymentOverrideNeededError = 'SPLIT_PAYMENT_OVERRIDE_NEEDED_ERROR',
  /** This error will be sent if the user tries to assign paid portions to a check, but the number of portions they're paying for are no longer available. Instead, a smaller amount of portions are. */
  SplitPaymentPaidPortionOverpaymentError = 'SPLIT_PAYMENT_PAID_PORTION_OVERPAYMENT_ERROR',
  SplitPaymentUnknownError = 'SPLIT_PAYMENT_UNKNOWN_ERROR',
  /** This error will be sent if the user tries to assign paid portions to a check, but the number of portions available to split by doesn't match. */
  SplitPortionMismatchError = 'SPLIT_PORTION_MISMATCH_ERROR',
  /** deprecated: use OPTPartyPaymentError */
  UndefinedSplitPaymentMethod = 'UNDEFINED_SPLIT_PAYMENT_METHOD',
  UpdatePartyMemberFailed = 'UPDATE_PARTY_MEMBER_FAILED',
  /** This error will be sent if the user tries to assign paid portions to a non SPLIT EVENLY split type check. */
  WrongSplitTypeError = 'WRONG_SPLIT_TYPE_ERROR'
}

export type Opt_OptPartyMemberStub = {
  __typename?: 'OPT_OPTPartyMemberStub';
  emoji?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Opt_OptPartyMemberV2 = {
  __typename?: 'OPT_OPTPartyMemberV2';
  appliedDiscounts: Array<Maybe<Opt_AppliedDiscount>>;
  /** List of applied loyalty rewards - if this party member has a loyalty account Used for /v2 versions of apply loyalty and add/remove discounts endpoints */
  appliedRewards?: Maybe<Array<Maybe<Opt_RedemptionData>>>;
  availableDiscounts: Array<Maybe<Opt_AppliedDiscount>>;
  /** List of available loyalty rewards - if this party member has a loyalty account Used for /v2 versions of apply loyalty and add/remove discounts endpoints */
  availableRewards?: Maybe<Array<Maybe<Opt_RedemptionData>>>;
  /** Guid corresponding to this member's cart. */
  cartGuid?: Maybe<Scalars['ID']['output']>;
  /** Check this party member is associated with. Null if they don't have a specific check. */
  claimedCheckGuids: Array<Scalars['ID']['output']>;
  /** Number of paid portions that the party member has successfully paid for */
  claimedPortionsPaid?: Maybe<Scalars['Int']['output']>;
  /** Emoji to use as avatar representation of guest */
  emoji?: Maybe<Scalars['String']['output']>;
  loyaltyState?: Maybe<Opt_BalanceStateData>;
  /** Name of this party member. */
  name: Scalars['String']['output'];
  /** List of selection guids a party member is responsible for ordering. */
  orderSelectionIds: Array<Scalars['String']['output']>;
  /** Unique identifier for member. */
  partyMemberGuid: Scalars['String']['output'];
  /** Guid corresponding to this member's preauthed card. Null if this party member did not preauth. */
  preauthCardGuid?: Maybe<Scalars['String']['output']>;
};

export type Opt_OptPartyPaygPromoInput = {
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** Promo code to apply to cart */
  promoCode: Scalars['String']['input'];
};

export type Opt_OptPartyPaymentError = Opt_Error & {
  __typename?: 'OPT_OPTPartyPaymentError';
  code: Opt_OptPartyPaymentErrorCode;
  invalidatesPreauth: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export enum Opt_OptPartyPaymentErrorCode {
  AuthorizationFailed = 'AUTHORIZATION_FAILED',
  CheckNotFound = 'CHECK_NOT_FOUND',
  OrderPaymentError = 'ORDER_PAYMENT_ERROR',
  PartyAlreadyPaid = 'PARTY_ALREADY_PAID',
  PartyMemberAlreadyPaid = 'PARTY_MEMBER_ALREADY_PAID',
  PartyPaymentOutOfSync = 'PARTY_PAYMENT_OUT_OF_SYNC',
  PaymentFailedAfterAuth = 'PAYMENT_FAILED_AFTER_AUTH',
  PaymentFailedAfterAuthPreauth = 'PAYMENT_FAILED_AFTER_AUTH_PREAUTH',
  PaymentMethodDisallowed = 'PAYMENT_METHOD_DISALLOWED',
  SplitCheckFailed = 'SPLIT_CHECK_FAILED',
  UndefinedSplitPaymentMethod = 'UNDEFINED_SPLIT_PAYMENT_METHOD',
  UnknownPaymentResponse = 'UNKNOWN_PAYMENT_RESPONSE'
}

export enum Opt_OptPartyPaymentErrorCodeV2 {
  AuthorizationFailed = 'AUTHORIZATION_FAILED',
  CheckNotFound = 'CHECK_NOT_FOUND',
  OrderPaymentError = 'ORDER_PAYMENT_ERROR',
  PartyPaymentOutOfSync = 'PARTY_PAYMENT_OUT_OF_SYNC',
  PaymentAppliedFailed = 'PAYMENT_APPLIED_FAILED',
  SpiUpdateIntentFailed = 'SPI_UPDATE_INTENT_FAILED',
  SplitCheckFailed = 'SPLIT_CHECK_FAILED',
  TokenizationFailed = 'TOKENIZATION_FAILED'
}

export type Opt_OptPartyPaymentErrorV2 = Opt_Error & {
  __typename?: 'OPT_OPTPartyPaymentErrorV2';
  code: Opt_OptPartyPaymentErrorCodeV2;
  invalidatesPreauth: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  /** Refreshed party data. Returns null if field is unsupported by the mutation. */
  partyRefreshResponse?: Maybe<Opt_OptPartyRefreshResponseV2>;
  /** Guid of the created, but unsuccessfully paid, split check. If not present, the error occurred before a new split check was created. */
  splitCheckGuid?: Maybe<Scalars['ID']['output']>;
};

export type Opt_OptPartyPaymentResponse = {
  __typename?: 'OPT_OPTPartyPaymentResponse';
  /** indicates whether the payment had loyalty attached */
  hasLoyalty?: Maybe<Scalars['Boolean']['output']>;
  /** Returns a feedback survey for the given order payment */
  itemFeedbackSurvey: Opt_ItemFeedbackSurveyResponse;
  /** indicates whether the payment can be used to sign up for loyalty */
  loyaltySignupPossible?: Maybe<Scalars['Boolean']['output']>;
  /** Refreshed party data. */
  partyRefresh: Opt_OptPartyRefreshV2;
  /** Any non-blocking errors that occurred during payment, to be presented to the user. */
  warnings: Array<Opt_PlaceOrderWarning>;
};

export type Opt_OptPartyRefreshResponseV2 = Opt_OptPartyError | Opt_OptPartyRefreshV2;

export type Opt_OptPartyRefreshV2 = {
  __typename?: 'OPT_OPTPartyRefreshV2';
  /** The hydrated list of carts in the party. This allows us to show what others are ordering. */
  carts: Array<Opt_OptCart>;
  /** Data required to increment auth */
  incrementAuthData?: Maybe<Opt_IncrementAuthData>;
  /** The hydrated order with all items in the cart. */
  order?: Maybe<Opt_OptOrderGuid>;
  /** The data for the refreshed party. */
  party: Opt_OptPartyV2;
  /** Represents whether or not a restaurant is offline */
  rxAvailability?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Deprecated - use **priceSplitCheck** mutation
   * @deprecated use priceSplitCheck mutation
   */
  splitCheckPreview?: Maybe<Opt_OptSplitCheckPreview>;
  /** Indicates what type of split is being made on the check */
  splitPaymentData?: Maybe<Opt_SplitPaymentData>;
};

export type Opt_OptPartyResponseV2 = Opt_OptPartyError | Opt_OptPartyV2;

export type Opt_OptPartyStub = {
  __typename?: 'OPT_OPTPartyStub';
  /** Represented as a long - when a party was created in seconds. */
  createdTime?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['ID']['output']>;
  members?: Maybe<Array<Maybe<Opt_OptPartyMemberStub>>>;
};

export type Opt_OptPartyStubResponse = Opt_OptPartyError | Opt_OptPartyStub;

export type Opt_OptPartyTabPromoInput = {
  /** Check to which promo should be applied */
  checkGuid: Scalars['ID']['input'];
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** Promo code to apply to cart */
  promoCode: Scalars['String']['input'];
};

export type Opt_OptPartyV2 = {
  __typename?: 'OPT_OPTPartyV2';
  /** Calculated line items for all the party's carts combined */
  cartLineItems?: Maybe<Opt_LineItems>;
  /** Represented as a long - when a party was created in seconds. */
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Identifier for the Party object itself. */
  guid: Scalars['ID']['output'];
  /** Represented as a long - party's TTL value, when it was last updated. */
  lastUpdated?: Maybe<Scalars['String']['output']>;
  /** Identifier for the Order object corresponding to this Party. */
  mainCheckGuid?: Maybe<Scalars['ID']['output']>;
  /** Auth token specific to party member who made the request. */
  memberAuthToken?: Maybe<Scalars['String']['output']>;
  /** List of members currently taking part in this Party. */
  members: Array<Opt_OptPartyMemberV2>;
  /** The type of DDI experience/mode that this party is for, if null, client should assume OPT */
  mode?: Maybe<Opt_DdiMode>;
  /** Identifier for the Order object corresponding to this Party. */
  orderGuid?: Maybe<Scalars['ID']['output']>;
  /** Calculated line items for the party's tab */
  orderLineItems?: Maybe<Opt_LineItems>;
  /** Identifier for the user making the request which yielded this object. Matches the property of the same name on one of the objects in the members array. */
  partyMemberGuid?: Maybe<Scalars['ID']['output']>;
  /** Security PIN to allow other diners to join this Party. */
  pin?: Maybe<Scalars['String']['output']>;
  /** The name of the table for the party if it exists */
  tableName?: Maybe<Scalars['String']['output']>;
};

export type Opt_OptPartyV3 = {
  __typename?: 'OPT_OPTPartyV3';
  createdTime: Scalars['String']['output'];
  guid: Scalars['ID']['output'];
  mainCheckGuid?: Maybe<Scalars['ID']['output']>;
  members: Array<Opt_OptPartyMemberV2>;
  mode?: Maybe<Opt_DdiMode>;
  orderGuid?: Maybe<Scalars['ID']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  restaurantGuid: Scalars['ID']['output'];
  splitPaymentData?: Maybe<Opt_SplitPaymentData>;
  tableGuid?: Maybe<Scalars['ID']['output']>;
  tableName?: Maybe<Scalars['String']['output']>;
  updatedTime: Scalars['String']['output'];
  visibility?: Maybe<Opt_PartyVisibility>;
};

/** GROUP ORDERING */
export enum Opt_OptPayForCheckErrorCode {
  CheckAlreadyPaidFor = 'CHECK_ALREADY_PAID_FOR',
  CheckNotFound = 'CHECK_NOT_FOUND',
  InvalidCardInformation = 'INVALID_CARD_INFORMATION',
  InvalidPaymentRequest = 'INVALID_PAYMENT_REQUEST',
  MissingRequiredParameter = 'MISSING_REQUIRED_PARAMETER',
  PaymentConflict = 'PAYMENT_CONFLICT',
  PaymentDenied = 'PAYMENT_DENIED',
  PaymentFailedAfterAuth = 'PAYMENT_FAILED_AFTER_AUTH',
  PaymentFailedAfterAuthPreauth = 'PAYMENT_FAILED_AFTER_AUTH_PREAUTH',
  TransDenied = 'TRANS_DENIED',
  ValidationFailed = 'VALIDATION_FAILED'
}

export type Opt_OptPayForCheckResponse = {
  __typename?: 'OPT_OPTPayForCheckResponse';
  completedOrder: Opt_CompletedOrder;
  warnings: Array<Opt_PlaceOrderWarning>;
};

export type Opt_OptPayment = {
  __typename?: 'OPT_OPTPayment';
  amount: Scalars['Float']['output'];
  guid: Scalars['ID']['output'];
  paymentStatus?: Maybe<Opt_PaymentStatus>;
  tipAmount: Scalars['Float']['output'];
  type?: Maybe<Opt_PaymentType>;
};

export type Opt_OptReorderItemInput = {
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** SelectionGuid to reorder. */
  selectionGuid: Scalars['String']['input'];
};

export type Opt_OptRestaurantGiftCard = {
  __typename?: 'OPT_OPTRestaurantGiftCard';
  /** 16-digit number associated with the restaurant gift card. */
  cardNumber: Scalars['String']['output'];
  /** Amount the gift card can cover. */
  expectedAvailableBalance: Scalars['Float']['output'];
};

export type Opt_OptSplitCheckInput = {
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** List of selections to split, paired with floats indicating how they should be split. */
  selectionsToSplit: Array<Opt_SplitItemInput>;
};

export type Opt_OptSplitCheckPaymentError = Opt_Error & {
  __typename?: 'OPT_OPTSplitCheckPaymentError';
  code: Opt_OptSplitCheckPaymentErrorCode;
  /** If the error occurred after a payment authorization with a pre-authorized card, the pre-authorized card cannot be re-used and is therefore invalidated. */
  invalidatesPreauth: Scalars['Boolean']['output'];
  /** User-facing message for the payment error */
  message: Scalars['String']['output'];
  /** Refreshed party data. Returns null if field is unsupported by the mutation. */
  partyRefreshResponse?: Maybe<Opt_OptPartyRefreshResponseV2>;
  /** Guid of the created, but unsuccessfully paid, split check. If not present, the error occurred before a new split check was created. */
  splitCheckGuid?: Maybe<Scalars['ID']['output']>;
};

export enum Opt_OptSplitCheckPaymentErrorCode {
  AuthorizationFailed = 'AUTHORIZATION_FAILED',
  OrderPaymentError = 'ORDER_PAYMENT_ERROR',
  PaymentAppliedFailed = 'PAYMENT_APPLIED_FAILED',
  /** This error will be sent if there has been a payment posted to the check. At this point, the split type and portions are locked in. */
  SplitPaymentAssignmentLockedInError = 'SPLIT_PAYMENT_ASSIGNMENT_LOCKED_IN_ERROR',
  /** This error will be sent if the number of paid portions is fewer than the number of portions being asked to remove */
  SplitPaymentCannotRemovePaidPortions = 'SPLIT_PAYMENT_CANNOT_REMOVE_PAID_PORTIONS',
  /** This error will be sent if the user tries to assign paid portions to a check, but the check has been completely paid for */
  SplitPaymentNoPortionsLeftError = 'SPLIT_PAYMENT_NO_PORTIONS_LEFT_ERROR',
  /** This error will be sent if the party object doesn't have splitPaymentData */
  SplitPaymentNoSplitDataFound = 'SPLIT_PAYMENT_NO_SPLIT_DATA_FOUND',
  /** This error will be sent if a split type has already been chosen, but no payment has been posted. The user can still change the split type and number of portions, but must request it with an explicit override request */
  SplitPaymentOverrideNeededError = 'SPLIT_PAYMENT_OVERRIDE_NEEDED_ERROR',
  /** This error will be sent if the user tries to assign paid portions to a check, but the number of portions they're paying for are no longer available. Instead, a smaller amount of portions are. */
  SplitPaymentPaidPortionOverpaymentError = 'SPLIT_PAYMENT_PAID_PORTION_OVERPAYMENT_ERROR',
  SplitPaymentUnknownError = 'SPLIT_PAYMENT_UNKNOWN_ERROR',
  /** This error will be sent if the user tries to assign paid portions to a check, but the number of portions available to split by doesn't match. */
  SplitPortionMismatchError = 'SPLIT_PORTION_MISMATCH_ERROR',
  /** This error will be sent if the user tries to assign paid portions to a non SPLIT EVENLY split type check. */
  WrongSplitTypeError = 'WRONG_SPLIT_TYPE_ERROR'
}

export type Opt_OptSplitCheckPreview = Opt_OptCheckV2 & {
  __typename?: 'OPT_OPTSplitCheckPreview';
  appliedLoyaltyInfo?: Maybe<Opt_AppliedLoyaltyInfo>;
  appliedServiceCharges?: Maybe<Array<Opt_AppliedServiceCharge>>;
  customer?: Maybe<Opt_CustomerInfo>;
  discounts: Opt_Discounts;
  expectedPaymentAmount: Scalars['Float']['output'];
  numberOfSelections: Scalars['Int']['output'];
  preComputedTips: Array<Opt_PreComputedTip>;
  preDiscountedSubtotal: Scalars['Float']['output'];
  selections: Array<Opt_CheckSelectionGuid>;
  serviceChargeTotal: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  /** A breakdown of potential surcharge amounts on the split check depending on the payment type. Payment types are unique across all list elements, e.g. you won't see multiple surcharge entries with PaymentType.CREDIT. */
  surcharges?: Maybe<Array<Opt_SurchargeSummaryForPaymentTypes>>;
  tax: Scalars['Float']['output'];
  taxWithoutSurchargeTax: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};


export type Opt_OptSplitCheckPreviewSurchargesArgs = {
  totalGiftCardBalance?: InputMaybe<Scalars['Float']['input']>;
};

export type Opt_OptSplitCheckResponse = Opt_OptPartyError | Opt_OptSplitCheckPreview;

export type Opt_OptValidateInput = {
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party to join */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
};

export type Opt_OptDiscountInput = {
  discountGuid?: InputMaybe<Scalars['ID']['input']>;
  discountType?: InputMaybe<Opt_LoyaltyRedemptionType>;
  memberAuthToken: Scalars['ID']['input'];
  partyGuid: Scalars['ID']['input'];
  partyMemberGuid: Scalars['ID']['input'];
};

export type Opt_OptDynamicQrJoinOrCreatePartyInput = {
  /** Check the Party represents */
  checkGuid: Scalars['ID']['input'];
  /** User's contact info. Phone/email. */
  contactInfo?: InputMaybe<Opt_ContactInfo>;
  /** Emoji to use as avatar representation of guest */
  emoji?: InputMaybe<Scalars['String']['input']>;
  /** User's name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Order the Party represents */
  orderGuid: Scalars['ID']['input'];
  /** Used for disambiguating table names */
  restaurantGuid: Scalars['ID']['input'];
};

export type Opt_Order = {
  __typename?: 'OPT_Order';
  /** @deprecated use discounts field instead */
  appliedCustomerReward?: Maybe<Opt_AppliedCustomerReward>;
  appliedServiceCharges?: Maybe<Array<Opt_AppliedServiceCharge>>;
  /** The delivery fee based on the current delivery info, provided this is a delivery order. */
  deliveryChargeTotal?: Maybe<Scalars['Float']['output']>;
  /** The delivery info to use to calculate delivery fees, provided this is a delivery order. */
  deliveryInfo?: Maybe<Opt_DeliveryInfo>;
  /** An object containing potential discounts applied to order, such as a global reward or a restaurant specific reward. */
  discounts: Opt_Discounts;
  numberOfSelections?: Maybe<Scalars['Int']['output']>;
  /** A number that indicates how much to charge a user for placing an outpost order. This value will only be non null if the order is an outpost order, otherwise it will be null. */
  outpostFee?: Maybe<Scalars['Float']['output']>;
  promisedDateTime?: Maybe<Scalars['Float']['output']>;
  selections?: Maybe<Array<Maybe<Opt_Selection>>>;
  /** Does not include delivery charges. */
  serviceChargeTotal?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use taxV2 field instead */
  tax?: Maybe<Scalars['Float']['output']>;
  /** The order tax calculated after applying global promo codes if they exist. */
  taxV2?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use totalV2 field instead */
  total?: Maybe<Scalars['Float']['output']>;
  /** The order total calculated after applying global promo codes if they exist. */
  totalV2?: Maybe<Scalars['Float']['output']>;
};


export type Opt_OrderAppliedCustomerRewardArgs = {
  input?: InputMaybe<Opt_ApplyCustomerRewardInput>;
};

export type Opt_OrderAtTableCustomerInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
};

export type Opt_OrderAtTablePartySelectionItemDetailsInput = {
  itemGroupGuid: Scalars['ID']['input'];
  itemGuid: Scalars['ID']['input'];
  memberAuthToken: Scalars['ID']['input'];
  partyGuid: Scalars['ID']['input'];
  partyMemberGuid: Scalars['ID']['input'];
  selectionGuid: Scalars['ID']['input'];
};

/** The different states or an order tracked order. If **orderStatus** is null then the restaurant does not support order tracking currently */
export enum Opt_OrderStatusType {
  /** The order has been marked as completed by the restaurant through the KDS. */
  AlmostReady = 'ALMOST_READY',
  /** An order is being prepared. */
  Preparing = 'PREPARING',
  /** The order is ready for pickup. Set 90 seconds after the order becomes **ALMOST_READY** to account for bagging and placing order on shelf etc. */
  ReadyForPickup = 'READY_FOR_PICKUP',
  /** An order has been received and is present in the orders database. */
  Received = 'RECEIVED',
  /** When a RECEIVED state order reaches 15 minutes past its estimated completion date, it becomes unfulfilled. */
  Unfulfilled = 'UNFULFILLED'
}

export type Opt_PartyMemberResponse = Opt_OptPartyError | Opt_OptPartyMemberV2;

export enum Opt_PartyVisibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Opt_PayForCheckError = Opt_Error & {
  __typename?: 'OPT_PayForCheckError';
  code: Opt_PayForCheckErrorCode;
  message: Scalars['String']['output'];
};

export enum Opt_PayForCheckErrorCode {
  CheckAlreadyPaidFor = 'CHECK_ALREADY_PAID_FOR',
  CheckNotFound = 'CHECK_NOT_FOUND',
  InvalidPaymentRequest = 'INVALID_PAYMENT_REQUEST',
  PaymentConflict = 'PAYMENT_CONFLICT',
  PaymentDenied = 'PAYMENT_DENIED',
  ValidationFailed = 'VALIDATION_FAILED'
}

export type Opt_PayForCheckInput = {
  /** The guid of the check to pay for */
  checkGuid: Scalars['ID']['input'];
  /** The guest's email to send a digital receipt to, also used for accrue loyalty points */
  email: Scalars['String']['input'];
  /** True if the guest opted into marketing, false if not. */
  marketable?: InputMaybe<Scalars['Boolean']['input']>;
  /** A new credit card with encrypted data */
  newCardInput: Opt_NewCardInput;
  /** The order guid which contains the check that is being paid for */
  orderGuid: Scalars['ID']['input'];
  /** The guest's phone number to accrue loyalty points, can be null */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The guid of the restaurant which has the order being paid for */
  restaurantGuid: Scalars['ID']['input'];
  /** The amount that the consumer selected to tip */
  tipAmount: Scalars['Float']['input'];
};

export type Opt_PayForCheckResponse = {
  __typename?: 'OPT_PayForCheckResponse';
  /** Indicates whether loyalty account was found and user accrued points for paid check. */
  hasLoyalty?: Maybe<Scalars['Boolean']['output']>;
  /** An array of all checks associated with the order still open. Used to allow the client to display any remaining balance, and the selections, to the guest. */
  remainingChecks: Array<Opt_InProgressOrderCheck>;
};

export type Opt_PayForCheckResponseOrError = Opt_PayForCheckError | Opt_PayForCheckResponse;

export type Opt_PaymentIntent = {
  __typename?: 'OPT_PaymentIntent';
  amount: Scalars['Int']['output'];
  captureMethod: Scalars['String']['output'];
  creationDate: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  externalReferenceId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sessionSecret: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type Opt_PaymentIntentError = {
  __typename?: 'OPT_PaymentIntentError';
  errorDetails: Scalars['String']['output'];
};

export enum Opt_PaymentMethods {
  ApplePay = 'APPLE_PAY',
  ClickToPay = 'CLICK_TO_PAY',
  CreditCard = 'CREDIT_CARD',
  GooglePay = 'GOOGLE_PAY',
  NewCreditCard = 'NEW_CREDIT_CARD'
}

export enum Opt_PaymentStatus {
  Authorized = 'AUTHORIZED',
  AuthorizedAtRisk = 'AUTHORIZED_AT_RISK',
  Cancelled = 'CANCELLED',
  Captured = 'CAPTURED',
  CaptureInProgress = 'CAPTURE_IN_PROGRESS',
  Denied = 'DENIED',
  Error = 'ERROR',
  ErrorNetwork = 'ERROR_NETWORK',
  Open = 'OPEN',
  Processing = 'PROCESSING',
  ProcessingVoid = 'PROCESSING_VOID',
  Voided = 'VOIDED',
  VoidedAtRisk = 'VOIDED_AT_RISK'
}

/** This is a subset of the values from toast-orders' com.toasttab.service.orders.api.Payment.TypeEnum See https://dev.toasttab.com/Ie5QH/apiOrdersApiReference.html#/definitions/Payment */
export enum Opt_PaymentType {
  Cash = 'CASH',
  Credit = 'CREDIT',
  Giftcard = 'GIFTCARD',
  HouseAccount = 'HOUSE_ACCOUNT',
  Levelup = 'LEVELUP',
  Other = 'OTHER',
  Rewardcard = 'REWARDCARD',
  Undetermined = 'UNDETERMINED'
}

/** The type of payment method used for issuing rewards. */
export enum Opt_PaymentTypeForRewards {
  GooglePay = 'GOOGLE_PAY'
}

/** Requires a PKPaymentToken generated from apple pay as well as customer information generated by the Apple Payment Sheet */
export type Opt_PlaceApplePayOrderInput = {
  /** The global (restaurant-agnostic) customer reward to be applied to the order being placed. The absence of this input in the request indicates that no reward is to be applied. Currently only first-order promo is supported. */
  applicableCustomerRewardInput?: InputMaybe<Opt_ApplicableCustomerRewardInput>;
  /** GUID for the cart that has the order currently being placed. */
  cartGuid: Scalars['ID']['input'];
  /** Determines curbside pickup options for an order */
  curbsidePickup?: InputMaybe<Opt_CurbsidePickupInput>;
  /** Curbside Pickup information for the order. Namely, a vehicle description. */
  curbsidePickupV2?: InputMaybe<Opt_CurbsidePickupInputV2>;
  /** Customer's information, generated by the Apple Payment Sheet */
  customer?: InputMaybe<Opt_CustomerInput>;
  /** Indicates whether the diner has given consent for the delivery provider to communicate to them. Only relevant if the order is a DaaS order and consent is needed for the delivery provider fulfilling the delivery. Since DaaS orders only accept CC payments, this field is only present on **PlaceCcOrderInput**. */
  deliveryCommunicationConsentGiven?: InputMaybe<Scalars['Boolean']['input']>;
  /** ***MVP feature***: The GUID of the dining option to be applied to the cart before placing the order. This overrides the dining option selected from the restaurant admin online ordering configuration, e.g. the takeout dining option would be automatically configured on the cart when it was first created, but selecting an outpost dining option would override this selection during the **placeCcOrder** mutation. */
  diningOptionGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Gift Card Payment */
  giftCard?: InputMaybe<Opt_GiftCardPaymentInput>;
  /** The final delivery info to set on the order. If absent, will use whatever delivery info was previously set on the cart, if any. It is an error if the cart's dining option behavior was configured for **DELIVERY** but no delivery info is provided, either here or previously set. */
  newAddress?: InputMaybe<Opt_NewAddressInput>;
  /** A token generated by Apple Pay */
  pkPaymentToken: Scalars['String']['input'];
  /** The promo code supplied by the user for order being placed, must be re-validated before applying. The absence of this input in the request indicates that no promo code is to be applied. */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** The saved address to use for an authenticated customer. Mutually exclusive with **newAddresss**. */
  savedAddress?: InputMaybe<Opt_SavedAddressInput>;
  /** This input will determine whether the place order mutation should also call loyaltySignup for the user. If the flag is false or not set, loyalty signup will not occur in the place order request. */
  signUpLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if RoundUp for cause is turned on or not in the order Represents the estimated roundUpAmount calculated in the frontend */
  tfgInput?: InputMaybe<Opt_TfgInput>;
  /** The amount of tip the customer intends to give. */
  tipAmount: Scalars['Float']['input'];
};

export type Opt_PlaceApplePayOrderResponse = Opt_PlaceOrderCartUpdatedError | Opt_PlaceOrderError | Opt_PlaceOrderOutOfStockError | Opt_PlaceOrderResponse;

export type Opt_PlaceOptOrderResponse = Opt_OptOrderError | Opt_OptPayForCheckResponse;

/** Returned when the server prevents the placing of an order due to the cart being updated automatically by the server. */
export type Opt_PlaceOrderCartUpdatedError = Opt_Error & {
  __typename?: 'OPT_PlaceOrderCartUpdatedError';
  code: Opt_PlaceOrderCartUpdatedErrorCode;
  message: Scalars['String']['output'];
};

export enum Opt_PlaceOrderCartUpdatedErrorCode {
  /** The fulfillment time (for FUTURE) or quote time (for ASAP) on the cart is out of date and no longer accurate. E.g. the server automatically changed the fulfillment/quote time due to price-based prep or kitchen capacity, but the order can still be placed. In this case the **cart** field of this response will have the updated fulfillment/quote time. In contrast, if it is no longer possible to place an order at all, a **PlaceOrderError** would be returned with a code of **ORDER_TIME_UNAVAILABLE**. */
  OrderTimeChanged = 'ORDER_TIME_CHANGED',
  /** A number of items on the cart has been automatically removed due to being out of stock. */
  OutOfStock = 'OUT_OF_STOCK'
}

export type Opt_PlaceOrderError = Opt_Error & {
  __typename?: 'OPT_PlaceOrderError';
  code: Opt_PlaceOrderErrorCode;
  message: Scalars['String']['output'];
};

export enum Opt_PlaceOrderErrorCode {
  AlcoholUnsupported = 'ALCOHOL_UNSUPPORTED',
  CartContentNotFound = 'CART_CONTENT_NOT_FOUND',
  CriticalError = 'CRITICAL_ERROR',
  DiningOptionUnavailable = 'DINING_OPTION_UNAVAILABLE',
  InvalidCreditCard = 'INVALID_CREDIT_CARD',
  LoyaltyRedemptionRemoved = 'LOYALTY_REDEMPTION_REMOVED',
  MissingCustomerInfo = 'MISSING_CUSTOMER_INFO',
  MissingDeliveryInfo = 'MISSING_DELIVERY_INFO',
  NotInDeliveryArea = 'NOT_IN_DELIVERY_AREA',
  OoDisabled = 'OO_DISABLED',
  OrderTimeUnavailable = 'ORDER_TIME_UNAVAILABLE',
  PlaceOrderEmptyCart = 'PLACE_ORDER_EMPTY_CART',
  PlaceOrderFailed = 'PLACE_ORDER_FAILED',
  PlaceOrderInvalidEmail = 'PLACE_ORDER_INVALID_EMAIL',
  RewardNotFound = 'REWARD_NOT_FOUND',
  UnsatisfiedApprovalRule = 'UNSATISFIED_APPROVAL_RULE',
  UnsupportedPaymentMethod = 'UNSUPPORTED_PAYMENT_METHOD'
}

/** Deprecated - use **PlaceOrderCartUpdatedError** */
export type Opt_PlaceOrderOutOfStockError = Opt_Error & {
  __typename?: 'OPT_PlaceOrderOutOfStockError';
  message: Scalars['String']['output'];
};

export type Opt_PlaceOrderResponse = {
  __typename?: 'OPT_PlaceOrderResponse';
  completedOrder: Opt_CompletedOrder;
  warnings: Array<Opt_PlaceOrderWarning>;
};

export type Opt_PlaceOrderWarning = Opt_Warning & {
  __typename?: 'OPT_PlaceOrderWarning';
  code: Opt_PlaceOrderWarningCode;
  message: Scalars['String']['output'];
};

export enum Opt_PlaceOrderWarningCode {
  AfterPlaceOrderFailed = 'AFTER_PLACE_ORDER_FAILED',
  LoyaltySignupFailed = 'LOYALTY_SIGNUP_FAILED',
  SendReceiptFailed = 'SEND_RECEIPT_FAILED'
}

export type Opt_PopularItemV3 = {
  __typename?: 'OPT_PopularItemV3';
  doMenuItem: Opt_DoMenuItem;
  groupGuid: Scalars['String']['output'];
  itemGuid: Scalars['String']['output'];
};

export type Opt_PopularItemsConfig = {
  __typename?: 'OPT_PopularItemsConfig';
  enabled: Scalars['Boolean']['output'];
};

export type Opt_PopularItemsV3 = {
  __typename?: 'OPT_PopularItemsV3';
  popularItems: Array<Opt_PopularItemV3>;
};

export type Opt_PostPaymentCommunicationPreferences = {
  /** Whether the guest has explicitly consented to be subscribed for marketing purposes. */
  consentMarketingSubscription: Scalars['Boolean']['input'];
};

export type Opt_PreComputedTip = {
  __typename?: 'OPT_PreComputedTip';
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use percentV2 */
  percent: Scalars['Int']['output'];
  /** Represents PreComputedTip percent as string rounded to single decimal place */
  percentLabel: Scalars['String']['output'];
  /** PreComputedTip percent as raw floating point value from 0 to 1 */
  percentV2: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type Opt_PricingRules = {
  __typename?: 'OPT_PricingRules';
  sizeSequencePricingRules: Array<Scalars['Int']['output']>;
  sizeSpecificPricingGuid: Scalars['String']['output'];
  timeSpecificPricingRules: Array<Scalars['Int']['output']>;
};

export enum Opt_PricingStrategy {
  BasePrice = 'BASE_PRICE',
  GroupPrice = 'GROUP_PRICE',
  MenuSpecificPrice = 'MENU_SPECIFIC_PRICE',
  None = 'NONE',
  OpenPrice = 'OPEN_PRICE',
  SequencePrice = 'SEQUENCE_PRICE',
  SizePrice = 'SIZE_PRICE',
  TimeSpecificPrice = 'TIME_SPECIFIC_PRICE'
}

export type Opt_RedemptionData = {
  __typename?: 'OPT_RedemptionData';
  currentState?: Maybe<Opt_LoyaltyRewardState>;
  itemId?: Maybe<Scalars['ID']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['Int']['output']>;
};

export enum Opt_RequiredMode {
  Optional = 'OPTIONAL',
  OptionalForceShow = 'OPTIONAL_FORCE_SHOW',
  Required = 'REQUIRED'
}

export type Opt_Restaurant = {
  __typename?: 'OPT_Restaurant';
  bannerUrls?: Maybe<Opt_ImageSet>;
  /** Determines if the restaurant is enabled for Toast Takeout. */
  consumerAppEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the restaurant is allowed to show a CTA. Restaurant must be enabled for the Toast Takeout and have Toast Takeout CTA enabled. */
  consumerCTAEnabled?: Maybe<Scalars['Boolean']['output']>;
  creditCardConfig: Opt_RestaurantCreditCardConfig;
  /** The restaurant's cuisineType that is a high-level descriptor for the type of food served by the restaurant. This value is defined under the consumer app config and is NOT set by the restaurant. If it is null, then the property has not been defined on the consumer app config. */
  cuisineType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Gift card config */
  giftCardConfig: Opt_GiftCardConfig;
  /** Gift card links */
  giftCardLinks: Opt_GiftCardLinks;
  /** The restaurant's guest currency (Toast Cash) config */
  guestCurrencyConfig: Opt_GuestCurrencyConfig;
  guid: Scalars['ID']['output'];
  /** The Internationalization (i18n) properties relating to a given restaurant */
  i18n?: Maybe<Opt_I18n>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Item level feedback config When null, no configuration can be resolved for the restaurant */
  itemLevelFeedbackConfig?: Maybe<Opt_ItemLevelFeedbackConfig>;
  location: Opt_Location;
  logoUrls?: Maybe<Opt_ImageSet>;
  /** The restaurant's loyalty settings, defaulting to disabled settings if the restaurant has no loyalty or if the loyalty service is unavailable */
  loyaltyConfig: Opt_LoyaltyConfig;
  minimumDeliveryTime: Scalars['Int']['output'];
  minimumTakeoutTime: Scalars['Int']['output'];
  /** The restaurant's name that an aggregator client should use. Accounts for Takeout-specific name override */
  name: Scalars['String']['output'];
  orderAndPayConfig?: Maybe<Opt_OptConfig>;
  /** Configuration for a restaurant's popular items display */
  popularItemsConfig?: Maybe<Opt_PopularItemsConfig>;
  shortUrl: Scalars['String']['output'];
  /** Links to resturant social media platforms. */
  socialMediaLinks: Opt_SocialMediaLinks;
  /** Configuration options for the per-selection freeform special requests field */
  specialRequestsConfig: Opt_SpecialRequestsConfig;
  /** Configuration for optional information a restaurant could spotlight */
  spotlightConfig?: Maybe<Opt_SpotlightConfig>;
  /** Determines if the restaurant is operating in test mode */
  testMode: Scalars['Boolean']['output'];
  /** The restaurant's Toast For Good settings, defaulting to disabled settings if the restaurant has no Toast For Good settings or if the Toast For Good settings service is unavailable */
  tfgConfig: Opt_TfgConfig;
  /** Toast Pay product configuration. When null, no configuration can be resolved for the restaurant */
  toastPayConfig?: Maybe<Opt_ToastPayConfig>;
  /** Configuration for a restaurant's item upsells */
  upsellsConfig?: Maybe<Opt_UpsellsConfig>;
  /** The restaurant's name that a white-label client should use */
  whiteLabelName: Scalars['String']['output'];
};

export type Opt_RestaurantCreditCardConfig = {
  __typename?: 'OPT_RestaurantCreditCardConfig';
  /** Indicates if the restaurant accepts American Express credit card payments, assuming that the restaurant allows payment via credit card in the first place. */
  amexAccepted: Scalars['Boolean']['output'];
  /** Indicates if the restaurant allows the diner to specify a tip when paying via credit card, assuming that the restaurant allows payment via credit card in the first place. */
  tipEnabled: Scalars['Boolean']['output'];
};

/** An object representing a restaurant reward, i.e. a reward provided by a restaurant itself. */
export type Opt_RestaurantDiscount = {
  __typename?: 'OPT_RestaurantDiscount';
  amount: Scalars['Float']['output'];
  guid: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  promoCode: Scalars['String']['output'];
};

export type Opt_RestaurantOrError = Opt_GeneralError | Opt_Restaurant;

export enum Opt_RewardType {
  CustomerNUse = 'CUSTOMER_N_USE',
  GlobalNUse = 'GLOBAL_N_USE',
  SignUp = 'SIGN_UP'
}

export type Opt_SpiPayment = {
  amount: Scalars['Float']['input'];
  paymentId: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Opt_SpiPaymentMethods>;
  /** Links the card fingerprint identified by the payment method id to the guest account. Guest must be logged in. */
  shouldLinkPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Opt_SpiPaymentData = {
  /** Indicates to set the externalReferenceId when payment confirmation has to be retried */
  enableConfirmRetry: Scalars['Boolean']['input'];
  /** Identifier for the payment intent to be updated */
  paymentIntentId: Scalars['ID']['input'];
  /** Identifier of the payment method, which can inform pricing calculations. */
  paymentMethodId: Scalars['ID']['input'];
  /** The type of payment method used only for detecting rewards. Not used for confirming payment intent. */
  paymentTypeForRewards?: InputMaybe<Opt_PaymentTypeForRewards>;
  /** Should the card be saved or linked for later use. Note that all paymentMethodType do not support saving the card; in these cases where we do not expect a save card capability to be supported, pass in `false` */
  saveCard: Scalars['Boolean']['input'];
  /** Payment sessions secret from SDK initialization. Needed to confirm a payment. */
  sessionSecret: Scalars['String']['input'];
  /** Links the card fingerprint identified by the payment method id to the guest account. Guest must be logged in. */
  shouldLinkPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Opt_StpCreatePartyInput = {
  /** Table the Party represents */
  checkGuid: Scalars['ID']['input'];
  /** User's contact info. Phone/email. */
  contactInfo?: InputMaybe<Opt_ContactInfo>;
  /** User's name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Used for disambiguating table names */
  restaurantGuid: Scalars['ID']['input'];
};

export type Opt_StpJoinOrCreatePartyByMainCheckGuidInput = {
  /** Used to query for an existing party */
  checkGuid: Scalars['ID']['input'];
  /** The guests phone and email. These can be updated later in the flow */
  contactInfo?: InputMaybe<Opt_ContactInfo>;
  /** The full name of the guest paying for their portion of a check. Must be unique to the party. If it is not provided, a name will be autogenerated for the guest. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Used to fetch the order */
  restaurantGuid: Scalars['ID']['input'];
};

export type Opt_SavedAddress = {
  __typename?: 'OPT_SavedAddress';
  deliveryInfo: Opt_DeliveryInfo;
  guid: Scalars['ID']['output'];
  /** The name/label for this address, e.g. "Home", "Work" */
  name?: Maybe<Scalars['String']['output']>;
};

export type Opt_SavedAddressInput = {
  addressGuid: Scalars['ID']['input'];
};

export type Opt_SavedCardInput = {
  cardGuid: Scalars['ID']['input'];
};

/** Saved credit card information; the token itself is stored securely in customermgmt and not provided to the client */
export type Opt_SavedCreditCard = {
  __typename?: 'OPT_SavedCreditCard';
  /** The issuing network of the card, e.g. "VISA" */
  cardType: Opt_CardType;
  /** Two digit expiration month */
  expirationMonth: Scalars['String']['output'];
  /** Four digit expiration year */
  expirationYear: Scalars['String']['output'];
  /** The card guid, used as an identifier for the card */
  guid: Scalars['ID']['output'];
  /** Flag indicating whether the card is the primary (selected by default) card for the account */
  isPrimary: Scalars['Boolean']['output'];
  /** The masked card number with only the last four digits visible, in the format of "XXXX-1234" */
  maskedPan: Scalars['String']['output'];
};

export type Opt_Selection = {
  __typename?: 'OPT_Selection';
  fractionalQuantity: Opt_FractionalQuantity;
  guid?: Maybe<Scalars['ID']['output']>;
  itemGroupGuid?: Maybe<Scalars['ID']['output']>;
  itemGuid?: Maybe<Scalars['ID']['output']>;
  modifiers?: Maybe<Array<Maybe<Opt_Selection>>>;
  name?: Maybe<Scalars['String']['output']>;
  /** The cost of the Selection before any discounts are applied to the order */
  preDiscountPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  usesFractionalQuantity: Scalars['Boolean']['output'];
};

export type Opt_SelectionInput = {
  fractionalQuantity?: InputMaybe<Opt_FractionalQuantityInput>;
  itemGroupGuid?: InputMaybe<Scalars['ID']['input']>;
  itemGuid: Scalars['ID']['input'];
  modifierGroups: Array<Opt_ModifierGroupInput>;
  quantity: Scalars['Int']['input'];
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
};

export type Opt_SelectionItemV2 = {
  __typename?: 'OPT_SelectionItemV2';
  calories?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fractionalQuantity: Opt_FractionalQuantity;
  guid: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  itemGroupGuid: Scalars['ID']['output'];
  itemGuid: Scalars['ID']['output'];
  menuItemPrice?: Maybe<Scalars['Float']['output']>;
  modifierGroups: Array<Opt_SelectionModifierGroupV2>;
  name?: Maybe<Scalars['String']['output']>;
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  selectionItemPrice?: Maybe<Scalars['Float']['output']>;
  specialRequest?: Maybe<Scalars['String']['output']>;
  stockQuantity?: Maybe<Scalars['Float']['output']>;
  unitOfMeasure: Opt_UnitOfMeasure;
  usesFractionalQuantity: Scalars['Boolean']['output'];
};


export type Opt_SelectionItemV2ModifierGroupsArgs = {
  nestingLevel?: InputMaybe<Scalars['Int']['input']>;
};

export type Opt_SelectionModifierGroupV2 = {
  __typename?: 'OPT_SelectionModifierGroupV2';
  guid: Scalars['ID']['output'];
  maxSelections?: Maybe<Scalars['Int']['output']>;
  minSelections: Scalars['Int']['output'];
  modifiers: Array<Opt_SelectionModifierOptionV2>;
  name?: Maybe<Scalars['String']['output']>;
  requiredMode: Opt_RequiredMode;
};

export type Opt_SelectionModifierOptionV2 = {
  __typename?: 'OPT_SelectionModifierOptionV2';
  itemGroupGuid?: Maybe<Scalars['ID']['output']>;
  itemGuid: Scalars['ID']['output'];
  modifierGroups: Array<Opt_SelectionModifierGroupV2>;
  name?: Maybe<Scalars['String']['output']>;
  outOfStock: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  stockQuantity?: Maybe<Scalars['Float']['output']>;
};

export type Opt_ServiceCharge = {
  __typename?: 'OPT_ServiceCharge';
  entityType?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['ID']['output']>;
  guid?: Maybe<Scalars['ID']['output']>;
};

export enum Opt_ServiceChargeCalculation {
  PostDiscount = 'POST_DISCOUNT',
  PreDiscount = 'PRE_DISCOUNT'
}

export enum Opt_ServiceChargeCategory {
  CreditCardSurcharge = 'CREDIT_CARD_SURCHARGE',
  FundraisingCampaign = 'FUNDRAISING_CAMPAIGN',
  ServiceCharge = 'SERVICE_CHARGE'
}

export type Opt_ServiceChargeCriteria = {
  __typename?: 'OPT_ServiceChargeCriteria';
  maxCheckAmount?: Maybe<Scalars['Float']['output']>;
  minCheckAmount?: Maybe<Scalars['Float']['output']>;
};

export type Opt_ServiceChargeDetails = {
  __typename?: 'OPT_ServiceChargeDetails';
  amount?: Maybe<Scalars['Float']['output']>;
  amountType?: Maybe<Opt_ServiceChargeType>;
  criteria?: Maybe<Opt_ServiceChargeCriteria>;
  description?: Maybe<Scalars['String']['output']>;
  gratuity?: Maybe<Scalars['Boolean']['output']>;
  guid?: Maybe<Scalars['ID']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
  properties?: Maybe<Scalars['String']['output']>;
  taxable?: Maybe<Scalars['Boolean']['output']>;
};

export enum Opt_ServiceChargeType {
  Fixed = 'FIXED',
  Open = 'OPEN',
  Percent = 'PERCENT'
}

export type Opt_SignUpToLoyaltyError = Opt_Error & {
  __typename?: 'OPT_SignUpToLoyaltyError';
  code: Opt_SignUpToLoyaltyErrorCode;
  message: Scalars['String']['output'];
};

export enum Opt_SignUpToLoyaltyErrorCode {
  CannotSignUp = 'CANNOT_SIGN_UP'
}

export type Opt_SignUpToLoyaltyInput = {
  /** The guid of the paid check */
  checkGuid: Scalars['ID']['input'];
  /** The guest's email to sign-up to rewards program - either email or phone number, or both, must be provided */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The guest's phone number to sign-up to rewards program - either email or phone number, or both must, be provided */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The guid of the restaurant which has the paid check */
  restaurantGuid: Scalars['ID']['input'];
};

export type Opt_SignUpToLoyaltyResponse = {
  __typename?: 'OPT_SignUpToLoyaltyResponse';
  hasLoyalty?: Maybe<Scalars['Boolean']['output']>;
  newAccount?: Maybe<Scalars['Boolean']['output']>;
};

export type Opt_SignUpToLoyaltyResponseOrError = Opt_SignUpToLoyaltyError | Opt_SignUpToLoyaltyResponse;

/** Social Media Links allow a restaurant to point customers to their social media pages. */
export type Opt_SocialMediaLinks = {
  __typename?: 'OPT_SocialMediaLinks';
  /** Link to the restaurant's facebook page. */
  facebookLink?: Maybe<Scalars['String']['output']>;
  /** Instagram */
  instagramLink?: Maybe<Scalars['String']['output']>;
  /** Link to a restaurant's home page */
  resturantLink?: Maybe<Scalars['String']['output']>;
  /** Link to the restaurant's twitter feed */
  twitterLink?: Maybe<Scalars['String']['output']>;
  /** Twitter user */
  twitterUser?: Maybe<Scalars['String']['output']>;
};

export type Opt_SpecialRequestsConfig = {
  __typename?: 'OPT_SpecialRequestsConfig';
  /** Indicates whether special requests input box should be visible in modifier dialogs. */
  enabled: Scalars['Boolean']['output'];
  /** Indicates what hint text to display in the special requests input box if special requests is enabled. */
  placeholderMessage: Scalars['String']['output'];
};

export type Opt_SpiCardInfoInput = {
  cardHolderExpirationMonth: Scalars['String']['input'];
  cardHolderExpirationYear: Scalars['String']['input'];
  cardType: Opt_CardType;
  last4CardDigits: Scalars['String']['input'];
};

export enum Opt_SpiPaymentMethods {
  ApplePay = 'APPLE_PAY',
  GooglePay = 'GOOGLE_PAY',
  NewCard = 'NEW_CARD',
  SavedCard = 'SAVED_CARD'
}

export type Opt_SplitItemInput = {
  /** How many of the selection to split off */
  proportion: Scalars['Float']['input'];
  /** ID of the selection to split */
  selectionID: Scalars['String']['input'];
};

export enum Opt_SplitMode {
  Even = 'EVEN',
  MyItems = 'MY_ITEMS'
}

export type Opt_SplitPaymentData = {
  __typename?: 'OPT_SplitPaymentData';
  /** Indicates how many portions of the check have been paid */
  evenSplitPaidPortions: Scalars['Int']['output'];
  /** Indicates how many portions the check can be split into */
  evenSplitPortions: Scalars['Int']['output'];
  /** Indicates what split type the check is being split by */
  splitMode: Opt_SplitMode;
};

export type Opt_SplitPaymentDataInput = {
  /** Indicates how many portions of the check have been paid */
  evenSplitPaidPortions: Scalars['Int']['input'];
  /** Indicates how many portions the check can be split into */
  evenSplitPortions: Scalars['Int']['input'];
  /** Indicates what split type the check is being split by */
  splitMode: Opt_SplitMode;
};

export type Opt_SplitPaymentInitializationDataInput = {
  /** Indicates how many portions the check can be split into */
  evenSplitPortions: Scalars['Int']['input'];
  /** Indicates what split type the check is being split by */
  splitMode: Opt_SplitMode;
};

export type Opt_SplitPaymentPaidPortionInput = {
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** Split Evenly metadata for number of portions, as well as how many have been paid */
  splitPaymentData: Opt_SplitPaymentDataInput;
};

/** Configuration for optional information a restaurant could spotlight */
export type Opt_SpotlightConfig = {
  __typename?: 'OPT_SpotlightConfig';
  /** Spotlight secondary header text. Can be arbitrary length */
  bodyText?: Maybe<Scalars['String']['output']>;
  /** Spotlight primary header text. Should be a relatively short message Max length of 150 characters */
  headerText?: Maybe<Scalars['String']['output']>;
};

/** Concrete type for String feature flag results. Contains the flag and a String value representing its current state. */
export type Opt_StringFeatureFlagResult = Opt_FeatureFlagResult & {
  __typename?: 'OPT_StringFeatureFlagResult';
  flag: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** generic key-value pair object */
export type Opt_StringKeyVal = {
  __typename?: 'OPT_StringKeyVal';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** generic key-value pair object */
export type Opt_StringKeyValInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Possible payment types that a surcharge summary can be applicable to. Derived from Orders API (link will undergo updates): https://github.toasttab.com/toasttab/toast-orders/blob/arina.ielchiieva/OAPI-1101-check-summary-endpoint/toast-orders-api/src/main/java/com/toasttab/service/orders/enums/PaymentType.kt Independent of the plain PaymentType enum, which does not acknowledge debit cards. */
export enum Opt_SurchargePaymentType {
  Cash = 'CASH',
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Giftcard = 'GIFTCARD'
}

/** The surcharge summary information for a single collection of payment types. If surcharging is not applicable for a restaurant, e.g. the surcharging config is disabled, then paymentTypes will have every payment type, and the amounts and rates will be zero. */
export type Opt_SurchargeSummaryForPaymentTypes = {
  __typename?: 'OPT_SurchargeSummaryForPaymentTypes';
  /** A list of payment types that this surcharge info is applicable on. */
  paymentTypes: Array<Opt_SurchargePaymentType>;
  /** The surcharge amount for the check without tax applied. */
  surchargePreTaxAmount: Scalars['Float']['output'];
  /** The percentage used to calculate surcharge amounts in decimal format (0.03, not 3%). */
  surchargeRate: Scalars['Float']['output'];
  /** The surcharge amount for the check with tax applied. */
  surchargeTaxAmount: Scalars['Float']['output'];
};

export type Opt_TfgConfig = {
  __typename?: 'OPT_TfgConfig';
  /** Whether roundup feature is enabled or not */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** campaign Description */
  campaignDescription?: Maybe<Scalars['String']['output']>;
  /** campaign logo */
  campaignLogoURL?: Maybe<Scalars['String']['output']>;
  /** campaign name */
  campaignName?: Maybe<Scalars['String']['output']>;
  /** service charge associated with the Toast for good config */
  serviceChargeGuid?: Maybe<Scalars['String']['output']>;
};

export type Opt_TfgInput = {
  estimatedRoundUpValue: Scalars['Float']['input'];
  roundUpEnabled: Scalars['Boolean']['input'];
};

export type Opt_ToastPayConfig = {
  __typename?: 'OPT_ToastPayConfig';
  /** Whether we enable ability to pay with split payments for Toast Pay restaurants. This value cannot currently be controlled by the restaurant, and is primarily a toggle we can use for rollout purposes. */
  splitPaymentsEnabled: Scalars['Boolean']['output'];
};

/** Field representing the unit which is used to measure the weight of an item. */
export enum Opt_UnitOfMeasure {
  /** Grams */
  G = 'G',
  /** Kilograms */
  Kg = 'KG',
  /** Pounds */
  Lb = 'LB',
  /** None - this is the default */
  None = 'NONE',
  /** Ounces */
  Oz = 'OZ'
}

export type Opt_UpdateBasicInfoError = Opt_Error & {
  __typename?: 'OPT_UpdateBasicInfoError';
  code: Opt_UpdateBasicInfoErrorCode;
  message: Scalars['String']['output'];
};

export enum Opt_UpdateBasicInfoErrorCode {
  InvalidBasicInfo = 'INVALID_BASIC_INFO'
}

export type Opt_UpdateBasicInfoResponse = {
  __typename?: 'OPT_UpdateBasicInfoResponse';
  customer: Opt_Customer;
};

export type Opt_UpdateBasicInfoResponseOrError = Opt_UpdateBasicInfoError | Opt_UpdateBasicInfoResponse;

export type Opt_UpdatePartyMemberInput = {
  /** One of PartyMembers updatable properties. */
  contactInfo?: InputMaybe<Opt_ContactInfo>;
  /** One of PartyMembers updatable properties. */
  emoji?: InputMaybe<Scalars['String']['input']>;
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** One of PartyMembers updatable properties. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
};

export type Opt_UpdatePaymentIntentForSplitCheckBySelectionsInput = {
  /** Email to be sent for fraud checks. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Indicates to set the externalReferenceId when payment confirmation has to be retried */
  enableConfirmRetry?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gift Card Payment */
  giftCard?: InputMaybe<Opt_GiftCardPaymentInput>;
  /** Promo code to be used for a Toast Cash redemption. Normal restaurant promo codes should *not* be submitted here. */
  globalGiftCard?: InputMaybe<Opt_GlobalGiftCardPaymentInput>;
  /** Toast Cash from the guest currency account, a global wallet tied to the guest */
  guestCurrencyAccount?: InputMaybe<Opt_GuestCurrencyAccountPaymentInput>;
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** Identifier for the payment intent to be updated */
  paymentIntentId: Scalars['ID']['input'];
  /** Identifier of the payment method, which can inform pricing calculations. */
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  /** List of selections to split, paired with floats indicating how they should be split. */
  selectionsToSplit: Array<Opt_SplitItemInput>;
  /** The amount of tip the customer intends to give. */
  tipAmount: Scalars['Float']['input'];
};

export type Opt_UpdatePaymentIntentInput = {
  /** Identifier for the check */
  checkGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Email to be sent for fraud checks. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Indicates to set the externalReferenceId when payment confirmation has to be retried */
  enableConfirmRetry?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gift Card Payment */
  giftCard?: InputMaybe<Opt_GiftCardPaymentInput>;
  /** Promo code to be used for a Toast Cash redemption. Normal restaurant promo codes should *not* be submitted here. */
  globalGiftCard?: InputMaybe<Opt_GlobalGiftCardPaymentInput>;
  /** Toast Cash from the guest currency account, a global wallet tied to the guest */
  guestCurrencyAccount?: InputMaybe<Opt_GuestCurrencyAccountPaymentInput>;
  /** Member's auth token. */
  memberAuthToken: Scalars['String']['input'];
  /** Party member is a part of. */
  partyGuid: Scalars['ID']['input'];
  /** Member's unique identifier. */
  partyMemberGuid: Scalars['ID']['input'];
  /** Identifier for the payment intent to be updated */
  paymentIntentId: Scalars['ID']['input'];
  /** Identifier of the payment method, which can inform pricing calculations. */
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  /** The amount of tip the customer intends to give. */
  tipAmount: Scalars['Float']['input'];
  /** Indicates whether split payment data should be used for pricing. */
  useSplitPaymentData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Opt_UpdatePaymentIntentResponse = Opt_PaymentIntentError | Opt_UpdatePaymentIntentSuccess;

export type Opt_UpdatePaymentIntentSuccess = {
  __typename?: 'OPT_UpdatePaymentIntentSuccess';
  /** The base amount the guest is expecting to pay for, not including the surcharge: check amount + tip - gift card - Toast Cash */
  baseAmount?: Maybe<Scalars['Float']['output']>;
  /** The actual amount on the payment intent that we intend to charge, in the minimum denomination of the currency: check amount + tip + surcharge - gift card - Toast Cash */
  intentAmount: Scalars['Int']['output'];
  /** The surcharge portion of the intent amount, in the default currency representation */
  surchargeAmount?: Maybe<Scalars['Float']['output']>;
};

export type Opt_UpsellsConfig = {
  __typename?: 'OPT_UpsellsConfig';
  enabled: Scalars['Boolean']['output'];
};

export type Opt_ValidateApplePayMerchantError = Opt_Error & {
  __typename?: 'OPT_ValidateApplePayMerchantError';
  code: Opt_ValidateApplePayMerchantErrorCode;
  message: Scalars['String']['output'];
};

export enum Opt_ValidateApplePayMerchantErrorCode {
  ValidateMerchantFailed = 'VALIDATE_MERCHANT_FAILED'
}

export type Opt_ValidateApplePayMerchantInput = {
  /** The domain which the Apple Pay JS client is running */
  merchantDomain: Scalars['String']['input'];
  /** The GUID of the restaurant that client is using for checkout */
  restaurantGuid: Scalars['ID']['input'];
  /** The url generated by the Apple Pay JS client that will be used for merchant validation */
  validationURL: Scalars['String']['input'];
};

/** extend type Query {} */
export type Opt_ValidateApplePayMerchantResponse = Opt_ValidateApplePayMerchantError | Opt_ValidateApplePayMerchantSuccessResponse;

export type Opt_ValidateApplePayMerchantSuccessResponse = {
  __typename?: 'OPT_ValidateApplePayMerchantSuccessResponse';
  merchantSession: Scalars['String']['output'];
};

/** Indicates that although the intended result of a query or mutation was achieved, there are side effects that would affect downstream actions. */
export type Opt_Warning = {
  message: Scalars['String']['output'];
};

export type OfferBadge = {
  /** The display text of a badge */
  badgeText: Scalars['String']['output'];
};

export type OfferTargeting = LocationTargeting | NoTargeting | RestaurantTargeting;

export type OffersQuery = {
  __typename?: 'OffersQuery';
  /** Promo offers are offers funded by the Restaurant. They are configured by the Restaurant administrators, and use discounts on the check to redeem the value. Restaurant's receive only the value of the order after discount. */
  rankedPromoOffers: RankedPromoOffersResponseOrError;
  /** Toast funded offers are offers funded by Toast. They are configured by Toast administrators, and use payments on the check to redeem the value. Currently, the payment type used is Toast Cash, so that restaurants receive the full value of the order, with Toast partially paying the order with the offer value. */
  rankedToastFundedOffers: RankedToastFundedOffersResponseOrError;
};


export type OffersQueryRankedPromoOffersArgs = {
  input: RankedPromoOffersInput;
};


export type OffersQueryRankedToastFundedOffersArgs = {
  input: RankedToastFundedOffersInput;
};

export type OnlineOrderingMutation = {
  __typename?: 'OnlineOrderingMutation';
  spiCreateGiftCardPaymentIntent: OnlineOrderingSpiCreatePaymentIntentResponse;
  spiCreatePaymentIntent: OnlineOrderingSpiCreatePaymentIntentResponse;
  spiUpdateGiftCardPaymentIntent: OnlineOrderingSpiUpdatePaymentIntentResponse;
  spiUpdatePaymentIntent: OnlineOrderingSpiUpdatePaymentIntentResponse;
};


export type OnlineOrderingMutationSpiCreateGiftCardPaymentIntentArgs = {
  input: OnlineOrderingSpiCreateGiftCardPaymentIntentInput;
};


export type OnlineOrderingMutationSpiCreatePaymentIntentArgs = {
  input: OnlineOrderingSpiCreatePaymentIntentInput;
};


export type OnlineOrderingMutationSpiUpdateGiftCardPaymentIntentArgs = {
  input: OnlineOrderingSpiUpdateGiftCardPaymentIntentInput;
};


export type OnlineOrderingMutationSpiUpdatePaymentIntentArgs = {
  input: OnlineOrderingSpiUpdatePaymentIntentInput;
};

export type OnlineOrderingPaymentIntentError = Error & {
  __typename?: 'OnlineOrderingPaymentIntentError';
  message: Scalars['String']['output'];
};

export type OnlineOrderingQuery = {
  __typename?: 'OnlineOrderingQuery';
  spiGetClientToken: OnlineOrderingSpiGetClientTokenResponse;
};

export type OnlineOrderingSpiCreateGiftCardPaymentIntentInput = {
  amount: Scalars['Float']['input'];
  deliveryProvider?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  orderSource?: InputMaybe<Scalars['String']['input']>;
  paymentMethodConfigId?: InputMaybe<Scalars['ID']['input']>;
  restaurantGuid: Scalars['ID']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type OnlineOrderingSpiCreatePaymentIntentInput = {
  cartGuid: Scalars['ID']['input'];
  deliveryProvider?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  orderSource?: InputMaybe<Scalars['String']['input']>;
  paymentMethodConfigId?: InputMaybe<Scalars['ID']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type OnlineOrderingSpiCreatePaymentIntentResponse = OnlineOrderingPaymentIntentError | OnlineOrderingSpiCreatePaymentIntentSuccessResponse;

export type OnlineOrderingSpiCreatePaymentIntentSuccessResponse = {
  __typename?: 'OnlineOrderingSpiCreatePaymentIntentSuccessResponse';
  amount: Scalars['Int']['output'];
  captureMethod: Scalars['String']['output'];
  creationDate: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  externalReferenceId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  sessionSecret: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OnlineOrderingSpiGetClientTokenResponse = OnlineOrderingPaymentIntentError | OnlineOrderingSpiGetClientTokenSuccessResponse;

export type OnlineOrderingSpiGetClientTokenSuccessResponse = {
  __typename?: 'OnlineOrderingSpiGetClientTokenSuccessResponse';
  token: Scalars['String']['output'];
};

export type OnlineOrderingSpiUpdateGiftCardPaymentIntentInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  enableConfirmRetry?: InputMaybe<Scalars['Boolean']['input']>;
  giftCardAmount: Scalars['Float']['input'];
  globalGiftCardPaymentAmount: Scalars['Float']['input'];
  paymentIntentId: Scalars['ID']['input'];
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  restaurantGuid: Scalars['ID']['input'];
};

export type OnlineOrderingSpiUpdatePaymentIntentInput = {
  cartGuid: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  enableConfirmRetry?: InputMaybe<Scalars['Boolean']['input']>;
  fundraisingAmount?: InputMaybe<Scalars['Float']['input']>;
  globalGiftCardPaymentAmount: Scalars['Float']['input'];
  paymentIntentId: Scalars['ID']['input'];
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  restaurantGiftCardPaymentAmount: Scalars['Float']['input'];
  tipAmount: Scalars['Float']['input'];
};

export type OnlineOrderingSpiUpdatePaymentIntentResponse = OnlineOrderingPaymentIntentError | OnlineOrderingSpiUpdatePaymentIntentSuccessResponse;

export type OnlineOrderingSpiUpdatePaymentIntentSuccessResponse = {
  __typename?: 'OnlineOrderingSpiUpdatePaymentIntentSuccessResponse';
  guestGuid?: Maybe<Scalars['ID']['output']>;
  intentAmount: Scalars['Int']['output'];
  surchargeAmount?: Maybe<Scalars['Float']['output']>;
};

export type OptMenuConfig = {
  __typename?: 'OptMenuConfig';
  menusEnabled: Scalars['Boolean']['output'];
  showFeaturedItems: Scalars['Boolean']['output'];
  showPopularItems: Scalars['Boolean']['output'];
};

export type OptOrderingConfig = {
  __typename?: 'OptOrderingConfig';
  orderingEnabled: Scalars['Boolean']['output'];
};

export type OptPaymentConfig = {
  __typename?: 'OptPaymentConfig';
  paymentEnabled: Scalars['Boolean']['output'];
};

export type OptQuery = {
  __typename?: 'OptQuery';
  menuConfig: OptMenuConfig;
  orderingConfig: OptOrderingConfig;
  paymentConfig: OptPaymentConfig;
  spotlightConfig: OptSpotlightConfig;
};


export type OptQueryMenuConfigArgs = {
  restaurantGuid: Scalars['ID']['input'];
};


export type OptQueryOrderingConfigArgs = {
  restaurantGuid: Scalars['ID']['input'];
};


export type OptQueryPaymentConfigArgs = {
  restaurantGuid: Scalars['ID']['input'];
};


export type OptQuerySpotlightConfigArgs = {
  restaurantGuid: Scalars['ID']['input'];
};

export type OptSpotlightConfig = {
  __typename?: 'OptSpotlightConfig';
  body: Scalars['String']['output'];
  header: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type Order = {
  __typename?: 'Order';
  /** @deprecated use discounts field instead */
  appliedCustomerReward?: Maybe<AppliedCustomerReward>;
  /**
   * The delivery fee based on the current delivery info, provided this is a delivery order.
   * @deprecated service charges are separated out into different categories such as processingServiceCharges and deliveryServiceCharges
   */
  deliveryChargeTotal?: Maybe<Scalars['Float']['output']>;
  /** The delivery info to use to calculate delivery fees, provided this is a delivery order. */
  deliveryInfo?: Maybe<DeliveryInfo>;
  /** The sum of the service charges that are not UBP and only for delivery orders */
  deliveryServiceCharges: Scalars['Float']['output'];
  /** An object containing potential discounts applied to order, such as a global reward or a restaurant specific reward. */
  discounts: Discounts;
  /** Total of all the discounts applied to the order. */
  discountsTotal: Scalars['Float']['output'];
  /** The sum of the service charges that are not UBP, not only for delivery orders, and identified as gratuity */
  gratuityServiceCharges: Scalars['Float']['output'];
  /** The sum of the cost of all items in the cart except for outpost fees */
  itemsSubtotal: Scalars['Float']['output'];
  /** The sum of the service charges that are not UBP, not only for delivery orders, and not identified as gratuity */
  nonDeliveryNonGratuityNonUbpServiceCharges: Scalars['Float']['output'];
  numberOfSelections?: Maybe<Scalars['Int']['output']>;
  /** A number that indicates how much to charge a user for placing an outpost order. This value will only be non null if the order is an outpost order, otherwise it will be null. */
  outpostFee?: Maybe<Scalars['Float']['output']>;
  /** The sum of the cost of all items, before discounts, in the cart except for outpost fees */
  preDiscountItemsSubtotal: Scalars['Float']['output'];
  /** The sum of the service charges identified as UBP (user based pricing) */
  processingServiceCharges: Scalars['Float']['output'];
  promisedDateTime?: Maybe<Scalars['Float']['output']>;
  selections?: Maybe<Array<Maybe<Selection>>>;
  /**
   * Does not include delivery charges.
   * @deprecated service charges are separated out into different categories such as processingServiceCharges and deliveryServiceCharges
   */
  serviceChargeTotal?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use itemsSubtotal */
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** A breakdown of potential surcharge amounts on the check depending on the payment type. Payment types are unique across all list elements, e.g. you won't see multiple surcharge entries with PaymentType.CREDIT. */
  surcharges?: Maybe<Array<SurchargeSummaryResponse>>;
  /** @deprecated use taxV2 field instead */
  tax?: Maybe<Scalars['Float']['output']>;
  /** The order tax calculated after applying global promo codes if they exist. */
  taxV2?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use totalV2 field instead */
  total?: Maybe<Scalars['Float']['output']>;
  /** The order total calculated after applying global promo codes if they exist. */
  totalV2?: Maybe<Scalars['Float']['output']>;
};


export type OrderAppliedCustomerRewardArgs = {
  input?: InputMaybe<ApplyCustomerRewardInput>;
};


export type OrderSurchargesArgs = {
  totalGiftCardBalance?: InputMaybe<Scalars['Float']['input']>;
};

export enum OrderApprovalStatus {
  Approved = 'APPROVED',
  Future = 'FUTURE',
  NeedsApproval = 'NEEDS_APPROVAL',
  NotApproved = 'NOT_APPROVED'
}

export type OrderDetails = {
  __typename?: 'OrderDetails';
  checkId: Scalars['ID']['output'];
  /** Whether a guest has a pre-authorization on corresponding check. */
  hasPreauth: Scalars['Boolean']['output'];
  orderId: Scalars['ID']['output'];
};

/** The guestGuid will be extracted from the JWT */
export type OrderHistoryInput = {
  /** @deprecated This property will no longer be used to determine whether to show null orders. Instead a check for all default expectedOrderSources is used. */
  allowNullOrderSource?: InputMaybe<Scalars['Boolean']['input']>;
  /** This property will default to show only off-prem orders. Starting Oct 2023 only orders made on MOP and MP have an orderSource connected to the guest-profiles saved order. All earlier orders and orders from other platforms will have a null orderSource. If a client wants to receive null orderSources all four of these default orderSources must be listed as expectedOrderSources ONLINE, CONSUMER_APP, LOCAL, BOO. */
  expectedOrderSources?: InputMaybe<Array<InputMaybe<OrderSource>>>;
  /** The page token to retrieve the next page of results. To retrieve the first page, set this to null. All subsequent request should have a non-null value for this. */
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Number of results to return for this given page. Default: 20 Max: 100 (exclusive) */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Filter results to only include orders at the specified restaurant. */
  restaurantGuid?: InputMaybe<Scalars['ID']['input']>;
  /** This property will default to show only orders from the expectedOrderSources. If this property is true it will show all orders from all orderSources. */
  showAllOrdersFromAllSources?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderHistoryResponse = {
  __typename?: 'OrderHistoryResponse';
  /** Page token used to retrieve the current page of orders. Passing this value through as the pageToken in subsequent requests will result in the same orders being retrieved. */
  currentPageToken?: Maybe<Scalars['String']['output']>;
  /** Page token used to retrieve the next page of orders. When this field is null that indicates that [currentPageToken] was the last page in the result set. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
  /** The guest's orders sorted via openedDate newest -> oldest */
  orders: Array<CompletedOrder>;
};

export type OrderIdentifier = {
  diningOptionBehavior: DiningOptionBehavior;
  /** DeliveryServiceInfo is returned on the Order object and indicates that an order is a Third Party Delivery Service(3PD) order. When this value is true, tracking details will be returned in the response for this order */
  isThirdPartyDeliveryServiceOrder: Scalars['Boolean']['input'];
  orderGuid: Scalars['String']['input'];
  restaurantGuid: Scalars['String']['input'];
};

export enum OrderSource {
  Api = 'API',
  Boo = 'BOO',
  CallerId = 'CALLER_ID',
  Catering = 'CATERING',
  CateringOo = 'CATERING_OO',
  ConsumerApp = 'CONSUMER_APP',
  Google = 'GOOGLE',
  Grubhub = 'GRUBHUB',
  Invoice = 'INVOICE',
  InStore = 'IN_STORE',
  Kiosk = 'KIOSK',
  Local = 'LOCAL',
  Online = 'ONLINE',
  Opt = 'OPT',
  Tables = 'TABLES',
  Unknown = 'UNKNOWN'
}

export type OrderStatusData = {
  __typename?: 'OrderStatusData';
  channelGuid?: Maybe<Scalars['String']['output']>;
  checkDisplayNumber?: Maybe<Scalars['String']['output']>;
  deliveryStatus?: Maybe<ThirdPartyDeliveryStatus>;
  diningOption: DiningOption;
  estimatedFulfillmentDate?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  guestOrderStatus?: Maybe<OrderStatusType>;
  lastNameInitial?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  orderGuid: Scalars['String']['output'];
  restaurantGuid: Scalars['String']['output'];
  trackingDetails?: Maybe<TrackingDetails>;
  version?: Maybe<Scalars['String']['output']>;
};

/** The different states or an order tracked order. If **orderStatus** is null then the restaurant does not support order tracking currently */
export enum OrderStatusType {
  /** The order has been marked as completed by the restaurant through the KDS. Existing but is not supported */
  AlmostReady = 'ALMOST_READY',
  Approved = 'APPROVED',
  /** Marking the paid orders as closed automatically nightly */
  AutoClosed = 'AUTO_CLOSED',
  /** Marking orders closed manually. */
  Closed = 'CLOSED',
  /** To Indicate that an order is a scheduled order */
  Future = 'FUTURE',
  InPreparation = 'IN_PREPARATION',
  /** An order is being prepared. */
  Preparing = 'PREPARING',
  /** The order is ready for pickup. Set 90 seconds after the order becomes **ALMOST_READY** to account for bagging and placing order on shelf etc. */
  ReadyForPickup = 'READY_FOR_PICKUP',
  /** An order has been received and is present in the orders database. */
  Received = 'RECEIVED',
  /** When a RECEIVED state order reaches 15 minutes past its estimated completion date, it becomes unfulfilled. */
  Unfulfilled = 'UNFULFILLED',
  Unknown = 'UNKNOWN',
  Voided = 'VOIDED'
}

export type OrderStatusesInput = {
  orderIdentifiers: Array<OrderIdentifier>;
};

export type OrderStatusesResponse = {
  __typename?: 'OrderStatusesResponse';
  orderStatusesResponse?: Maybe<Array<OrderStatusData>>;
};

export enum OrderTriggerMatchType {
  CashGteq = 'CASH_GTEQ',
  CreditLt = 'CREDIT_LT',
  DeliveryLt = 'DELIVERY_LT',
  TotalGteq = 'TOTAL_GTEQ'
}

export type Outpost = {
  __typename?: 'Outpost';
  /** An outpost guid is generated at the time of the creation of the outpost and can be associated as the dining option when ordering from a specific restaurant for outpost. */
  guid: Scalars['String']['output'];
  /** URL for the image for the outpost. */
  image?: Maybe<Scalars['String']['output']>;
  /** Name of the outpost which is the exact name of the dining option this outpost is associated with. */
  name: Scalars['String']['output'];
  /** The display name for an outpost location */
  outpostName: Scalars['String']['output'];
  /** Schedule of restaurants for the next 7 days with index 0 = today with respect to the outpost's time zone. */
  schedule: Array<OutpostDay>;
};

export type OutpostDay = {
  __typename?: 'OutpostDay';
  /** A specific number that corresponds to the day of the week. Monday is 1 and Sunday is 7 [1-7] */
  dayOfWeek: Scalars['Int']['output'];
  /** List of restaurants that are available on a specific day. */
  outpostRestaurants: Array<OutpostRestaurant>;
};

export type OutpostDaySchedule = {
  __typename?: 'OutpostDaySchedule';
  /** The latest acceptable time to place an outpost order, presented as an ISO date+time string. */
  cutoffDateTime: Scalars['String']['output'];
  /** The latest acceptable time to place an outpost order, presented as an ISO local time string. */
  cutoffTime: Scalars['String']['output'];
  /** The time that an order will be delivered to the outpost by, presented as an ISO date+time string. */
  deliveryDateTime: Scalars['String']['output'];
  /** The time that an order will be delivered to the outpost by, presented as an ISO local time string. */
  deliveryTime: Scalars['String']['output'];
};

export type OutpostInput = {
  /** The diner's current latitude for determining which outposts should be available (leaving optional will return all outposts) */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** The diner's current longitude for determining which outposts should be available (leaving optional will return all outposts) */
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type OutpostRestaurant = {
  __typename?: 'OutpostRestaurant';
  /**
   * The latest acceptable time to place an outpost order.
   * @deprecated replaced by daySchedule
   */
  cutOffTime: Scalars['String']['output'];
  /** The cut off and delivery time for one day for this OutpostRestaurant. When getting a single OutpostRestaurant, the schedule for today--with respect to the outpost's timezone--is returned. When this as part of a schedule, the day of the week from the schedule is used. */
  daySchedule?: Maybe<OutpostDaySchedule>;
  /**
   * The time that an order will be delivered to the outpost by.
   * @deprecated replaced by daySchedule
   */
  deliveryTime: Scalars['String']['output'];
  /** The dining option GUID for this restaurant-outpost pair */
  diningOptionGuid: Scalars['ID']['output'];
  /** Whether or not a user can place an outpost order at this outpost-restaurant pair currently. */
  orderableNow: Scalars['Boolean']['output'];
  /** Outpost info for a specific outpost restaurant */
  outpost: Outpost;
  /** Restaurant info for a specific outpost restaurant */
  restaurant: Restaurant;
};

export type OutpostRestaurantInput = {
  /** The guid of the dining option representing this outpost-restaurant pair. */
  diningOptionGuid: Scalars['ID']['input'];
};

export type OutpostScheduleInput = {
  /** The guid of the specific outpost we want to request the schedule for. */
  guid: Scalars['String']['input'];
};

/** See PackagingConfig in order-config's OpenAPI spec for field information and examples. https://github.com/toasttab/toast-orders-config/blob/main/toast-orders-config-api/src/main/resources/toast-orders-config-api.yaml */
export type PackagingConfig = {
  __typename?: 'PackagingConfig';
  enabled: Scalars['Boolean']['output'];
  guestMessage?: Maybe<Scalars['String']['output']>;
  items: Array<PackagingItem>;
};

export enum PackagingInclusion {
  No = 'NO',
  Yes = 'YES'
}

/** Input to submit guest packaging preferences */
export type PackagingInfo = {
  packagingItems: Array<PackagingItemInput>;
};

/** See PackagingItem in order-config's OpenAPI spec for field information and examples. https://github.com/toasttab/toast-orders-config/blob/main/toast-orders-config-api/src/main/resources/toast-orders-config-api.yaml */
export type PackagingItem = {
  __typename?: 'PackagingItem';
  guestDescription?: Maybe<Scalars['String']['output']>;
  guestDisplayName: Scalars['String']['output'];
  guestInclusionType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemTypes: Array<Scalars['String']['output']>;
};

/** Guest packaging preference corresponding to a particular configured packaging item */
export type PackagingItemInput = {
  included: Scalars['Boolean']['input'];
  itemConfigId: Scalars['ID']['input'];
};

/** An object representing Packaging preferences selected by the guest */
export type PackagingSelection = {
  __typename?: 'PackagingSelection';
  entityType?: Maybe<Scalars['String']['output']>;
  guestDisplayName: Scalars['String']['output'];
  guid: Scalars['ID']['output'];
  inclusion: PackagingInclusion;
  itemConfigId?: Maybe<Scalars['ID']['output']>;
  itemTypes?: Maybe<Array<Scalars['String']['output']>>;
};

/** A page of `PageItem`s. This is based on cursor-based pagination, where opaque tokens indicate locations within the result and are used to retrieve subsequent pages. Create concrete types for `Page` and `PageItem` to implement use case specific behaviour. */
export type Page = {
  /** Opaque token used to retrieve the current `Page`. If the current `Page` is the first page, this will be `null`. */
  currentPageToken?: Maybe<Scalars['String']['output']>;
  /** Items in the current `Page`. */
  items: Array<PageItem>;
  /** Opaque token that can be used to retrieve the next `Page`. If there are no more `Page`s, this will be `null`. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

/** Input for retrieving a `Page` of `PageItem`s. This is based on cursor-based pagination, where opaque tokens indicate locations within the result and are used to retrieve subsequent pages. */
export type PageInput = {
  /** Number of `PageItem`s to include in the next `Page`. If not set, a default value of 20 is used. */
  nextPageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque token to retrieve the next `Page`. To retrieve the first `Page`, set this to `null`. */
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
};

/** A single item in a `Page`. Create concrete types for `Page` and `PageItem` to implement use case specific behaviour. */
export type PageItem = {
  /** Unique identifier for this item. */
  id: Scalars['ID']['output'];
};

export type PaginatedMenus = {
  __typename?: 'PaginatedMenus';
  /** Number of menu items returned in this response */
  count: Scalars['Int']['output'];
  /** Metadata about menu and menu groups, useful for constructing filter UIs */
  groupings?: Maybe<Array<MenuGrouping>>;
  /** A paginated list of menu items, returned if the number of menu items exceeds the page size limit, */
  items?: Maybe<Array<MenuItem>>;
  /** The full menus structure, returned if the number of menu items does not exceed the page size limit */
  menus?: Maybe<Array<Menu>>;
  /** Total number of menu items available */
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMenusInput = {
  /** Optional Channel identifier */
  channelGuid?: InputMaybe<Scalars['String']['input']>;
  /** Date should be in ISO 8601 format and include date and time. Example: 2019-08-07T13:00:00-04:00 */
  dateTime?: InputMaybe<Scalars['String']['input']>;
  /** A list of lists of menu/menu group GUIDs representing a path to a menu/menu group in the menu tree structure */
  filters?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  /** Determines whether the request should filter out of stock items or include them */
  hideOutOfStockItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum number of menu items to return in the paginated list */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Determine which menu API should be used for retrieving menu and stock data */
  menuApi?: InputMaybe<MenuApiType>;
  /** Offset from the beginning of the list of menu items */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates that results should be paginated even if the total count is less than the menu item cap */
  requirePagination?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines whether the request should respect fulfillment time and availability schedules */
  respectAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required if menuApi is DO */
  restaurantGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Determines the visibility to filter menu items by. Defaults to TOAST_ONLINE_ORDERING. */
  visibility?: InputMaybe<Menus_VisibilityEnum>;
};

export type PaginatedOrderResponse = {
  __typename?: 'PaginatedOrderResponse';
  orders: Array<CompletedOrder>;
  /** Total number of orders, were the list to be not paginated */
  totalSize: Scalars['Int']['output'];
};

/** Fetch past orders between two indices, for a paginated orders display (or to limit orders to display) TODO: Replace with cursor based pagination, for more info see https://graphql.org/learn/pagination/ and https://facebook.github.io/relay/graphql/connections.htm */
export type PaginatedOrdersInput = {
  /** Maximimum number of orders to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of orders to offset the returned list by, i.e. the starting index of the list */
  offset?: InputMaybe<Scalars['Int']['input']>;
  restaurantGuid: Scalars['ID']['input'];
};

export type PasswordlessAuthenticationError = Error & {
  __typename?: 'PasswordlessAuthenticationError';
  code: PasswordlessAuthenticationErrorCode;
  message: Scalars['String']['output'];
};

export enum PasswordlessAuthenticationErrorCode {
  IncorrectCode = 'INCORRECT_CODE',
  InvalidEmail = 'INVALID_EMAIL',
  InvalidName = 'INVALID_NAME',
  InvalidPhone = 'INVALID_PHONE',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  UnknownOrInvalidRefresh = 'UNKNOWN_OR_INVALID_REFRESH'
}

export type PasswordlessConfirmCodeInput = {
  code: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  source: Source;
};

export type PasswordlessConfirmCodeUnifiedInput = {
  code: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  source: Source;
};

export type PasswordlessLoginInput = {
  phone: Scalars['String']['input'];
  source: Source;
};

export type PasswordlessLoginResponse = {
  __typename?: 'PasswordlessLoginResponse';
  success: Scalars['Boolean']['output'];
};

export type PasswordlessLoginResponseOrError = PasswordlessAuthenticationError | PasswordlessLoginResponse;

export type PasswordlessLoginUnifiedInput = {
  phone: Scalars['String']['input'];
  source: Source;
};

export type PasswordlessLoginUnifiedResponse = {
  __typename?: 'PasswordlessLoginUnifiedResponse';
  success: Scalars['Boolean']['output'];
};

export type PasswordlessLoginUnifiedResponseOrError = PasswordlessAuthenticationError | PasswordlessLoginUnifiedResponse;

export type PasswordlessLogoutInput = {
  refreshToken: Scalars['String']['input'];
  source: Source;
};

export type PasswordlessLogoutResponse = {
  __typename?: 'PasswordlessLogoutResponse';
  success: Scalars['Boolean']['output'];
};

export type PasswordlessLogoutResponseOrError = PasswordlessAuthenticationError | PasswordlessLogoutResponse;

export type PasswordlessRefreshTokenInput = {
  refreshToken: Scalars['String']['input'];
  source: Source;
};

export type PasswordlessSignupInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  source: Source;
};

export type PasswordlessSignupResponse = {
  __typename?: 'PasswordlessSignupResponse';
  success: Scalars['Boolean']['output'];
};

export type PasswordlessSignupResponseOrError = PasswordlessAuthenticationError | PasswordlessSignupResponse;

export type PasswordlessTokenResponse = {
  __typename?: 'PasswordlessTokenResponse';
  accessToken: Scalars['String']['output'];
  /** Time in ISO8601 format, when the accessToken expires */
  expiresAtIso8601: Scalars['String']['output'];
  /** The guid associated with the access and refresh tokens */
  guestGuid: Scalars['ID']['output'];
  refreshToken: Scalars['String']['output'];
};

export type PasswordlessTokenResponseOrError = PasswordlessAuthenticationError | PasswordlessTokenResponse;

export type PasswordlessTokenUnifiedResponse = {
  __typename?: 'PasswordlessTokenUnifiedResponse';
  accessToken: Scalars['String']['output'];
  /** Time in ISO8601 format, when the accessToken expires */
  expiresAtIso8601: Scalars['String']['output'];
  /** The guid associated with the access and refresh tokens */
  guestGuid: Scalars['ID']['output'];
  refreshToken: Scalars['String']['output'];
};

export type PasswordlessTokenUnifiedResponseOrError = PasswordlessAuthenticationError | PasswordlessTokenUnifiedResponse;

/** It is strongly recommended to use the OrderHistory query instead when working with pw- guests */
export type PastOrdersInput = {
  /** For guest-profiles guests only This property will default to show only off-prem orders. Starting Oct 2023 only orders made on MOP and MP have an orderSource connected to the guest-profiles saved order. All earlier orders and orders from other platforms will have a null orderSource. If a client wants to receive null orderSources all four of these default orderSources must be listed as expectedOrderSources ONLINE, CONSUMER_APP, LOCAL, BOO. */
  expectedOrderSources?: InputMaybe<Array<InputMaybe<OrderSource>>>;
  /** The maximum of past orders to return, before applying the rules of **reorderableOnly**. */
  limit: Scalars['Int']['input'];
  /** When set to true, orders that belongs to at least one of the following categories will be filtered out: 1. The order is voided. 2. The restaurant that the order belongs to is not available for ASAP takeout at the moment. 3. The order has the same content (same restaurant, same items, same modifiers on the items, same quantity of contents) as one of the more recent orders. */
  reorderableOnly: Scalars['Boolean']['input'];
  /** For guest-profiles guests only This property will default to show only orders from the expectedOrderSources. If this property is true it will show all orders from all orderSources. */
  showAllOrdersFromAllSources?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayAtADistanceLinkInput = {
  /** The guest's check guid that they will pay for */
  checkGuid: Scalars['ID']['input'];
  /** The guest's phone number that will receive the message */
  phoneNumber: Scalars['String']['input'];
  /** The restaurant guid for this check */
  restaurantGuid: Scalars['ID']['input'];
};

export type PayBearerToken = {
  __typename?: 'PayBearerToken';
  /** token for front-end clients to use SPI operations */
  token: Scalars['String']['output'];
};

export type PayBearerTokenError = {
  __typename?: 'PayBearerTokenError';
  code: PayBearerTokenErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PayBearerTokenErrorCode {
  FailedToRetrieve = 'FAILED_TO_RETRIEVE'
}

export type PayBearerTokenResponse = PayBearerToken | PayBearerTokenError;

export type PayBreakdownLine = PayChargeLine | PayDiscountLine | PayPaymentLine | PaySubtotalLine | PayTaxLine | PayTipLine | PayTotalLine;

/** A service charge line to be displayed in total breakdown, can optionally have a percent value */
export type PayChargeLine = PayNamedAmount & {
  __typename?: 'PayChargeLine';
  amount: Money;
  name: Scalars['String']['output'];
  percent?: Maybe<PayPercent>;
};

export type PayCheck = {
  __typename?: 'PayCheck';
  /** Lines containing a name and amount to display on a check that is "open" (has an unpaid balance) */
  checkLines: PayCheckLines;
  /** Lines containing a name and amount to display on checkout to detail amounts due on a check that is "open" (has an unpaid balance) */
  checkoutLines: PayCheckoutLines;
  /** Not guaranteed to be unique or present. */
  displayNumber?: Maybe<Scalars['String']['output']>;
  /** Identifier for this check entity */
  id: Scalars['ID']['output'];
  /** Payment status of check */
  paymentStatus: PayPaymentStatus;
  /** Lines containing a name and amount to display on receipt to detail amounts on a check that has been paid */
  receiptLines?: Maybe<PayReceiptLines>;
  /** A list of restaurant preferred tip selections, based upon the current check */
  suggestedTipInfo: PaySuggestedTipInfo;
  /** Total amount for a check including discounts and taxes */
  totalAmount: Money;
};

export type PayCheckLines = {
  __typename?: 'PayCheckLines';
  breakdownLines: Array<PayBreakdownLine>;
  selectionLines: Array<PayLine>;
};

export type PayCheckoutByCheckError = {
  __typename?: 'PayCheckoutByCheckError';
  code: PayCheckoutByCheckErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PayCheckoutByCheckErrorCode {
  FailedToRetrieve = 'FAILED_TO_RETRIEVE',
  /** order or check not found */
  NotFound = 'NOT_FOUND'
}

export type PayCheckoutByCheckResponse = PayCheckoutByCheckError | PayCheckoutByCheckSuccess;

export type PayCheckoutByCheckSuccess = {
  __typename?: 'PayCheckoutByCheckSuccess';
  /** The total amount remaining to be paid on the other checks on the order. Even if orderHasUnpaidChecks is true, this value could still be zero in some edge cases, e.g. with $0 checks. */
  amountOnUnpaidChecksInOrder: Money;
  check: PayCheck;
  orderHasMultipleChecks: Scalars['Boolean']['output'];
  orderHasUnpaidChecks: Scalars['Boolean']['output'];
};

export type PayCheckoutByOrderError = {
  __typename?: 'PayCheckoutByOrderError';
  code: PayCheckoutByOrderErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PayCheckoutByOrderErrorCode {
  FailedToRetrieve = 'FAILED_TO_RETRIEVE',
  /** order not found */
  NotFound = 'NOT_FOUND'
}

export type PayCheckoutByOrderResponse = PayCheckoutByOrderError | PayCheckoutByOrderSuccess;

export type PayCheckoutByOrderSuccess = {
  __typename?: 'PayCheckoutByOrderSuccess';
  order: PayOrder;
};

export type PayCheckoutLines = {
  __typename?: 'PayCheckoutLines';
  breakdownLines: Array<PayBreakdownLine>;
};

export type PayCloseoutByCheckError = {
  __typename?: 'PayCloseoutByCheckError';
  code: PayCloseoutByCheckErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PayCloseoutByCheckErrorCode {
  AmountMismatch = 'AMOUNT_MISMATCH',
  FailedToApplyPayment = 'FAILED_TO_APPLY_PAYMENT',
  FailedToFindCheckWithPayment = 'FAILED_TO_FIND_CHECK_WITH_PAYMENT',
  FailedToRetrieve = 'FAILED_TO_RETRIEVE',
  FailedToRetrievePaymentIntent = 'FAILED_TO_RETRIEVE_PAYMENT_INTENT',
  NotFound = 'NOT_FOUND',
  TipAmountMismatch = 'TIP_AMOUNT_MISMATCH'
}

export type PayCloseoutByCheckInput = {
  /** checkGuid for check to closeout for */
  checkId: Scalars['ID']['input'];
  /** optional email input for digital receipt */
  email?: InputMaybe<Scalars['String']['input']>;
  /** information for optional fraud check */
  fraud?: InputMaybe<PayFraudInput>;
  /** options for closeout */
  options?: InputMaybe<PayCloseoutOptionsInput>;
  /** orderGuid for the order with the specified check */
  orderId: Scalars['ID']['input'];
  /** A payment intent id authorized via SPI for the check. Nullable for future use cases utilizing non-SPI payment methods, i.e. gift cards). */
  paymentIntentId?: InputMaybe<Scalars['ID']['input']>;
  /** restaurantGuid for the restaurant with the specified order */
  restaurantId: Scalars['ID']['input'];
  /** amount of tip the customer intends to give. */
  tipAmount: PayMoneyInput;
};

export type PayCloseoutByCheckResponse = PayCloseoutByCheckError | PayCloseoutByCheckSuccess;

export type PayCloseoutByCheckSuccess = {
  __typename?: 'PayCloseoutByCheckSuccess';
  /** The total amount remaining to be paid on the other checks on the order. Even if orderHasUnpaidChecks is true, this value could still be zero in some edge cases, e.g. with $0 checks. */
  amountOnUnpaidChecksInOrder: Money;
  check: PayCheck;
  /** Generates a receipt given the payments transacted during this closeout Receipt data can be recovered/refreshed using a query for PayReceiptLines fields, using the payment id values (PayCloseoutPayment.id) */
  closeoutReceipt: PayCloseoutReceipt;
  /** These next 3 fields are duplicated from PayCheckoutByCheckSuccess to inform the presentation of any immediate post-closeout information */
  orderHasMultipleChecks: Scalars['Boolean']['output'];
  orderHasUnpaidChecks: Scalars['Boolean']['output'];
  /** Payments that correspond to the closeout that was executed */
  payments: Array<PayCloseoutPayment>;
};

export type PayCloseoutOptionsInput = {
  /** whether or not to send an email receipt to the guest. Defaults to true */
  sendEmailReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  /** whether or not to send a POS notification to the server. Defaults to true */
  sendServerNotification?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayCloseoutPayment = {
  __typename?: 'PayCloseoutPayment';
  id: Scalars['ID']['output'];
};

export type PayCloseoutReceipt = {
  __typename?: 'PayCloseoutReceipt';
  paymentsBreakdown: PayPaymentsBreakdown;
  selectionLines: Array<PayLine>;
};

export type PayCreateMarketingSubscriptionInput = {
  /** marketing channel type, i.e. EMAIL */
  channel: PayMarketingSubscriptionChannel;
  /** optional first name of guest */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** optional last name of guest */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** restaurant id to create subscription for */
  restaurantId: Scalars['ID']['input'];
  /** Source of marketing subscription, i.e. which surface a guest has consented subscription on */
  source: PayMarketingSubscriptionSource;
  /** guest contact information, i.e. email value */
  value: Scalars['String']['input'];
};

export type PayCreateMarketingSubscriptionResponse = PayMarketingSubscriptionError | PayMarketingSubscriptionSuccess;

export type PayCreatePaymentIntentByCheckInput = {
  /** checkGuid with the total amount to use to create payment intent for */
  checkId: Scalars['ID']['input'];
  /** information for optional fraud check */
  fraud?: InputMaybe<PayFraudInput>;
  /** orderGuid for the order with the specified check */
  orderId: Scalars['ID']['input'];
  /** restaurantGuid for the restaurant with the specified order */
  restaurantId: Scalars['ID']['input'];
};

export type PayCreatePaymentIntentByCheckResponse = PayPaymentIntent | PayPaymentIntentError;

export type PayDiscountLine = PayNamedAmount & {
  __typename?: 'PayDiscountLine';
  /** As a Line or BreakdownLine, negative amount (-5.00). As a SelectionSubLine, a positive amount representing the total value of the Selection pre-discount. */
  amount: Money;
  name: Scalars['String']['output'];
  percent?: Maybe<PayPercent>;
};

export type PayForCheckError = Error & {
  __typename?: 'PayForCheckError';
  code: PayForCheckErrorCode;
  /** To notify the frontend of any changes which occurred on the order, especially in the case that the check total has changed. May not exist on all error types. */
  inProgressOrder?: Maybe<InProgressOrder>;
  message: Scalars['String']['output'];
};

export enum PayForCheckErrorCode {
  CheckAlreadyPaidFor = 'CHECK_ALREADY_PAID_FOR',
  CheckNotFound = 'CHECK_NOT_FOUND',
  InvalidPaymentRequest = 'INVALID_PAYMENT_REQUEST',
  PaymentConflict = 'PAYMENT_CONFLICT',
  PaymentDenied = 'PAYMENT_DENIED',
  PaymentOutOfSync = 'PAYMENT_OUT_OF_SYNC',
  ValidationFailed = 'VALIDATION_FAILED'
}

export type PayForCheckInput = {
  /** The amount the consumer has selected to pay, not including the tip. If this field null, the remaining balance on the check will be used. This allows for partial/split payments on a single check */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** The guid of the check to pay for */
  checkGuid: Scalars['ID']['input'];
  /** The guest's email to send a digital receipt to, also used for accrue loyalty points */
  email: Scalars['String']['input'];
  /** Expected amount to be charged, not including tips. If the client sends an expected amount to be charged, it expects this mutation to fail if the actual order balance is more than 3 cents different. */
  expectedAmount?: InputMaybe<Scalars['Float']['input']>;
  /** True if the guest opted into marketing, false if not. */
  marketable?: InputMaybe<Scalars['Boolean']['input']>;
  /** A new credit card with encrypted data. Either newCardInput, savedCardInput or pkPaymentToken must be supplied. */
  newCardInput?: InputMaybe<NewCardInput>;
  /** The order guid which contains the check that is being paid for */
  orderGuid: Scalars['ID']['input'];
  /** The guest's phone number to accrue loyalty points, can be null */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** For ApplePay. A PKPayment is a payment object from apple that contains information such as the encrypted payment token and key secure diner information. The pkPayment as well as the entiure PKPayment object including payment user metadata. Either pkPayment, newCardInput or savedCardInput must be supplied. */
  pkPayment?: InputMaybe<Scalars['String']['input']>;
  /** The promo code to apply to this order. Only necessary for global promos */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** The guid of the restaurant which has the order being paid for */
  restaurantGuid: Scalars['ID']['input'];
  /** A customer's saved credit card. Either savedCardInput, newCardInput or pkPaymentToken must be supplied. */
  savedCardInput?: InputMaybe<SavedCardInput>;
  /** The amount that the consumer selected to tip */
  tipAmount: Scalars['Float']['input'];
};

export type PayForCheckResponse = {
  __typename?: 'PayForCheckResponse';
  /** Indicates whether loyalty account was found and user accrued points for paid check. */
  hasLoyalty?: Maybe<Scalars['Boolean']['output']>;
  /** An array of all checks associated with the order still open. Used to allow the client to display any remaining balance, and the selections, to the guest. */
  remainingChecks: Array<InProgressOrderCheck>;
};

export type PayForCheckResponseOrError = PayForCheckError | PayForCheckResponse;

export type PayFraudInput = {
  /** optional email for fraud checks */
  email?: InputMaybe<Scalars['String']['input']>;
};

export type PayLine = PayDiscountLine | PaySelectionLine | PaySubtotalLine;

export type PayMarketingSubscription = {
  __typename?: 'PayMarketingSubscription';
  /** marketing channel type, i.e. EMAIL */
  channel: PayMarketingSubscriptionChannel;
  /** guest contact information, i.e. email value */
  value: Scalars['String']['output'];
};

export enum PayMarketingSubscriptionChannel {
  Email = 'EMAIL'
}

export type PayMarketingSubscriptionError = {
  __typename?: 'PayMarketingSubscriptionError';
  code?: Maybe<PayMarketingSubscriptionErrorCode>;
};

export enum PayMarketingSubscriptionErrorCode {
  FailedToCreate = 'FAILED_TO_CREATE'
}

export enum PayMarketingSubscriptionSource {
  /** Source for Toast Pay checkouts */
  PayAtTable = 'PAY_AT_TABLE',
  Table = 'TABLE'
}

export type PayMarketingSubscriptionSuccess = {
  __typename?: 'PayMarketingSubscriptionSuccess';
  subscription?: Maybe<PayMarketingSubscription>;
};

export type PayModifierLine = PayNamedAmount & {
  __typename?: 'PayModifierLine';
  amount: Money;
  name: Scalars['String']['output'];
};

export type PayMoneyInput = {
  amount: Scalars['Decimal']['input'];
  currency: Currency;
};

/** Mutations concerning pay-related operations */
export type PayMutation = {
  __typename?: 'PayMutation';
  /** applies payment to check and sends digital receipt */
  closeoutByCheck: PayCloseoutByCheckResponse;
  /** creates a marketing subscription to a restaurant for a provided value */
  createMarketingSubscription: PayCreateMarketingSubscriptionResponse;
  /** creates SPI payment intent for specified check */
  createPaymentIntentByCheck: PayCreatePaymentIntentByCheckResponse;
  splitCheckByItem: PaySplitCheckByItemResponse;
  /** Does a "dry run" of the splitCheckByItem mutation, previewing what it would look like without physically splitting the check. Does not mutate any data or change any state. */
  splitCheckByItemPreview: PaySplitCheckByItemPreviewResponse;
  /** updates SPI payment intent with amounts (total amount and tip) for specified check */
  updatePaymentIntentByCheck: PayUpdatePaymentIntentByCheckResponse;
};


/** Mutations concerning pay-related operations */
export type PayMutationCloseoutByCheckArgs = {
  input: PayCloseoutByCheckInput;
};


/** Mutations concerning pay-related operations */
export type PayMutationCreateMarketingSubscriptionArgs = {
  input: PayCreateMarketingSubscriptionInput;
};


/** Mutations concerning pay-related operations */
export type PayMutationCreatePaymentIntentByCheckArgs = {
  input: PayCreatePaymentIntentByCheckInput;
};


/** Mutations concerning pay-related operations */
export type PayMutationSplitCheckByItemArgs = {
  input: PaySplitCheckByItemInput;
};


/** Mutations concerning pay-related operations */
export type PayMutationSplitCheckByItemPreviewArgs = {
  input: PaySplitCheckByItemInput;
};


/** Mutations concerning pay-related operations */
export type PayMutationUpdatePaymentIntentByCheckArgs = {
  input: PayUpdatePaymentIntentByCheckInput;
};

export type PayNamedAmount = {
  amount: Money;
  name: Scalars['String']['output'];
};

export type PayOrder = {
  __typename?: 'PayOrder';
  checks: Array<PayCheck>;
  id: Scalars['ID']['output'];
};

export type PayPaymentIntent = {
  __typename?: 'PayPaymentIntent';
  id: Scalars['ID']['output'];
  /** amount on the payment intent that we intend to charge */
  intentAmount: Money;
  sessionSecret: Scalars['String']['output'];
};

export type PayPaymentIntentError = {
  __typename?: 'PayPaymentIntentError';
  code: PayPaymentIntentErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PayPaymentIntentErrorCode {
  FailedToCreatePaymentIntent = 'FAILED_TO_CREATE_PAYMENT_INTENT',
  FailedToRetrieve = 'FAILED_TO_RETRIEVE',
  /** order or check not found */
  NotFound = 'NOT_FOUND'
}

export type PayPaymentLine = PayNamedAmount & {
  __typename?: 'PayPaymentLine';
  amount: Money;
  name: Scalars['String']['output'];
};

export enum PayPaymentStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Paid = 'PAID'
}

/** Summarized data for a receipt, corresponding to one or more payments on a check */
export type PayPaymentlessBreakdown = {
  __typename?: 'PayPaymentlessBreakdown';
  /** Reflects all the items on the parent check */
  checkBreakdownLines: Array<PayBreakdownLine>;
};

/** Summarized data for a receipt, corresponding to one or more payments on a check */
export type PayPaymentsBreakdown = {
  __typename?: 'PayPaymentsBreakdown';
  /** The reflecting the parent check to which these payments belong. The displayed lines parent check may differ depending upon the set of queried payments. */
  checkBreakdownLines: Array<PayBreakdownLine>;
  /** Whether the payments this breakdown represents *all* of the valid payments that were responsible for closing out a given check. */
  isPartial: Scalars['Boolean']['output'];
  /** The lines that correspond to the payment(s) made */
  paymentsLines: Array<PayBreakdownLine>;
};

/** Custom type for percent-based metadata */
export type PayPercent = {
  __typename?: 'PayPercent';
  /** An percentage value, where .20 = 20%, 1 = 100%, etc. */
  value: Scalars['Float']['output'];
};

/** A precomputed value that can be used as a suggested tip amount for a guest. Reflects restaurant preferences regarding default tip selection and percentage calculations. */
export type PayPrecomputedTip = {
  __typename?: 'PayPrecomputedTip';
  /** The amount of money the tip will be charged if the guest makes this selection Note that 'zero' is a valid amount. Depending upon the guest context, could imply either they are leaving a cash tip, or no tip is being provided (e.g. because a service charge already applied, a tip is already present on the check, etc.) */
  amount: Money;
  /** Whether the tip should be pre-selected for the guest. When presented in a list: - At most one should contain true - If all contain false, no default tip should be pre-selected for a guest */
  isDefault: Scalars['Boolean']['output'];
  /** The percent of the check amount to which this precomputed tip corresponds Note that 0% is a valid value. Depending upon the guest context, could imply either they are leaving a cash tip, or no tip is being provided (e.g. because a service charge already applied, a tip is already present on the check, etc.) */
  percent: PayPercent;
};

export type PayQuantity = {
  __typename?: 'PayQuantity';
  amount: Scalars['Float']['output'];
  /** Indicates that a quantity has a unit of measure (i.e. is weighed and not measured in discrete quantities) */
  isOpenQuantity: Scalars['Boolean']['output'];
};

/** Queries concerning pay-related operations */
export type PayQuery = {
  __typename?: 'PayQuery';
  bearerToken: PayBearerTokenResponse;
  /** Returns data for a check to be displayed for Toast Pay checkout experience */
  checkoutByCheck: PayCheckoutByCheckResponse;
  checkoutByOrder: PayCheckoutByOrderResponse;
};


/** Queries concerning pay-related operations */
export type PayQueryCheckoutByCheckArgs = {
  checkId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};


/** Queries concerning pay-related operations */
export type PayQueryCheckoutByOrderArgs = {
  orderId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};

export type PayReceiptLines = {
  __typename?: 'PayReceiptLines';
  /** Defers to a default decision on how to present a paid check, without knowledge of the payment made on the check */
  paymentlessBreakdown: PayPaymentlessBreakdown;
  /** A summarized breakdown of check and payment details, corresponding to the supplied payment ids */
  paymentsBreakdown: PayPaymentsBreakdown;
  selectionLines: Array<PayLine>;
};


export type PayReceiptLinesPaymentsBreakdownArgs = {
  paymentIds: Array<Scalars['ID']['input']>;
};

export type PaySelectionLine = PayNamedAmount & {
  __typename?: 'PaySelectionLine';
  amount: Money;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  quantity: PayQuantity;
  subLines: Array<PaySelectionSubLine>;
};

/** A selection on a check and how many of it */
export type PaySelectionQuantityInput = {
  /** Integer instead of float, as the client/guest has no use case for operating on selections in decimals. Null indicates "the entire selection". */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  selectionId: Scalars['ID']['input'];
};

export type PaySelectionSubLine = PayDiscountLine | PayModifierLine;

export enum PaySplitByItemErrorCode {
  FailedToRetrieve = 'FAILED_TO_RETRIEVE',
  FailedToSplit = 'FAILED_TO_SPLIT',
  NotFound = 'NOT_FOUND'
}

/** Specific error for when one or more items is unavailable to split */
export type PaySplitCheckByItemAvailabilityError = {
  __typename?: 'PaySplitCheckByItemAvailabilityError';
  unavailableSelectionNames: Array<Scalars['String']['output']>;
};

/** Any other error when splitting by item */
export type PaySplitCheckByItemError = {
  __typename?: 'PaySplitCheckByItemError';
  code: PaySplitByItemErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export type PaySplitCheckByItemInput = {
  /** checkGuid for check to split for */
  checkId: Scalars['ID']['input'];
  /** orderGuid for the order with the specified check */
  orderId: Scalars['ID']['input'];
  /** restaurantGuid for the restaurant with the specified order */
  restaurantId: Scalars['ID']['input'];
  /** Which items and how many of them? */
  selectionQuantities: Array<PaySelectionQuantityInput>;
};

export type PaySplitCheckByItemPreviewResponse = PaySplitCheckByItemAvailabilityError | PaySplitCheckByItemError | PaySplitCheckByItemPreviewSuccess;

export type PaySplitCheckByItemPreviewSuccess = {
  __typename?: 'PaySplitCheckByItemPreviewSuccess';
  checkLines: PayCheckLines;
};

export type PaySplitCheckByItemResponse = PaySplitCheckByItemAvailabilityError | PaySplitCheckByItemError | PaySplitCheckByItemSuccess;

export type PaySplitCheckByItemSuccess = {
  __typename?: 'PaySplitCheckByItemSuccess';
  check: PayCheck;
};

export type PaySubtotalLine = PayNamedAmount & {
  __typename?: 'PaySubtotalLine';
  amount: Money;
  name: Scalars['String']['output'];
};

export type PaySuggestedTipInfo = {
  __typename?: 'PaySuggestedTipInfo';
  /** Base amount from which a tip was calculated, from which a client could do math to determine the intended % amount from a provided custom amount. */
  baseAmount: Money;
  /** All amount-based ("flat" or "open") service charges on a check, as a summed value. This allow for the contextual presentation of service charges already applied paired with suggested tip information. Service charges that do not use a specific amount as the core calculation mechanism (e.g. percent-based charges) are excluded. For example, in a case where - Service charge 1: 3% - Service charge 2: $3.00 - Service charge 3: $5.00 Using this field, we can inform the guest: "$8.00 in service charge has already been applied" If no applicable service charges are present on the check, returns null. Zero is a possible, albeit edge-case, outcome if there are service charges present also with no corresponding amounts. Does not distinguish between gratuity and non-gratuity based service charges. */
  cumulativeAppliedAmountServiceCharge?: Maybe<Money>;
  /** All *percent* service charges on a check added up. This allow for the contextual presentation of service charges already applied paired with suggested tip information. Service charges that do not use percentage as the calculation mechanism are excluded. For example, in a case where - Service charge 1: 3% - Service charge 2: 15% - Service charge 3: $5.00 Using this field, can inform the guest: "18% service charge has already been applied" If no applicable percentage service charges are present on the check, returns null. Zero is a possible, albeit edge-casey, outcome if there are percent service charges present also with no corresponding percentages. Does not distinguish between gratuity and non-gratuity based service charges. */
  cumulativeAppliedPercentageServiceCharge?: Maybe<PayPercent>;
  /** Whether we should consider this an 'additional tip', e.g. in addition to tips already on a check payment, gratuity-based service charges, etc. */
  isAdditionalTip: Scalars['Boolean']['output'];
  /** A list of restaurant-preferred pre-computed tips, from which the guest will select. For consistency in presentation across platforms, response shape is opinionated where clients are expected to respect the provided sorting order, duplication, length, etc. */
  precomputedTips: Array<PayPrecomputedTip>;
};

export type PayTaxLine = PayNamedAmount & {
  __typename?: 'PayTaxLine';
  amount: Money;
  name: Scalars['String']['output'];
};

export type PayTipLine = PayNamedAmount & {
  __typename?: 'PayTipLine';
  amount: Money;
  name: Scalars['String']['output'];
};

export type PayTotalLine = PayNamedAmount & {
  __typename?: 'PayTotalLine';
  amount: Money;
  name: Scalars['String']['output'];
};

export type PayUpdatePaymentIntentByCheckError = {
  __typename?: 'PayUpdatePaymentIntentByCheckError';
  code?: Maybe<PayUpdatePaymentIntentByCheckErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PayUpdatePaymentIntentByCheckErrorCode {
  AmountMismatch = 'AMOUNT_MISMATCH',
  FailedToRetrieve = 'FAILED_TO_RETRIEVE',
  FailedToUpdate = 'FAILED_TO_UPDATE',
  NotFound = 'NOT_FOUND'
}

export type PayUpdatePaymentIntentByCheckInput = {
  /** checkGuid with the total amount to use to update payment intent for */
  checkId: Scalars['ID']['input'];
  /** Indicates to set the externalReferenceId when payment confirmation has to be retried */
  enableConfirmRetry?: InputMaybe<Scalars['Boolean']['input']>;
  /** information for optional fraud check */
  fraud?: InputMaybe<PayFraudInput>;
  /** orderGuid for the order with the specified check */
  orderId: Scalars['ID']['input'];
  /** payment intent id to update */
  paymentIntentId: Scalars['ID']['input'];
  /** payment method id customer selected; optionally included to inform pricing calculations */
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  /** restaurantGuid for the restaurant with the specified order */
  restaurantId: Scalars['ID']['input'];
  /** amount of tip customer intends to tip */
  tipAmount: PayMoneyInput;
};

export type PayUpdatePaymentIntentByCheckResponse = PayUpdatePaymentIntentByCheckError | PayUpdatePaymentIntentByCheckSuccess;

export type PayUpdatePaymentIntentByCheckSuccess = {
  __typename?: 'PayUpdatePaymentIntentByCheckSuccess';
  /** amount on the payment intent that we intend to charge: check amount + tip */
  intentAmount?: Maybe<Money>;
};

/** The issuing network of the payment card. */
export enum PaymentCardType {
  Amex = 'AMEX',
  Citi = 'CITI',
  Diners = 'DINERS',
  Discover = 'DISCOVER',
  Eftpos = 'EFTPOS',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Laser = 'LASER',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Solo = 'SOLO',
  Unknown = 'UNKNOWN',
  Visa = 'VISA'
}

/** used to update the payment method being used during checkout */
export type PaymentIntentInput = {
  amount: Scalars['Float']['input'];
  cartGuid: Scalars['String']['input'];
  checkGuid?: InputMaybe<Scalars['String']['input']>;
  orderGuid?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: Scalars['String']['input'];
  restaurantGuid: Scalars['String']['input'];
  taxAmount: Scalars['Float']['input'];
  tipAmount: Scalars['Float']['input'];
  totalAmount: Scalars['Float']['input'];
};

/** token that initiates checkout using a specific payment method */
export type PaymentIntentResponse = {
  __typename?: 'PaymentIntentResponse';
  apmInitiationToken: Scalars['String']['output'];
};

export type PaymentIntentResponseOrError = AlternativePaymentError | PaymentIntentResponse;

/** The payment method type of the card fingerprint. For future use to include Apple Pay. */
export enum PaymentMethodType {
  ApplePay = 'APPLE_PAY',
  /** Credit/Debit card payment method. */
  Card = 'CARD'
}

export enum PaymentState {
  Acknowledged = 'ACKNOWLEDGED',
  Authorized = 'AUTHORIZED',
  Cancelled = 'CANCELLED',
  Denied = 'DENIED',
  FraudReject = 'FRAUD_REJECT'
}

export enum PaymentStatus {
  Authorized = 'AUTHORIZED',
  AuthorizedAtRisk = 'AUTHORIZED_AT_RISK',
  Cancelled = 'CANCELLED',
  Captured = 'CAPTURED',
  CaptureInProgress = 'CAPTURE_IN_PROGRESS',
  Denied = 'DENIED',
  Error = 'ERROR',
  ErrorNetwork = 'ERROR_NETWORK',
  Open = 'OPEN',
  Processing = 'PROCESSING',
  ProcessingVoid = 'PROCESSING_VOID',
  Voided = 'VOIDED',
  VoidedAtRisk = 'VOIDED_AT_RISK'
}

/** This is a subset of the values from toast-orders' com.toasttab.service.orders.api.Payment.TypeEnum See https://dev.toasttab.com/Ie5QH/apiOrdersApiReference.html#/definitions/Payment */
export enum PaymentType {
  Cash = 'CASH',
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Giftcard = 'GIFTCARD',
  HouseAccount = 'HOUSE_ACCOUNT',
  Levelup = 'LEVELUP',
  Other = 'OTHER',
  Rewardcard = 'REWARDCARD',
  Undetermined = 'UNDETERMINED'
}

/** Mutations concerning payment-related operations */
export type PaymentsMutation = {
  __typename?: 'PaymentsMutation';
  /** Specific mutations for Creating a Save-able Payment Method */
  createSetupIntent: CreateSetupIntentResponse;
};

/** Query concerning payment-related operations */
export type PaymentsQuery = {
  __typename?: 'PaymentsQuery';
  bearerToken: SetupIntentBearerTokenResponse;
};

export type PickupWindow = {
  __typename?: 'PickupWindow';
  duration: Scalars['Int']['output'];
};

export type PickupWindowDay = {
  __typename?: 'PickupWindowDay';
  dayOfWeek: DayOfWeek;
  pickupWindows: Array<PickupWindow>;
};

/** Rule defining when during business hours an item can be ordered. Current assumptions: unit is hours, applies to end of business day. */
export type PickupWindowRule = {
  __typename?: 'PickupWindowRule';
  days: Array<PickupWindowDay>;
};

/** A restaurant or food-serving place. */
export type Place = {
  __typename?: 'Place';
  /** Uniquely identifies the place. */
  id: Scalars['ID']['output'];
  /** The posts associated with the place with the following sorting: 1) The posts created by the followees of the authenticated social user are shown first, given the visibility of the posts is set to public or followers-only. 2) Once there are no more posts from followees, next the public posts are shown from social users that the authenticated social user is not following. The posts fetched for #1 will not respect `PageInput.nextPageSize` but will instead be fetched in increments of 10 weeks. Posts from #2 will respect `PageInput.nextPageSize` Note that GuestPostContent and Place have a bidirectional relationship. Due to this, If place.posts is requested from GuestPostContent an exception will be thrown to prevent unnecessary network calls. */
  posts: GuestPostPage;
  /** If the place is a Toast restaurant, this will be the internal Toast Restaurant type. If the place is not a Toast restaurant, this will be null. */
  toastRestaurant?: Maybe<Restaurant>;
};


/** A restaurant or food-serving place. */
export type PlacePostsArgs = {
  input?: InputMaybe<PageInput>;
};

/** Requires a token generated by some APM Integration, as well as customer information entered via Toast client */
export type PlaceApmOrderInput = {
  /** A token generated by an APM Integration */
  apmAuthToken: Scalars['String']['input'];
  /** The global (restaurant-agnostic) customer reward to be applied to the order being placed. The absence of this input in the request indicates that no reward is to be applied. Currently only first-order promo is supported. */
  applicableCustomerRewardInput?: InputMaybe<ApplicableCustomerRewardInput>;
  /** GUID for the cart that has the order currently being placed. */
  cartGuid: Scalars['ID']['input'];
  /** Determines curbside pickup options for an order */
  curbsidePickup?: InputMaybe<CurbsidePickupInput>;
  /** Curbside Pickup information for the order. Namely, a vehicle description. */
  curbsidePickupV2?: InputMaybe<CurbsidePickupInputV2>;
  /** Customer's information, generated by the Apple Payment Sheet */
  customer?: InputMaybe<CustomerInput>;
  /** Customer guid, should only be provided for an unconfirmed account - authenticated orders placed for a confirmed account will use the customer guid from the access token (JWT) */
  customerGuid?: InputMaybe<Scalars['ID']['input']>;
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  /** Values used for attribution */
  digitalSurface?: InputMaybe<DigitalSurface>;
  /** ***MVP feature***: The GUID of the dining option to be applied to the cart before placing the order. This overrides the dining option selected from the restaurant admin online ordering configuration, e.g. the takeout dining option would be automatically configured on the cart when it was first created, but selecting an outpost dining option would override this selection during the **placeCcOrder** mutation. */
  diningOptionGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates whether a donation amount has been applied to the order and its quantity */
  fundraisingInput?: InputMaybe<FundraisingInput>;
  /** Gift Card Payment */
  giftCard?: InputMaybe<GiftCardPaymentInput>;
  /** Indicates that a guest currency account is available and should be used to pay for some or all of the order. Null means no guest currency account is available to pay for the order. */
  guestCurrencyAccountPayment?: InputMaybe<GuestCurrencyAccountPaymentInput>;
  isCustomDomain?: InputMaybe<Scalars['Boolean']['input']>;
  /** The final delivery info to set on the order. If absent, will use whatever delivery info was previously set on the cart, if any. It is an error if the cart's dining option behavior was configured for **DELIVERY** but no delivery info is provided, either here or previously set. */
  newAddress?: InputMaybe<NewAddressInput>;
  /** The name of the alternative payment method being used, corresponds to the type of token supplied in the apmToken field */
  paymentMethod: Scalars['String']['input'];
  /** The promo code supplied by the user for order being placed, must be re-validated before applying. The absence of this input in the request indicates that no promo code is to be applied. */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** The saved address to use for an authenticated customer. Mutually exclusive with **newAddresss**. */
  savedAddress?: InputMaybe<SavedAddressInput>;
  /** This input will determine whether the place order mutation should also call loyaltySignup for the user. If the flag is false or not set, loyalty signup will not occur in the place order request. */
  signUpLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  /** The amount of tip the customer intends to give. */
  tipAmount: Scalars['Float']['input'];
};

export type PlaceApmOrderResponse = PlaceOrderCartUpdatedError | PlaceOrderError | PlaceOrderOutOfStockError | PlaceOrderResponse;

/** Requires a PKPaymentToken generated from apple pay as well as customer information generated by the Apple Payment Sheet */
export type PlaceApplePayOrderInput = {
  /** The global (restaurant-agnostic) customer reward to be applied to the order being placed. The absence of this input in the request indicates that no reward is to be applied. Currently only first-order promo is supported. */
  applicableCustomerRewardInput?: InputMaybe<ApplicableCustomerRewardInput>;
  /** GUID for the cart that has the order currently being placed. */
  cartGuid: Scalars['ID']['input'];
  /** Determines curbside pickup options for an order */
  curbsidePickup?: InputMaybe<CurbsidePickupInput>;
  /** Curbside Pickup information for the order. Namely, a vehicle description. */
  curbsidePickupV2?: InputMaybe<CurbsidePickupInputV2>;
  /** Customer's information, generated by the Apple Payment Sheet */
  customer?: InputMaybe<CustomerInput>;
  /** Customer guid, should only be provided for an unconfirmed account - authenticated orders placed for a confirmed account will use the customer guid from the access token (JWT) */
  customerGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates whether the diner has given consent for the delivery provider to communicate to them. Only relevant if the order is a DaaS order and consent is needed for the delivery provider fulfilling the delivery. Since DaaS orders only accept CC payments, this field is only present on **PlaceCcOrderInput**. */
  deliveryCommunicationConsentGiven?: InputMaybe<Scalars['Boolean']['input']>;
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  /** Values used for attribution */
  digitalSurface?: InputMaybe<DigitalSurface>;
  /** ***MVP feature***: The GUID of the dining option to be applied to the cart before placing the order. This overrides the dining option selected from the restaurant admin online ordering configuration, e.g. the takeout dining option would be automatically configured on the cart when it was first created, but selecting an outpost dining option would override this selection during the **placeCcOrder** mutation. */
  diningOptionGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates whether a donation amount has been applied to the order and its quantity */
  fundraisingInput?: InputMaybe<FundraisingInput>;
  /** Gift Card Payment */
  giftCard?: InputMaybe<GiftCardPaymentInput>;
  /** Indicates that a guest currency account is available and should be used to pay for some or all of the order. Null means no guest currency account is available to pay for the order. */
  guestCurrencyAccountPayment?: InputMaybe<GuestCurrencyAccountPaymentInput>;
  isCustomDomain?: InputMaybe<Scalars['Boolean']['input']>;
  /** The final delivery info to set on the order. If absent, will use whatever delivery info was previously set on the cart, if any. It is an error if the cart's dining option behavior was configured for **DELIVERY** but no delivery info is provided, either here or previously set. */
  newAddress?: InputMaybe<NewAddressInput>;
  /** Packaging preferences selected by the guest */
  packagingInfo?: InputMaybe<PackagingInfo>;
  /** A token generated by Apple Pay */
  pkPaymentToken: Scalars['String']['input'];
  /** The promo code supplied by the user for order being placed, must be re-validated before applying. The absence of this input in the request indicates that no promo code is to be applied. */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** The saved address to use for an authenticated customer. Mutually exclusive with **newAddresss**. */
  savedAddress?: InputMaybe<SavedAddressInput>;
  /** This input will determine whether the place order mutation should also call loyaltySignup for the user. If the flag is false or not set, loyalty signup will not occur in the place order request. */
  signUpLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  /** The amount of tip the customer intends to give. */
  tipAmount: Scalars['Float']['input'];
};

export type PlaceApplePayOrderResponse = PlaceOrderCartUpdatedError | PlaceOrderError | PlaceOrderOutOfStockError | PlaceOrderResponse;

export type PlaceAwardTally = {
  __typename?: 'PlaceAwardTally';
  place?: Maybe<Place>;
  totalVotes: Scalars['Int']['output'];
};

/** Customer is optional for future replacement with customerGuid on authenticated orders */
export type PlaceCashOrderInput = {
  cartGuid: Scalars['ID']['input'];
  /** Determines curbside pickup options for an order */
  curbsidePickup?: InputMaybe<CurbsidePickupInput>;
  /** Curbside Pickup information for the order. Namely, a vehicle description. */
  curbsidePickupV2?: InputMaybe<CurbsidePickupInputV2>;
  /** Customer's information, required for unauthenticated **placeCashOrder**, if absent for authenticated **placeCashOrder** it will be looked up based on the customerGuid. */
  customer?: InputMaybe<CustomerInput>;
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  /** Values used for attribution */
  digitalSurface?: InputMaybe<DigitalSurface>;
  /** Indicates whether a donation amount has been applied to the order and its quantity */
  fundraisingInput?: InputMaybe<FundraisingInput>;
  /** Gift Card Payment */
  giftCard?: InputMaybe<GiftCardPaymentInput>;
  /** Indicates that a guest currency account is available and should be used to pay for some or all of the order. Null means no guest currency account is available to pay for the order. */
  guestCurrencyAccountPayment?: InputMaybe<GuestCurrencyAccountPaymentInput>;
  isCustomDomain?: InputMaybe<Scalars['Boolean']['input']>;
  /** The final delivery info to set on the order. If absent, will use whatever delivery info was previously set on the cart, if any. It is an error if the cart's dining option behavior was configured for **DELIVERY** but no delivery info is provided, either here or previously set. */
  newAddress?: InputMaybe<NewAddressInput>;
  /** Packaging preferences selected by the guest */
  packagingInfo?: InputMaybe<PackagingInfo>;
  /** The saved address to use for an authenticated customer. Mutually exclusive with **newAddresss**. */
  savedAddress?: InputMaybe<SavedAddressInput>;
};

export type PlaceCashOrderResponse = PlaceOrderCartUpdatedError | PlaceOrderError | PlaceOrderOutOfStockError | PlaceOrderResponse;

/** Either the CC payment is done via a new CC or a saved CC. This means that exactly 1 of **newCardInput** and **savedCardInput** is non-null. Note that **savedCardInput** should only be non-null for an authenticated **placeCcOrder** mutation. If both fields are null or if both fields are non-null, a GraphQL error will be returned. */
export type PlaceCcOrderInput = {
  /** The global (restaurant-agnostic) customer reward to be applied to the order being placed. The absence of this input in the request indicates that no reward is to be applied. Currently only first-order promo is supported. */
  applicableCustomerRewardInput?: InputMaybe<ApplicableCustomerRewardInput>;
  /** GUID for the cart that has the order currently being placed. */
  cartGuid: Scalars['ID']['input'];
  /** Determines curbside pickup options for an order */
  curbsidePickup?: InputMaybe<CurbsidePickupInput>;
  /** Curbside Pickup information for the order. Namely, a vehicle description. */
  curbsidePickupV2?: InputMaybe<CurbsidePickupInputV2>;
  /** Customer's information, required for unauthenticated **placeCcOrder**, if absent for authenticated **placeCcOrder** it will be looked up based on the customerGuid. */
  customer?: InputMaybe<CustomerInput>;
  /** Customer guid, should only be provided for an unconfirmed account - authenticated orders placed for a confirmed account will use the customer guid from the access token (JWT) */
  customerGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates whether the diner has given consent for the delivery provider to communicate to them. Only relevant if the order is a DaaS order and consent is needed for the delivery provider fulfilling the delivery. Since DaaS orders only accept CC payments, this field is only present on **PlaceCcOrderInput**. */
  deliveryCommunicationConsentGiven?: InputMaybe<Scalars['Boolean']['input']>;
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  /** Values used for attribution */
  digitalSurface?: InputMaybe<DigitalSurface>;
  /** ***MVP feature***: The GUID of the dining option to be applied to the cart before placing the order. This overrides the dining option selected from the restaurant admin online ordering configuration, e.g. the takeout dining option would be automatically configured on the cart when it was first created, but selecting an outpost dining option would override this selection during the **placeCcOrder** mutation. */
  diningOptionGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates whether a donation amount has been applied to the order and its quantity */
  fundraisingInput?: InputMaybe<FundraisingInput>;
  /** Gift Card Payment */
  giftCard?: InputMaybe<GiftCardPaymentInput>;
  /** Indicates that a guest currency account is available and should be used to pay for some or all of the order. Null means no guest currency account is available to pay for the order. */
  guestCurrencyAccountPayment?: InputMaybe<GuestCurrencyAccountPaymentInput>;
  isCustomDomain?: InputMaybe<Scalars['Boolean']['input']>;
  /** The final delivery info to set on the order. If absent, will use whatever delivery info was previously set on the cart, if any. It is an error if the cart's dining option behavior was configured for **DELIVERY** but no delivery info is provided, either here or previously set. */
  newAddress?: InputMaybe<NewAddressInput>;
  /** A new credit card with encrypted data. */
  newCardInput?: InputMaybe<NewCardInput>;
  /** Packaging preferences selected by the guest */
  packagingInfo?: InputMaybe<PackagingInfo>;
  /** The promo code supplied by the user for order being placed, must be re-validated before applying. The absence of this input in the request indicates that no promo code is to be applied. */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** The saved address to use for an authenticated customer. Mutually exclusive with **newAddresss**. */
  savedAddress?: InputMaybe<SavedAddressInput>;
  /** A customer's saved credit card. */
  savedCardInput?: InputMaybe<SavedCardInput>;
  /** Payment intent id for semi integrated payments */
  semiPaymentIntentId?: InputMaybe<Scalars['ID']['input']>;
  /** This input will determine whether the place order mutation should also call loyaltySignup for the user. If the flag is false or not set, loyalty signup will not occur in the place order request. */
  signUpLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  /** The amount of tip the customer intends to give. */
  tipAmount: Scalars['Float']['input'];
};

export type PlaceCcOrderResponse = PlaceOrderCartUpdatedError | PlaceOrderError | PlaceOrderOutOfStockError | PlaceOrderResponse;

/** Customer is optional for future replacement with customerGuid on authenticated orders */
export type PlaceGiftCardOrderInput = {
  /** The global (restaurant-agnostic) customer reward to be applied to the order being placed. The absence of this input in the request indicates that no reward is to be applied. Currently only first-order promo is supported. */
  applicableCustomerRewardInput?: InputMaybe<ApplicableCustomerRewardInput>;
  /** GUID for the cart that has the order currently being placed. */
  cartGuid: Scalars['ID']['input'];
  /** Determines curbside pickup options for an order */
  curbsidePickup?: InputMaybe<CurbsidePickupInput>;
  /** Curbside Pickup information for the order. Namely, a vehicle description. */
  curbsidePickupV2?: InputMaybe<CurbsidePickupInputV2>;
  /** Customer's information, required for unauthenticated **placeGiftCardOrder**, if absent for authenticated **placeGiftCardOrder** it will be looked up based on the customerGuid. */
  customer?: InputMaybe<CustomerInput>;
  /** Customer guid, should only be provided for an unconfirmed account - authenticated orders placed for a confirmed account will use the customer guid from the access token (JWT) */
  customerGuid?: InputMaybe<Scalars['ID']['input']>;
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  /** Values used for attribution */
  digitalSurface?: InputMaybe<DigitalSurface>;
  /** ***MVP feature***: The GUID of the dining option to be applied to the cart before placing the order. This overrides the dining option selected from the restaurant admin online ordering configuration, e.g. the takeout dining option would be automatically configured on the cart when it was first created, but selecting an outpost dining option would override this selection during the **placeCcOrder** mutation. */
  diningOptionGuid?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates whether a donation amount has been applied to the order and its quantity */
  fundraisingInput?: InputMaybe<FundraisingInput>;
  /** Gift Card Payment */
  giftCard: GiftCardPaymentInput;
  /** Indicates that a guest currency account is available and should be used to pay for some or all of the order. Null means no guest currency account is available to pay for the order. */
  guestCurrencyAccountPayment?: InputMaybe<GuestCurrencyAccountPaymentInput>;
  isCustomDomain?: InputMaybe<Scalars['Boolean']['input']>;
  /** The final delivery info to set on the order. If absent, will use whatever delivery info was previously set on the cart, if any. It is an error if the cart's dining option behavior was configured for **DELIVERY** but no delivery info is provided, either here or previously set. */
  newAddress?: InputMaybe<NewAddressInput>;
  /** Packaging preferences selected by the guest */
  packagingInfo?: InputMaybe<PackagingInfo>;
  /** The promo code supplied by the user for order being placed, must be re-validated before applying. The absence of this input in the request indicates that no promo code is to be applied. */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** The saved address to use for an authenticated customer. Mutually exclusive with **newAddresss**. */
  savedAddress?: InputMaybe<SavedAddressInput>;
  /** This input will determine whether the place order mutation should also call loyaltySignup for the user. If the flag is false or not set, loyalty signup will not occur in the place order request. */
  signUpLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  /** The amount of tip the customer intends to give. */
  tipAmount: Scalars['Float']['input'];
};

export type PlaceGiftCardOrderResponse = PlaceOrderCartUpdatedError | PlaceOrderError | PlaceOrderOutOfStockError | PlaceOrderResponse;

export type PlaceGuestSavedListItem = GuestSavedListItem & {
  __typename?: 'PlaceGuestSavedListItem';
  id: Scalars['ID']['output'];
  itemType: GuestSavedListItemType;
  place: Place;
  rank: Scalars['Int']['output'];
};

export type PlaceInput = {
  /** ID of the place. */
  placeId: Scalars['ID']['input'];
};

export type PlaceNotFoundError = Error & {
  __typename?: 'PlaceNotFoundError';
  message: Scalars['String']['output'];
};

/** Returned when the server prevents the placing of an order due to the cart being updated automatically by the server. */
export type PlaceOrderCartUpdatedError = Error & {
  __typename?: 'PlaceOrderCartUpdatedError';
  /** The updated cart as a result of server updates. */
  cart: Cart;
  code: PlaceOrderCartUpdatedErrorCode;
  message: Scalars['String']['output'];
};

export enum PlaceOrderCartUpdatedErrorCode {
  /** The fulfillment time (for FUTURE) or quote time (for ASAP) on the cart is out of date and no longer accurate. E.g. the server automatically changed the fulfillment/quote time due to price-based prep or kitchen capacity, but the order can still be placed. In this case the **cart** field of this response will have the updated fulfillment/quote time. In contrast, if it is no longer possible to place an order at all, a **PlaceOrderError** would be returned with a code of **ORDER_TIME_UNAVAILABLE**. */
  OrderTimeChanged = 'ORDER_TIME_CHANGED',
  /** A number of items on the cart has been automatically removed due to being out of stock. */
  OutOfStock = 'OUT_OF_STOCK'
}

export type PlaceOrderError = Error & {
  __typename?: 'PlaceOrderError';
  code: PlaceOrderErrorCode;
  message: Scalars['String']['output'];
};

export enum PlaceOrderErrorCode {
  AlcoholUnsupported = 'ALCOHOL_UNSUPPORTED',
  CartContentNotFound = 'CART_CONTENT_NOT_FOUND',
  CriticalError = 'CRITICAL_ERROR',
  DiningOptionUnavailable = 'DINING_OPTION_UNAVAILABLE',
  /** When Gift card is the primary payment method this error is returned when funds are insufficient to cover the entirety of the bill (including tip). */
  GiftCardInsufficientFunds = 'GIFT_CARD_INSUFFICIENT_FUNDS',
  /** Request expected gift card to cover tip but was not not allowed according to the restaurants config. */
  GiftCardTipNotAllowed = 'GIFT_CARD_TIP_NOT_ALLOWED',
  /** The available balance in the provided guest currency account, indicated by GuestCurrencyAccountPaymentInput.guestCurrencyAccountId, is less than GuestCurrencyAccountPaymentInput.expectedGuestCurrencyAccountPaymentAmount. The client should refetch the available balance for the guest currency account and recompute GuestCurrencyAccountPaymentInput.expectedGuestCurrencyAccountPaymentAmount. */
  GuestCurrencyAccountInsufficientFunds = 'GUEST_CURRENCY_ACCOUNT_INSUFFICIENT_FUNDS',
  /** Failed to authorize a payment from the provided guest currency account, indicated by GuestCurrencyAccountPaymentInput.guestCurrencyAccountId. The client should submit the order without requesting a payment using the provided guest currency account. */
  GuestCurrencyAccountPaymentDenied = 'GUEST_CURRENCY_ACCOUNT_PAYMENT_DENIED',
  InvalidCreditCard = 'INVALID_CREDIT_CARD',
  LoyaltyRedemptionRemoved = 'LOYALTY_REDEMPTION_REMOVED',
  MissingCustomerInfo = 'MISSING_CUSTOMER_INFO',
  MissingDeliveryInfo = 'MISSING_DELIVERY_INFO',
  NotInDeliveryArea = 'NOT_IN_DELIVERY_AREA',
  OoAutofireOffline = 'OO_AUTOFIRE_OFFLINE',
  OoDeliveryDisabled = 'OO_DELIVERY_DISABLED',
  OoDisabled = 'OO_DISABLED',
  OrderTimeUnavailable = 'ORDER_TIME_UNAVAILABLE',
  PlaceOrderEmptyCart = 'PLACE_ORDER_EMPTY_CART',
  PlaceOrderFailed = 'PLACE_ORDER_FAILED',
  PlaceOrderInvalidEmail = 'PLACE_ORDER_INVALID_EMAIL',
  RewardNotFound = 'REWARD_NOT_FOUND',
  TtoDisabled = 'TTO_DISABLED',
  UnsatisfiedApprovalRule = 'UNSATISFIED_APPROVAL_RULE',
  UnsupportedPaymentMethod = 'UNSUPPORTED_PAYMENT_METHOD',
  UnsupportedPromoCode = 'UNSUPPORTED_PROMO_CODE'
}

/** Deprecated - use **PlaceOrderCartUpdatedError** */
export type PlaceOrderOutOfStockError = Error & {
  __typename?: 'PlaceOrderOutOfStockError';
  cart: Cart;
  message: Scalars['String']['output'];
};

export type PlaceOrderResponse = {
  __typename?: 'PlaceOrderResponse';
  completedOrder: CompletedOrder;
  warnings: Array<PlaceOrderWarning>;
};

export type PlaceOrderWarning = Warning & {
  __typename?: 'PlaceOrderWarning';
  code: PlaceOrderWarningCode;
  message: Scalars['String']['output'];
};

export enum PlaceOrderWarningCode {
  AfterPlaceOrderFailed = 'AFTER_PLACE_ORDER_FAILED',
  LoyaltySignupFailed = 'LOYALTY_SIGNUP_FAILED'
}

export type PlacePaidGiftCardOrderResponse = {
  __typename?: 'PlacePaidGiftCardOrderResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type PlacePaidOrderInput = {
  /** GUID for the cart that has the order currently being placed. */
  cartGuid: Scalars['ID']['input'];
  /** Determines curbside pickup options for an order */
  curbsidePickup?: InputMaybe<CurbsidePickupInput>;
  /** Curbside Pickup information for the order. Namely, a vehicle description. */
  curbsidePickupV2?: InputMaybe<CurbsidePickupInputV2>;
  /** Customer's information, required for unauthenticated **placePaidOrder**, if absent for authenticated **placePaidOrder** it will be looked up based on the customerGuid. */
  customer?: InputMaybe<CustomerInput>;
  /** Indicates whether the diner has given consent for the delivery provider to communicate to them. Only relevant if the order is a DaaS order and consent is needed for the delivery provider fulfilling the delivery. Since DaaS orders only accept CC payments, this field is only present on **PlacePaidOrderInput**. */
  deliveryCommunicationConsentGiven?: InputMaybe<Scalars['Boolean']['input']>;
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  /** Values used for attribution */
  digitalSurface?: InputMaybe<DigitalSurface>;
  /** Indicates whether a donation amount has been applied to the order and its quantity */
  fundraisingInput?: InputMaybe<FundraisingInput>;
  /** Gift Card Payment */
  giftCard?: InputMaybe<GiftCardPaymentInput>;
  /** Indicates that a guest currency account is available and should be used to pay for some or all of the order. Null means no guest currency account is available to pay for the order. */
  guestCurrencyAccountPayment?: InputMaybe<GuestCurrencyAccountPaymentInput>;
  isCustomDomain?: InputMaybe<Scalars['Boolean']['input']>;
  /** The final delivery info to set on the order. If absent, will use whatever delivery info was previously set on the cart, if any. It is an error if the cart's dining option behavior was configured for **DELIVERY** but no delivery info is provided, either here or previously set. */
  newAddress?: InputMaybe<NewAddressInput>;
  /** Packaging preferences selected by the guest */
  packagingInfo?: InputMaybe<PackagingInfo>;
  /** Payment id for the authorized payment. Orders covered by discounts or gift cards may not include a payment id. */
  paymentId?: InputMaybe<Scalars['ID']['input']>;
  /** The payment method identifier for use with SPI surcharging that will be added to the order payment object. */
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  /** Links the card fingerprint identified by the payment method id to the guest account. */
  shouldLinkPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  /** This input will determine whether the place order mutation should also call loyaltySignup for the user. If the flag is false or not set, loyalty signup will not occur in the place order request. */
  signUpLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  /** The surcharge amount for use with SPI surcharging that will be added to the order payment object. */
  surchargeAmount?: InputMaybe<Scalars['Float']['input']>;
  /** The amount of tip the customer intends to give. */
  tipAmount: Scalars['Float']['input'];
};

export type PlacePaidOrderResponse = PlaceOrderCartUpdatedError | PlaceOrderError | PlaceOrderOutOfStockError | PlaceOrderResponse;

export type PlaceResult = PlaceNotFoundError | PlaceSuccess | UnexpectedError;

export type PlaceSuccess = {
  __typename?: 'PlaceSuccess';
  place: Place;
};

export type PlaceVideoGuestPostContent = GuestPostContent & {
  __typename?: 'PlaceVideoGuestPostContent';
  caption?: Maybe<Scalars['String']['output']>;
  /** See the documentation on `GuestPostContent.place`. */
  place?: Maybe<Place>;
  /** This list is empty if `place` does not reference a Toast restaurant or if no menu items are featured. */
  toastMenuItems: Array<PlaceVideoGuestPostContentToastMenuItem>;
  video: Video;
};

export type PlaceVideoGuestPostContentToastMenuItem = {
  __typename?: 'PlaceVideoGuestPostContentToastMenuItem';
  itemGroupId: Scalars['ID']['output'];
  itemId: Scalars['ID']['output'];
};

export type PopularItemsConfig = {
  __typename?: 'PopularItemsConfig';
  enabled: Scalars['Boolean']['output'];
};

export type PopularItemsError = Error & {
  __typename?: 'PopularItemsError';
  message: Scalars['String']['output'];
};

export type PopularItemsInput = {
  menusInput: MenusInput;
  restaurantGuid: Scalars['ID']['input'];
};

export type PopularItemsResponse = {
  __typename?: 'PopularItemsResponse';
  items: Array<MenuItem>;
};

export type PopularItemsResponseOrError = PopularItemsError | PopularItemsResponse;

export type PostCommentCreatedNotificationHubItem = GuestNotificationHubItem & {
  __typename?: 'PostCommentCreatedNotificationHubItem';
  /** comments and post are nullable in the event that they are deleted or archived. */
  comment?: Maybe<VisibleGuestComment>;
  id: Scalars['ID']['output'];
  notificationRoutes?: Maybe<NotificationHubRoutes>;
  notificationText: Scalars['String']['output'];
  post?: Maybe<GuestPost>;
  timestamp: Scalars['String']['output'];
};

export type PostCommentReplyNotificationHubItem = GuestNotificationHubItem & {
  __typename?: 'PostCommentReplyNotificationHubItem';
  comment?: Maybe<VisibleGuestComment>;
  id: Scalars['ID']['output'];
  notificationRoutes?: Maybe<NotificationHubRoutes>;
  notificationText: Scalars['String']['output'];
  post?: Maybe<GuestPost>;
  timestamp: Scalars['String']['output'];
};

/** Information on a physical address in the world. Supports regions outside of the US. */
export type PostalAddress = {
  __typename?: 'PostalAddress';
  /** Unstructured data describing the lower levels of an address. > **USA**: This is commonly the first and second line of the address, where first line is building number and street name and second is the optional unit number. In regions without a well defined `locality`, you may find the locality included as an additional address line. */
  addressLines: Array<Scalars['String']['output']>;
  /** The highest subdivision in a region. > **USA**: A state Not all countries use an administrative area. */
  administrativeArea?: Maybe<Scalars['String']['output']>;
  /** Generally the city or town of the address. > **USA: A city** Not all countries have well-defined localities. */
  locality?: Maybe<Scalars['String']['output']>;
  /** The postal code of the address. > **USA**: A zip code Not all countries require postal codes. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The [ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) code for a region or country, for example "US", "UK", "CA" and "IE". > **USA:** "US" */
  regionCode: Scalars['String']['output'];
};

/** Information on a physical address in the world. Supports regions outside of the US. */
export type PostalAddressInput = {
  /** Unstructured data describing the lower levels of an address. > **USA**: This is commonly the first and second line of the address, where first line is building number and street name and second is the optional unit number. In regions without a well defined `locality`, you may find the locality included as an additional address line. */
  addressLines: Array<Scalars['String']['input']>;
  /** The highest subdivision in a region. > **USA**: A state Not all countries use an administrative area. */
  administrativeArea?: InputMaybe<Scalars['String']['input']>;
  /** Generally the city or town of the address. > **USA: A city** Some parts of the world do not well define their localities; in these situations, use `addressLines` instead. */
  locality?: InputMaybe<Scalars['String']['input']>;
  /** The postal code of the address. > **USA**: A zip code Not all countries require postal codes. */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The [ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) code for a region or country, for example "US", "UK", "CA" and "IE". > **USA:** "US" This is not validated, it is up to the client to ensure it is correct. */
  regionCode: Scalars['String']['input'];
};

/** Pre-calculated tips deriving from a restaurant-specified configuration */
export type PreComputedTip = {
  __typename?: 'PreComputedTip';
  /** Whether preComputedTip is default preferred tip specified by restaurant */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Percent as a whole number (18% = 18) */
  percent: Scalars['Int']['output'];
  /** Represents PreComputedTip percent as string rounded to single decimal place */
  percentLabel: Scalars['String']['output'];
  /** Percent as a decimal float (18% = 0.18) */
  percentV2: Scalars['Float']['output'];
  /** Represents final computation of tippable amount * tip percentage in USD */
  value: Scalars['Float']['output'];
};

/** Rule defining a date range within which an item can be ordered and a date range within which it can be fulfilled. */
export type PreorderRule = {
  __typename?: 'PreorderRule';
  fulfillmentDateRange?: Maybe<DateTimeRange>;
  orderDateRange?: Maybe<DateTimeRange>;
};

/** Indicates the guest's profile is locked and they should not be able to proceed in authentication. */
export type ProfileLockedError = {
  message: Scalars['String']['output'];
};

/** Indicates the guest's profile is locked specifically because their account is in queue to be deleted. */
export type ProfileLockedForDeletionError = Error & ProfileLockedError & {
  __typename?: 'ProfileLockedForDeletionError';
  message: Scalars['String']['output'];
};

export type PromoBanner = {
  __typename?: 'PromoBanner';
  /** The GUID of the banner */
  bannerGuid: Scalars['String']['output'];
  /** The banner text */
  bannerText: Scalars['String']['output'];
  /** The promo code that can be applied at the checkout. Example: PIZZA5 */
  promoCode: Scalars['String']['output'];
};

export type PromoBannerAvailability = {
  __typename?: 'PromoBannerAvailability';
  /** Days of the week during which this banner is available Days are represented by integers 1-7, where 1 is Monday and 7 is Sunday */
  days?: Maybe<Array<Scalars['Int']['output']>>;
  /** End date of the date range during which this banner is available */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Start date of the date range during which this banner is available */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Time range constraints on a banners promotion (e.g. available between 4-6PM) If null, there are no constraints (e.g. available all day) */
  time?: Maybe<PromoBannerAvailabilityTime>;
  /** The restaurant's timeZone, used to create the date and time strings in the availability data */
  timeZone: Scalars['String']['output'];
};

export type PromoBannerAvailabilityTime = {
  __typename?: 'PromoBannerAvailabilityTime';
  /** End of the local time range during which the offer is available (in the format HH:MM) */
  endTime: Scalars['String']['output'];
  /** Start of the local time range during which the offer is available (in the format HH:MM) */
  startTime: Scalars['String']['output'];
};

export type PromoBannerBase = {
  /** The GUID of the banner */
  bannerGuid: Scalars['String']['output'];
  /** The banner text */
  bannerText: Scalars['String']['output'];
  /** The banner type */
  type: Scalars['String']['output'];
};

export type PromoBannerInput = {
  /** The source of the request, ONLINE_ORDERING or TOAST_APP */
  requestSource?: InputMaybe<Scalars['String']['input']>;
  /** The guid of the restaurant which has the order being paid for */
  restaurantGuid: Scalars['ID']['input'];
};

export type PromoBannerResponse = {
  __typename?: 'PromoBannerResponse';
  /** @deprecated in favor of banner specific fields */
  banners: Array<PromoBanner>;
  deliveryBanners: Array<DeliveryBanner>;
  loyaltyBanners: Array<LoyaltyBanner>;
  promoCodeBanners: Array<PromoCodeBanner>;
};

export type PromoBannerResponseOrError = GeneralError | PromoBannerResponse;

export type PromoCodeBanner = PromoBannerBase & {
  __typename?: 'PromoCodeBanner';
  /** Time, date, and day of the week restrictions for when the banner is available */
  availability?: Maybe<PromoBannerAvailability>;
  /** The GUID of the banner */
  bannerGuid: Scalars['String']['output'];
  /** The banner text */
  bannerText: Scalars['String']['output'];
  /** An expanded description of the offer */
  offerDescription?: Maybe<Scalars['String']['output']>;
  /** The promo code that can be applied at the checkout. Example: PIZZA5 */
  promoCode: Scalars['String']['output'];
  /** Whether or not the offer can only be redeemed once per guest */
  singleUse: Scalars['Boolean']['output'];
  /** The promo code banner type */
  type: Scalars['String']['output'];
};

export type PromoOfferDiscount = {
  __typename?: 'PromoOfferDiscount';
  /** The GUID of the banner */
  bannerGuid: Scalars['String']['output'];
  /** The banner text */
  bannerText: Scalars['String']['output'];
  /** Raw discount data */
  discount?: Maybe<CustomDiscount>;
  /** Unique id for the cache (type + bannerGuid) */
  id: Scalars['ID']['output'];
  /** An expanded description of the offer */
  offerDescription?: Maybe<Scalars['String']['output']>;
  /** The promo code hoisted from the discount data */
  promoCode: Scalars['String']['output'];
  /** The delivery banner type */
  type: Scalars['String']['output'];
};

export type PromoOfferDiscountAvailability = {
  __typename?: 'PromoOfferDiscountAvailability';
  /** The day of the week the offer can be applied 0-6, 0 is Sunday */
  days?: Maybe<Array<Scalars['Int']['output']>>;
  /** Time range constraints on a banners promotion (e.g. available between 4-6PM) If null, there are no constraints (e.g. available all day) */
  time?: Maybe<PromoBannerAvailabilityTime>;
};

export type PromoOfferDiscountBogoAction = {
  __typename?: 'PromoOfferDiscountBogoAction';
  /** How a discount is applied if conditions are met - FIXED - How many dollars are discounted from action item - PERCENT - What percentage of the action item is discounted */
  amountType: Scalars['String']['output'];
  /** Dollar amount or percentage that is discounted */
  discountValue?: Maybe<Scalars['Float']['output']>;
  /** List of group uuids that include items that the discount can be applied to */
  groups?: Maybe<Array<Scalars['String']['output']>>;
  /** List of menu item uuids that the discount can be applied to */
  items?: Maybe<Array<Scalars['String']['output']>>;
  /** List of menu uuids that include items that the discount can be applied to */
  menus?: Maybe<Array<Scalars['String']['output']>>;
  /** Number of items that the discount can be applied to */
  numberOfFreeItems: Scalars['Int']['output'];
  /** Whether the discount is applied per item or per total */
  perItem: Scalars['Boolean']['output'];
  /** Guid of the action */
  uuid: Scalars['String']['output'];
};

export type PromoOfferDiscountPromoBanner = {
  __typename?: 'PromoOfferDiscountPromoBanner';
  /** End date the banner can be displayed until */
  bannerEndDate?: Maybe<Scalars['String']['output']>;
  /** Start date the banner can be displayed on */
  bannerStartDate?: Maybe<Scalars['String']['output']>;
  /** The text to display for the banner */
  bannerText: Scalars['String']['output'];
  /** Guid of the banner */
  guid: Scalars['String']['output'];
  /** Status of the banner - ACTIVE - can be displayed - INACTIVE - cannot be displayed - ARCHIVED - deleted */
  status: Scalars['String']['output'];
};

export type PromoOfferDiscountPromoCode = {
  __typename?: 'PromoOfferDiscountPromoCode';
  /** Banners associated with the promo code, to be displayed in the app */
  banners?: Maybe<Array<Maybe<PromoOfferDiscountPromoBanner>>>;
  /** Code used to apply an offer to a cart */
  code: Scalars['String']['output'];
  /** End date of the promo code is available for */
  endDate?: Maybe<Scalars['String']['output']>;
  /** If the promo code can only be used once */
  singleUse?: Maybe<Scalars['Boolean']['output']>;
  /** Start date of the promo code is available for */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Guid of the promo code */
  uuid: Scalars['String']['output'];
};

export type PromoOfferDiscountsInput = {
  /** The source of the request, ONLINE_ORDERING or TOAST_APP */
  requestSource?: InputMaybe<Scalars['String']['input']>;
  /** The guid of the restaurant which has the order being paid for */
  restaurantGuid: Scalars['ID']['input'];
};

export type PromoOfferDiscountsResponse = {
  __typename?: 'PromoOfferDiscountsResponse';
  discounts: Array<PromoOfferDiscount>;
  restaurantGuid: Scalars['ID']['output'];
};

export type PromoOfferDiscountsResponseOrError = GeneralError | PromoOfferDiscountsResponse;

export enum PushNotificationTargetType {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Query = {
  __typename?: 'Query';
  /** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
  CON_industryPass: Con_IndustryPass;
  /** CONCEPT - Experimental. */
  CON_person: Con_Person;
  /** CONCEPT - Experimental. */
  CON_personByName: Con_Person;
  /** Experimental: Do not use. */
  CON_queryPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Experimental feature: please reach out to the Community team (Slack @consumer-social-backend-dev) if you are interested, thank you! Guest authentication required. */
  CON_socialUserFollowedAfterReferralCampaign?: Maybe<Con_SocialUserFollowedAfterReferralCampaign>;
  /** Experimental feature: please reach out to the Community team (Slack @consumer-social-backend-dev) if you are interested, thank you! Guest authentication required. */
  CON_socialUserReferAFriendCampaign?: Maybe<Con_SocialUserReferAFriendCampaign>;
  /** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
  CON_toastCashbackRestaurants: Con_ToastCashbackRestaurantsResult;
  adsManager: AdsManagerQuery;
  /** @deprecated use discounts field on cart */
  availableRewards?: Maybe<Array<Reward>>;
  booking: BookingQuery;
  /** @deprecated use cartV2 */
  cart?: Maybe<Cart>;
  /** Gets the cart represented by **guid**. */
  cartV2: CartResponseOrError;
  /** Allows user to query a single past order. */
  completedOrder: CompletedOrder;
  customer: Customer;
  /** Fetches loyalty information about a user at a restaurant. */
  customerLoyaltyInfo: CustomerLoyaltyInfoResponseOrError;
  customerLoyaltyInfoBulk: Array<CustomerLoyaltyInfoBulkItemResponse>;
  diningOptions: Array<DiningOption>;
  doCheckout_helloWorld: Scalars['String']['output'];
  doMenusPlaceholder?: Maybe<Scalars['String']['output']>;
  doMenus_findMenuItem: DoMenus_FindMenuItemResult;
  /** Gets a list of menu items by calling the DO getMenuItem endpoint multiple times. */
  doMenus_findMenuItems: DoMenus_FindMenuItemsResult;
  /** Gets a list of menu groups by calling the DO getMenuGroups endpoint. */
  doMenus_getMenuGroups: DoMenus_GetMenuGroupsResult;
  /** Gets a list of menu items by calling the DO getMenuItems endpoint. */
  doMenus_getMenuItems: DoMenus_GetMenuItemsResult;
  doMenus_popularItems: DoMenus_PopularItemsResult;
  doPaymentsPlaceholder?: Maybe<Scalars['String']['output']>;
  eGiftCardConfig?: Maybe<EGiftCardConfig>;
  eGiftCardShopCart: EGiftCardShopCartQuery;
  eGiftCardShopConfig: EGiftCardShopConfigQuery;
  findConsumerAppRestaurants: RestaurantSearchResultsOrError;
  /** Retrieve gift card information from Toast-Cards */
  findGiftCardBySecureToken: GiftCardDataOrError;
  fundedOffers: FundedOffersQuery;
  /** Fetches all of the posts created by the requested `SocialUser`. */
  getAllPostsForSocialUser: Array<GuestPost>;
  /** An admin query that fetches all of the reviews created by the requested `Guest`. */
  getAllReviewsForGuest: GetAllReviewsForGuestResponse;
  getAwardLeaderboard: GetAwardLeaderboardResult;
  getCartShippingRates: Array<Maybe<ShippingRate>>;
  getGuestFacingInstructions: GuestFacingMessagesConfig;
  getMyGuestNotificationHubItems: GuestNotificationHubItemPage;
  getMyGuestSavedLists: Array<GuestSavedList>;
  getMySocialUser: GetMySocialUserResult;
  getServiceGroups: Array<Maybe<ServiceGroup>>;
  /** Returns reasons a user can be reported. For use in `reportSocialUser` mutation. */
  getSocialUserReportReasons: SocialUserReportReasonsResult;
  getSocialUsers?: Maybe<GetSocialUsersResult>;
  getSurchargeSummary?: Maybe<Array<SurchargeSummaryResponse>>;
  /** Get gift card balance */
  giftCardBalanceInquiry: GiftCardBalanceInquiryResponseOrError;
  giftCardExtensionBalanceInquiry: GiftCardBalanceInquiryResponseOrError;
  /** Dummy top level Query field. Needs to exist for apollo client codegen. */
  globalGcPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Fetch a guest's profile data. A valid guest JWT and an existing profile are required. Missing or invalid guest JWT will result in a GraphQL error with code **UNAUTHORIZED**. Valid JWT but missing profile will result in a GraphQL error with code **FORBIDDEN**. */
  guest: Guest;
  /** Returns the comment for a given id. Used for UGC moderation investigation if a comment is reported. */
  guestComment?: Maybe<GuestComment>;
  /** Returns reasons a comment can be reported. For use in `reportGuestComment` mutation. */
  guestCommentReportReasons: GuestCommentReportReasonsResult;
  guestOrderReviewPrompt: GuestOrderReviewPromptResult;
  /** Fetches the post with the given `GuestPostInput.postId`. Authenticated with either admin or guest permissions. If authenticated by the latter, returns null if none of the following criteria are met: 1. The authenticated guest is the author of the post. 1. The authenticated guest is following the author of the post and the post is not private. 1. The post is set to public visibility. */
  guestPost?: Maybe<GuestPost>;
  guestPostReactions: GuestPostReactionPage;
  /** Returns reasons a post can be reported. For use in `reportGuestPost` mutation. */
  guestPostReportReasons: GuestPostReportReasonsResult;
  /** Fetches aggregate data for a guest about their visited restaurants. */
  guestRestaurantsSummaryData: GuestRestaurantsSummaryDataResult;
  /** An admin query that fetches all of the reviews of the input type between the input date time range. `type` can be one of the following: - EXPERIENCE_RATING - MENU_ITEM_RATING - IMAGE_REVIEW - TEXT_REVIEW */
  guestReviewsByTypeAndDateTimeRange: GetAllReviewsForGuestResponse;
  guidShortURLRestaurantSearch: RestaurantSearchResponse;
  /** Get's import details related to the guest-profiles account associated to the given access token */
  importStatus: ImportStatus;
  inAppCheckIn: InAppCheckInQuery;
  /** Allows clients to query orders that are still open by check number (legacy) or check guid */
  inProgressOrder?: Maybe<InProgressOrder>;
  /** gets the most recent InProgressOrder attached to a specified table */
  inProgressOrderForTable?: Maybe<InProgressOrder>;
  influencersByLocation: InfluencersByLocationResult;
  isNvBrandingEnabled: Scalars['Boolean']['output'];
  /** Checks whether the **resetToken** obtained from the email sent by **initiateEmailPasswordReset** is still valid or not. This isn't necessary to use the **resetPassword** mutation, but can be used to check the token validity before prompting the user to enter a new password in. */
  isResetTokenValid: Scalars['Boolean']['output'];
  itemFeedbackConfig: ItemFeedbackConfigResponse;
  itemOfferBadges: ItemDetailOfferBadgeResponseOrError;
  /** Retrieve a combined item order history for a single guest across all their orders from specified orderSources. Defaults to off-prem orders This API is only compatible with guest-profiles accounts (i.e. passwordless-based). */
  itemOrderHistory: ItemOrderHistoryResponseOrError;
  /** Fetches the feed comprised of public posts around the input location defined by `LocalPostFeedInput.latitude` and `LocalPostFeedInput.longitude`. Currently, it is a geographical radius search using the input location with a progressively increasing radius, starting from 5 km and increasing by 15 km until 50 km. The posts are sorted by the most recent posts first within each page of the result, but not necessarily across all pages. Only public posts with at least one of the following are returned: - Text review - Image review */
  localPostFeed: GuestPostPage;
  /** Get gift card balance */
  lookupGiftCard: GiftCardLookupResponse;
  loyaltyFeatures: LoyaltyFeaturesResponse;
  marketing: MarketingQuery;
  /** Menu item details including out-of-stock status and all modifier groups/modifiers */
  menuItemDetails: MenuItem;
  /** @deprecated use selectionItemDetails */
  menuItemFromCart?: Maybe<MenuItemFromCart>;
  menuOfferBadges: MenuOfferBadgesResponseOrError;
  /** @deprecated use menusV3 */
  menus: Array<Menu>;
  /** @deprecated use menusV3 */
  menusV2: Array<Menu>;
  /** Fetches the menus given the specified shortUrl and dateTime. If the dateTime is not specified, defaults to now. */
  menusV3: MenusResponseOrError;
  /** @deprecated use menuItemDetails */
  modifierGroups: Array<ModifierGroup>;
  nearbyFavorites: Array<Restaurant>;
  nearbyRestaurantSearch: RestaurantSearchResponse;
  nearbyRestaurants: Array<Restaurant>;
  offers: OffersQuery;
  oo: OnlineOrderingQuery;
  opt: OptQuery;
  /** Allows user to query a single past order. */
  opt_completedOrder: Opt_CompletedOrder;
  opt_customer: Opt_Customer;
  /** Get a token for the iFrame to call out securely to scoped API endpoints. */
  opt_getBearerToken: Scalars['String']['output'];
  /** Fetches menus for restaurant Empty array means no menus available or failure */
  opt_getMenus?: Maybe<Opt_GetMenusResponseOrError>;
  opt_getPopularItems?: Maybe<Opt_GetPopularItemsResponse>;
  /** Get's import details related to the guest-profiles account associated to the given access token */
  opt_importStatus: Opt_ImportStatus;
  /** Allows clients to query orders that are still open by check number (legacy) or check guid */
  opt_inProgressOrder?: Maybe<Opt_InProgressOrder>;
  /**
   * Retrieves if new ventures branding applies to the restaurant based on guid.
   * @deprecated Use nvBrandingConfig.isNvBrandingEnabled
   */
  opt_isNvBrandingEnabled: Scalars['Boolean']['output'];
  opt_itemFeedbackSurvey: Opt_ItemFeedbackSurveyResponse;
  /** Finds all parties by given check */
  opt_lookupPartiesByCheck: Opt_OptPartiesLookupResponse;
  /** Finds all parties by given table */
  opt_lookupPartiesByTable: Opt_OptPartiesLookupResponse;
  /** New ventures branding config for showing advertisements */
  opt_nvBrandingConfig?: Maybe<Opt_NvBrandingConfig>;
  /** Retrieves a cart based on guid. Does not load party. Unauthenticated. Returns null if supplied GUID does not correspond to a cart. */
  opt_optGetCart?: Maybe<Opt_OptCartResponse>;
  /** Given an identifier string, attempts to lookup associated restaurant gift cards/Toast Cash (global gift cards). */
  opt_optGetGiftCardBalance?: Maybe<Opt_OptGiftCardBalanceResponse>;
  /** Gets a Party, using its guid. */
  opt_optLookupPartyByGuidV2: Opt_OptPartyRefreshResponseV2;
  /** Gets a Party, using its order guid. */
  opt_optLookupPartyByOrder: Opt_OptPartyStubResponse;
  /** Gets the Party associated with the supplied PIN. Used for invites. */
  opt_optLookupPartyByTableAndPinV2: Opt_OptPartyStubResponse;
  /** Gets the latest Party, using table name and restaurant guid. */
  opt_optLookupPartyByTableV2: Opt_OptPartyStubResponse;
  /** Gets a group member's cart. */
  opt_optLookupPartyCartV2: Opt_OptPartyCartResponse;
  /** Prices a possible splitting of a party's check. */
  opt_optPriceSplitCheck: Opt_OptSplitCheckResponse;
  /** Gets a Party, using its guid. */
  opt_optUnverifiedLookupPartyByGuidV2: Opt_OptPartyStubResponse;
  /** Fetches menu item in a group for restaurant using do-menus getMenuItem endpoint */
  opt_orderAtTableMenuItemV2: Opt_MenuItemV2;
  /** Fetches menus for restaurant */
  opt_orderAtTableMenus: Array<Opt_MenuV2>;
  /** Fetches selection item from a party order. */
  opt_orderAtTablePartySelectionItemV2: Opt_SelectionItemV2;
  /** @deprecated use restaurantV2 */
  opt_restaurant?: Maybe<Opt_Restaurant>;
  /** Restaurant configuration data such as its name and location. */
  opt_restaurantV2: Opt_RestaurantOrError;
  /** Retrieves the value of a single feature flag. If restaurantGuid is provided, it retrieves the value of that flag that corresponds to that restaurantGuid, otherwise fetches the default value. */
  opt_retrieveFlag: Opt_FeatureFlagResult;
  /** Retrieves values for a list of feature flags. If restaurantGuid is provided, it retrieves the value of that flag that corresponds to that restaurantGuid, otherwise fetches the default value for each. */
  opt_retrieveFlags: Array<Opt_FeatureFlagResult>;
  orderAtTablePlaceholder?: Maybe<Scalars['String']['output']>;
  /** Retrieve paginated order history for a single guest. Can specify expected orderSources. But will default to off-prem orders. This API is only compatable with guest-profiles accounts (i.e. passwordless-based). */
  orderHistory: OrderHistoryResponse;
  /** Returns an order status object for each OrderIdentifier that is requested */
  orderStatuses: OrderStatusesResponse;
  /** Returns a single outpost. */
  outpost: Outpost;
  /** Returns an outpost-restaurant pair. */
  outpostRestaurant: OutpostRestaurant;
  /**
   * Returns a list of outpost days which contain a day of week and a list of restaurants available to outpost on that day. Only days that contain a restaurant will be represented in the list.
   * @deprecated get schedule from outpost query now
   */
  outpostSchedule: Array<OutpostDay>;
  /** Returns a list of outpost locations. */
  outposts: Array<Outpost>;
  paginatedMenuItems: PaginatedMenus;
  paginatedOrders: PaginatedOrderResponse;
  pastOrders?: Maybe<Array<Maybe<CompletedOrder>>>;
  /** Specific queries for PAY specific checkout */
  pay: PayQuery;
  paymentsQuery: PaymentsQuery;
  /** Fetches a place by its ID. */
  place: PlaceResult;
  placeHolder: Scalars['String']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  placeholderQuery?: Maybe<Scalars['String']['output']>;
  /** Fetches the popular menu items for a given restaurant. Returns a maximum of 3 menu items in the response case or an error in error case. Every item returned by this query must be available to order. */
  popularItems: PopularItemsResponseOrError;
  promoBanners: PromoBannerResponseOrError;
  promoOfferDiscounts: PromoOfferDiscountsResponseOrError;
  queryPlaceholder: Scalars['String']['output'];
  reorderableItems: ReorderableItemsResponse;
  reorderableSelectionItemDetails: SelectionItem;
  resolveData?: Maybe<UrlShortenerResolvedResponseOrError>;
  /** @deprecated use restaurantV2 */
  restaurant?: Maybe<Restaurant>;
  restaurantOfferBadges: RestaurantOfferBadgeResponseOrError;
  restaurantOfferBadgesV2: RestaurantOfferBadgeV2ResponseOrError;
  /** Restaurant configuration data such as its name and location, searched for by guid. */
  restaurantV2: RestaurantOrError;
  /** Restaurant configuration data such as its name and location, searched for by shortUrl. */
  restaurantV2ByShortUrl: RestaurantOrError;
  /** Restaurant configuration data such as name and location, searched in batch by guid */
  restaurants: Array<RestaurantOrError>;
  /** Cart item details including out-of-stock status and all modifier groups/modifiers (selected and unselected) */
  selectionItemDetails: SelectionItem;
  shouldForceUpdate: Scalars['Boolean']['output'];
  shouldForceUpdateAndroid: Scalars['Boolean']['output'];
  /** Fetches the feed comprised of posts for the authenticated guest. This feed includes posts from the guest and the guest's followees, sorted by the more recent posts first. */
  socialUserFolloweesPostFeed: GuestPostPage;
  socialUserLocalVideoPostFeed: GuestPostPage;
  socialUserSearch: SocialUserSearchResult;
  socialUserSearchByPhoneNumber: SocialUserSearchResult;
  storedValue: StoredValueQuery;
  toastOrderGuestPost: ToastOrderGuestPostResult;
  /**
   * Validates whether the provided latitude+longitude fall within the provided restaurant's delivery area. Requires that an address has already been geocoded.
   * @deprecated use validateDeliveryLocationV2
   */
  validateDeliveryLocation: ValidateDeliveryLocationResponse;
  /** For 1PD: Validates whether the provided address falls within the provided restaurant's delivery area. For DaaS: Validates whether the provided address can be serviced by the delivery provider from the given restaurant. Requires that an address has already been geocoded. */
  validateDeliveryLocationV2: ValidateDeliveryLocationResponse;
  walkout_walkoutByBookingId?: Maybe<Walkout_WalkoutResponse>;
};


export type QueryCon_PersonArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryCon_PersonByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryCon_ToastCashbackRestaurantsArgs = {
  input: Con_ToastCashbackRestaurantsInput;
};


export type QueryCartArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryCartV2Args = {
  guid: Scalars['ID']['input'];
};


export type QueryCompletedOrderArgs = {
  input: CompletedOrderInput;
};


export type QueryCustomerLoyaltyInfoArgs = {
  input: CustomerLoyaltyInfoInput;
};


export type QueryCustomerLoyaltyInfoBulkArgs = {
  input: CustomerLoyaltyInfoBulkInput;
};


export type QueryDiningOptionsArgs = {
  input: DiningOptionsInput;
};


export type QueryDoMenus_FindMenuItemArgs = {
  input: DoMenus_FindMenuItemInput;
};


export type QueryDoMenus_FindMenuItemsArgs = {
  input: DoMenus_FindMenuItemsInput;
};


export type QueryDoMenus_GetMenuGroupsArgs = {
  input: DoMenus_GetMenuGroupsInput;
};


export type QueryDoMenus_GetMenuItemsArgs = {
  input: DoMenus_GetMenuItemsInput;
};


export type QueryDoMenus_PopularItemsArgs = {
  input: DoMenus_PopularItemsInput;
};


export type QueryEGiftCardConfigArgs = {
  restaurantGuid: Scalars['ID']['input'];
};


export type QueryFindConsumerAppRestaurantsArgs = {
  input?: InputMaybe<RestaurantSearchInput>;
};


export type QueryFindGiftCardBySecureTokenArgs = {
  input: FindGiftCardBySecureTokenInput;
};


export type QueryGetAllPostsForSocialUserArgs = {
  input: GetAllPostsForSocialUserInput;
};


export type QueryGetAllReviewsForGuestArgs = {
  input: GetAllReviewsForGuestInput;
};


export type QueryGetAwardLeaderboardArgs = {
  input: GetAwardLeaderboardInput;
};


export type QueryGetCartShippingRatesArgs = {
  input: ShippingRatesQueryInput;
};


export type QueryGetGuestFacingInstructionsArgs = {
  input: GuestFacingInstructionsQueryInput;
};


export type QueryGetMyGuestNotificationHubItemsArgs = {
  input: GetMyGuestNotificationHubItemsInput;
};


export type QueryGetServiceGroupsArgs = {
  input: ServiceGroupsQueryInput;
};


export type QueryGetSocialUsersArgs = {
  socialUserIds: Array<Scalars['ID']['input']>;
};


export type QueryGetSurchargeSummaryArgs = {
  input: GetSurchargeSummaryInput;
};


export type QueryGiftCardBalanceInquiryArgs = {
  input: GiftCardBalanceInquiryInput;
};


export type QueryGiftCardExtensionBalanceInquiryArgs = {
  input: GiftCardExtensionBalanceInquiryInput;
};


export type QueryGuestCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGuestOrderReviewPromptArgs = {
  input: GuestOrderReviewPromptInput;
};


export type QueryGuestPostArgs = {
  input: GuestPostInput;
};


export type QueryGuestPostReactionsArgs = {
  pageInput?: InputMaybe<PageInput>;
  postId: Scalars['ID']['input'];
};


export type QueryGuestReviewsByTypeAndDateTimeRangeArgs = {
  endDateTime: Scalars['DateTime']['input'];
  startDateTime: Scalars['DateTime']['input'];
  type: Scalars['String']['input'];
};


export type QueryGuidShortUrlRestaurantSearchArgs = {
  input: GuidShortUrlRestaurantSearchInput;
};


export type QueryInProgressOrderArgs = {
  input: InProgressOrderInput;
};


export type QueryInProgressOrderForTableArgs = {
  input: InProgressOrderForTableInput;
};


export type QueryInfluencersByLocationArgs = {
  input: InfluencersByLocationInput;
};


export type QueryIsNvBrandingEnabledArgs = {
  input: NvBrandsInput;
};


export type QueryIsResetTokenValidArgs = {
  resetToken: Scalars['String']['input'];
};


export type QueryItemOfferBadgesArgs = {
  input: ItemDetailOfferBadgeInput;
};


export type QueryItemOrderHistoryArgs = {
  input: ItemOrderHistoryInput;
};


export type QueryLocalPostFeedArgs = {
  input: LocalPostFeedInput;
};


export type QueryLookupGiftCardArgs = {
  input: GiftCardLookupInput;
};


export type QueryLoyaltyFeaturesArgs = {
  input: LoyaltyFeaturesInput;
};


export type QueryMenuItemDetailsArgs = {
  input: MenuItemDetailsInput;
};


export type QueryMenuItemFromCartArgs = {
  input: MenuItemFromCartInput;
};


export type QueryMenuOfferBadgesArgs = {
  input: MenuOfferBadgesInput;
};


export type QueryMenusArgs = {
  shortUrl: Scalars['ID']['input'];
};


export type QueryMenusV2Args = {
  input: MenusInput;
};


export type QueryMenusV3Args = {
  input: MenusInput;
};


export type QueryModifierGroupsArgs = {
  input: ModifierGroupsInput;
};


export type QueryNearbyFavoritesArgs = {
  input: FavoriteRestaurantsInput;
};


export type QueryNearbyRestaurantSearchArgs = {
  input: NearbyRestaurantSearchInput;
};


export type QueryNearbyRestaurantsArgs = {
  input: NearbyRestaurantsInput;
};


export type QueryOpt_CompletedOrderArgs = {
  input: Opt_CompletedOrderInput;
};


export type QueryOpt_GetMenusArgs = {
  channelGuid?: InputMaybe<Scalars['ID']['input']>;
  restaurantGuid: Scalars['ID']['input'];
};


export type QueryOpt_GetPopularItemsArgs = {
  input: Opt_GetPopularItemsInput;
};


export type QueryOpt_InProgressOrderArgs = {
  input: Opt_InProgressOrderInput;
};


export type QueryOpt_IsNvBrandingEnabledArgs = {
  input: Opt_NvBrandsInput;
};


export type QueryOpt_ItemFeedbackSurveyArgs = {
  input: Opt_ItemFeedbackSurveyLookupInput;
};


export type QueryOpt_LookupPartiesByCheckArgs = {
  input: Opt_LookupPartiesByCheckInput;
};


export type QueryOpt_LookupPartiesByTableArgs = {
  input: Opt_LookupPartiesByTableInput;
};


export type QueryOpt_NvBrandingConfigArgs = {
  input: Opt_NvBrandsInput;
};


export type QueryOpt_OptGetCartArgs = {
  cartGuid: Scalars['ID']['input'];
};


export type QueryOpt_OptGetGiftCardBalanceArgs = {
  input?: InputMaybe<Opt_OptGetGiftCardBalanceInput>;
};


export type QueryOpt_OptLookupPartyByGuidV2Args = {
  memberAuthToken: Scalars['String']['input'];
  partyGuid: Scalars['ID']['input'];
  partyMemberGuid: Scalars['ID']['input'];
};


export type QueryOpt_OptLookupPartyByOrderArgs = {
  orderGuid: Scalars['String']['input'];
  restaurantGuid: Scalars['ID']['input'];
};


export type QueryOpt_OptLookupPartyByTableAndPinV2Args = {
  pin: Scalars['String']['input'];
  restaurantGuid: Scalars['ID']['input'];
  tableName: Scalars['String']['input'];
};


export type QueryOpt_OptLookupPartyByTableV2Args = {
  restaurantGuid: Scalars['ID']['input'];
  tableName: Scalars['String']['input'];
};


export type QueryOpt_OptLookupPartyCartV2Args = {
  memberAuthToken: Scalars['String']['input'];
  partyGuid: Scalars['ID']['input'];
  partyMemberGuid: Scalars['ID']['input'];
};


export type QueryOpt_OptPriceSplitCheckArgs = {
  optSplitCheckInput: Opt_OptSplitCheckInput;
};


export type QueryOpt_OptUnverifiedLookupPartyByGuidV2Args = {
  partyGuid: Scalars['ID']['input'];
};


export type QueryOpt_OrderAtTableMenuItemV2Args = {
  itemGroupGuid: Scalars['ID']['input'];
  itemGuid: Scalars['ID']['input'];
  nestingLevel: Scalars['Int']['input'];
  restaurantGuid: Scalars['ID']['input'];
};


export type QueryOpt_OrderAtTableMenusArgs = {
  restaurantGuid: Scalars['ID']['input'];
};


export type QueryOpt_OrderAtTablePartySelectionItemV2Args = {
  input: Opt_OrderAtTablePartySelectionItemDetailsInput;
  nestingLevel: Scalars['Int']['input'];
  restaurantGuid: Scalars['ID']['input'];
};


export type QueryOpt_RestaurantArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryOpt_RestaurantV2Args = {
  guid: Scalars['ID']['input'];
};


export type QueryOpt_RetrieveFlagArgs = {
  flag: Scalars['String']['input'];
  restaurantGuid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOpt_RetrieveFlagsArgs = {
  flags: Array<Scalars['String']['input']>;
  restaurantGuid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrderHistoryArgs = {
  input: OrderHistoryInput;
};


export type QueryOrderStatusesArgs = {
  input: OrderStatusesInput;
};


export type QueryOutpostArgs = {
  input: SingleOutpostInput;
};


export type QueryOutpostRestaurantArgs = {
  input: OutpostRestaurantInput;
};


export type QueryOutpostScheduleArgs = {
  input: OutpostScheduleInput;
};


export type QueryOutpostsArgs = {
  input: OutpostInput;
};


export type QueryPaginatedMenuItemsArgs = {
  input: PaginatedMenusInput;
};


export type QueryPaginatedOrdersArgs = {
  input: PaginatedOrdersInput;
};


export type QueryPastOrdersArgs = {
  input: PastOrdersInput;
};


export type QueryPlaceArgs = {
  input: PlaceInput;
};


export type QueryPopularItemsArgs = {
  input: PopularItemsInput;
};


export type QueryPromoBannersArgs = {
  input: PromoBannerInput;
};


export type QueryPromoOfferDiscountsArgs = {
  input: PromoOfferDiscountsInput;
};


export type QueryReorderableItemsArgs = {
  input: ReorderableItemsInput;
};


export type QueryReorderableSelectionItemDetailsArgs = {
  input: ReorderableSelectionItemDetailsInput;
};


export type QueryResolveDataArgs = {
  shortUrlKey: Scalars['String']['input'];
};


export type QueryRestaurantArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryRestaurantOfferBadgesArgs = {
  input: RestaurantOfferBadgeInput;
};


export type QueryRestaurantOfferBadgesV2Args = {
  input: RestaurantOfferBadgeInput;
};


export type QueryRestaurantV2Args = {
  guid: Scalars['ID']['input'];
};


export type QueryRestaurantV2ByShortUrlArgs = {
  shortUrl: Scalars['String']['input'];
};


export type QueryRestaurantsArgs = {
  guids: Array<Scalars['ID']['input']>;
};


export type QuerySelectionItemDetailsArgs = {
  input: SelectionItemDetailsInput;
};


export type QueryShouldForceUpdateArgs = {
  version: IosVersionInput;
};


export type QueryShouldForceUpdateAndroidArgs = {
  version: AndroidVersionInput;
};


export type QuerySocialUserFolloweesPostFeedArgs = {
  input?: InputMaybe<PageInput>;
};


export type QuerySocialUserLocalVideoPostFeedArgs = {
  input: SocialUserLocalVideoPostFeedInput;
};


export type QuerySocialUserSearchArgs = {
  request: SocialUserSearchRequest;
};


export type QuerySocialUserSearchByPhoneNumberArgs = {
  request: SocialUserSearchByPhoneNumberRequest;
};


export type QueryToastOrderGuestPostArgs = {
  input: ToastOrderGuestPostInput;
};


export type QueryValidateDeliveryLocationArgs = {
  input: ValidateDeliveryLocationInput;
};


export type QueryValidateDeliveryLocationV2Args = {
  input: ValidateDeliveryLocationInputV2;
};


export type QueryWalkout_WalkoutByBookingIdArgs = {
  bookingId: Scalars['ID']['input'];
  restaurantId: Scalars['ID']['input'];
};

export type RankedDiscountOffMinOffer = BaseRankedToastFundedOffer & {
  __typename?: 'RankedDiscountOffMinOffer';
  active: Scalars['Boolean']['output'];
  amountNeeded: Scalars['Float']['output'];
  /** The amount to discount from the total */
  amountToDiscount: Money;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  estimatedSavings: Scalars['Float']['output'];
  guid: Scalars['ID']['output'];
  maxGuestRedemptions: Scalars['Int']['output'];
  minPurchaseAmount: Money;
  offerClaimed: Scalars['Boolean']['output'];
  offerDescription?: Maybe<Scalars['String']['output']>;
  offerName: Scalars['String']['output'];
  percentComplete: Scalars['Float']['output'];
  percentCompleteInt: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  targeting: OfferTargeting;
};

export type RankedFreeDeliveryOffer = BaseRankedToastFundedOffer & {
  __typename?: 'RankedFreeDeliveryOffer';
  active: Scalars['Boolean']['output'];
  amountNeeded: Scalars['Float']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  estimatedSavings: Scalars['Float']['output'];
  guid: Scalars['ID']['output'];
  /** The maximum delivery value that can be claimed */
  maxDeliveryValue: Money;
  maxGuestRedemptions: Scalars['Int']['output'];
  minPurchaseAmount: Money;
  offerClaimed: Scalars['Boolean']['output'];
  offerDescription?: Maybe<Scalars['String']['output']>;
  offerName: Scalars['String']['output'];
  percentComplete: Scalars['Float']['output'];
  percentCompleteInt: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  targeting: OfferTargeting;
};

export type RankedPromoOfferBuyEntities = {
  __typename?: 'RankedPromoOfferBuyEntities';
  groups?: Maybe<Array<Scalars['String']['output']>>;
  items?: Maybe<Array<Scalars['String']['output']>>;
  menus?: Maybe<Array<Scalars['String']['output']>>;
};

export type RankedPromoOfferCustomDiscount = {
  __typename?: 'RankedPromoOfferCustomDiscount';
  /** Whether the discount is currently active */
  active: Scalars['Boolean']['output'];
  /** How a discount is applied if conditions are met - FIXED - How many dollars are discounted from the check/item - PERCENT - What percentage of the check/item is discounted - BOGO - Follow the bogoAction for how the discount is applied to action items (buy one get one free) */
  amountType: Scalars['String']['output'];
  /** Time and day of the week restrictions for when the offer can be applied */
  availability?: Maybe<RankedPromoOfferDiscountAvailability>;
  /** The action to take when the discount amountType is BOGO and the offer is applied */
  bogoAction?: Maybe<RankedPromoOfferDiscountBogoAction>;
  /** Dollar amount or percentage that is discounted */
  discountValue?: Maybe<Scalars['Float']['output']>;
  /** Channels that the discount is available on - ONLINE_ORDERING - available for display on the online ordering web apps - TOAST_APP - available for display on the Toast app - MARKETING_SMS - available via SMS marketing */
  displayChannels?: Maybe<Array<Scalars['String']['output']>>;
  /** Guid for the discount */
  guid: Scalars['String']['output'];
  /** Minimum amount that needs to be spent to apply the discount */
  minSpendAmount?: Maybe<Scalars['Float']['output']>;
  /** Name of the discount. This is the same as the banner text */
  name: Scalars['String']['output'];
  /** Promo codes that are associated with the discount */
  promoCodes?: Maybe<Array<RankedPromoOfferDiscountPromoCode>>;
  /** Type that needs to be selected for the discount to be able to be applied - CHECK - The discount can be applied if the amount condition is met - ITEM - The discount can be applied if the conditions on target entities (item, group, menu) are met */
  selectionType: Scalars['String']['output'];
  /** List of groups that an item in the cart can belong to for this offer to be applied */
  triggerMenuGroups?: Maybe<Array<Scalars['String']['output']>>;
  /** List of items that need to be in the cart for this offer to be applied */
  triggerMenuItems?: Maybe<Array<Scalars['String']['output']>>;
  /** List of menus that an item in the cart can belong to for this offer to be applied */
  triggerMenus?: Maybe<Array<Scalars['String']['output']>>;
};

export type RankedPromoOfferDiscount = {
  __typename?: 'RankedPromoOfferDiscount';
  /** The dollar amount needed to reach the promo threshold */
  amountNeeded: Scalars['Float']['output'];
  /** Time, date, and day of the week restrictions for when the offer is available */
  availability?: Maybe<PromoBannerAvailability>;
  /** The GUID of the banner */
  bannerGuid: Scalars['String']['output'];
  /** The banner text */
  bannerText: Scalars['String']['output'];
  /** Entities where at least one must be in your cart to be able to apply the discount (Used for BOGO) These are hoisted from the trigger data to be more front end friendly. */
  buyEntities?: Maybe<RankedPromoOfferBuyEntities>;
  /** Raw discount data */
  discount?: Maybe<RankedPromoOfferCustomDiscount>;
  /** Entities where the discount can be applied to (Used for BOGO and ITEM selections) These are hoisted from the bogoAction or trigger data, depending on the selection type, to be more front end friendly. */
  discountEntities?: Maybe<RankedPromoOfferDiscountEntities>;
  /** This is true once the necessary discounted entities have been added to the cart, if applicable. */
  discountEntitiesClaimed: Scalars['Boolean']['output'];
  /** Estimates how much money will be saved if they reach the promo threshold and apply the discount. This is not exact since some types like BOGO depend on the final prices of items in the cart during checkout. */
  estimatedSavings: Scalars['Float']['output'];
  /** Unique id for the cache (type + bannerGuid) */
  id: Scalars['ID']['output'];
  /** An expanded description of the offer */
  offerDescription?: Maybe<Scalars['String']['output']>;
  /** 0-100% to being able to apply the discount. Use whole percentages to be consistent with discount percents. */
  percentComplete: Scalars['Float']['output'];
  /** 0-100% see percentComplete, but in Int format to avoid precision errors when using Double */
  percentCompleteInt: Scalars['Int']['output'];
  /** The promo code hoisted from the discount data */
  promoCode: Scalars['String']['output'];
  /** Denotes if the offer can only be redeemed once per guest If false, there are no limits on the number of redemptions per guest */
  singleUse: Scalars['Boolean']['output'];
  /** The delivery banner type */
  type: Scalars['String']['output'];
};

export type RankedPromoOfferDiscountAvailability = {
  __typename?: 'RankedPromoOfferDiscountAvailability';
  /** The day of the week the offer can be applied 1-7, 1 is Monday. This is offset from the backend days field to conform to ISO-8601 */
  daysOfWeek?: Maybe<Array<Scalars['Int']['output']>>;
};

export type RankedPromoOfferDiscountBogoAction = {
  __typename?: 'RankedPromoOfferDiscountBogoAction';
  /** How a discount is applied if conditions are met - FIXED - How many dollars are discounted from action item - PERCENT - What percentage of the action item is discounted */
  amountType: Scalars['String']['output'];
  /** Id of the action */
  bogoActionId: Scalars['String']['output'];
  /** Dollar amount or percentage that is discounted */
  discountValue?: Maybe<Scalars['Float']['output']>;
  /** List of group uuids that include items that the discount can be applied to */
  groups?: Maybe<Array<Scalars['String']['output']>>;
  /** List of menu item uuids that the discount can be applied to */
  items?: Maybe<Array<Scalars['String']['output']>>;
  /** List of menu uuids that include items that the discount can be applied to */
  menus?: Maybe<Array<Scalars['String']['output']>>;
  /** Number of items that the discount can be applied to */
  numberOfFreeItems: Scalars['Int']['output'];
  /** Whether the discount is applied per item or per total */
  perItem: Scalars['Boolean']['output'];
};

export type RankedPromoOfferDiscountEntities = {
  __typename?: 'RankedPromoOfferDiscountEntities';
  groups?: Maybe<Array<Scalars['String']['output']>>;
  items?: Maybe<Array<Scalars['String']['output']>>;
  menus?: Maybe<Array<Scalars['String']['output']>>;
};

export type RankedPromoOfferDiscountPromoBanner = {
  __typename?: 'RankedPromoOfferDiscountPromoBanner';
  /** End date the banner can be displayed until */
  bannerEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Start date the banner can be displayed on */
  bannerStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** The text to display for the banner */
  bannerText: Scalars['String']['output'];
  /** Guid of the banner */
  guid: Scalars['String']['output'];
  /** Status of the banner - ACTIVE - can be displayed - INACTIVE - cannot be displayed - ARCHIVED - deleted */
  status: Scalars['String']['output'];
};

export type RankedPromoOfferDiscountPromoCode = {
  __typename?: 'RankedPromoOfferDiscountPromoCode';
  /** Banners associated with the promo code, to be displayed in the app */
  banners?: Maybe<Array<RankedPromoOfferDiscountPromoBanner>>;
  /** Code used to apply an offer to a cart */
  code: Scalars['String']['output'];
  /** End date of the promo code is available for */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Id of the promo code */
  promoCodeId: Scalars['String']['output'];
  /** If the promo code can only be used once */
  singleUse?: Maybe<Scalars['Boolean']['output']>;
  /** Start date of the promo code is available for */
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type RankedPromoOffersError = Error & {
  __typename?: 'RankedPromoOffersError';
  message: Scalars['String']['output'];
};

export type RankedPromoOffersInput = {
  cartGuid?: InputMaybe<Scalars['ID']['input']>;
  requestSource: Scalars['String']['input'];
  restaurantGuid: Scalars['ID']['input'];
};

export type RankedPromoOffersResponse = {
  __typename?: 'RankedPromoOffersResponse';
  /** The cart guid */
  cartGuid?: Maybe<Scalars['ID']['output']>;
  /** A list of ranked promo offers in the order of most attainable to least attainable. */
  rankedDiscounts: Array<RankedPromoOfferDiscount>;
  /** The restaurant guid */
  restaurantGuid: Scalars['ID']['output'];
};

export type RankedPromoOffersResponseOrError = RankedPromoOffersError | RankedPromoOffersResponse;

export type RankedToastFundedOffer = RankedDiscountOffMinOffer | RankedFreeDeliveryOffer;

export type RankedToastFundedOffersError = Error & {
  __typename?: 'RankedToastFundedOffersError';
  message: Scalars['String']['output'];
};

export type RankedToastFundedOffersInput = {
  cartGuid?: InputMaybe<Scalars['ID']['input']>;
  restaurantGuid?: InputMaybe<Scalars['ID']['input']>;
  userLocation?: InputMaybe<GeoCoordinatesInput>;
};

export type RankedToastFundedOffersResponse = {
  __typename?: 'RankedToastFundedOffersResponse';
  /** A list of ranked offers in the order of most attainable to least attainable. */
  rankedOffers: Array<RankedToastFundedOffer>;
};

export type RankedToastFundedOffersResponseOrError = RankedToastFundedOffersError | RankedToastFundedOffersResponse;

/** Types of rating systems available. */
export enum RatingSystem {
  /** 1-4 rating system. */
  FourPoint = 'FOUR_POINT',
  /** 1-10 rating system. */
  TenPoint = 'TEN_POINT',
  /** 1-3 rating system. */
  ThreePoint = 'THREE_POINT'
}

export enum RegistrationSource {
  Local = 'LOCAL',
  OnlineOrdering = 'ONLINE_ORDERING',
  OrderAndPay = 'ORDER_AND_PAY',
  Sites = 'SITES',
  ToastApp = 'TOAST_APP'
}

export type RejectSocialFollowersRequest = {
  followersToReject: Array<SocialFollowerInput>;
};

export type RejectSocialFollowersResult = RejectSocialFollowersSuccess | SocialUserDoesNotExistError | UnexpectedError;

export type RejectSocialFollowersSuccess = {
  __typename?: 'RejectSocialFollowersSuccess';
  rejectedFollowers: Array<SocialUser>;
};

export type RemoveGuestAwardInput = {
  awardTypeId: Scalars['ID']['input'];
};

export type RemoveGuestAwardResult = AwardSeasonHasEndedError | RemoveGuestAwardSuccess | UnexpectedError;

export type RemoveGuestAwardSuccess = {
  __typename?: 'RemoveGuestAwardSuccess';
  awardTypeId: Scalars['ID']['output'];
};

export type RemoveGuestReactionFromPostInput = {
  postId: Scalars['ID']['input'];
};

/** The possible responses of the `removeGuestReactionFromPost` mutation. */
export type RemoveGuestReactionFromPostResponse = RemoveGuestReactionFromPostSuccess | UnexpectedError;

export type RemoveGuestReactionFromPostSuccess = {
  __typename?: 'RemoveGuestReactionFromPostSuccess';
  reactionAggregates: Array<GuestPostReactionAggregate>;
};

export type RemoveGuestToastOrderImageReviewsInput = {
  checkId: Scalars['ID']['input'];
  /** Image review IDs not associated with `orderId` and `checkId` will be ignored. */
  imageReviewIds: Array<Scalars['ID']['input']>;
  orderId: Scalars['ID']['input'];
  placeId: Scalars['ID']['input'];
};

export type RemoveGuestToastOrderImageReviewsResult = RemoveGuestToastOrderImageReviewsSuccess | UnexpectedError;

export type RemoveGuestToastOrderImageReviewsSuccess = {
  __typename?: 'RemoveGuestToastOrderImageReviewsSuccess';
  removedImageReviewIds: Array<Scalars['ID']['output']>;
  /** The image review IDs that were not removed. */
  retainedImageReviewIds: Array<Scalars['ID']['output']>;
};

export type RemoveItemsFromGuestSavedListInput = {
  items: Array<GuestSavedListItemInput>;
  listId: Scalars['ID']['input'];
};

export type RemoveLoyaltyRedemptionInput = {
  cartGuid: Scalars['ID']['input'];
  /** Guid of the applied redemption to be removed */
  redemptionGuid: Scalars['ID']['input'];
};

export type RemoveLoyaltyRedemptionV2Input = {
  cartGuid: Scalars['ID']['input'];
  redemption: LoyaltyRedemptionInput;
};

export type RemovePromoCodeInput = {
  /** The guid of the cart in the order the user wishes to apply the promo code reward to. */
  cartGuid: Scalars['ID']['input'];
  /** A generic string that is used to look up rewards. */
  discountType: DiscountType;
};

/** Input for when a customer attempts to remove all promo code based rewards from their order. */
export type RemovePromoCodeInputV2 = {
  /** The guid of the cart in the order the user wishes to apply the promo code reward to. */
  cartGuid: Scalars['ID']['input'];
};

export type RemovePromoCodeResponseOrError = CartModificationError | CartOutOfStockError | CartResponse;

export type RemoveSocialFollowersRequest = {
  followersToRemove: Array<SocialFollowerInput>;
};

export type RemoveSocialFollowersResult = RemoveSocialFollowersSuccess | SocialUserDoesNotExistError | UnexpectedError;

export type RemoveSocialFollowersSuccess = {
  __typename?: 'RemoveSocialFollowersSuccess';
  removedFollowers: Array<SocialUser>;
};

export type RemoveSocialUserProfilePhotoResult = RemoveSocialUserProfilePhotoSuccess | UnexpectedError;

export type RemoveSocialUserProfilePhotoSuccess = {
  __typename?: 'RemoveSocialUserProfilePhotoSuccess';
  socialUserId: Scalars['ID']['output'];
};

export type RemoveToastFundedOfferError = Error & {
  __typename?: 'RemoveToastFundedOfferError';
  /** The error code for the TFO removal. */
  code: RemoveToastFundedOfferErrorCode;
  /** The human readable message for the error. */
  message: Scalars['String']['output'];
};

/** Error codes encountered when removing a TFO. */
export enum RemoveToastFundedOfferErrorCode {
  /** Indicates that the TFO could not be removed. */
  RemovalFailed = 'REMOVAL_FAILED'
}

/** Input for when a customer attempts to remove a Toast funded offer to their order. */
export type RemoveToastFundedOfferInput = {
  /** The guid of the cart in the order the user wishes to remove the TFO from. */
  cartGuid: Scalars['ID']['input'];
};

/** Return type for the removeToastFundedOffer mutation. Follows the pattern of other cart mutations. */
export type RemoveToastFundedOfferResponseOrError = CartModificationError | CartOutOfStockError | CartResponse | RemoveToastFundedOfferError;

export type ReorderError = Error & {
  __typename?: 'ReorderError';
  code: ReorderErrorCode;
  message: Scalars['String']['output'];
};

export enum ReorderErrorCode {
  /** Indicates that none of the items from the order could be added to the cart. */
  NoAvailableItems = 'NO_AVAILABLE_ITEMS',
  /** Indicates that the order referenced by **orderGuid** could not be fetched. */
  OrderUnavailable = 'ORDER_UNAVAILABLE',
  /** Indicates that the order couldn't be successfully reordered due to unknown reasons. */
  ReorderFailed = 'REORDER_FAILED'
}

export type ReorderInput = {
  /** Indicates how the order on the cart should be fulfilled. Optional to ensure backwards compatability, please provide this in all future usages. */
  cartFulfillmentInput?: InputMaybe<CartFulfillmentInput>;
  /** References the order to be reordered. */
  orderGuid: Scalars['ID']['input'];
  /** The product that the cart is created on. Optional to ensure backwards compatability, please provide this in all future usages. */
  orderSource?: InputMaybe<OrderSource>;
  /** References the restaurant that the order being reordered belongs to. */
  restaurantGuid: Scalars['ID']['input'];
};

export type ReorderResponse = {
  __typename?: 'ReorderResponse';
  /** The resulting **Cart** with as many items added as possible from the order being reordered. */
  cart: Cart;
  outOfStockItems: Array<CartOutOfStockItem>;
  /** @deprecated use warningsV2 */
  warnings: Array<Maybe<Scalars['String']['output']>>;
  /** If the client is using **reorderV2**, then the client should request this field and not **warnings**. */
  warningsV2: Array<ReorderWarning>;
};

export type ReorderResponseOrError = ReorderError | ReorderResponse;

export type ReorderWarning = Warning & {
  __typename?: 'ReorderWarning';
  code: ReorderWarningCode;
  message: Scalars['String']['output'];
};

export enum ReorderWarningCode {
  /** A warning with this enum as the code will only occur if some, but not all, of the items are unavailable for reorder. If all of the items in the order are unavailable, then a ReorderError will return with a code of NO_AVAILABLE_ITEMS. */
  ItemsUnavailable = 'ITEMS_UNAVAILABLE',
  /** Indicates that the restaurant cannot fulfill the current cart at this time. */
  OrderTimeUnavailable = 'ORDER_TIME_UNAVAILABLE'
}

export type ReorderableItem = {
  __typename?: 'ReorderableItem';
  imageUrls?: Maybe<ImageSet>;
  orderGuid: Scalars['ID']['output'];
  selection: Selection;
};

export type ReorderableItemsInput = {
  /** Date should be in ISO 8601 format and include date and time. Example: 2019-08-07T13:00:00-04:00 This is necessary if fetching selection items that are not currently available. If the dateTime is not provided, the current time is used. */
  dateTime?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  restaurantGuid: Scalars['ID']['input'];
  /** Determines the visibility to filter menu items by. Defaults to TOAST_ONLINE_ORDERING. */
  visibility?: InputMaybe<Menus_VisibilityEnum>;
};

export type ReorderableItemsResponse = {
  __typename?: 'ReorderableItemsResponse';
  currentPageToken?: Maybe<Scalars['String']['output']>;
  items: Array<ReorderableItem>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ReorderableSelectionItemDetailsInput = {
  /** Date should be in ISO 8601 format and include date and time. Example: 2019-08-07T13:00:00-04:00 This is necessary if fetching selection items that are not currently available. If the dateTime is not provided, the current time is used. */
  dateTime?: InputMaybe<Scalars['String']['input']>;
  orderGuid: Scalars['ID']['input'];
  restaurantGuid: Scalars['ID']['input'];
  selectionGuid: Scalars['ID']['input'];
  /** Determines the visibility to filter menu items by. Defaults to TOAST_ONLINE_ORDERING. */
  visibility?: InputMaybe<Menus_VisibilityEnum>;
};

export type ReportGuestCommentInput = {
  commentId: Scalars['ID']['input'];
  /** Why the comment is being reported. Will use a default reason if omitted. */
  reason?: InputMaybe<GuestCommentReportReasonInput>;
};

export type ReportGuestCommentResult = CommentDoesNotExistError | ReportGuestCommentSuccess | UnexpectedError;

export type ReportGuestCommentSuccess = {
  __typename?: 'ReportGuestCommentSuccess';
  commentId: Scalars['ID']['output'];
};

export type ReportGuestPostInput = {
  postId: Scalars['ID']['input'];
  /** Why the post is being reported. Will use a default reason if omitted. */
  reason?: InputMaybe<GuestPostReportReasonInput>;
};

export type ReportGuestPostResult = ReportGuestPostSuccess | UnexpectedError;

export type ReportGuestPostSuccess = {
  __typename?: 'ReportGuestPostSuccess';
  postId: Scalars['ID']['output'];
};

export type ReportSocialUserRequest = {
  /** Why the user is being reported. Will use a default reason if omitted. */
  reason?: InputMaybe<SocialUserReportReasonInput>;
  socialUser: SocialUserInput;
};

export type ReportSocialUserResult = ReportSocialUserSuccess | SocialUserDoesNotExistError | UnexpectedError;

export type ReportSocialUserSuccess = {
  __typename?: 'ReportSocialUserSuccess';
  socialUser: SocialUser;
};

export type Restaurant = {
  __typename?: 'Restaurant';
  /** Experimental feature: please reach out to Insider team (Slack @insider-team) if you are interested, thank you! */
  CON_industryPassConfig?: Maybe<Con_RestaurantIndustryPassConfig>;
  adsManagerConversionTagsConfig: AdsManagerConversionTagsConfig;
  adsManagerRestaurantConversionsData: AdsManagerRestaurantConversionsData;
  /** Flag indicating whether a restaurant can be ordered from within the consumer app. Only populated when searching by shortUrl. */
  allowOrderingInConsumerApp?: Maybe<Scalars['Boolean']['output']>;
  bannerUrls?: Maybe<ImageSet>;
  bookingConfig?: Maybe<BookingRestaurantConfig>;
  /** Determines if the restaurant is enabled for Toast Takeout. */
  consumerAppEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the restaurant is allowed to show a CTA. Restaurant must be enabled for the Toast Takeout and have Toast Takeout CTA enabled. */
  consumerCTAEnabled?: Maybe<Scalars['Boolean']['output']>;
  creditCardConfig: RestaurantCreditCardConfig;
  /** The restaurant's cuisineType that is a high-level descriptor for the type of food served by the restaurant. This value is defined under the consumer app config and is NOT set by the restaurant. If it is null, then the property has not been defined on the consumer app config. */
  cuisineType?: Maybe<Scalars['String']['output']>;
  /** Configuration for a restaurant's curbside pickup order fulfillment option */
  curbsidePickupConfig?: Maybe<CurbsidePickupConfig>;
  /**
   * The **DiningOption**s available to be selected at the moment
   * @deprecated use diningOptions
   */
  currentlyAvailableDiningOptions: Array<DiningOption>;
  /** The restaurant's configured delivery providers (may or may not be enabled) */
  deliveryProviders: Array<DeliveryProviderConfig>;
  /** Availability of third party delivery */
  deliveryServiceAvailability: DeliveryServiceAvailability;
  description?: Maybe<Scalars['String']['output']>;
  /** The restaurant's fundraiser input settings, which default to disabled settings if the restaurant has no fundraiser input settings or if the fundraiser input settings are unavailable */
  fundraisingConfig: FundraisingConfig;
  /** Gift card config */
  giftCardConfig: GiftCardConfig;
  /** Gift card links */
  giftCardLinks: GiftCardLinks;
  guestCurrencyConfig: RestaurantGuestCurrencyConfig;
  /** GUID of the restaurant */
  guid: Scalars['ID']['output'];
  /** Whether a restaurant has the online ordering product module */
  hasOnlineOrderingModule: Scalars['Boolean']['output'];
  /** Whether a restaurant has the TOAST_GIFT_CARDS product module */
  hasToastGiftCardsModule: Scalars['Boolean']['output'];
  /** The Internationalization (i18n) properties relating to a given restaurant */
  i18n: I18n;
  imageUrl?: Maybe<Scalars['String']['output']>;
  location: Location;
  logoUrls?: Maybe<ImageSet>;
  /** The restaurant's loyalty settings, defaulting to disabled settings if the restaurant has no loyalty or if the loyalty service is unavailable. Clients can set the "supportedAccrualTypes" property to indicate which types of loyalty programs they support. If the restaurant is using an accrual type the client does not support, loyalty will default to appearing as disabled. By default, the omission of this field will assume the client supports "CHECK_TOTAL" loyalty for backwards compatibility. */
  loyaltyConfig: LoyaltyConfig;
  minimumDeliveryTime: Scalars['Int']['output'];
  minimumTakeoutTime: Scalars['Int']['output'];
  /** The restaurant's name that an aggregator client should use. Accounts for Takeout-specific name override */
  name: Scalars['String']['output'];
  /** Determines whether a restaurant has both the online ordering product module and that the online ordering module is set to an active state. */
  onlineOrderingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Config indicating what guests should be asked about how to package their order */
  packagingConfig: PackagingConfig;
  /** Configuration for a restaurant's popular items display */
  popularItemsConfig?: Maybe<PopularItemsConfig>;
  /** All promotional banners available for this restaurant */
  promoBanners?: Maybe<PromoBannerResponseOrError>;
  schedule: Schedule;
  shortUrl: Scalars['String']['output'];
  /** Links to resturant social media platforms. */
  socialMediaLinks: SocialMediaLinks;
  specialRequestsConfig: SpecialRequestsConfig;
  /** Configuration for optional information a restaurant could spotlight */
  spotlightConfig?: Maybe<SpotlightConfig>;
  /** Restaurant TimeZone identifier */
  timeZoneId?: Maybe<Scalars['String']['output']>;
  /** Toast Pay product configuration. When null, no configuration can be resolved for the restaurant */
  toastPayConfig?: Maybe<ToastPayConfig>;
  /** Configuration for a restaurant's item upsells */
  upsellsConfig?: Maybe<UpsellsConfig>;
  /** The restaurant's name that a white-label client should use */
  whiteLabelName: Scalars['String']['output'];
};


export type RestaurantLoyaltyConfigArgs = {
  supportedAccrualTypes?: InputMaybe<Array<LoyaltyAccrualType>>;
};

export type RestaurantCreditCardConfig = {
  __typename?: 'RestaurantCreditCardConfig';
  /** Indicates if the restaurant accepts American Express credit card payments, assuming that the restaurant allows payment via credit card in the first place. */
  amexAccepted: Scalars['Boolean']['output'];
  /** Indicates if the restaurant allows the diner to specify a tip when paying via credit card, assuming that the restaurant allows payment via credit card in the first place. Note: This only applies to OO/off-premise configurations. Currently all on-premise dining has tips enabled. */
  tipEnabled: Scalars['Boolean']['output'];
};

/** An object representing a restaurant reward, i.e. a reward provided by a restaurant itself. */
export type RestaurantDiscount = {
  __typename?: 'RestaurantDiscount';
  amount: Scalars['Float']['output'];
  guid: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Promo code can be empty string if the discount is added on the POS and doesn't have a promoCode attached. In this case use name. */
  promoCode: Scalars['String']['output'];
};

export type RestaurantGuestCurrencyConfig = {
  __typename?: 'RestaurantGuestCurrencyConfig';
  /** Whether the restaurant has Guest Currency payments enabled. Currently, restaurants can opt-out of supporting this feature. Use to determine whether Guest Currency should be shown to the user as a valid payment option for this restaurant. To be enabled, a restaurant must accept either stored value or promotional currencies */
  enabled: Scalars['Boolean']['output'];
  /** For cases where you need to know if specific types of guest currency are enabled for a restaurant. */
  promoEnabled: Scalars['Boolean']['output'];
  storedValueEnabled: Scalars['Boolean']['output'];
};

export type RestaurantOfferBadge = {
  __typename?: 'RestaurantOfferBadge';
  /** The badge text */
  badgeText: Scalars['String']['output'];
  /** The offer count */
  offerCount: Scalars['Int']['output'];
  /** The GUID of the Restaurant to be badged */
  restaurantGuid: Scalars['String']['output'];
};

export type RestaurantOfferBadgeInput = {
  /** The guid of the restaurant which has the order being paid for */
  restaurantGuids: Array<Scalars['ID']['input']>;
};

export type RestaurantOfferBadgeResponse = {
  __typename?: 'RestaurantOfferBadgeResponse';
  restaurantOfferBadges: Array<RestaurantOfferBadge>;
};

export type RestaurantOfferBadgeResponseOrError = GeneralError | RestaurantOfferBadgeResponse;

export type RestaurantOfferBadgeV2 = {
  __typename?: 'RestaurantOfferBadgeV2';
  /** The loyalty badge text */
  loyaltyBadgeText?: Maybe<Scalars['String']['output']>;
  /** The offer badge text */
  offerBadgeText?: Maybe<Scalars['String']['output']>;
  /** The offer count */
  offerCount: Scalars['Int']['output'];
  /** The GUID of the Restaurant to be badged */
  restaurantGuid: Scalars['String']['output'];
};

export type RestaurantOfferBadgeV2Response = {
  __typename?: 'RestaurantOfferBadgeV2Response';
  restaurantBadges: Array<RestaurantOfferBadgeV2>;
};

export type RestaurantOfferBadgeV2ResponseOrError = GeneralError | RestaurantOfferBadgeV2Response;

export type RestaurantOrError = GeneralError | Restaurant;

export type RestaurantSearchInput = {
  allowRestaurantsWithoutOnlineOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableLoyaltyFilter?: InputMaybe<Scalars['Boolean']['input']>;
  enableToastGiftCardsFilter?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  onlineReservationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  onlineWaitlistEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  restaurantSearchFilters?: InputMaybe<Array<ConsumerAppRestaurantSearchFilter>>;
};

export type RestaurantSearchItem = {
  __typename?: 'RestaurantSearchItem';
  /** The federated Restaurant object for use merging results with those of other subgraphs */
  restaurant: Restaurant;
  /** The upcoming schedule for online ordering for the given restaurant */
  upcomingOnlineOrderingSchedule?: Maybe<Array<UpcomingOnlineOrderingScheduleForDate>>;
};

export type RestaurantSearchResponse = {
  __typename?: 'RestaurantSearchResponse';
  results: Array<RestaurantSearchItem>;
};

export type RestaurantSearchResult = {
  __typename?: 'RestaurantSearchResult';
  consumerAppCuisineType?: Maybe<Scalars['String']['output']>;
  consumerAppDescription?: Maybe<Scalars['String']['output']>;
  consumerAppDisplayName?: Maybe<Scalars['String']['output']>;
  consumerAppEnabled: Scalars['Boolean']['output'];
  consumerAppListImage?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  giftCardEnabled: Scalars['Boolean']['output'];
  guid: Scalars['ID']['output'];
  hasOnlineOrderingModule: Scalars['Boolean']['output'];
  hasToastGiftCardsModule: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  loyaltyVendor?: Maybe<Scalars['String']['output']>;
  offPremDerivedDeliveryEnabled: Scalars['Boolean']['output'];
  offPremDerivedTakeoutEnabled: Scalars['Boolean']['output'];
  onlineReservationsEnabled: Scalars['Boolean']['output'];
  onlineWaitlistEnabled: Scalars['Boolean']['output'];
  reservationsEnabled: Scalars['Boolean']['output'];
  shortUrl?: Maybe<Scalars['String']['output']>;
  waitlistEnabled: Scalars['Boolean']['output'];
};

export type RestaurantSearchResults = {
  __typename?: 'RestaurantSearchResults';
  results: Array<RestaurantSearchResult>;
  totalCount: Scalars['Int']['output'];
};

export type RestaurantSearchResultsOrError = GeneralError | RestaurantSearchResults;

export type RestaurantTargeting = BaseOfferTargeting & {
  __typename?: 'RestaurantTargeting';
  distance: Scalars['Float']['output'];
  restaurantGuids: Array<Scalars['ID']['output']>;
  type: Scalars['String']['output'];
};

export type ReviewOrderGuestNotificationHubItem = GuestNotificationHubItem & {
  __typename?: 'ReviewOrderGuestNotificationHubItem';
  checkGuid: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  notificationRoutes?: Maybe<NotificationHubRoutes>;
  notificationText: Scalars['String']['output'];
  orderGuid: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
};

/** Fields to specify the reviewable entity. */
export type ReviewableEntityIdentifier = {
  __typename?: 'ReviewableEntityIdentifier';
  /** Unique identifier corresponding to reviewableEntityType. */
  id: Scalars['ID']['output'];
  /** See [ReviewableEntityType]. */
  type: ReviewableEntityType;
};

export enum ReviewableEntityType {
  MenuGroup = 'MENU_GROUP',
  MenuItem = 'MENU_ITEM'
}

export type Reward = {
  __typename?: 'Reward';
  amount?: Maybe<Scalars['Float']['output']>;
  beforeTax?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rewardType?: Maybe<RewardType>;
};

/** A container of messages related to a specific reward. A client application is expected to use these messages instead of building their own. This provides consistency across different surfaces, the loyalty configuration details (points/visit/item/cashback etc) are hidden from the client. */
export type RewardMessagesData = {
  __typename?: 'RewardMessagesData';
  /** A message shown when the guest hasn't reached the target to redeem the reward. Usually shown together with a progress bar. 1st party only. e.g. 'Next reward in 50 points' */
  nextRewardMessage?: Maybe<Scalars['String']['output']>;
  /** Not supported yet */
  nextRewardMiniMessage?: Maybe<Scalars['String']['output']>;
  /** A label intended to be shown on the reward buttons on different UIs. For rewards redeemed when reaching target balance it shows the points/visits that will be subtracted from the balance after redemption. 1st party only. e.g. '5 visits' or '50 points' or 'Birthday treat' */
  rewardLabelMessage?: Maybe<Scalars['String']['output']>;
  /** A label intended to be shown on the reward buttons on different UIs (usually at the bottom). It shows the reward that will be redeemed. Both 1st party and 3rd party supported. e.g. '$5.00' or 'Free Coffee' */
  rewardValueMessage?: Maybe<Scalars['String']['output']>;
  /** A message shown when the guest has enough points/visits balance to redeem this specific reward. 1st party only. e.g. 'You've unlocked $5 off!' */
  unlockedMessage?: Maybe<Scalars['String']['output']>;
};

export enum RewardRedemptionType {
  /** Redeem dollars amount - this is the default */
  Cashback = 'CASHBACK',
  /** Redeem eligible items */
  Item = 'ITEM'
}

/** A container showing a state of a specific reward. The idea is to use this object both representing the current state or reward (how many points left to target, is it redeemable or not) and future state (for example, will the reward become redeemable after accruing points on the pending order, how many points will be left to target otherwise). This will allow the client applications to support "interactive" behavior and show the changes in loyalty balance in "real time" */
export type RewardStateData = {
  __typename?: 'RewardStateData';
  /** How many points/visits are left to target. 0 if the loyalty balance is equal or greater than the target. Null if the reward has a different mechanism of triggering (e.g. birthday reward) or if the target is unknown (for 3rd party). */
  leftToTarget?: Maybe<Scalars['Int']['output']>;
  messages?: Maybe<RewardMessagesData>;
};

export enum RewardType {
  CustomerNUse = 'CUSTOMER_N_USE',
  GlobalNUse = 'GLOBAL_N_USE',
  SignUp = 'SIGN_UP',
  ToastGc = 'TOAST_GC'
}

export enum RewardTypeData {
  Birthday = 'BIRTHDAY',
  Cashback = 'CASHBACK',
  Item = 'ITEM'
}

export type SavedAddress = {
  __typename?: 'SavedAddress';
  deliveryInfo: DeliveryInfo;
  guid: Scalars['ID']['output'];
  /** The name/label for this address, e.g. "Home", "Work" */
  name?: Maybe<Scalars['String']['output']>;
};

export type SavedAddressInput = {
  addressGuid: Scalars['ID']['input'];
};

export type SavedCardInput = {
  cardGuid: Scalars['ID']['input'];
};

/** Saved credit card information; the token itself is stored securely in customermgmt and not provided to the client */
export type SavedCreditCard = {
  __typename?: 'SavedCreditCard';
  /** The issuing network of the card, e.g. "VISA" */
  cardType: CardType;
  /** Two digit expiration month */
  expirationMonth: Scalars['String']['output'];
  /** Four digit expiration year */
  expirationYear: Scalars['String']['output'];
  /** The card guid, used as an identifier for the card */
  guid: Scalars['ID']['output'];
  /** Flag indicating whether the card is the primary (selected by default) card for the account */
  isPrimary: Scalars['Boolean']['output'];
  /** The masked card number with only the last four digits visible, in the format of "XXXX-1234" */
  maskedPan: Scalars['String']['output'];
};

export type Schedule = {
  __typename?: 'Schedule';
  /** This field will be superseded by **asapSchedule.availableNow** on one of the returned **DiningOption**s for the appropriate inputs to the **diningOptions()** query. */
  asapAvailableForDelivery?: Maybe<Scalars['Boolean']['output']>;
  /** This field will be superseded by **asapSchedule.availableNow** on one of the returned **DiningOption**s for the appropriate inputs to the **diningOptions()** query. */
  asapAvailableForTakeout?: Maybe<Scalars['Boolean']['output']>;
  /** The overall OO delivery hours for the current business day. This does not indicate if there are any service gaps within the day. If null, indicates the restaurant does not have any hours for today. */
  todaysHoursForDelivery?: Maybe<ServicePeriod>;
  /** The overall OO takeout hours for the current business day. This does not indicate if there are any service gaps within the day. If null, indicates the restaurant does not have any hours for today. */
  todaysHoursForTakeout?: Maybe<ServicePeriod>;
  /** The schedules for the upcoming 7 business days (including today) */
  upcomingSchedules: Array<UpcomingSchedules>;
};

export type Selection = {
  __typename?: 'Selection';
  appliedDiscounts?: Maybe<Array<Discounts>>;
  fractionalQuantity: FractionalQuantity;
  /** Key used to group identical duplicate selections */
  groupingKey?: Maybe<Scalars['ID']['output']>;
  guid?: Maybe<Scalars['ID']['output']>;
  itemGroupGuid?: Maybe<Scalars['ID']['output']>;
  itemGuid?: Maybe<Scalars['ID']['output']>;
  modifiers?: Maybe<Array<Maybe<Selection>>>;
  name?: Maybe<Scalars['String']['output']>;
  optionGroupGuid?: Maybe<Scalars['ID']['output']>;
  /** The cost of the Selection before any discounts are applied to the order */
  preDiscountPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  receiptLinePrice?: Maybe<Scalars['Float']['output']>;
  usesFractionalQuantity: Scalars['Boolean']['output'];
};

export type SelectionInput = {
  fractionalQuantity?: InputMaybe<FractionalQuantityInput>;
  itemGroupGuid?: InputMaybe<Scalars['ID']['input']>;
  itemGuid: Scalars['ID']['input'];
  /** Field is only applicable for upsells and only when it represents the item, not a modifier. */
  itemMasterId?: InputMaybe<Scalars['String']['input']>;
  modifierGroups: Array<ModifierGroupInput>;
  quantity: Scalars['Int']['input'];
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
};

/** A selection in the cart */
export type SelectionItem = {
  __typename?: 'SelectionItem';
  calories?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fractionalQuantity: FractionalQuantity;
  guid: Scalars['ID']['output'];
  /** @deprecated use imageUrls */
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageUrls?: Maybe<ImageSet>;
  itemGroupGuid: Scalars['ID']['output'];
  itemGuid: Scalars['ID']['output'];
  menuItemPrice?: Maybe<Scalars['Float']['output']>;
  /** This optional argument allows the query to specify the level of nesting in the modifiers. Any top level modifier with greater than the specified level of nesting is removed, and empty modifier groups are removed as well. A level of 1 will return mods without nesting. A level of 2 will return mods with at most one level of nesting, and so on. */
  modifierGroups: Array<SelectionModifierGroup>;
  name?: Maybe<Scalars['String']['output']>;
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  selectionItemPrice?: Maybe<Scalars['Float']['output']>;
  specialRequest?: Maybe<Scalars['String']['output']>;
  usesFractionalQuantity: Scalars['Boolean']['output'];
};


/** A selection in the cart */
export type SelectionItemModifierGroupsArgs = {
  nestingLevel?: InputMaybe<Scalars['Int']['input']>;
};

/** Note that shortUrl will remain required throughout the transition to the DO menu API */
export type SelectionItemDetailsInput = {
  /** The cart schema is the same across services but is stored and retrieved differently. */
  cartApi?: InputMaybe<CartApiType>;
  cartGuid: Scalars['ID']['input'];
  /** Date should be in ISO 8601 format and include date and time. Example: 2019-08-07T13:00:00-04:00 This is necessary if fetching selection items that are not currently available. If the dateTime is not provided, the current time is used. */
  dateTime?: InputMaybe<Scalars['String']['input']>;
  itemGroupGuid: Scalars['ID']['input'];
  itemGuid: Scalars['ID']['input'];
  /** Determine which menu API should be used for retrieving menu and stock data */
  menuApi?: InputMaybe<MenuApiType>;
  /** Required if menuApi is DO */
  restaurantGuid?: InputMaybe<Scalars['ID']['input']>;
  selectionGuid: Scalars['ID']['input'];
  /** Deprecated: shortUrl and the TOASTWEB menuApi are no longer supported */
  shortUrl?: InputMaybe<Scalars['String']['input']>;
  /** Determines the visibility to filter menu items by. Defaults to TOAST_ONLINE_ORDERING. */
  visibility?: InputMaybe<Menus_VisibilityEnum>;
};

export type SelectionModifier = {
  __typename?: 'SelectionModifier';
  /** Required for modifier quantity implementation. Will only be populated if retrieved from DO Menus. */
  allowsDuplicates?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  itemGroupGuid?: Maybe<Scalars['ID']['output']>;
  itemGuid: Scalars['ID']['output'];
  modifierGroups: Array<SelectionModifierGroup>;
  name?: Maybe<Scalars['String']['output']>;
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
};

export type SelectionModifierGroup = {
  __typename?: 'SelectionModifierGroup';
  guid: Scalars['ID']['output'];
  maxSelections?: Maybe<Scalars['Int']['output']>;
  minSelections?: Maybe<Scalars['Int']['output']>;
  modifiers: Array<SelectionModifier>;
  name?: Maybe<Scalars['String']['output']>;
  pricingMode?: Maybe<Scalars['String']['output']>;
};

export type SendPayAtADistanceResponse = {
  __typename?: 'SendPayAtADistanceResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ServiceGroup = {
  __typename?: 'ServiceGroup';
  description: Scalars['String']['output'];
  flatRate?: Maybe<Scalars['String']['output']>;
  flatRateCurrency?: Maybe<Scalars['String']['output']>;
  freeShippingThresholdCurrency?: Maybe<Scalars['String']['output']>;
  freeShippingThresholdMin?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  objectId: Scalars['String']['output'];
  rateAdjustment?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ServiceGroupsQueryInput = {
  siteGuid: Scalars['ID']['input'];
};

export type ServicePeriod = {
  __typename?: 'ServicePeriod';
  /** An hh:mm:ss.mmm formatted local time representing the end of the period within the context of the restaurant's timezone. */
  endTime: Scalars['String']['output'];
  /** An hh:mm:ss.mmm formatted local time representing the start of the period within the context of the restaurant's timezone. */
  startTime: Scalars['String']['output'];
};

export type SetMyUserVisibilityRequest = {
  userVisibility: SocialUserVisibility;
};

export type SetSelectedShippingRateInput = {
  cartGuid: Scalars['ID']['input'];
  restaurantGuid: Scalars['ID']['input'];
  selectedShippingRateGuid: Scalars['String']['input'];
  siteGuid: Scalars['ID']['input'];
};

/** The input of the `setupGuest` mutation. */
export type SetupGuestInput = {
  identity: GuestIdentityInput;
  /** Identification of your product confirming the guest. */
  source: GuestAuthenticationSource;
};

/** The possible results of the `setupGuest` mutation. */
export type SetupGuestResult = InvalidPhoneFormatError | ProfileLockedForDeletionError | SetupGuestSuccess | SingleIdentityInputRequiredError | UnexpectedAuthError;

/** The successful result of the `setupGuest` mutation. */
export type SetupGuestSuccess = {
  __typename?: 'SetupGuestSuccess';
  /** The identity that was successfully setup for the guest. */
  unverified: UnverifiedGuestIdentity;
};

export type SetupIntent = {
  __typename?: 'SetupIntent';
  /** Validated Customer Id */
  customerId?: Maybe<Scalars['ID']['output']>;
  /** Intent Id */
  id: Scalars['ID']['output'];
  /** Session Secret - also contains which IntentMode the Intent is */
  sessionSecret: Scalars['String']['output'];
};

/** Bearer Token */
export type SetupIntentBearerToken = {
  __typename?: 'SetupIntentBearerToken';
  /** token for front-end clients to use SPI operations */
  token: Scalars['String']['output'];
};

export type SetupIntentBearerTokenError = {
  __typename?: 'SetupIntentBearerTokenError';
  code: SetupIntentBearerTokenErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum SetupIntentBearerTokenErrorCode {
  FailedToRetrieve = 'FAILED_TO_RETRIEVE'
}

export type SetupIntentBearerTokenResponse = SetupIntentBearerToken | SetupIntentBearerTokenError;

export type SetupIntentError = Error & {
  __typename?: 'SetupIntentError';
  /** Error Code Describing the Error */
  code: SetupIntentErrorCode;
  /** Non-Localized Error Message */
  message: Scalars['String']['output'];
};

export enum SetupIntentErrorCode {
  /** Failed to create intent */
  FailedToCreateIntent = 'FAILED_TO_CREATE_INTENT',
  /** Client Id was not found */
  GuestWalletNotFound = 'GUEST_WALLET_NOT_FOUND',
  /** Client was not authorized to access */
  NoAuthorization = 'NO_AUTHORIZATION'
}

export type ShippingRate = {
  __typename?: 'ShippingRate';
  amount: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  estimatedDays: Scalars['Int']['output'];
  shippingRateGuid: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ShippingRateInput = {
  amount: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  description: Scalars['String']['input'];
  estimatedDays: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type ShippingRatesQueryInput = {
  cartGuid: Scalars['ID']['input'];
  restaurantGuid: Scalars['ID']['input'];
  siteGuid: Scalars['ID']['input'];
};

export type SignUpToLoyaltyError = Error & {
  __typename?: 'SignUpToLoyaltyError';
  code: SignUpToLoyaltyErrorCode;
  message: Scalars['String']['output'];
};

export enum SignUpToLoyaltyErrorCode {
  CannotSignUp = 'CANNOT_SIGN_UP'
}

export type SignUpToLoyaltyInput = {
  /** The guid of the paid check */
  checkGuid: Scalars['ID']['input'];
  /** The guest's email to sign-up to rewards program - either email or phone number, or both, must be provided */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The guest's phone number to sign-up to rewards program - either email or phone number, or both must, be provided */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The guid of the restaurant which has the paid check */
  restaurantGuid: Scalars['ID']['input'];
};

export type SignUpToLoyaltyResponse = {
  __typename?: 'SignUpToLoyaltyResponse';
  hasLoyalty?: Maybe<Scalars['Boolean']['output']>;
  newAccount?: Maybe<Scalars['Boolean']['output']>;
};

export type SignUpToLoyaltyResponseOrError = SignUpToLoyaltyError | SignUpToLoyaltyResponse;

/** Occurs when either no identity, or more than one identity, was provided on the request. Only a single identity can be used. */
export type SingleIdentityInputRequiredError = Error & ValidationError & {
  __typename?: 'SingleIdentityInputRequiredError';
  message: Scalars['String']['output'];
};

export type SingleOutpostInput = {
  /** The guid of the outpost. */
  guid: Scalars['ID']['input'];
};

/** When a user tries to follow themselves, this error is returned. */
export type SocialCannotFollowSelfError = Error & {
  __typename?: 'SocialCannotFollowSelfError';
  message: Scalars['String']['output'];
};

export type SocialFollowRequest = {
  followees: Array<SocialFolloweeInput>;
};

export type SocialFollowResult = SocialCannotFollowSelfError | SocialFollowSuccess | SocialOnlyMeUserActionProhibitedError | SocialUserDoesNotExistError | UnexpectedError;

export type SocialFollowSuccess = {
  __typename?: 'SocialFollowSuccess';
  followees: Array<SocialUser>;
};

export type SocialFolloweeInput = {
  id: Scalars['ID']['input'];
};

export type SocialFollowerInput = {
  id: Scalars['ID']['input'];
};

export enum SocialFollowingStatus {
  Following = 'FOLLOWING',
  NotFollowing = 'NOT_FOLLOWING',
  Pending = 'PENDING',
  Self = 'SELF'
}

/** Social Media Links allow a restaurant to point customers to their social media pages. */
export type SocialMediaLinks = {
  __typename?: 'SocialMediaLinks';
  /** Link to the restaurant's facebook page. */
  facebookLink?: Maybe<Scalars['String']['output']>;
  /** Instagram */
  instagramLink?: Maybe<Scalars['String']['output']>;
  /** Link to a restaurant's home page */
  resturantLink?: Maybe<Scalars['String']['output']>;
  /** Link to the restaurant's twitter feed */
  twitterLink?: Maybe<Scalars['String']['output']>;
  /** Twitter user */
  twitterUser?: Maybe<Scalars['String']['output']>;
};

/** When a user tries to follow a user that is a hidden (ONLY_ME privacy setting) user, this error is returned */
export type SocialOnlyMeUserActionProhibitedError = Error & {
  __typename?: 'SocialOnlyMeUserActionProhibitedError';
  message: Scalars['String']['output'];
};

export type SocialUnfollowRequest = {
  unfollowees: Array<SocialFolloweeInput>;
};

export type SocialUnfollowResult = SocialUnfollowSuccess | SocialUserDoesNotExistError | UnexpectedError;

export type SocialUnfollowSuccess = {
  __typename?: 'SocialUnfollowSuccess';
  unfollowees: Array<SocialUser>;
};

export type SocialUser = {
  __typename?: 'SocialUser';
  firstName?: Maybe<Scalars['String']['output']>;
  followeeCount: Scalars['Int']['output'];
  followees: Array<SocialUser>;
  followerCount: Scalars['Int']['output'];
  followers: Array<SocialUser>;
  guestCurrentSeasonAwards?: Maybe<GuestAwardSeason>;
  guestSavedLists?: Maybe<Array<GuestSavedList>>;
  id: Scalars['ID']['output'];
  /** Indicates whether the requested social user is banned from use of the social network. */
  isBanned: Scalars['Boolean']['output'];
  /** Indicates whether the authenticated guest is the same as the requested social user. */
  isMe: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  myFollowerStatus: SocialFollowingStatus;
  myFollowingStatus: SocialFollowingStatus;
  pendingFollowees: Array<SocialUser>;
  pendingFollowers: Array<SocialUser>;
  /** Fetches the posts created by the requested `SocialUser`, sorted by the more recent posts first. Returns null if none of the following criteria are met: 1. The requested `SocialUser` is the authenticated guest. 1. The requested `SocialUser` has a public profile. 1. The authenticated guest is following the requested `SocialUser`. */
  posts?: Maybe<GuestPostPage>;
  profileMedia?: Maybe<GuestProfileMedia>;
  userVisibility: SocialUserVisibility;
};


export type SocialUserGuestSavedListsArgs = {
  listType?: InputMaybe<GuestSavedListType>;
};


export type SocialUserPostsArgs = {
  input?: InputMaybe<PageInput>;
};

export type SocialUserBannedError = Error & {
  __typename?: 'SocialUserBannedError';
  message: Scalars['String']['output'];
};

/** When user information is requested for a social user ID that does not exist, this error is returned. */
export type SocialUserDoesNotExistError = Error & {
  __typename?: 'SocialUserDoesNotExistError';
  message: Scalars['String']['output'];
};

export type SocialUserInput = {
  id: Scalars['ID']['input'];
};

export type SocialUserLocalVideoPostFeedInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  pageInput?: InputMaybe<PageInput>;
};

export type SocialUserReactedToPostNotificationHubItem = GuestNotificationHubItem & {
  __typename?: 'SocialUserReactedToPostNotificationHubItem';
  id: Scalars['ID']['output'];
  notificationRoutes?: Maybe<NotificationHubRoutes>;
  notificationText: Scalars['String']['output'];
  post?: Maybe<GuestPost>;
  reactor?: Maybe<SocialUser>;
  timestamp: Scalars['String']['output'];
};

export type SocialUserReportReason = {
  __typename?: 'SocialUserReportReason';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SocialUserReportReasonInput = {
  id: Scalars['ID']['input'];
};

export type SocialUserReportReasonsResult = SocialUserReportReasonsSuccess | UnexpectedError;

export type SocialUserReportReasonsSuccess = {
  __typename?: 'SocialUserReportReasonsSuccess';
  reasons: Array<SocialUserReportReason>;
};

export type SocialUserSearchByPhoneNumberRequest = {
  /** If a passed-in phone number does not include a country code, then we will prepend countryCode before searching. This most likely should match the country code of the searcher's phone number. */
  countryCode: Scalars['String']['input'];
  /** Phone numbers by which to search. The phone numbers should be in E.164 format if possible, but we can also accept national phone numbers. */
  phoneNumbers: Array<Scalars['String']['input']>;
};

export type SocialUserSearchRequest = {
  searchQuery: Scalars['String']['input'];
};

export type SocialUserSearchResult = SocialUserSearchSuccess | UnexpectedError;

export type SocialUserSearchSuccess = {
  __typename?: 'SocialUserSearchSuccess';
  socialUsers: Array<SocialUser>;
};

export enum SocialUserVisibility {
  OnlyMe = 'ONLY_ME',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum Source {
  ToastAppAndroid = 'TOAST_APP_ANDROID',
  ToastAppIos = 'TOAST_APP_IOS',
  ToastLocal = 'TOAST_LOCAL',
  ToastSites = 'TOAST_SITES'
}

export type SpecialRequestsConfig = {
  __typename?: 'SpecialRequestsConfig';
  /** Indicates whether special requests input box should be visible in modifier dialogs. */
  enabled: Scalars['Boolean']['output'];
  /** Indicates what hint text to display in the special requests input box if special requests is enabled. */
  placeholderMessage: Scalars['String']['output'];
};

/** Configuration for optional information a restaurant could spotlight */
export type SpotlightConfig = {
  __typename?: 'SpotlightConfig';
  /** Spotlight secondary header text. Can be arbitrary length */
  bodyText?: Maybe<Scalars['String']['output']>;
  /** Spotlight primary header text. Should be a relatively short message Max length of 150 characters */
  headerText?: Maybe<Scalars['String']['output']>;
};

export type StartIdentityProfileError = Error & {
  __typename?: 'StartIdentityProfileError';
  code: StartIdentityProfileErrorCode;
  message: Scalars['String']['output'];
};

export enum StartIdentityProfileErrorCode {
  InvalidPhone = 'INVALID_PHONE',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE'
}

export type StartIdentityProfileInput = {
  /** phoneNumber for the account. */
  phone: Scalars['String']['input'];
};

export type StartProfileCreationError = Error & {
  __typename?: 'StartProfileCreationError';
  code: StartProfileCreationErrorCode;
  message: Scalars['String']['output'];
};

export enum StartProfileCreationErrorCode {
  InvalidEmail = 'INVALID_EMAIL',
  InvalidName = 'INVALID_NAME',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE'
}

export type StartProfileCreationInput = {
  /** Optional basic info can be provided to create the account with these fields (first name, last name, phone number) already set */
  basicInfo?: InputMaybe<BasicInfoInput>;
  /** Email for the new account. Cannot be changed once the account is created. */
  email: Scalars['String']['input'];
  /** Optional input to create a loyalty account at the same time as the OO account is created. **basicInfo** is required for the loyalty account to be successfully created. */
  loyaltyAccountCreationInput?: InputMaybe<LoyaltyAccountCreationInput>;
  /** phoneNumber for the new account. Must not be in use by another account, and cannot be changed once the account is created. A verification text will be sent to this number */
  phone: Scalars['String']['input'];
  /** The source for the account creation (Toast App vs web Online Ordering vs Order and Pay) */
  source: RegistrationSource;
};

export type StartProfileCreationResponse = {
  __typename?: 'StartProfileCreationResponse';
  guestGuid: Scalars['ID']['output'];
};

export type StartProfileCreationResponseOrError = StartProfileCreationError | StartProfileCreationResponse;

export type StoredValueCardDesign = {
  __typename?: 'StoredValueCardDesign';
  /** Long-form description used to describe the design content; especially for guests using screen-readers */
  accessibleDescription: Scalars['String']['output'];
  /** Short-form description of the item selection as a label for the card design */
  accessibleLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
};

export type StoredValueCreateGiftError = Error & {
  __typename?: 'StoredValueCreateGiftError';
  code: StoredValueCreateGiftErrorCode;
  message: Scalars['String']['output'];
};

export enum StoredValueCreateGiftErrorCode {
  /** Failed to create a stored value account for the guest. Safely retryable, but it's possible that some account data is in an invalid state that can only be solved with manual intervention (e.g. the phone number is already in use with another stored value account). */
  AccountCreation = 'ACCOUNT_CREATION',
  /** Failed to create the stored value gift. Retryable. */
  GiftCreation = 'GIFT_CREATION',
  /** The provided request metadata was invalid. */
  InvalidMetadata = 'INVALID_METADATA',
  /** The provided payment method wasn't found in the list of the guest's saved payment methods. */
  InvalidPaymentMethod = 'INVALID_PAYMENT_METHOD',
  /** Creating the gift succeeded, but something afterwards failed. Do NOT retry this, as the gift was technically purchased and the guest was charged; requires manual intervention to fix. */
  PostGiftCreation = 'POST_GIFT_CREATION',
  /** Something else went wrong that's opaque to clients. Retryable. */
  UnknownCause = 'UNKNOWN_CAUSE'
}

export type StoredValueCreateGiftInput = {
  /** Amount the sender intends to gift */
  amount: GuestCurrencyMoneyInput;
  /** Selected card design id for gift. If no card design specified, gift will display a default design */
  cardDesignId?: InputMaybe<Scalars['ID']['input']>;
  /** Metadata about the sender's device */
  metadata: CreateGiftMetadataInput;
  /** Identifier of payment method the sender wishes to use to purchase the stored value to gift; the gift is not created using stored value in the sender's account */
  paymentMethodId: Scalars['ID']['input'];
  /** Name of the intended recipient */
  recipientName: Scalars['String']['input'];
  /** Message from the sender to the recipient */
  senderMessage?: InputMaybe<Scalars['String']['input']>;
  /** Name of the sender */
  senderName: Scalars['String']['input'];
};

export type StoredValueCreateGiftResponse = StoredValueCreateGiftError | StoredValueCreateGiftSuccess;

export type StoredValueCreateGiftSuccess = {
  __typename?: 'StoredValueCreateGiftSuccess';
  giftDetails: StoredValueGiftDetails;
};

export type StoredValueEligiblePaymentMethodsError = Error & {
  __typename?: 'StoredValueEligiblePaymentMethodsError';
  message: Scalars['String']['output'];
};

export type StoredValueEligiblePaymentMethodsResult = StoredValueEligiblePaymentMethodsError | StoredValueEligiblePaymentMethodsSuccess;

export type StoredValueEligiblePaymentMethodsSuccess = {
  __typename?: 'StoredValueEligiblePaymentMethodsSuccess';
  /** At most one of these payment methods should be primary, though zero is a possibility if their primary card is ineligible to purchase stored value. (Currently it's always zero, since isPrimary is hard-coded to false.) Sorted by expiry descending. */
  paymentMethods: Array<StoredValuePaymentMethod>;
};

export type StoredValueGiftDetails = PageItem & {
  __typename?: 'StoredValueGiftDetails';
  amount: Money;
  cardDesign?: Maybe<StoredValueCardDesign>;
  id: Scalars['ID']['output'];
  recipientName?: Maybe<Scalars['String']['output']>;
  redemptionStatus: StoredValueGiftRedemptionStatus;
  senderMessage?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A page of `StoredValueGiftDetails`. */
export type StoredValueGiftPage = Page & {
  __typename?: 'StoredValueGiftPage';
  /** See documentation for `Page.currentPageToken`. */
  currentPageToken?: Maybe<Scalars['String']['output']>;
  /** `StoredValueGiftDetails` in the current `StoredValueGiftPage`. Sorted descending by sent time */
  items: Array<StoredValueGiftDetails>;
  /** See documentation for `Page.nextPageToken`. */
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export enum StoredValueGiftRedemptionStatus {
  AlreadyRedeemed = 'ALREADY_REDEEMED',
  AvailableForRedemption = 'AVAILABLE_FOR_REDEMPTION'
}

export type StoredValueLoadFundsError = Error & {
  __typename?: 'StoredValueLoadFundsError';
  code: StoredValueLoadFundsErrorCode;
  message: Scalars['String']['output'];
};

export enum StoredValueLoadFundsErrorCode {
  /** Failed to create a stored value account for the guest. Safely retryable, but it's possible that some account data is in an invalid state that can only be solved with manual intervention (e.g. the phone number is already in use with another stored value account). */
  AccountCreation = 'ACCOUNT_CREATION',
  /** The provided request metadata was invalid. */
  InvalidMetadata = 'INVALID_METADATA',
  /** The provided payment method wasn't found in the list of the guest's saved payment methods. */
  InvalidPaymentMethod = 'INVALID_PAYMENT_METHOD',
  /** Something went wrong loading the funds. Retryable. */
  LoadFunds = 'LOAD_FUNDS',
  /** Something else went wrong that's opaque to clients. Retryable. */
  UnknownCause = 'UNKNOWN_CAUSE'
}

export type StoredValueLoadFundsInput = {
  /** Amount to load */
  amount: GuestCurrencyMoneyInput;
  /** Metadata about the buyer's device */
  metadata: StoredValuePurchaseMetadataInput;
  /** Identifier of payment method used to fund the purchase */
  paymentMethodId: Scalars['ID']['input'];
};

export type StoredValueLoadFundsResponse = StoredValueLoadFundsError | StoredValueLoadFundsSuccess;

export type StoredValueLoadFundsSuccess = {
  __typename?: 'StoredValueLoadFundsSuccess';
  /** The guest's entire guest currency account. */
  guestCurrencyAccount: GuestCurrencyAccount;
  /** The unit of guest currency that was just loaded successfully. */
  loadedGuestCurrencyUnit: GuestCurrencyStoredValueLoadUnit;
};

export type StoredValueMutation = {
  __typename?: 'StoredValueMutation';
  /** Creates a gift of stored value and persists it. */
  createGift: StoredValueCreateGiftResponse;
  /** Load stored value funds into my own account */
  loadFunds: StoredValueLoadFundsResponse;
  /** As an authenticated user, redeem a gift to my account */
  redeemGiftById: StoredValueRedeemGiftResponse;
};


export type StoredValueMutationCreateGiftArgs = {
  createGiftInput: StoredValueCreateGiftInput;
};


export type StoredValueMutationLoadFundsArgs = {
  loadFundsInput: StoredValueLoadFundsInput;
};


export type StoredValueMutationRedeemGiftByIdArgs = {
  id: Scalars['ID']['input'];
};

/** A payment method that can be used to purchase stored value. */
export type StoredValuePaymentMethod = {
  __typename?: 'StoredValuePaymentMethod';
  cardFunding: Scalars['String']['output'];
  cardType: CardType;
  expiryMonth: Scalars['String']['output'];
  expiryYear: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Whether the guest has this payment method marked as "default" in their account preferences. Temporarily hard-coded to false. */
  isPrimary: Scalars['Boolean']['output'];
  lastFour: Scalars['String']['output'];
};

/** Metadata for any purchase of stored value. Intended generalized successor to CreateGiftMetadataInput; prefer usage of this input type over that one. IP is expected from the Toast-Origin-IP header, and user agent (for web) is expected from the User-Agent header. */
export type StoredValuePurchaseMetadataInput = {
  /** Metadata about the device; one of mobileMetadata or webMetadata must be provided */
  mobileMetadata?: InputMaybe<StoredValuePurchaseMobileMetadataInput>;
  webMetadata?: InputMaybe<StoredValuePurchaseWebMetadataInput>;
};

export type StoredValuePurchaseMobileMetadataInput = {
  /** Mobile UID generated by Forter's SDK */
  forterMobileUID: Scalars['ID']['input'];
};

export enum StoredValuePurchaseMode {
  /** Gift funds to a recipient */
  Gift = 'GIFT',
  /** Load funds to my own account */
  Load = 'LOAD'
}

export type StoredValuePurchaseWebMetadataInput = {
  /** Token cookie generated by Forter's SDK */
  forterTokenCookie: Scalars['ID']['input'];
};

export type StoredValueQuery = {
  __typename?: 'StoredValueQuery';
  /** As an unauthenticated user, retrieve card designs I can select when creating a gift */
  cardDesigns: Array<StoredValueCardDesign>;
  /** Finds the saved payment methods belonging to the logged in guest that can be used to purchase stored value guest currency. */
  eligiblePaymentMethods: StoredValueEligiblePaymentMethodsResult;
  /** As an unauthenticated user, lookup details for a gift that is eligible for redemption */
  redeemableGiftById: StoredValueRedeemableGiftResponse;
  /** As an authenticated user, lookup details for a gift that I have redeemed to my account */
  redeemedGiftById: StoredValueRedeemedGiftLookupResponse;
  /** As an authenticated user, retrieve a page of gifts that I have sent */
  sentGifts: StoredValueSentGiftsResult;
};


export type StoredValueQueryEligiblePaymentMethodsArgs = {
  mode?: StoredValuePurchaseMode;
};


export type StoredValueQueryRedeemableGiftByIdArgs = {
  id: Scalars['ID']['input'];
};


export type StoredValueQueryRedeemedGiftByIdArgs = {
  id: Scalars['ID']['input'];
};

export type StoredValueRedeemGiftError = Error & {
  __typename?: 'StoredValueRedeemGiftError';
  code: StoredValueRedeemGiftErrorCode;
  message: Scalars['String']['output'];
};

export enum StoredValueRedeemGiftErrorCode {
  AlreadyRedeemedByOther = 'ALREADY_REDEEMED_BY_OTHER',
  /** Should be retried; expected to succeed within 30-90 seconds. */
  GiftStillProcessing = 'GIFT_STILL_PROCESSING',
  NotFound = 'NOT_FOUND',
  UnknownCause = 'UNKNOWN_CAUSE'
}

export type StoredValueRedeemGiftRecoverableError = Error & {
  __typename?: 'StoredValueRedeemGiftRecoverableError';
  code: StoredValueRedeemGiftRecoverableErrorCode;
  /** Gift details on the gift, so an application can meaningfully recover from an unexpected error scenario. */
  giftDetails: StoredValueGiftDetails;
  message: Scalars['String']['output'];
};

export enum StoredValueRedeemGiftRecoverableErrorCode {
  AlreadyRedeemedByMe = 'ALREADY_REDEEMED_BY_ME'
}

export type StoredValueRedeemGiftResponse = StoredValueRedeemGiftError | StoredValueRedeemGiftRecoverableError | StoredValueRedeemGiftSuccess;

export type StoredValueRedeemGiftSuccess = {
  __typename?: 'StoredValueRedeemGiftSuccess';
  giftDetails: StoredValueGiftDetails;
};

export type StoredValueRedeemableGiftError = Error & {
  __typename?: 'StoredValueRedeemableGiftError';
  code: StoredValueRedeemableGiftErrorCode;
  message: Scalars['String']['output'];
};

export enum StoredValueRedeemableGiftErrorCode {
  AlreadyRedeemed = 'ALREADY_REDEEMED',
  NotFound = 'NOT_FOUND'
}

export type StoredValueRedeemableGiftResponse = StoredValueRedeemableGiftError | StoredValueRedeemableGiftSuccess;

export type StoredValueRedeemableGiftSuccess = {
  __typename?: 'StoredValueRedeemableGiftSuccess';
  giftDetails: StoredValueGiftDetails;
};

export type StoredValueRedeemedGiftLookupError = Error & {
  __typename?: 'StoredValueRedeemedGiftLookupError';
  code: StoredValueRedeemedGiftLookupErrorCode;
  message: Scalars['String']['output'];
};

export enum StoredValueRedeemedGiftLookupErrorCode {
  NotFound = 'NOT_FOUND'
}

export type StoredValueRedeemedGiftLookupResponse = StoredValueRedeemedGiftLookupError | StoredValueRedeemedGiftLookupSuccess;

export type StoredValueRedeemedGiftLookupSuccess = {
  __typename?: 'StoredValueRedeemedGiftLookupSuccess';
  giftDetails: StoredValueGiftDetails;
};

export type StoredValueSentGiftsError = Error & {
  __typename?: 'StoredValueSentGiftsError';
  message: Scalars['String']['output'];
};

export type StoredValueSentGiftsResult = StoredValueGiftPage | StoredValueSentGiftsError;

/** generic key-value pair object */
export type StringKeyValInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitGuestFeedbackV2Input = {
  /** identifier of the check associated with this feedback */
  checkGuid: Scalars['ID']['input'];
  /** optional bool indicating if the feedback is complete. Defaults to true. */
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  /** optional bool indicating if the feedback completion type. Defaults to USER_COMPLETD */
  completeType?: InputMaybe<Scalars['String']['input']>;
  /** optional bool indicating the diner gave permission to be contacted */
  feedbackContactPermission?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any free form feedback that was given by the user */
  feedbackFreeFormText?: InputMaybe<Scalars['String']['input']>;
  /** additional metadata */
  feedbackMeta?: InputMaybe<Array<InputMaybe<StringKeyValInput>>>;
  /** a transposed rating that maps any rating structure to (negative, passive, positive) */
  feedbackRating: FeedbackRatingV2;
  /** a rating linked to the actual rating system in use (thumb down, thumb up, stars, etc) */
  feedbackRawRating: FeedbackRawRatingV2;
  /** A JSON array of feedback reasons */
  feedbackReasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Source the feedback is coming from Online Ordering, OPT, etc */
  feedbackSource: Scalars['String']['input'];
  /** Indicates whether the feedback is meant for Toast or a restaurant. Defaults to true. */
  internalFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  /** identifier of the order associated with this feedback */
  orderGuid: Scalars['ID']['input'];
  /** identifier of the order payment associated with this feedback */
  orderPaymentGuid: Scalars['ID']['input'];
  /** Restaurant identifier for the feedback */
  restaurantGuid: Scalars['ID']['input'];
};

export type SubmitGuestFeedbackV2Response = GuestFeedbackV2Error | GuestFeedbackV2SuccessResponse;

/** Input type for an order experience rating. */
export type SubmitGuestOrderExperienceRatingInput = {
  /** ID of guest's check on the order being rated. */
  checkGuid: Scalars['ID']['input'];
  /** ID of order being rated. */
  orderGuid: Scalars['ID']['input'];
  /** ID of place being rated. */
  placeId: Scalars['ID']['input'];
  /** See [GuestRatingInput]. If null then this will result in the rating being deleted. */
  rating?: InputMaybe<GuestRatingInput>;
};

export type SubmitGuestOrderMenuItemRatingInput = {
  /** ID of menu item group of which the menu item being rated belongs. */
  menuItemGroupId: Scalars['ID']['input'];
  /** ID of menu item being rated. */
  menuItemId: Scalars['ID']['input'];
  /** See [GuestRatingInput]. If null then this will result in the rating being deleted. */
  rating?: InputMaybe<GuestRatingInput>;
  /** Unique identifier of the selection being rated. */
  selectionGuid: Scalars['ID']['input'];
};

/** Input type for order menu item ratings. */
export type SubmitGuestOrderMenuItemRatingInputs = {
  /** ID of guest's check on the order being rated. */
  checkGuid: Scalars['ID']['input'];
  /** Ratings submitted for menu item selections in the order. */
  menuItemRatings: Array<SubmitGuestOrderMenuItemRatingInput>;
  /** ID of order being rated. */
  orderGuid: Scalars['ID']['input'];
  /** ID of place being rated. */
  placeId: Scalars['ID']['input'];
};

export type SubmitGuestRatingResult = GuestRating | SubmitGuestRatingSuccess | UnexpectedError;

export type SubmitGuestRatingResults = {
  __typename?: 'SubmitGuestRatingResults';
  error?: Maybe<UnexpectedError>;
  results: Array<SubmitGuestRatingResult>;
};

export type SubmitGuestRatingSuccess = {
  __typename?: 'SubmitGuestRatingSuccess';
  /** The rating that was updated or created. Null if the rating was deleted. */
  rating?: Maybe<GuestRating>;
};

export type SubmitGuestToastOrderImageReviewsInput = {
  checkId: Scalars['ID']['input'];
  /** The image reviews to be created. The number of image reviews to be created should be equal to the number of items in this list. For each `submitGuestToastOrderImageReviews` request, the minimum and maximum number of items in this list is 1 and 8, respectively. For each `orderId` and `checkId` combination, the maximum number of image reviews that can be created is 8. */
  imageReviewInputs: Array<GuestImageReviewInput>;
  orderId: Scalars['ID']['input'];
  placeId: Scalars['ID']['input'];
};

export type SubmitGuestToastOrderImageReviewsResult = SubmitGuestToastOrderImageReviewsSuccess | TooManyGuestReviewImagesError | UnexpectedError;

export type SubmitGuestToastOrderImageReviewsSuccess = {
  __typename?: 'SubmitGuestToastOrderImageReviewsSuccess';
  /** The image reviews created as part of `submitGuestToastOrderImageReviews`. The number of image reviews should be equal to the number of items in both `imageUploadUrls` and `SubmitGuestToastOrderImageReviewsInput.imageReviewInputs`. */
  imageReviews: Array<GuestImageReview>;
  /** The number of upload URLs should be equal to the number of items in both `imageReviews` and `SubmitGuestToastOrderImageReviewsInput.imageReviewInputs`. */
  imageUploadUrls: Array<GuestImageReviewUpload>;
};

export type SubmitGuestToastOrderTextReviewInput = {
  checkId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  placeId: Scalars['ID']['input'];
  /** Minimum number of characters is 1. Maximum number of characters is 5000. If null is passed in, the text review associated with the `orderId` and `checkId` combination will be removed. */
  reviewText?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitGuestToastOrderTextReviewResult = SubmitGuestToastOrderTextReviewSuccess | UnexpectedError;

export type SubmitGuestToastOrderTextReviewSuccess = {
  __typename?: 'SubmitGuestToastOrderTextReviewSuccess';
  textReview: GuestTextReview;
};

/** Tipping values based on amount based on restaurant specified preferences */
export type SuggestedTip = {
  __typename?: 'SuggestedTip';
  /** Pre-calculated tips based on suggested tips in restaurant preferences */
  preComputedTips: Array<PreComputedTip>;
  /** Base value upon which a percent tip is evaluated, to be used for consistency in client-side computations of percentage-based tips. */
  tippableAmount: Scalars['Float']['output'];
};

export type SurchargeAmounts = {
  __typename?: 'SurchargeAmounts';
  baseAmount: Scalars['Float']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  taxAmount: Scalars['Float']['output'];
};

export type SurchargeSummaryResponse = {
  __typename?: 'SurchargeSummaryResponse';
  /** A list of payment types that this surcharge info is applicable on. */
  paymentTypes: Array<PaymentType>;
  /** The surcharge amount for the check without tax applied. */
  surchargePreTaxAmount: Scalars['Float']['output'];
  /** The percentage used to calculate surcharge amounts in decimal format (0.03, not 3%). */
  surchargeRate: Scalars['Float']['output'];
  /** The surcharge amount for the check with tax applied. */
  surchargeTaxAmount: Scalars['Float']['output'];
};

export type TargetedLocation = {
  __typename?: 'TargetedLocation';
  bottomRight: GeoCoordinates;
  topLeft: GeoCoordinates;
};

export enum ThirdPartyDeliveryStatus {
  DeliveryCancelled = 'DELIVERY_CANCELLED',
  DeliveryCancelledNotApproved = 'DELIVERY_CANCELLED_NOT_APPROVED',
  DeliveryNotYetRequested = 'DELIVERY_NOT_YET_REQUESTED',
  DeliveryRequested = 'DELIVERY_REQUESTED',
  /** not fatal, should retry */
  DispatchError = 'DISPATCH_ERROR',
  /** fatal */
  DispatchFailure = 'DISPATCH_FAILURE',
  DriverAssigned = 'DRIVER_ASSIGNED',
  DriverAtDropoff = 'DRIVER_AT_DROPOFF',
  DriverAtRestaurant = 'DRIVER_AT_RESTAURANT',
  DriverEnRouteToDropoff = 'DRIVER_EN_ROUTE_TO_DROPOFF',
  DriverEnRouteToRestaurant = 'DRIVER_EN_ROUTE_TO_RESTAURANT',
  DriverReturnedOrder = 'DRIVER_RETURNED_ORDER',
  OrderDelivered = 'ORDER_DELIVERED',
  Undeliverable = 'UNDELIVERABLE'
}

export enum TimeBasedRuleTypeEnum {
  LeadTime = 'LEAD_TIME',
  PickupWindow = 'PICKUP_WINDOW',
  Preorder = 'PREORDER'
}

/** Rules defining when a specific item can be ordered */
export type TimeBasedRules = {
  __typename?: 'TimeBasedRules';
  leadTimeRule?: Maybe<LeadTimeRule>;
  pickupWindowRule?: Maybe<PickupWindowRule>;
  preorderRule?: Maybe<PreorderRule>;
};

export type ToastFundedOffer = DiscountOffMinOffer | FreeDeliveryOffer;

export type ToastOrderGuestPostContent = GuestPostContent & {
  __typename?: 'ToastOrderGuestPostContent';
  /** The unique identifier of the check on the order that was placed at the restaurant. Returns null if the authenticated guest is not the author of the post. */
  checkId?: Maybe<Scalars['ID']['output']>;
  /** The local date of when post content was last updated, using time zone of the restaurant if available, otherwise UTC. Null if the content has not been updated by the user. */
  contentUpdatedDate?: Maybe<Scalars['Date']['output']>;
  /** The dining option behavior for how the order was placed. UNKNOWN if there was an error retrieving the dining option, or the post was saved prior to storing the dining option. */
  diningOptionBehavior: ToastOrderGuestPostDiningOptionBehavior;
  /** Content associated with the Toast order post to highlight. The highlights are sorted by user-generated-content first, such as image reviews, with the order as provided by the guest, followed by unique menu items, which are sorted by highest rating first followed by highest unit price first. For a more detailed explanation on how the unique menu items are sorted, see the documentation on `ToastOrderGuestPostContent.uniqueMenuItems`. */
  highlights: Array<ToastOrderGuestPostContentHighlight>;
  /** The same menu items with a discrete quantity are returned as a single menu item in this list. The same menu items with a fractional quantity, with or without a unit of measure, are returned as separate menu items in this list, if they are ordered separately. The `ToastOrderGuestPostContentMenuItem.selectionId` is unique for each item in this list, but the combination of `ToastOrderGuestPostContentMenuItem.itemId` and `ToastOrderGuestPostContentMenuItem.itemGroupId` may not be. The menu items are sorted in order of descending ratings ending with unrated items. Items of the same rating are sorted with the highest unit price first, accounting for modifiers, with the same menu items grouped together. For e.g., given the following order: 1. 1.5 KG of Mussels for $12 1. 1 Clam Chowder with modifier for $11 1. 0.2 KG of Mussels for $10 1. 1/2 of Pizza for $9 1. 2 Clam Chowder with no modifier for $8 each 1. 1/4 of Pizza for $7 1. 300 Bottled Water for $1 each This list will contain [1.5 KG Mussels, 0.2 KG Mussels, 3 Clam Chowder, 1/2 of Pizza, 1/4 of Pizza, 300 Bottled Water]. In the order above, if the clam chowder was rated 2/3, pizza was rated 3/3, and everything else was unrated, then the list would be: [1/2 of Pizza with rating 3/3, 1/4 of Pizza with rating 3/3, 3 Clam Chowder with rating 2/3, 1.5 KG Mussels, 0.2 KG Mussels, 300 Bottled Water]. */
  menuItems: Array<ToastOrderGuestPostContentMenuItem>;
  /** An item with a fractional amount, with or without a unit of measure, contributes +1 to this value. For e.g., given the following order: 1. 2 Clam Chowder 1. 1.5 KG of Mussels 1. 1/4 of Pizza 1. 0.2 KG of Mussels 1. 1/2 of Pizza This value will be 6. */
  numberOfMenuItems: Scalars['Int']['output'];
  /** The local date of when the order was placed at the restaurant, using time zone of the restaurant if available, otherwise UTC. */
  orderCreatedDate: Scalars['Date']['output'];
  /** The unique identifier of the order that was placed at the restaurant. Returns null if the authenticated guest is not the author of the post. Use this in conjunction with `place.toastRestaurant.schedule.asapAvailableForTakeout` to determine if the order can be reordered. */
  orderId?: Maybe<Scalars['ID']['output']>;
  /** See the documentation on `GuestPostContent.place`. */
  place?: Maybe<Place>;
  review: ToastOrderGuestPostContentReview;
  /** If the same menu item is ordered multiple times separately, with or without different modifiers, it is returned as a single menu item in this list. This means that the combination of `ToastOrderGuestPostContentUniqueMenuItem.itemId` and `ToastOrderGuestPostContentUniqueMenuItem.itemGroupId` is unique for each item in this list. The menu items are sorted in order of descending ratings ending with unrated items. Items of the same rating are sorted with the highest unit price first, accounting for modifiers. For e.g., given the following order: 1. 1 Clam Chowder with modifier for $10 1. 1 Burger with modifier for $9 1. 1 Clam Chowder with no modifier for $8 1. 1 Burger with no modifier for $7 1. 300 Bottled Water for $1 each This list will contain [Clam Chowder with quantity 2, Burger with quantity 2, Bottled Water with quantity 300]. In the order above, if the clam chowder and bottled water were both rated 2/3 and the burger was unrated, then the list would be: [Clam Chowder with quantity 2 and rating 2/3, Bottled Water with quantity 300 and rating 2/3, Burger with quantity 2]. */
  uniqueMenuItems: Array<ToastOrderGuestPostContentUniqueMenuItem>;
};

export type ToastOrderGuestPostContentHighlight = ToastOrderGuestPostContentImageReview | ToastOrderGuestPostContentUniqueMenuItem;

export type ToastOrderGuestPostContentImageReview = {
  __typename?: 'ToastOrderGuestPostContentImageReview';
  /** Null to accommodate the inability to resolve due to crossing network boundary. */
  imageReview?: Maybe<GuestImageReview>;
};

export type ToastOrderGuestPostContentMenuItem = {
  __typename?: 'ToastOrderGuestPostContentMenuItem';
  /** The ID of the menu item group this object is referring to. */
  itemGroupId: Scalars['ID']['output'];
  /** The ID of the menu item this object is referring to. */
  itemId: Scalars['ID']['output'];
  /** The name of the menu item at the time the order was placed. If the menu item name changes after the order is placed, this value will not be updated. Null if the menu item does not have a name. */
  name?: Maybe<Scalars['String']['output']>;
  /** A `String` is used to accommodate items with a fractional amount, with or without a unit of measure, such as 1.6 KG, or a partial quantity, such as 1/4 of a pizza. */
  quantity: Scalars['String']['output'];
  review: ToastOrderGuestPostContentMenuItemReview;
  /** Unique identifier for this type. */
  selectionId: Scalars['ID']['output'];
};

export type ToastOrderGuestPostContentMenuItemReview = {
  __typename?: 'ToastOrderGuestPostContentMenuItemReview';
  /** Rating of the menu item. Null if item is unrated or rating has been deleted. */
  rating?: Maybe<GuestRating>;
};

export type ToastOrderGuestPostContentReview = {
  __typename?: 'ToastOrderGuestPostContentReview';
  /** The order experience rating. */
  authorReview: GuestReview;
  /** The text reviews on this post. */
  authorTextReview: ToastOrderGuestPostContentTextReview;
};

export type ToastOrderGuestPostContentTextReview = {
  __typename?: 'ToastOrderGuestPostContentTextReview';
  /** Null to accommodate the absence of order experience text review and the inability to resolve due to crossing network boundary. */
  orderExperience?: Maybe<GuestTextReview>;
};

export type ToastOrderGuestPostContentUniqueMenuItem = {
  __typename?: 'ToastOrderGuestPostContentUniqueMenuItem';
  /** The URLs by size of the image of the menu item at the time the order was placed. If the URLs change after the Toast order post is created, these values will not be updated. Null if the menu item does not have an image. */
  image?: Maybe<ImageSet>;
  itemGroupId: Scalars['ID']['output'];
  itemId: Scalars['ID']['output'];
  /** The name of the menu item at the time the order was placed. If the menu item name changes after the order is placed, this value will not be updated. Null if the menu item does not have a name. */
  name?: Maybe<Scalars['String']['output']>;
  /** An instance of this item with a fractional amount, with or without a unit of measure, contributes +1 to this value. For e.g., given the following order: 1. 2 Clam Chowder 1. 1.5 KG of Mussels 1. 1/4 of Pizza 1. 0.2 KG of Mussels 1. 1/2 of Pizza This value for Claim Chowder will be 2, for Mussels will be 2, and for Pizza will be 2. */
  quantity: Scalars['Int']['output'];
  review: ToastOrderGuestPostContentUniqueMenuItemReview;
};

export type ToastOrderGuestPostContentUniqueMenuItemReview = {
  __typename?: 'ToastOrderGuestPostContentUniqueMenuItemReview';
  /** Rating of the unique menu item. Null if item is unrated or rating has been deleted. */
  rating?: Maybe<GuestRating>;
};

export enum ToastOrderGuestPostDiningOptionBehavior {
  Delivery = 'DELIVERY',
  DineIn = 'DINE_IN',
  TakeOut = 'TAKE_OUT',
  Unknown = 'UNKNOWN'
}

export type ToastOrderGuestPostInput = {
  checkId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};

export type ToastOrderGuestPostResult = ToastOrderGuestPostSuccess | UnexpectedError;

export type ToastOrderGuestPostSuccess = {
  __typename?: 'ToastOrderGuestPostSuccess';
  post: GuestPost;
};

export type ToastPayConfig = {
  __typename?: 'ToastPayConfig';
  qrCodeOnReceiptEnabled: Scalars['Boolean']['output'];
};

export type TooManyGuestReviewImagesError = Error & {
  __typename?: 'TooManyGuestReviewImagesError';
  message: Scalars['String']['output'];
};

/** Tracking Details for Third Party Delivery(TDS) Orders */
export type TrackingDetails = {
  __typename?: 'TrackingDetails';
  actualDeliveryTime?: Maybe<Scalars['String']['output']>;
  deliveryDriver?: Maybe<DeliveryDriver>;
  deliveryProviderName?: Maybe<Scalars['String']['output']>;
  deliveryTimeException?: Maybe<DeliveryTimeException>;
  driverLocation?: Maybe<DeliveryDriverLocation>;
  dropOffImageUrl?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryTime?: Maybe<Scalars['String']['output']>;
  estimatedPickUpTime?: Maybe<Scalars['String']['output']>;
  quotedDeliveryTime?: Maybe<Scalars['String']['output']>;
  quotedPickUpTime?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type UnbanSocialUserRequest = {
  socialUser: SocialUserInput;
};

export type UnbanSocialUserResult = SocialUserDoesNotExistError | UnbanSocialUserSuccess | UnexpectedError;

export type UnbanSocialUserSuccess = {
  __typename?: 'UnbanSocialUserSuccess';
  socialUser: SocialUser;
};

/** Represents an error with the setup and confirmation process that was not explicitly accounted and should not occur during normal operations. You should continue to attempt to communicate with `toast-authentication` when this occurs, as guests with existing accounts will still be able to receive valid authorization tokens. This error only impacts the ability for new accounts to be successfully created and verified. */
export type UnexpectedAuthError = Error & {
  __typename?: 'UnexpectedAuthError';
  message: Scalars['String']['output'];
};

/** Indicates an unexpected error occurred during the OTP confirmation process. This error message should be surfaced to the guest. */
export type UnexpectedConfirmCodeError = Error & {
  __typename?: 'UnexpectedConfirmCodeError';
  message: Scalars['String']['output'];
};

/** Represents an error with an operation that should not occur during normal operations. You should retry the operation with exponential backoff. */
export type UnexpectedError = Error & {
  __typename?: 'UnexpectedError';
  message: Scalars['String']['output'];
};

/** Field representing the unit which is used to measure the weight of an item. */
export enum UnitOfMeasure {
  /** Grams */
  G = 'G',
  /** Kilograms */
  Kg = 'KG',
  /** Pounds */
  Lb = 'LB',
  /** None - this is the default */
  None = 'NONE',
  /** Ounces */
  Oz = 'OZ'
}

/** Input of the unlinkCardFingerprint mutation. */
export type UnlinkCardFingerprintInput = {
  /** Uniquely identifies the guest's card fingerprint that will be unlinked. */
  cardFingerprintId: Scalars['String']['input'];
};

/** The possible responses of the unlinkCardFingerprint mutation. */
export type UnlinkCardFingerprintResponse = UnexpectedError | UnlinkCardFingerprintSuccess;

/** Success response of the unlinkCardFingerprint mutation. */
export type UnlinkCardFingerprintSuccess = {
  __typename?: 'UnlinkCardFingerprintSuccess';
  /** The card fingerprint that has been successfully unlinked. */
  cardFingerprint: GuestCardFingerprint;
};

/** The identity details of a guest that has not yet verified they own this information. */
export type UnverifiedGuestIdentity = {
  __typename?: 'UnverifiedGuestIdentity';
  /** The phone number that should next be verified via authentication. Will be in the format of [E.164](https://en.wikipedia.org/wiki/E.164), such as `"+12223334444"`. */
  phone?: Maybe<Scalars['String']['output']>;
};

export type UpcomingOnlineOrderingScheduleForDate = {
  __typename?: 'UpcomingOnlineOrderingScheduleForDate';
  date: Scalars['String']['output'];
  servicePeriods: Array<UpcomingOnlineOrderingServicePeriod>;
};

export type UpcomingOnlineOrderingServicePeriod = {
  __typename?: 'UpcomingOnlineOrderingServicePeriod';
  diningBehavior: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type UpcomingSchedules = {
  __typename?: 'UpcomingSchedules';
  /** The type of the dining option */
  behavior: DiningOptionBehavior;
  dailySchedules: Array<DailySchedule>;
};

export type UpdateAddressError = Error & {
  __typename?: 'UpdateAddressError';
  code: UpdateAddressErrorCode;
  message: Scalars['String']['output'];
};

export enum UpdateAddressErrorCode {
  AddressNotFound = 'ADDRESS_NOT_FOUND'
}

export type UpdateAddressInput = {
  deliveryInfo: DeliveryInfoInput;
  guid: Scalars['ID']['input'];
  /** The name/label for this address, e.g. "Home", "Work" */
  name: Scalars['String']['input'];
};

export type UpdateAddressResponse = {
  __typename?: 'UpdateAddressResponse';
  customer: Customer;
};

export type UpdateAddressResponseOrError = UpdateAddressError | UpdateAddressResponse;

export type UpdateBasicInfoError = Error & {
  __typename?: 'UpdateBasicInfoError';
  code: UpdateBasicInfoErrorCode;
  message: Scalars['String']['output'];
};

export enum UpdateBasicInfoErrorCode {
  InvalidBasicInfo = 'INVALID_BASIC_INFO'
}

export type UpdateBasicInfoResponse = {
  __typename?: 'UpdateBasicInfoResponse';
  customer: Customer;
};

export type UpdateBasicInfoResponseOrError = UpdateBasicInfoError | UpdateBasicInfoResponse;

export type UpdateDiningOptionInput = {
  cartGuid: Scalars['ID']['input'];
  diningOption: DiningOptionBehavior;
  restaurantGuid: Scalars['ID']['input'];
};

export type UpdateFulfillmentAndClearCartInput = {
  /** Indicates how the order on the cart should be fulfilled. */
  cartFulfillmentInput: CartFulfillmentInput;
  /** The GUID of the cart for which the fulfillment information is to be updated. */
  cartGuid: Scalars['ID']['input'];
};

export type UpdateFulfillmentAndValidateInput = {
  /** Indicates how the order on the cart should be fulfilled. */
  cartFulfillmentInput: CartFulfillmentInput;
  /** The GUID of the cart for which the fulfillment information is to be updated. */
  cartGuid: Scalars['ID']['input'];
};

/** The input of the `updateGuestAddress` mutation. */
export type UpdateGuestAddressInput = {
  /** The postal address saved to the guest account. */
  address: PostalAddressInput;
  /** Identifies the guest address to update. */
  addressId: Scalars['ID']['input'];
  /** The latitude and longitude of the postal address. This expects the client has properly retrieved this; it does not validate it is correct. */
  coordinates: CoordinatesInput;
  /** A descriptor for this address such as "Home" or "Work". */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Notes about the address for delivery drivers to keep in mind. */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** The possible results of the `updateGuestAddress` mutation. */
export type UpdateGuestAddressResult = GuestAddressNotFoundError | UnexpectedError | UpdateGuestAddressSuccess;

/** The successful result of the `updateGuestAddress` mutation. */
export type UpdateGuestAddressSuccess = {
  __typename?: 'UpdateGuestAddressSuccess';
  /** The current verified, authorized guest. */
  guest: Guest;
};

/** The input of the `updateGuestContact` mutation. */
export type UpdateGuestContactInput = {
  /** The `GuestContact` first name to update. Cannot be blank. */
  firstName: Scalars['String']['input'];
  /** The `GuestContact` last name to update. Cannot be blank. */
  lastName: Scalars['String']['input'];
};

/** The possible results of the `updateGuestContact` mutation. */
export type UpdateGuestContactResult = InvalidNameError | UnexpectedError | UpdateGuestContactSuccess;

/** The successful result of the `updateGuestContact` mutation. */
export type UpdateGuestContactSuccess = {
  __typename?: 'UpdateGuestContactSuccess';
  /** The current verified, authorized guest. */
  guest: Guest;
};

export type UpdateGuestPostVisibilityInput = {
  postId: Scalars['ID']['input'];
  visibility: GuestPostVisibility;
};

export type UpdateGuestPostVisibilityResult = UnexpectedError | UpdateGuestPostVisibilitySuccess;

export type UpdateGuestPostVisibilitySuccess = {
  __typename?: 'UpdateGuestPostVisibilitySuccess';
  post: GuestPost;
};

export type UpdateMySocialUserResult = SocialUserBannedError | SocialUserDoesNotExistError | UnexpectedError | UpdateMySocialUserSuccess;

export type UpdateMySocialUserSuccess = {
  __typename?: 'UpdateMySocialUserSuccess';
  socialUser: SocialUser;
};

export type UpdatePasswordResponse = {
  __typename?: 'UpdatePasswordResponse';
  customer: Customer;
};

/** The input of the `updatePrimaryGuestPaymentCard` mutation. */
export type UpdatePrimaryGuestPaymentCardInput = {
  /** Uniquely identifies the guest's payment card that will become the new primary payment card for the guest. */
  paymentCardId: Scalars['ID']['input'];
};

/** The possible results of the `updatePrimaryGuestPaymentCard` mutation. */
export type UpdatePrimaryGuestPaymentCardResult = GuestPaymentCardNotFoundError | UnexpectedError | UpdatePrimaryGuestPaymentCardSuccess;

/** The successful result of the `updatePrimaryGuestPaymentCard` mutation. */
export type UpdatePrimaryGuestPaymentCardSuccess = {
  __typename?: 'UpdatePrimaryGuestPaymentCardSuccess';
  /** The current verified, authorized guest. */
  guest: Guest;
};

export type UpsellsConfig = {
  __typename?: 'UpsellsConfig';
  enabled: Scalars['Boolean']['output'];
};

export type UrlShortenerResolvedResponse = {
  __typename?: 'UrlShortenerResolvedResponse';
  expiry?: Maybe<Scalars['DateTime']['output']>;
  originalUrl: Scalars['String']['output'];
  resolved: Scalars['Boolean']['output'];
  shortUrlKey: Scalars['String']['output'];
};

export type UrlShortenerResolvedResponseOrError = UrlShortenerResolvedResponse | UrlShortenerResponseError;

export type UrlShortenerResponseError = {
  __typename?: 'UrlShortenerResponseError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  statusCode: Scalars['Int']['output'];
};

export type UrlShorteningInput = {
  expiry?: InputMaybe<Scalars['DateTime']['input']>;
  originalUrl: Scalars['String']['input'];
  shortUrlKey?: InputMaybe<Scalars['String']['input']>;
};

export type UrlShorteningResponse = {
  __typename?: 'UrlShorteningResponse';
  key: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  originalUrl: Scalars['String']['output'];
  shortenedUrl: Scalars['String']['output'];
};

export type UrlShorteningResponseOrError = UrlShortenerResponseError | UrlShorteningResponse;

export type ValidateApplePayMerchantError = Error & {
  __typename?: 'ValidateApplePayMerchantError';
  code: ValidateApplePayMerchantErrorCode;
  message: Scalars['String']['output'];
};

export enum ValidateApplePayMerchantErrorCode {
  ValidateMerchantFailed = 'VALIDATE_MERCHANT_FAILED'
}

export type ValidateApplePayMerchantInput = {
  /** The domain which the Apple Pay JS client is running */
  merchantDomain: Scalars['String']['input'];
  /** The GUID of the restaurant that client is using for checkout */
  restaurantGuid: Scalars['ID']['input'];
  /** The url generated by the Apple Pay JS client that will be used for merchant validation */
  validationURL: Scalars['String']['input'];
};

export type ValidateApplePayMerchantResponse = ValidateApplePayMerchantError | ValidateApplePayMerchantSuccessResponse;

export type ValidateApplePayMerchantSuccessResponse = {
  __typename?: 'ValidateApplePayMerchantSuccessResponse';
  merchantSession: Scalars['String']['output'];
};

export type ValidateCartPreCheckoutInput = {
  /** The GUID of the cart that needs to be validated */
  cartGuid: Scalars['ID']['input'];
  /** Guest information */
  customer?: InputMaybe<GuestInput>;
  /** Session ID */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  /** If true, a change to the order time will produce an error */
  validateOrderTime?: InputMaybe<Scalars['Boolean']['input']>;
};

/** deprecated: use ValidateDeliveryLocationInputV2 */
export type ValidateDeliveryLocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  restaurantGuid: Scalars['ID']['input'];
};

export type ValidateDeliveryLocationInputV2 = {
  /** The diner's location */
  deliveryInfo: DeliveryInfoInput;
  restaurantGuid: Scalars['ID']['input'];
};

export type ValidateDeliveryLocationResponse = {
  __typename?: 'ValidateDeliveryLocationResponse';
  /** Provides reasons for why delivery is unavailable. If valid or no reason, left as an empty list */
  unavailabilityReasons: Array<DeliveryUnavailableReason>;
  /** Indicates whether the input restaurant can deliver to the input location. */
  valid: Scalars['Boolean']['output'];
};

/** These errors indicate an issue with the data the client provided and are not retryable. */
export type ValidationError = {
  message: Scalars['String']['output'];
};

/** Contains a mapping of video qualities to their urls. */
export type Video = {
  __typename?: 'Video';
  raw: Scalars['String']['output'];
};

export type VisibleGuestComment = GuestComment & {
  __typename?: 'VisibleGuestComment';
  /** Null if the author is banned or deleted. If the user has opted out of Community then firstName and lastName will be null. */
  author?: Maybe<SocialUser>;
  content: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

/** Namespaced for flexibility to avoid clashes with federated types */
export type Walkout_BookingDetails = {
  __typename?: 'Walkout_BookingDetails';
  bookingType: Walkout_BookingType;
  id: Scalars['ID']['output'];
};

/** Differentiated from BookingType enum because we want to account for unknown values */
export enum Walkout_BookingType {
  Reservation = 'RESERVATION',
  /** Used for booking types not currently supported */
  Unknown = 'UNKNOWN',
  Waitlist = 'WAITLIST'
}

export type Walkout_CreatePreauthOrderForBookingError = {
  __typename?: 'Walkout_CreatePreauthOrderForBookingError';
  code?: Maybe<Walkout_CreatePreauthOrderForBookingErrorCode>;
};

export enum Walkout_CreatePreauthOrderForBookingErrorCode {
  FailedToCreateOrder = 'FailedToCreateOrder',
  FailedToLinkOrderToBooking = 'FailedToLinkOrderToBooking'
}

export type Walkout_CreatePreauthOrderForBookingResponse = Walkout_CreatePreauthOrderForBookingError | Walkout_CreatePreauthOrderForBookingSuccess;

export type Walkout_CreatePreauthOrderForBookingSuccess = {
  __typename?: 'Walkout_CreatePreauthOrderForBookingSuccess';
  checkId: Scalars['ID']['output'];
  orderId: Scalars['ID']['output'];
};

export type Walkout_WalkoutError = {
  __typename?: 'Walkout_WalkoutError';
  code?: Maybe<Walkout_WalkoutErrorCode>;
};

export enum Walkout_WalkoutErrorCode {
  FailedToRetrieveBooking = 'FailedToRetrieveBooking',
  FailedToRetrieveOrder = 'FailedToRetrieveOrder'
}

export type Walkout_WalkoutResponse = Walkout_WalkoutError | Walkout_WalkoutSuccess;

export enum Walkout_WalkoutState {
  Activated = 'Activated',
  ClosedTab = 'ClosedTab',
  Invalid = 'Invalid',
  InvalidBookingType = 'InvalidBookingType',
  OpenTab = 'OpenTab',
  ReservationsLanding = 'ReservationsLanding',
  RestaurantIdMismatch = 'RestaurantIdMismatch',
  WaitlistLanding = 'WaitlistLanding'
}

export type Walkout_WalkoutSuccess = {
  __typename?: 'Walkout_WalkoutSuccess';
  bookingDetails: Walkout_BookingDetails;
  /** @deprecated use orderDetails */
  checkId?: Maybe<Scalars['ID']['output']>;
  /** Order details associated with a walkout state. If null, no order exists for the current guest experience */
  orderDetails?: Maybe<OrderDetails>;
  /** @deprecated use orderDetails */
  orderId?: Maybe<Scalars['ID']['output']>;
  state: Walkout_WalkoutState;
};

/** Indicates that although the intended result of a query or mutation was achieved, there are side effects that would affect downstream actions. */
export type Warning = {
  message: Scalars['String']['output'];
};

export type AddToCartMutationVariables = Exact<{
  input: AddItemToCartInputV2;
}>;


export type AddToCartMutation = { __typename?: 'Mutation', addItemToCartV2: { __typename?: 'CartModificationError', code: CartModificationErrorCode, message: string } | { __typename?: 'CartOutOfStockError', message: string, items: Array<{ __typename?: 'CartOutOfStockItem', name?: string | null, guid?: string | null }> } | { __typename?: 'CartResponse', cart: { __typename?: 'Cart', guid: string, cartSource?: CartSource | null, expiredDate: number, cartUpsellInfo?: { __typename?: 'CartUpsellInfo', upsellItems?: Array<string> | null } | null, order?: { __typename?: 'Order', numberOfSelections?: number | null, taxV2?: number | null, totalV2?: number | null, selections?: Array<{ __typename?: 'Selection', name?: string | null, price?: number | null, quantity?: number | null, modifiers?: Array<{ __typename?: 'Selection', name?: string | null, price?: number | null } | null> | null } | null> | null, surcharges?: Array<{ __typename?: 'SurchargeSummaryResponse', paymentTypes: Array<PaymentType>, surchargePreTaxAmount: number, surchargeRate: number, surchargeTaxAmount: number }> | null } | null } } | { __typename?: 'CartValidationError' } };

export type AdsManagerConversionTagsConfigFieldsFragment = { __typename?: 'AdsManagerConversionTagsConfig', managementSetGuid: string, restaurantConversionsDataList?: Array<{ __typename?: 'AdsManagerRestaurantConversionsData', restaurantGuid: string, googleConversionsData?: { __typename?: 'GoogleConversionsData', tagId?: string | null, conversionLabels?: Array<{ __typename?: 'GoogleConversionLabel', label: string, type: string } | null> | null } | null, metaConversionsData?: { __typename?: 'MetaConversionsData', pixelId?: string | null } | null } | null> | null };

export type AdsManagerRestaurantConversionsDataFieldsFragment = { __typename?: 'AdsManagerRestaurantConversionsData', restaurantGuid: string, metaConversionsData?: { __typename?: 'MetaConversionsData', pixelId?: string | null } | null, googleConversionsData?: { __typename?: 'GoogleConversionsData', tagId?: string | null, conversionLabels?: Array<{ __typename?: 'GoogleConversionLabel', label: string, type: string } | null> | null } | null };

export type ApplyPromoCodeMutationVariables = Exact<{
  input: ApplyPromoCodeInputV3;
}>;


export type ApplyPromoCodeMutation = { __typename?: 'Mutation', applyPromoCodeV3: { __typename?: 'ApplyPromoCodeError', code: ApplyPromoCodeErrorCode, message: string } | { __typename?: 'CartModificationError' } | { __typename?: 'CartOutOfStockError' } | { __typename?: 'CartResponse', cart: { __typename?: 'Cart', guid: string, cartSource?: CartSource | null, order?: { __typename?: 'Order', discountsTotal: number } | null } } };

export type CompleteIdentityProfileMutationVariables = Exact<{
  input: CompleteIdentityProfileInput;
}>;


export type CompleteIdentityProfileMutation = { __typename?: 'Mutation', completeIdentityProfile: { __typename?: 'CompleteIdentityProfileError', code: CompleteIdentityProfileErrorCode, message: string } | { __typename?: 'CompleteIdentityProfileResponse', guestGuid: string } };

export type ConfirmCodeMutationVariables = Exact<{
  input: PasswordlessConfirmCodeUnifiedInput;
}>;


export type ConfirmCodeMutation = { __typename?: 'Mutation', passwordlessConfirmCodeUnified: { __typename?: 'PasswordlessAuthenticationError', message: string, code: PasswordlessAuthenticationErrorCode } | { __typename?: 'PasswordlessTokenUnifiedResponse', accessToken: string, refreshToken: string, expiresAtIso8601: string, guestGuid: string } };

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: { __typename?: 'DeleteAccountError', code: DeleteAccountErrorCode, message: string } | { __typename?: 'DeleteAccountResponse', success: boolean } };

export type LogoutMutationVariables = Exact<{
  input: PasswordlessLogoutInput;
}>;


export type LogoutMutation = { __typename?: 'Mutation', passwordlessLogout: { __typename?: 'PasswordlessAuthenticationError', code: PasswordlessAuthenticationErrorCode, message: string } | { __typename?: 'PasswordlessLogoutResponse', success: boolean } };

export type PasswordlessLoginMutationVariables = Exact<{
  input: PasswordlessLoginUnifiedInput;
}>;


export type PasswordlessLoginMutation = { __typename?: 'Mutation', passwordlessLoginUnified: { __typename?: 'PasswordlessAuthenticationError', code: PasswordlessAuthenticationErrorCode, message: string } | { __typename?: 'PasswordlessLoginUnifiedResponse', success: boolean } };

export type PasswordlessRefreshTokenMutationVariables = Exact<{
  input: PasswordlessRefreshTokenInput;
}>;


export type PasswordlessRefreshTokenMutation = { __typename?: 'Mutation', passwordlessRefreshToken: { __typename?: 'PasswordlessAuthenticationError', code: PasswordlessAuthenticationErrorCode, message: string } | { __typename?: 'PasswordlessTokenResponse', accessToken: string, expiresAtIso8601: string, refreshToken: string } };

export type OrderFieldsFragment = { __typename?: 'Order', numberOfSelections?: number | null, preDiscountItemsSubtotal: number, discountsTotal: number, deliveryServiceCharges: number, processingServiceCharges: number, gratuityServiceCharges: number, nonDeliveryNonGratuityNonUbpServiceCharges: number, taxV2?: number | null, totalV2?: number | null, deliveryInfo?: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null, administrativeArea?: string | null, country?: string | null } | null, selections?: Array<{ __typename?: 'Selection', itemGuid?: string | null, usesFractionalQuantity: boolean, quantity?: number | null, itemGroupGuid?: string | null, name?: string | null, guid?: string | null, preDiscountPrice?: number | null, price?: number | null, optionGroupGuid?: string | null, receiptLinePrice?: number | null, groupingKey?: string | null, fractionalQuantity: { __typename?: 'FractionalQuantity', unitOfMeasure: UnitOfMeasure, quantity: number }, appliedDiscounts?: Array<{ __typename?: 'Discounts', name?: string | null, discountAmount?: number | null, restaurantDiscount?: { __typename?: 'RestaurantDiscount', promoCode: string } | null, loyaltyDiscounts?: Array<{ __typename?: 'LoyaltyDiscount', guid: string, amount: number, type: LoyaltyRedemptionType, referenceId?: string | null, name?: string | null } | null> | null, globalReward?: { __typename?: 'AppliedCustomerReward', amount?: number | null, name?: string | null, rewardType?: RewardType | null, total?: number | null } | null, loyaltyDetails?: { __typename?: 'LoyaltyDetails', vendor?: string | null, referenceId?: string | null } | null, discount?: { __typename?: 'DiscountDetails', guid: string, entityType: string } | null }> | null, modifiers?: Array<{ __typename?: 'Selection', name?: string | null, guid?: string | null, preDiscountPrice?: number | null, price?: number | null, optionGroupGuid?: string | null, receiptLinePrice?: number | null, groupingKey?: string | null, modifiers?: Array<{ __typename?: 'Selection', name?: string | null, guid?: string | null, preDiscountPrice?: number | null, price?: number | null, optionGroupGuid?: string | null, receiptLinePrice?: number | null, groupingKey?: string | null, modifiers?: Array<{ __typename?: 'Selection', name?: string | null, guid?: string | null, preDiscountPrice?: number | null, price?: number | null, optionGroupGuid?: string | null, receiptLinePrice?: number | null, groupingKey?: string | null } | null> | null } | null> | null } | null> | null } | null> | null, discounts: { __typename?: 'Discounts', name?: string | null, discountAmount?: number | null, restaurantDiscount?: { __typename?: 'RestaurantDiscount', promoCode: string } | null, loyaltyDiscounts?: Array<{ __typename?: 'LoyaltyDiscount', guid: string, amount: number, type: LoyaltyRedemptionType, referenceId?: string | null, name?: string | null } | null> | null, globalReward?: { __typename?: 'AppliedCustomerReward', amount?: number | null, name?: string | null, rewardType?: RewardType | null, total?: number | null } | null, loyaltyDetails?: { __typename?: 'LoyaltyDetails', vendor?: string | null, referenceId?: string | null } | null, discount?: { __typename?: 'DiscountDetails', guid: string, entityType: string } | null }, surcharges?: Array<{ __typename?: 'SurchargeSummaryResponse', paymentTypes: Array<PaymentType>, surchargePreTaxAmount: number, surchargeRate: number, surchargeTaxAmount: number }> | null };

export type CartQueryVariables = Exact<{
  guid: Scalars['ID']['input'];
  totalGiftCardBalance?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CartQuery = { __typename?: 'Query', cartV2: { __typename?: 'CartError', code: CartErrorCode, message: string } | { __typename?: 'CartResponse', cart: { __typename?: 'Cart', cartSource?: CartSource | null, quoteTime?: number | null, takeoutQuoteTime?: number | null, deliveryQuoteTime?: number | null, diningOptionBehavior: DiningOptionBehavior, fulfillmentType: FulfillmentType, fulfillmentDateTime?: string | null, restaurant?: { __typename?: 'Restaurant', guid: string, name: string, shortUrl: string, deliveryProviders: Array<{ __typename?: 'DeliveryProviderConfig', provider: DeliveryProvider, enabled: boolean }>, location: { __typename?: 'Location', address1: string, address2?: string | null, city: string, state: string, zip: string, phone: string, latitude?: number | null, longitude?: number | null }, specialRequestsConfig: { __typename?: 'SpecialRequestsConfig', placeholderMessage: string, enabled: boolean } } | null, deliveryProviderInfo?: { __typename?: 'DeliveryProviderInfo', provider: DeliveryProvider, needsDeliveryCommunicationConsent: boolean } | null, cartUpsellInfo?: { __typename?: 'CartUpsellInfo', upsellItems?: Array<string> | null } | null, order?: { __typename?: 'Order', numberOfSelections?: number | null, preDiscountItemsSubtotal: number, discountsTotal: number, deliveryServiceCharges: number, processingServiceCharges: number, gratuityServiceCharges: number, nonDeliveryNonGratuityNonUbpServiceCharges: number, taxV2?: number | null, totalV2?: number | null, deliveryInfo?: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null, administrativeArea?: string | null, country?: string | null } | null, selections?: Array<{ __typename?: 'Selection', itemGuid?: string | null, usesFractionalQuantity: boolean, quantity?: number | null, itemGroupGuid?: string | null, name?: string | null, guid?: string | null, preDiscountPrice?: number | null, price?: number | null, optionGroupGuid?: string | null, receiptLinePrice?: number | null, groupingKey?: string | null, fractionalQuantity: { __typename?: 'FractionalQuantity', unitOfMeasure: UnitOfMeasure, quantity: number }, appliedDiscounts?: Array<{ __typename?: 'Discounts', name?: string | null, discountAmount?: number | null, restaurantDiscount?: { __typename?: 'RestaurantDiscount', promoCode: string } | null, loyaltyDiscounts?: Array<{ __typename?: 'LoyaltyDiscount', guid: string, amount: number, type: LoyaltyRedemptionType, referenceId?: string | null, name?: string | null } | null> | null, globalReward?: { __typename?: 'AppliedCustomerReward', amount?: number | null, name?: string | null, rewardType?: RewardType | null, total?: number | null } | null, loyaltyDetails?: { __typename?: 'LoyaltyDetails', vendor?: string | null, referenceId?: string | null } | null, discount?: { __typename?: 'DiscountDetails', guid: string, entityType: string } | null }> | null, modifiers?: Array<{ __typename?: 'Selection', name?: string | null, guid?: string | null, preDiscountPrice?: number | null, price?: number | null, optionGroupGuid?: string | null, receiptLinePrice?: number | null, groupingKey?: string | null, modifiers?: Array<{ __typename?: 'Selection', name?: string | null, guid?: string | null, preDiscountPrice?: number | null, price?: number | null, optionGroupGuid?: string | null, receiptLinePrice?: number | null, groupingKey?: string | null, modifiers?: Array<{ __typename?: 'Selection', name?: string | null, guid?: string | null, preDiscountPrice?: number | null, price?: number | null, optionGroupGuid?: string | null, receiptLinePrice?: number | null, groupingKey?: string | null } | null> | null } | null> | null } | null> | null } | null> | null, discounts: { __typename?: 'Discounts', name?: string | null, discountAmount?: number | null, restaurantDiscount?: { __typename?: 'RestaurantDiscount', promoCode: string } | null, loyaltyDiscounts?: Array<{ __typename?: 'LoyaltyDiscount', guid: string, amount: number, type: LoyaltyRedemptionType, referenceId?: string | null, name?: string | null } | null> | null, globalReward?: { __typename?: 'AppliedCustomerReward', amount?: number | null, name?: string | null, rewardType?: RewardType | null, total?: number | null } | null, loyaltyDetails?: { __typename?: 'LoyaltyDetails', vendor?: string | null, referenceId?: string | null } | null, discount?: { __typename?: 'DiscountDetails', guid: string, entityType: string } | null }, surcharges?: Array<{ __typename?: 'SurchargeSummaryResponse', paymentTypes: Array<PaymentType>, surchargePreTaxAmount: number, surchargeRate: number, surchargeTaxAmount: number }> | null } | null, paymentOptions: { __typename?: 'CartPaymentOptions', atCheckout: Array<{ __typename?: 'CartPaymentOption', paymentType: PaymentType } | null>, uponReceipt: Array<{ __typename?: 'CartPaymentOption', paymentType: PaymentType } | null> }, preComputedTips: Array<{ __typename?: 'PreComputedTip', percent: number, value: number } | null> } } };

export type CompletedOrderQueryVariables = Exact<{
  input: CompletedOrderInput;
}>;


export type CompletedOrderQuery = { __typename?: 'Query', completedOrder: { __typename?: 'CompletedOrder', guid: string, approvalStatus?: OrderApprovalStatus | null, checkGuid: string, checkNumber?: number | null, estimatedFulfillmentDate?: number | null, guestCommunication?: string | null, diningOptionBehavior: DiningOptionBehavior, numberOfSelections: number, preDiscountItemsSubtotal: number, discountsTotal: number, deliveryServiceCharges: number, processingServiceCharges: number, gratuityServiceCharges: number, nonDeliveryNonGratuityNonUbpServiceCharges: number, fundraisingTotal?: number | null, taxV2: number, tip: number, totalV2: number, hasLoyaltyAttached: boolean, paymentType: PaymentType, customerV3?: { __typename?: 'CustomerInfoV2', firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null } | null, restaurant: { __typename?: 'Restaurant', guid: string, name: string, location: { __typename?: 'Location', address1: string, address2?: string | null, city: string, state: string, zip: string, phone: string, latitude?: number | null, longitude?: number | null }, loyaltyConfig: { __typename?: 'LoyaltyConfig', loyaltySignupEnabled: boolean, loyaltyRedemptionEnabled: boolean, programName?: string | null, rewardType?: RewardRedemptionType | null } }, curbsidePickup?: { __typename?: 'CurbsidePickup', selected: boolean } | null, curbsidePickupV2?: { __typename?: 'CurbsidePickupV2', notes?: string | null } | null, deliveryInfo?: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null, administrativeArea?: string | null, country?: string | null } | null, deliveryServiceInfo?: { __typename?: 'DeliveryServiceInfo', providerName?: string | null } | null, selections: Array<{ __typename?: 'CompletedOrderSelection', externalId?: string | null, price: number, preDiscountPrice?: number | null, quantity: number, receiptLinePrice?: number | null, usesFractionalQuantity: boolean, name: string, fractionalQuantity: { __typename?: 'FractionalQuantity', unitOfMeasure: UnitOfMeasure, quantity: number }, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string }> }> }> }>, discounts: { __typename?: 'Discounts', name?: string | null, discountAmount?: number | null, restaurantDiscount?: { __typename?: 'RestaurantDiscount', promoCode: string } | null, loyaltyDiscounts?: Array<{ __typename?: 'LoyaltyDiscount', guid: string, amount: number, type: LoyaltyRedemptionType, referenceId?: string | null, name?: string | null } | null> | null, globalReward?: { __typename?: 'AppliedCustomerReward', amount?: number | null, name?: string | null, rewardType?: RewardType | null, total?: number | null } | null, loyaltyDetails?: { __typename?: 'LoyaltyDetails', vendor?: string | null, referenceId?: string | null } | null, discount?: { __typename?: 'DiscountDetails', guid: string, entityType: string } | null }, surchargeServiceCharges: { __typename?: 'SurchargeAmounts', baseAmount: number, taxAmount: number, rate?: number | null }, packagingSelections: Array<{ __typename?: 'PackagingSelection', guid: string, inclusion: PackagingInclusion, guestDisplayName: string }>, giftCard?: { __typename?: 'GiftCardPayment', appliedBalance: number } | null } };

export type CreateGiftCardOrderMutationVariables = Exact<{
  input: CreateGiftCardOrderInput;
}>;


export type CreateGiftCardOrderMutation = { __typename?: 'Mutation', createGiftCardOrder: { __typename?: 'CreateGiftCardOrderResponse', orderGuid: string } };

export type CustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', lastName?: string | null, firstName?: string | null, phone?: string | null, email: string, id: string, creditCards: Array<{ __typename?: 'SavedCreditCard', guid: string, cardType: CardType, maskedPan: string, expirationMonth: string, expirationYear: string, isPrimary: boolean }>, addresses: Array<{ __typename?: 'SavedAddress', guid: string, name?: string | null, deliveryInfo: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null } }> } };

export type AddGuestIdentityMutationVariables = Exact<{
  input: AddGuestIdentityInput;
}>;


export type AddGuestIdentityMutation = { __typename?: 'Mutation', addGuestIdentity: { __typename?: 'AddGuestIdentitySuccess', success: boolean } | { __typename?: 'GuestIdentityAlreadyExistsForCurrentGuestError', message: string } | { __typename?: 'InvalidEmailError', message: string } | { __typename?: 'ProfileLockedForDeletionError', message: string } | { __typename?: 'UnexpectedError', message: string } };

export type DeleteAddressMutationVariables = Exact<{
  input: DeleteAddressInput;
}>;


export type DeleteAddressMutation = { __typename?: 'Mutation', deleteAddress: { __typename?: 'DeleteAddressError', code: DeleteAddressErrorCode, message: string } | { __typename?: 'DeleteAddressResponse', customer: { __typename?: 'Customer', lastName?: string | null, firstName?: string | null, phone?: string | null, email: string, id: string, creditCards: Array<{ __typename?: 'SavedCreditCard', guid: string, cardType: CardType, maskedPan: string, expirationMonth: string, expirationYear: string, isPrimary: boolean }>, addresses: Array<{ __typename?: 'SavedAddress', guid: string, name?: string | null, deliveryInfo: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null } }> } } };

export type UpdateAddressMutationVariables = Exact<{
  input: UpdateAddressInput;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateAddress: { __typename?: 'UpdateAddressError', code: UpdateAddressErrorCode, message: string } | { __typename?: 'UpdateAddressResponse', customer: { __typename?: 'Customer', lastName?: string | null, firstName?: string | null, phone?: string | null, email: string, id: string, creditCards: Array<{ __typename?: 'SavedCreditCard', guid: string, cardType: CardType, maskedPan: string, expirationMonth: string, expirationYear: string, isPrimary: boolean }>, addresses: Array<{ __typename?: 'SavedAddress', guid: string, name?: string | null, deliveryInfo: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null } }> } } };

export type ConfirmGuestIdentityMutationVariables = Exact<{
  input: ConfirmGuestIdentityInput;
}>;


export type ConfirmGuestIdentityMutation = { __typename?: 'Mutation', confirmGuestIdentity: { __typename?: 'CodeAuthenticationError', message: string } | { __typename?: 'CodeExpiredError', message: string } | { __typename?: 'CodeMaxAttemptsReachedError', message: string } | { __typename?: 'ConfirmGuestIdentitySuccess', guest: { __typename?: 'Guest', id: string } } | { __typename?: 'GuestIdentityAlreadyExistsForAnotherGuestError', message: string } | { __typename?: 'IncorrectCodeError', message: string } | { __typename?: 'UnexpectedConfirmCodeError', message: string } };

export type CustomerFieldsFragment = { __typename?: 'Customer', lastName?: string | null, firstName?: string | null, phone?: string | null, email: string, id: string, creditCards: Array<{ __typename?: 'SavedCreditCard', guid: string, cardType: CardType, maskedPan: string, expirationMonth: string, expirationYear: string, isPrimary: boolean }>, addresses: Array<{ __typename?: 'SavedAddress', guid: string, name?: string | null, deliveryInfo: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null } }> };

export type UpdateBasicInfoMutationVariables = Exact<{
  input: BasicInfoInput;
}>;


export type UpdateBasicInfoMutation = { __typename?: 'Mutation', updateBasicInfo: { __typename?: 'UpdateBasicInfoError', code: UpdateBasicInfoErrorCode, message: string } | { __typename?: 'UpdateBasicInfoResponse', customer: { __typename?: 'Customer', firstName?: string | null, lastName?: string | null, phone?: string | null, id: string } } };

export type DeleteCreditCardMutationVariables = Exact<{
  input: DeleteCreditCardInput;
}>;


export type DeleteCreditCardMutation = { __typename?: 'Mutation', deleteCreditCard: { __typename?: 'DeleteCreditCardError', code: DeleteCreditCardErrorCode, message: string } | { __typename?: 'DeleteCreditCardResponse', customer: { __typename?: 'Customer', lastName?: string | null, firstName?: string | null, phone?: string | null, email: string, id: string, creditCards: Array<{ __typename?: 'SavedCreditCard', guid: string, cardType: CardType, maskedPan: string, expirationMonth: string, expirationYear: string, isPrimary: boolean }>, addresses: Array<{ __typename?: 'SavedAddress', guid: string, name?: string | null, deliveryInfo: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null } }> } } };

export type DeleteFromCartMutationVariables = Exact<{
  input: DeleteItemFromCartInput;
}>;


export type DeleteFromCartMutation = { __typename?: 'Mutation', deleteItemFromCartV2: { __typename?: 'CartModificationError', code: CartModificationErrorCode, message: string } | { __typename?: 'CartOutOfStockError', message: string, items: Array<{ __typename?: 'CartOutOfStockItem', name?: string | null, guid?: string | null }> } | { __typename?: 'CartResponse', cart: { __typename?: 'Cart', guid: string, cartSource?: CartSource | null } } | { __typename?: 'CartValidationError' } };

export type DiningOptionFragmentFragment = { __typename?: 'DiningOption', behavior: DiningOptionBehavior, asapSchedule?: { __typename?: 'AsapSchedule', availableNow: boolean } | null, futureSchedule?: { __typename?: 'FutureSchedule', dates: Array<{ __typename?: 'FutureFulfillmentDate', date: string, times: Array<{ __typename?: 'FutureFulfillmentTime', time: string }> }> } | null };

export type DoGetMenuGroupsQueryVariables = Exact<{
  input: DoMenus_GetMenuGroupsInput;
}>;


export type DoGetMenuGroupsQuery = { __typename?: 'Query', doMenus_getMenuGroups: { __typename?: 'DoMenus_GetMenuGroupsError', message: string } | { __typename?: 'DoMenus_GetMenuGroupsResponse', groups: Array<{ __typename?: 'DoMenus_GetMenuGroupsGroup', guid: string, masterId?: string | null, name: string, description?: string | null, imageLink?: string | null, items: Array<{ __typename?: 'DoMenus_GetMenuItemsItem', description?: string | null, groupGuid?: string | null, guid: string, imageLink?: string | null, masterId?: string | null, name: string, price?: number | null, itemTags: Array<{ __typename?: 'Menus_MenuItemTag', guid?: string | null, name?: string | null }> } | null> } | null> } };

export type DoGetMenuItemsQueryVariables = Exact<{
  input: DoMenus_GetMenuItemsInput;
}>;


export type DoGetMenuItemsQuery = { __typename?: 'Query', doMenus_getMenuItems: { __typename?: 'DoMenus_GetMenuItemsError', message: string } | { __typename?: 'DoMenus_GetMenuItemsResponse', items: Array<{ __typename?: 'DoMenus_GetMenuItemsItem', description?: string | null, groupGuid?: string | null, guid: string, imageLink?: string | null, masterId?: string | null, name: string, price?: number | null } | null> } };

export type DoMenuItemQueryVariables = Exact<{
  input: DoMenus_FindMenuItemInput;
}>;


export type DoMenuItemQuery = { __typename?: 'Query', doMenus_findMenuItem: { __typename?: 'DoMenus_FindMenuItemError', message: string } | { __typename?: 'DoMenus_FindMenuItemResponse', menuResponse: { __typename?: 'Menus_MenuResponseV2', modifierGroupReferences: Array<{ __typename?: 'Menus_MenuOptionGroupV2', guid: string, defaultOptionsSubstitutionPricing?: string | null, defaultOptionsChargePrice?: string | null, pricingStrategy: Menus_MappablePricingStrategy, pricingRules?: { __typename?: 'Menus_PricingRules', sizeSpecificPricingGuid?: string | null, sizeSequencePricingRules: Array<{ __typename?: 'Menus_SizeSequencePricingRule', sizeName?: string | null, sizeGuid?: string | null, sequencePrices: Array<{ __typename?: 'Menus_SequencePrice', sequence: number, price: number }> }> } | null }> } } };

export type GuestFacingInstructionsQueryVariables = Exact<{
  input: GuestFacingInstructionsQueryInput;
}>;


export type GuestFacingInstructionsQuery = { __typename?: 'Query', getGuestFacingInstructions: { __typename?: 'GuestFacingMessagesConfig', confirmationInstructions?: { __typename?: 'Instructions', enabled: boolean, message: string } | null } };

export type EditCartItemMutationVariables = Exact<{
  input: EditItemInCartInput;
}>;


export type EditCartItemMutation = { __typename?: 'Mutation', editItemInCartV2: { __typename?: 'CartModificationError', code: CartModificationErrorCode, message: string } | { __typename?: 'CartOutOfStockError', message: string, items: Array<{ __typename?: 'CartOutOfStockItem', name?: string | null, guid?: string | null }> } | { __typename?: 'CartResponse', cart: { __typename?: 'Cart', guid: string, cartSource?: CartSource | null, expiredDate: number, order?: { __typename?: 'Order', numberOfSelections?: number | null, taxV2?: number | null, totalV2?: number | null, selections?: Array<{ __typename?: 'Selection', name?: string | null, price?: number | null, quantity?: number | null, modifiers?: Array<{ __typename?: 'Selection', name?: string | null, price?: number | null } | null> | null } | null> | null } | null } } | { __typename?: 'CartValidationError' } };

export type GetEGiftCardConfigQueryVariables = Exact<{
  restaurantGuid: Scalars['ID']['input'];
}>;


export type GetEGiftCardConfigQuery = { __typename?: 'Query', eGiftCardConfig?: { __typename?: 'EGiftCardConfig', eGiftCardPurchasingEnabled?: boolean | null, minimumPurchaseAmount?: { __typename?: 'GiftCardAmount', value: number, currency: string } | null, maximumPurchaseAmount?: { __typename?: 'GiftCardAmount', currency: string, value: number } | null } | null };

export type GetShippingOptionsQueryVariables = Exact<{
  input: ServiceGroupsQueryInput;
}>;


export type GetShippingOptionsQuery = { __typename?: 'Query', getServiceGroups: Array<{ __typename?: 'ServiceGroup', objectId: string, name: string, description: string, type: string, flatRate?: string | null, flatRateCurrency?: string | null, freeShippingThresholdMin?: string | null, freeShippingThresholdCurrency?: string | null } | null> };

export type GiftCardBalanceQueryVariables = Exact<{
  input: GiftCardBalanceInquiryInput;
}>;


export type GiftCardBalanceQuery = { __typename?: 'Query', giftCardBalanceInquiry: { __typename?: 'GiftCardBalanceInquiryError', code: GiftCardBalanceInquiryErrorCode, message: string } | { __typename?: 'GiftCardBalanceInquiryResponse', availableBalance: number, cardNumber: string } };

export type GiftCardConfigFieldsFragment = { __typename?: 'GiftCardConfig', redemptionAllowed: boolean, hasGiftCardsExtension: boolean, supportVerificationCode: boolean, purchaseAllowed: boolean };

export type GiftCardExtensionBalanceQueryVariables = Exact<{
  input: GiftCardExtensionBalanceInquiryInput;
}>;


export type GiftCardExtensionBalanceQuery = { __typename?: 'Query', giftCardExtensionBalanceInquiry: { __typename?: 'GiftCardBalanceInquiryError', code: GiftCardBalanceInquiryErrorCode, message: string } | { __typename?: 'GiftCardBalanceInquiryResponse', availableBalance: number, cardNumber: string } };

export type GuestQueryVariables = Exact<{ [key: string]: never; }>;


export type GuestQuery = { __typename?: 'Query', guest: { __typename?: 'Guest', id: string, contact: { __typename?: 'GuestContact', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, contactEmails?: Array<{ __typename?: 'ContactEmail', email: string, isVerified: boolean }> | null } } };

export type GuestWalletQueryVariables = Exact<{
  timeZone: Scalars['String']['input'];
  restaurantId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GuestWalletQuery = { __typename?: 'Query', guest: { __typename?: 'Guest', wallet: { __typename?: 'GuestWallet', guestCurrencyAccount: { __typename?: 'GuestCurrencyAccount', id: string, availableBalanceByRestaurant: { __typename?: 'Money', amount: string, currency: Currency }, availableBalanceWithStoredValue: { __typename?: 'Money', amount: string, currency: Currency }, nearestFutureExpirableDayValue?: { __typename?: 'GuestCurrencyExpirableDayValue', expirationDate: string, amount: { __typename?: 'Money', amount: string, currency: Currency } } | null } } } };

export type ImageFieldsFragment = { __typename?: 'ImageSet', xxl: string, xl: string, large: string, medium: string, small: string, xs: string, raw: string };

export type LocationFieldsFragment = { __typename?: 'Location', address1: string, address2?: string | null, city: string, state: string, zip: string, phone: string, latitude?: number | null, longitude?: number | null };

export type AddLoyaltyToCartMutationVariables = Exact<{
  input: AddLoyaltyRedemptionV2Input;
}>;


export type AddLoyaltyToCartMutation = { __typename?: 'Mutation', addLoyaltyRedemptionV2: { __typename?: 'CartModificationError' } | { __typename?: 'CartOutOfStockError' } | { __typename?: 'CartResponse', cart: { __typename?: 'Cart', guid: string, cartSource?: CartSource | null } } | { __typename?: 'CartValidationError' } };

export type CustomerLoyaltyInfoQueryVariables = Exact<{
  input: CustomerLoyaltyInfoInput;
}>;


export type CustomerLoyaltyInfoQuery = { __typename?: 'Query', customerLoyaltyInfo: { __typename?: 'CustomerLoyaltyError' } | { __typename?: 'LoyaltyInquiryResponse', pointsBalance: number, currentState?: { __typename?: 'BalanceStateData', balance?: number | null, balancePoints?: number | null, messages?: { __typename?: 'BalanceMessagesData', balance?: string | null, balanceShort?: string | null } | null } | null } };

export type CustomerLoyaltySignupMutationVariables = Exact<{
  input: LoyaltySignupInput;
}>;


export type CustomerLoyaltySignupMutation = { __typename?: 'Mutation', loyaltySignup: { __typename?: 'LoyaltySignupError' } | { __typename?: 'LoyaltySignupResponse', customer?: { __typename?: 'Customer', lastName?: string | null, firstName?: string | null, phone?: string | null, email: string, id: string, creditCards: Array<{ __typename?: 'SavedCreditCard', guid: string, cardType: CardType, maskedPan: string, expirationMonth: string, expirationYear: string, isPrimary: boolean }>, addresses: Array<{ __typename?: 'SavedAddress', guid: string, name?: string | null, deliveryInfo: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null } }> } | null } };

export type LoyaltyFeaturesQueryVariables = Exact<{
  input: LoyaltyFeaturesInput;
}>;


export type LoyaltyFeaturesQuery = { __typename?: 'Query', loyaltyFeatures: { __typename?: 'LoyaltyFeaturesResponse', programDescription: string, features: Array<{ __typename?: 'LoyaltyFeatures', message?: string | null, description?: string | null, tags?: Array<string | null> | null } | null> } };

export type LoyaltyConfigFieldsFragment = { __typename?: 'LoyaltyConfig', loyaltySignupEnabled: boolean, loyaltyRedemptionEnabled: boolean, programName?: string | null, rewardType?: RewardRedemptionType | null };

export type LoyaltyInquiryResponseFieldsFragment = { __typename?: 'LoyaltyInquiryResponse', pointsBalance: number, loyaltyAccountIdentifier?: string | null, redemptions: Array<{ __typename?: 'LoyaltyRedemption', name?: string | null, type: LoyaltyRedemptionType, referenceId?: string | null, redemptionAmount: number, redemptionGuid: string, rewardType?: RewardTypeData | null, target?: number | null, available?: boolean | null, currentState?: { __typename?: 'RewardStateData', leftToTarget?: number | null, messages?: { __typename?: 'RewardMessagesData', nextRewardMessage?: string | null, nextRewardMiniMessage?: string | null, rewardLabelMessage?: string | null, rewardValueMessage?: string | null, unlockedMessage?: string | null } | null } | null }>, currentState?: { __typename?: 'BalanceStateData', balance?: number | null, balancePoints?: number | null, messages?: { __typename?: 'BalanceMessagesData', balance?: string | null, balanceShort?: string | null } | null } | null };

export type LoyaltyInquiryMutationVariables = Exact<{
  input: LoyaltyInquiryInput;
}>;


export type LoyaltyInquiryMutation = { __typename?: 'Mutation', loyaltyInquiryV3: { __typename?: 'CartOutOfStockError' } | { __typename?: 'CustomerLoyaltyError' } | { __typename?: 'LoyaltyInquiryResponse', pointsBalance: number, loyaltyAccountIdentifier?: string | null, redemptions: Array<{ __typename?: 'LoyaltyRedemption', name?: string | null, type: LoyaltyRedemptionType, referenceId?: string | null, redemptionAmount: number, redemptionGuid: string, rewardType?: RewardTypeData | null, target?: number | null, available?: boolean | null, currentState?: { __typename?: 'RewardStateData', leftToTarget?: number | null, messages?: { __typename?: 'RewardMessagesData', nextRewardMessage?: string | null, nextRewardMiniMessage?: string | null, rewardLabelMessage?: string | null, rewardValueMessage?: string | null, unlockedMessage?: string | null } | null } | null }>, currentState?: { __typename?: 'BalanceStateData', balance?: number | null, balancePoints?: number | null, messages?: { __typename?: 'BalanceMessagesData', balance?: string | null, balanceShort?: string | null } | null } | null } };

export type RemoveLoyaltyFromCartMutationVariables = Exact<{
  input: RemoveLoyaltyRedemptionV2Input;
}>;


export type RemoveLoyaltyFromCartMutation = { __typename?: 'Mutation', removeLoyaltyRedemptionV2: { __typename?: 'CartModificationError' } | { __typename?: 'CartOutOfStockError' } | { __typename?: 'CartResponse', cart: { __typename?: 'Cart', guid: string, cartSource?: CartSource | null } } | { __typename?: 'CartValidationError' } };

export type MakeCreditCardPrimaryMutationVariables = Exact<{
  input: MakeCreditCardPrimaryInput;
}>;


export type MakeCreditCardPrimaryMutation = { __typename?: 'Mutation', makeCreditCardPrimary: { __typename?: 'MakeCreditCardPrimaryError', code: MakeCreditCardPrimaryErrorCode, message: string } | { __typename?: 'MakeCreditCardPrimaryResponse', customer: { __typename?: 'Customer', lastName?: string | null, firstName?: string | null, phone?: string | null, email: string, id: string, creditCards: Array<{ __typename?: 'SavedCreditCard', guid: string, cardType: CardType, maskedPan: string, expirationMonth: string, expirationYear: string, isPrimary: boolean }>, addresses: Array<{ __typename?: 'SavedAddress', guid: string, name?: string | null, deliveryInfo: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null } }> } } };

export type MarketingConfigQueryVariables = Exact<{
  input: MarketingConfigQueryInput;
}>;


export type MarketingConfigQuery = { __typename?: 'Query', marketing: { __typename?: 'MarketingQuery', marketingConfig: { __typename: 'MarketingConfigQueryError' } | { __typename: 'MarketingConfigQuerySuccessResponse', smsAccountEnabled: boolean } } };

export type MarketingSubscriptionMutationVariables = Exact<{
  input: CreateMarketingSubscriptionRequestInput;
}>;


export type MarketingSubscriptionMutation = { __typename?: 'Mutation', marketing: { __typename?: 'MarketingMutation', marketingSubscription: { __typename: 'CreateMarketingSubscriptionRequestError', message: string } | { __typename: 'CreateMarketingSubscriptionRequestSuccessResponse', source: string, firstName?: string | null, lastName?: string | null, restaurantGuid: string, subscriptions: Array<{ __typename?: 'CreateMarketingSubscriptionResponse', value: string, channel: string }> } } };

export type MenuItemDetailsQueryVariables = Exact<{
  input: MenuItemDetailsInput;
  nestingLevel?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MenuItemDetailsQuery = { __typename?: 'Query', menuItemDetails: { __typename?: 'MenuItem', description?: string | null, name?: string | null, prices: Array<number>, masterId?: string | null, usesFractionalQuantity?: boolean | null, unitOfMeasure: UnitOfMeasure, contentAdvisories: { __typename?: 'Menus_ContentAdvisories', alcohol?: { __typename?: 'Menus_Alcohol', containsAlcohol?: Menus_ContainsAlcohol | null } | null }, imageUrls?: { __typename?: 'ImageSet', xxl: string, xl: string, large: string, medium: string, small: string, xs: string, raw: string } | null, timeBasedRules?: { __typename?: 'TimeBasedRules', leadTimeRule?: { __typename?: 'LeadTimeRule', leadTime: number } | null, preorderRule?: { __typename?: 'PreorderRule', fulfillmentDateRange?: { __typename?: 'DateTimeRange', start: string, end?: string | null } | null } | null, pickupWindowRule?: { __typename?: 'PickupWindowRule', days: Array<{ __typename?: 'PickupWindowDay', dayOfWeek: DayOfWeek, pickupWindows: Array<{ __typename?: 'PickupWindow', duration: number }> }> } | null } | null, itemTags: Array<{ __typename?: 'Menus_MenuItemTag', guid?: string | null, name?: string | null }>, modifierGroups: Array<{ __typename?: 'ModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'Modifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, modifierGroups: Array<{ __typename?: 'ModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'Modifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, modifierGroups: Array<{ __typename?: 'ModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'Modifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, modifierGroups: Array<{ __typename?: 'ModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'Modifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, modifierGroups: Array<{ __typename?: 'ModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'Modifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, modifierGroups: Array<{ __typename?: 'ModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'Modifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, modifierGroups: Array<{ __typename?: 'ModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'Modifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, modifierGroups: Array<{ __typename?: 'ModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'Modifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, modifierGroups: Array<{ __typename?: 'ModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'Modifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, modifierGroups: Array<{ __typename?: 'ModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'Modifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, modifierGroups: Array<{ __typename?: 'ModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'Modifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> } };

export type MenuItemFragmentFragment = { __typename?: 'MenuItem', guid: string, outOfStock?: boolean | null, itemGroupGuid: string, name?: string | null, description?: string | null, prices: Array<number>, defaultModifiersPrice?: number | null, masterId?: string | null, unitOfMeasure: UnitOfMeasure, usesFractionalQuantity?: boolean | null, imageUrls?: { __typename?: 'ImageSet', xxl: string, xl: string, large: string, medium: string, small: string, xs: string, raw: string } | null, timeBasedRules?: { __typename?: 'TimeBasedRules', leadTimeRule?: { __typename?: 'LeadTimeRule', leadTime: number } | null, preorderRule?: { __typename?: 'PreorderRule', fulfillmentDateRange?: { __typename?: 'DateTimeRange', start: string, end?: string | null } | null, orderDateRange?: { __typename?: 'DateTimeRange', start: string, end?: string | null } | null } | null, pickupWindowRule?: { __typename?: 'PickupWindowRule', days: Array<{ __typename?: 'PickupWindowDay', dayOfWeek: DayOfWeek, pickupWindows: Array<{ __typename?: 'PickupWindow', duration: number }> }> } | null } | null, itemTags: Array<{ __typename?: 'Menus_MenuItemTag', guid?: string | null, name?: string | null }> };

export type MenuItemFromCartQueryVariables = Exact<{
  input: SelectionItemDetailsInput;
  nestingLevel?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MenuItemFromCartQuery = { __typename?: 'Query', selectionItemDetails: { __typename?: 'SelectionItem', description?: string | null, name?: string | null, quantity?: number | null, itemGuid: string, itemGroupGuid: string, specialRequest?: string | null, menuItemPrice?: number | null, selectionItemPrice?: number | null, usesFractionalQuantity: boolean, imageUrls?: { __typename?: 'ImageSet', xxl: string, xl: string, large: string, medium: string, small: string, xs: string, raw: string } | null, fractionalQuantity: { __typename?: 'FractionalQuantity', unitOfMeasure: UnitOfMeasure, quantity: number }, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> } };

export type ModifierGroupFieldsFragment = { __typename?: 'ModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string };

export type ModifierFieldsFragment = { __typename?: 'Modifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null };

export type SelectionModifierGroupFieldsFragment = { __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string };

export type SelectionModifierFieldsFragment = { __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null };

export type OoAvailabilityQueryVariables = Exact<{
  restaurantGuid: Scalars['ID']['input'];
  fulfillmentDaysAhead?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OoAvailabilityQuery = { __typename?: 'Query', restaurantV2: { __typename?: 'GeneralError' } | { __typename?: 'Restaurant', onlineOrderingEnabled?: boolean | null }, diningOptions: Array<{ __typename?: 'DiningOption', behavior: DiningOptionBehavior, asapSchedule?: { __typename?: 'AsapSchedule', availableNow: boolean } | null, futureSchedule?: { __typename?: 'FutureSchedule', dates: Array<{ __typename?: 'FutureFulfillmentDate', date: string, times: Array<{ __typename?: 'FutureFulfillmentTime', time: string }> }> } | null }> };

export type SelectionFieldsFragment = { __typename?: 'Selection', name?: string | null, guid?: string | null, preDiscountPrice?: number | null, price?: number | null, optionGroupGuid?: string | null, receiptLinePrice?: number | null, groupingKey?: string | null };

export type FractionalQuantityFieldsFragment = { __typename?: 'FractionalQuantity', unitOfMeasure: UnitOfMeasure, quantity: number };

export type ParentSelectionFieldsFragment = { __typename?: 'Selection', itemGuid?: string | null, usesFractionalQuantity: boolean, quantity?: number | null, itemGroupGuid?: string | null, name?: string | null, guid?: string | null, preDiscountPrice?: number | null, price?: number | null, optionGroupGuid?: string | null, receiptLinePrice?: number | null, groupingKey?: string | null, fractionalQuantity: { __typename?: 'FractionalQuantity', unitOfMeasure: UnitOfMeasure, quantity: number }, appliedDiscounts?: Array<{ __typename?: 'Discounts', name?: string | null, discountAmount?: number | null, restaurantDiscount?: { __typename?: 'RestaurantDiscount', promoCode: string } | null, loyaltyDiscounts?: Array<{ __typename?: 'LoyaltyDiscount', guid: string, amount: number, type: LoyaltyRedemptionType, referenceId?: string | null, name?: string | null } | null> | null, globalReward?: { __typename?: 'AppliedCustomerReward', amount?: number | null, name?: string | null, rewardType?: RewardType | null, total?: number | null } | null, loyaltyDetails?: { __typename?: 'LoyaltyDetails', vendor?: string | null, referenceId?: string | null } | null, discount?: { __typename?: 'DiscountDetails', guid: string, entityType: string } | null }> | null, modifiers?: Array<{ __typename?: 'Selection', name?: string | null, guid?: string | null, preDiscountPrice?: number | null, price?: number | null, optionGroupGuid?: string | null, receiptLinePrice?: number | null, groupingKey?: string | null, modifiers?: Array<{ __typename?: 'Selection', name?: string | null, guid?: string | null, preDiscountPrice?: number | null, price?: number | null, optionGroupGuid?: string | null, receiptLinePrice?: number | null, groupingKey?: string | null, modifiers?: Array<{ __typename?: 'Selection', name?: string | null, guid?: string | null, preDiscountPrice?: number | null, price?: number | null, optionGroupGuid?: string | null, receiptLinePrice?: number | null, groupingKey?: string | null } | null> | null } | null> | null } | null> | null };

export type DeliveryInfoFieldsFragment = { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null, administrativeArea?: string | null, country?: string | null };

export type DiscountsFieldsFragment = { __typename?: 'Discounts', name?: string | null, discountAmount?: number | null, restaurantDiscount?: { __typename?: 'RestaurantDiscount', promoCode: string } | null, loyaltyDiscounts?: Array<{ __typename?: 'LoyaltyDiscount', guid: string, amount: number, type: LoyaltyRedemptionType, referenceId?: string | null, name?: string | null } | null> | null, globalReward?: { __typename?: 'AppliedCustomerReward', amount?: number | null, name?: string | null, rewardType?: RewardType | null, total?: number | null } | null, loyaltyDetails?: { __typename?: 'LoyaltyDetails', vendor?: string | null, referenceId?: string | null } | null, discount?: { __typename?: 'DiscountDetails', guid: string, entityType: string } | null };

export type CompletedOrderSelectionFieldsFragment = { __typename?: 'CompletedOrderSelection', externalId?: string | null, price: number, preDiscountPrice?: number | null, quantity: number, receiptLinePrice?: number | null, usesFractionalQuantity: boolean, name: string, fractionalQuantity: { __typename?: 'FractionalQuantity', unitOfMeasure: UnitOfMeasure, quantity: number }, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string }> }> }> };

export type CompletedOrderFieldsFragment = { __typename?: 'CompletedOrder', guid: string, approvalStatus?: OrderApprovalStatus | null, checkGuid: string, checkNumber?: number | null, estimatedFulfillmentDate?: number | null, guestCommunication?: string | null, diningOptionBehavior: DiningOptionBehavior, numberOfSelections: number, preDiscountItemsSubtotal: number, discountsTotal: number, deliveryServiceCharges: number, processingServiceCharges: number, gratuityServiceCharges: number, nonDeliveryNonGratuityNonUbpServiceCharges: number, fundraisingTotal?: number | null, taxV2: number, tip: number, totalV2: number, hasLoyaltyAttached: boolean, paymentType: PaymentType, customerV3?: { __typename?: 'CustomerInfoV2', firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null } | null, restaurant: { __typename?: 'Restaurant', guid: string, name: string, location: { __typename?: 'Location', address1: string, address2?: string | null, city: string, state: string, zip: string, phone: string, latitude?: number | null, longitude?: number | null }, loyaltyConfig: { __typename?: 'LoyaltyConfig', loyaltySignupEnabled: boolean, loyaltyRedemptionEnabled: boolean, programName?: string | null, rewardType?: RewardRedemptionType | null } }, curbsidePickup?: { __typename?: 'CurbsidePickup', selected: boolean } | null, curbsidePickupV2?: { __typename?: 'CurbsidePickupV2', notes?: string | null } | null, deliveryInfo?: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null, administrativeArea?: string | null, country?: string | null } | null, deliveryServiceInfo?: { __typename?: 'DeliveryServiceInfo', providerName?: string | null } | null, selections: Array<{ __typename?: 'CompletedOrderSelection', externalId?: string | null, price: number, preDiscountPrice?: number | null, quantity: number, receiptLinePrice?: number | null, usesFractionalQuantity: boolean, name: string, fractionalQuantity: { __typename?: 'FractionalQuantity', unitOfMeasure: UnitOfMeasure, quantity: number }, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string }> }> }> }>, discounts: { __typename?: 'Discounts', name?: string | null, discountAmount?: number | null, restaurantDiscount?: { __typename?: 'RestaurantDiscount', promoCode: string } | null, loyaltyDiscounts?: Array<{ __typename?: 'LoyaltyDiscount', guid: string, amount: number, type: LoyaltyRedemptionType, referenceId?: string | null, name?: string | null } | null> | null, globalReward?: { __typename?: 'AppliedCustomerReward', amount?: number | null, name?: string | null, rewardType?: RewardType | null, total?: number | null } | null, loyaltyDetails?: { __typename?: 'LoyaltyDetails', vendor?: string | null, referenceId?: string | null } | null, discount?: { __typename?: 'DiscountDetails', guid: string, entityType: string } | null }, surchargeServiceCharges: { __typename?: 'SurchargeAmounts', baseAmount: number, taxAmount: number, rate?: number | null }, packagingSelections: Array<{ __typename?: 'PackagingSelection', guid: string, inclusion: PackagingInclusion, guestDisplayName: string }>, giftCard?: { __typename?: 'GiftCardPayment', appliedBalance: number } | null };

export type SurchargeFieldsFragment = { __typename?: 'SurchargeSummaryResponse', paymentTypes: Array<PaymentType>, surchargePreTaxAmount: number, surchargeRate: number, surchargeTaxAmount: number };

export type OrderHistoryQueryVariables = Exact<{
  input: OrderHistoryInput;
}>;


export type OrderHistoryQuery = { __typename?: 'Query', orderHistory: { __typename?: 'OrderHistoryResponse', nextPageToken?: string | null, orders: Array<{ __typename?: 'CompletedOrder', guid: string, totalV2: number, estimatedFulfillmentDate?: number | null, numberOfSelections: number, selections: Array<{ __typename?: 'CompletedOrderSelection', name: string, quantity: number, price: number }> }> } };

export type GetOrderStatusesQueryVariables = Exact<{
  input: OrderStatusesInput;
}>;


export type GetOrderStatusesQuery = { __typename?: 'Query', orderStatuses: { __typename?: 'OrderStatusesResponse', orderStatusesResponse?: Array<{ __typename?: 'OrderStatusData', orderGuid: string, restaurantGuid: string, firstName?: string | null, lastNameInitial?: string | null, guestOrderStatus?: OrderStatusType | null, checkDisplayNumber?: string | null, channelGuid?: string | null, lastUpdated?: string | null, version?: string | null, estimatedFulfillmentDate?: string | null, deliveryStatus?: ThirdPartyDeliveryStatus | null, diningOption: { __typename?: 'DiningOption', guid: string, behavior: DiningOptionBehavior, description: string }, trackingDetails?: { __typename?: 'TrackingDetails', quotedPickUpTime?: string | null, quotedDeliveryTime?: string | null, estimatedPickUpTime?: string | null, estimatedDeliveryTime?: string | null, actualDeliveryTime?: string | null, deliveryProviderName?: string | null, dropOffImageUrl?: string | null, trackingUrl?: string | null, deliveryTimeException?: DeliveryTimeException | null, deliveryDriver?: { __typename?: 'DeliveryDriver', name: string, phoneNumber?: string | null, profileImageUrl?: string | null } | null, driverLocation?: { __typename?: 'DeliveryDriverLocation', latitude: number, longitude: number } | null } | null }> | null } };

export type PaginatedMenuItemsQueryVariables = Exact<{
  input: PaginatedMenusInput;
}>;


export type PaginatedMenuItemsQuery = { __typename?: 'Query', paginatedMenuItems: { __typename?: 'PaginatedMenus', totalCount: number, count: number, menus?: Array<{ __typename?: 'Menu', name?: string | null, guid: string, groups?: Array<{ __typename?: 'MenuGroup', name?: string | null, description?: string | null, guid: string, items?: Array<{ __typename?: 'MenuItem', guid: string, outOfStock?: boolean | null, itemGroupGuid: string, name?: string | null, description?: string | null, prices: Array<number>, defaultModifiersPrice?: number | null, masterId?: string | null, unitOfMeasure: UnitOfMeasure, usesFractionalQuantity?: boolean | null, imageUrls?: { __typename?: 'ImageSet', xxl: string, xl: string, large: string, medium: string, small: string, xs: string, raw: string } | null, timeBasedRules?: { __typename?: 'TimeBasedRules', leadTimeRule?: { __typename?: 'LeadTimeRule', leadTime: number } | null, preorderRule?: { __typename?: 'PreorderRule', fulfillmentDateRange?: { __typename?: 'DateTimeRange', start: string, end?: string | null } | null, orderDateRange?: { __typename?: 'DateTimeRange', start: string, end?: string | null } | null } | null, pickupWindowRule?: { __typename?: 'PickupWindowRule', days: Array<{ __typename?: 'PickupWindowDay', dayOfWeek: DayOfWeek, pickupWindows: Array<{ __typename?: 'PickupWindow', duration: number }> }> } | null } | null, itemTags: Array<{ __typename?: 'Menus_MenuItemTag', guid?: string | null, name?: string | null }> } | null> | null } | null> | null }> | null, items?: Array<{ __typename?: 'MenuItem', guid: string, outOfStock?: boolean | null, itemGroupGuid: string, name?: string | null, description?: string | null, prices: Array<number>, defaultModifiersPrice?: number | null, masterId?: string | null, unitOfMeasure: UnitOfMeasure, usesFractionalQuantity?: boolean | null, imageUrls?: { __typename?: 'ImageSet', xxl: string, xl: string, large: string, medium: string, small: string, xs: string, raw: string } | null, timeBasedRules?: { __typename?: 'TimeBasedRules', leadTimeRule?: { __typename?: 'LeadTimeRule', leadTime: number } | null, preorderRule?: { __typename?: 'PreorderRule', fulfillmentDateRange?: { __typename?: 'DateTimeRange', start: string, end?: string | null } | null, orderDateRange?: { __typename?: 'DateTimeRange', start: string, end?: string | null } | null } | null, pickupWindowRule?: { __typename?: 'PickupWindowRule', days: Array<{ __typename?: 'PickupWindowDay', dayOfWeek: DayOfWeek, pickupWindows: Array<{ __typename?: 'PickupWindow', duration: number }> }> } | null } | null, itemTags: Array<{ __typename?: 'Menus_MenuItemTag', guid?: string | null, name?: string | null }> }> | null, groupings?: Array<{ __typename?: 'MenuGrouping', name: string, guid: string, itemCount: number, children?: Array<{ __typename?: 'MenuGrouping', name: string, guid: string, itemCount: number, children?: Array<{ __typename?: 'MenuGrouping', name: string, guid: string, itemCount: number }> | null }> | null }> | null } };

export type PaginatedMenuItemsWithPopularItemsQueryVariables = Exact<{
  input: PaginatedMenusInput;
  popularItemsInput: PopularItemsInput;
}>;


export type PaginatedMenuItemsWithPopularItemsQuery = { __typename?: 'Query', paginatedMenuItems: { __typename?: 'PaginatedMenus', totalCount: number, count: number, menus?: Array<{ __typename?: 'Menu', name?: string | null, guid: string, groups?: Array<{ __typename?: 'MenuGroup', name?: string | null, description?: string | null, guid: string, items?: Array<{ __typename?: 'MenuItem', guid: string, outOfStock?: boolean | null, itemGroupGuid: string, name?: string | null, description?: string | null, prices: Array<number>, defaultModifiersPrice?: number | null, masterId?: string | null, unitOfMeasure: UnitOfMeasure, usesFractionalQuantity?: boolean | null, imageUrls?: { __typename?: 'ImageSet', xxl: string, xl: string, large: string, medium: string, small: string, xs: string, raw: string } | null, timeBasedRules?: { __typename?: 'TimeBasedRules', leadTimeRule?: { __typename?: 'LeadTimeRule', leadTime: number } | null, preorderRule?: { __typename?: 'PreorderRule', fulfillmentDateRange?: { __typename?: 'DateTimeRange', start: string, end?: string | null } | null, orderDateRange?: { __typename?: 'DateTimeRange', start: string, end?: string | null } | null } | null, pickupWindowRule?: { __typename?: 'PickupWindowRule', days: Array<{ __typename?: 'PickupWindowDay', dayOfWeek: DayOfWeek, pickupWindows: Array<{ __typename?: 'PickupWindow', duration: number }> }> } | null } | null, itemTags: Array<{ __typename?: 'Menus_MenuItemTag', guid?: string | null, name?: string | null }> } | null> | null } | null> | null }> | null, items?: Array<{ __typename?: 'MenuItem', guid: string, outOfStock?: boolean | null, itemGroupGuid: string, name?: string | null, description?: string | null, prices: Array<number>, defaultModifiersPrice?: number | null, masterId?: string | null, unitOfMeasure: UnitOfMeasure, usesFractionalQuantity?: boolean | null, imageUrls?: { __typename?: 'ImageSet', xxl: string, xl: string, large: string, medium: string, small: string, xs: string, raw: string } | null, timeBasedRules?: { __typename?: 'TimeBasedRules', leadTimeRule?: { __typename?: 'LeadTimeRule', leadTime: number } | null, preorderRule?: { __typename?: 'PreorderRule', fulfillmentDateRange?: { __typename?: 'DateTimeRange', start: string, end?: string | null } | null, orderDateRange?: { __typename?: 'DateTimeRange', start: string, end?: string | null } | null } | null, pickupWindowRule?: { __typename?: 'PickupWindowRule', days: Array<{ __typename?: 'PickupWindowDay', dayOfWeek: DayOfWeek, pickupWindows: Array<{ __typename?: 'PickupWindow', duration: number }> }> } | null } | null, itemTags: Array<{ __typename?: 'Menus_MenuItemTag', guid?: string | null, name?: string | null }> }> | null, groupings?: Array<{ __typename?: 'MenuGrouping', name: string, guid: string, itemCount: number, children?: Array<{ __typename?: 'MenuGrouping', name: string, guid: string, itemCount: number, children?: Array<{ __typename?: 'MenuGrouping', name: string, guid: string, itemCount: number }> | null }> | null }> | null }, popularItems: { __typename: 'PopularItemsError', message: string } | { __typename: 'PopularItemsResponse', items: Array<{ __typename?: 'MenuItem', guid: string, itemGroupGuid: string, name?: string | null, description?: string | null, prices: Array<number>, defaultModifiersPrice?: number | null, masterId?: string | null, imageUrls?: { __typename?: 'ImageSet', xxl: string, xl: string, large: string, medium: string, small: string, xs: string, raw: string } | null, timeBasedRules?: { __typename?: 'TimeBasedRules', leadTimeRule?: { __typename?: 'LeadTimeRule', leadTime: number } | null, preorderRule?: { __typename?: 'PreorderRule', fulfillmentDateRange?: { __typename?: 'DateTimeRange', start: string, end?: string | null } | null, orderDateRange?: { __typename?: 'DateTimeRange', start: string, end?: string | null } | null } | null, pickupWindowRule?: { __typename?: 'PickupWindowRule', days: Array<{ __typename?: 'PickupWindowDay', dayOfWeek: DayOfWeek, pickupWindows: Array<{ __typename?: 'PickupWindow', duration: number }> }> } | null } | null, itemTags: Array<{ __typename?: 'Menus_MenuItemTag', guid?: string | null, name?: string | null }> }> } };

export type PayForCheckMutationVariables = Exact<{
  input: PayForCheckInput;
}>;


export type PayForCheckMutation = { __typename?: 'Mutation', payForCheck: { __typename?: 'PayForCheckError', code: PayForCheckErrorCode, message: string } | { __typename?: 'PayForCheckResponse', remainingChecks: Array<{ __typename?: 'InProgressOrderCheck', guid: string }> } };

export type CreateGiftCardPaymentIntentMutationVariables = Exact<{
  input: OnlineOrderingSpiCreateGiftCardPaymentIntentInput;
}>;


export type CreateGiftCardPaymentIntentMutation = { __typename?: 'Mutation', oo: { __typename?: 'OnlineOrderingMutation', spiCreateGiftCardPaymentIntent: { __typename?: 'OnlineOrderingPaymentIntentError', message: string } | { __typename?: 'OnlineOrderingSpiCreatePaymentIntentSuccessResponse', amount: number, captureMethod: string, creationDate: string, currency: string, externalReferenceId: string, id: string, sessionSecret: string, status: string } } };

export type CreatePaymentIntentMutationVariables = Exact<{
  input: OnlineOrderingSpiCreatePaymentIntentInput;
}>;


export type CreatePaymentIntentMutation = { __typename?: 'Mutation', oo: { __typename?: 'OnlineOrderingMutation', spiCreatePaymentIntent: { __typename?: 'OnlineOrderingPaymentIntentError', message: string } | { __typename?: 'OnlineOrderingSpiCreatePaymentIntentSuccessResponse', amount: number, captureMethod: string, creationDate: string, currency: string, externalReferenceId: string, id: string, sessionSecret: string, status: string } } };

export type GetClientTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientTokenQuery = { __typename?: 'Query', oo: { __typename?: 'OnlineOrderingQuery', spiGetClientToken: { __typename?: 'OnlineOrderingPaymentIntentError', message: string } | { __typename?: 'OnlineOrderingSpiGetClientTokenSuccessResponse', token: string } } };

export type UpdateGiftCardPaymentIntentMutationVariables = Exact<{
  input: OnlineOrderingSpiUpdateGiftCardPaymentIntentInput;
}>;


export type UpdateGiftCardPaymentIntentMutation = { __typename?: 'Mutation', oo: { __typename?: 'OnlineOrderingMutation', spiUpdateGiftCardPaymentIntent: { __typename?: 'OnlineOrderingPaymentIntentError', message: string } | { __typename?: 'OnlineOrderingSpiUpdatePaymentIntentSuccessResponse', guestGuid?: string | null, intentAmount: number } } };

export type UpdatePaymentIntentMutationVariables = Exact<{
  input: OnlineOrderingSpiUpdatePaymentIntentInput;
}>;


export type UpdatePaymentIntentMutation = { __typename?: 'Mutation', oo: { __typename?: 'OnlineOrderingMutation', spiUpdatePaymentIntent: { __typename?: 'OnlineOrderingPaymentIntentError', message: string } | { __typename?: 'OnlineOrderingSpiUpdatePaymentIntentSuccessResponse', guestGuid?: string | null, intentAmount: number, surchargeAmount?: number | null } } };

export type PlaceCashOrderMutationVariables = Exact<{
  input: PlaceCashOrderInput;
}>;


export type PlaceCashOrderMutation = { __typename?: 'Mutation', placeOrder: { __typename?: 'PlaceOrderCartUpdatedError', message: string, placeOrderCartUpdatedErrorCode: PlaceOrderCartUpdatedErrorCode, cart: { __typename?: 'Cart', guid: string } } | { __typename?: 'PlaceOrderError', message: string, placeOrderErrorCode: PlaceOrderErrorCode } | { __typename?: 'PlaceOrderOutOfStockError' } | { __typename?: 'PlaceOrderResponse', completedOrder: { __typename?: 'CompletedOrder', guid: string, approvalStatus?: OrderApprovalStatus | null, checkGuid: string, checkNumber?: number | null, estimatedFulfillmentDate?: number | null, guestCommunication?: string | null, diningOptionBehavior: DiningOptionBehavior, numberOfSelections: number, preDiscountItemsSubtotal: number, discountsTotal: number, deliveryServiceCharges: number, processingServiceCharges: number, gratuityServiceCharges: number, nonDeliveryNonGratuityNonUbpServiceCharges: number, fundraisingTotal?: number | null, taxV2: number, tip: number, totalV2: number, hasLoyaltyAttached: boolean, paymentType: PaymentType, customerV3?: { __typename?: 'CustomerInfoV2', firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null } | null, restaurant: { __typename?: 'Restaurant', guid: string, name: string, location: { __typename?: 'Location', address1: string, address2?: string | null, city: string, state: string, zip: string, phone: string, latitude?: number | null, longitude?: number | null }, loyaltyConfig: { __typename?: 'LoyaltyConfig', loyaltySignupEnabled: boolean, loyaltyRedemptionEnabled: boolean, programName?: string | null, rewardType?: RewardRedemptionType | null } }, curbsidePickup?: { __typename?: 'CurbsidePickup', selected: boolean } | null, curbsidePickupV2?: { __typename?: 'CurbsidePickupV2', notes?: string | null } | null, deliveryInfo?: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null, administrativeArea?: string | null, country?: string | null } | null, deliveryServiceInfo?: { __typename?: 'DeliveryServiceInfo', providerName?: string | null } | null, selections: Array<{ __typename?: 'CompletedOrderSelection', externalId?: string | null, price: number, preDiscountPrice?: number | null, quantity: number, receiptLinePrice?: number | null, usesFractionalQuantity: boolean, name: string, fractionalQuantity: { __typename?: 'FractionalQuantity', unitOfMeasure: UnitOfMeasure, quantity: number }, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string }> }> }> }>, discounts: { __typename?: 'Discounts', name?: string | null, discountAmount?: number | null, restaurantDiscount?: { __typename?: 'RestaurantDiscount', promoCode: string } | null, loyaltyDiscounts?: Array<{ __typename?: 'LoyaltyDiscount', guid: string, amount: number, type: LoyaltyRedemptionType, referenceId?: string | null, name?: string | null } | null> | null, globalReward?: { __typename?: 'AppliedCustomerReward', amount?: number | null, name?: string | null, rewardType?: RewardType | null, total?: number | null } | null, loyaltyDetails?: { __typename?: 'LoyaltyDetails', vendor?: string | null, referenceId?: string | null } | null, discount?: { __typename?: 'DiscountDetails', guid: string, entityType: string } | null }, surchargeServiceCharges: { __typename?: 'SurchargeAmounts', baseAmount: number, taxAmount: number, rate?: number | null }, packagingSelections: Array<{ __typename?: 'PackagingSelection', guid: string, inclusion: PackagingInclusion, guestDisplayName: string }>, giftCard?: { __typename?: 'GiftCardPayment', appliedBalance: number } | null } } };

export type PlaceCcOrderMutationVariables = Exact<{
  input: PlaceCcOrderInput;
}>;


export type PlaceCcOrderMutation = { __typename?: 'Mutation', placeOrder: { __typename?: 'PlaceOrderCartUpdatedError', message: string, placeOrderCartUpdatedErrorCode: PlaceOrderCartUpdatedErrorCode, cart: { __typename?: 'Cart', guid: string } } | { __typename?: 'PlaceOrderError', message: string, placeOrderErrorCode: PlaceOrderErrorCode } | { __typename?: 'PlaceOrderOutOfStockError' } | { __typename?: 'PlaceOrderResponse', completedOrder: { __typename?: 'CompletedOrder', guid: string, approvalStatus?: OrderApprovalStatus | null, checkGuid: string, checkNumber?: number | null, estimatedFulfillmentDate?: number | null, guestCommunication?: string | null, diningOptionBehavior: DiningOptionBehavior, numberOfSelections: number, preDiscountItemsSubtotal: number, discountsTotal: number, deliveryServiceCharges: number, processingServiceCharges: number, gratuityServiceCharges: number, nonDeliveryNonGratuityNonUbpServiceCharges: number, fundraisingTotal?: number | null, taxV2: number, tip: number, totalV2: number, hasLoyaltyAttached: boolean, paymentType: PaymentType, customerV3?: { __typename?: 'CustomerInfoV2', firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null } | null, restaurant: { __typename?: 'Restaurant', guid: string, name: string, location: { __typename?: 'Location', address1: string, address2?: string | null, city: string, state: string, zip: string, phone: string, latitude?: number | null, longitude?: number | null }, loyaltyConfig: { __typename?: 'LoyaltyConfig', loyaltySignupEnabled: boolean, loyaltyRedemptionEnabled: boolean, programName?: string | null, rewardType?: RewardRedemptionType | null } }, curbsidePickup?: { __typename?: 'CurbsidePickup', selected: boolean } | null, curbsidePickupV2?: { __typename?: 'CurbsidePickupV2', notes?: string | null } | null, deliveryInfo?: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null, administrativeArea?: string | null, country?: string | null } | null, deliveryServiceInfo?: { __typename?: 'DeliveryServiceInfo', providerName?: string | null } | null, selections: Array<{ __typename?: 'CompletedOrderSelection', externalId?: string | null, price: number, preDiscountPrice?: number | null, quantity: number, receiptLinePrice?: number | null, usesFractionalQuantity: boolean, name: string, fractionalQuantity: { __typename?: 'FractionalQuantity', unitOfMeasure: UnitOfMeasure, quantity: number }, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string }> }> }> }>, discounts: { __typename?: 'Discounts', name?: string | null, discountAmount?: number | null, restaurantDiscount?: { __typename?: 'RestaurantDiscount', promoCode: string } | null, loyaltyDiscounts?: Array<{ __typename?: 'LoyaltyDiscount', guid: string, amount: number, type: LoyaltyRedemptionType, referenceId?: string | null, name?: string | null } | null> | null, globalReward?: { __typename?: 'AppliedCustomerReward', amount?: number | null, name?: string | null, rewardType?: RewardType | null, total?: number | null } | null, loyaltyDetails?: { __typename?: 'LoyaltyDetails', vendor?: string | null, referenceId?: string | null } | null, discount?: { __typename?: 'DiscountDetails', guid: string, entityType: string } | null }, surchargeServiceCharges: { __typename?: 'SurchargeAmounts', baseAmount: number, taxAmount: number, rate?: number | null }, packagingSelections: Array<{ __typename?: 'PackagingSelection', guid: string, inclusion: PackagingInclusion, guestDisplayName: string }>, giftCard?: { __typename?: 'GiftCardPayment', appliedBalance: number } | null } } };

export type PlacePaidOrderMutationVariables = Exact<{
  input: PlacePaidOrderInput;
}>;


export type PlacePaidOrderMutation = { __typename?: 'Mutation', placeOrder: { __typename?: 'PlaceOrderCartUpdatedError', message: string, placeOrderCartUpdatedErrorCode: PlaceOrderCartUpdatedErrorCode, cart: { __typename?: 'Cart', guid: string } } | { __typename?: 'PlaceOrderError', message: string, placeOrderErrorCode: PlaceOrderErrorCode } | { __typename?: 'PlaceOrderOutOfStockError' } | { __typename?: 'PlaceOrderResponse', completedOrder: { __typename?: 'CompletedOrder', guid: string, approvalStatus?: OrderApprovalStatus | null, checkGuid: string, checkNumber?: number | null, estimatedFulfillmentDate?: number | null, guestCommunication?: string | null, diningOptionBehavior: DiningOptionBehavior, numberOfSelections: number, preDiscountItemsSubtotal: number, discountsTotal: number, deliveryServiceCharges: number, processingServiceCharges: number, gratuityServiceCharges: number, nonDeliveryNonGratuityNonUbpServiceCharges: number, fundraisingTotal?: number | null, taxV2: number, tip: number, totalV2: number, hasLoyaltyAttached: boolean, paymentType: PaymentType, customerV3?: { __typename?: 'CustomerInfoV2', firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null } | null, restaurant: { __typename?: 'Restaurant', guid: string, name: string, location: { __typename?: 'Location', address1: string, address2?: string | null, city: string, state: string, zip: string, phone: string, latitude?: number | null, longitude?: number | null }, loyaltyConfig: { __typename?: 'LoyaltyConfig', loyaltySignupEnabled: boolean, loyaltyRedemptionEnabled: boolean, programName?: string | null, rewardType?: RewardRedemptionType | null } }, curbsidePickup?: { __typename?: 'CurbsidePickup', selected: boolean } | null, curbsidePickupV2?: { __typename?: 'CurbsidePickupV2', notes?: string | null } | null, deliveryInfo?: { __typename?: 'DeliveryInfo', address1: string, address2?: string | null, city: string, state: string, zipCode: string, latitude: number, longitude: number, notes?: string | null, administrativeArea?: string | null, country?: string | null } | null, deliveryServiceInfo?: { __typename?: 'DeliveryServiceInfo', providerName?: string | null } | null, selections: Array<{ __typename?: 'CompletedOrderSelection', externalId?: string | null, price: number, preDiscountPrice?: number | null, quantity: number, receiptLinePrice?: number | null, usesFractionalQuantity: boolean, name: string, fractionalQuantity: { __typename?: 'FractionalQuantity', unitOfMeasure: UnitOfMeasure, quantity: number }, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string, modifiers: Array<{ __typename?: 'CompletedOrderModifierSelection', name: string }> }> }> }>, discounts: { __typename?: 'Discounts', name?: string | null, discountAmount?: number | null, restaurantDiscount?: { __typename?: 'RestaurantDiscount', promoCode: string } | null, loyaltyDiscounts?: Array<{ __typename?: 'LoyaltyDiscount', guid: string, amount: number, type: LoyaltyRedemptionType, referenceId?: string | null, name?: string | null } | null> | null, globalReward?: { __typename?: 'AppliedCustomerReward', amount?: number | null, name?: string | null, rewardType?: RewardType | null, total?: number | null } | null, loyaltyDetails?: { __typename?: 'LoyaltyDetails', vendor?: string | null, referenceId?: string | null } | null, discount?: { __typename?: 'DiscountDetails', guid: string, entityType: string } | null }, surchargeServiceCharges: { __typename?: 'SurchargeAmounts', baseAmount: number, taxAmount: number, rate?: number | null }, packagingSelections: Array<{ __typename?: 'PackagingSelection', guid: string, inclusion: PackagingInclusion, guestDisplayName: string }>, giftCard?: { __typename?: 'GiftCardPayment', appliedBalance: number } | null } } };

export type PromoBannersQueryVariables = Exact<{
  restaurantGuid: Scalars['ID']['input'];
}>;


export type PromoBannersQuery = { __typename?: 'Query', promoBanners: { __typename?: 'GeneralError' } | { __typename?: 'PromoBannerResponse', promoCodeBanners: Array<{ __typename?: 'PromoCodeBanner', bannerGuid: string, bannerText: string, promoCode: string }>, loyaltyBanners: Array<{ __typename?: 'LoyaltyBanner', bannerGuid: string, bannerText: string, availability?: { __typename?: 'PromoBannerAvailability', time?: { __typename?: 'PromoBannerAvailabilityTime', startTime: string, endTime: string } | null } | null }>, deliveryBanners: Array<{ __typename?: 'DeliveryBanner', bannerGuid: string, bannerText: string }> } };

export type RankedPromoOfferQueryVariables = Exact<{
  input: RankedPromoOffersInput;
}>;


export type RankedPromoOfferQuery = { __typename?: 'Query', offers: { __typename?: 'OffersQuery', rankedPromoOffers: { __typename?: 'RankedPromoOffersError', message: string } | { __typename?: 'RankedPromoOffersResponse', restaurantGuid: string, cartGuid?: string | null, rankedDiscounts: Array<{ __typename: 'RankedPromoOfferDiscount', id: string, bannerGuid: string, bannerText: string, offerDescription?: string | null, promoCode: string, type: string, percentCompleteInt: number, discountEntitiesClaimed: boolean, amountNeeded: number, estimatedSavings: number, buyEntities?: { __typename?: 'RankedPromoOfferBuyEntities', items?: Array<string> | null, groups?: Array<string> | null, menus?: Array<string> | null } | null, discountEntities?: { __typename?: 'RankedPromoOfferDiscountEntities', items?: Array<string> | null, groups?: Array<string> | null, menus?: Array<string> | null } | null, discount?: { __typename?: 'RankedPromoOfferCustomDiscount', guid: string, name: string, selectionType: string, amountType: string, discountValue?: number | null, minSpendAmount?: number | null, active: boolean, displayChannels?: Array<string> | null, triggerMenuItems?: Array<string> | null, triggerMenuGroups?: Array<string> | null, triggerMenus?: Array<string> | null, promoCodes?: Array<{ __typename?: 'RankedPromoOfferDiscountPromoCode', promoCodeId: string, code: string, startDate?: string | null, endDate?: string | null, singleUse?: boolean | null, banners?: Array<{ __typename?: 'RankedPromoOfferDiscountPromoBanner', guid: string, bannerText: string, bannerStartDate?: string | null, bannerEndDate?: string | null, status: string }> | null }> | null, bogoAction?: { __typename?: 'RankedPromoOfferDiscountBogoAction', bogoActionId: string, amountType: string, discountValue?: number | null, perItem: boolean, numberOfFreeItems: number, items?: Array<string> | null, groups?: Array<string> | null, menus?: Array<string> | null } | null, availability?: { __typename?: 'RankedPromoOfferDiscountAvailability', daysOfWeek?: Array<number> | null } | null } | null }> } } };

export type RemovePromoCodeMutationVariables = Exact<{
  input: RemovePromoCodeInputV2;
}>;


export type RemovePromoCodeMutation = { __typename?: 'Mutation', removePromoCodeV2: { __typename?: 'CartModificationError', code: CartModificationErrorCode, message: string } | { __typename?: 'CartOutOfStockError', message: string, items: Array<{ __typename?: 'CartOutOfStockItem', name?: string | null, guid?: string | null }> } | { __typename?: 'CartResponse', cart: { __typename?: 'Cart', guid: string, cartSource?: CartSource | null, order?: { __typename?: 'Order', discountsTotal: number } | null } } };

export type ReorderMutationVariables = Exact<{
  input: ReorderInput;
}>;


export type ReorderMutation = { __typename?: 'Mutation', reorderV2?: { __typename?: 'ReorderError', code: ReorderErrorCode, message: string } | { __typename?: 'ReorderResponse', cart: { __typename?: 'Cart', expiredDate: number, guid: string }, warningsV2: Array<{ __typename?: 'ReorderWarning', code: ReorderWarningCode, message: string }>, outOfStockItems: Array<{ __typename?: 'CartOutOfStockItem', name?: string | null, guid?: string | null }> } | null };

export type ReorderableItemsQueryVariables = Exact<{
  input: ReorderableItemsInput;
}>;


export type ReorderableItemsQuery = { __typename?: 'Query', reorderableItems: { __typename?: 'ReorderableItemsResponse', currentPageToken?: string | null, nextPageToken?: string | null, items: Array<{ __typename?: 'ReorderableItem', orderGuid: string, imageUrls?: { __typename?: 'ImageSet', xxl: string, xl: string, large: string, medium: string, small: string, xs: string, raw: string } | null, selection: { __typename?: 'Selection', guid?: string | null, itemGuid?: string | null, itemGroupGuid?: string | null, name?: string | null, preDiscountPrice?: number | null, modifiers?: Array<{ __typename?: 'Selection', name?: string | null } | null> | null } }> } };

export type ReorderableMenuItemQueryVariables = Exact<{
  input: ReorderableSelectionItemDetailsInput;
  nestingLevel?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReorderableMenuItemQuery = { __typename?: 'Query', reorderableSelectionItemDetails: { __typename?: 'SelectionItem', description?: string | null, name?: string | null, quantity?: number | null, itemGuid: string, itemGroupGuid: string, specialRequest?: string | null, menuItemPrice?: number | null, selectionItemPrice?: number | null, usesFractionalQuantity: boolean, imageUrls?: { __typename?: 'ImageSet', xxl: string, xl: string, large: string, medium: string, small: string, xs: string, raw: string } | null, fractionalQuantity: { __typename?: 'FractionalQuantity', unitOfMeasure: UnitOfMeasure, quantity: number }, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> } };

export type RestaurantQueryVariables = Exact<{
  restaurantGuid: Scalars['ID']['input'];
}>;


export type RestaurantQuery = { __typename?: 'Query', restaurantV2: { __typename?: 'GeneralError' } | { __typename?: 'Restaurant', guid: string, name: string, whiteLabelName: string, minimumTakeoutTime: number, minimumDeliveryTime: number, timeZoneId?: string | null, cuisineType?: string | null, hasOnlineOrderingModule: boolean, description?: string | null, consumerCTAEnabled?: boolean | null, consumerAppEnabled?: boolean | null, shortUrl: string, location: { __typename?: 'Location', address1: string, address2?: string | null, city: string, state: string, zip: string, phone: string, latitude?: number | null, longitude?: number | null }, specialRequestsConfig: { __typename?: 'SpecialRequestsConfig', enabled: boolean, placeholderMessage: string }, creditCardConfig: { __typename?: 'RestaurantCreditCardConfig', amexAccepted: boolean, tipEnabled: boolean }, giftCardConfig: { __typename?: 'GiftCardConfig', redemptionAllowed: boolean, hasGiftCardsExtension: boolean, supportVerificationCode: boolean, purchaseAllowed: boolean }, curbsidePickupConfig?: { __typename?: 'CurbsidePickupConfig', enabled: boolean, enabledV2: boolean } | null, i18n: { __typename?: 'I18n', currency: string, locale: string, country?: string | null }, loyaltyConfig: { __typename?: 'LoyaltyConfig', loyaltySignupEnabled: boolean, loyaltyRedemptionEnabled: boolean, programName?: string | null, rewardType?: RewardRedemptionType | null }, giftCardLinks: { __typename?: 'GiftCardLinks', purchaseLink?: string | null }, socialMediaLinks: { __typename?: 'SocialMediaLinks', facebookLink?: string | null, twitterLink?: string | null, instagramLink?: string | null, restaurantLink?: string | null }, schedule: { __typename?: 'Schedule', asapAvailableForDelivery?: boolean | null, asapAvailableForTakeout?: boolean | null, todaysHoursForDelivery?: { __typename?: 'ServicePeriod', startTime: string, endTime: string } | null, upcomingSchedules: Array<{ __typename?: 'UpcomingSchedules', behavior: DiningOptionBehavior, dailySchedules: Array<{ __typename?: 'DailySchedule', date: string, overrideDescription?: string | null, servicePeriods: Array<{ __typename?: 'ServicePeriod', startTime: string, endTime: string }> }> }> }, logoUrls?: { __typename?: 'ImageSet', small: string } | null, bannerUrls?: { __typename?: 'ImageSet', medium: string } | null, spotlightConfig?: { __typename?: 'SpotlightConfig', headerText?: string | null, bodyText?: string | null } | null, fundraisingConfig: { __typename?: 'FundraisingConfig', campaignName?: string | null, campaignDescription?: string | null, campaignLogoURL?: string | null, donationType?: string | null, donationAmounts?: Array<number> | null, active?: boolean | null, guestLegalDisclosure?: string | null, causeParentName?: string | null }, packagingConfig: { __typename?: 'PackagingConfig', enabled: boolean, guestMessage?: string | null, items: Array<{ __typename?: 'PackagingItem', id: string, itemTypes: Array<string>, guestDisplayName: string, guestDescription?: string | null, guestInclusionType: string }> }, adsManagerConversionTagsConfig: { __typename?: 'AdsManagerConversionTagsConfig', managementSetGuid: string, restaurantConversionsDataList?: Array<{ __typename?: 'AdsManagerRestaurantConversionsData', restaurantGuid: string, googleConversionsData?: { __typename?: 'GoogleConversionsData', tagId?: string | null, conversionLabels?: Array<{ __typename?: 'GoogleConversionLabel', label: string, type: string } | null> | null } | null, metaConversionsData?: { __typename?: 'MetaConversionsData', pixelId?: string | null } | null } | null> | null }, adsManagerRestaurantConversionsData: { __typename?: 'AdsManagerRestaurantConversionsData', restaurantGuid: string, metaConversionsData?: { __typename?: 'MetaConversionsData', pixelId?: string | null } | null, googleConversionsData?: { __typename?: 'GoogleConversionsData', tagId?: string | null, conversionLabels?: Array<{ __typename?: 'GoogleConversionLabel', label: string, type: string } | null> | null } | null } } };

export type RestaurantByShortUrlQueryVariables = Exact<{
  shortUrl: Scalars['String']['input'];
}>;


export type RestaurantByShortUrlQuery = { __typename?: 'Query', restaurantV2ByShortUrl: { __typename?: 'GeneralError', code: GeneralErrorCode, message: string } | { __typename?: 'Restaurant', guid: string, name: string, whiteLabelName: string, minimumTakeoutTime: number, minimumDeliveryTime: number, timeZoneId?: string | null, cuisineType?: string | null, hasOnlineOrderingModule: boolean, description?: string | null, consumerCTAEnabled?: boolean | null, consumerAppEnabled?: boolean | null, shortUrl: string, location: { __typename?: 'Location', address1: string, address2?: string | null, city: string, state: string, zip: string, phone: string, latitude?: number | null, longitude?: number | null }, specialRequestsConfig: { __typename?: 'SpecialRequestsConfig', enabled: boolean, placeholderMessage: string }, creditCardConfig: { __typename?: 'RestaurantCreditCardConfig', amexAccepted: boolean, tipEnabled: boolean }, giftCardConfig: { __typename?: 'GiftCardConfig', redemptionAllowed: boolean, hasGiftCardsExtension: boolean, supportVerificationCode: boolean, purchaseAllowed: boolean }, curbsidePickupConfig?: { __typename?: 'CurbsidePickupConfig', enabled: boolean, enabledV2: boolean } | null, i18n: { __typename?: 'I18n', currency: string, locale: string, country?: string | null }, loyaltyConfig: { __typename?: 'LoyaltyConfig', loyaltySignupEnabled: boolean, loyaltyRedemptionEnabled: boolean, programName?: string | null, rewardType?: RewardRedemptionType | null }, giftCardLinks: { __typename?: 'GiftCardLinks', purchaseLink?: string | null }, socialMediaLinks: { __typename?: 'SocialMediaLinks', facebookLink?: string | null, twitterLink?: string | null, instagramLink?: string | null, restaurantLink?: string | null }, schedule: { __typename?: 'Schedule', asapAvailableForDelivery?: boolean | null, asapAvailableForTakeout?: boolean | null, todaysHoursForDelivery?: { __typename?: 'ServicePeriod', startTime: string, endTime: string } | null, upcomingSchedules: Array<{ __typename?: 'UpcomingSchedules', behavior: DiningOptionBehavior, dailySchedules: Array<{ __typename?: 'DailySchedule', date: string, overrideDescription?: string | null, servicePeriods: Array<{ __typename?: 'ServicePeriod', startTime: string, endTime: string }> }> }> }, logoUrls?: { __typename?: 'ImageSet', small: string } | null, bannerUrls?: { __typename?: 'ImageSet', medium: string } | null, spotlightConfig?: { __typename?: 'SpotlightConfig', headerText?: string | null, bodyText?: string | null } | null, fundraisingConfig: { __typename?: 'FundraisingConfig', campaignName?: string | null, campaignDescription?: string | null, campaignLogoURL?: string | null, donationType?: string | null, donationAmounts?: Array<number> | null, active?: boolean | null, guestLegalDisclosure?: string | null, causeParentName?: string | null }, packagingConfig: { __typename?: 'PackagingConfig', enabled: boolean, guestMessage?: string | null, items: Array<{ __typename?: 'PackagingItem', id: string, itemTypes: Array<string>, guestDisplayName: string, guestDescription?: string | null, guestInclusionType: string }> }, adsManagerConversionTagsConfig: { __typename?: 'AdsManagerConversionTagsConfig', managementSetGuid: string, restaurantConversionsDataList?: Array<{ __typename?: 'AdsManagerRestaurantConversionsData', restaurantGuid: string, googleConversionsData?: { __typename?: 'GoogleConversionsData', tagId?: string | null, conversionLabels?: Array<{ __typename?: 'GoogleConversionLabel', label: string, type: string } | null> | null } | null, metaConversionsData?: { __typename?: 'MetaConversionsData', pixelId?: string | null } | null } | null> | null }, adsManagerRestaurantConversionsData: { __typename?: 'AdsManagerRestaurantConversionsData', restaurantGuid: string, metaConversionsData?: { __typename?: 'MetaConversionsData', pixelId?: string | null } | null, googleConversionsData?: { __typename?: 'GoogleConversionsData', tagId?: string | null, conversionLabels?: Array<{ __typename?: 'GoogleConversionLabel', label: string, type: string } | null> | null } | null } } };

export type RestaurantFieldsFragment = { __typename?: 'Restaurant', guid: string, name: string, whiteLabelName: string, minimumTakeoutTime: number, minimumDeliveryTime: number, timeZoneId?: string | null, cuisineType?: string | null, hasOnlineOrderingModule: boolean, description?: string | null, consumerCTAEnabled?: boolean | null, consumerAppEnabled?: boolean | null, shortUrl: string, location: { __typename?: 'Location', address1: string, address2?: string | null, city: string, state: string, zip: string, phone: string, latitude?: number | null, longitude?: number | null }, specialRequestsConfig: { __typename?: 'SpecialRequestsConfig', enabled: boolean, placeholderMessage: string }, creditCardConfig: { __typename?: 'RestaurantCreditCardConfig', amexAccepted: boolean, tipEnabled: boolean }, giftCardConfig: { __typename?: 'GiftCardConfig', redemptionAllowed: boolean, hasGiftCardsExtension: boolean, supportVerificationCode: boolean, purchaseAllowed: boolean }, curbsidePickupConfig?: { __typename?: 'CurbsidePickupConfig', enabled: boolean, enabledV2: boolean } | null, i18n: { __typename?: 'I18n', currency: string, locale: string, country?: string | null }, loyaltyConfig: { __typename?: 'LoyaltyConfig', loyaltySignupEnabled: boolean, loyaltyRedemptionEnabled: boolean, programName?: string | null, rewardType?: RewardRedemptionType | null }, giftCardLinks: { __typename?: 'GiftCardLinks', purchaseLink?: string | null }, socialMediaLinks: { __typename?: 'SocialMediaLinks', facebookLink?: string | null, twitterLink?: string | null, instagramLink?: string | null, restaurantLink?: string | null }, schedule: { __typename?: 'Schedule', asapAvailableForDelivery?: boolean | null, asapAvailableForTakeout?: boolean | null, todaysHoursForDelivery?: { __typename?: 'ServicePeriod', startTime: string, endTime: string } | null, upcomingSchedules: Array<{ __typename?: 'UpcomingSchedules', behavior: DiningOptionBehavior, dailySchedules: Array<{ __typename?: 'DailySchedule', date: string, overrideDescription?: string | null, servicePeriods: Array<{ __typename?: 'ServicePeriod', startTime: string, endTime: string }> }> }> }, logoUrls?: { __typename?: 'ImageSet', small: string } | null, bannerUrls?: { __typename?: 'ImageSet', medium: string } | null, spotlightConfig?: { __typename?: 'SpotlightConfig', headerText?: string | null, bodyText?: string | null } | null, fundraisingConfig: { __typename?: 'FundraisingConfig', campaignName?: string | null, campaignDescription?: string | null, campaignLogoURL?: string | null, donationType?: string | null, donationAmounts?: Array<number> | null, active?: boolean | null, guestLegalDisclosure?: string | null, causeParentName?: string | null }, packagingConfig: { __typename?: 'PackagingConfig', enabled: boolean, guestMessage?: string | null, items: Array<{ __typename?: 'PackagingItem', id: string, itemTypes: Array<string>, guestDisplayName: string, guestDescription?: string | null, guestInclusionType: string }> }, adsManagerConversionTagsConfig: { __typename?: 'AdsManagerConversionTagsConfig', managementSetGuid: string, restaurantConversionsDataList?: Array<{ __typename?: 'AdsManagerRestaurantConversionsData', restaurantGuid: string, googleConversionsData?: { __typename?: 'GoogleConversionsData', tagId?: string | null, conversionLabels?: Array<{ __typename?: 'GoogleConversionLabel', label: string, type: string } | null> | null } | null, metaConversionsData?: { __typename?: 'MetaConversionsData', pixelId?: string | null } | null } | null> | null }, adsManagerRestaurantConversionsData: { __typename?: 'AdsManagerRestaurantConversionsData', restaurantGuid: string, metaConversionsData?: { __typename?: 'MetaConversionsData', pixelId?: string | null } | null, googleConversionsData?: { __typename?: 'GoogleConversionsData', tagId?: string | null, conversionLabels?: Array<{ __typename?: 'GoogleConversionLabel', label: string, type: string } | null> | null } | null } };

export type RestaurantLocationsQueryVariables = Exact<{
  restaurantGuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestaurantLocationsQuery = { __typename?: 'Query', restaurants: Array<{ __typename?: 'GeneralError' } | { __typename?: 'Restaurant', name: string, whiteLabelName: string, shortUrl: string, guid: string, timeZoneId?: string | null, hasOnlineOrderingModule: boolean, onlineOrderingEnabled?: boolean | null, location: { __typename?: 'Location', address1: string, address2?: string | null, city: string, state: string, zip: string, phone: string, latitude?: number | null, longitude?: number | null }, deliveryProviders: Array<{ __typename?: 'DeliveryProviderConfig', enabled: boolean, provider: DeliveryProvider, pending: boolean }>, deliveryServiceAvailability: { __typename?: 'DeliveryServiceAvailability', available: boolean }, schedule: { __typename?: 'Schedule', asapAvailableForDelivery?: boolean | null, asapAvailableForTakeout?: boolean | null, todaysHoursForTakeout?: { __typename?: 'ServicePeriod', startTime: string, endTime: string } | null, todaysHoursForDelivery?: { __typename?: 'ServicePeriod', startTime: string, endTime: string } | null, upcomingSchedules: Array<{ __typename?: 'UpcomingSchedules', behavior: DiningOptionBehavior, dailySchedules: Array<{ __typename?: 'DailySchedule', date: string, overrideDescription?: string | null, servicePeriods: Array<{ __typename?: 'ServicePeriod', startTime: string, endTime: string }> }> }> } }> };

export type RestaurantProfileQueryVariables = Exact<{
  guid: Scalars['ID']['input'];
}>;


export type RestaurantProfileQuery = { __typename?: 'Query', restaurantV2: { __typename?: 'GeneralError' } | { __typename?: 'Restaurant', guid: string, name: string, whiteLabelName: string, minimumTakeoutTime: number, minimumDeliveryTime: number, timeZoneId?: string | null, cuisineType?: string | null, hasOnlineOrderingModule: boolean, description?: string | null, consumerCTAEnabled?: boolean | null, consumerAppEnabled?: boolean | null, shortUrl: string, location: { __typename?: 'Location', address1: string, address2?: string | null, city: string, state: string, zip: string, phone: string, latitude?: number | null, longitude?: number | null }, specialRequestsConfig: { __typename?: 'SpecialRequestsConfig', enabled: boolean, placeholderMessage: string }, creditCardConfig: { __typename?: 'RestaurantCreditCardConfig', amexAccepted: boolean, tipEnabled: boolean }, giftCardConfig: { __typename?: 'GiftCardConfig', redemptionAllowed: boolean, hasGiftCardsExtension: boolean, supportVerificationCode: boolean, purchaseAllowed: boolean }, curbsidePickupConfig?: { __typename?: 'CurbsidePickupConfig', enabled: boolean, enabledV2: boolean } | null, i18n: { __typename?: 'I18n', currency: string, locale: string, country?: string | null }, loyaltyConfig: { __typename?: 'LoyaltyConfig', loyaltySignupEnabled: boolean, loyaltyRedemptionEnabled: boolean, programName?: string | null, rewardType?: RewardRedemptionType | null }, giftCardLinks: { __typename?: 'GiftCardLinks', purchaseLink?: string | null }, socialMediaLinks: { __typename?: 'SocialMediaLinks', facebookLink?: string | null, twitterLink?: string | null, instagramLink?: string | null, restaurantLink?: string | null }, schedule: { __typename?: 'Schedule', asapAvailableForDelivery?: boolean | null, asapAvailableForTakeout?: boolean | null, todaysHoursForDelivery?: { __typename?: 'ServicePeriod', startTime: string, endTime: string } | null, upcomingSchedules: Array<{ __typename?: 'UpcomingSchedules', behavior: DiningOptionBehavior, dailySchedules: Array<{ __typename?: 'DailySchedule', date: string, overrideDescription?: string | null, servicePeriods: Array<{ __typename?: 'ServicePeriod', startTime: string, endTime: string }> }> }> }, logoUrls?: { __typename?: 'ImageSet', small: string } | null, bannerUrls?: { __typename?: 'ImageSet', medium: string } | null, spotlightConfig?: { __typename?: 'SpotlightConfig', headerText?: string | null, bodyText?: string | null } | null, fundraisingConfig: { __typename?: 'FundraisingConfig', campaignName?: string | null, campaignDescription?: string | null, campaignLogoURL?: string | null, donationType?: string | null, donationAmounts?: Array<number> | null, active?: boolean | null, guestLegalDisclosure?: string | null, causeParentName?: string | null }, packagingConfig: { __typename?: 'PackagingConfig', enabled: boolean, guestMessage?: string | null, items: Array<{ __typename?: 'PackagingItem', id: string, itemTypes: Array<string>, guestDisplayName: string, guestDescription?: string | null, guestInclusionType: string }> }, adsManagerConversionTagsConfig: { __typename?: 'AdsManagerConversionTagsConfig', managementSetGuid: string, restaurantConversionsDataList?: Array<{ __typename?: 'AdsManagerRestaurantConversionsData', restaurantGuid: string, googleConversionsData?: { __typename?: 'GoogleConversionsData', tagId?: string | null, conversionLabels?: Array<{ __typename?: 'GoogleConversionLabel', label: string, type: string } | null> | null } | null, metaConversionsData?: { __typename?: 'MetaConversionsData', pixelId?: string | null } | null } | null> | null }, adsManagerRestaurantConversionsData: { __typename?: 'AdsManagerRestaurantConversionsData', restaurantGuid: string, metaConversionsData?: { __typename?: 'MetaConversionsData', pixelId?: string | null } | null, googleConversionsData?: { __typename?: 'GoogleConversionsData', tagId?: string | null, conversionLabels?: Array<{ __typename?: 'GoogleConversionLabel', label: string, type: string } | null> | null } | null } } };

export type RestaurantPromoBannersQueryVariables = Exact<{
  restaurantGuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestaurantPromoBannersQuery = { __typename?: 'Query', restaurants: Array<{ __typename?: 'GeneralError' } | { __typename?: 'Restaurant', guid: string, name: string, shortUrl: string, promoBanners?: { __typename?: 'GeneralError' } | { __typename?: 'PromoBannerResponse', promoCodeBanners: Array<{ __typename?: 'PromoCodeBanner', bannerGuid: string, bannerText: string, promoCode: string }> } | null }> };

export type RestaurantScheduleFieldsFragment = { __typename?: 'Restaurant', guid: string, timeZoneId?: string | null, hasOnlineOrderingModule: boolean, onlineOrderingEnabled?: boolean | null, deliveryProviders: Array<{ __typename?: 'DeliveryProviderConfig', enabled: boolean, provider: DeliveryProvider, pending: boolean }>, deliveryServiceAvailability: { __typename?: 'DeliveryServiceAvailability', available: boolean }, schedule: { __typename?: 'Schedule', asapAvailableForDelivery?: boolean | null, asapAvailableForTakeout?: boolean | null, todaysHoursForTakeout?: { __typename?: 'ServicePeriod', startTime: string, endTime: string } | null, todaysHoursForDelivery?: { __typename?: 'ServicePeriod', startTime: string, endTime: string } | null, upcomingSchedules: Array<{ __typename?: 'UpcomingSchedules', behavior: DiningOptionBehavior, dailySchedules: Array<{ __typename?: 'DailySchedule', date: string, overrideDescription?: string | null, servicePeriods: Array<{ __typename?: 'ServicePeriod', startTime: string, endTime: string }> }> }> } };

export type RestaurantSchedulesQueryVariables = Exact<{
  restaurantGuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestaurantSchedulesQuery = { __typename?: 'Query', restaurants: Array<{ __typename?: 'GeneralError' } | { __typename?: 'Restaurant', guid: string, timeZoneId?: string | null, hasOnlineOrderingModule: boolean, onlineOrderingEnabled?: boolean | null, deliveryProviders: Array<{ __typename?: 'DeliveryProviderConfig', enabled: boolean, provider: DeliveryProvider, pending: boolean }>, deliveryServiceAvailability: { __typename?: 'DeliveryServiceAvailability', available: boolean }, schedule: { __typename?: 'Schedule', asapAvailableForDelivery?: boolean | null, asapAvailableForTakeout?: boolean | null, todaysHoursForTakeout?: { __typename?: 'ServicePeriod', startTime: string, endTime: string } | null, todaysHoursForDelivery?: { __typename?: 'ServicePeriod', startTime: string, endTime: string } | null, upcomingSchedules: Array<{ __typename?: 'UpcomingSchedules', behavior: DiningOptionBehavior, dailySchedules: Array<{ __typename?: 'DailySchedule', date: string, overrideDescription?: string | null, servicePeriods: Array<{ __typename?: 'ServicePeriod', startTime: string, endTime: string }> }> }> } }> };

export type RxSearchQueryVariables = Exact<{
  input: NearbyRestaurantSearchInput;
}>;


export type RxSearchQuery = { __typename?: 'Query', nearbyRestaurantSearch: { __typename?: 'RestaurantSearchResponse', results: Array<{ __typename?: 'RestaurantSearchItem', restaurant: { __typename?: 'Restaurant', guid: string, imageUrl?: string | null, shortUrl: string, name: string, cuisineType?: string | null, hasOnlineOrderingModule: boolean, location: { __typename?: 'Location', latitude?: number | null, longitude?: number | null }, deliveryServiceAvailability: { __typename?: 'DeliveryServiceAvailability', available: boolean }, guestCurrencyConfig: { __typename?: 'RestaurantGuestCurrencyConfig', enabled: boolean, promoEnabled: boolean, storedValueEnabled: boolean }, toastPayConfig?: { __typename?: 'ToastPayConfig', qrCodeOnReceiptEnabled: boolean } | null, promoBanners?: { __typename?: 'GeneralError' } | { __typename?: 'PromoBannerResponse', promoCodeBanners: Array<{ __typename?: 'PromoCodeBanner', bannerText: string }> } | null } }> } };

export type SelectionItemDetailsFieldsFragment = { __typename?: 'SelectionItem', description?: string | null, name?: string | null, quantity?: number | null, itemGuid: string, itemGroupGuid: string, specialRequest?: string | null, menuItemPrice?: number | null, selectionItemPrice?: number | null, usesFractionalQuantity: boolean, imageUrls?: { __typename?: 'ImageSet', xxl: string, xl: string, large: string, medium: string, small: string, xs: string, raw: string } | null, fractionalQuantity: { __typename?: 'FractionalQuantity', unitOfMeasure: UnitOfMeasure, quantity: number }, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null, modifierGroups: Array<{ __typename?: 'SelectionModifierGroup', name?: string | null, maxSelections?: number | null, minSelections?: number | null, pricingMode?: string | null, guid: string, modifiers: Array<{ __typename?: 'SelectionModifier', itemGuid: string, itemGroupGuid?: string | null, selected?: boolean | null, name?: string | null, price?: number | null, allowsDuplicates?: boolean | null, outOfStock?: boolean | null, isDefault?: boolean | null, quantity?: number | null }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> }> };

export type SelectShippingRateMutationVariables = Exact<{
  input: SetSelectedShippingRateInput;
}>;


export type SelectShippingRateMutation = { __typename?: 'Mutation', setSelectedShippingRate: { __typename?: 'EcommerceMutationErrorResponse', message: string } | { __typename?: 'EcommerceMutationSuccessResponse', success: boolean } };

export type CartShippingRatesQueryVariables = Exact<{
  input: ShippingRatesQueryInput;
}>;


export type CartShippingRatesQuery = { __typename?: 'Query', getCartShippingRates: Array<{ __typename?: 'ShippingRate', shippingRateGuid: string, amount: string, currency: string, description: string, estimatedDays: number, title: string } | null> };

export type SitemapMenuDataFragment = { __typename?: 'MenusResponse', menus: Array<{ __typename?: 'Menu', id: string, groups?: Array<{ __typename?: 'MenuGroup', guid: string, items?: Array<{ __typename?: 'MenuItem', name?: string | null, guid: string } | null> | null } | null> | null }> };

export type GetMenusSitemapQueryVariables = Exact<{
  input: MenusInput;
}>;


export type GetMenusSitemapQuery = { __typename?: 'Query', menusV3: { __typename?: 'GeneralError', code: GeneralErrorCode, message: string } | { __typename?: 'MenusResponse', menus: Array<{ __typename?: 'Menu', id: string, groups?: Array<{ __typename?: 'MenuGroup', guid: string, items?: Array<{ __typename?: 'MenuItem', name?: string | null, guid: string } | null> | null } | null> | null }> } };

export type GetSurchargeSummaryQueryVariables = Exact<{
  input: GetSurchargeSummaryInput;
}>;


export type GetSurchargeSummaryQuery = { __typename?: 'Query', getSurchargeSummary?: Array<{ __typename?: 'SurchargeSummaryResponse', paymentTypes: Array<PaymentType>, surchargePreTaxAmount: number, surchargeTaxAmount: number, surchargeRate: number }> | null };

export type UpdateFulfillmentMutationVariables = Exact<{
  input: UpdateFulfillmentAndValidateInput;
}>;


export type UpdateFulfillmentMutation = { __typename?: 'Mutation', updateFulfillmentAndValidate: { __typename?: 'CartModificationError', code: CartModificationErrorCode, message: string } | { __typename?: 'CartOutOfStockError', message: string, items: Array<{ __typename?: 'CartOutOfStockItem', name?: string | null, guid?: string | null }> } | { __typename?: 'CartResponse', cart: { __typename?: 'Cart', guid: string, cartSource?: CartSource | null, expiredDate: number, order?: { __typename?: 'Order', numberOfSelections?: number | null, taxV2?: number | null, totalV2?: number | null, selections?: Array<{ __typename?: 'Selection', name?: string | null, price?: number | null, quantity?: number | null, modifiers?: Array<{ __typename?: 'Selection', name?: string | null, price?: number | null } | null> | null } | null> | null } | null } } | { __typename?: 'CartValidationError' } };

export type ValidateCartPreCheckoutMutationVariables = Exact<{
  cartGuid: Scalars['ID']['input'];
  validateOrderTime?: InputMaybe<Scalars['Boolean']['input']>;
  customer?: InputMaybe<GuestInput>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ValidateCartPreCheckoutMutation = { __typename?: 'Mutation', validateCartPreCheckout: { __typename?: 'CartModificationError', message: string, code: CartModificationErrorCode } | { __typename?: 'CartOutOfStockError', message: string } | { __typename?: 'CartResponse', cart: { __typename?: 'Cart', guid: string, cartSource?: CartSource | null, restaurant?: { __typename?: 'Restaurant', name: string } | null }, info: Array<{ __typename?: 'CartInfo', code: CartInfoCode, message: string }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, message: string }> } | { __typename?: 'CartValidationError', key: string, message: string } };

export type ValidateDeliveryDistanceQueryVariables = Exact<{
  input: ValidateDeliveryLocationInputV2;
}>;


export type ValidateDeliveryDistanceQuery = { __typename?: 'Query', validateDeliveryLocationV2: { __typename?: 'ValidateDeliveryLocationResponse', valid: boolean } };

export const DeliveryInfoFieldsFragmentDoc = gql`
    fragment DeliveryInfoFields on DeliveryInfo {
  address1
  address2
  city
  state
  zipCode
  latitude
  longitude
  notes
  administrativeArea
  country
}
    `;
export const FractionalQuantityFieldsFragmentDoc = gql`
    fragment FractionalQuantityFields on FractionalQuantity {
  unitOfMeasure
  quantity
}
    `;
export const DiscountsFieldsFragmentDoc = gql`
    fragment DiscountsFields on Discounts {
  restaurantDiscount {
    promoCode
  }
  loyaltyDiscounts {
    guid
    amount
    type
    referenceId
    name
  }
  globalReward {
    amount
    name
    rewardType
    total
  }
  loyaltyDetails {
    vendor
    referenceId
  }
  name
  discountAmount
  discount {
    guid
    entityType
  }
}
    `;
export const SelectionFieldsFragmentDoc = gql`
    fragment SelectionFields on Selection {
  name
  guid
  preDiscountPrice
  price
  optionGroupGuid
  receiptLinePrice
  groupingKey
}
    `;
export const ParentSelectionFieldsFragmentDoc = gql`
    fragment ParentSelectionFields on Selection {
  itemGuid
  usesFractionalQuantity
  fractionalQuantity {
    ...FractionalQuantityFields
  }
  quantity
  itemGroupGuid
  itemGuid
  appliedDiscounts {
    ...DiscountsFields
  }
  ...SelectionFields
  modifiers {
    ...SelectionFields
    modifiers {
      ...SelectionFields
      modifiers {
        ...SelectionFields
      }
    }
  }
}
    ${FractionalQuantityFieldsFragmentDoc}
${DiscountsFieldsFragmentDoc}
${SelectionFieldsFragmentDoc}`;
export const SurchargeFieldsFragmentDoc = gql`
    fragment SurchargeFields on SurchargeSummaryResponse {
  paymentTypes
  surchargePreTaxAmount
  surchargeRate
  surchargeTaxAmount
}
    `;
export const OrderFieldsFragmentDoc = gql`
    fragment OrderFields on Order {
  deliveryInfo {
    ...DeliveryInfoFields
  }
  numberOfSelections
  selections {
    ...ParentSelectionFields
  }
  preDiscountItemsSubtotal
  discounts {
    ...DiscountsFields
  }
  discountsTotal
  deliveryServiceCharges
  processingServiceCharges
  gratuityServiceCharges
  nonDeliveryNonGratuityNonUbpServiceCharges
  taxV2
  totalV2
  surcharges(totalGiftCardBalance: $totalGiftCardBalance) {
    ...SurchargeFields
  }
}
    ${DeliveryInfoFieldsFragmentDoc}
${ParentSelectionFieldsFragmentDoc}
${DiscountsFieldsFragmentDoc}
${SurchargeFieldsFragmentDoc}`;
export const CustomerFieldsFragmentDoc = gql`
    fragment CustomerFields on Customer {
  id: guid
  lastName
  firstName
  phone
  email
  creditCards {
    guid
    cardType
    maskedPan
    expirationMonth
    expirationYear
    isPrimary
  }
  addresses {
    guid
    name
    deliveryInfo {
      address1
      address2
      city
      state
      zipCode
      latitude
      longitude
      notes
    }
  }
}
    `;
export const DiningOptionFragmentFragmentDoc = gql`
    fragment DiningOptionFragment on DiningOption {
  behavior
  asapSchedule {
    availableNow
  }
  futureSchedule {
    dates {
      date
      times {
        time
      }
    }
  }
}
    `;
export const LoyaltyInquiryResponseFieldsFragmentDoc = gql`
    fragment LoyaltyInquiryResponseFields on LoyaltyInquiryResponse {
  pointsBalance
  redemptions {
    name
    type
    referenceId
    redemptionAmount
    redemptionGuid
    rewardType
    target
    available
    currentState {
      leftToTarget
      messages {
        nextRewardMessage
        nextRewardMiniMessage
        rewardLabelMessage
        rewardValueMessage
        unlockedMessage
      }
    }
  }
  loyaltyAccountIdentifier
  currentState {
    balance
    balancePoints
    messages {
      balance
      balanceShort
    }
  }
}
    `;
export const ImageFieldsFragmentDoc = gql`
    fragment ImageFields on ImageSet {
  xxl
  xl
  large
  medium
  small
  xs
  raw
}
    `;
export const MenuItemFragmentFragmentDoc = gql`
    fragment MenuItemFragment on MenuItem {
  guid
  outOfStock
  itemGroupGuid
  name
  description
  prices
  defaultModifiersPrice
  masterId
  imageUrls {
    ...ImageFields
  }
  unitOfMeasure
  usesFractionalQuantity
  timeBasedRules {
    leadTimeRule {
      leadTime
    }
    preorderRule {
      fulfillmentDateRange {
        start
        end
      }
      orderDateRange {
        start
        end
      }
    }
    pickupWindowRule {
      days {
        dayOfWeek
        pickupWindows {
          duration
        }
      }
    }
  }
  itemTags {
    guid
    name
  }
}
    ${ImageFieldsFragmentDoc}`;
export const ModifierGroupFieldsFragmentDoc = gql`
    fragment ModifierGroupFields on ModifierGroup {
  name
  maxSelections
  minSelections
  pricingMode
  guid
}
    `;
export const ModifierFieldsFragmentDoc = gql`
    fragment ModifierFields on Modifier {
  itemGuid
  itemGroupGuid
  selected
  name
  price
  allowsDuplicates
  outOfStock
  isDefault
}
    `;
export const LocationFieldsFragmentDoc = gql`
    fragment LocationFields on Location {
  address1
  address2
  city
  state
  zip
  phone
  latitude
  longitude
}
    `;
export const LoyaltyConfigFieldsFragmentDoc = gql`
    fragment LoyaltyConfigFields on LoyaltyConfig {
  loyaltySignupEnabled
  loyaltyRedemptionEnabled
  programName
  rewardType
}
    `;
export const CompletedOrderSelectionFieldsFragmentDoc = gql`
    fragment CompletedOrderSelectionFields on CompletedOrderSelection {
  externalId
  price
  preDiscountPrice
  quantity
  receiptLinePrice
  usesFractionalQuantity
  fractionalQuantity {
    ...FractionalQuantityFields
  }
  name
  modifiers {
    name
    modifiers {
      name
      modifiers {
        name
      }
    }
  }
}
    ${FractionalQuantityFieldsFragmentDoc}`;
export const CompletedOrderFieldsFragmentDoc = gql`
    fragment CompletedOrderFields on CompletedOrder {
  guid
  approvalStatus
  checkGuid
  checkNumber
  customerV3 {
    firstName
    lastName
    phone
    email
  }
  restaurant {
    guid
    name
    location {
      ...LocationFields
    }
    loyaltyConfig(supportedAccrualTypes: [CHECK_TOTAL, VISIT]) {
      ...LoyaltyConfigFields
    }
  }
  estimatedFulfillmentDate
  guestCommunication
  diningOptionBehavior
  curbsidePickup {
    selected
  }
  curbsidePickupV2 {
    notes
  }
  deliveryInfo {
    ...DeliveryInfoFields
  }
  deliveryServiceInfo {
    providerName
  }
  numberOfSelections
  selections {
    ...CompletedOrderSelectionFields
  }
  preDiscountItemsSubtotal
  discounts {
    ...DiscountsFields
  }
  discountsTotal
  deliveryServiceCharges
  processingServiceCharges
  gratuityServiceCharges
  nonDeliveryNonGratuityNonUbpServiceCharges
  surchargeServiceCharges {
    baseAmount
    taxAmount
    rate
  }
  fundraisingTotal
  packagingSelections {
    guid
    inclusion
    guestDisplayName
  }
  taxV2
  tip
  totalV2
  giftCard {
    appliedBalance
  }
  hasLoyaltyAttached
  paymentType
}
    ${LocationFieldsFragmentDoc}
${LoyaltyConfigFieldsFragmentDoc}
${DeliveryInfoFieldsFragmentDoc}
${CompletedOrderSelectionFieldsFragmentDoc}
${DiscountsFieldsFragmentDoc}`;
export const GiftCardConfigFieldsFragmentDoc = gql`
    fragment GiftCardConfigFields on GiftCardConfig {
  redemptionAllowed
  hasGiftCardsExtension
  supportVerificationCode
  purchaseAllowed
}
    `;
export const AdsManagerConversionTagsConfigFieldsFragmentDoc = gql`
    fragment AdsManagerConversionTagsConfigFields on AdsManagerConversionTagsConfig {
  managementSetGuid
  restaurantConversionsDataList {
    restaurantGuid
    googleConversionsData {
      tagId
      conversionLabels {
        label
        type
      }
    }
    metaConversionsData {
      pixelId
    }
  }
}
    `;
export const AdsManagerRestaurantConversionsDataFieldsFragmentDoc = gql`
    fragment AdsManagerRestaurantConversionsDataFields on AdsManagerRestaurantConversionsData {
  restaurantGuid
  metaConversionsData {
    pixelId
  }
  googleConversionsData {
    tagId
    conversionLabels {
      label
      type
    }
  }
}
    `;
export const RestaurantFieldsFragmentDoc = gql`
    fragment RestaurantFields on Restaurant {
  guid
  name
  whiteLabelName
  location {
    ...LocationFields
  }
  minimumTakeoutTime
  minimumDeliveryTime
  timeZoneId
  cuisineType
  hasOnlineOrderingModule
  description
  consumerCTAEnabled
  consumerAppEnabled
  shortUrl
  specialRequestsConfig {
    enabled
    placeholderMessage
  }
  creditCardConfig {
    amexAccepted
    tipEnabled
  }
  giftCardConfig {
    ...GiftCardConfigFields
  }
  curbsidePickupConfig {
    enabled
    enabledV2
  }
  i18n {
    currency
    locale
    country
  }
  loyaltyConfig(supportedAccrualTypes: [CHECK_TOTAL, VISIT]) {
    ...LoyaltyConfigFields
  }
  giftCardLinks {
    purchaseLink
  }
  socialMediaLinks {
    facebookLink
    twitterLink
    instagramLink
    restaurantLink: resturantLink
  }
  schedule {
    asapAvailableForDelivery
    asapAvailableForTakeout
    todaysHoursForDelivery {
      startTime
      endTime
    }
    upcomingSchedules {
      behavior
      dailySchedules {
        date
        overrideDescription
        servicePeriods {
          startTime
          endTime
        }
      }
    }
  }
  logoUrls {
    small
  }
  bannerUrls {
    medium
  }
  spotlightConfig {
    headerText
    bodyText
  }
  fundraisingConfig {
    campaignName
    campaignDescription
    campaignLogoURL
    donationType
    donationAmounts
    active
    guestLegalDisclosure
    causeParentName
  }
  packagingConfig {
    enabled
    guestMessage
    items {
      id
      itemTypes
      guestDisplayName
      guestDescription
      guestInclusionType
    }
  }
  adsManagerConversionTagsConfig {
    ...AdsManagerConversionTagsConfigFields
  }
  adsManagerRestaurantConversionsData {
    ...AdsManagerRestaurantConversionsDataFields
  }
}
    ${LocationFieldsFragmentDoc}
${GiftCardConfigFieldsFragmentDoc}
${LoyaltyConfigFieldsFragmentDoc}
${AdsManagerConversionTagsConfigFieldsFragmentDoc}
${AdsManagerRestaurantConversionsDataFieldsFragmentDoc}`;
export const RestaurantScheduleFieldsFragmentDoc = gql`
    fragment RestaurantScheduleFields on Restaurant {
  guid
  timeZoneId
  hasOnlineOrderingModule
  onlineOrderingEnabled
  deliveryProviders {
    enabled
    provider
    pending
  }
  deliveryServiceAvailability {
    available
  }
  schedule {
    asapAvailableForDelivery
    asapAvailableForTakeout
    todaysHoursForTakeout {
      startTime
      endTime
    }
    todaysHoursForDelivery {
      startTime
      endTime
    }
    upcomingSchedules {
      behavior
      dailySchedules {
        date
        overrideDescription
        servicePeriods {
          startTime
          endTime
        }
      }
    }
  }
}
    `;
export const SelectionModifierGroupFieldsFragmentDoc = gql`
    fragment SelectionModifierGroupFields on SelectionModifierGroup {
  name
  maxSelections
  minSelections
  pricingMode
  guid
}
    `;
export const SelectionModifierFieldsFragmentDoc = gql`
    fragment SelectionModifierFields on SelectionModifier {
  itemGuid
  itemGroupGuid
  selected
  name
  price
  allowsDuplicates
  outOfStock
  isDefault
  quantity
}
    `;
export const SelectionItemDetailsFieldsFragmentDoc = gql`
    fragment SelectionItemDetailsFields on SelectionItem {
  description
  name
  imageUrls {
    ...ImageFields
  }
  quantity
  itemGuid
  itemGroupGuid
  specialRequest
  menuItemPrice
  selectionItemPrice
  usesFractionalQuantity
  fractionalQuantity {
    unitOfMeasure
    quantity
  }
  modifierGroups(nestingLevel: $nestingLevel) {
    ...SelectionModifierGroupFields
    modifiers {
      ...SelectionModifierFields
      modifierGroups {
        ...SelectionModifierGroupFields
        modifiers {
          ...SelectionModifierFields
          modifierGroups {
            ...SelectionModifierGroupFields
            modifiers {
              ...SelectionModifierFields
              modifierGroups {
                ...SelectionModifierGroupFields
                modifiers {
                  ...SelectionModifierFields
                  modifierGroups {
                    ...SelectionModifierGroupFields
                    modifiers {
                      ...SelectionModifierFields
                      modifierGroups {
                        ...SelectionModifierGroupFields
                        modifiers {
                          ...SelectionModifierFields
                          modifierGroups {
                            ...SelectionModifierGroupFields
                            modifiers {
                              ...SelectionModifierFields
                              modifierGroups {
                                ...SelectionModifierGroupFields
                                modifiers {
                                  ...SelectionModifierFields
                                  modifierGroups {
                                    ...SelectionModifierGroupFields
                                    modifiers {
                                      ...SelectionModifierFields
                                      modifierGroups {
                                        ...SelectionModifierGroupFields
                                        modifiers {
                                          ...SelectionModifierFields
                                          modifierGroups {
                                            ...SelectionModifierGroupFields
                                            modifiers {
                                              ...SelectionModifierFields
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ImageFieldsFragmentDoc}
${SelectionModifierGroupFieldsFragmentDoc}
${SelectionModifierFieldsFragmentDoc}`;
export const SitemapMenuDataFragmentDoc = gql`
    fragment SitemapMenuData on MenusResponse {
  menus {
    id
    groups {
      guid
      items {
        name
        guid
      }
    }
  }
}
    `;
export const AddToCartDocument = gql`
    mutation AddToCart($input: AddItemToCartInputV2!) {
  addItemToCartV2(input: $input) {
    ... on CartResponse {
      cart {
        cartUpsellInfo {
          upsellItems
        }
        guid
        cartSource
        expiredDate
        order {
          numberOfSelections
          taxV2
          totalV2
          selections {
            name
            price
            quantity
            modifiers {
              name
              price
            }
          }
          surcharges {
            ...SurchargeFields
          }
        }
      }
    }
    ... on CartModificationError {
      code
      message
    }
    ... on CartOutOfStockError {
      message
      items {
        name
        guid
      }
    }
  }
}
    ${SurchargeFieldsFragmentDoc}`;
export type AddToCartMutationFn = Apollo.MutationFunction<AddToCartMutation, AddToCartMutationVariables>;

/**
 * __useAddToCartMutation__
 *
 * To run a mutation, you first call `useAddToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToCartMutation, { data, loading, error }] = useAddToCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddToCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddToCartMutation, AddToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddToCartMutation, AddToCartMutationVariables>(AddToCartDocument, options);
      }
export type AddToCartMutationHookResult = ReturnType<typeof useAddToCartMutation>;
export type AddToCartMutationResult = Apollo.MutationResult<AddToCartMutation>;
export type AddToCartMutationOptions = Apollo.BaseMutationOptions<AddToCartMutation, AddToCartMutationVariables>;
export const ApplyPromoCodeDocument = gql`
    mutation ApplyPromoCode($input: ApplyPromoCodeInputV3!) {
  applyPromoCodeV3(input: $input) {
    ... on CartResponse {
      cart {
        guid
        cartSource
        order {
          discountsTotal
        }
      }
    }
    ... on ApplyPromoCodeError {
      code
      message
    }
  }
}
    `;
export type ApplyPromoCodeMutationFn = Apollo.MutationFunction<ApplyPromoCodeMutation, ApplyPromoCodeMutationVariables>;

/**
 * __useApplyPromoCodeMutation__
 *
 * To run a mutation, you first call `useApplyPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyPromoCodeMutation, { data, loading, error }] = useApplyPromoCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyPromoCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyPromoCodeMutation, ApplyPromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApplyPromoCodeMutation, ApplyPromoCodeMutationVariables>(ApplyPromoCodeDocument, options);
      }
export type ApplyPromoCodeMutationHookResult = ReturnType<typeof useApplyPromoCodeMutation>;
export type ApplyPromoCodeMutationResult = Apollo.MutationResult<ApplyPromoCodeMutation>;
export type ApplyPromoCodeMutationOptions = Apollo.BaseMutationOptions<ApplyPromoCodeMutation, ApplyPromoCodeMutationVariables>;
export const CompleteIdentityProfileDocument = gql`
    mutation CompleteIdentityProfile($input: CompleteIdentityProfileInput!) {
  completeIdentityProfile(input: $input) {
    ... on CompleteIdentityProfileResponse {
      guestGuid
    }
    ... on CompleteIdentityProfileError {
      code
      message
    }
  }
}
    `;
export type CompleteIdentityProfileMutationFn = Apollo.MutationFunction<CompleteIdentityProfileMutation, CompleteIdentityProfileMutationVariables>;

/**
 * __useCompleteIdentityProfileMutation__
 *
 * To run a mutation, you first call `useCompleteIdentityProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteIdentityProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeIdentityProfileMutation, { data, loading, error }] = useCompleteIdentityProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteIdentityProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteIdentityProfileMutation, CompleteIdentityProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteIdentityProfileMutation, CompleteIdentityProfileMutationVariables>(CompleteIdentityProfileDocument, options);
      }
export type CompleteIdentityProfileMutationHookResult = ReturnType<typeof useCompleteIdentityProfileMutation>;
export type CompleteIdentityProfileMutationResult = Apollo.MutationResult<CompleteIdentityProfileMutation>;
export type CompleteIdentityProfileMutationOptions = Apollo.BaseMutationOptions<CompleteIdentityProfileMutation, CompleteIdentityProfileMutationVariables>;
export const ConfirmCodeDocument = gql`
    mutation ConfirmCode($input: PasswordlessConfirmCodeUnifiedInput!) {
  passwordlessConfirmCodeUnified(input: $input) {
    ... on Error {
      message
    }
    ... on PasswordlessAuthenticationError {
      message
      code
    }
    ... on PasswordlessTokenUnifiedResponse {
      accessToken
      refreshToken
      expiresAtIso8601
      guestGuid
    }
  }
}
    `;
export type ConfirmCodeMutationFn = Apollo.MutationFunction<ConfirmCodeMutation, ConfirmCodeMutationVariables>;

/**
 * __useConfirmCodeMutation__
 *
 * To run a mutation, you first call `useConfirmCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCodeMutation, { data, loading, error }] = useConfirmCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmCodeMutation, ConfirmCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfirmCodeMutation, ConfirmCodeMutationVariables>(ConfirmCodeDocument, options);
      }
export type ConfirmCodeMutationHookResult = ReturnType<typeof useConfirmCodeMutation>;
export type ConfirmCodeMutationResult = Apollo.MutationResult<ConfirmCodeMutation>;
export type ConfirmCodeMutationOptions = Apollo.BaseMutationOptions<ConfirmCodeMutation, ConfirmCodeMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount {
  deleteAccount {
    ... on DeleteAccountResponse {
      success
    }
    ... on DeleteAccountError {
      code
      message
    }
  }
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout($input: PasswordlessLogoutInput!) {
  passwordlessLogout(input: $input) {
    ... on PasswordlessLogoutResponse {
      success
    }
    ... on PasswordlessAuthenticationError {
      code
      message
    }
    ... on Error {
      message
    }
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const PasswordlessLoginDocument = gql`
    mutation PasswordlessLogin($input: PasswordlessLoginUnifiedInput!) {
  passwordlessLoginUnified(input: $input) {
    ... on PasswordlessLoginUnifiedResponse {
      success
    }
    ... on PasswordlessAuthenticationError {
      code
      message
    }
    ... on Error {
      message
    }
  }
}
    `;
export type PasswordlessLoginMutationFn = Apollo.MutationFunction<PasswordlessLoginMutation, PasswordlessLoginMutationVariables>;

/**
 * __usePasswordlessLoginMutation__
 *
 * To run a mutation, you first call `usePasswordlessLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordlessLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordlessLoginMutation, { data, loading, error }] = usePasswordlessLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordlessLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PasswordlessLoginMutation, PasswordlessLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PasswordlessLoginMutation, PasswordlessLoginMutationVariables>(PasswordlessLoginDocument, options);
      }
export type PasswordlessLoginMutationHookResult = ReturnType<typeof usePasswordlessLoginMutation>;
export type PasswordlessLoginMutationResult = Apollo.MutationResult<PasswordlessLoginMutation>;
export type PasswordlessLoginMutationOptions = Apollo.BaseMutationOptions<PasswordlessLoginMutation, PasswordlessLoginMutationVariables>;
export const PasswordlessRefreshTokenDocument = gql`
    mutation PasswordlessRefreshToken($input: PasswordlessRefreshTokenInput!) {
  passwordlessRefreshToken(input: $input) {
    ... on PasswordlessTokenResponse {
      accessToken
      expiresAtIso8601
      refreshToken
    }
    ... on PasswordlessAuthenticationError {
      code
      message
    }
  }
}
    `;
export type PasswordlessRefreshTokenMutationFn = Apollo.MutationFunction<PasswordlessRefreshTokenMutation, PasswordlessRefreshTokenMutationVariables>;

/**
 * __usePasswordlessRefreshTokenMutation__
 *
 * To run a mutation, you first call `usePasswordlessRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordlessRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordlessRefreshTokenMutation, { data, loading, error }] = usePasswordlessRefreshTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordlessRefreshTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PasswordlessRefreshTokenMutation, PasswordlessRefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PasswordlessRefreshTokenMutation, PasswordlessRefreshTokenMutationVariables>(PasswordlessRefreshTokenDocument, options);
      }
export type PasswordlessRefreshTokenMutationHookResult = ReturnType<typeof usePasswordlessRefreshTokenMutation>;
export type PasswordlessRefreshTokenMutationResult = Apollo.MutationResult<PasswordlessRefreshTokenMutation>;
export type PasswordlessRefreshTokenMutationOptions = Apollo.BaseMutationOptions<PasswordlessRefreshTokenMutation, PasswordlessRefreshTokenMutationVariables>;
export const CartDocument = gql`
    query Cart($guid: ID!, $totalGiftCardBalance: Float) {
  cartV2(guid: $guid) {
    ... on CartResponse {
      cart {
        restaurant {
          guid
          name
          deliveryProviders {
            provider
            enabled
          }
          location {
            ...LocationFields
          }
          shortUrl
          specialRequestsConfig {
            placeholderMessage
            enabled
          }
        }
        cartSource
        quoteTime
        takeoutQuoteTime
        deliveryQuoteTime
        diningOptionBehavior
        fulfillmentType
        fulfillmentDateTime
        deliveryProviderInfo {
          provider
          needsDeliveryCommunicationConsent
        }
        cartUpsellInfo {
          upsellItems
        }
        order {
          ...OrderFields
        }
        paymentOptions {
          atCheckout {
            paymentType
          }
          uponReceipt {
            paymentType
          }
        }
        preComputedTips {
          percent
          value
        }
      }
    }
    ... on CartError {
      code
      message
    }
  }
}
    ${LocationFieldsFragmentDoc}
${OrderFieldsFragmentDoc}`;

/**
 * __useCartQuery__
 *
 * To run a query within a React component, call `useCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartQuery({
 *   variables: {
 *      guid: // value for 'guid'
 *      totalGiftCardBalance: // value for 'totalGiftCardBalance'
 *   },
 * });
 */
export function useCartQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CartQuery, CartQueryVariables> & ({ variables: CartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CartQuery, CartQueryVariables>(CartDocument, options);
      }
export function useCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export function useCartSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export type CartQueryHookResult = ReturnType<typeof useCartQuery>;
export type CartLazyQueryHookResult = ReturnType<typeof useCartLazyQuery>;
export type CartSuspenseQueryHookResult = ReturnType<typeof useCartSuspenseQuery>;
export type CartQueryResult = Apollo.QueryResult<CartQuery, CartQueryVariables>;
export const CompletedOrderDocument = gql`
    query CompletedOrder($input: CompletedOrderInput!) {
  completedOrder(input: $input) {
    ...CompletedOrderFields
  }
}
    ${CompletedOrderFieldsFragmentDoc}`;

/**
 * __useCompletedOrderQuery__
 *
 * To run a query within a React component, call `useCompletedOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedOrderQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompletedOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompletedOrderQuery, CompletedOrderQueryVariables> & ({ variables: CompletedOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompletedOrderQuery, CompletedOrderQueryVariables>(CompletedOrderDocument, options);
      }
export function useCompletedOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompletedOrderQuery, CompletedOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompletedOrderQuery, CompletedOrderQueryVariables>(CompletedOrderDocument, options);
        }
export function useCompletedOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompletedOrderQuery, CompletedOrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompletedOrderQuery, CompletedOrderQueryVariables>(CompletedOrderDocument, options);
        }
export type CompletedOrderQueryHookResult = ReturnType<typeof useCompletedOrderQuery>;
export type CompletedOrderLazyQueryHookResult = ReturnType<typeof useCompletedOrderLazyQuery>;
export type CompletedOrderSuspenseQueryHookResult = ReturnType<typeof useCompletedOrderSuspenseQuery>;
export type CompletedOrderQueryResult = Apollo.QueryResult<CompletedOrderQuery, CompletedOrderQueryVariables>;
export const CreateGiftCardOrderDocument = gql`
    mutation CreateGiftCardOrder($input: CreateGiftCardOrderInput!) {
  createGiftCardOrder(input: $input) {
    orderGuid
  }
}
    `;
export type CreateGiftCardOrderMutationFn = Apollo.MutationFunction<CreateGiftCardOrderMutation, CreateGiftCardOrderMutationVariables>;

/**
 * __useCreateGiftCardOrderMutation__
 *
 * To run a mutation, you first call `useCreateGiftCardOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGiftCardOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGiftCardOrderMutation, { data, loading, error }] = useCreateGiftCardOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGiftCardOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateGiftCardOrderMutation, CreateGiftCardOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateGiftCardOrderMutation, CreateGiftCardOrderMutationVariables>(CreateGiftCardOrderDocument, options);
      }
export type CreateGiftCardOrderMutationHookResult = ReturnType<typeof useCreateGiftCardOrderMutation>;
export type CreateGiftCardOrderMutationResult = Apollo.MutationResult<CreateGiftCardOrderMutation>;
export type CreateGiftCardOrderMutationOptions = Apollo.BaseMutationOptions<CreateGiftCardOrderMutation, CreateGiftCardOrderMutationVariables>;
export const CustomerDocument = gql`
    query Customer {
  customer {
    ...CustomerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export function useCustomerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerSuspenseQueryHookResult = ReturnType<typeof useCustomerSuspenseQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const AddGuestIdentityDocument = gql`
    mutation AddGuestIdentity($input: AddGuestIdentityInput!) {
  addGuestIdentity(input: $input) {
    ... on AddGuestIdentitySuccess {
      success
    }
    ... on GuestIdentityAlreadyExistsForCurrentGuestError {
      message
    }
    ... on InvalidEmailError {
      message
    }
    ... on ProfileLockedForDeletionError {
      message
    }
    ... on UnexpectedError {
      message
    }
  }
}
    `;
export type AddGuestIdentityMutationFn = Apollo.MutationFunction<AddGuestIdentityMutation, AddGuestIdentityMutationVariables>;

/**
 * __useAddGuestIdentityMutation__
 *
 * To run a mutation, you first call `useAddGuestIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGuestIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGuestIdentityMutation, { data, loading, error }] = useAddGuestIdentityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddGuestIdentityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddGuestIdentityMutation, AddGuestIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddGuestIdentityMutation, AddGuestIdentityMutationVariables>(AddGuestIdentityDocument, options);
      }
export type AddGuestIdentityMutationHookResult = ReturnType<typeof useAddGuestIdentityMutation>;
export type AddGuestIdentityMutationResult = Apollo.MutationResult<AddGuestIdentityMutation>;
export type AddGuestIdentityMutationOptions = Apollo.BaseMutationOptions<AddGuestIdentityMutation, AddGuestIdentityMutationVariables>;
export const DeleteAddressDocument = gql`
    mutation DeleteAddress($input: DeleteAddressInput!) {
  deleteAddress(input: $input) {
    ... on DeleteAddressResponse {
      customer {
        ...CustomerFields
      }
    }
    ... on DeleteAddressError {
      code
      message
    }
  }
}
    ${CustomerFieldsFragmentDoc}`;
export type DeleteAddressMutationFn = Apollo.MutationFunction<DeleteAddressMutation, DeleteAddressMutationVariables>;

/**
 * __useDeleteAddressMutation__
 *
 * To run a mutation, you first call `useDeleteAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddressMutation, { data, loading, error }] = useDeleteAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAddressMutation, DeleteAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAddressMutation, DeleteAddressMutationVariables>(DeleteAddressDocument, options);
      }
export type DeleteAddressMutationHookResult = ReturnType<typeof useDeleteAddressMutation>;
export type DeleteAddressMutationResult = Apollo.MutationResult<DeleteAddressMutation>;
export type DeleteAddressMutationOptions = Apollo.BaseMutationOptions<DeleteAddressMutation, DeleteAddressMutationVariables>;
export const UpdateAddressDocument = gql`
    mutation UpdateAddress($input: UpdateAddressInput!) {
  updateAddress(input: $input) {
    ... on UpdateAddressResponse {
      customer {
        ...CustomerFields
      }
    }
    ... on UpdateAddressError {
      code
      message
    }
  }
}
    ${CustomerFieldsFragmentDoc}`;
export type UpdateAddressMutationFn = Apollo.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const ConfirmGuestIdentityDocument = gql`
    mutation ConfirmGuestIdentity($input: ConfirmGuestIdentityInput!) {
  confirmGuestIdentity(input: $input) {
    ... on ConfirmGuestIdentitySuccess {
      guest {
        id
      }
    }
    ... on IncorrectCodeError {
      message
    }
    ... on CodeExpiredError {
      message
    }
    ... on CodeAuthenticationError {
      message
    }
    ... on CodeMaxAttemptsReachedError {
      message
    }
    ... on GuestIdentityAlreadyExistsForAnotherGuestError {
      message
    }
    ... on UnexpectedConfirmCodeError {
      message
    }
  }
}
    `;
export type ConfirmGuestIdentityMutationFn = Apollo.MutationFunction<ConfirmGuestIdentityMutation, ConfirmGuestIdentityMutationVariables>;

/**
 * __useConfirmGuestIdentityMutation__
 *
 * To run a mutation, you first call `useConfirmGuestIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmGuestIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmGuestIdentityMutation, { data, loading, error }] = useConfirmGuestIdentityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmGuestIdentityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmGuestIdentityMutation, ConfirmGuestIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfirmGuestIdentityMutation, ConfirmGuestIdentityMutationVariables>(ConfirmGuestIdentityDocument, options);
      }
export type ConfirmGuestIdentityMutationHookResult = ReturnType<typeof useConfirmGuestIdentityMutation>;
export type ConfirmGuestIdentityMutationResult = Apollo.MutationResult<ConfirmGuestIdentityMutation>;
export type ConfirmGuestIdentityMutationOptions = Apollo.BaseMutationOptions<ConfirmGuestIdentityMutation, ConfirmGuestIdentityMutationVariables>;
export const UpdateBasicInfoDocument = gql`
    mutation UpdateBasicInfo($input: BasicInfoInput!) {
  updateBasicInfo(input: $input) {
    ... on UpdateBasicInfoResponse {
      customer {
        id: guid
        firstName
        lastName
        phone
      }
    }
    ... on UpdateBasicInfoError {
      code
      message
    }
  }
}
    `;
export type UpdateBasicInfoMutationFn = Apollo.MutationFunction<UpdateBasicInfoMutation, UpdateBasicInfoMutationVariables>;

/**
 * __useUpdateBasicInfoMutation__
 *
 * To run a mutation, you first call `useUpdateBasicInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBasicInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBasicInfoMutation, { data, loading, error }] = useUpdateBasicInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBasicInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBasicInfoMutation, UpdateBasicInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBasicInfoMutation, UpdateBasicInfoMutationVariables>(UpdateBasicInfoDocument, options);
      }
export type UpdateBasicInfoMutationHookResult = ReturnType<typeof useUpdateBasicInfoMutation>;
export type UpdateBasicInfoMutationResult = Apollo.MutationResult<UpdateBasicInfoMutation>;
export type UpdateBasicInfoMutationOptions = Apollo.BaseMutationOptions<UpdateBasicInfoMutation, UpdateBasicInfoMutationVariables>;
export const DeleteCreditCardDocument = gql`
    mutation DeleteCreditCard($input: DeleteCreditCardInput!) {
  deleteCreditCard(input: $input) {
    ... on DeleteCreditCardResponse {
      customer {
        ...CustomerFields
      }
    }
    ... on DeleteCreditCardError {
      code
      message
    }
  }
}
    ${CustomerFieldsFragmentDoc}`;
export type DeleteCreditCardMutationFn = Apollo.MutationFunction<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>;

/**
 * __useDeleteCreditCardMutation__
 *
 * To run a mutation, you first call `useDeleteCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreditCardMutation, { data, loading, error }] = useDeleteCreditCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCreditCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>(DeleteCreditCardDocument, options);
      }
export type DeleteCreditCardMutationHookResult = ReturnType<typeof useDeleteCreditCardMutation>;
export type DeleteCreditCardMutationResult = Apollo.MutationResult<DeleteCreditCardMutation>;
export type DeleteCreditCardMutationOptions = Apollo.BaseMutationOptions<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>;
export const DeleteFromCartDocument = gql`
    mutation DeleteFromCart($input: DeleteItemFromCartInput!) {
  deleteItemFromCartV2(input: $input) {
    ... on CartResponse {
      cart {
        guid
        cartSource
      }
    }
    ... on CartModificationError {
      code
      message
    }
    ... on CartOutOfStockError {
      message
      items {
        name
        guid
      }
    }
  }
}
    `;
export type DeleteFromCartMutationFn = Apollo.MutationFunction<DeleteFromCartMutation, DeleteFromCartMutationVariables>;

/**
 * __useDeleteFromCartMutation__
 *
 * To run a mutation, you first call `useDeleteFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFromCartMutation, { data, loading, error }] = useDeleteFromCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFromCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFromCartMutation, DeleteFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFromCartMutation, DeleteFromCartMutationVariables>(DeleteFromCartDocument, options);
      }
export type DeleteFromCartMutationHookResult = ReturnType<typeof useDeleteFromCartMutation>;
export type DeleteFromCartMutationResult = Apollo.MutationResult<DeleteFromCartMutation>;
export type DeleteFromCartMutationOptions = Apollo.BaseMutationOptions<DeleteFromCartMutation, DeleteFromCartMutationVariables>;
export const DoGetMenuGroupsDocument = gql`
    query doGetMenuGroups($input: DoMenus_GetMenuGroupsInput!) {
  doMenus_getMenuGroups(input: $input) {
    ... on DoMenus_GetMenuGroupsResponse {
      groups {
        guid
        masterId
        name
        description
        imageLink
        items {
          description
          groupGuid
          guid
          imageLink
          masterId
          name
          price
          itemTags {
            guid
            name
          }
        }
      }
    }
    ... on DoMenus_GetMenuGroupsError {
      message
    }
  }
}
    `;

/**
 * __useDoGetMenuGroupsQuery__
 *
 * To run a query within a React component, call `useDoGetMenuGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoGetMenuGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoGetMenuGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoGetMenuGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DoGetMenuGroupsQuery, DoGetMenuGroupsQueryVariables> & ({ variables: DoGetMenuGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DoGetMenuGroupsQuery, DoGetMenuGroupsQueryVariables>(DoGetMenuGroupsDocument, options);
      }
export function useDoGetMenuGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DoGetMenuGroupsQuery, DoGetMenuGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DoGetMenuGroupsQuery, DoGetMenuGroupsQueryVariables>(DoGetMenuGroupsDocument, options);
        }
export function useDoGetMenuGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DoGetMenuGroupsQuery, DoGetMenuGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DoGetMenuGroupsQuery, DoGetMenuGroupsQueryVariables>(DoGetMenuGroupsDocument, options);
        }
export type DoGetMenuGroupsQueryHookResult = ReturnType<typeof useDoGetMenuGroupsQuery>;
export type DoGetMenuGroupsLazyQueryHookResult = ReturnType<typeof useDoGetMenuGroupsLazyQuery>;
export type DoGetMenuGroupsSuspenseQueryHookResult = ReturnType<typeof useDoGetMenuGroupsSuspenseQuery>;
export type DoGetMenuGroupsQueryResult = Apollo.QueryResult<DoGetMenuGroupsQuery, DoGetMenuGroupsQueryVariables>;
export const DoGetMenuItemsDocument = gql`
    query doGetMenuItems($input: DoMenus_GetMenuItemsInput!) {
  doMenus_getMenuItems(input: $input) {
    ... on DoMenus_GetMenuItemsResponse {
      items {
        description
        groupGuid
        guid
        imageLink
        masterId
        name
        price
      }
    }
    ... on DoMenus_GetMenuItemsError {
      message
    }
  }
}
    `;

/**
 * __useDoGetMenuItemsQuery__
 *
 * To run a query within a React component, call `useDoGetMenuItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoGetMenuItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoGetMenuItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoGetMenuItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DoGetMenuItemsQuery, DoGetMenuItemsQueryVariables> & ({ variables: DoGetMenuItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DoGetMenuItemsQuery, DoGetMenuItemsQueryVariables>(DoGetMenuItemsDocument, options);
      }
export function useDoGetMenuItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DoGetMenuItemsQuery, DoGetMenuItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DoGetMenuItemsQuery, DoGetMenuItemsQueryVariables>(DoGetMenuItemsDocument, options);
        }
export function useDoGetMenuItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DoGetMenuItemsQuery, DoGetMenuItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DoGetMenuItemsQuery, DoGetMenuItemsQueryVariables>(DoGetMenuItemsDocument, options);
        }
export type DoGetMenuItemsQueryHookResult = ReturnType<typeof useDoGetMenuItemsQuery>;
export type DoGetMenuItemsLazyQueryHookResult = ReturnType<typeof useDoGetMenuItemsLazyQuery>;
export type DoGetMenuItemsSuspenseQueryHookResult = ReturnType<typeof useDoGetMenuItemsSuspenseQuery>;
export type DoGetMenuItemsQueryResult = Apollo.QueryResult<DoGetMenuItemsQuery, DoGetMenuItemsQueryVariables>;
export const DoMenuItemDocument = gql`
    query doMenuItem($input: DoMenus_FindMenuItemInput!) {
  doMenus_findMenuItem(input: $input) {
    ... on DoMenus_FindMenuItemResponse {
      menuResponse {
        modifierGroupReferences {
          guid
          defaultOptionsSubstitutionPricing
          defaultOptionsChargePrice
          pricingStrategy
          pricingRules {
            sizeSpecificPricingGuid
            sizeSequencePricingRules {
              sizeName
              sizeGuid
              sequencePrices {
                sequence
                price
              }
            }
          }
        }
      }
    }
    ... on DoMenus_FindMenuItemError {
      message
    }
  }
}
    `;

/**
 * __useDoMenuItemQuery__
 *
 * To run a query within a React component, call `useDoMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoMenuItemQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoMenuItemQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DoMenuItemQuery, DoMenuItemQueryVariables> & ({ variables: DoMenuItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DoMenuItemQuery, DoMenuItemQueryVariables>(DoMenuItemDocument, options);
      }
export function useDoMenuItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DoMenuItemQuery, DoMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DoMenuItemQuery, DoMenuItemQueryVariables>(DoMenuItemDocument, options);
        }
export function useDoMenuItemSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DoMenuItemQuery, DoMenuItemQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DoMenuItemQuery, DoMenuItemQueryVariables>(DoMenuItemDocument, options);
        }
export type DoMenuItemQueryHookResult = ReturnType<typeof useDoMenuItemQuery>;
export type DoMenuItemLazyQueryHookResult = ReturnType<typeof useDoMenuItemLazyQuery>;
export type DoMenuItemSuspenseQueryHookResult = ReturnType<typeof useDoMenuItemSuspenseQuery>;
export type DoMenuItemQueryResult = Apollo.QueryResult<DoMenuItemQuery, DoMenuItemQueryVariables>;
export const GuestFacingInstructionsDocument = gql`
    query GuestFacingInstructions($input: GuestFacingInstructionsQueryInput!) {
  getGuestFacingInstructions(input: $input) {
    confirmationInstructions {
      enabled
      message
    }
  }
}
    `;

/**
 * __useGuestFacingInstructionsQuery__
 *
 * To run a query within a React component, call `useGuestFacingInstructionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFacingInstructionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFacingInstructionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuestFacingInstructionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GuestFacingInstructionsQuery, GuestFacingInstructionsQueryVariables> & ({ variables: GuestFacingInstructionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GuestFacingInstructionsQuery, GuestFacingInstructionsQueryVariables>(GuestFacingInstructionsDocument, options);
      }
export function useGuestFacingInstructionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestFacingInstructionsQuery, GuestFacingInstructionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GuestFacingInstructionsQuery, GuestFacingInstructionsQueryVariables>(GuestFacingInstructionsDocument, options);
        }
export function useGuestFacingInstructionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GuestFacingInstructionsQuery, GuestFacingInstructionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GuestFacingInstructionsQuery, GuestFacingInstructionsQueryVariables>(GuestFacingInstructionsDocument, options);
        }
export type GuestFacingInstructionsQueryHookResult = ReturnType<typeof useGuestFacingInstructionsQuery>;
export type GuestFacingInstructionsLazyQueryHookResult = ReturnType<typeof useGuestFacingInstructionsLazyQuery>;
export type GuestFacingInstructionsSuspenseQueryHookResult = ReturnType<typeof useGuestFacingInstructionsSuspenseQuery>;
export type GuestFacingInstructionsQueryResult = Apollo.QueryResult<GuestFacingInstructionsQuery, GuestFacingInstructionsQueryVariables>;
export const EditCartItemDocument = gql`
    mutation EditCartItem($input: EditItemInCartInput!) {
  editItemInCartV2(input: $input) {
    ... on CartResponse {
      cart {
        guid
        cartSource
        expiredDate
        order {
          numberOfSelections
          taxV2
          totalV2
          selections {
            name
            price
            quantity
            modifiers {
              name
              price
            }
          }
        }
      }
    }
    ... on CartModificationError {
      code
      message
    }
    ... on CartOutOfStockError {
      message
      items {
        name
        guid
      }
    }
  }
}
    `;
export type EditCartItemMutationFn = Apollo.MutationFunction<EditCartItemMutation, EditCartItemMutationVariables>;

/**
 * __useEditCartItemMutation__
 *
 * To run a mutation, you first call `useEditCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCartItemMutation, { data, loading, error }] = useEditCartItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCartItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditCartItemMutation, EditCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditCartItemMutation, EditCartItemMutationVariables>(EditCartItemDocument, options);
      }
export type EditCartItemMutationHookResult = ReturnType<typeof useEditCartItemMutation>;
export type EditCartItemMutationResult = Apollo.MutationResult<EditCartItemMutation>;
export type EditCartItemMutationOptions = Apollo.BaseMutationOptions<EditCartItemMutation, EditCartItemMutationVariables>;
export const GetEGiftCardConfigDocument = gql`
    query GetEGiftCardConfig($restaurantGuid: ID!) {
  eGiftCardConfig(restaurantGuid: $restaurantGuid) {
    eGiftCardPurchasingEnabled
    minimumPurchaseAmount {
      value
      currency
    }
    maximumPurchaseAmount {
      currency
      value
    }
  }
}
    `;

/**
 * __useGetEGiftCardConfigQuery__
 *
 * To run a query within a React component, call `useGetEGiftCardConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEGiftCardConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEGiftCardConfigQuery({
 *   variables: {
 *      restaurantGuid: // value for 'restaurantGuid'
 *   },
 * });
 */
export function useGetEGiftCardConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEGiftCardConfigQuery, GetEGiftCardConfigQueryVariables> & ({ variables: GetEGiftCardConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEGiftCardConfigQuery, GetEGiftCardConfigQueryVariables>(GetEGiftCardConfigDocument, options);
      }
export function useGetEGiftCardConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEGiftCardConfigQuery, GetEGiftCardConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEGiftCardConfigQuery, GetEGiftCardConfigQueryVariables>(GetEGiftCardConfigDocument, options);
        }
export function useGetEGiftCardConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEGiftCardConfigQuery, GetEGiftCardConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEGiftCardConfigQuery, GetEGiftCardConfigQueryVariables>(GetEGiftCardConfigDocument, options);
        }
export type GetEGiftCardConfigQueryHookResult = ReturnType<typeof useGetEGiftCardConfigQuery>;
export type GetEGiftCardConfigLazyQueryHookResult = ReturnType<typeof useGetEGiftCardConfigLazyQuery>;
export type GetEGiftCardConfigSuspenseQueryHookResult = ReturnType<typeof useGetEGiftCardConfigSuspenseQuery>;
export type GetEGiftCardConfigQueryResult = Apollo.QueryResult<GetEGiftCardConfigQuery, GetEGiftCardConfigQueryVariables>;
export const GetShippingOptionsDocument = gql`
    query GetShippingOptions($input: ServiceGroupsQueryInput!) {
  getServiceGroups(input: $input) {
    objectId
    name
    description
    type
    flatRate
    flatRateCurrency
    freeShippingThresholdMin
    freeShippingThresholdCurrency
  }
}
    `;

/**
 * __useGetShippingOptionsQuery__
 *
 * To run a query within a React component, call `useGetShippingOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetShippingOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetShippingOptionsQuery, GetShippingOptionsQueryVariables> & ({ variables: GetShippingOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetShippingOptionsQuery, GetShippingOptionsQueryVariables>(GetShippingOptionsDocument, options);
      }
export function useGetShippingOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShippingOptionsQuery, GetShippingOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetShippingOptionsQuery, GetShippingOptionsQueryVariables>(GetShippingOptionsDocument, options);
        }
export function useGetShippingOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetShippingOptionsQuery, GetShippingOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetShippingOptionsQuery, GetShippingOptionsQueryVariables>(GetShippingOptionsDocument, options);
        }
export type GetShippingOptionsQueryHookResult = ReturnType<typeof useGetShippingOptionsQuery>;
export type GetShippingOptionsLazyQueryHookResult = ReturnType<typeof useGetShippingOptionsLazyQuery>;
export type GetShippingOptionsSuspenseQueryHookResult = ReturnType<typeof useGetShippingOptionsSuspenseQuery>;
export type GetShippingOptionsQueryResult = Apollo.QueryResult<GetShippingOptionsQuery, GetShippingOptionsQueryVariables>;
export const GiftCardBalanceDocument = gql`
    query GiftCardBalance($input: GiftCardBalanceInquiryInput!) {
  giftCardBalanceInquiry(input: $input) {
    ... on GiftCardBalanceInquiryResponse {
      availableBalance
      cardNumber
    }
    ... on GiftCardBalanceInquiryError {
      code
      message
    }
  }
}
    `;

/**
 * __useGiftCardBalanceQuery__
 *
 * To run a query within a React component, call `useGiftCardBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftCardBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftCardBalanceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGiftCardBalanceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GiftCardBalanceQuery, GiftCardBalanceQueryVariables> & ({ variables: GiftCardBalanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GiftCardBalanceQuery, GiftCardBalanceQueryVariables>(GiftCardBalanceDocument, options);
      }
export function useGiftCardBalanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GiftCardBalanceQuery, GiftCardBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GiftCardBalanceQuery, GiftCardBalanceQueryVariables>(GiftCardBalanceDocument, options);
        }
export function useGiftCardBalanceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GiftCardBalanceQuery, GiftCardBalanceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GiftCardBalanceQuery, GiftCardBalanceQueryVariables>(GiftCardBalanceDocument, options);
        }
export type GiftCardBalanceQueryHookResult = ReturnType<typeof useGiftCardBalanceQuery>;
export type GiftCardBalanceLazyQueryHookResult = ReturnType<typeof useGiftCardBalanceLazyQuery>;
export type GiftCardBalanceSuspenseQueryHookResult = ReturnType<typeof useGiftCardBalanceSuspenseQuery>;
export type GiftCardBalanceQueryResult = Apollo.QueryResult<GiftCardBalanceQuery, GiftCardBalanceQueryVariables>;
export const GiftCardExtensionBalanceDocument = gql`
    query GiftCardExtensionBalance($input: GiftCardExtensionBalanceInquiryInput!) {
  giftCardExtensionBalanceInquiry(input: $input) {
    ... on GiftCardBalanceInquiryResponse {
      availableBalance
      cardNumber
    }
    ... on GiftCardBalanceInquiryError {
      code
      message
    }
  }
}
    `;

/**
 * __useGiftCardExtensionBalanceQuery__
 *
 * To run a query within a React component, call `useGiftCardExtensionBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftCardExtensionBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftCardExtensionBalanceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGiftCardExtensionBalanceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GiftCardExtensionBalanceQuery, GiftCardExtensionBalanceQueryVariables> & ({ variables: GiftCardExtensionBalanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GiftCardExtensionBalanceQuery, GiftCardExtensionBalanceQueryVariables>(GiftCardExtensionBalanceDocument, options);
      }
export function useGiftCardExtensionBalanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GiftCardExtensionBalanceQuery, GiftCardExtensionBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GiftCardExtensionBalanceQuery, GiftCardExtensionBalanceQueryVariables>(GiftCardExtensionBalanceDocument, options);
        }
export function useGiftCardExtensionBalanceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GiftCardExtensionBalanceQuery, GiftCardExtensionBalanceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GiftCardExtensionBalanceQuery, GiftCardExtensionBalanceQueryVariables>(GiftCardExtensionBalanceDocument, options);
        }
export type GiftCardExtensionBalanceQueryHookResult = ReturnType<typeof useGiftCardExtensionBalanceQuery>;
export type GiftCardExtensionBalanceLazyQueryHookResult = ReturnType<typeof useGiftCardExtensionBalanceLazyQuery>;
export type GiftCardExtensionBalanceSuspenseQueryHookResult = ReturnType<typeof useGiftCardExtensionBalanceSuspenseQuery>;
export type GiftCardExtensionBalanceQueryResult = Apollo.QueryResult<GiftCardExtensionBalanceQuery, GiftCardExtensionBalanceQueryVariables>;
export const GuestDocument = gql`
    query Guest {
  guest {
    id
    contact {
      phone
      email
      firstName
      lastName
      contactEmails {
        email
        isVerified
      }
    }
  }
}
    `;

/**
 * __useGuestQuery__
 *
 * To run a query within a React component, call `useGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestQuery, GuestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GuestQuery, GuestQueryVariables>(GuestDocument, options);
      }
export function useGuestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestQuery, GuestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GuestQuery, GuestQueryVariables>(GuestDocument, options);
        }
export function useGuestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GuestQuery, GuestQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GuestQuery, GuestQueryVariables>(GuestDocument, options);
        }
export type GuestQueryHookResult = ReturnType<typeof useGuestQuery>;
export type GuestLazyQueryHookResult = ReturnType<typeof useGuestLazyQuery>;
export type GuestSuspenseQueryHookResult = ReturnType<typeof useGuestSuspenseQuery>;
export type GuestQueryResult = Apollo.QueryResult<GuestQuery, GuestQueryVariables>;
export const GuestWalletDocument = gql`
    query GuestWallet($timeZone: String!, $restaurantId: String) {
  guest {
    wallet {
      guestCurrencyAccount {
        id
        availableBalanceByRestaurant: availableBalance(restaurantGuid: $restaurantId) {
          amount
          currency
        }
        availableBalanceWithStoredValue {
          amount
          currency
        }
        nearestFutureExpirableDayValue(timeZone: $timeZone) {
          amount {
            amount
            currency
          }
          expirationDate
        }
      }
    }
  }
}
    `;

/**
 * __useGuestWalletQuery__
 *
 * To run a query within a React component, call `useGuestWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestWalletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestWalletQuery({
 *   variables: {
 *      timeZone: // value for 'timeZone'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useGuestWalletQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GuestWalletQuery, GuestWalletQueryVariables> & ({ variables: GuestWalletQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GuestWalletQuery, GuestWalletQueryVariables>(GuestWalletDocument, options);
      }
export function useGuestWalletLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestWalletQuery, GuestWalletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GuestWalletQuery, GuestWalletQueryVariables>(GuestWalletDocument, options);
        }
export function useGuestWalletSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GuestWalletQuery, GuestWalletQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GuestWalletQuery, GuestWalletQueryVariables>(GuestWalletDocument, options);
        }
export type GuestWalletQueryHookResult = ReturnType<typeof useGuestWalletQuery>;
export type GuestWalletLazyQueryHookResult = ReturnType<typeof useGuestWalletLazyQuery>;
export type GuestWalletSuspenseQueryHookResult = ReturnType<typeof useGuestWalletSuspenseQuery>;
export type GuestWalletQueryResult = Apollo.QueryResult<GuestWalletQuery, GuestWalletQueryVariables>;
export const AddLoyaltyToCartDocument = gql`
    mutation AddLoyaltyToCart($input: AddLoyaltyRedemptionV2Input!) {
  addLoyaltyRedemptionV2(input: $input) {
    ... on CartResponse {
      cart {
        guid
        cartSource
      }
    }
  }
}
    `;
export type AddLoyaltyToCartMutationFn = Apollo.MutationFunction<AddLoyaltyToCartMutation, AddLoyaltyToCartMutationVariables>;

/**
 * __useAddLoyaltyToCartMutation__
 *
 * To run a mutation, you first call `useAddLoyaltyToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLoyaltyToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLoyaltyToCartMutation, { data, loading, error }] = useAddLoyaltyToCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLoyaltyToCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddLoyaltyToCartMutation, AddLoyaltyToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddLoyaltyToCartMutation, AddLoyaltyToCartMutationVariables>(AddLoyaltyToCartDocument, options);
      }
export type AddLoyaltyToCartMutationHookResult = ReturnType<typeof useAddLoyaltyToCartMutation>;
export type AddLoyaltyToCartMutationResult = Apollo.MutationResult<AddLoyaltyToCartMutation>;
export type AddLoyaltyToCartMutationOptions = Apollo.BaseMutationOptions<AddLoyaltyToCartMutation, AddLoyaltyToCartMutationVariables>;
export const CustomerLoyaltyInfoDocument = gql`
    query CustomerLoyaltyInfo($input: CustomerLoyaltyInfoInput!) {
  customerLoyaltyInfo(input: $input) {
    ... on LoyaltyInquiryResponse {
      pointsBalance
      currentState {
        balance
        balancePoints
        messages {
          balance
          balanceShort
        }
      }
    }
  }
}
    `;

/**
 * __useCustomerLoyaltyInfoQuery__
 *
 * To run a query within a React component, call `useCustomerLoyaltyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerLoyaltyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerLoyaltyInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerLoyaltyInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CustomerLoyaltyInfoQuery, CustomerLoyaltyInfoQueryVariables> & ({ variables: CustomerLoyaltyInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomerLoyaltyInfoQuery, CustomerLoyaltyInfoQueryVariables>(CustomerLoyaltyInfoDocument, options);
      }
export function useCustomerLoyaltyInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomerLoyaltyInfoQuery, CustomerLoyaltyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomerLoyaltyInfoQuery, CustomerLoyaltyInfoQueryVariables>(CustomerLoyaltyInfoDocument, options);
        }
export function useCustomerLoyaltyInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomerLoyaltyInfoQuery, CustomerLoyaltyInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CustomerLoyaltyInfoQuery, CustomerLoyaltyInfoQueryVariables>(CustomerLoyaltyInfoDocument, options);
        }
export type CustomerLoyaltyInfoQueryHookResult = ReturnType<typeof useCustomerLoyaltyInfoQuery>;
export type CustomerLoyaltyInfoLazyQueryHookResult = ReturnType<typeof useCustomerLoyaltyInfoLazyQuery>;
export type CustomerLoyaltyInfoSuspenseQueryHookResult = ReturnType<typeof useCustomerLoyaltyInfoSuspenseQuery>;
export type CustomerLoyaltyInfoQueryResult = Apollo.QueryResult<CustomerLoyaltyInfoQuery, CustomerLoyaltyInfoQueryVariables>;
export const CustomerLoyaltySignupDocument = gql`
    mutation CustomerLoyaltySignup($input: LoyaltySignupInput!) {
  loyaltySignup(input: $input) {
    ... on LoyaltySignupResponse {
      customer {
        ...CustomerFields
      }
    }
  }
}
    ${CustomerFieldsFragmentDoc}`;
export type CustomerLoyaltySignupMutationFn = Apollo.MutationFunction<CustomerLoyaltySignupMutation, CustomerLoyaltySignupMutationVariables>;

/**
 * __useCustomerLoyaltySignupMutation__
 *
 * To run a mutation, you first call `useCustomerLoyaltySignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerLoyaltySignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerLoyaltySignupMutation, { data, loading, error }] = useCustomerLoyaltySignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerLoyaltySignupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CustomerLoyaltySignupMutation, CustomerLoyaltySignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CustomerLoyaltySignupMutation, CustomerLoyaltySignupMutationVariables>(CustomerLoyaltySignupDocument, options);
      }
export type CustomerLoyaltySignupMutationHookResult = ReturnType<typeof useCustomerLoyaltySignupMutation>;
export type CustomerLoyaltySignupMutationResult = Apollo.MutationResult<CustomerLoyaltySignupMutation>;
export type CustomerLoyaltySignupMutationOptions = Apollo.BaseMutationOptions<CustomerLoyaltySignupMutation, CustomerLoyaltySignupMutationVariables>;
export const LoyaltyFeaturesDocument = gql`
    query loyaltyFeatures($input: LoyaltyFeaturesInput!) {
  loyaltyFeatures(input: $input) {
    ... on LoyaltyFeaturesResponse {
      programDescription
      features {
        message
        description
        tags
      }
    }
  }
}
    `;

/**
 * __useLoyaltyFeaturesQuery__
 *
 * To run a query within a React component, call `useLoyaltyFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyFeaturesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoyaltyFeaturesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LoyaltyFeaturesQuery, LoyaltyFeaturesQueryVariables> & ({ variables: LoyaltyFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LoyaltyFeaturesQuery, LoyaltyFeaturesQueryVariables>(LoyaltyFeaturesDocument, options);
      }
export function useLoyaltyFeaturesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LoyaltyFeaturesQuery, LoyaltyFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LoyaltyFeaturesQuery, LoyaltyFeaturesQueryVariables>(LoyaltyFeaturesDocument, options);
        }
export function useLoyaltyFeaturesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LoyaltyFeaturesQuery, LoyaltyFeaturesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LoyaltyFeaturesQuery, LoyaltyFeaturesQueryVariables>(LoyaltyFeaturesDocument, options);
        }
export type LoyaltyFeaturesQueryHookResult = ReturnType<typeof useLoyaltyFeaturesQuery>;
export type LoyaltyFeaturesLazyQueryHookResult = ReturnType<typeof useLoyaltyFeaturesLazyQuery>;
export type LoyaltyFeaturesSuspenseQueryHookResult = ReturnType<typeof useLoyaltyFeaturesSuspenseQuery>;
export type LoyaltyFeaturesQueryResult = Apollo.QueryResult<LoyaltyFeaturesQuery, LoyaltyFeaturesQueryVariables>;
export const LoyaltyInquiryDocument = gql`
    mutation LoyaltyInquiry($input: LoyaltyInquiryInput!) {
  loyaltyInquiryV3(input: $input) {
    ... on LoyaltyInquiryResponse {
      ...LoyaltyInquiryResponseFields
    }
  }
}
    ${LoyaltyInquiryResponseFieldsFragmentDoc}`;
export type LoyaltyInquiryMutationFn = Apollo.MutationFunction<LoyaltyInquiryMutation, LoyaltyInquiryMutationVariables>;

/**
 * __useLoyaltyInquiryMutation__
 *
 * To run a mutation, you first call `useLoyaltyInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyInquiryMutation, { data, loading, error }] = useLoyaltyInquiryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoyaltyInquiryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoyaltyInquiryMutation, LoyaltyInquiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoyaltyInquiryMutation, LoyaltyInquiryMutationVariables>(LoyaltyInquiryDocument, options);
      }
export type LoyaltyInquiryMutationHookResult = ReturnType<typeof useLoyaltyInquiryMutation>;
export type LoyaltyInquiryMutationResult = Apollo.MutationResult<LoyaltyInquiryMutation>;
export type LoyaltyInquiryMutationOptions = Apollo.BaseMutationOptions<LoyaltyInquiryMutation, LoyaltyInquiryMutationVariables>;
export const RemoveLoyaltyFromCartDocument = gql`
    mutation RemoveLoyaltyFromCart($input: RemoveLoyaltyRedemptionV2Input!) {
  removeLoyaltyRedemptionV2(input: $input) {
    ... on CartResponse {
      cart {
        guid
        cartSource
      }
    }
  }
}
    `;
export type RemoveLoyaltyFromCartMutationFn = Apollo.MutationFunction<RemoveLoyaltyFromCartMutation, RemoveLoyaltyFromCartMutationVariables>;

/**
 * __useRemoveLoyaltyFromCartMutation__
 *
 * To run a mutation, you first call `useRemoveLoyaltyFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLoyaltyFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLoyaltyFromCartMutation, { data, loading, error }] = useRemoveLoyaltyFromCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveLoyaltyFromCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveLoyaltyFromCartMutation, RemoveLoyaltyFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveLoyaltyFromCartMutation, RemoveLoyaltyFromCartMutationVariables>(RemoveLoyaltyFromCartDocument, options);
      }
export type RemoveLoyaltyFromCartMutationHookResult = ReturnType<typeof useRemoveLoyaltyFromCartMutation>;
export type RemoveLoyaltyFromCartMutationResult = Apollo.MutationResult<RemoveLoyaltyFromCartMutation>;
export type RemoveLoyaltyFromCartMutationOptions = Apollo.BaseMutationOptions<RemoveLoyaltyFromCartMutation, RemoveLoyaltyFromCartMutationVariables>;
export const MakeCreditCardPrimaryDocument = gql`
    mutation MakeCreditCardPrimary($input: MakeCreditCardPrimaryInput!) {
  makeCreditCardPrimary(input: $input) {
    ... on MakeCreditCardPrimaryResponse {
      customer {
        ...CustomerFields
      }
    }
    ... on MakeCreditCardPrimaryError {
      code
      message
    }
  }
}
    ${CustomerFieldsFragmentDoc}`;
export type MakeCreditCardPrimaryMutationFn = Apollo.MutationFunction<MakeCreditCardPrimaryMutation, MakeCreditCardPrimaryMutationVariables>;

/**
 * __useMakeCreditCardPrimaryMutation__
 *
 * To run a mutation, you first call `useMakeCreditCardPrimaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeCreditCardPrimaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeCreditCardPrimaryMutation, { data, loading, error }] = useMakeCreditCardPrimaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeCreditCardPrimaryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MakeCreditCardPrimaryMutation, MakeCreditCardPrimaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MakeCreditCardPrimaryMutation, MakeCreditCardPrimaryMutationVariables>(MakeCreditCardPrimaryDocument, options);
      }
export type MakeCreditCardPrimaryMutationHookResult = ReturnType<typeof useMakeCreditCardPrimaryMutation>;
export type MakeCreditCardPrimaryMutationResult = Apollo.MutationResult<MakeCreditCardPrimaryMutation>;
export type MakeCreditCardPrimaryMutationOptions = Apollo.BaseMutationOptions<MakeCreditCardPrimaryMutation, MakeCreditCardPrimaryMutationVariables>;
export const MarketingConfigDocument = gql`
    query MarketingConfig($input: MarketingConfigQueryInput!) {
  marketing {
    marketingConfig(input: $input) {
      __typename
      ... on MarketingConfigQuerySuccessResponse {
        smsAccountEnabled
      }
    }
  }
}
    `;

/**
 * __useMarketingConfigQuery__
 *
 * To run a query within a React component, call `useMarketingConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingConfigQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarketingConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MarketingConfigQuery, MarketingConfigQueryVariables> & ({ variables: MarketingConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MarketingConfigQuery, MarketingConfigQueryVariables>(MarketingConfigDocument, options);
      }
export function useMarketingConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MarketingConfigQuery, MarketingConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MarketingConfigQuery, MarketingConfigQueryVariables>(MarketingConfigDocument, options);
        }
export function useMarketingConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MarketingConfigQuery, MarketingConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MarketingConfigQuery, MarketingConfigQueryVariables>(MarketingConfigDocument, options);
        }
export type MarketingConfigQueryHookResult = ReturnType<typeof useMarketingConfigQuery>;
export type MarketingConfigLazyQueryHookResult = ReturnType<typeof useMarketingConfigLazyQuery>;
export type MarketingConfigSuspenseQueryHookResult = ReturnType<typeof useMarketingConfigSuspenseQuery>;
export type MarketingConfigQueryResult = Apollo.QueryResult<MarketingConfigQuery, MarketingConfigQueryVariables>;
export const MarketingSubscriptionDocument = gql`
    mutation MarketingSubscription($input: CreateMarketingSubscriptionRequestInput!) {
  marketing {
    marketingSubscription(input: $input) {
      __typename
      ... on CreateMarketingSubscriptionRequestSuccessResponse {
        source
        firstName
        lastName
        restaurantGuid
        subscriptions {
          value
          channel
        }
      }
      ... on CreateMarketingSubscriptionRequestError {
        message
      }
    }
  }
}
    `;
export type MarketingSubscriptionMutationFn = Apollo.MutationFunction<MarketingSubscriptionMutation, MarketingSubscriptionMutationVariables>;

/**
 * __useMarketingSubscriptionMutation__
 *
 * To run a mutation, you first call `useMarketingSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarketingSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marketingSubscriptionMutation, { data, loading, error }] = useMarketingSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarketingSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarketingSubscriptionMutation, MarketingSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarketingSubscriptionMutation, MarketingSubscriptionMutationVariables>(MarketingSubscriptionDocument, options);
      }
export type MarketingSubscriptionMutationHookResult = ReturnType<typeof useMarketingSubscriptionMutation>;
export type MarketingSubscriptionMutationResult = Apollo.MutationResult<MarketingSubscriptionMutation>;
export type MarketingSubscriptionMutationOptions = Apollo.BaseMutationOptions<MarketingSubscriptionMutation, MarketingSubscriptionMutationVariables>;
export const MenuItemDetailsDocument = gql`
    query MenuItemDetails($input: MenuItemDetailsInput!, $nestingLevel: Int) {
  menuItemDetails(input: $input) {
    description
    name
    prices
    masterId
    contentAdvisories {
      alcohol {
        containsAlcohol
      }
    }
    imageUrls {
      ...ImageFields
    }
    timeBasedRules {
      leadTimeRule {
        leadTime
      }
      preorderRule {
        fulfillmentDateRange {
          start
          end
        }
      }
      pickupWindowRule {
        days {
          dayOfWeek
          pickupWindows {
            duration
          }
        }
      }
    }
    itemTags {
      guid
      name
    }
    usesFractionalQuantity
    unitOfMeasure
    modifierGroups(nestingLevel: $nestingLevel) {
      ...ModifierGroupFields
      modifiers {
        ...ModifierFields
        modifierGroups {
          ...ModifierGroupFields
          modifiers {
            ...ModifierFields
            modifierGroups {
              ...ModifierGroupFields
              modifiers {
                ...ModifierFields
                modifierGroups {
                  ...ModifierGroupFields
                  modifiers {
                    ...ModifierFields
                    modifierGroups {
                      ...ModifierGroupFields
                      modifiers {
                        ...ModifierFields
                        modifierGroups {
                          ...ModifierGroupFields
                          modifiers {
                            ...ModifierFields
                            modifierGroups {
                              ...ModifierGroupFields
                              modifiers {
                                ...ModifierFields
                                modifierGroups {
                                  ...ModifierGroupFields
                                  modifiers {
                                    ...ModifierFields
                                    modifierGroups {
                                      ...ModifierGroupFields
                                      modifiers {
                                        ...ModifierFields
                                        modifierGroups {
                                          ...ModifierGroupFields
                                          modifiers {
                                            ...ModifierFields
                                            modifierGroups {
                                              ...ModifierGroupFields
                                              modifiers {
                                                ...ModifierFields
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ImageFieldsFragmentDoc}
${ModifierGroupFieldsFragmentDoc}
${ModifierFieldsFragmentDoc}`;

/**
 * __useMenuItemDetailsQuery__
 *
 * To run a query within a React component, call `useMenuItemDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuItemDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuItemDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      nestingLevel: // value for 'nestingLevel'
 *   },
 * });
 */
export function useMenuItemDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MenuItemDetailsQuery, MenuItemDetailsQueryVariables> & ({ variables: MenuItemDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MenuItemDetailsQuery, MenuItemDetailsQueryVariables>(MenuItemDetailsDocument, options);
      }
export function useMenuItemDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MenuItemDetailsQuery, MenuItemDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MenuItemDetailsQuery, MenuItemDetailsQueryVariables>(MenuItemDetailsDocument, options);
        }
export function useMenuItemDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MenuItemDetailsQuery, MenuItemDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MenuItemDetailsQuery, MenuItemDetailsQueryVariables>(MenuItemDetailsDocument, options);
        }
export type MenuItemDetailsQueryHookResult = ReturnType<typeof useMenuItemDetailsQuery>;
export type MenuItemDetailsLazyQueryHookResult = ReturnType<typeof useMenuItemDetailsLazyQuery>;
export type MenuItemDetailsSuspenseQueryHookResult = ReturnType<typeof useMenuItemDetailsSuspenseQuery>;
export type MenuItemDetailsQueryResult = Apollo.QueryResult<MenuItemDetailsQuery, MenuItemDetailsQueryVariables>;
export const MenuItemFromCartDocument = gql`
    query MenuItemFromCart($input: SelectionItemDetailsInput!, $nestingLevel: Int) {
  selectionItemDetails(input: $input) {
    ...SelectionItemDetailsFields
  }
}
    ${SelectionItemDetailsFieldsFragmentDoc}`;

/**
 * __useMenuItemFromCartQuery__
 *
 * To run a query within a React component, call `useMenuItemFromCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuItemFromCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuItemFromCartQuery({
 *   variables: {
 *      input: // value for 'input'
 *      nestingLevel: // value for 'nestingLevel'
 *   },
 * });
 */
export function useMenuItemFromCartQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MenuItemFromCartQuery, MenuItemFromCartQueryVariables> & ({ variables: MenuItemFromCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MenuItemFromCartQuery, MenuItemFromCartQueryVariables>(MenuItemFromCartDocument, options);
      }
export function useMenuItemFromCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MenuItemFromCartQuery, MenuItemFromCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MenuItemFromCartQuery, MenuItemFromCartQueryVariables>(MenuItemFromCartDocument, options);
        }
export function useMenuItemFromCartSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MenuItemFromCartQuery, MenuItemFromCartQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MenuItemFromCartQuery, MenuItemFromCartQueryVariables>(MenuItemFromCartDocument, options);
        }
export type MenuItemFromCartQueryHookResult = ReturnType<typeof useMenuItemFromCartQuery>;
export type MenuItemFromCartLazyQueryHookResult = ReturnType<typeof useMenuItemFromCartLazyQuery>;
export type MenuItemFromCartSuspenseQueryHookResult = ReturnType<typeof useMenuItemFromCartSuspenseQuery>;
export type MenuItemFromCartQueryResult = Apollo.QueryResult<MenuItemFromCartQuery, MenuItemFromCartQueryVariables>;
export const OoAvailabilityDocument = gql`
    query OOAvailability($restaurantGuid: ID!, $fulfillmentDaysAhead: Int) {
  restaurantV2(guid: $restaurantGuid) {
    ... on Restaurant {
      onlineOrderingEnabled
    }
  }
  diningOptions(
    input: {includeBehaviors: [], restaurantGuid: $restaurantGuid, futureFulfillmentDaysAhead: $fulfillmentDaysAhead}
  ) {
    ...DiningOptionFragment
  }
}
    ${DiningOptionFragmentFragmentDoc}`;

/**
 * __useOoAvailabilityQuery__
 *
 * To run a query within a React component, call `useOoAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOoAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOoAvailabilityQuery({
 *   variables: {
 *      restaurantGuid: // value for 'restaurantGuid'
 *      fulfillmentDaysAhead: // value for 'fulfillmentDaysAhead'
 *   },
 * });
 */
export function useOoAvailabilityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OoAvailabilityQuery, OoAvailabilityQueryVariables> & ({ variables: OoAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OoAvailabilityQuery, OoAvailabilityQueryVariables>(OoAvailabilityDocument, options);
      }
export function useOoAvailabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OoAvailabilityQuery, OoAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OoAvailabilityQuery, OoAvailabilityQueryVariables>(OoAvailabilityDocument, options);
        }
export function useOoAvailabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OoAvailabilityQuery, OoAvailabilityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OoAvailabilityQuery, OoAvailabilityQueryVariables>(OoAvailabilityDocument, options);
        }
export type OoAvailabilityQueryHookResult = ReturnType<typeof useOoAvailabilityQuery>;
export type OoAvailabilityLazyQueryHookResult = ReturnType<typeof useOoAvailabilityLazyQuery>;
export type OoAvailabilitySuspenseQueryHookResult = ReturnType<typeof useOoAvailabilitySuspenseQuery>;
export type OoAvailabilityQueryResult = Apollo.QueryResult<OoAvailabilityQuery, OoAvailabilityQueryVariables>;
export const OrderHistoryDocument = gql`
    query OrderHistory($input: OrderHistoryInput!) {
  orderHistory(input: $input) {
    nextPageToken
    orders {
      guid
      totalV2
      estimatedFulfillmentDate
      numberOfSelections
      selections {
        name
        quantity
        price
      }
    }
  }
}
    `;

/**
 * __useOrderHistoryQuery__
 *
 * To run a query within a React component, call `useOrderHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrderHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrderHistoryQuery, OrderHistoryQueryVariables> & ({ variables: OrderHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrderHistoryQuery, OrderHistoryQueryVariables>(OrderHistoryDocument, options);
      }
export function useOrderHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderHistoryQuery, OrderHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrderHistoryQuery, OrderHistoryQueryVariables>(OrderHistoryDocument, options);
        }
export function useOrderHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrderHistoryQuery, OrderHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrderHistoryQuery, OrderHistoryQueryVariables>(OrderHistoryDocument, options);
        }
export type OrderHistoryQueryHookResult = ReturnType<typeof useOrderHistoryQuery>;
export type OrderHistoryLazyQueryHookResult = ReturnType<typeof useOrderHistoryLazyQuery>;
export type OrderHistorySuspenseQueryHookResult = ReturnType<typeof useOrderHistorySuspenseQuery>;
export type OrderHistoryQueryResult = Apollo.QueryResult<OrderHistoryQuery, OrderHistoryQueryVariables>;
export const GetOrderStatusesDocument = gql`
    query getOrderStatuses($input: OrderStatusesInput!) {
  orderStatuses(input: $input) {
    ... on OrderStatusesResponse {
      orderStatusesResponse {
        orderGuid
        restaurantGuid
        firstName
        lastNameInitial
        guestOrderStatus
        checkDisplayNumber
        diningOption {
          ... on DiningOption {
            guid
            behavior
            description
          }
        }
        channelGuid
        lastUpdated
        version
        estimatedFulfillmentDate
        trackingDetails {
          ... on TrackingDetails {
            quotedPickUpTime
            quotedDeliveryTime
            estimatedPickUpTime
            estimatedDeliveryTime
            actualDeliveryTime
            deliveryProviderName
            deliveryDriver {
              ... on DeliveryDriver {
                name
                phoneNumber
                profileImageUrl
              }
            }
            driverLocation {
              ... on DeliveryDriverLocation {
                latitude
                longitude
              }
            }
            dropOffImageUrl
            trackingUrl
            deliveryTimeException
          }
        }
        deliveryStatus
      }
    }
  }
}
    `;

/**
 * __useGetOrderStatusesQuery__
 *
 * To run a query within a React component, call `useGetOrderStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderStatusesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrderStatusesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOrderStatusesQuery, GetOrderStatusesQueryVariables> & ({ variables: GetOrderStatusesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrderStatusesQuery, GetOrderStatusesQueryVariables>(GetOrderStatusesDocument, options);
      }
export function useGetOrderStatusesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderStatusesQuery, GetOrderStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrderStatusesQuery, GetOrderStatusesQueryVariables>(GetOrderStatusesDocument, options);
        }
export function useGetOrderStatusesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOrderStatusesQuery, GetOrderStatusesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOrderStatusesQuery, GetOrderStatusesQueryVariables>(GetOrderStatusesDocument, options);
        }
export type GetOrderStatusesQueryHookResult = ReturnType<typeof useGetOrderStatusesQuery>;
export type GetOrderStatusesLazyQueryHookResult = ReturnType<typeof useGetOrderStatusesLazyQuery>;
export type GetOrderStatusesSuspenseQueryHookResult = ReturnType<typeof useGetOrderStatusesSuspenseQuery>;
export type GetOrderStatusesQueryResult = Apollo.QueryResult<GetOrderStatusesQuery, GetOrderStatusesQueryVariables>;
export const PaginatedMenuItemsDocument = gql`
    query PaginatedMenuItems($input: PaginatedMenusInput!) {
  paginatedMenuItems(input: $input) {
    menus {
      guid: id
      name
      groups {
        name
        description
        guid
        items {
          ...MenuItemFragment
        }
      }
    }
    items {
      ...MenuItemFragment
    }
    groupings {
      name
      guid
      itemCount
      children {
        name
        guid
        itemCount
        children {
          name
          guid
          itemCount
        }
      }
    }
    totalCount
    count
  }
}
    ${MenuItemFragmentFragmentDoc}`;

/**
 * __usePaginatedMenuItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedMenuItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedMenuItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedMenuItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedMenuItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedMenuItemsQuery, PaginatedMenuItemsQueryVariables> & ({ variables: PaginatedMenuItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedMenuItemsQuery, PaginatedMenuItemsQueryVariables>(PaginatedMenuItemsDocument, options);
      }
export function usePaginatedMenuItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedMenuItemsQuery, PaginatedMenuItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedMenuItemsQuery, PaginatedMenuItemsQueryVariables>(PaginatedMenuItemsDocument, options);
        }
export function usePaginatedMenuItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaginatedMenuItemsQuery, PaginatedMenuItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PaginatedMenuItemsQuery, PaginatedMenuItemsQueryVariables>(PaginatedMenuItemsDocument, options);
        }
export type PaginatedMenuItemsQueryHookResult = ReturnType<typeof usePaginatedMenuItemsQuery>;
export type PaginatedMenuItemsLazyQueryHookResult = ReturnType<typeof usePaginatedMenuItemsLazyQuery>;
export type PaginatedMenuItemsSuspenseQueryHookResult = ReturnType<typeof usePaginatedMenuItemsSuspenseQuery>;
export type PaginatedMenuItemsQueryResult = Apollo.QueryResult<PaginatedMenuItemsQuery, PaginatedMenuItemsQueryVariables>;
export const PaginatedMenuItemsWithPopularItemsDocument = gql`
    query PaginatedMenuItemsWithPopularItems($input: PaginatedMenusInput!, $popularItemsInput: PopularItemsInput!) {
  paginatedMenuItems(input: $input) {
    menus {
      guid: id
      name
      groups {
        name
        description
        guid
        items {
          ...MenuItemFragment
        }
      }
    }
    items {
      ...MenuItemFragment
    }
    groupings {
      name
      guid
      itemCount
      children {
        name
        guid
        itemCount
        children {
          name
          guid
          itemCount
        }
      }
    }
    totalCount
    count
  }
  popularItems(input: $popularItemsInput) {
    __typename
    ... on PopularItemsResponse {
      items {
        guid
        itemGroupGuid
        name
        description
        prices
        defaultModifiersPrice
        masterId
        imageUrls {
          ...ImageFields
        }
        timeBasedRules {
          leadTimeRule {
            leadTime
          }
          preorderRule {
            fulfillmentDateRange {
              start
              end
            }
            orderDateRange {
              start
              end
            }
          }
          pickupWindowRule {
            days {
              dayOfWeek
              pickupWindows {
                duration
              }
            }
          }
        }
        itemTags {
          guid
          name
        }
      }
    }
    ... on PopularItemsError {
      message
    }
  }
}
    ${MenuItemFragmentFragmentDoc}
${ImageFieldsFragmentDoc}`;

/**
 * __usePaginatedMenuItemsWithPopularItemsQuery__
 *
 * To run a query within a React component, call `usePaginatedMenuItemsWithPopularItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedMenuItemsWithPopularItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedMenuItemsWithPopularItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      popularItemsInput: // value for 'popularItemsInput'
 *   },
 * });
 */
export function usePaginatedMenuItemsWithPopularItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedMenuItemsWithPopularItemsQuery, PaginatedMenuItemsWithPopularItemsQueryVariables> & ({ variables: PaginatedMenuItemsWithPopularItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedMenuItemsWithPopularItemsQuery, PaginatedMenuItemsWithPopularItemsQueryVariables>(PaginatedMenuItemsWithPopularItemsDocument, options);
      }
export function usePaginatedMenuItemsWithPopularItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedMenuItemsWithPopularItemsQuery, PaginatedMenuItemsWithPopularItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedMenuItemsWithPopularItemsQuery, PaginatedMenuItemsWithPopularItemsQueryVariables>(PaginatedMenuItemsWithPopularItemsDocument, options);
        }
export function usePaginatedMenuItemsWithPopularItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaginatedMenuItemsWithPopularItemsQuery, PaginatedMenuItemsWithPopularItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PaginatedMenuItemsWithPopularItemsQuery, PaginatedMenuItemsWithPopularItemsQueryVariables>(PaginatedMenuItemsWithPopularItemsDocument, options);
        }
export type PaginatedMenuItemsWithPopularItemsQueryHookResult = ReturnType<typeof usePaginatedMenuItemsWithPopularItemsQuery>;
export type PaginatedMenuItemsWithPopularItemsLazyQueryHookResult = ReturnType<typeof usePaginatedMenuItemsWithPopularItemsLazyQuery>;
export type PaginatedMenuItemsWithPopularItemsSuspenseQueryHookResult = ReturnType<typeof usePaginatedMenuItemsWithPopularItemsSuspenseQuery>;
export type PaginatedMenuItemsWithPopularItemsQueryResult = Apollo.QueryResult<PaginatedMenuItemsWithPopularItemsQuery, PaginatedMenuItemsWithPopularItemsQueryVariables>;
export const PayForCheckDocument = gql`
    mutation PayForCheck($input: PayForCheckInput!) {
  payForCheck(input: $input) {
    ... on PayForCheckResponse {
      remainingChecks {
        guid
      }
    }
    ... on PayForCheckError {
      code
      message
    }
  }
}
    `;
export type PayForCheckMutationFn = Apollo.MutationFunction<PayForCheckMutation, PayForCheckMutationVariables>;

/**
 * __usePayForCheckMutation__
 *
 * To run a mutation, you first call `usePayForCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayForCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payForCheckMutation, { data, loading, error }] = usePayForCheckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePayForCheckMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PayForCheckMutation, PayForCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PayForCheckMutation, PayForCheckMutationVariables>(PayForCheckDocument, options);
      }
export type PayForCheckMutationHookResult = ReturnType<typeof usePayForCheckMutation>;
export type PayForCheckMutationResult = Apollo.MutationResult<PayForCheckMutation>;
export type PayForCheckMutationOptions = Apollo.BaseMutationOptions<PayForCheckMutation, PayForCheckMutationVariables>;
export const CreateGiftCardPaymentIntentDocument = gql`
    mutation CreateGiftCardPaymentIntent($input: OnlineOrderingSpiCreateGiftCardPaymentIntentInput!) {
  oo {
    spiCreateGiftCardPaymentIntent(input: $input) {
      ... on OnlineOrderingPaymentIntentError {
        message
      }
      ... on OnlineOrderingSpiCreatePaymentIntentSuccessResponse {
        amount
        captureMethod
        creationDate
        currency
        externalReferenceId
        id
        sessionSecret
        status
      }
    }
  }
}
    `;
export type CreateGiftCardPaymentIntentMutationFn = Apollo.MutationFunction<CreateGiftCardPaymentIntentMutation, CreateGiftCardPaymentIntentMutationVariables>;

/**
 * __useCreateGiftCardPaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreateGiftCardPaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGiftCardPaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGiftCardPaymentIntentMutation, { data, loading, error }] = useCreateGiftCardPaymentIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGiftCardPaymentIntentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateGiftCardPaymentIntentMutation, CreateGiftCardPaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateGiftCardPaymentIntentMutation, CreateGiftCardPaymentIntentMutationVariables>(CreateGiftCardPaymentIntentDocument, options);
      }
export type CreateGiftCardPaymentIntentMutationHookResult = ReturnType<typeof useCreateGiftCardPaymentIntentMutation>;
export type CreateGiftCardPaymentIntentMutationResult = Apollo.MutationResult<CreateGiftCardPaymentIntentMutation>;
export type CreateGiftCardPaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreateGiftCardPaymentIntentMutation, CreateGiftCardPaymentIntentMutationVariables>;
export const CreatePaymentIntentDocument = gql`
    mutation CreatePaymentIntent($input: OnlineOrderingSpiCreatePaymentIntentInput!) {
  oo {
    spiCreatePaymentIntent(input: $input) {
      ... on OnlineOrderingPaymentIntentError {
        message
      }
      ... on OnlineOrderingSpiCreatePaymentIntentSuccessResponse {
        amount
        captureMethod
        creationDate
        currency
        externalReferenceId
        id
        sessionSecret
        status
      }
    }
  }
}
    `;
export type CreatePaymentIntentMutationFn = Apollo.MutationFunction<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>;

/**
 * __useCreatePaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentIntentMutation, { data, loading, error }] = useCreatePaymentIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentIntentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>(CreatePaymentIntentDocument, options);
      }
export type CreatePaymentIntentMutationHookResult = ReturnType<typeof useCreatePaymentIntentMutation>;
export type CreatePaymentIntentMutationResult = Apollo.MutationResult<CreatePaymentIntentMutation>;
export type CreatePaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>;
export const GetClientTokenDocument = gql`
    query GetClientToken {
  oo {
    spiGetClientToken {
      ... on OnlineOrderingSpiGetClientTokenSuccessResponse {
        token
      }
      ... on OnlineOrderingPaymentIntentError {
        message
      }
    }
  }
}
    `;

/**
 * __useGetClientTokenQuery__
 *
 * To run a query within a React component, call `useGetClientTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClientTokenQuery, GetClientTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientTokenQuery, GetClientTokenQueryVariables>(GetClientTokenDocument, options);
      }
export function useGetClientTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientTokenQuery, GetClientTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientTokenQuery, GetClientTokenQueryVariables>(GetClientTokenDocument, options);
        }
export function useGetClientTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClientTokenQuery, GetClientTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClientTokenQuery, GetClientTokenQueryVariables>(GetClientTokenDocument, options);
        }
export type GetClientTokenQueryHookResult = ReturnType<typeof useGetClientTokenQuery>;
export type GetClientTokenLazyQueryHookResult = ReturnType<typeof useGetClientTokenLazyQuery>;
export type GetClientTokenSuspenseQueryHookResult = ReturnType<typeof useGetClientTokenSuspenseQuery>;
export type GetClientTokenQueryResult = Apollo.QueryResult<GetClientTokenQuery, GetClientTokenQueryVariables>;
export const UpdateGiftCardPaymentIntentDocument = gql`
    mutation UpdateGiftCardPaymentIntent($input: OnlineOrderingSpiUpdateGiftCardPaymentIntentInput!) {
  oo {
    spiUpdateGiftCardPaymentIntent(input: $input) {
      ... on OnlineOrderingPaymentIntentError {
        message
      }
      ... on OnlineOrderingSpiUpdatePaymentIntentSuccessResponse {
        guestGuid
        intentAmount
      }
    }
  }
}
    `;
export type UpdateGiftCardPaymentIntentMutationFn = Apollo.MutationFunction<UpdateGiftCardPaymentIntentMutation, UpdateGiftCardPaymentIntentMutationVariables>;

/**
 * __useUpdateGiftCardPaymentIntentMutation__
 *
 * To run a mutation, you first call `useUpdateGiftCardPaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGiftCardPaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGiftCardPaymentIntentMutation, { data, loading, error }] = useUpdateGiftCardPaymentIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGiftCardPaymentIntentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGiftCardPaymentIntentMutation, UpdateGiftCardPaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateGiftCardPaymentIntentMutation, UpdateGiftCardPaymentIntentMutationVariables>(UpdateGiftCardPaymentIntentDocument, options);
      }
export type UpdateGiftCardPaymentIntentMutationHookResult = ReturnType<typeof useUpdateGiftCardPaymentIntentMutation>;
export type UpdateGiftCardPaymentIntentMutationResult = Apollo.MutationResult<UpdateGiftCardPaymentIntentMutation>;
export type UpdateGiftCardPaymentIntentMutationOptions = Apollo.BaseMutationOptions<UpdateGiftCardPaymentIntentMutation, UpdateGiftCardPaymentIntentMutationVariables>;
export const UpdatePaymentIntentDocument = gql`
    mutation UpdatePaymentIntent($input: OnlineOrderingSpiUpdatePaymentIntentInput!) {
  oo {
    spiUpdatePaymentIntent(input: $input) {
      ... on OnlineOrderingPaymentIntentError {
        message
      }
      ... on OnlineOrderingSpiUpdatePaymentIntentSuccessResponse {
        guestGuid
        intentAmount
        surchargeAmount
      }
    }
  }
}
    `;
export type UpdatePaymentIntentMutationFn = Apollo.MutationFunction<UpdatePaymentIntentMutation, UpdatePaymentIntentMutationVariables>;

/**
 * __useUpdatePaymentIntentMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentIntentMutation, { data, loading, error }] = useUpdatePaymentIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentIntentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePaymentIntentMutation, UpdatePaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePaymentIntentMutation, UpdatePaymentIntentMutationVariables>(UpdatePaymentIntentDocument, options);
      }
export type UpdatePaymentIntentMutationHookResult = ReturnType<typeof useUpdatePaymentIntentMutation>;
export type UpdatePaymentIntentMutationResult = Apollo.MutationResult<UpdatePaymentIntentMutation>;
export type UpdatePaymentIntentMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentIntentMutation, UpdatePaymentIntentMutationVariables>;
export const PlaceCashOrderDocument = gql`
    mutation PlaceCashOrder($input: PlaceCashOrderInput!) {
  placeOrder: placeCashOrder(input: $input) {
    ... on PlaceOrderResponse {
      completedOrder {
        ...CompletedOrderFields
      }
    }
    ... on PlaceOrderError {
      placeOrderErrorCode: code
      message
    }
    ... on PlaceOrderCartUpdatedError {
      placeOrderCartUpdatedErrorCode: code
      message
      cart {
        guid
      }
    }
  }
}
    ${CompletedOrderFieldsFragmentDoc}`;
export type PlaceCashOrderMutationFn = Apollo.MutationFunction<PlaceCashOrderMutation, PlaceCashOrderMutationVariables>;

/**
 * __usePlaceCashOrderMutation__
 *
 * To run a mutation, you first call `usePlaceCashOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceCashOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeCashOrderMutation, { data, loading, error }] = usePlaceCashOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlaceCashOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PlaceCashOrderMutation, PlaceCashOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PlaceCashOrderMutation, PlaceCashOrderMutationVariables>(PlaceCashOrderDocument, options);
      }
export type PlaceCashOrderMutationHookResult = ReturnType<typeof usePlaceCashOrderMutation>;
export type PlaceCashOrderMutationResult = Apollo.MutationResult<PlaceCashOrderMutation>;
export type PlaceCashOrderMutationOptions = Apollo.BaseMutationOptions<PlaceCashOrderMutation, PlaceCashOrderMutationVariables>;
export const PlaceCcOrderDocument = gql`
    mutation PlaceCcOrder($input: PlaceCcOrderInput!) {
  placeOrder: placeCcOrder(input: $input) {
    ... on PlaceOrderResponse {
      completedOrder {
        ...CompletedOrderFields
      }
    }
    ... on PlaceOrderError {
      placeOrderErrorCode: code
      message
    }
    ... on PlaceOrderCartUpdatedError {
      placeOrderCartUpdatedErrorCode: code
      message
      cart {
        guid
      }
    }
  }
}
    ${CompletedOrderFieldsFragmentDoc}`;
export type PlaceCcOrderMutationFn = Apollo.MutationFunction<PlaceCcOrderMutation, PlaceCcOrderMutationVariables>;

/**
 * __usePlaceCcOrderMutation__
 *
 * To run a mutation, you first call `usePlaceCcOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceCcOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeCcOrderMutation, { data, loading, error }] = usePlaceCcOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlaceCcOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PlaceCcOrderMutation, PlaceCcOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PlaceCcOrderMutation, PlaceCcOrderMutationVariables>(PlaceCcOrderDocument, options);
      }
export type PlaceCcOrderMutationHookResult = ReturnType<typeof usePlaceCcOrderMutation>;
export type PlaceCcOrderMutationResult = Apollo.MutationResult<PlaceCcOrderMutation>;
export type PlaceCcOrderMutationOptions = Apollo.BaseMutationOptions<PlaceCcOrderMutation, PlaceCcOrderMutationVariables>;
export const PlacePaidOrderDocument = gql`
    mutation PlacePaidOrder($input: PlacePaidOrderInput!) {
  placeOrder: placePaidOrder(input: $input) {
    ... on PlaceOrderResponse {
      completedOrder {
        ...CompletedOrderFields
      }
    }
    ... on PlaceOrderError {
      placeOrderErrorCode: code
      message
    }
    ... on PlaceOrderCartUpdatedError {
      placeOrderCartUpdatedErrorCode: code
      message
      cart {
        guid
      }
    }
  }
}
    ${CompletedOrderFieldsFragmentDoc}`;
export type PlacePaidOrderMutationFn = Apollo.MutationFunction<PlacePaidOrderMutation, PlacePaidOrderMutationVariables>;

/**
 * __usePlacePaidOrderMutation__
 *
 * To run a mutation, you first call `usePlacePaidOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlacePaidOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placePaidOrderMutation, { data, loading, error }] = usePlacePaidOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlacePaidOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PlacePaidOrderMutation, PlacePaidOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PlacePaidOrderMutation, PlacePaidOrderMutationVariables>(PlacePaidOrderDocument, options);
      }
export type PlacePaidOrderMutationHookResult = ReturnType<typeof usePlacePaidOrderMutation>;
export type PlacePaidOrderMutationResult = Apollo.MutationResult<PlacePaidOrderMutation>;
export type PlacePaidOrderMutationOptions = Apollo.BaseMutationOptions<PlacePaidOrderMutation, PlacePaidOrderMutationVariables>;
export const PromoBannersDocument = gql`
    query PromoBanners($restaurantGuid: ID!) {
  promoBanners(input: {restaurantGuid: $restaurantGuid}) {
    ... on PromoBannerResponse {
      promoCodeBanners {
        bannerGuid
        bannerText
        promoCode
      }
      loyaltyBanners {
        bannerGuid
        bannerText
        availability {
          time {
            startTime
            endTime
          }
        }
      }
      deliveryBanners {
        bannerGuid
        bannerText
      }
    }
  }
}
    `;

/**
 * __usePromoBannersQuery__
 *
 * To run a query within a React component, call `usePromoBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoBannersQuery({
 *   variables: {
 *      restaurantGuid: // value for 'restaurantGuid'
 *   },
 * });
 */
export function usePromoBannersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PromoBannersQuery, PromoBannersQueryVariables> & ({ variables: PromoBannersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PromoBannersQuery, PromoBannersQueryVariables>(PromoBannersDocument, options);
      }
export function usePromoBannersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PromoBannersQuery, PromoBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PromoBannersQuery, PromoBannersQueryVariables>(PromoBannersDocument, options);
        }
export function usePromoBannersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PromoBannersQuery, PromoBannersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PromoBannersQuery, PromoBannersQueryVariables>(PromoBannersDocument, options);
        }
export type PromoBannersQueryHookResult = ReturnType<typeof usePromoBannersQuery>;
export type PromoBannersLazyQueryHookResult = ReturnType<typeof usePromoBannersLazyQuery>;
export type PromoBannersSuspenseQueryHookResult = ReturnType<typeof usePromoBannersSuspenseQuery>;
export type PromoBannersQueryResult = Apollo.QueryResult<PromoBannersQuery, PromoBannersQueryVariables>;
export const RankedPromoOfferDocument = gql`
    query RankedPromoOffer($input: RankedPromoOffersInput!) {
  offers {
    rankedPromoOffers(input: $input) {
      ... on RankedPromoOffersResponse {
        restaurantGuid
        cartGuid
        rankedDiscounts {
          __typename
          id
          bannerGuid
          bannerText
          offerDescription
          promoCode
          type
          percentCompleteInt
          discountEntitiesClaimed
          amountNeeded
          estimatedSavings
          buyEntities {
            items
            groups
            menus
          }
          discountEntities {
            items
            groups
            menus
          }
          discount {
            guid
            name
            selectionType
            amountType
            discountValue
            minSpendAmount
            promoCodes {
              promoCodeId
              code
              startDate
              endDate
              singleUse
              banners {
                guid
                bannerText
                bannerStartDate
                bannerEndDate
                status
              }
            }
            active
            displayChannels
            triggerMenuItems
            triggerMenuGroups
            triggerMenus
            bogoAction {
              bogoActionId
              amountType
              discountValue
              perItem
              numberOfFreeItems
              items
              groups
              menus
            }
            availability {
              daysOfWeek
            }
          }
        }
      }
      ... on RankedPromoOffersError {
        message
      }
    }
  }
}
    `;

/**
 * __useRankedPromoOfferQuery__
 *
 * To run a query within a React component, call `useRankedPromoOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useRankedPromoOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRankedPromoOfferQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRankedPromoOfferQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RankedPromoOfferQuery, RankedPromoOfferQueryVariables> & ({ variables: RankedPromoOfferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RankedPromoOfferQuery, RankedPromoOfferQueryVariables>(RankedPromoOfferDocument, options);
      }
export function useRankedPromoOfferLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RankedPromoOfferQuery, RankedPromoOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RankedPromoOfferQuery, RankedPromoOfferQueryVariables>(RankedPromoOfferDocument, options);
        }
export function useRankedPromoOfferSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RankedPromoOfferQuery, RankedPromoOfferQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RankedPromoOfferQuery, RankedPromoOfferQueryVariables>(RankedPromoOfferDocument, options);
        }
export type RankedPromoOfferQueryHookResult = ReturnType<typeof useRankedPromoOfferQuery>;
export type RankedPromoOfferLazyQueryHookResult = ReturnType<typeof useRankedPromoOfferLazyQuery>;
export type RankedPromoOfferSuspenseQueryHookResult = ReturnType<typeof useRankedPromoOfferSuspenseQuery>;
export type RankedPromoOfferQueryResult = Apollo.QueryResult<RankedPromoOfferQuery, RankedPromoOfferQueryVariables>;
export const RemovePromoCodeDocument = gql`
    mutation RemovePromoCode($input: RemovePromoCodeInputV2!) {
  removePromoCodeV2(input: $input) {
    ... on CartResponse {
      cart {
        guid
        cartSource
        order {
          discountsTotal
        }
      }
    }
    ... on CartModificationError {
      code
      message
    }
    ... on CartOutOfStockError {
      message
      items {
        name
        guid
      }
    }
  }
}
    `;
export type RemovePromoCodeMutationFn = Apollo.MutationFunction<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>;

/**
 * __useRemovePromoCodeMutation__
 *
 * To run a mutation, you first call `useRemovePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePromoCodeMutation, { data, loading, error }] = useRemovePromoCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePromoCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>(RemovePromoCodeDocument, options);
      }
export type RemovePromoCodeMutationHookResult = ReturnType<typeof useRemovePromoCodeMutation>;
export type RemovePromoCodeMutationResult = Apollo.MutationResult<RemovePromoCodeMutation>;
export type RemovePromoCodeMutationOptions = Apollo.BaseMutationOptions<RemovePromoCodeMutation, RemovePromoCodeMutationVariables>;
export const ReorderDocument = gql`
    mutation Reorder($input: ReorderInput!) {
  reorderV2(input: $input) {
    ... on ReorderResponse {
      cart {
        expiredDate
        guid
      }
      warningsV2 {
        code
        message
      }
      outOfStockItems {
        name
        guid
      }
    }
    ... on ReorderError {
      code
      message
    }
  }
}
    `;
export type ReorderMutationFn = Apollo.MutationFunction<ReorderMutation, ReorderMutationVariables>;

/**
 * __useReorderMutation__
 *
 * To run a mutation, you first call `useReorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderMutation, { data, loading, error }] = useReorderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderMutation, ReorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReorderMutation, ReorderMutationVariables>(ReorderDocument, options);
      }
export type ReorderMutationHookResult = ReturnType<typeof useReorderMutation>;
export type ReorderMutationResult = Apollo.MutationResult<ReorderMutation>;
export type ReorderMutationOptions = Apollo.BaseMutationOptions<ReorderMutation, ReorderMutationVariables>;
export const ReorderableItemsDocument = gql`
    query ReorderableItems($input: ReorderableItemsInput!) {
  reorderableItems(input: $input) {
    currentPageToken
    nextPageToken
    items {
      orderGuid
      imageUrls {
        ...ImageFields
      }
      selection {
        guid
        itemGuid
        itemGroupGuid
        name
        preDiscountPrice
        modifiers {
          name
        }
      }
    }
  }
}
    ${ImageFieldsFragmentDoc}`;

/**
 * __useReorderableItemsQuery__
 *
 * To run a query within a React component, call `useReorderableItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReorderableItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReorderableItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderableItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReorderableItemsQuery, ReorderableItemsQueryVariables> & ({ variables: ReorderableItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReorderableItemsQuery, ReorderableItemsQueryVariables>(ReorderableItemsDocument, options);
      }
export function useReorderableItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReorderableItemsQuery, ReorderableItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReorderableItemsQuery, ReorderableItemsQueryVariables>(ReorderableItemsDocument, options);
        }
export function useReorderableItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReorderableItemsQuery, ReorderableItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReorderableItemsQuery, ReorderableItemsQueryVariables>(ReorderableItemsDocument, options);
        }
export type ReorderableItemsQueryHookResult = ReturnType<typeof useReorderableItemsQuery>;
export type ReorderableItemsLazyQueryHookResult = ReturnType<typeof useReorderableItemsLazyQuery>;
export type ReorderableItemsSuspenseQueryHookResult = ReturnType<typeof useReorderableItemsSuspenseQuery>;
export type ReorderableItemsQueryResult = Apollo.QueryResult<ReorderableItemsQuery, ReorderableItemsQueryVariables>;
export const ReorderableMenuItemDocument = gql`
    query ReorderableMenuItem($input: ReorderableSelectionItemDetailsInput!, $nestingLevel: Int) {
  reorderableSelectionItemDetails(input: $input) {
    ...SelectionItemDetailsFields
  }
}
    ${SelectionItemDetailsFieldsFragmentDoc}`;

/**
 * __useReorderableMenuItemQuery__
 *
 * To run a query within a React component, call `useReorderableMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useReorderableMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReorderableMenuItemQuery({
 *   variables: {
 *      input: // value for 'input'
 *      nestingLevel: // value for 'nestingLevel'
 *   },
 * });
 */
export function useReorderableMenuItemQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReorderableMenuItemQuery, ReorderableMenuItemQueryVariables> & ({ variables: ReorderableMenuItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReorderableMenuItemQuery, ReorderableMenuItemQueryVariables>(ReorderableMenuItemDocument, options);
      }
export function useReorderableMenuItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReorderableMenuItemQuery, ReorderableMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReorderableMenuItemQuery, ReorderableMenuItemQueryVariables>(ReorderableMenuItemDocument, options);
        }
export function useReorderableMenuItemSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReorderableMenuItemQuery, ReorderableMenuItemQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReorderableMenuItemQuery, ReorderableMenuItemQueryVariables>(ReorderableMenuItemDocument, options);
        }
export type ReorderableMenuItemQueryHookResult = ReturnType<typeof useReorderableMenuItemQuery>;
export type ReorderableMenuItemLazyQueryHookResult = ReturnType<typeof useReorderableMenuItemLazyQuery>;
export type ReorderableMenuItemSuspenseQueryHookResult = ReturnType<typeof useReorderableMenuItemSuspenseQuery>;
export type ReorderableMenuItemQueryResult = Apollo.QueryResult<ReorderableMenuItemQuery, ReorderableMenuItemQueryVariables>;
export const RestaurantDocument = gql`
    query Restaurant($restaurantGuid: ID!) {
  restaurantV2(guid: $restaurantGuid) {
    ... on Restaurant {
      ...RestaurantFields
    }
  }
}
    ${RestaurantFieldsFragmentDoc}`;

/**
 * __useRestaurantQuery__
 *
 * To run a query within a React component, call `useRestaurantQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantQuery({
 *   variables: {
 *      restaurantGuid: // value for 'restaurantGuid'
 *   },
 * });
 */
export function useRestaurantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RestaurantQuery, RestaurantQueryVariables> & ({ variables: RestaurantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestaurantQuery, RestaurantQueryVariables>(RestaurantDocument, options);
      }
export function useRestaurantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestaurantQuery, RestaurantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestaurantQuery, RestaurantQueryVariables>(RestaurantDocument, options);
        }
export function useRestaurantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RestaurantQuery, RestaurantQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RestaurantQuery, RestaurantQueryVariables>(RestaurantDocument, options);
        }
export type RestaurantQueryHookResult = ReturnType<typeof useRestaurantQuery>;
export type RestaurantLazyQueryHookResult = ReturnType<typeof useRestaurantLazyQuery>;
export type RestaurantSuspenseQueryHookResult = ReturnType<typeof useRestaurantSuspenseQuery>;
export type RestaurantQueryResult = Apollo.QueryResult<RestaurantQuery, RestaurantQueryVariables>;
export const RestaurantByShortUrlDocument = gql`
    query RestaurantByShortUrl($shortUrl: String!) {
  restaurantV2ByShortUrl(shortUrl: $shortUrl) {
    ... on Restaurant {
      ...RestaurantFields
    }
    ... on GeneralError {
      code
      message
    }
  }
}
    ${RestaurantFieldsFragmentDoc}`;

/**
 * __useRestaurantByShortUrlQuery__
 *
 * To run a query within a React component, call `useRestaurantByShortUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantByShortUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantByShortUrlQuery({
 *   variables: {
 *      shortUrl: // value for 'shortUrl'
 *   },
 * });
 */
export function useRestaurantByShortUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RestaurantByShortUrlQuery, RestaurantByShortUrlQueryVariables> & ({ variables: RestaurantByShortUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestaurantByShortUrlQuery, RestaurantByShortUrlQueryVariables>(RestaurantByShortUrlDocument, options);
      }
export function useRestaurantByShortUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestaurantByShortUrlQuery, RestaurantByShortUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestaurantByShortUrlQuery, RestaurantByShortUrlQueryVariables>(RestaurantByShortUrlDocument, options);
        }
export function useRestaurantByShortUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RestaurantByShortUrlQuery, RestaurantByShortUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RestaurantByShortUrlQuery, RestaurantByShortUrlQueryVariables>(RestaurantByShortUrlDocument, options);
        }
export type RestaurantByShortUrlQueryHookResult = ReturnType<typeof useRestaurantByShortUrlQuery>;
export type RestaurantByShortUrlLazyQueryHookResult = ReturnType<typeof useRestaurantByShortUrlLazyQuery>;
export type RestaurantByShortUrlSuspenseQueryHookResult = ReturnType<typeof useRestaurantByShortUrlSuspenseQuery>;
export type RestaurantByShortUrlQueryResult = Apollo.QueryResult<RestaurantByShortUrlQuery, RestaurantByShortUrlQueryVariables>;
export const RestaurantLocationsDocument = gql`
    query RestaurantLocations($restaurantGuids: [ID!]!) {
  restaurants(guids: $restaurantGuids) {
    ... on Restaurant {
      ...RestaurantScheduleFields
      name
      whiteLabelName
      shortUrl
      guid
      location {
        ...LocationFields
      }
    }
  }
}
    ${RestaurantScheduleFieldsFragmentDoc}
${LocationFieldsFragmentDoc}`;

/**
 * __useRestaurantLocationsQuery__
 *
 * To run a query within a React component, call `useRestaurantLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantLocationsQuery({
 *   variables: {
 *      restaurantGuids: // value for 'restaurantGuids'
 *   },
 * });
 */
export function useRestaurantLocationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RestaurantLocationsQuery, RestaurantLocationsQueryVariables> & ({ variables: RestaurantLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestaurantLocationsQuery, RestaurantLocationsQueryVariables>(RestaurantLocationsDocument, options);
      }
export function useRestaurantLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestaurantLocationsQuery, RestaurantLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestaurantLocationsQuery, RestaurantLocationsQueryVariables>(RestaurantLocationsDocument, options);
        }
export function useRestaurantLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RestaurantLocationsQuery, RestaurantLocationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RestaurantLocationsQuery, RestaurantLocationsQueryVariables>(RestaurantLocationsDocument, options);
        }
export type RestaurantLocationsQueryHookResult = ReturnType<typeof useRestaurantLocationsQuery>;
export type RestaurantLocationsLazyQueryHookResult = ReturnType<typeof useRestaurantLocationsLazyQuery>;
export type RestaurantLocationsSuspenseQueryHookResult = ReturnType<typeof useRestaurantLocationsSuspenseQuery>;
export type RestaurantLocationsQueryResult = Apollo.QueryResult<RestaurantLocationsQuery, RestaurantLocationsQueryVariables>;
export const RestaurantProfileDocument = gql`
    query RestaurantProfile($guid: ID!) {
  restaurantV2(guid: $guid) {
    ... on Restaurant {
      ...RestaurantFields
    }
  }
}
    ${RestaurantFieldsFragmentDoc}`;

/**
 * __useRestaurantProfileQuery__
 *
 * To run a query within a React component, call `useRestaurantProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantProfileQuery({
 *   variables: {
 *      guid: // value for 'guid'
 *   },
 * });
 */
export function useRestaurantProfileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RestaurantProfileQuery, RestaurantProfileQueryVariables> & ({ variables: RestaurantProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestaurantProfileQuery, RestaurantProfileQueryVariables>(RestaurantProfileDocument, options);
      }
export function useRestaurantProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestaurantProfileQuery, RestaurantProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestaurantProfileQuery, RestaurantProfileQueryVariables>(RestaurantProfileDocument, options);
        }
export function useRestaurantProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RestaurantProfileQuery, RestaurantProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RestaurantProfileQuery, RestaurantProfileQueryVariables>(RestaurantProfileDocument, options);
        }
export type RestaurantProfileQueryHookResult = ReturnType<typeof useRestaurantProfileQuery>;
export type RestaurantProfileLazyQueryHookResult = ReturnType<typeof useRestaurantProfileLazyQuery>;
export type RestaurantProfileSuspenseQueryHookResult = ReturnType<typeof useRestaurantProfileSuspenseQuery>;
export type RestaurantProfileQueryResult = Apollo.QueryResult<RestaurantProfileQuery, RestaurantProfileQueryVariables>;
export const RestaurantPromoBannersDocument = gql`
    query RestaurantPromoBanners($restaurantGuids: [ID!]!) {
  restaurants(guids: $restaurantGuids) {
    ... on Restaurant {
      guid
      name
      shortUrl
      promoBanners {
        ... on PromoBannerResponse {
          promoCodeBanners {
            bannerGuid
            bannerText
            promoCode
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRestaurantPromoBannersQuery__
 *
 * To run a query within a React component, call `useRestaurantPromoBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantPromoBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantPromoBannersQuery({
 *   variables: {
 *      restaurantGuids: // value for 'restaurantGuids'
 *   },
 * });
 */
export function useRestaurantPromoBannersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RestaurantPromoBannersQuery, RestaurantPromoBannersQueryVariables> & ({ variables: RestaurantPromoBannersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestaurantPromoBannersQuery, RestaurantPromoBannersQueryVariables>(RestaurantPromoBannersDocument, options);
      }
export function useRestaurantPromoBannersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestaurantPromoBannersQuery, RestaurantPromoBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestaurantPromoBannersQuery, RestaurantPromoBannersQueryVariables>(RestaurantPromoBannersDocument, options);
        }
export function useRestaurantPromoBannersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RestaurantPromoBannersQuery, RestaurantPromoBannersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RestaurantPromoBannersQuery, RestaurantPromoBannersQueryVariables>(RestaurantPromoBannersDocument, options);
        }
export type RestaurantPromoBannersQueryHookResult = ReturnType<typeof useRestaurantPromoBannersQuery>;
export type RestaurantPromoBannersLazyQueryHookResult = ReturnType<typeof useRestaurantPromoBannersLazyQuery>;
export type RestaurantPromoBannersSuspenseQueryHookResult = ReturnType<typeof useRestaurantPromoBannersSuspenseQuery>;
export type RestaurantPromoBannersQueryResult = Apollo.QueryResult<RestaurantPromoBannersQuery, RestaurantPromoBannersQueryVariables>;
export const RestaurantSchedulesDocument = gql`
    query RestaurantSchedules($restaurantGuids: [ID!]!) {
  restaurants(guids: $restaurantGuids) {
    ... on Restaurant {
      guid
      ...RestaurantScheduleFields
    }
  }
}
    ${RestaurantScheduleFieldsFragmentDoc}`;

/**
 * __useRestaurantSchedulesQuery__
 *
 * To run a query within a React component, call `useRestaurantSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantSchedulesQuery({
 *   variables: {
 *      restaurantGuids: // value for 'restaurantGuids'
 *   },
 * });
 */
export function useRestaurantSchedulesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RestaurantSchedulesQuery, RestaurantSchedulesQueryVariables> & ({ variables: RestaurantSchedulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestaurantSchedulesQuery, RestaurantSchedulesQueryVariables>(RestaurantSchedulesDocument, options);
      }
export function useRestaurantSchedulesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestaurantSchedulesQuery, RestaurantSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestaurantSchedulesQuery, RestaurantSchedulesQueryVariables>(RestaurantSchedulesDocument, options);
        }
export function useRestaurantSchedulesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RestaurantSchedulesQuery, RestaurantSchedulesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RestaurantSchedulesQuery, RestaurantSchedulesQueryVariables>(RestaurantSchedulesDocument, options);
        }
export type RestaurantSchedulesQueryHookResult = ReturnType<typeof useRestaurantSchedulesQuery>;
export type RestaurantSchedulesLazyQueryHookResult = ReturnType<typeof useRestaurantSchedulesLazyQuery>;
export type RestaurantSchedulesSuspenseQueryHookResult = ReturnType<typeof useRestaurantSchedulesSuspenseQuery>;
export type RestaurantSchedulesQueryResult = Apollo.QueryResult<RestaurantSchedulesQuery, RestaurantSchedulesQueryVariables>;
export const RxSearchDocument = gql`
    query RxSearch($input: NearbyRestaurantSearchInput!) {
  nearbyRestaurantSearch(input: $input) {
    results {
      restaurant {
        guid
        imageUrl
        shortUrl
        name
        location {
          latitude
          longitude
        }
        cuisineType
        hasOnlineOrderingModule
        deliveryServiceAvailability {
          available
        }
        guestCurrencyConfig {
          enabled
          promoEnabled
          storedValueEnabled
        }
        toastPayConfig {
          qrCodeOnReceiptEnabled
        }
        promoBanners {
          ... on PromoBannerResponse {
            promoCodeBanners {
              bannerText
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRxSearchQuery__
 *
 * To run a query within a React component, call `useRxSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRxSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRxSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRxSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RxSearchQuery, RxSearchQueryVariables> & ({ variables: RxSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RxSearchQuery, RxSearchQueryVariables>(RxSearchDocument, options);
      }
export function useRxSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RxSearchQuery, RxSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RxSearchQuery, RxSearchQueryVariables>(RxSearchDocument, options);
        }
export function useRxSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RxSearchQuery, RxSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RxSearchQuery, RxSearchQueryVariables>(RxSearchDocument, options);
        }
export type RxSearchQueryHookResult = ReturnType<typeof useRxSearchQuery>;
export type RxSearchLazyQueryHookResult = ReturnType<typeof useRxSearchLazyQuery>;
export type RxSearchSuspenseQueryHookResult = ReturnType<typeof useRxSearchSuspenseQuery>;
export type RxSearchQueryResult = Apollo.QueryResult<RxSearchQuery, RxSearchQueryVariables>;
export const SelectShippingRateDocument = gql`
    mutation SelectShippingRate($input: SetSelectedShippingRateInput!) {
  setSelectedShippingRate(input: $input) {
    ... on EcommerceMutationSuccessResponse {
      success
    }
    ... on EcommerceMutationErrorResponse {
      message
    }
  }
}
    `;
export type SelectShippingRateMutationFn = Apollo.MutationFunction<SelectShippingRateMutation, SelectShippingRateMutationVariables>;

/**
 * __useSelectShippingRateMutation__
 *
 * To run a mutation, you first call `useSelectShippingRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectShippingRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectShippingRateMutation, { data, loading, error }] = useSelectShippingRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectShippingRateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelectShippingRateMutation, SelectShippingRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SelectShippingRateMutation, SelectShippingRateMutationVariables>(SelectShippingRateDocument, options);
      }
export type SelectShippingRateMutationHookResult = ReturnType<typeof useSelectShippingRateMutation>;
export type SelectShippingRateMutationResult = Apollo.MutationResult<SelectShippingRateMutation>;
export type SelectShippingRateMutationOptions = Apollo.BaseMutationOptions<SelectShippingRateMutation, SelectShippingRateMutationVariables>;
export const CartShippingRatesDocument = gql`
    query CartShippingRates($input: ShippingRatesQueryInput!) {
  getCartShippingRates(input: $input) {
    shippingRateGuid
    amount
    currency
    description
    estimatedDays
    title
  }
}
    `;

/**
 * __useCartShippingRatesQuery__
 *
 * To run a query within a React component, call `useCartShippingRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartShippingRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartShippingRatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCartShippingRatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CartShippingRatesQuery, CartShippingRatesQueryVariables> & ({ variables: CartShippingRatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CartShippingRatesQuery, CartShippingRatesQueryVariables>(CartShippingRatesDocument, options);
      }
export function useCartShippingRatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CartShippingRatesQuery, CartShippingRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CartShippingRatesQuery, CartShippingRatesQueryVariables>(CartShippingRatesDocument, options);
        }
export function useCartShippingRatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CartShippingRatesQuery, CartShippingRatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CartShippingRatesQuery, CartShippingRatesQueryVariables>(CartShippingRatesDocument, options);
        }
export type CartShippingRatesQueryHookResult = ReturnType<typeof useCartShippingRatesQuery>;
export type CartShippingRatesLazyQueryHookResult = ReturnType<typeof useCartShippingRatesLazyQuery>;
export type CartShippingRatesSuspenseQueryHookResult = ReturnType<typeof useCartShippingRatesSuspenseQuery>;
export type CartShippingRatesQueryResult = Apollo.QueryResult<CartShippingRatesQuery, CartShippingRatesQueryVariables>;
export const GetMenusSitemapDocument = gql`
    query GetMenusSitemap($input: MenusInput!) {
  menusV3(input: $input) {
    ... on MenusResponse {
      ...SitemapMenuData
    }
    ... on GeneralError {
      code
      message
    }
  }
}
    ${SitemapMenuDataFragmentDoc}`;

/**
 * __useGetMenusSitemapQuery__
 *
 * To run a query within a React component, call `useGetMenusSitemapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenusSitemapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenusSitemapQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMenusSitemapQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMenusSitemapQuery, GetMenusSitemapQueryVariables> & ({ variables: GetMenusSitemapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMenusSitemapQuery, GetMenusSitemapQueryVariables>(GetMenusSitemapDocument, options);
      }
export function useGetMenusSitemapLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMenusSitemapQuery, GetMenusSitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMenusSitemapQuery, GetMenusSitemapQueryVariables>(GetMenusSitemapDocument, options);
        }
export function useGetMenusSitemapSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMenusSitemapQuery, GetMenusSitemapQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMenusSitemapQuery, GetMenusSitemapQueryVariables>(GetMenusSitemapDocument, options);
        }
export type GetMenusSitemapQueryHookResult = ReturnType<typeof useGetMenusSitemapQuery>;
export type GetMenusSitemapLazyQueryHookResult = ReturnType<typeof useGetMenusSitemapLazyQuery>;
export type GetMenusSitemapSuspenseQueryHookResult = ReturnType<typeof useGetMenusSitemapSuspenseQuery>;
export type GetMenusSitemapQueryResult = Apollo.QueryResult<GetMenusSitemapQuery, GetMenusSitemapQueryVariables>;
export const GetSurchargeSummaryDocument = gql`
    query getSurchargeSummary($input: GetSurchargeSummaryInput!) {
  getSurchargeSummary(input: $input) {
    ... on SurchargeSummaryResponse {
      paymentTypes
      surchargePreTaxAmount
      surchargeTaxAmount
      surchargeRate
    }
  }
}
    `;

/**
 * __useGetSurchargeSummaryQuery__
 *
 * To run a query within a React component, call `useGetSurchargeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurchargeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurchargeSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSurchargeSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSurchargeSummaryQuery, GetSurchargeSummaryQueryVariables> & ({ variables: GetSurchargeSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSurchargeSummaryQuery, GetSurchargeSummaryQueryVariables>(GetSurchargeSummaryDocument, options);
      }
export function useGetSurchargeSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSurchargeSummaryQuery, GetSurchargeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSurchargeSummaryQuery, GetSurchargeSummaryQueryVariables>(GetSurchargeSummaryDocument, options);
        }
export function useGetSurchargeSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSurchargeSummaryQuery, GetSurchargeSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSurchargeSummaryQuery, GetSurchargeSummaryQueryVariables>(GetSurchargeSummaryDocument, options);
        }
export type GetSurchargeSummaryQueryHookResult = ReturnType<typeof useGetSurchargeSummaryQuery>;
export type GetSurchargeSummaryLazyQueryHookResult = ReturnType<typeof useGetSurchargeSummaryLazyQuery>;
export type GetSurchargeSummarySuspenseQueryHookResult = ReturnType<typeof useGetSurchargeSummarySuspenseQuery>;
export type GetSurchargeSummaryQueryResult = Apollo.QueryResult<GetSurchargeSummaryQuery, GetSurchargeSummaryQueryVariables>;
export const UpdateFulfillmentDocument = gql`
    mutation UpdateFulfillment($input: UpdateFulfillmentAndValidateInput!) {
  updateFulfillmentAndValidate(input: $input) {
    ... on CartResponse {
      cart {
        guid
        cartSource
        expiredDate
        order {
          numberOfSelections
          taxV2
          totalV2
          selections {
            name
            price
            quantity
            modifiers {
              name
              price
            }
          }
        }
      }
    }
    ... on CartModificationError {
      code
      message
    }
    ... on CartOutOfStockError {
      message
      items {
        name
        guid
      }
    }
  }
}
    `;
export type UpdateFulfillmentMutationFn = Apollo.MutationFunction<UpdateFulfillmentMutation, UpdateFulfillmentMutationVariables>;

/**
 * __useUpdateFulfillmentMutation__
 *
 * To run a mutation, you first call `useUpdateFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFulfillmentMutation, { data, loading, error }] = useUpdateFulfillmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFulfillmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFulfillmentMutation, UpdateFulfillmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFulfillmentMutation, UpdateFulfillmentMutationVariables>(UpdateFulfillmentDocument, options);
      }
export type UpdateFulfillmentMutationHookResult = ReturnType<typeof useUpdateFulfillmentMutation>;
export type UpdateFulfillmentMutationResult = Apollo.MutationResult<UpdateFulfillmentMutation>;
export type UpdateFulfillmentMutationOptions = Apollo.BaseMutationOptions<UpdateFulfillmentMutation, UpdateFulfillmentMutationVariables>;
export const ValidateCartPreCheckoutDocument = gql`
    mutation ValidateCartPreCheckout($cartGuid: ID!, $validateOrderTime: Boolean, $customer: GuestInput, $sessionId: String) {
  validateCartPreCheckout(
    input: {cartGuid: $cartGuid, validateOrderTime: $validateOrderTime, customer: $customer, sessionId: $sessionId}
  ) {
    ... on CartResponse {
      cart {
        guid
        cartSource
        restaurant {
          name
        }
      }
      info {
        code
        message
      }
      warnings {
        code
        message
      }
    }
    ... on CartModificationError {
      message
      code
    }
    ... on CartOutOfStockError {
      message
    }
    ... on CartValidationError {
      key
      message
    }
  }
}
    `;
export type ValidateCartPreCheckoutMutationFn = Apollo.MutationFunction<ValidateCartPreCheckoutMutation, ValidateCartPreCheckoutMutationVariables>;

/**
 * __useValidateCartPreCheckoutMutation__
 *
 * To run a mutation, you first call `useValidateCartPreCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateCartPreCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateCartPreCheckoutMutation, { data, loading, error }] = useValidateCartPreCheckoutMutation({
 *   variables: {
 *      cartGuid: // value for 'cartGuid'
 *      validateOrderTime: // value for 'validateOrderTime'
 *      customer: // value for 'customer'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useValidateCartPreCheckoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ValidateCartPreCheckoutMutation, ValidateCartPreCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ValidateCartPreCheckoutMutation, ValidateCartPreCheckoutMutationVariables>(ValidateCartPreCheckoutDocument, options);
      }
export type ValidateCartPreCheckoutMutationHookResult = ReturnType<typeof useValidateCartPreCheckoutMutation>;
export type ValidateCartPreCheckoutMutationResult = Apollo.MutationResult<ValidateCartPreCheckoutMutation>;
export type ValidateCartPreCheckoutMutationOptions = Apollo.BaseMutationOptions<ValidateCartPreCheckoutMutation, ValidateCartPreCheckoutMutationVariables>;
export const ValidateDeliveryDistanceDocument = gql`
    query ValidateDeliveryDistance($input: ValidateDeliveryLocationInputV2!) {
  validateDeliveryLocationV2(input: $input) {
    valid
  }
}
    `;

/**
 * __useValidateDeliveryDistanceQuery__
 *
 * To run a query within a React component, call `useValidateDeliveryDistanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateDeliveryDistanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateDeliveryDistanceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateDeliveryDistanceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ValidateDeliveryDistanceQuery, ValidateDeliveryDistanceQueryVariables> & ({ variables: ValidateDeliveryDistanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValidateDeliveryDistanceQuery, ValidateDeliveryDistanceQueryVariables>(ValidateDeliveryDistanceDocument, options);
      }
export function useValidateDeliveryDistanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidateDeliveryDistanceQuery, ValidateDeliveryDistanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValidateDeliveryDistanceQuery, ValidateDeliveryDistanceQueryVariables>(ValidateDeliveryDistanceDocument, options);
        }
export function useValidateDeliveryDistanceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ValidateDeliveryDistanceQuery, ValidateDeliveryDistanceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ValidateDeliveryDistanceQuery, ValidateDeliveryDistanceQueryVariables>(ValidateDeliveryDistanceDocument, options);
        }
export type ValidateDeliveryDistanceQueryHookResult = ReturnType<typeof useValidateDeliveryDistanceQuery>;
export type ValidateDeliveryDistanceLazyQueryHookResult = ReturnType<typeof useValidateDeliveryDistanceLazyQuery>;
export type ValidateDeliveryDistanceSuspenseQueryHookResult = ReturnType<typeof useValidateDeliveryDistanceSuspenseQuery>;
export type ValidateDeliveryDistanceQueryResult = Apollo.QueryResult<ValidateDeliveryDistanceQuery, ValidateDeliveryDistanceQueryVariables>;

// Set the persisted document hashes
(AddToCartDocument as any).__meta__ = {"hash":"4c2522284d144f3ec2f9d3d2518985353681ccc2"};
(ApplyPromoCodeDocument as any).__meta__ = {"hash":"fa669f4df68a30cbe5bb694f36a69a02e928b26b"};
(CompleteIdentityProfileDocument as any).__meta__ = {"hash":"83020d46b4e367691bec210989fe6c3d34c14e03"};
(ConfirmCodeDocument as any).__meta__ = {"hash":"8dc6dbb2c755f82ab9bfa8f38dee29fb715935f1"};
(DeleteAccountDocument as any).__meta__ = {"hash":"a9d89846fcc1c57b1b3e5e6b00175f1e44ea6918"};
(LogoutDocument as any).__meta__ = {"hash":"09902c2eceea054ffe6aa37fbbdcd5a693be35fd"};
(PasswordlessLoginDocument as any).__meta__ = {"hash":"72c7d8f191d86c459aded7114b07acf6e0e31f0d"};
(PasswordlessRefreshTokenDocument as any).__meta__ = {"hash":"42d11baa376389f04d6259834f9b497e2a3398cc"};
(CartDocument as any).__meta__ = {"hash":"cbdea04d9066d5d0e2563914ca69cb12b54a3fa9"};
(CompletedOrderDocument as any).__meta__ = {"hash":"e66fa9a42de2f6b511e9aad307035f15196c9915"};
(CreateGiftCardOrderDocument as any).__meta__ = {"hash":"905bd59cb9383f8dac13225b073d659265a9fed3"};
(CustomerDocument as any).__meta__ = {"hash":"acd8359895d49be002f979ffccf966d6788663aa"};
(AddGuestIdentityDocument as any).__meta__ = {"hash":"6f0661694d6fef592a64e99f3d307ab0b497b2ca"};
(DeleteAddressDocument as any).__meta__ = {"hash":"d14fe8234d6a198072eac692ad9cb28173811df2"};
(UpdateAddressDocument as any).__meta__ = {"hash":"9275e267a3cb2732f27cf579bbe1241ca9f64395"};
(ConfirmGuestIdentityDocument as any).__meta__ = {"hash":"dc24a1ad5bb20b7d646a4bbcf2045bd53969aea7"};
(UpdateBasicInfoDocument as any).__meta__ = {"hash":"b56ebca97ab2b5f890bac97a36d0684b61ad4218"};
(DeleteCreditCardDocument as any).__meta__ = {"hash":"5ad1bff13393b7de59ea5760d104dca305b4778c"};
(DeleteFromCartDocument as any).__meta__ = {"hash":"784c659c6b2446a42ed57e71379951807e8ccecd"};
(DoGetMenuGroupsDocument as any).__meta__ = {"hash":"4515f8507f8655a3a4ebb1385e685015c0038904"};
(DoGetMenuItemsDocument as any).__meta__ = {"hash":"e385a3a0e75bdf588c38955f2a7866286c3b4f2f"};
(DoMenuItemDocument as any).__meta__ = {"hash":"999951ed34e98efd42b7e6d67a1a9fdc96b7b6ec"};
(GuestFacingInstructionsDocument as any).__meta__ = {"hash":"41cf36d3ec52a4519f6d2cae4cfd85f1d0f014bf"};
(EditCartItemDocument as any).__meta__ = {"hash":"204d88205115e64c8b048556f176f0706042ac4f"};
(GetEGiftCardConfigDocument as any).__meta__ = {"hash":"36f54746a486af5bd1addf0c0d5cf762e2f70541"};
(GetShippingOptionsDocument as any).__meta__ = {"hash":"40b1a7ce9c4fe0fec19827cc5a04f00fbb31fb58"};
(GiftCardBalanceDocument as any).__meta__ = {"hash":"a3d3fc86fbe338d7cd22aae108c45cba3dbc9ee4"};
(GiftCardExtensionBalanceDocument as any).__meta__ = {"hash":"9251b190182d29aebb623e3036881cba8db291b0"};
(GuestDocument as any).__meta__ = {"hash":"4f90974c7b1ade759fa53dd74ffd7a0408428d1c"};
(GuestWalletDocument as any).__meta__ = {"hash":"77fba201def3b8ce80e931b944ab6933f76bd3de"};
(AddLoyaltyToCartDocument as any).__meta__ = {"hash":"01c66abf5184151c49ea5a18f6e0730a005fc83f"};
(CustomerLoyaltyInfoDocument as any).__meta__ = {"hash":"f04312a55c90b6595c32d244de3726342e621e9b"};
(CustomerLoyaltySignupDocument as any).__meta__ = {"hash":"35ba6fc063eddf13a4fea00523c8ab73fc9b4ad1"};
(LoyaltyFeaturesDocument as any).__meta__ = {"hash":"884252f38431e8a38fe86e6e0af7dfdd0c5f2dca"};
(LoyaltyInquiryDocument as any).__meta__ = {"hash":"ef6ce883fe3aab890bc32f2685bf44a277b84aca"};
(RemoveLoyaltyFromCartDocument as any).__meta__ = {"hash":"200406cc0c023f0bf97075ae1eb5dc09251392a4"};
(MakeCreditCardPrimaryDocument as any).__meta__ = {"hash":"069b647a331aec16feb7c865125d31575702448f"};
(MarketingConfigDocument as any).__meta__ = {"hash":"fb0402d1941ae7af4fa98f676f189a47e86c1c4f"};
(MarketingSubscriptionDocument as any).__meta__ = {"hash":"02eb65e64b5308b67c3d07d9e189f94b762eee7b"};
(MenuItemDetailsDocument as any).__meta__ = {"hash":"7407d872c8a1b1b71a07b694b78e2b0a989e2934"};
(MenuItemFromCartDocument as any).__meta__ = {"hash":"65f614e3780c482c8af8faa88261c83d49127c35"};
(OoAvailabilityDocument as any).__meta__ = {"hash":"9e9f26e7af77fd805a704a08d3406720699fe1e7"};
(OrderHistoryDocument as any).__meta__ = {"hash":"d292484740396c258fcdbeaccfe5ad4d8c02768a"};
(GetOrderStatusesDocument as any).__meta__ = {"hash":"b4a37ce202a43c43827d51f945eb89346c314033"};
(PaginatedMenuItemsDocument as any).__meta__ = {"hash":"e429e87160545347ef3608bfcd681a72dbff49df"};
(PaginatedMenuItemsWithPopularItemsDocument as any).__meta__ = {"hash":"96a3da4f2fe8858e7fe5810b963e78db6e814b13"};
(PayForCheckDocument as any).__meta__ = {"hash":"2fa45ffe312eaba0ce42d432013d8019ea5b2f67"};
(CreateGiftCardPaymentIntentDocument as any).__meta__ = {"hash":"845ec28489145fceb16bed994adf142df4c8083f"};
(CreatePaymentIntentDocument as any).__meta__ = {"hash":"459d12bf5c5277668a3fede75f9fe5dd43973315"};
(GetClientTokenDocument as any).__meta__ = {"hash":"e55996741692889fe8574b5f69ae26218ca0dd3a"};
(UpdateGiftCardPaymentIntentDocument as any).__meta__ = {"hash":"6c0303a50a5dd55f7e4392874250c882f78e1ec3"};
(UpdatePaymentIntentDocument as any).__meta__ = {"hash":"6722d69c4398bae99619a177e7941c5826a63806"};
(PlaceCashOrderDocument as any).__meta__ = {"hash":"263afb17c40bae9cb58c3b89f9c7899a136ec5cd"};
(PlaceCcOrderDocument as any).__meta__ = {"hash":"bb77d21c13da22635520956141ea9bcfe6879bda"};
(PlacePaidOrderDocument as any).__meta__ = {"hash":"a5cf079d6d58db6529149a85dc576649317ce5fd"};
(PromoBannersDocument as any).__meta__ = {"hash":"e19b7b15fbb4aaad215c13c263e7c86dcf81dee5"};
(RankedPromoOfferDocument as any).__meta__ = {"hash":"438acaa49a83387c2f27b2adef89e5f11a839453"};
(RemovePromoCodeDocument as any).__meta__ = {"hash":"63716977b203fa5f268f17ea673eb091d5ebd98f"};
(ReorderDocument as any).__meta__ = {"hash":"7b3bfa007b30adf4ce1c72edd79df371d38faf13"};
(ReorderableItemsDocument as any).__meta__ = {"hash":"e1fe236e799aaabc12bdf2f1a40bd62ae83456d0"};
(ReorderableMenuItemDocument as any).__meta__ = {"hash":"8e7731829e164e2df414ed92197cc824c49466e6"};
(RestaurantDocument as any).__meta__ = {"hash":"bdca11a5e4bc4380dc39dd159871b0b66e0404f4"};
(RestaurantByShortUrlDocument as any).__meta__ = {"hash":"364b3b6de14bdea6c93fb4c73c48054776d1cee2"};
(RestaurantLocationsDocument as any).__meta__ = {"hash":"62d313a93cfc2bd95a564a1ea730fe22825ac79f"};
(RestaurantProfileDocument as any).__meta__ = {"hash":"3a45da0f43eeaaa723e1820c8cd3c9e4022ef5d8"};
(RestaurantPromoBannersDocument as any).__meta__ = {"hash":"3530a80955eb0ea500d301c267919828d9eeeb66"};
(RestaurantSchedulesDocument as any).__meta__ = {"hash":"2e14153e758f6beaad02d0635cebcb8f7d4194d0"};
(RxSearchDocument as any).__meta__ = {"hash":"b31e5efa125b6ddf6e67125ad9ef5e6f15c84056"};
(SelectShippingRateDocument as any).__meta__ = {"hash":"35c7508802d912bf06bf87c733ff76fd18dd286a"};
(CartShippingRatesDocument as any).__meta__ = {"hash":"a7237d39b787b4d3ee75b24c9a3700c5b8a9f6b0"};
(GetMenusSitemapDocument as any).__meta__ = {"hash":"cb2f3d4e3e65ef0e93adde1b4c74b198d02d13b7"};
(GetSurchargeSummaryDocument as any).__meta__ = {"hash":"3aebf6682a330d2b8b2d4dc23b1a970093b5bfba"};
(UpdateFulfillmentDocument as any).__meta__ = {"hash":"a90a6ba93c6a9aed26a7b8940264a98ae3c17f67"};
(ValidateCartPreCheckoutDocument as any).__meta__ = {"hash":"0d850d9e710dd6f587d59837d3898a206cedd927"};
(ValidateDeliveryDistanceDocument as any).__meta__ = {"hash":"be4943f75a733bbd1f3378450ce57484ba40851e"};
